module.exports = {
	"type": "champion",
	"format": "full",
	"version": "8.4.1",
	"data": {
		"Aatrox": {
			"id": "Aatrox",
			"key": "266",
			"name": "Aatrox",
			"title": "the Darkin Blade",
			"image": {
				"full": "Aatrox.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 0,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "266000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "266001",
					"num": 1,
					"name": "Justicar Aatrox",
					"chromas": false
				},
				{
					"id": "266002",
					"num": 2,
					"name": "Mecha Aatrox",
					"chromas": true
				},
				{
					"id": "266003",
					"num": 3,
					"name": "Sea Hunter Aatrox",
					"chromas": false
				}
			],
			"lore": "One of the ancient darkin, Aatrox was once a peerless swordmaster who reveled in the bloody chaos of the battlefield. Trapped within his own blade by the magic of his foes, he waited out the millennia for a suitable host to wield him—this mortal warrior was corrupted and transformed by the living weapon, and Aatrox was reborn. Though tales of the darkin have now passed into legend, he remembers only too well the destruction of his race, and wreaks his vengeance one sword blow at a time.",
			"blurb": "One of the ancient darkin, Aatrox was once a peerless swordmaster who reveled in the bloody chaos of the battlefield. Trapped within his own blade by the magic of his foes, he waited out the millennia for a suitable host to wield him—this mortal warrior...",
			"allytips": [
				"Being Hellbent contributes a significant amount of power in a fight, so avoid engaging with an empty Blood Well.",
				"Building Life Steal or small amounts of defense can be very potent on Aatrox, giving him more time to get the most out of being Hellbent.",
				"Massacre is great at turning the tide of a battle. Make sure to use it at the right moment to maximize its benefits."
			],
			"enemytips": [
				"Aatrox is much more powerful while Hellbent, so be cautious fighting him if he's able to fill his Blood Well.",
				"When Aatrox casts Dark Flight towards your location, avoid being knocked up by moving away from the center of impact.",
				"Aatrox is reliant on basic attacks for most of his damage and survivability, reducing his attack speed by purchasing Randuin's Omen or Frozen Heart can help reduce both of those components greatly."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Blood Well",
			"info": {
				"attack": 8,
				"defense": 4,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 580,
				"hpperlevel": 85,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 33,
				"armorperlevel": 3.8,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 150,
				"hpregen": 6.5,
				"hpregenperlevel": 0.5,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 70,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.04,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "AatroxQ",
					"name": "Dark Flight",
					"description": "Aatrox takes flight and slams down at a targeted location, dealing damage and knocking up enemies at the center of impact.",
					"tooltip": "Aatrox takes flight and slams down at target location, dealing {{ e1 }}<span class=\"colorF88017\"> (+{{ a1 }})</span> physical damage and knocking up enemies at the center of impact for {{ e4 }} second.<br /><br />Aatrox fills up 20% of the Blood Well upon cast.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12.5,
						12,
						11.5,
						11
					],
					"cooldownBurn": "13/12.5/12/11.5/11",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							50,
							80,
							110,
							140
						],
						[
							310,
							310,
							310,
							310,
							310
						],
						[
							190,
							190,
							190,
							190,
							190
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/50/80/110/140",
						"310",
						"190",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.1,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "AatroxQ.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "AatroxW",
					"name": "Blood Thirst / Blood Price",
					"description": "While toggled on Aatrox deals bonus damage and fills a portion of his Blood Well every third subsequent attack. While toggled off Aatrox restores Health every third subsequent attack.",
					"tooltip": "<span class=\"colorFF9900\">Toggle Off:</span><span class=\"colore60000\"> Blood Thirst: </span>Every third attack, Aatrox restores {{ e3 }} <span class=\"colorCC3300\">(+{{ f1*100 }}% Missing Health)</span> Health.<br /><br /><span class=\"colorFF9900\">Toggle On:</span><span class=\"color9900ff\"> Blood Price: </span>Every third attack, Aatrox deals {{ e2 }}<span class=\"colorF88017\"> (+{{ a2 }})</span> bonus physical damage and fills up 20% of the Blood Well.",
					"leveltip": {
						"label": [
							"Heal",
							"Damage"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.5,
						0.5,
						0.5,
						0.5,
						0.5
					],
					"cooldownBurn": "0.5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							50,
							85,
							120,
							155,
							190
						],
						[
							30,
							45,
							60,
							75,
							90
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200",
						"50/85/120/155/190",
						"30/45/60/75/90",
						"50",
						"50",
						"0.5",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.75,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "AatroxW.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "AatroxE",
					"name": "Blades of Torment",
					"description": "Aatrox unleashes the power of his blade, dealing damage to enemies hit and slowing them.",
					"tooltip": "Aatrox unleashes the power of his blade, dealing {{ e1 }} <span class=\"colorF88017\">(+{{ a2 }})</span> physical damage to enemies hit and slowing them by {{ e2 }}% for {{ e3 }} seconds.<br /><br />Aatrox fills up 20% of the Blood Well upon cast.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"30/35/40/45/50",
						"2",
						"30",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.7,
							"key": "a2"
						}
					],
					"costType": " Health",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "AatroxE.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e4 }} Health"
				},
				{
					"id": "AatroxR",
					"name": "Massacre",
					"description": "Aatrox draws in the blood of his foes, damaging all nearby enemy champions around him and gaining increased Attack Speed and bonus Attack Range for a short duration.",
					"tooltip": "Aatrox draws in the blood of his foes, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemy champions, filling up 20% of the Blood Well for each hit.<br /><br />Aatrox gains {{ e3 }}% Attack Speed and {{ e5 }} attack range for {{ e8 }} seconds upon cast.",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						85,
						70
					],
					"cooldownBurn": "100/85/70",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							550,
							550,
							550
						],
						[
							200,
							300,
							400
						],
						[
							40,
							50,
							60
						],
						[
							0,
							0,
							0
						],
						[
							225,
							225,
							225
						],
						[
							0,
							0,
							0
						],
						[
							20,
							20,
							20
						],
						[
							12,
							12,
							12
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"550",
						"200/300/400",
						"40/50/60",
						"0",
						"225",
						"0",
						"20",
						"12",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "AatroxR.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Blood Well",
				"description": "Aatrox fills up his Blood Well through his abilities. When filled, Aatrox becomes Hellbent for as long as he stays in combat with champions or monsters, granting him attack damage, attack speed, and the ability to survive fatal damage.",
				"image": {
					"full": "Aatrox_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Aatrox",
					"title": "AatroxARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "AatroxCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "AatroxFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "AatroxKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "AatroxSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "AatroxSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "AatroxTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Aatrox",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Ahri": {
			"id": "Ahri",
			"key": "103",
			"name": "Ahri",
			"title": "the Nine-Tailed Fox",
			"image": {
				"full": "Ahri.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 48,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "103000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "103001",
					"num": 1,
					"name": "Dynasty Ahri",
					"chromas": false
				},
				{
					"id": "103002",
					"num": 2,
					"name": "Midnight Ahri",
					"chromas": false
				},
				{
					"id": "103003",
					"num": 3,
					"name": "Foxfire Ahri",
					"chromas": false
				},
				{
					"id": "103004",
					"num": 4,
					"name": "Popstar Ahri",
					"chromas": true
				},
				{
					"id": "103005",
					"num": 5,
					"name": "Challenger Ahri",
					"chromas": false
				},
				{
					"id": "103006",
					"num": 6,
					"name": "Academy Ahri",
					"chromas": false
				},
				{
					"id": "103007",
					"num": 7,
					"name": "Arcade Ahri",
					"chromas": false
				},
				{
					"id": "103014",
					"num": 14,
					"name": "Star Guardian Ahri",
					"chromas": false
				}
			],
			"lore": "Innately connected to the latent power of Runeterra, Ahri is a vastaya who can reshape magic into orbs of raw energy. She revels in toying with her prey by manipulating their emotions before devouring their life essence. Despite her predatory nature, Ahri retains a sense of empathy as she receives flashes of memory from each soul she consumes.",
			"blurb": "Innately connected to the latent power of Runeterra, Ahri is a vastaya who can reshape magic into orbs of raw energy. She revels in toying with her prey by manipulating their emotions before devouring their life essence. Despite her predatory nature...",
			"allytips": [
				"Use Charm to set up your combos, it will make landing Orb of Deception and Fox-Fire dramatically easier.",
				"Initiate team fights using Charm, and chase down stragglers with Spirit Rush.",
				"Spirit Rush enables Ahri's abilities, it opens up paths for Charm, helps double hitting with Orb of Deception, and closes to make use of Fox-Fire."
			],
			"enemytips": [
				"Ahri's survivability is dramatically reduced when her Ultimate, Spirit Rush, is down.",
				"Stay behind minions to make Charm difficult to land, this will reduce Ahri's damage potential significantly."
			],
			"tags": [
				"Mage",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 4,
				"magic": 8,
				"difficulty": 5
			},
			"stats": {
				"hp": 526,
				"hpperlevel": 92,
				"mp": 334,
				"mpperlevel": 50,
				"movespeed": 330,
				"armor": 20.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.065,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "AhriOrbofDeception",
					"name": "Orb of Deception",
					"description": "Ahri sends out and pulls back her orb, dealing magic damage on the way out and true damage on the way back. Ahri gains movement speed that decays while her orb is traveling.",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage on the way out, and {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> true damage on the way back.<br /><br />Ahri gains movement speed that decays while her orb is traveling.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"  {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						7,
						7,
						7,
						7
					],
					"cooldownBurn": "7",
					"cost": [
						65,
						70,
						75,
						80,
						85
					],
					"costBurn": "65/70/75/80/85",
					"effect": [
						null,
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/65/90/115/140",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						880,
						880,
						880,
						880,
						880
					],
					"rangeBurn": "880",
					"image": {
						"full": "AhriOrbofDeception.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AhriFoxFire",
					"name": "Fox-Fire",
					"description": "Ahri releases three fox-fires, that lock onto and attack nearby enemies.",
					"tooltip": "Releases three fox-fires that lock on to nearby enemies (prioritizes Champions) dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Enemies hit with multiple fox-fires take 30% damage from each additional fox-fire beyond the first, for a maximum of {{ f1 }} damage to a single enemy.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							12,
							19.5,
							27,
							34.5,
							42
						],
						[
							64,
							104,
							144,
							184,
							224
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/65/90/115/140",
						"12/19.5/27/34.5/42",
						"64/104/144/184/224",
						"30",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "AhriFoxFire.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AhriSeduce",
					"name": "Charm",
					"description": "Ahri blows a kiss that damages and charms an enemy it encounters, causing them to walk harmlessly towards her.",
					"tooltip": "Blows a kiss dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and charms an enemy causing them to walk harmlessly towards Ahri for {{ e2 }} second(s).",
					"leveltip": {
						"label": [
							"Damage",
							"Duration"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						85,
						85,
						85,
						85,
						85
					],
					"costBurn": "85",
					"effect": [
						null,
						[
							60,
							95,
							130,
							165,
							200
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/95/130/165/200",
						"1/1.25/1.5/1.75/2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						975,
						975,
						975,
						975,
						975
					],
					"rangeBurn": "975",
					"image": {
						"full": "AhriSeduce.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AhriTumble",
					"name": "Spirit Rush",
					"description": "Ahri dashes forward and fires essence bolts, damaging 3 nearby enemies (prioritizes Champions). Spirit Rush can be cast up to three times before going on cooldown.",
					"tooltip": "Nimbly dashes forward firing 3 essence bolts at nearby enemies (prioritizes Champions) dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Can be cast up to three times within 10 seconds before going on cooldown.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						95,
						80
					],
					"cooldownBurn": "110/95/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							70,
							110,
							150
						],
						[
							10,
							20,
							30
						],
						[
							28,
							23,
							18
						],
						[
							2,
							2,
							2
						],
						[
							1,
							1,
							1
						],
						[
							10,
							10,
							10
						],
						[
							10,
							10,
							10
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150",
						"10/20/30",
						"28/23/18",
						"2",
						"1",
						"10",
						"10",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "AhriTumble.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Essence Theft",
				"description": "Gains a charge of Essence Theft whenever a spell hits an enemy (max: 3 charges per spell). Upon reaching 9 charges, Ahri's next spell heals her whenever it hits an enemy.",
				"image": {
					"full": "Ahri_SoulEater.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ahri",
					"title": "AhriARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3114",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "AhriTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ahri",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				}
			]
		},
		"Akali": {
			"id": "Akali",
			"key": "84",
			"name": "Akali",
			"title": "the Fist of Shadow",
			"image": {
				"full": "Akali.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 96,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "84000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "84001",
					"num": 1,
					"name": "Stinger Akali",
					"chromas": false
				},
				{
					"id": "84002",
					"num": 2,
					"name": "Crimson Akali",
					"chromas": false
				},
				{
					"id": "84003",
					"num": 3,
					"name": "All-star Akali",
					"chromas": false
				},
				{
					"id": "84004",
					"num": 4,
					"name": "Nurse Akali",
					"chromas": false
				},
				{
					"id": "84005",
					"num": 5,
					"name": "Blood Moon Akali",
					"chromas": false
				},
				{
					"id": "84006",
					"num": 6,
					"name": "Silverfang Akali",
					"chromas": false
				},
				{
					"id": "84007",
					"num": 7,
					"name": "Headhunter Akali",
					"chromas": false
				},
				{
					"id": "84008",
					"num": 8,
					"name": "Sashimi Akali",
					"chromas": false
				}
			],
			"lore": "A prodigy in the fighting arts, Akali is a member of the martial order known as the Kinkou. She succeeds her mother as the Fist of Shadow, entrusted with the sacred duty to end those who would bring imbalance to her homeland. While some find her methods extreme, Akali is judicious in maintaining harmony across Ionia.",
			"blurb": "A prodigy in the fighting arts, Akali is a member of the martial order known as the Kinkou. She succeeds her mother as the Fist of Shadow, entrusted with the sacred duty to end those who would bring imbalance to her homeland. While some find her methods...",
			"allytips": [
				"Akali excels at killing weaker characters. Let your team initiate and then strike at the people in the back.",
				"Find the balance between storing Essence of Shadows, and using Shadow Dance before having max charges."
			],
			"enemytips": [
				"Akali can still be hit by area effect spells while Invisible inside Twilight Shroud.",
				"Akali can choose where she starts within her Twilight Shroud before casting it, even if part of the shroud would extend beyond a wall.",
				"Return to base if your Health is low and Akali has multiple charges of her ultimate."
			],
			"tags": [
				"Assassin"
			],
			"partype": "Energy",
			"info": {
				"attack": 5,
				"defense": 3,
				"magic": 8,
				"difficulty": 7
			},
			"stats": {
				"hp": 593,
				"hpperlevel": 90,
				"mp": 200,
				"mpperlevel": 0,
				"movespeed": 350,
				"armor": 31.38,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.65,
				"mpregen": 50,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 58.376,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.1,
				"attackspeedperlevel": 3.1
			},
			"spells": [
				{
					"id": "AkaliMota",
					"name": "Mark of the Assassin",
					"description": "Akali spins her kama at a target enemy to deal Magic Damage and mark the target for 6 seconds. Akali's melee attacks against a marked target will trigger and consume the mark to cause additional damage and restore Energy.",
					"tooltip": "Akali throws her kama at a target enemy to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and mark the target for {{ e4 }} seconds.<br /><br />Akali's melee attacks against a marked target will consume the mark to deal {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and restore {{ e3 }} energy.",
					"leveltip": {
						"label": [
							"Damage (initial)",
							"Damage (secondary)",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.5,
						5,
						4.5,
						4
					],
					"cooldownBurn": "6/5.5/5/4.5/4",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							35,
							55,
							75,
							95,
							115
						],
						[
							45,
							70,
							95,
							120,
							145
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/55/75/95/115",
						"45/70/95/120/145",
						"40",
						"6",
						"0",
						"0.4",
						"4",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a2"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "AkaliMota.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "AkaliSmokeBomb",
					"name": "Twilight Shroud",
					"description": "Akali teleports to a nearby location, leaving a cover of smoke at her previous location. While inside the shroud, Akali becomes Invisible and gains Movement Speed. Attacking or using abilities will briefly reveal her. Enemies inside the smoke have their Movement Speed reduced.",
					"tooltip": "Akali teleports to a nearby location, leaving a cover of smoke at her previous location that lasts for {{ e2 }} seconds and slows enemies within its area by {{ e3 }}%.<br /><br />While inside the shroud Akali gains <span class=\"color91d7ee\">Invisibility</span> and {{ e6 }}% movement speed. Attacking or using abilities briefly removes <span class=\"color91d7ee\">Invisibility</span>.<br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Akali can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
					"leveltip": {
						"label": [
							"Movement Speed",
							"Slow",
							"Cost"
						],
						"effect": [
							"{{ e6 }}% -> {{ e6NL }}%",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						18,
						18,
						18,
						18
					],
					"cooldownBurn": "18",
					"cost": [
						60,
						55,
						50,
						45,
						40
					],
					"costBurn": "60/55/50/45/40",
					"effect": [
						null,
						[
							425,
							425,
							425,
							425,
							425
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							14,
							18,
							22,
							26,
							30
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"425",
						"8",
						"14/18/22/26/30",
						"250",
						"0",
						"20/40/60/80/100",
						"1",
						"0.5",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						270,
						270,
						270,
						270,
						270
					],
					"rangeBurn": "270",
					"image": {
						"full": "AkaliSmokeBomb.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "AkaliShadowSwipe",
					"name": "Crescent Slash",
					"description": "Akali flourishes her kamas, dealing damage based on her bonus Attack Damage and Ability Power. When Crescent Slash kills a unit, it has a shorter cooldown.",
					"tooltip": "Akali flourishes her kamas, slicing enemies for {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage.<br /><br />If Crescent Slash kills an enemy, its cooldown is refunded by {{ e3 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						4.5,
						4,
						3.5,
						3
					],
					"cooldownBurn": "5/4.5/4/3.5/3",
					"cost": [
						60,
						55,
						50,
						45,
						40
					],
					"costBurn": "60/55/50/45/40",
					"effect": [
						null,
						[
							70,
							100,
							130,
							160,
							190
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/100/130/160/190",
						"1",
						"60",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "AkaliShadowSwipe.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "AkaliShadowDance",
					"name": "Shadow Dance",
					"description": "Akali moves through shadows to quickly strike through her target, dealing damage and consuming an Essence of Shadow charge. Akali recharges Essence of Shadow charges periodically, max 3 stacks.",
					"tooltip": "Akali quickly strikes through her target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Akali stores an Essence of Shadow on kills and assists as well as every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds up to {{ e4 }} total.",
					"leveltip": {
						"label": [
							"Damage",
							"Essence Refresh Timer"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f1 }} -> {{ f2 }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						2,
						2,
						2
					],
					"cooldownBurn": "2",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							50,
							100,
							150
						],
						[
							2000,
							2000,
							2000
						],
						[
							1,
							1,
							1
						],
						[
							3,
							3,
							3
						],
						[
							1,
							1,
							1
						],
						[
							100,
							100,
							100
						],
						[
							200,
							200,
							200
						],
						[
							600,
							600,
							600
						],
						[
							225,
							225,
							225
						],
						[
							1,
							1,
							1
						]
					],
					"effectBurn": [
						null,
						"50/100/150",
						"2000",
						"1",
						"3",
						"1",
						"100",
						"200",
						"600",
						"225",
						"1"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						},
						{
							"link": "@cooldownchampion",
							"coeff": [
								30,
								22.5,
								15
							],
							"key": "f1"
						},
						{
							"link": "@cooldownchampion",
							"coeff": [
								30,
								22.5,
								15
							],
							"key": "f1"
						},
						{
							"link": "@cooldownchampion",
							"coeff": [
								22.5,
								15
							],
							"key": "f2"
						}
					],
					"costType": " Essence of Shadow",
					"maxammo": "3",
					"range": [
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "AkaliShadowDance.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e5 }} Essence of Shadow"
				}
			],
			"passive": {
				"name": "Twin Disciplines",
				"description": "Akali's first two attacks are empowered. The first strike heals her, and the second strike deals bonus magic damage. Twin Disciplines will recharge itself automatically a short while after being used.",
				"image": {
					"full": "AkaliTwinDisciplines.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Akali",
					"title": "AkaliARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "AkaliCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "AkaliFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "AkaliKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "AkaliSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "AkaliSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "AkaliTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Akali",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"customPanel": "",
					"customPanelCurrencyType": "",
					"customPanelBuffCurrencyName": "",
					"blocks": [
						{
							"type": "beginner_Starter",
							"recMath": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_Starter",
							"recMath": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"recMath": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Alistar": {
			"id": "Alistar",
			"key": "12",
			"name": "Alistar",
			"title": "the Minotaur",
			"image": {
				"full": "Alistar.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 144,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "12000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "12001",
					"num": 1,
					"name": "Black Alistar",
					"chromas": false
				},
				{
					"id": "12002",
					"num": 2,
					"name": "Golden Alistar",
					"chromas": false
				},
				{
					"id": "12003",
					"num": 3,
					"name": "Matador Alistar",
					"chromas": false
				},
				{
					"id": "12004",
					"num": 4,
					"name": "Longhorn Alistar",
					"chromas": false
				},
				{
					"id": "12005",
					"num": 5,
					"name": "Unchained Alistar",
					"chromas": false
				},
				{
					"id": "12006",
					"num": 6,
					"name": "Infernal Alistar",
					"chromas": false
				},
				{
					"id": "12007",
					"num": 7,
					"name": "Sweeper Alistar",
					"chromas": false
				},
				{
					"id": "12008",
					"num": 8,
					"name": "Marauder Alistar",
					"chromas": false
				},
				{
					"id": "12009",
					"num": 9,
					"name": "SKT T1 Alistar",
					"chromas": false
				},
				{
					"id": "12010",
					"num": 10,
					"name": "Moo Cow Alistar",
					"chromas": true
				}
			],
			"lore": "Always a mighty warrior with a fearsome reputation, Alistar seeks revenge for the death of his clan at the hands of the Noxian empire. Though he was enslaved and forced into the life of a gladiator, his unbreakable will was what kept him from truly becoming a beast. Now, free of the chains of his former masters, he fights in the name of the downtrodden and the disadvantaged, his rage as much a weapon as his horns, hooves and fists.",
			"blurb": "Always a mighty warrior with a fearsome reputation, Alistar seeks revenge for the death of his clan at the hands of the Noxian empire. Though he was enslaved and forced into the life of a gladiator, his unbreakable will was what kept him from truly...",
			"allytips": [
				"Using Pulverize can allow you to establish better positioning for Headbutt.",
				"Movement speed is very important on Alistar. Consider which boots to buy carefully.",
				"Using Flash can allow you catch your target off guard to knock them back into your allies with Pulverize and Headbutt."
			],
			"enemytips": [
				"Alistar is very disruptive but very tough - try to target more fragile damage dealers.",
				"Watch out for the Pulverize-Headbutt combo when around turrets.",
				"When Alistar uses his ultimate, it's often better to move back and wait until the effect wears off before attacking him."
			],
			"tags": [
				"Tank",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 9,
				"magic": 5,
				"difficulty": 7
			},
			"stats": {
				"hp": 613.36,
				"hpperlevel": 106,
				"mp": 278.84,
				"mpperlevel": 38,
				"movespeed": 330,
				"armor": 44,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.85,
				"mpregen": 8.5,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61.1116,
				"attackdamageperlevel": 3.62,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.125
			},
			"spells": [
				{
					"id": "Pulverize",
					"name": "Pulverize",
					"description": "Alistar smashes the ground, dealing damage to nearby enemies and tossing them into the air.",
					"tooltip": "Alistar smashes the ground, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and tossing nearby enemy units into the air for {{ e3 }} second.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						16,
						15,
						14,
						13
					],
					"cooldownBurn": "17/16/15/14/13",
					"cost": [
						65,
						70,
						75,
						80,
						85
					],
					"costBurn": "65/70/75/80/85",
					"effect": [
						null,
						[
							375,
							375,
							375,
							375,
							375
						],
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"375",
						"60/105/150/195/240",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						365,
						365,
						365,
						365,
						365
					],
					"rangeBurn": "365",
					"image": {
						"full": "Pulverize.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Headbutt",
					"name": "Headbutt",
					"description": "Alistar rams a target with his head, dealing damage and knocking the target back.",
					"tooltip": "Alistar rams into an enemy, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and knocking them back.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						65,
						70,
						75,
						80,
						85
					],
					"costBurn": "65/70/75/80/85",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							55,
							110,
							165,
							220,
							275
						],
						[
							700,
							700,
							700,
							700,
							700
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"55/110/165/220/275",
						"700",
						"0.75",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "Headbutt.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AlistarE",
					"name": "Trample",
					"description": "Alistar tramples nearby enemy units, ignoring unit collision and gaining stacks if he damages an enemy champion. At full stacks Alistar's next basic attack against an enemy champion deals additional magic damage and stuns them.",
					"tooltip": "Alistar tramples the ground, ignoring unit collision and dealing {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage over {{ e3 }} seconds to nearby enemies. Each pulse that damages at least one enemy champion grants Alistar a <span class=\"colorFF6E1C\">Trample</span> stack.<br /><br />At {{ e5 }} <span class=\"colorFF6E1C\">Trample</span> stacks Alistar empowers his next basic attack against an enemy champion to deal an additional <span class=\"colorFFFFFF\">{{ f3 }}</span> magic damage and stun for {{ e6 }} second.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Mana Cost",
							"Trample Damage"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11.5,
						11,
						10.5,
						10
					],
					"cooldownBurn": "12/11.5/11/10.5/10",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							100,
							125,
							150,
							175,
							200
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							350,
							350,
							350,
							350,
							350
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/125/150/175/200",
						"50",
						"5",
						"350",
						"5",
						"1",
						"5",
						"40",
						"15",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "AlistarE.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FerociousHowl",
					"name": "Unbreakable Will",
					"description": "Alistar lets out a wild roar, removing all crowd control effects on himself, and reducing incoming physical and magical damage for the duration.",
					"tooltip": "Removes all disables from Alistar. For {{ e1 }} seconds Alistar takes {{ e2 }}% reduced physical and magical damage.",
					"leveltip": {
						"label": [
							"Damage Reduction",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							7,
							7,
							7
						],
						[
							55,
							65,
							75
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"7",
						"55/65/75",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "FerociousHowl.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Triumphant Roar",
				"description": "Alistar charges his roar by stunning or displacing enemy champions or when nearby enemies die. When fully charged he heals himself and all nearby allied champions.",
				"image": {
					"full": "Alistar_E.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Alistar",
					"title": "AlistarARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "AlistarCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "AlistarFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3711",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "AlistarKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "AlistarSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "AlistarSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "AlistarTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Alistar",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3158",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3065",
									"count": 1
								},
								{
									"id": "3110",
									"count": 1
								},
								{
									"id": "3001",
									"count": 1
								},
								{
									"id": "3083",
									"count": 1
								}
							]
						}
					]
				}
			]
		},
		"Amumu": {
			"id": "Amumu",
			"key": "32",
			"name": "Amumu",
			"title": "the Sad Mummy",
			"image": {
				"full": "Amumu.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 192,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "32000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "32001",
					"num": 1,
					"name": "Pharaoh Amumu",
					"chromas": false
				},
				{
					"id": "32002",
					"num": 2,
					"name": "Vancouver Amumu",
					"chromas": false
				},
				{
					"id": "32003",
					"num": 3,
					"name": "Emumu",
					"chromas": false
				},
				{
					"id": "32004",
					"num": 4,
					"name": "Re-Gifted Amumu",
					"chromas": false
				},
				{
					"id": "32005",
					"num": 5,
					"name": "Almost-Prom King Amumu",
					"chromas": false
				},
				{
					"id": "32006",
					"num": 6,
					"name": "Little Knight Amumu",
					"chromas": false
				},
				{
					"id": "32007",
					"num": 7,
					"name": "Sad Robot Amumu",
					"chromas": false
				},
				{
					"id": "32008",
					"num": 8,
					"name": "Surprise Party Amumu",
					"chromas": true
				}
			],
			"lore": "Legend claims that Amumu is a lonely and melancholy soul from ancient Shurima, roaming the world in search of a friend. Doomed by an ancient curse to remain alone forever, his touch is death, his affection ruin. Those who claim to have seen him describe a living cadaver, small in stature and wrapped in creeping bandages. Amumu has inspired myths, songs, and folklore told and retold for generations—such that it is impossible to separate truth from fiction.",
			"blurb": "Legend claims that Amumu is a lonely and melancholy soul from ancient Shurima, roaming the world in search of a friend. Doomed by an ancient curse to remain alone forever, his touch is death, his affection ruin. Those who claim to have seen him describe...",
			"allytips": [
				"Amumu is highly dependent on teammates, so try laning with your friends for maximum effectiveness.",
				"Cooldown Reduction on Amumu is very strong, but it's often difficult to itemize for it. Grab the Golem buff whenever possible to gain Cooldown Reduction without sacrificing stats.",
				"Despair is very effective against other tanks, so make sure you're in range of opponents with the highest Health."
			],
			"enemytips": [
				"Avoid bunching up with other allies when Amumu has his ultimate available.",
				"Erratic movement, or hiding behind creep waves can make it difficult for Amumu to instigate a fight with Bandage Toss.",
				"Amumu's Despair makes purchasing primarily Health items a risky proposition."
			],
			"tags": [
				"Tank",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 6,
				"magic": 8,
				"difficulty": 3
			},
			"stats": {
				"hp": 613.12,
				"hpperlevel": 84,
				"mp": 287.2,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 33,
				"armorperlevel": 3.8,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9,
				"hpregenperlevel": 0.85,
				"mpregen": 7.382,
				"mpregenperlevel": 0.525,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.38,
				"attackdamageperlevel": 3.8,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 2.18
			},
			"spells": [
				{
					"id": "BandageToss",
					"name": "Bandage Toss",
					"description": "Amumu tosses a sticky bandage at a target, stunning and damaging the target while he pulls himself to them.",
					"tooltip": "Launches a bandage in a direction. If it hits an enemy unit, Amumu pulls himself to them, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and stunning for {{ e2 }} second. ",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14,
						12,
						10,
						8
					],
					"cooldownBurn": "16/14/12/10/8",
					"cost": [
						80,
						90,
						100,
						110,
						120
					],
					"costBurn": "80/90/100/110/120",
					"effect": [
						null,
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1350,
							1350,
							1350,
							1350,
							1350
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/130/180/230/280",
						"1",
						"1350",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "BandageToss.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AuraofDespair",
					"name": "Despair",
					"description": "Overcome by anguish, nearby enemies lose a percentage of their maximum Health each second and have their <font color='#9b0f5f'>Curses</font> refreshed.",
					"tooltip": "<span class=\"colorFF9900\">Toggle: </span>Amumu cries, refreshing <span class=\"color9b0f5f\">Curses</span> on nearby enemies and dealing magic damage equal to {{ e2 }} plus {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of their maximum health each second.",
					"leveltip": {
						"label": [
							"Percent Health Damaged",
							"Base Damage"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1,
						1,
						1,
						1,
						1
					],
					"cooldownBurn": "1",
					"cost": [
						8,
						8,
						8,
						8,
						8
					],
					"costBurn": "8",
					"effect": [
						null,
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1/1.25/1.5/1.75/2",
						"10/15/20/25/30",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.01,
							"key": "a1"
						}
					],
					"costType": " Mana per Second",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "AuraofDespair.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana per Second"
				},
				{
					"id": "Tantrum",
					"name": "Tantrum",
					"description": "Permanently reduces the physical damage Amumu would take. Amumu can unleash his rage, dealing damage to surrounding enemies. Each time Amumu is hit, the cooldown on Tantrum is reduced by 0.5 seconds.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Amumu takes {{ e1 }} reduced damage from physical attacks.<br /><br /><span class=\"colorFF9900\">Active: </span>Amumu tantrums, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to surrounding units.<br /><br /><span class=\"size16 color8C8C8C\">Basic attacks that hit Amumu reduce the cooldown of Tantrum by 0.5 seconds.</span>",
					"leveltip": {
						"label": [
							"Damage Reduced",
							"Cooldown",
							"Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						35,
						35,
						35,
						35,
						35
					],
					"costBurn": "35",
					"effect": [
						null,
						[
							2,
							4,
							6,
							8,
							10
						],
						[
							75,
							100,
							125,
							150,
							175
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2/4/6/8/10",
						"75/100/125/150/175",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "Tantrum.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CurseoftheSadMummy",
					"name": "Curse of the Sad Mummy",
					"description": "Amumu entangles surrounding enemy units in bandages, applying his <font color='#9b0f5f'>Curse</font>, damaging them and rendering them unable to attack or move.",
					"tooltip": "Amumu entangles nearby enemy units, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and applying <span class=\"color9b0f5f\">Curse</span>. Entangled enemies are unable to attack or move for 2 seconds.",
					"leveltip": {
						"label": [
							"Damage Dealt",
							"Mana Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						150,
						130,
						110
					],
					"cooldownBurn": "150/130/110",
					"cost": [
						100,
						150,
						200
					],
					"costBurn": "100/150/200",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "CurseoftheSadMummy.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Cursed Touch",
				"description": "Amumu's basic attacks <font color='#9b0f5f'>Curse</font> enemies for 3 seconds, causing them to take 10% bonus true damage from any magic damage dealt to them.<rules>",
				"image": {
					"full": "Amumu_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Amumu",
					"title": "AmumuARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "AmumuCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "AmumuFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "AmumuKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "AmumuSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "AmumuSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "AmumuTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Amumu",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1054",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1054",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3068",
									"count": 1
								},
								{
									"id": "3105",
									"count": 1
								},
								{
									"id": "3110",
									"count": 1
								},
								{
									"id": "3001",
									"count": 1
								}
							]
						}
					]
				}
			]
		},
		"Anivia": {
			"id": "Anivia",
			"key": "34",
			"name": "Anivia",
			"title": "the Cryophoenix",
			"image": {
				"full": "Anivia.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 240,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "34000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "34001",
					"num": 1,
					"name": "Team Spirit Anivia",
					"chromas": false
				},
				{
					"id": "34002",
					"num": 2,
					"name": "Bird of Prey Anivia",
					"chromas": false
				},
				{
					"id": "34003",
					"num": 3,
					"name": "Noxus Hunter Anivia",
					"chromas": false
				},
				{
					"id": "34004",
					"num": 4,
					"name": "Hextech Anivia",
					"chromas": false
				},
				{
					"id": "34005",
					"num": 5,
					"name": "Blackfrost Anivia",
					"chromas": false
				},
				{
					"id": "34006",
					"num": 6,
					"name": "Prehistoric Anivia",
					"chromas": false
				},
				{
					"id": "34007",
					"num": 7,
					"name": "Festival Queen Anivia",
					"chromas": false
				}
			],
			"lore": "Anivia is a benevolent winged spirit who endures endless cycles of life, death, and rebirth to protect the Freljord. A demigod born of unforgiving ice and bitter winds, she wields those elemental powers to thwart any who dare disturb her homeland. Anivia guides and protects the tribes of the harsh north, who revere her as a symbol of hope, and a portent of great change. She fights with every ounce of her being, knowing that through her sacrifice, her memory will endure, and she will be reborn into a new tomorrow.",
			"blurb": "Anivia is a benevolent winged spirit who endures endless cycles of life, death, and rebirth to protect the Freljord. A demigod born of unforgiving ice and bitter winds, she wields those elemental powers to thwart any who dare disturb her homeland...",
			"allytips": [
				"Timing Flash Frost with Frostbite can lead to devastating combinations.",
				"Anivia is extremely reliant on Mana for Glacial Storm. Try getting items with Mana or going for a Crest of the Ancient Golem buff on Summoner's Rift.",
				"It can be very difficult for enemy champions to kill her egg early in game. Seize the advantage by playing aggressively."
			],
			"enemytips": [
				"Try to gank Anivia when she's laning. With multiple people, it is easier to ensure that her egg dies.",
				"If you're playing a ranged champion, stay far enough away from Anivia so you can dodge Flash Frost more easily.",
				"Try to fight Anivia in the lanes. In the jungle she can block pathways with lower ranks of Crystallize."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 4,
				"magic": 10,
				"difficulty": 10
			},
			"stats": {
				"hp": 480,
				"hpperlevel": 82,
				"mp": 396.04,
				"mpperlevel": 50,
				"movespeed": 325,
				"armor": 21.22,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 600,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 51.376,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.68
			},
			"spells": [
				{
					"id": "FlashFrost",
					"name": "Flash Frost",
					"description": "Anivia brings her wings together and summons a sphere of ice that flies towards her opponents, chilling and damaging anyone in its path. When the sphere explodes it does moderate damage in a radius, stunning anyone in the area.",
					"tooltip": "A massive chunk of ice flies toward target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. <br /><br />At the end of its range or if Anivia activates the spell again, the missile detonates, doing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage in a small area and stunning units for {{ e4 }} seconds.<br /><br />Enemies damaged by Flash Frost are also slowed by {{ f1 }}% for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Stun Duration",
							"Cooldown",
							"Mana Cost "
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						80,
						90,
						100,
						110,
						120
					],
					"costBurn": "80/90/100/110/120",
					"effect": [
						null,
						[
							60,
							85,
							110,
							135,
							160
						],
						[
							13,
							12,
							11,
							10,
							9
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.1,
							1.2,
							1.3,
							1.4,
							1.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/85/110/135/160",
						"13/12/11/10/9",
						"0",
						"1.1/1.2/1.3/1.4/1.5",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "FlashFrost.png",
						"sprite": "spell0.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Crystallize",
					"name": "Crystallize",
					"description": "Anivia condenses the moisture in the air into an impassable wall of ice to block all movement. The wall only lasts a short duration before it melts.",
					"tooltip": "Anivia summons an impassable wall of ice {{ e2 }} units wide, blocking all movement. The wall lasts for {{ e1 }} seconds before it melts.",
					"leveltip": {
						"label": [
							"Width"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						17,
						17,
						17,
						17
					],
					"cooldownBurn": "17",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							400,
							500,
							600,
							700,
							800
						],
						[
							4,
							5,
							6,
							7,
							8
						],
						[
							120,
							120,
							120,
							120,
							120
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5",
						"400/500/600/700/800",
						"4/5/6/7/8",
						"120",
						"250",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "Crystallize.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Frostbite",
					"name": "Frostbite",
					"description": "With a flap of her wings, Anivia blasts a freezing gust of wind at her target, dealing a low amount of damage. If the target was recently stunned by Flash Frost or damaged by a fully formed Glacial Storm, the damage they take is doubled.",
					"tooltip": "Anivia blasts her target with a freezing wind, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. <br /><br />If a target was recently stunned by Anivia or damaged by a fully formed Glacial Storm, they take double damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "Frostbite.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GlacialStorm",
					"name": "Glacial Storm",
					"description": "Anivia summons a driving rain of ice and hail to damage her enemies and slow their advance.",
					"tooltip": "<span class=\"colorFF9900\">Activate: </span>Drains {{ e2 }} Mana per second. <br /><br />Anivia calls forth a driving rain of ice and hail that increases in size over {{ e7 }} seconds, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to targets and slowing their Movement Speed by {{ e4 }}%. <br /><br />When the Glacial Storm is fully formed, it slows targets' Movement Speed by {{ f1 }}% and does {{ e3 }}% damage instead.",
					"leveltip": {
						"label": [
							"Damage Per Second",
							"Chilled Slow Amount",
							"Mana Cost Per Second"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						75,
						75,
						75
					],
					"costBurn": "75",
					"effect": [
						null,
						[
							40,
							60,
							80
						],
						[
							40,
							50,
							60
						],
						[
							300,
							300,
							300
						],
						[
							20,
							30,
							40
						],
						[
							0,
							0,
							0
						],
						[
							1,
							1,
							1
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							50,
							50,
							50
						],
						[
							800,
							800,
							800
						],
						[
							1000,
							1000,
							1000
						]
					],
					"effectBurn": [
						null,
						"40/60/80",
						"40/50/60",
						"300",
						"20/30/40",
						"0",
						"1",
						"1.5",
						"50",
						"800",
						"1000"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.125,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "GlacialStorm.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Rebirth",
				"description": "Upon dying, Anivia will revert into an egg. If the egg can survive for six seconds, she is gloriously reborn.",
				"image": {
					"full": "Anivia_P.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Anivia",
					"title": "AniviaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "AniviaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "AniviaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "AniviaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "AniviaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "AniviaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "AniviaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Anivia",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Annie": {
			"id": "Annie",
			"key": "1",
			"name": "Annie",
			"title": "the Dark Child",
			"image": {
				"full": "Annie.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 288,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "1000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "1001",
					"num": 1,
					"name": "Goth Annie",
					"chromas": false
				},
				{
					"id": "1002",
					"num": 2,
					"name": "Red Riding Annie",
					"chromas": false
				},
				{
					"id": "1003",
					"num": 3,
					"name": "Annie in Wonderland",
					"chromas": false
				},
				{
					"id": "1004",
					"num": 4,
					"name": "Prom Queen Annie",
					"chromas": false
				},
				{
					"id": "1005",
					"num": 5,
					"name": "Frostfire Annie",
					"chromas": false
				},
				{
					"id": "1006",
					"num": 6,
					"name": "Reverse Annie",
					"chromas": false
				},
				{
					"id": "1007",
					"num": 7,
					"name": "FrankenTibbers Annie",
					"chromas": false
				},
				{
					"id": "1008",
					"num": 8,
					"name": "Panda Annie",
					"chromas": false
				},
				{
					"id": "1009",
					"num": 9,
					"name": "Sweetheart Annie",
					"chromas": false
				},
				{
					"id": "1010",
					"num": 10,
					"name": "Hextech Annie",
					"chromas": false
				},
				{
					"id": "1011",
					"num": 11,
					"name": "Super Galaxy Annie",
					"chromas": false
				}
			],
			"lore": "Dangerous, yet disarmingly precocious, Annie is a child mage with immense pyromantic power. Even in the shadows of the mountains north of Noxus, she is a magical outlier. Her natural affinity for fire manifested early in life through unpredictable, emotional outbursts, though she eventually learned to control these “playful tricks.” Her favorite includes the summoning of her beloved teddy bear, Tibbers, as a fiery protector. Lost in the perpetual innocence of childhood, Annie wanders the dark forests, always looking for someone to play with.",
			"blurb": "Dangerous, yet disarmingly precocious, Annie is a child mage with immense pyromantic power. Even in the shadows of the mountains north of Noxus, she is a magical outlier. Her natural affinity for fire manifested early in life through unpredictable...",
			"allytips": [
				"Storing a stun for use with her ultimate can turn the tide of a team fight.",
				"Striking killing blows on minions with Disintegrate enables Annie to farm extremely well early in the game.",
				"Molten Shield is a good spell to cast to work up to Annie's stun, so sometimes it's beneficial to grab at least 1 rank in it early."
			],
			"enemytips": [
				"Annie's summoned bear, Tibbers, burns opposing units around himself. Try to keep your distance from him after he's been summoned.",
				"Summoner Smite can be used to help take down Tibbers.",
				"Keep an eye out for a white, swirling power around Annie. It means she's ready to unleash her stun."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 3,
				"magic": 10,
				"difficulty": 6
			},
			"stats": {
				"hp": 524,
				"hpperlevel": 88,
				"mp": 334,
				"mpperlevel": 50,
				"movespeed": 335,
				"armor": 19.22,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 575,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 50.41,
				"attackdamageperlevel": 2.625,
				"attackspeedoffset": 0.08,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "Disintegrate",
					"name": "Disintegrate",
					"description": "Annie hurls a Mana infused fireball, dealing damage and refunding the Mana cost if it destroys the target.",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Mana cost and half the cooldown are refunded if Disintegrate kills the target.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							80,
							115,
							150,
							185,
							220
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/115/150/185/220",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "Disintegrate.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Incinerate",
					"name": "Incinerate",
					"description": "Annie casts a blazing cone of fire, dealing damage to all enemies in the area.",
					"tooltip": "Casts a cone of fire dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in the area.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.85,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "Incinerate.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MoltenShield",
					"name": "Molten Shield",
					"description": "Grants Annie and Tibbers increased percentage Damage Resist and damages enemies who attack with basic attacks.",
					"tooltip": "Annie grants herself and Tibbers {{ e1 }}% damage reduction for {{ e3 }} seconds.<br /><br />While the shield is active, enemies who basic attack it take {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Damage Reduction",
							"Damage Return"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							16,
							22,
							28,
							34,
							40
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"16/22/28/34/40",
						"20/30/40/50/60",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						0,
						0,
						0,
						0,
						0
					],
					"rangeBurn": "0",
					"image": {
						"full": "MoltenShield.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "InfernalGuardian",
					"name": "Summon: Tibbers",
					"description": "Annie wills her bear Tibbers to life, dealing damage to units in the area. Tibbers can attack and also burns enemies that stand near him.",
					"tooltip": "Summons Tibbers, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the target area. For the next 45 seconds, Tibbers burns nearby enemies for {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> per second and attacks for {{ e3 }} <span class=\"color99FF99\">(+{{ f1 }})</span> as magic damage. Annie can control Tibbers by reactivating this ability.<br /><br />Tibbers <span class=\"colorFFEB7F\">Enrages</span> when: summoned; Annie uses Pyromania on an enemy Champion; and when Annie dies.<br /><br /><span class=\"colorFFEB7F\">Enrages</span>: Tibbers gains 275% Attack Speed and 100% Movement Speed, decaying over 3 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Tibbers Health",
							"Tibbers Armor and Magic Resist",
							"Tibbers Attack Damage",
							"Tibbers Burn Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e0 }} -> {{ e0NL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							275,
							400
						],
						[
							10,
							15,
							20
						],
						[
							50,
							75,
							100
						],
						[
							-0.1,
							-0.1,
							-0.1
						],
						[
							1,
							1,
							1
						],
						[
							3,
							3,
							3
						],
						[
							30,
							50,
							70
						],
						[
							0,
							900,
							1800
						],
						[
							0.15,
							0.15,
							0.15
						],
						[
							1200,
							2100,
							3000
						]
					],
					"effectBurn": [
						null,
						"150/275/400",
						"10/15/20",
						"50/75/100",
						"-0.1",
						"1",
						"3",
						"30/50/70",
						"0/900/1800",
						"0.15",
						"1200/2100/3000"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "InfernalGuardian.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Pyromania",
				"description": "After casting 4 spells, Annie's next offensive spell will stun the target for a short duration.",
				"image": {
					"full": "Annie_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Annie",
					"title": "AnnieARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "AnnieCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "AnnieFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "AnnieKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "AnnieSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "AnnieSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "AnnieTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Annie",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Ashe": {
			"id": "Ashe",
			"key": "22",
			"name": "Ashe",
			"title": "the Frost Archer",
			"image": {
				"full": "Ashe.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 336,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "22000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "22001",
					"num": 1,
					"name": "Freljord Ashe",
					"chromas": false
				},
				{
					"id": "22002",
					"num": 2,
					"name": "Sherwood Forest Ashe",
					"chromas": false
				},
				{
					"id": "22003",
					"num": 3,
					"name": "Woad Ashe",
					"chromas": false
				},
				{
					"id": "22004",
					"num": 4,
					"name": "Queen Ashe",
					"chromas": false
				},
				{
					"id": "22005",
					"num": 5,
					"name": "Amethyst Ashe",
					"chromas": false
				},
				{
					"id": "22006",
					"num": 6,
					"name": "Heartseeker Ashe",
					"chromas": false
				},
				{
					"id": "22007",
					"num": 7,
					"name": "Marauder Ashe",
					"chromas": false
				},
				{
					"id": "22008",
					"num": 8,
					"name": "PROJECT: Ashe",
					"chromas": false
				},
				{
					"id": "22009",
					"num": 9,
					"name": "Championship Ashe",
					"chromas": true
				}
			],
			"lore": "Iceborn warmother of the Avarosan tribe, Ashe commands the most populous horde in the north. Stoic, intelligent, and idealistic, yet uncomfortable with her role as leader, she taps into the ancestral magics of her lineage to wield a bow of True Ice. With her people's belief that she is the mythological hero Avarosa reincarnated, Ashe hopes to unify the Freljord once more by retaking their ancient, tribal lands.",
			"blurb": "Iceborn warmother of the Avarosan tribe, Ashe commands the most populous horde in the north. Stoic, intelligent, and idealistic, yet uncomfortable with her role as leader, she taps into the ancestral magics of her lineage to wield a bow of True Ice...",
			"allytips": [
				"Try to fire Enchanted Crystal Arrow in the same direction enemies are moving, so it is more likely to hit.",
				"Volley arrows are blocked by the first enemy they hit, so keep your distance to avoid having them all absorbed by enemy frontliners.",
				"Hawkshot reveals units in brush. If a team fight is occuring in the jungle it can give you a significant advantage."
			],
			"enemytips": [
				"Ashe has very few defensive options, and she's a good target to gank.",
				"Be wary of moving around the map alone if Ashe has not recently cast her Enchanted Crystal Arrow."
			],
			"tags": [
				"Marksman",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 3,
				"magic": 2,
				"difficulty": 4
			},
			"stats": {
				"hp": 527.72,
				"hpperlevel": 79,
				"mp": 280,
				"mpperlevel": 32,
				"movespeed": 325,
				"armor": 30,
				"armorperlevel": 3.4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 600,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6.972,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 2.26,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3.33
			},
			"spells": [
				{
					"id": "AsheQ",
					"name": "Ranger's Focus",
					"description": "Ashe builds up Focus by attacking. At maximum Focus, Ashe can cast Ranger's Focus to consume all stacks of Focus, temporarily increasing her Attack Speed and transforming her basic attack into a powerful flurry attack for the duration.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Basic attacks grant Focus for {{ e1 }} seconds, stacking up to {{ e2 }} times. Stacks fall off one at a time, and at {{ e2 }} stacks, Ranger's Focus can be cast, consuming all Focus.<br /><br /><span class=\"colorFF9900\">Active:</span> For {{ e3 }} seconds, Ashe gains {{ e4 }}% Attack Speed, and her basic attacks fire a flurry of arrows dealing <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage. During this time, she does not stack Focus. Ranger's Focus applies Frost Shot.",
					"leveltip": {
						"label": [
							"Attack Speed Bonus",
							"Flurry Attack Damage ratio"
						],
						"effect": [
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e6 }} -> {{ e6NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0.21,
							0.22,
							0.23,
							0.24,
							0.25
						],
						[
							1.05,
							1.1,
							1.15,
							1.2,
							1.25
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4",
						"4",
						"4",
						"20/25/30/35/40",
						"0.21/0.22/0.23/0.24/0.25",
						"1.05/1.1/1.15/1.2/1.25",
						"1",
						"1",
						"1",
						"0"
					],
					"vars": [],
					"costType": " Mana, {{ e2 }} Focus",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "AsheQ.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana, {{ e2 }} Focus"
				},
				{
					"id": "Volley",
					"name": "Volley",
					"description": "Ashe fires 9 arrows in a cone for increased damage. Also applies Frost Shot.",
					"tooltip": "Fires arrows in a cone, each dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. Enemies can block multiple arrows, but only take damage from the first.<br /><br />Champion hits count as Critical Strikes for the purposes of Frost Shot.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						12.5,
						10,
						7.5,
						5
					],
					"cooldownBurn": "15/12.5/10/7.5/5",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							5,
							7,
							9,
							11,
							13
						],
						[
							20,
							35,
							50,
							65,
							80
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5/7/9/11/13",
						"20/35/50/65/80",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "Volley.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AsheSpiritOfTheHawk",
					"name": "Hawkshot",
					"description": "Ashe sends her Hawk Spirit on a scouting mission anywhere on the map.",
					"tooltip": "Reveals terrain as it flies toward target location anywhere on the map. Grants vision for {{ e4 }} seconds. Ashe can store up to 2 charges of Hawkshot.",
					"leveltip": {
						"label": [
							"Recharge Time"
						],
						"effect": [
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						5,
						5,
						5,
						5
					],
					"cooldownBurn": "5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							50,
							90,
							130,
							170,
							210
						],
						[
							25000,
							25000,
							25000,
							25000,
							25000
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"3",
						"50/90/130/170/210",
						"25000",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "2",
					"range": [
						25000,
						25000,
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "AsheSpiritOfTheHawk.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "EnchantedCrystalArrow",
					"name": "Enchanted Crystal Arrow",
					"description": "Ashe fires a missile of ice in a straight line. If the arrow collides with an enemy Champion, it deals damage and stuns the Champion, stunning for longer the farther arrow has traveled. In addition, surrounding enemy units take damage and are slowed.",
					"tooltip": "Launches a crystal arrow of ice that stuns the first enemy Champion hit, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The farther the arrow flies, the longer the stun, up to {{ e2 }} seconds. Surrounding enemies take half damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							200,
							400,
							600
						],
						[
							3.5,
							3.5,
							3.5
						],
						[
							50,
							50,
							50
						],
						[
							3,
							3,
							3
						],
						[
							5,
							5,
							5
						],
						[
							1100,
							1200,
							1300
						],
						[
							1,
							1,
							1
						],
						[
							400,
							400,
							400
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/400/600",
						"3.5",
						"50",
						"3",
						"5",
						"1100/1200/1300",
						"1",
						"400",
						"0.5",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "EnchantedCrystalArrow.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Frost Shot",
				"description": "Ashe's attacks slow their target, causing her to deal increased damage to these targets.<br><br>Ashe's critical strikes deal no bonus damage but apply an empowered slow to the target.",
				"image": {
					"full": "Ashe_P.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ashe",
					"title": "AsheARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheBT",
					"map": "SR",
					"mode": "TUTORIAL",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AshePRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "AsheTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Ashe",
					"title": "Map12T",
					"map": "HA",
					"mode": "TUTORIAL",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"AurelionSol": {
			"id": "AurelionSol",
			"key": "136",
			"name": "Aurelion Sol",
			"title": "The Star Forger",
			"image": {
				"full": "AurelionSol.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 384,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "136000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "136001",
					"num": 1,
					"name": "Ashen Lord Aurelion Sol",
					"chromas": false
				}
			],
			"lore": "Aurelion Sol once graced the vast emptiness of the cosmos with celestial wonders of his own devising. Now, he is forced to wield his awesome power at the behest of a space-faring empire that tricked him into servitude. Desiring a return to his star-forging ways, Aurelion Sol will drag the very stars from the sky, if he must, in order to regain his freedom.",
			"blurb": "Aurelion Sol once graced the vast emptiness of the cosmos with celestial wonders of his own devising. Now, he is forced to wield his awesome power at the behest of a space-faring empire that tricked him into servitude. Desiring a return to his...",
			"allytips": [
				"You can use Comet of Legend's flight to grow Starsurge to massive proportions.",
				"Save Voice of Light to use as a defense against melee opponents if you need to - otherwise, use its slow to start a fight at long range.",
				"Comet of Legend allows you to move quickly around the map; use it to put pressure on other lanes."
			],
			"enemytips": [
				"Try to get inside his orbit, since his stars can't hurt you up close.",
				"His stars disappear while stunned or silenced, giving you an easy opportunity to fight him.",
				"He gains speed while chasing in a straight line, but taking damage makes him lose that momentum.",
				"His Starsurge ability can grow to cover a huge area - don't stay in the same place too long!"
			],
			"tags": [
				"Mage",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 3,
				"magic": 8,
				"difficulty": 7
			},
			"stats": {
				"hp": 562,
				"hpperlevel": 92,
				"mp": 350,
				"mpperlevel": 50,
				"movespeed": 325,
				"armor": 19,
				"armorperlevel": 3.6,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 57,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "AurelionSolQ",
					"name": "Starsurge",
					"description": "Aurelion Sol creates an expanding disk, which explodes to stun and damage enemies when it moves too far away from him.",
					"tooltip": "<span class=\"colorFF9900\">First Press: </span>Aurelion Sol creates a new stellar core, which grows over time and grants him {{ e2 }}% Movement Speed.<br /><br />The core will detonate when it reaches his <span class=\"color308BDB\">Outer Limit</span>, applying {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and a {{ e4 }} second stun.<br /><br /><span class=\"colorFF9900\">Second Press: </span>Detonate the core early.<br />",
					"leveltip": {
						"label": [
							"Damage",
							"Stun Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							1.1,
							1.2,
							1.3,
							1.4,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"10",
						"20",
						"1.1/1.2/1.3/1.4/1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "AurelionSolQ.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AurelionSolW",
					"name": "Celestial Expansion",
					"description": "Aurelion Sol pushes his stars farther out, magnifying their damage.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Increases Star base damage by {{ e2 }}.<br /><br /><span class=\"colorFF9900\">Toggle: </span>Aurelion Sol's Stars orbit at his <span class=\"color308BDB\">Outer Limit</span> and deal {{ e1 }}% damage, for a total of {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage.<br />",
					"leveltip": {
						"label": [
							"Passive Damage Bonus",
							"Mana Cost Per Second",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.5,
						5,
						4.5,
						4
					],
					"cooldownBurn": "6/5.5/5/4.5/4",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							5,
							10,
							15,
							20,
							25
						],
						[
							22,
							24,
							26,
							28,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150",
						"5/10/15/20/25",
						"22/24/26/28/30",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana plus {{ e3 }} Mana Per Second",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "AurelionSolW.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana plus {{ e3 }} Mana Per Second"
				},
				{
					"id": "AurelionSolE",
					"name": "Comet of Legend",
					"description": "Aurelion Sol gains speed while moving in one continuous direction, and can take off flying for a long distance.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Continuously moving in one direction grants increasing Movement Speed up to {{ e2 }}%.<br /><br /><span class=\"colorFF9900\">Active: </span>Fly for {{ e3 }} units in the chosen direction. Only castable outside of combat. Aurelion Sol can see and be seen over walls while flying.<br /><br />Taking champion or turret damage will force a landing and reset the passive movement speed.<br />",
					"leveltip": {
						"label": [
							"Movement Speed Cap ",
							"Flight Range",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						60,
						55,
						50,
						45,
						40
					],
					"cooldownBurn": "60/55/50/45/40",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							5,
							6,
							7,
							8,
							9
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							3000,
							4000,
							5000,
							6000,
							7000
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5/6/7/8/9",
						"25/30/35/40/45",
						"3000/4000/5000/6000/7000",
						"600",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3000,
						4000,
						5000,
						6000,
						7000
					],
					"rangeBurn": "3000/4000/5000/6000/7000",
					"image": {
						"full": "AurelionSolE.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AurelionSolR",
					"name": "Voice of Light",
					"description": "Aurelion Sol projects a blast of pure starfire, damaging and slowing all enemies caught in it and knocking nearby enemies back to a safer distance.",
					"tooltip": "Breathes out a blast of pure starfire, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing by {{ e2 }}% for {{ e3 }} seconds. <br /><br />The blast will also knock nearby enemies back to Aurelion Sol's <span class=\"color308BDB\">Outer Limit</span>.<br />",
					"leveltip": {
						"label": [
							"Damage",
							"Slow ",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						90,
						70
					],
					"cooldownBurn": "110/90/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							40,
							50,
							60
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							650,
							650,
							650
						],
						[
							50,
							50,
							50
						],
						[
							1300,
							1300,
							1300
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"40/50/60",
						"2",
						"0",
						"650",
						"50",
						"1300",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1500,
						1500,
						1500
					],
					"rangeBurn": "1500",
					"image": {
						"full": "AurelionSolR.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Center of the Universe",
				"description": "Stars orbit Aurelion Sol, dealing magic damage when they hit an enemy.",
				"image": {
					"full": "AurelionSol_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "AurelionSol",
					"title": "AurelionSolARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolBEGINNER",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "AurelionSol",
					"title": "AurelionSolTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Azir": {
			"id": "Azir",
			"key": "268",
			"name": "Azir",
			"title": "the Emperor of the Sands",
			"image": {
				"full": "Azir.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 432,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "268000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "268001",
					"num": 1,
					"name": "Galactic Azir",
					"chromas": false
				},
				{
					"id": "268002",
					"num": 2,
					"name": "Gravelord Azir",
					"chromas": false
				},
				{
					"id": "268003",
					"num": 3,
					"name": "SKT T1 Azir",
					"chromas": false
				},
				{
					"id": "268004",
					"num": 4,
					"name": "Warring Kingdoms Azir",
					"chromas": false
				}
			],
			"lore": "Azir was a mortal emperor of Shurima in a far distant age, a proud man who stood at the cusp of immortality. His hubris saw him betrayed and murdered at the moment of his greatest triumph, but now, millennia later, he has been reborn as an Ascended being of immense power. With his buried city risen from the sand, Azir seeks to restore Shurima to its former glory.",
			"blurb": "Azir was a mortal emperor of Shurima in a far distant age, a proud man who stood at the cusp of immortality. His hubris saw him betrayed and murdered at the moment of his greatest triumph, but now, millennia later, he has been reborn as an Ascended...",
			"allytips": [
				"Be careful about putting down both of the soldiers stored by Arise! Unless you're going all-in, always have a soldier in your back pocket if you need to escape over a wall or if you misposition your other soldier and need damage now.",
				"In the lane, try to position your soldiers between the enemy's minions and the enemy champion. This way you can use them both to last hit and to project threat onto your lane opponent.",
				"Think of Emperor's Divide as a defensive ability first and foremost. Use it when the enemy engages on you or your allies. Remember that your team can walk through the soldiers summoned by Emperor's Divide and use this to your advantage when enemy melee champions engage on you.",
				"Be a bird!"
			],
			"enemytips": [
				"Azir relies on his soldiers to deal damage and can only move them so often. Try to capitalize on windows of time when his soldiers are stationary.",
				"Azir has immense damage over a prolonged amount of time but lacks the upfront burst of other mages. Try to burst him out before he can turn a confrontation around.",
				"Try to think of Sand Soldiers as fire. Don't stand in the fire."
			],
			"tags": [
				"Mage",
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 3,
				"magic": 8,
				"difficulty": 9
			},
			"stats": {
				"hp": 552,
				"hpperlevel": 92,
				"mp": 350.56,
				"mpperlevel": 42,
				"movespeed": 335,
				"armor": 19.04,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 52,
				"attackdamageperlevel": 2.8,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 1.5
			},
			"spells": [
				{
					"id": "AzirQWrapper",
					"name": "Conquering Sands",
					"description": "Azir sends all Sand Soldiers towards a location. Sand Soldiers deal magic damage to enemies they pass through and apply a slow for 1 second.",
					"tooltip": "Azir sends all <span class=\"colorEED6AF\">Sand Soldiers</span> towards a location. <span class=\"colorEED6AF\">Sand Soldiers</span> deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies they pass through and apply a {{ e2 }}% slow for 1 second.<br /><br />Enemies hit by multiple <span class=\"colorEED6AF\">Sand Soldiers</span> will not take additional damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f1 }} -> {{ f2 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							70,
							95,
							120,
							145,
							170
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							15,
							12.5,
							10,
							7.5,
							5
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							1600,
							1600,
							1600,
							1600,
							1600
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							370,
							370,
							370,
							370,
							370
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/95/120/145/170",
						"25",
						"15/12.5/10/7.5/5",
						"70",
						"1600",
						"200",
						"370",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						740,
						740,
						740,
						740,
						740
					],
					"rangeBurn": "740",
					"image": {
						"full": "AzirQWrapper.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AzirW",
					"name": "Arise!",
					"description": "Azir summons a Sand Soldier to attack nearby targets for him, replacing his basic attack against targets within the soldier's range. Their attacks deal magic damage to enemies in a line. Arise! also passively grants attack speed to Azir and his Sand Soldiers.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Azir gains {{ e3 }}% attack speed. When Azir has {{ e6 }} or more <span class=\"colorEED6AF\">Sand Soldiers</span>, he gains {{ e7 }}% additional attack speed for {{ e8 }} seconds.<br /><br /><span class=\"colorFF9900\">Active:</span> Azir summons a <span class=\"colorEED6AF\">Sand Soldier</span> for {{ e1 }} seconds. When Azir attacks an enemy in a soldier's range, the soldier attacks in his stead, stabbing the target for <scaleLevel>{{ f2 }}</scaleLevel> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Other enemies caught in the soldier's attack take <scaleLevel>{{ f7 }}%</scaleLevel> of the stab's damage.<br /><br />Azir stores up to {{ maxammo }} <span class=\"colorEED6AF\">Sand Soldiers</span> and prepares a new one every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds.<br /><br /><span class=\"color919191\"><i>Sand Soldiers that strike the same targets deal {{ e9 }}% damage after the first.<br />Sand Soldiers can attack targets outside of Azir's basic attack range.<br />Sand Soldiers expire twice as fast when near an enemy turret.</i></span>",
					"leveltip": {
						"label": [
							"Recharge",
							"Passive Attack Speed",
							"Attack Speed with Soldiers"
						],
						"effect": [
							"{{ f1 }} -> {{ f3 }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e7 }}% -> {{ e7NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							8,
							7.5,
							7,
							6.5,
							6
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						]
					],
					"effectBurn": [
						null,
						"10",
						"8/7.5/7/6.5/6",
						"20/30/40/50/60",
						"0",
						"1.5",
						"3",
						"20/30/40/50/60",
						"5",
						"25",
						"0.5"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "AzirW.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AzirEWrapper",
					"name": "Shifting Sands",
					"description": "Azir shields himself briefly and dashes to one of his Sand Soldiers, damaging enemies. If he hits an enemy champion, he instantly readies a new Sand Soldier for deployment and halts his dash.",
					"tooltip": "Azir shields himself for {{ e6 }} seconds, blocking up to {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage and dashes to one of his <span class=\"colorEED6AF\">Sand Soldiers</span>, damaging enemies hit for {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />If Azir hits an enemy champion, he halts his dash and instantly prepares a new <span class=\"colorEED6AF\">Sand Soldier</span>.",
					"leveltip": {
						"label": [
							"Shield Amount",
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ f2 }} -> {{ f3 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							1700,
							1700,
							1700,
							1700,
							1700
						],
						[
							19,
							18,
							17,
							16,
							15
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							0.3,
							0.5,
							0.7,
							0.9,
							1.1
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1100,
							1100,
							1100,
							1100,
							1100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							25,
							25,
							25,
							25,
							25
						]
					],
					"effectBurn": [
						null,
						"1700",
						"19/18/17/16/15",
						"60/90/120/150/180",
						"80/120/160/200/240",
						"0.3/0.5/0.7/0.9/1.1",
						"1.5",
						"1100",
						"0",
						"5",
						"25"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "AzirEWrapper.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AzirR",
					"name": "Emperor's Divide",
					"description": "Azir summons a wall of soldiers which charge forward, knocking back and damaging enemies.",
					"tooltip": "Azir summons a wall of armored soldiers that charge forward, knocking back enemies and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The soldiers then remain as a wall for {{ e4 }} seconds.<br /><br />Azir and his allies can pass freely through Emperor's Divide.<br /><br /><span class=\"color919191\"><i>Emperor's Divide does not interact with Azir's basic attacks or spells.</i></span>",
					"leveltip": {
						"label": [
							"Damage",
							"Number of Soldiers",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							450
						],
						[
							0,
							0,
							0
						],
						[
							5,
							6,
							7
						],
						[
							3,
							3,
							3
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/450",
						"0",
						"5/6/7",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						250,
						250,
						250
					],
					"rangeBurn": "250",
					"image": {
						"full": "AzirR.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Shurima's Legacy",
				"description": "Azir can summon the Disc of the Sun from the ruins of allied or enemy turrets.",
				"image": {
					"full": "Azir_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Azir",
					"title": "AhriFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1004",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2044",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "AzirTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Azir",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Bard": {
			"id": "Bard",
			"key": "432",
			"name": "Bard",
			"title": "the Wandering Caretaker",
			"image": {
				"full": "Bard.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 0,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "432000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "432001",
					"num": 1,
					"name": "Elderwood Bard",
					"chromas": false
				},
				{
					"id": "432005",
					"num": 5,
					"name": "Snow Day Bard",
					"chromas": false
				},
				{
					"id": "432006",
					"num": 6,
					"name": "Bard Bard",
					"chromas": false
				}
			],
			"lore": "A traveler from beyond the stars, Bard is an agent of serendipity who fights to maintain a balance where life can endure the indifference of chaos. Many Runeterrans sing songs that ponder his extraordinary nature, yet they all agree that the cosmic vagabond is drawn to artifacts of great magical power. Surrounded by a jubilant choir of helpful spirit meeps, it is impossible to mistake his actions as malevolent, as Bard always serves the greater good... in his own odd way.",
			"blurb": "A traveler from beyond the stars, Bard is an agent of serendipity who fights to maintain a balance where life can endure the indifference of chaos. Many Runeterrans sing songs that ponder his extraordinary nature, yet they all agree that the cosmic...",
			"allytips": [
				"It's important to collect chimes to improve your meep's attacks, but don't neglect your lane partner! Try to make a big entrance by bringing an ally into the lane with you with Magical Journey.",
				"Let your Caretaker's Shrines charge up - they heal for a lot more when at full power.",
				"Don't forget that enemies can also use your Magical Journey doorways, and that your ultimate can also hit your allies!"
			],
			"enemytips": [
				"Bard's opponents can also travel through his Magical Journey doorways. You can follow him, if you think it's safe.",
				"You can crush Bard's healing shrines just by walking over them. Don't let his allies take them without a fight.",
				"Bard's ultimate, Tempered Fate, affects allies, enemies, monsters, and turrets alike. Sometimes it can be to your advantage to jump into it!"
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 4,
				"magic": 5,
				"difficulty": 9
			},
			"stats": {
				"hp": 535,
				"hpperlevel": 89,
				"mp": 350,
				"mpperlevel": 50,
				"movespeed": 330,
				"armor": 34,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 7.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 52,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "BardQ",
					"name": "Cosmic Binding",
					"description": "Bard fires a missile which will slow the first enemy struck, and continue onward. If it strikes a wall, it will stun the initial target; if it strikes another enemy, it will stun them both.",
					"tooltip": "Bard fires an energy bolt, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to one or two enemies. The first target hit will be slowed by {{ e3 }}% for {{ e4 }} second(s).<br /><br />If the bolt hits another enemy or a wall, any enemies hit are stunned for {{ e2 }} second(s).<br />",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Duration",
							"Stun Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10,
						9,
						8,
						7
					],
					"cooldownBurn": "11/10/9/8/7",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							1,
							1.2,
							1.4,
							1.6,
							1.8
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							1,
							1.2,
							1.4,
							1.6,
							1.8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"1/1.2/1.4/1.6/1.8",
						"60",
						"1/1.2/1.4/1.6/1.8",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "BardQ.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BardW",
					"name": "Caretaker's Shrine",
					"description": "Reveals a healing shrine which powers up over a short time, disappearing after healing the first ally that touches it.",
					"tooltip": "Bard raises a health shrine that immediately offers {{ e5 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health, but restores up to {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> health as it gathers power for 10 seconds. The shrine's effect also grants {{ e1 }}% decaying movement speed for {{ e2 }} seconds. <br /><br />Bard can have up to {{ e3 }} shrines active at once, which remain until visited by an ally champion or crushed by an enemy champion.<br /><br /><span class=\"colorFFCC00\">Active Shrines: </span><span class=\"colorFFFFFF\">{{ f1 }}</span> / <span class=\"colorFFCC00\">{{ f2 }}</span></mainText><br />",
					"leveltip": {
						"label": [
							"Base Heal",
							"Max Heal"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e6 }} -> {{ e6NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						90,
						90,
						90,
						90,
						90
					],
					"costBurn": "90",
					"effect": [
						null,
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							30,
							60,
							90,
							120,
							150
						],
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50",
						"1.5",
						"3",
						"0",
						"30/60/90/120/150",
						"70/110/150/190/230",
						"0",
						"10",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "BardW.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BardE",
					"name": "Magical Journey",
					"description": "Bard opens a portal in nearby terrain. Allies and enemies alike can take a one-way trip through that terrain by moving into the portal.",
					"tooltip": "Bard opens a one-way corridor through nearby terrain. Both allies and enemies can use the corridor by right-clicking on any part of it while near its entrance, with allies travelling {{ e2 }}% faster than enemies.<br /><br />The corridor disappears after {{ e1 }} seconds.<br />",
					"leveltip": {
						"label": [
							"Cooldown",
							"Ally Travel Speed Bonus"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10",
						"10/20/30/40/50",
						"800",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "BardE.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BardR",
					"name": "Tempered Fate",
					"description": "Bard sends spirit energy arcing to a location, putting all champions, minions, monsters, and turrets hit into stasis for a brief time.",
					"tooltip": "Bard sends magical energy arcing to a target location. On impact, all champions, minions, monsters, and turrets in the target area are put in stasis, becoming invincible, untargetable, and unable to act for {{ e1 }} seconds.<br /><br />Epic monsters are also put into stasis, despite normally being immune to disables.",
					"leveltip": {
						"label": [
							"Cooldown"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						115,
						90
					],
					"cooldownBurn": "130/115/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3400,
						3400,
						3400
					],
					"rangeBurn": "3400",
					"image": {
						"full": "BardR.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Traveler's Call",
				"description": "Bard's presence causes magical chimes to appear, which grant Bard experience, mana, and a burst of speed. Additionally, lesser spirits follow Bard and aid in his attacks - collecting chimes causes these meeps to gain power over the course of the game.",
				"image": {
					"full": "Bard_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Bard",
					"title": "BardARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Bard",
					"title": "BardCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "support",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Bard",
					"title": "BardFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "support",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Bard",
					"title": "BardKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Bard",
					"title": "BardSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "support",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Bard",
					"title": "BardSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "support",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Bard",
					"title": "BardTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Blitzcrank": {
			"id": "Blitzcrank",
			"key": "53",
			"name": "Blitzcrank",
			"title": "the Great Steam Golem",
			"image": {
				"full": "Blitzcrank.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 48,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "53000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "53001",
					"num": 1,
					"name": "Rusty Blitzcrank",
					"chromas": false
				},
				{
					"id": "53002",
					"num": 2,
					"name": "Goalkeeper Blitzcrank",
					"chromas": false
				},
				{
					"id": "53003",
					"num": 3,
					"name": "Boom Boom Blitzcrank",
					"chromas": false
				},
				{
					"id": "53004",
					"num": 4,
					"name": "Piltover Customs Blitzcrank",
					"chromas": false
				},
				{
					"id": "53005",
					"num": 5,
					"name": "Definitely Not Blitzcrank",
					"chromas": false
				},
				{
					"id": "53006",
					"num": 6,
					"name": "iBlitzcrank",
					"chromas": false
				},
				{
					"id": "53007",
					"num": 7,
					"name": "Riot Blitzcrank",
					"chromas": false
				},
				{
					"id": "53011",
					"num": 11,
					"name": "Battle Boss Blitzcrank",
					"chromas": true
				},
				{
					"id": "53020",
					"num": 20,
					"name": "Lancer Rogue Blitzcrank",
					"chromas": false
				},
				{
					"id": "53021",
					"num": 21,
					"name": "Lancer Paragon Blitzcrank",
					"chromas": false
				}
			],
			"lore": "Blitzcrank is an enormous, near-indestructible automaton from Zaun, originally built to dispose of hazardous waste. However, he found this primary purpose too restricting, and modified his own form to better serve the fragile people of the Sump. Blitzcrank selflessly uses his strength and durability to protect others, extending a helpful metal fist or burst of energy to subdue any troublemakers.",
			"blurb": "Blitzcrank is an enormous, near-indestructible automaton from Zaun, originally built to dispose of hazardous waste. However, he found this primary purpose too restricting, and modified his own form to better serve the fragile people of the Sump...",
			"allytips": [
				"The 1-2-3 combo of Rocket Grab, Power Fist, and Static Field can devastate an individual opponent.",
				"Using Blitzcrank's grab to pull an enemy into your tower range followed by a Power Fist will allow the tower to get several hits on them."
			],
			"enemytips": [
				"Blitzcrank's passive Mana Barrier grants him a shield when he is low on health.",
				"Staying behind creeps can prevent you from being Rocket Grabbed. Blitzcrank's Rocket Grab only pulls the first enemy target it encounters."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 8,
				"magic": 5,
				"difficulty": 4
			},
			"stats": {
				"hp": 582.6,
				"hpperlevel": 95,
				"mp": 267.2,
				"mpperlevel": 40,
				"movespeed": 325,
				"armor": 44,
				"armorperlevel": 4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.75,
				"mpregen": 8.5,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61.54,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.13
			},
			"spells": [
				{
					"id": "RocketGrab",
					"name": "Rocket Grab",
					"description": "Blitzcrank fires his right hand to grab an opponent on its path, dealing damage and dragging it back to him.",
					"tooltip": "Blitzcrank fires his right hand. If it encounters an enemy unit it will stun them and deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage while he pulls them to himself.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						19,
						18,
						17,
						16
					],
					"cooldownBurn": "20/19/18/17/16",
					"cost": [
						100,
						100,
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							80,
							135,
							190,
							245,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/135/190/245/300",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "RocketGrab.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Overdrive",
					"name": "Overdrive",
					"description": "Blitzcrank super charges himself to get dramatically increased Movement and Attack Speed. He is temporarily slowed after the effect ends.",
					"tooltip": "Blitzcrank supercharges himself, gaining {{ e1 }}% Movement Speed and {{ e2 }}% Attack Speed for {{ e4 }} seconds. The Movement Speed bonus decays over the duration.<br /><br />When Overdrive ends, Blitzcrank's Movement Speed is slowed by {{ e3 }}% for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Movement Speed",
							"Attack Speed"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						75,
						75,
						75,
						75,
						75
					],
					"costBurn": "75",
					"effect": [
						null,
						[
							70,
							75,
							80,
							85,
							90
						],
						[
							30,
							38,
							46,
							54,
							62
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/75/80/85/90",
						"30/38/46/54/62",
						"30",
						"5",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "Overdrive.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PowerFist",
					"name": "Power Fist",
					"description": "Blitzcrank charges up his fist to make his next attack deal double damage and pop his target up in the air.",
					"tooltip": "Blitzcrank charges up his fist to make his next attack deal double his total attack damage as physical damage and pop his target up in the air.",
					"leveltip": {
						"label": [
							"Cooldown"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						25,
						25,
						25,
						25,
						25
					],
					"costBurn": "25",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "PowerFist.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "StaticField",
					"name": "Static Field",
					"description": "Passively causes lightning bolts to damage a nearby enemy. Additionally, Blitzcrank can activate this ability to damage nearby enemies and silence them for 0.5 seconds, but doing so removes the passive lightning until Static Field becomes available again.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Lightning arcs off of Blitzcrank to hit a random nearby enemy for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage every 2.5 seconds.<br /><br /><span class=\"colorFF9900\">Active: </span>Deals {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and silences surrounding enemy units for 0.5 seconds. The passive is not in effect during the cooldown.",
					"leveltip": {
						"label": [
							"Lightning Damage",
							"Activation Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						60,
						40,
						20
					],
					"cooldownBurn": "60/40/20",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							200,
							300
						],
						[
							250,
							375,
							500
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/200/300",
						"250/375/500",
						"2.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "StaticField.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Mana Barrier",
				"description": "When Blitzcrank's life is brought below 20% health, he activates Mana Barrier. This creates a mana shield equal to 50% of his mana for 10 seconds. Mana Barrier can only occur once every 90 seconds.",
				"image": {
					"full": "Blitzcrank_ManaBarrier.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Blitzcrank",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "1)buystarteritems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Blitzcrank",
					"title": "BlitzcrankTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Brand": {
			"id": "Brand",
			"key": "63",
			"name": "Brand",
			"title": "the Burning Vengeance",
			"image": {
				"full": "Brand.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 96,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "63000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "63001",
					"num": 1,
					"name": "Apocalyptic Brand",
					"chromas": false
				},
				{
					"id": "63002",
					"num": 2,
					"name": "Vandal Brand",
					"chromas": false
				},
				{
					"id": "63003",
					"num": 3,
					"name": "Cryocore Brand",
					"chromas": false
				},
				{
					"id": "63004",
					"num": 4,
					"name": "Zombie Brand",
					"chromas": false
				},
				{
					"id": "63005",
					"num": 5,
					"name": "Spirit Fire Brand",
					"chromas": false
				},
				{
					"id": "63006",
					"num": 6,
					"name": "Battle Boss Brand",
					"chromas": false
				}
			],
			"lore": "Once a tribesman of the icy Freljord named Kegan Rodhe, the creature known as Brand is a lesson in the temptation of greater power. Seeking one of the legendary World Runes, Kegan betrayed his companions and seized it for himself—and, in an instant, the man was no more. His soul burned away, his body a vessel of living flame, Brand now roams Valoran in search of other Runes, swearing revenge for wrongs he could never possibly have suffered in a dozen mortal lifetimes.",
			"blurb": "Once a tribesman of the icy Freljord named Kegan Rodhe, the creature known as Brand is a lesson in the temptation of greater power. Seeking one of the legendary World Runes, Kegan betrayed his companions and seized it for himself—and, in an instant, the...",
			"allytips": [
				"You can deter enemies from standing near their minions by setting them ablaze, due to Conflagration.",
				"You can use Brand's abilities in a variety of combinations to maximize his damage in different situations.",
				"Pyroclasm bounces randomly between enemies, so try to cast it on a small group of enemies if you want to hit the same target multiple times."
			],
			"enemytips": [
				"Brand must land an ability before his combo is able to get started. Dodging his Sear or Pillar of Flame will disrupt his rhythm.",
				"Try to move away from allies when you see Pyroclasm being cast. The initial missile speed is slow, which should give your team time to react.",
				"Brand's passive allows him to excel against teams that cluster together. Be sure to split up against him."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 2,
				"magic": 9,
				"difficulty": 4
			},
			"stats": {
				"hp": 519.68,
				"hpperlevel": 88,
				"mp": 375.6,
				"mpperlevel": 42,
				"movespeed": 340,
				"armor": 21.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 8.008,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 57.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "BrandQ",
					"name": "Sear",
					"description": "Brand launches a ball of fire forward that deals magic damage. If the target is ablaze, Sear will stun the target for 1.5 seconds.",
					"tooltip": "Brand launches a ball of fire forward that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> If the target is ablaze, Sear will stun the target for 1.5 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7.5,
						7,
						6.5,
						6
					],
					"cooldownBurn": "8/7.5/7/6.5/6",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/110/140/170/200",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.55,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1050,
						1050,
						1050,
						1050,
						1050
					],
					"rangeBurn": "1050",
					"image": {
						"full": "BrandQ.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BrandW",
					"name": "Pillar of Flame",
					"description": "After a short delay, Brand creates a Pillar of Flame at a target area, dealing magic damage to enemy units within the area. Units that are ablaze take an additional 25% damage.",
					"tooltip": "After a short delay, Brand creates a Pillar of Flame at a location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> Units that are ablaze take an additional 25% damage from Pillar of Flame.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9.5,
						9,
						8.5,
						8
					],
					"cooldownBurn": "10/9.5/9/8.5/8",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							75,
							120,
							165,
							210,
							255
						],
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/120/165/210/255",
						"20/40/60/80/100",
						"0.25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "BrandW.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BrandE",
					"name": "Conflagration",
					"description": "Brand conjures a powerful blast at his target, dealing magic damage to them. If the target is ablaze, Conflagration spreads to nearby enemies.",
					"tooltip": "Brand conjures a powerful blast at his target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> If the target is ablaze, Conflagration spreads to nearby enemies. ",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							70,
							90,
							110,
							130,
							150
						],
						[
							375,
							375,
							375,
							375,
							375
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/90/110/130/150",
						"375",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "BrandE.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BrandR",
					"name": "Pyroclasm",
					"description": "Brand unleashes a devastating torrent of fire, dealing magic damage each time it bounces, up to 5 bounces. Bounces prioritize stacking Blaze to max on Champions. If a target is ablaze, Pyroclasm will briefly slow them.",
					"tooltip": "Brand unleashes a devastating torrent of fire, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage each time it bounces up to 5 bounces. Bounces prioritize stacking Blaze to max on Champions.<br /><br /><span class=\"colorDDDD77\">Blaze:</span> If the target is ablaze, Pyroclasm will briefly slow the target by {{ e4 }}%.",
					"leveltip": {
						"label": [
							"Damage per Bounce",
							"Slow Amount",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						105,
						90,
						75
					],
					"cooldownBurn": "105/90/75",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							200,
							300
						],
						[
							5,
							7,
							9
						],
						[
							150,
							225,
							300
						],
						[
							30,
							45,
							60
						],
						[
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/200/300",
						"5/7/9",
						"150/225/300",
						"30/45/60",
						"0.25",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "BrandR.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Blaze",
				"description": "Brand's spells light his targets ablaze, dealing 4% of their maximum Health in magic damage over 4 seconds, stacking up to 3 times. If Brand kills an enemy while it is ablaze he regains mana. When Blaze reaches max stacks on a Champion or large monster, it becomes unstable. It detonates in 2 seconds, applying spell effects and dealing massive damage in an area around the victim.",
				"image": {
					"full": "BrandP.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Brand",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot-mid",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandSRSupport",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot-support",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Brand",
					"title": "BrandTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Braum": {
			"id": "Braum",
			"key": "201",
			"name": "Braum",
			"title": "the Heart of the Freljord",
			"image": {
				"full": "Braum.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 144,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "201000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "201001",
					"num": 1,
					"name": "Dragonslayer Braum",
					"chromas": true
				},
				{
					"id": "201002",
					"num": 2,
					"name": "El Tigre Braum",
					"chromas": false
				},
				{
					"id": "201003",
					"num": 3,
					"name": "Braum Lionheart",
					"chromas": false
				},
				{
					"id": "201010",
					"num": 10,
					"name": "Santa Braum",
					"chromas": false
				}
			],
			"lore": "Blessed with massive biceps and an even bigger heart, Braum is a beloved hero of the Freljord. Every mead hall north of Frostheld toasts his legendary strength, said to have felled a forest of oaks in a single night, and punched an entire mountain into rubble. Bearing an enchanted vault door as his shield, Braum roams the frozen north sporting a mustachioed smile as big as his muscles—a true friend to all those in need.",
			"blurb": "Blessed with massive biceps and an even bigger heart, Braum is a beloved hero of the Freljord. Every mead hall north of Frostheld toasts his legendary strength, said to have felled a forest of oaks in a single night, and punched an entire mountain into...",
			"allytips": [
				"Work with your allies to stack Concussive Blows, encourage them to basic attack marked targets.",
				"Leap in front of squishy friends and shield them from projectiles with Unbreakable.",
				"Glacial Fissure leaves a powerful slow zone, position it well to split teamfights and slow the enemy approach."
			],
			"enemytips": [
				"Braum must land Winter's Bite or a basic attack to start Concussive Blows. If you get marked, exit combat range before getting hit 3 more times to avoid the stun.",
				"Braum's ultimate has a long cast time, use that extra time to dodge. Walking over the frozen ground left behind will slow you, position so that you don't need to cross it.",
				"Unbreakable gives Braum extremely strong directional defense, either wait until it is down or outposition the ability."
			],
			"tags": [
				"Support",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 9,
				"magic": 4,
				"difficulty": 3
			},
			"stats": {
				"hp": 576.16,
				"hpperlevel": 87,
				"mp": 310.6,
				"mpperlevel": 45,
				"movespeed": 335,
				"armor": 47,
				"armorperlevel": 4.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 1,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55.376,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.03,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "BraumQ",
					"name": "Winter's Bite",
					"description": "Braum propels freezing ice from his shield, slowing and dealing magic damage.<br><br>Applies a stack of <font color='#FFF673'>Concussive Blows</font>.",
					"tooltip": "Braum propels freezing ice from his shield dealing {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [2.5% of Braum's Max Health]</span> magic damage to the first enemy hit and slowing them by {{ e2 }}%, decaying over the next {{ e5 }} seconds.<br /><br />Applies a stack of <span class=\"colorFFF673\">Concussive Blows</span>. ",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						55,
						60,
						65,
						70,
						75
					],
					"costBurn": "55/60/65/70/75",
					"effect": [
						null,
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0.02,
							0.02,
							0.02,
							0.02,
							0.02
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1050,
							1050,
							1050,
							1050,
							1050
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/105/150/195/240",
						"70",
						"30",
						"0.02",
						"2",
						"1050",
						"4",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "BraumQ.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BraumW",
					"name": "Stand Behind Me",
					"description": "Braum leaps to a target allied champion or minion. On arrival, Braum and the ally gain Armor and Magic Resist for a few seconds.",
					"tooltip": "Braum leaps to target allied champion or minion.<br /><br />On arrival, Braum and the ally gain <span class=\"colorFFFF00\">{{ f3 }}</span> Armor and <span class=\"colorFF00FF\">{{ f4 }}</span> Magic Resist ({{ e4 }} plus {{ e3 }}% of Braum's bonus Armor/Magic Resist) for {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Base Armor",
							"Base Magic Resist",
							"Defensive Scaling",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							750,
							750,
							750,
							750,
							750
						],
						[
							10,
							11.5,
							13,
							14.5,
							16
						],
						[
							17.5,
							20,
							22.5,
							25,
							27.5
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"3",
						"750",
						"10/11.5/13/14.5/16",
						"17.5/20/22.5/25/27.5",
						"15/17.5/20/22.5/25",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "@special.BraumWArmor",
							"coeff": 0,
							"key": "f3"
						},
						{
							"link": "@special.BraumWMR",
							"coeff": 0,
							"key": "f4"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "BraumW.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BraumE",
					"name": "Unbreakable",
					"description": "Braum raises his shield in a direction for several seconds, intercepting all projectiles causing them to hit him and be destroyed. He negates the damage of the first attack completely and reduces the damage of all subsequent attacks from this direction.",
					"tooltip": "<span class=\"colorFFFFFF\">Braum reduces incoming damage and blocks for allies behind him.</span><br />Braum raises his shield in a direction for {{ e2 }} seconds negating the damage of the next attack from that direction. Subsequent attacks deal {{ e3 }}% reduced damage.<br /><br />Braum <span class=\"colorFFF673\">intercepts</span> projectiles, causing them to hit him and be destroyed.<br /><br />Braum gains {{ e4 }}% Movement Speed for the duration.",
					"leveltip": {
						"label": [
							"Duration",
							"Damage Reduction",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						30,
						35,
						40,
						45,
						50
					],
					"costBurn": "30/35/40/45/50",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							3,
							3.25,
							3.5,
							3.75,
							4
						],
						[
							30,
							32.5,
							35,
							37.5,
							40
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"3/3.25/3.5/3.75/4",
						"30/32.5/35/37.5/40",
						"10",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "BraumE.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BraumRWrapper",
					"name": "Glacial Fissure",
					"description": "Braum slams the ground, knocking up enemies nearby and in a line in front of him. A fissure is left along the line that slows enemies.",
					"tooltip": "Braum slams the ground, knocking up enemies nearby and in a line in front of him. A fissure is left along the line for {{ e3 }} seconds, slowing enemies above it by {{ e4 }}%.<br /><br />Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The first champion hit is knocked up for {{ e5 }} seconds, subsequent enemies are knocked up briefly.",
					"leveltip": {
						"label": [
							"Damage",
							"Knockup Duration",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						120,
						100
					],
					"cooldownBurn": "140/120/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							0.3,
							0.3,
							0.3
						],
						[
							4,
							4,
							4
						],
						[
							40,
							50,
							60
						],
						[
							1,
							1.25,
							1.5
						],
						[
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"0.3",
						"4",
						"40/50/60",
						"1/1.25/1.5",
						"0.25",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1250,
						1250,
						1250
					],
					"rangeBurn": "1250",
					"image": {
						"full": "BraumRWrapper.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Concussive Blows",
				"description": "Braum adds stacks of Concussive Blows to enemies with basic attacks or Winter's Bite. He and his allies continue to add stacks with basic attacks, at 4 stacks their target will be stunned.",
				"image": {
					"full": "Braum_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Braum",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Braum",
					"title": "BraumTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Caitlyn": {
			"id": "Caitlyn",
			"key": "51",
			"name": "Caitlyn",
			"title": "the Sheriff of Piltover",
			"image": {
				"full": "Caitlyn.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 192,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "51000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "51001",
					"num": 1,
					"name": "Resistance Caitlyn",
					"chromas": false
				},
				{
					"id": "51002",
					"num": 2,
					"name": "Sheriff Caitlyn",
					"chromas": false
				},
				{
					"id": "51003",
					"num": 3,
					"name": "Safari Caitlyn",
					"chromas": false
				},
				{
					"id": "51004",
					"num": 4,
					"name": "Arctic Warfare Caitlyn",
					"chromas": false
				},
				{
					"id": "51005",
					"num": 5,
					"name": "Officer Caitlyn",
					"chromas": false
				},
				{
					"id": "51006",
					"num": 6,
					"name": "Headhunter Caitlyn",
					"chromas": false
				},
				{
					"id": "51010",
					"num": 10,
					"name": "Lunar Wraith Caitlyn",
					"chromas": true
				},
				{
					"id": "51011",
					"num": 11,
					"name": "Pulsefire Caitlyn",
					"chromas": false
				}
			],
			"lore": "Renowned as its finest peacekeeper, Caitlyn is also Piltover's best shot at ridding the city of its elusive criminal elements. She is often paired with Vi, acting as a cool counterpoint to her partner's more impetuous nature. Even though she carries a one-of-a-kind hextech rifle, Caitlyn's most powerful weapon is her superior intellect, allowing her to lay elaborate traps for any lawbreakers foolish enough to operate in the City of Progress.",
			"blurb": "Renowned as its finest peacekeeper, Caitlyn is also Piltover's best shot at ridding the city of its elusive criminal elements. She is often paired with Vi, acting as a cool counterpoint to her partner's more impetuous nature. Even though she carries a...",
			"allytips": [
				"Make use of her Yordle Snap Traps by placing them pre-emptively to ensure that you'll have one off of cooldown during combat.",
				"Avoid using Ace in the Hole in large team melees as it might be blocked by the wrong target.",
				"Fire 90 Caliber Net away from the opponent to close the gap or hop over walls."
			],
			"enemytips": [
				"Keep behind allied minions if Caitlyn is harassing you with Piltover Peacemaker (it deals less damage with each subsequent target).",
				"You can intercept Ace in the Hole's missile from hitting an ally if you stand in its path."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 2,
				"magic": 2,
				"difficulty": 6
			},
			"stats": {
				"hp": 475,
				"hpperlevel": 85,
				"mp": 313.7,
				"mpperlevel": 35,
				"movespeed": 325,
				"armor": 32,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 650,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 7.4,
				"mpregenperlevel": 0.55,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 62,
				"attackdamageperlevel": 2.18,
				"attackspeedoffset": 0.1,
				"attackspeedperlevel": 4
			},
			"spells": [
				{
					"id": "CaitlynPiltoverPeacemaker",
					"name": "Piltover Peacemaker",
					"description": "Caitlyn revs up her rifle for 1 second to unleash a penetrating shot that deals physical damage (deals less damage to subsequent targets).",
					"tooltip": "Revs the rifle for {{ e4 }} second to fire a narrow piercing shot dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage. After hitting any target, it opens into a wider shot that deals {{ e2 }}% less damage. <br /><br />Always deals full damage to trap revealed targets.",
					"leveltip": {
						"label": [
							"Damage",
							"Total Attack Damage Ratio",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							30,
							70,
							110,
							150,
							190
						],
						[
							33,
							33,
							33,
							33,
							33
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							130,
							140,
							150,
							160,
							170
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/70/110/150/190",
						"33",
						"50",
						"1",
						"130/140/150/160/170",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1250,
						1250,
						1250,
						1250,
						1250
					],
					"rangeBurn": "1250",
					"image": {
						"full": "CaitlynPiltoverPeacemaker.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CaitlynYordleTrap",
					"name": "Yordle Snap Trap",
					"description": "Caitlyn sets a trap to find sneaky yordles. When sprung, the trap reveals and immobilizes the enemy champion for 1.5 seconds.",
					"tooltip": "Sets traps that an enemy Champion can spring, immobilizing them for {{ e6 }} seconds and granting <span class=\"coloree91d7\">True Sight</span> for a short duration.<br /><br />Traps last for {{ e3 }} seconds. {{ e5 }} traps may be active at once.<br /><br />Trapped enemies take an additional {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> increased damage from Headshot.",
					"leveltip": {
						"label": [
							"Bonus Headshot Damage on Trapped Targets",
							"Bonus Attack Damage Ratio",
							"Recharge Rate",
							"Maximum Traps",
							"Trap Duration"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e7 }}% -> {{ e7NL }}%",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e3 }} -> {{ e3NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.5,
						0.5,
						0.5,
						0.5,
						0.5
					],
					"cooldownBurn": "0.5",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							40,
							90,
							140,
							190,
							240
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							3,
							3,
							4,
							4,
							5
						],
						[
							3,
							3,
							4,
							4,
							5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2",
						"40/90/140/190/240",
						"30/35/40/45/50",
						"3/3/4/4/5",
						"3/3/4/4/5",
						"1.5",
						"40/55/70/85/100",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "CaitlynYordleTrap.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CaitlynEntrapment",
					"name": "90 Caliber Net",
					"description": "Caitlyn fires a heavy net to slow her target. The recoil knocks Caitlyn back.",
					"tooltip": "Fires a net, knocking Caitlyn backwards. The net deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slows the first enemy hit by {{ e3 }}% for {{ e2 }} second.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14.5,
						13,
						11.5,
						10
					],
					"cooldownBurn": "16/14.5/13/11.5/10",
					"cost": [
						75,
						75,
						75,
						75,
						75
					],
					"costBurn": "75",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"1",
						"50",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "CaitlynEntrapment.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CaitlynAceintheHole",
					"name": "Ace in the Hole",
					"description": "Caitlyn takes time to line up the perfect shot, dealing massive damage to a single target at a huge range. Enemy champions can intercept the bullet for their ally.",
					"tooltip": "Takes a second to line up the perfect shot on an enemy Champion at up to {{ e2 }} range. The shot deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage, but other enemy Champions can intercept it.<br /><br />Grants <span class=\"coloree91d7\">True Sight</span> of the target during the channel.",
					"leveltip": {
						"label": [
							"Damage",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						90,
						75,
						60
					],
					"cooldownBurn": "90/75/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							250,
							475,
							700
						],
						[
							2000,
							2500,
							3000
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250/475/700",
						"2000/2500/3000",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 2,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						2000,
						2500,
						3000
					],
					"rangeBurn": "2000/2500/3000",
					"image": {
						"full": "CaitlynAceintheHole.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Headshot",
				"description": "Every few basic attacks, or against a target she has trapped or netted, Caitlyn will fire a headshot dealing bonus damage that scales with her critical strike chance. On trapped or netted targets, Caitlyn's Headshot attack range is doubled.",
				"image": {
					"full": "Caitlyn_Headshot.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Caitlyn",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Caitlyn",
					"title": "CaitlynTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Camille": {
			"id": "Camille",
			"key": "164",
			"name": "Camille",
			"title": "the Steel Shadow",
			"image": {
				"full": "Camille.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 240,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "164000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "164001",
					"num": 1,
					"name": "Program Camille",
					"chromas": false
				}
			],
			"lore": "Weaponized to operate outside the boundaries of the law, Camille is the Principal Intelligencer of Clan Ferros—an elegant and elite agent who ensures the Piltover machine and its Zaunite underbelly runs smoothly. Adaptable and precise, she views sloppy technique as an embarrassment that must be put to order. With a mind as sharp as the blades she bears, Camille's pursuit of superiority through hextech body augmentation has left many to wonder if she is now more machine than woman.",
			"blurb": "Weaponized to operate outside the boundaries of the law, Camille is the Principal Intelligencer of Clan Ferros—an elegant and elite agent who ensures the Piltover machine and its Zaunite underbelly runs smoothly. Adaptable and precise, she views sloppy...",
			"allytips": [
				"Try waiting until the other team is distracted with fighting your team, and use Hookshot to pick off vulnerable targets.",
				"Use the CC from your abilities to land both of your Precision Protocol attacks on enemies."
			],
			"enemytips": [
				"Camille's shield only works against one damage type, so hit her when she's vulnerable to your damage.",
				"The Hextech Ultimatum has a very short range to cast, so try to flash away from her before she gets close."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 6,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 575.6,
				"hpperlevel": 85,
				"mp": 338.8,
				"mpperlevel": 32,
				"movespeed": 340,
				"armor": 35,
				"armorperlevel": 3.8,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.8,
				"mpregen": 8.15,
				"mpregenperlevel": 0.75,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "CamilleQ",
					"name": "Precision Protocol",
					"description": "Camille's next attack deals bonus damage and grants bonus movement speed. This spell can be recast for a short period of time, doing significantly increased bonus damage if Camille delays a period of time between the two attacks.",
					"tooltip": "Camille's next basic attack deals <span class=\"colorFF8C00\">{{ f1 }}</span> bonus physical damage and increases her movement speed by {{ e4 }}% for {{ e5 }} second. This ability can be recast in the next {{ e0 }} seconds at no cost.<br /><br />If the second Precision Protocol attack hits at least {{ e1 }} seconds after the first, the bonus damage is increased by {{ e8 }}% to <span class=\"colorFF8C00\">{{ f2 }}</span> and <span class=\"colorFFFFFF\">{{ f3 }}%</span> of the attack is converted into true damage.<br /><br /><span class=\"size16 colorFFEB7F\">Precision Protocol</span> <span class=\"size16 color8C8C8C\">cannot critically strike.</span>",
					"leveltip": {
						"label": [
							"Total AD Ratio",
							"Cooldown",
							"Movement Speed"
						],
						"effect": [
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e4 }}% -> {{ e4NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8.25,
						7.5,
						6.75,
						6
					],
					"cooldownBurn": "9/8.25/7.5/6.75/6",
					"cost": [
						25,
						25,
						25,
						25,
						25
					],
					"costBurn": "25",
					"effect": [
						null,
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0.04,
							0.04,
							0.04,
							0.04,
							0.04
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						]
					],
					"effectBurn": [
						null,
						"1.5",
						"50",
						"20/25/30/35/40",
						"20/25/30/35/40",
						"1",
						"0.4",
						"0.04",
						"100",
						"2",
						"3.5"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "CamilleQ.png",
						"sprite": "spell1.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CamilleW",
					"name": "Tactical Sweep",
					"description": "Camille blasts in a cone after a delay, dealing damage. Enemies in the outer half are slowed and take extra damage, while also healing Camille.",
					"tooltip": "Camille winds up and then slices in a direction, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to enemies hit.<br /><br />Enemies hit by the outer half are slowed by {{ e4 }}%, decaying over {{ e2 }} seconds. They take extra physical damage equal to {{ e5 }}% (<span class=\"colorFF8C00\">+{{ f2 }}</span>%) of their maximum health, and Camille heals for {{ e9 }}% of the bonus damage dealt to champions.<br /><br /><span class=\"size16 colorFFEB7F\">Tactical Sweep</span> <span class=\"size16 color8C8C8C\">does {{ e8 }}% less damage to non-epic monsters.</span>",
					"leveltip": {
						"label": [
							"Mana Cost",
							"Damage",
							"Maximum Health Damage",
							"Cooldown"
						],
						"effect": [
							"{{ cost }} -> {{ costNL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						13.5,
						12,
						10.5,
						9
					],
					"cooldownBurn": "15/13.5/12/10.5/9",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							70,
							100,
							130,
							160,
							190
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							6,
							6.5,
							7,
							7.5,
							8
						],
						[
							650,
							650,
							650,
							650,
							650
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						]
					],
					"effectBurn": [
						null,
						"70/100/130/160/190",
						"2",
						"0.75",
						"80",
						"6/6.5/7/7.5/8",
						"650",
						"30",
						"50",
						"100",
						"0.1"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						610,
						610,
						610,
						610,
						610
					],
					"rangeBurn": "610",
					"image": {
						"full": "CamilleW.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CamilleE",
					"name": "Hookshot",
					"description": "Camille pulls herself to a wall, leaping off and knocking up enemies upon landing.",
					"tooltip": "<span class=\"colorFF8C00\">First Cast:</span> Fire a hookshot that attaches to terrain, pulling Camille to it and allowing Hookshot to be recast for 1 second.<br /><br /><span class=\"colorFF8C00\">Second Cast:</span> Camille leaps from the wall, colliding with the first enemy champion hit. Upon landing, she deals {{ e3 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and a {{ e1 }} second stun to nearby enemies. Dashes towards enemy champions travel twice as far and grant {{ e2 }}% attack speed for {{ e5 }} seconds on impact.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Damage",
							"Attack Speed"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14.5,
						13,
						11.5,
						10
					],
					"cooldownBurn": "16/14.5/13/11.5/10",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							75,
							120,
							175,
							210,
							255
						],
						[
							1050,
							1050,
							1050,
							1050,
							1050
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							130,
							130,
							130,
							130,
							130
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0.75",
						"40/50/60/70/80",
						"75/120/175/210/255",
						"1050",
						"5",
						"1",
						"800",
						"400",
						"130",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "CamilleE.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CamilleR",
					"name": "The Hextech Ultimatum",
					"description": "Camille dashes to target champion, anchoring them to the area. She also deals bonus magic damage to the target with her basic attacks.",
					"tooltip": "Camille briefly becomes untargetable and leaps onto an enemy champion, interrupting channels and locking them into an area they cannot escape by any means for {{ e3 }} seconds. Other nearby enemies are knocked away. Her basic attacks against the trapped enemy deal bonus magic damage equal to {{ e2 }} plus {{ e1 }}% of their current health.<br /><br /><span class=\"size16 colorFFEB7F\">The Hextech Ultimatum</span> <span class=\"size16 color8C8C8C\">ends if Camille leaves the area.",
					"leveltip": {
						"label": [
							"Duration",
							"Cooldown",
							"Bonus Damage",
							"Current Health Damage"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						115,
						90
					],
					"cooldownBurn": "140/115/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							4,
							6,
							8
						],
						[
							5,
							10,
							15
						],
						[
							2.5,
							3.25,
							4
						],
						[
							-0.9,
							-0.9,
							-0.9
						],
						[
							425,
							425,
							425
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/6/8",
						"5/10/15",
						"2.5/3.25/4",
						"-0.9",
						"425",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						475,
						475,
						475
					],
					"rangeBurn": "475",
					"image": {
						"full": "CamilleR.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Adaptive Defenses",
				"description": "Basic attacks on champions grant a shield equal to 20% of Camille's maximum health against their damage type (Physical or Magic) for a brief duration.",
				"image": {
					"full": "Camille_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Camille",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Camille",
					"title": "CamilleTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Cassiopeia": {
			"id": "Cassiopeia",
			"key": "69",
			"name": "Cassiopeia",
			"title": "the Serpent's Embrace",
			"image": {
				"full": "Cassiopeia.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 288,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "69000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "69001",
					"num": 1,
					"name": "Desperada Cassiopeia",
					"chromas": false
				},
				{
					"id": "69002",
					"num": 2,
					"name": "Siren Cassiopeia",
					"chromas": false
				},
				{
					"id": "69003",
					"num": 3,
					"name": "Mythic Cassiopeia",
					"chromas": false
				},
				{
					"id": "69004",
					"num": 4,
					"name": "Jade Fang Cassiopeia",
					"chromas": false
				},
				{
					"id": "69008",
					"num": 8,
					"name": "Eternum Cassiopeia",
					"chromas": false
				}
			],
			"lore": "Cassiopeia is a deadly creature bent on manipulating others to her sinister will. Youngest and most beautiful daughter of the noble Du Couteau family of Noxus, she ventured deep into the crypts beneath Shurima in search of ancient power. There, she was bitten by a gruesome tomb guardian, whose venom transformed her into a viper-like predator. Cunning and agile, Cassiopeia now slithers under the veil of night, petrifying her enemies with her baleful gaze.",
			"blurb": "Cassiopeia is a deadly creature bent on manipulating others to her sinister will. Youngest and most beautiful daughter of the noble Du Couteau family of Noxus, she ventured deep into the crypts beneath Shurima in search of ancient power. There, she was...",
			"allytips": [
				"Use Twin Fang on poisoned stationary targets like monsters and units stunned by her Petrifying Gaze for maximum damage.",
				"Lead your enemy when targeting with Noxious Blast to ensure the hit."
			],
			"enemytips": [
				"Be wary of Cassiopeia's damage potential with Twin Fang when she has you poisoned.",
				"Turn away from Cassiopeia when she is casting Petrifying Gaze to get slowed instead of stunned."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 3,
				"magic": 9,
				"difficulty": 10
			},
			"stats": {
				"hp": 537,
				"hpperlevel": 87,
				"mp": 334,
				"mpperlevel": 63,
				"movespeed": 328,
				"armor": 25,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.5,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.034,
				"attackspeedperlevel": 1.5
			},
			"spells": [
				{
					"id": "CassiopeiaQ",
					"name": "Noxious Blast",
					"description": "Cassiopeia blasts an area with Poison after a brief delay, granting her increased Movement Speed if she hits an enemy champion.",
					"tooltip": "Blasts enemies in an area with <span class=\"color32CD32\">Noxious Poison</span>. If a champion is hit, Cassiopeia gains {{ e3 }}% Movement Speed decaying over {{ e4 }} seconds.<br /><br /><span class=\"color32CD32\">Noxious Poison</span> deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Movement Speed",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						3.5,
						3.5,
						3.5,
						3.5,
						3.5
					],
					"cooldownBurn": "3.5",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							75,
							120,
							165,
							210,
							255
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/120/165/210/255",
						"3",
						"30/35/40/45/50",
						"3",
						"7",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "CassiopeiaQ.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CassiopeiaW",
					"name": "Miasma",
					"description": "Cassiopeia releases several clouds of poison, slowing, grounding, and lightly damaging enemies that pass through them. Grounded enemies cannot use Movement abilities.",
					"tooltip": "Cassiopeia spews venom in an arc, leaving toxic clouds for {{ e4 }} seconds.<br /><br />Enemies in the clouds are continually afflicted with <span class=\"color32CD32\">Debilitating Poison</span>, inflicting a decaying {{ e2 }}% slow and grounding them, prohibiting the use of Movement abilities. They also take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second.<br /><br />Miasma has a minimum cast range.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Slow Amount",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							20,
							35,
							50,
							65,
							80
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/35/50/65/80",
						"40/50/60/70/80",
						"1",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "CassiopeiaW.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CassiopeiaE",
					"name": "Twin Fang",
					"description": "Cassiopeia lets loose an attack that deals increased damage to Poisoned targets and heals her for a percentage of the damage dealt. If the target dies from this attack, Cassiopeia regains Mana.",
					"tooltip": "Deal <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to a target. If the target is killed by Twin Fang, or is killed during its flight, Cassiopeia gains {{ cost }} Mana.<br /><br />If the victim is <span class=\"color32CD32\">Poisoned</span> when Twin Fang hits, it takes {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> additional magic damage and Cassiopeia heals for <span class=\"colorFFFFFF\">{{ f4 }}</span> <span class=\"color99FF99\">(+{{ f2 }})</span>.",
					"leveltip": {
						"label": [
							"Bonus Poison Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.75,
						0.75,
						0.75,
						0.75,
						0.75
					],
					"cooldownBurn": "0.75",
					"cost": [
						40,
						50,
						60,
						70,
						80
					],
					"costBurn": "40/50/60/70/80",
					"effect": [
						null,
						[
							10,
							30,
							50,
							70,
							90
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/30/50/70/90",
						"0",
						"0.1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.55,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "CassiopeiaE.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CassiopeiaR",
					"name": "Petrifying Gaze",
					"description": "Cassiopeia releases a swirl of magical energy from her eyes, stunning any enemies in front of her that are facing her and slowing any others with their back turned.",
					"tooltip": "Cassiopeia deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in front of her. Enemies facing her turn to stone and are stunned for {{ e3 }} seconds while enemies facing away are slowed by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							40,
							40,
							40
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"40",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						825,
						825,
						825
					],
					"rangeBurn": "825",
					"image": {
						"full": "CassiopeiaR.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Serpentine Grace",
				"description": "Cassiopeia gains Movement Speed per level, but she cannot purchase Boots items.",
				"image": {
					"full": "Cassiopeia_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Cassiopeia",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Cassiopeia",
					"title": "CassiopeiaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Chogath": {
			"id": "Chogath",
			"key": "31",
			"name": "Cho'Gath",
			"title": "the Terror of the Void",
			"image": {
				"full": "Chogath.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 336,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "31000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "31001",
					"num": 1,
					"name": "Nightmare Cho'Gath",
					"chromas": false
				},
				{
					"id": "31002",
					"num": 2,
					"name": "Gentleman Cho'Gath",
					"chromas": false
				},
				{
					"id": "31003",
					"num": 3,
					"name": "Loch Ness Cho'Gath",
					"chromas": false
				},
				{
					"id": "31004",
					"num": 4,
					"name": "Jurassic Cho'Gath",
					"chromas": false
				},
				{
					"id": "31005",
					"num": 5,
					"name": "Battlecast Prime Cho'Gath",
					"chromas": false
				},
				{
					"id": "31006",
					"num": 6,
					"name": "Prehistoric Cho'Gath",
					"chromas": false
				}
			],
			"lore": "From the moment Cho'Gath first emerged into the harsh light of Runeterra's sun, the beast was driven by the most pure and insatiable hunger. A perfect expression of the Void's desire to consume all life, Cho'Gath's complex biology quickly converts matter into new bodily growth—increasing its muscle mass and density, or hardening its outer carapace like organic diamond. When growing larger does not suit the Void-spawn's needs, it vomits out the excess material as razor-sharp spines, leaving prey skewered and ready to feast upon later.",
			"blurb": "From the moment Cho'Gath first emerged into the harsh light of Runeterra's sun, the beast was driven by the most pure and insatiable hunger. A perfect expression of the Void's desire to consume all life, Cho'Gath's complex biology quickly converts...",
			"allytips": [
				"Try to line up your attacks with Vorpal Spikes so that they kill minions and harass enemy champions at the same time.",
				"If you're having difficulty feasting upon champions, try eating minions until you're larger.",
				"Using Rupture on creeps in combination with Carnivore is a good way to gain Health and Mana."
			],
			"enemytips": [
				"Purchasing a few HP items decreases the chances of Cho'Gath killing you quickly.",
				"Focus on preventing Cho'Gath from reaching his max size.",
				"Rupture has a smoke cloud indicating the area it will strike. Try to watch out for it to prevent Cho'Gath from being able to combo his abilities."
			],
			"tags": [
				"Tank",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 7,
				"magic": 7,
				"difficulty": 5
			},
			"stats": {
				"hp": 574.4,
				"hpperlevel": 80,
				"mp": 272.2,
				"mpperlevel": 40,
				"movespeed": 345,
				"armor": 38,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9,
				"hpregenperlevel": 0.85,
				"mpregen": 7.206,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 69,
				"attackdamageperlevel": 4.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.44
			},
			"spells": [
				{
					"id": "Rupture",
					"name": "Rupture",
					"description": "Ruptures the ground at target location, popping enemy units into the air, dealing damage and slowing them.",
					"tooltip": "Ruptures the ground at target location. Enemies caught in the rupture are launched into the air for {{ e5 }} second, take {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage, and are slowed by {{ e2 }}% for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							80,
							135,
							190,
							245,
							300
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0.625,
							0.625,
							0.625,
							0.625,
							0.625
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/135/190/245/300",
						"60",
						"1.5",
						"0.63",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "Rupture.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FeralScream",
					"name": "Feral Scream",
					"description": "Cho'Gath unleashes a terrible scream at enemies in a cone, dealing magic damage and Silencing enemies for a few seconds.",
					"tooltip": "Silences enemies in a cone for {{ e2 }} seconds and deals {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Silence Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							75,
							125,
							175,
							225,
							275
						],
						[
							1.6,
							1.7,
							1.8,
							1.9,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/125/175/225/275",
						"1.6/1.7/1.8/1.9/2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "FeralScream.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VorpalSpikes",
					"name": "Vorpal Spikes",
					"description": "Cho'Gath's attacks release deadly spikes, dealing damage and slowing all enemy units in front of him.",
					"tooltip": "Cho'Gath's next 3 basic attacks launch spikes that deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> plus {{ f1 }}% of enemies' maximum Health as magic damage and slow by {{ e2 }}% for {{ e3 }} seconds, decaying over the duration.<br /><br /><rules>Spikes grow wider as Cho'Gath gains Feast stacks.<br />Spikes deal an additional 0.5% of enemies' maximum Health per Feast stack.<br />Percent Health damage against minions and monsters is capped at {{ e8 }}.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Slow"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7,
						6,
						5,
						4
					],
					"cooldownBurn": "8/7/6/5/4",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							50,
							50,
							50,
							50,
							50
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"30/35/40/45/50",
						"1.5",
						"6",
						"3",
						"3",
						"0.5",
						"60/80/100/120/140",
						"6",
						"50"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						40,
						40,
						40,
						40,
						40
					],
					"rangeBurn": "40",
					"image": {
						"full": "VorpalSpikes.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Feast",
					"name": "Feast",
					"description": "Devours an enemy unit, dealing a high amount of true damage. If the target is killed, Cho'Gath grows, gaining maximum Health.",
					"tooltip": "Ravenously feed on an enemy, dealing {{ e2 }} <scaleHealth>(+{{ f2 }})</scaleHealth> <scaleAP>(+{{ a2 }})</scaleAP> true damage to champions or {{ e1 }} <scaleHealth>(+{{ f2 }}) </scaleHealth><scaleAP>(+{{ a2 }})</scaleAP> to minions and monsters. If the target is killed, Cho'Gath gains a stack of Feast, which causes him to grow in size and gain {{ e3 }} maximum health.<br /><br /><rules>Only {{ e4 }} total stacks can be gained from minions and non-epic monsters. <span class=\"colorFFF673\">(Current: {{ f3 }}/{{ e4 }})</span></rules>",
					"leveltip": {
						"label": [
							"Champion Damage",
							"Health per Stack"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						80,
						80,
						80
					],
					"cooldownBurn": "80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							1000,
							1000,
							1000
						],
						[
							300,
							475,
							650
						],
						[
							80,
							120,
							160
						],
						[
							6,
							6,
							6
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1000",
						"300/475/650",
						"80/120/160",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						175,
						175,
						175
					],
					"rangeBurn": "175",
					"image": {
						"full": "Feast.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Carnivore",
				"description": "Whenever Cho'Gath kills a unit, he recovers Health and Mana. The values restored increase with Cho'Gath's level.",
				"image": {
					"full": "GreenTerror_TailSpike.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Chogath",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3105",
									"count": 1
								},
								{
									"id": "3001",
									"count": 1
								},
								{
									"id": "3110",
									"count": 1
								},
								{
									"id": "3083",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Chogath",
					"title": "ChogathTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Corki": {
			"id": "Corki",
			"key": "42",
			"name": "Corki",
			"title": "the Daring Bombardier",
			"image": {
				"full": "Corki.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 384,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "42000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "42001",
					"num": 1,
					"name": "UFO Corki",
					"chromas": false
				},
				{
					"id": "42002",
					"num": 2,
					"name": "Ice Toboggan Corki",
					"chromas": false
				},
				{
					"id": "42003",
					"num": 3,
					"name": "Red Baron Corki",
					"chromas": false
				},
				{
					"id": "42004",
					"num": 4,
					"name": "Hot Rod Corki",
					"chromas": false
				},
				{
					"id": "42005",
					"num": 5,
					"name": "Urfrider Corki",
					"chromas": false
				},
				{
					"id": "42006",
					"num": 6,
					"name": "Dragonwing Corki",
					"chromas": true
				},
				{
					"id": "42007",
					"num": 7,
					"name": "Fnatic Corki",
					"chromas": false
				},
				{
					"id": "42008",
					"num": 8,
					"name": "Arcade Corki",
					"chromas": true
				}
			],
			"lore": "The yordle pilot Corki loves two things above all others: flying, and his glamorous mustache... though not necessarily in that order. After leaving Bandle City, he settled in Piltover and fell in love with the wondrous machines he found there. He dedicated himself to the development of flying contraptions, leading an aerial defense force of seasoned veterans known as the Screaming Yipsnakes. Calm under fire, Corki patrols the skies around his adopted home, and has never encountered a problem that a good missile barrage couldn't solve.",
			"blurb": "The yordle pilot Corki loves two things above all others: flying, and his glamorous mustache... though not necessarily in that order. After leaving Bandle City, he settled in Piltover and fell in love with the wondrous machines he found there. He...",
			"allytips": [
				"Phosphorus Bomb can be used to reveal enemy units that might be hiding in a nearby patch of brush.",
				"Valkyrie can be used defensively as well, so try using it for a quick escape.",
				"Corki can continue to attack while using Gatling Gun. Maximizing Gatling Gun is key to mastering Corki."
			],
			"enemytips": [
				"Watch out for Corki's Missile Barrage. They deal splash damage, so you can get hit even when hiding behind minions.",
				"Corki is vulnerable after he uses his Valkyrie or Special Delivery, so try switching focus to him if he uses them to enter a fight."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 3,
				"magic": 6,
				"difficulty": 6
			},
			"stats": {
				"hp": 518,
				"hpperlevel": 87,
				"mp": 350.16,
				"mpperlevel": 34,
				"movespeed": 325,
				"armor": 28,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 7.424,
				"mpregenperlevel": 0.55,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 60,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 2.3
			},
			"spells": [
				{
					"id": "PhosphorusBomb",
					"name": "Phosphorus Bomb",
					"description": "Corki fires a flash bomb at a target location, dealing magic damage to enemies in the area. This attack additionally reveals units in the area for a duration.",
					"tooltip": "Corki lobs a bomb, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the target area. In addition, the blast reveals the area and champions hit by the blast for {{ e2 }} seconds (does not reveal stealth).",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							75,
							120,
							165,
							210,
							255
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/120/165/210/255",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						825,
						825,
						825,
						825,
						825
					],
					"rangeBurn": "825",
					"image": {
						"full": "PhosphorusBomb.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CarpetBomb",
					"name": "Valkyrie",
					"description": "Corki flies a short distance, dropping bombs that create a trail of fire that damages opponents who remain in it.",
					"tooltip": "<span class=\"colorFF9900\">Active:</span> Corki flies a short distance, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to enemies in the fire left along his path.<br /><br /><span class=\"colorFF9900\">Special Delivery:</span> Corki flies a great distance, dropping bombs that knock aside enemies and leave a burning trail for 5 seconds. The trail slows enemies by {{ e2 }}% and burns them for {{ f1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage per second.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						19,
						18,
						17,
						16
					],
					"cooldownBurn": "20/19/18/17/16",
					"cost": [
						100,
						100,
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							90,
							90,
							90,
							90,
							90
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/90/120/150/180",
						"90",
						"0",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "CarpetBomb.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GGun",
					"name": "Gatling Gun",
					"description": "Corki's gatling gun rapidly fires in a cone in front of him, dealing damage and reducing enemy Armor and Magic Resist.",
					"tooltip": "Corki's gatling gun fires continuously at targets in front of him for {{ e2 }} seconds, dealing up to {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> damage and reducing up to {{ e4 }} armor and magic resist.<br /><br /><span class=\"color919191\"><i>Gatling Gun's damage is {{ e7 }}% physical, {{ e8 }}% magic.<br />Defense reductions last for {{ e6 }} seconds after last being damaged by Gatling Gun.</i></span>",
					"leveltip": {
						"label": [
							"Damage",
							"Defense Reduction"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						16,
						16,
						16,
						16
					],
					"cooldownBurn": "16",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							80,
							140,
							200,
							260,
							320
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							8,
							12,
							16,
							20
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/140/200/260/320",
						"4",
						"4",
						"4/8/12/16/20",
						"8",
						"2",
						"50",
						"50",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "GGun.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MissileBarrage",
					"name": "Missile Barrage",
					"description": "Corki fires a missile toward his target location that explodes on impact, dealing damage to enemies in an area. Corki stores missiles over time, up to a maximum. Every 3rd missile fired will be a Big One, dealing extra damage.",
					"tooltip": "<span class=\"colorFF9900\">Active:</span> Corki fires a missile that explodes at the first enemy it hits, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all nearby enemies.<br /><br />Corki can store up to 7 missiles, and every 3rd missile will be a Big One, dealing {{ f2 }}% damage ({{ f3 }})</span>.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Attack Damage Scaling",
							"Missile Reload Time"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						2,
						2,
						2
					],
					"cooldownBurn": "2",
					"cost": [
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							75,
							100,
							125
						],
						[
							15,
							45,
							75
						],
						[
							300,
							300,
							300
						],
						[
							2,
							2,
							2
						],
						[
							0.15,
							0.45,
							0.75
						],
						[
							0,
							0,
							0
						],
						[
							50,
							50,
							50
						],
						[
							200,
							200,
							200
						],
						[
							200,
							200,
							200
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/100/125",
						"15/45/75",
						"300",
						"2",
						"0.15/0.45/0.75",
						"0",
						"50",
						"200",
						"200",
						"0"
					],
					"vars": [
						{
							"link": "@cooldownchampion",
							"coeff": 10,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "@dynamic.attackdamage",
							"coeff": 0,
							"key": "f3"
						}
					],
					"costType": " Mana",
					"maxammo": "7",
					"range": [
						1225,
						1225,
						1225
					],
					"rangeBurn": "1225",
					"image": {
						"full": "MissileBarrage.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Hextech Munitions",
				"description": "Corki's basic attack deals a percentage of their damage as magic instead of physical. Every once in a while, The Package arrives in Corki's base to be picked up, temporarily granting him out of combat Movement Speed and upgrading Valkyrie into Special Delivery.",
				"image": {
					"full": "Corki_RapidReload.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Corki",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Corki",
					"title": "CorkiTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Darius": {
			"id": "Darius",
			"key": "122",
			"name": "Darius",
			"title": "the Hand of Noxus",
			"image": {
				"full": "Darius.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 432,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "122000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "122001",
					"num": 1,
					"name": "Lord Darius",
					"chromas": false
				},
				{
					"id": "122002",
					"num": 2,
					"name": "Bioforge Darius",
					"chromas": false
				},
				{
					"id": "122003",
					"num": 3,
					"name": "Woad King Darius",
					"chromas": false
				},
				{
					"id": "122004",
					"num": 4,
					"name": "Dunkmaster Darius",
					"chromas": true
				},
				{
					"id": "122008",
					"num": 8,
					"name": "Academy Darius",
					"chromas": false
				},
				{
					"id": "122014",
					"num": 14,
					"name": "Dreadnova Darius",
					"chromas": false
				}
			],
			"lore": "There is no greater symbol of Noxian might than Darius, the nation's most feared and battle-hardened leader. Rising from humble origins to become the Hand of Noxus, he cleaves through the empire's enemies—many of them Noxians themselves. Knowing that he never doubts his cause is just, and never hesitates once his axe is raised, those who stand against the commander of the Trifarian Legion can expect no mercy.",
			"blurb": "There is no greater symbol of Noxian might than Darius, the nation's most feared and battle-hardened leader. Rising from humble origins to become the Hand of Noxus, he cleaves through the empire's enemies—many of them Noxians themselves. Knowing that he...",
			"allytips": [
				"Decimate is a powerful harassment ability. Strike an enemy from maximum range for the greatest effect.",
				"Noxian Guillotine does more damage the more attacks you can land prior to it. Use Noxian Might to deal maximum damage.",
				"Darius benefits greatly from enhanced survivability. The longer you can prolong a fight, the more powerful he becomes."
			],
			"enemytips": [
				"When Darius's axe grab is on cooldown, he is vulnerable to harassment attacks.",
				"Darius's ability to escape from fights is limited. If you have an advantage against him, press your lead."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 5,
				"magic": 1,
				"difficulty": 2
			},
			"stats": {
				"hp": 582.24,
				"hpperlevel": 100,
				"mp": 263,
				"mpperlevel": 37.5,
				"movespeed": 340,
				"armor": 39,
				"armorperlevel": 4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 10,
				"hpregenperlevel": 0.95,
				"mpregen": 6.6,
				"mpregenperlevel": 0.35,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1
			},
			"spells": [
				{
					"id": "DariusCleave",
					"name": "Decimate",
					"description": "Darius winds up and swings his axe in a wide circle. Enemies struck by the blade take more damage than those struck by the handle. Darius heals based on enemy champions hit by the blade.",
					"tooltip": "After a short delay, Darius swings his axe around himself, striking enemies in its path. Enemies hit by the axe's blade take {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage. Enemies hit by the handle take {{ e6 }}% damage (does not apply Hemorrhage).<br /><br />Darius heals for <span class=\"colorFF0000\">{{ e5 }}% of his missing Health</span> per enemy champion hit by the blade (max: {{ e7 }}%).",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Damage Scaling",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						30,
						35,
						40,
						45,
						50
					],
					"costBurn": "30/35/40/45/50",
					"effect": [
						null,
						[
							100,
							110,
							120,
							130,
							140
						],
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							99,
							99,
							99,
							99,
							99
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							36,
							36,
							36,
							36,
							36
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/110/120/130/140",
						"40/70/100/130/160",
						"99",
						"0.1",
						"12",
						"35",
						"36",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.05,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "DariusCleave.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DariusNoxianTacticsONH",
					"name": "Crippling Strike",
					"description": "Darius's next attack strikes an enemy's crucial artery. As they bleed out, their Movement Speed is slowed.",
					"tooltip": " Darius's next basic attack deals <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage and slows the target by {{ e2 }}% for {{ e5 }} second.<br /><br />Crippling Strike refunds its Mana cost and {{ e3 }}% of its cooldown if it kills the target.",
					"leveltip": {
						"label": [
							"Attack Damage Scaling",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							90,
							90,
							90,
							90,
							90
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							140,
							145,
							150,
							155,
							160
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"90",
						"50",
						"140/145/150/155/160",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "DariusNoxianTacticsONH.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DariusAxeGrabCone",
					"name": "Apprehend",
					"description": "Darius hones his axe, passively causing his physical damage to ignore a percentage of his target's Armor. When activated, Darius sweeps up his enemies with his axe's hook and pulls them to him.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Darius gains {{ e1 }}% Armor Penetration.<br /><br /><span class=\"colorFF9900\">Active: </span>Pulls in all enemies in front of Darius and slows them by {{ e2 }}% for {{ e3 }} second.",
					"leveltip": {
						"label": [
							"Armor Penetration",
							"Cooldown "
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						21,
						18,
						15,
						12
					],
					"cooldownBurn": "24/21/18/15/12",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/15/20/25/30",
						"40",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						535,
						535,
						535,
						535,
						535
					],
					"rangeBurn": "535",
					"image": {
						"full": "DariusAxeGrabCone.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DariusExecute",
					"name": "Noxian Guillotine",
					"description": "Darius leaps to an enemy champion and strikes a lethal blow, dealing true damage. This damage is increased for each stack of Hemorrhage on the target. If Noxian Guillotine is a killing blow, its cooldown is refreshed for a brief duration.",
					"tooltip": "Leaps to target enemy champion and strikes a lethal blow, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> true damage. For each stack of Hemorrhage on the target, Noxian Guillotine deals an additional {{ e3 }}% damage.<span class=\"size8 colorFF9900\"><br /><br /></span><span class=\"colorF50F00\">Maximum Damage: {{ f3 }}</span><span class=\"size8\"><br /><br /></span>If Noxian Guillotine kills the target, it may be re-cast at no cost within 20 seconds.<span class=\"size8\"><br /><br /></span>At rank 3, Noxian Guillotine <span class=\"colorFFFF66\"><i>unlocks</i></span> - its cooldown resets entirely on kills and it no longer has a Mana cost.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						0
					],
					"costBurn": "100/100/0",
					"effect": [
						null,
						[
							100,
							200,
							300
						],
						[
							0.75,
							0.75,
							0.75
						],
						[
							20,
							20,
							20
						],
						[
							25,
							50,
							100
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/200/300",
						"0.75",
						"20",
						"25/50/100",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.75,
							"key": "f1"
						},
						{
							"link": "@special.dariusr3",
							"coeff": 0,
							"key": "f3"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						460,
						460,
						460
					],
					"rangeBurn": "460",
					"image": {
						"full": "DariusExecute.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Hemorrhage",
				"description": "Darius aims his attacks strategically, causing his target to bleed. This effect stacks up to five times. Enemies that reach max Hemorrhage cause Darius to gain Noxian Might, greatly increasing his damage.",
				"image": {
					"full": "Darius_PassiveBuff.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Darius",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Darius",
					"title": "DariusTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Diana": {
			"id": "Diana",
			"key": "131",
			"name": "Diana",
			"title": "Scorn of the Moon",
			"image": {
				"full": "Diana.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 0,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "131000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "131001",
					"num": 1,
					"name": "Dark Valkyrie Diana",
					"chromas": false
				},
				{
					"id": "131002",
					"num": 2,
					"name": "Lunar Goddess Diana",
					"chromas": true
				},
				{
					"id": "131003",
					"num": 3,
					"name": "Infernal Diana",
					"chromas": false
				},
				{
					"id": "131011",
					"num": 11,
					"name": "Blood Moon Diana",
					"chromas": false
				}
			],
			"lore": "Bearing her crescent moonblade, Diana fights as a warrior of the Lunari—a faith all but quashed in the lands around Mount Targon. Clad in shimmering armor the color of winter snow at night, she is a living embodiment of the silver moon's power. Imbued with the essence of an Aspect from beyond Targon's towering summit, Diana is no longer wholly human, and struggles to understand her power and purpose in this world.",
			"blurb": "Bearing her crescent moonblade, Diana fights as a warrior of the Lunari—a faith all but quashed in the lands around Mount Targon. Clad in shimmering armor the color of winter snow at night, she is a living embodiment of the silver moon's power. Imbued...",
			"allytips": [
				"Landing Crescent Strike is critically important, but don't be afraid to miss. The cooldown is short and the mana cost is low.",
				"Consider when to cast Lunar Rush without Moonlight and when to wait for another Crescent Strike.",
				"Use Moonfall and Lunar Rush to stay on targets and activate Moonsilver Blade for extra damage."
			],
			"enemytips": [
				"Dodge Crescent Strike, or move to safety if you are affected by Moonlight.",
				"Pale Cascade orbs only last a few seconds. Avoid Diana and engage her after the shield dissipates.",
				"Diana can play very aggressively if she uses Lunar Rush without Moonlight, but you can punish her by slowing or stunning her when she has no way to get back into position."
			],
			"tags": [
				"Fighter",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 6,
				"magic": 8,
				"difficulty": 4
			},
			"stats": {
				"hp": 594,
				"hpperlevel": 95,
				"mp": 297.2,
				"mpperlevel": 40,
				"movespeed": 345,
				"armor": 31,
				"armorperlevel": 3.6,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 150,
				"hpregen": 7.5,
				"hpregenperlevel": 0.85,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.25
			},
			"spells": [
				{
					"id": "DianaArc",
					"name": "Crescent Strike",
					"description": "Diana swings her blade to unleash a bolt of lunar energy that deals damage in an arc before exploding. Afflicts enemies struck with the Moonlight debuff, revealing them if they are not stealthed. ",
					"tooltip": "Unleashes a bolt of lunar energy in an arc dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage.<br /><br />Afflicts enemies struck with Moonlight, revealing them if they are not stealthed for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7.5,
						7,
						6.5,
						6
					],
					"cooldownBurn": "8/7.5/7/6.5/6",
					"cost": [
						55,
						55,
						55,
						55,
						55
					],
					"costBurn": "55",
					"effect": [
						null,
						[
							60,
							95,
							130,
							165,
							200
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							55,
							55,
							55,
							55,
							55
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/95/130/165/200",
						"15",
						"55",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "DianaArc.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DianaOrbs",
					"name": "Pale Cascade",
					"description": "Diana creates three orbiting spheres that detonate on contact with enemies to deal damage in an area. She also gains a temporary shield that absorbs damage. If her third sphere detonates, the shield gains additional strength.",
					"tooltip": "Creates three orbiting spheres that explode on contact with enemies dealing {{ e2 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage. Lasts {{ e1 }} seconds.<br /><br />Grants a temporary shield that absorbs {{ e3 }} <scaleAP>(+{{ a2 }})</scaleAP> damage. If the third sphere detonates, the shield increases by {{ e3 }} <scaleAP>(+{{ a2 }})</scaleAP>.",
					"leveltip": {
						"label": [
							"Damage",
							"Shield",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						40,
						55,
						70,
						85,
						100
					],
					"costBurn": "40/55/70/85/100",
					"effect": [
						null,
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							22,
							34,
							46,
							58,
							70
						],
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5",
						"22/34/46/58/70",
						"40/55/70/85/100",
						"1",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "DianaOrbs.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DianaVortex",
					"name": "Moonfall",
					"description": "Diana draws in and slows all nearby enemies. Passively grants Diana attack speed after spell casts.",
					"tooltip": "<spellPassive>Passive:</spellPassive> Increases the attack speed gained from Moonsilver Blade to {{ e3 }}%.<br /><br /><spellActive>Active:</spellActive> Reveals and draws in all nearby enemies and then slows them by {{ e1 }}% for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						26,
						24,
						22,
						20,
						18
					],
					"cooldownBurn": "26/24/22/20/18",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							35,
							40,
							45,
							50,
							55
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							50,
							60,
							70,
							80,
							90
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/40/45/50/55",
						"2",
						"50/60/70/80/90",
						"3",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "DianaVortex.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DianaTeleport",
					"name": "Lunar Rush",
					"description": "Diana dashes to an enemy and deals magic damage. Lunar Rush has no cooldown when used to teleport to a target afflicted with Moonlight.",
					"tooltip": "Becomes the living embodiment of the vengeful moon, dashing to an enemy and dealing {{ e2 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage.<br /><br />Lunar Rush has no cooldown when used to dash to an enemy afflicted with Moonlight. All other enemies will have the Moonlight debuff removed regardless of whether they were the target of Lunar Rush.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						25,
						20,
						15
					],
					"cooldownBurn": "25/20/15",
					"cost": [
						50,
						65,
						80
					],
					"costBurn": "50/65/80",
					"effect": [
						null,
						[
							4,
							4,
							4
						],
						[
							100,
							160,
							220
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4",
						"100/160/220",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						825,
						825,
						825
					],
					"rangeBurn": "825",
					"image": {
						"full": "DianaTeleport.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Moonsilver Blade",
				"description": "Every third strike restores mana and cleaves nearby enemies for additional magic damage. Every spell cast grants attack speed for the next 3 attacks.",
				"image": {
					"full": "Diana_Passive_LunarBlade.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Diana",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Diana",
					"title": "DianaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Draven": {
			"id": "Draven",
			"key": "119",
			"name": "Draven",
			"title": "the Glorious Executioner",
			"image": {
				"full": "Draven.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 48,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "119000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "119001",
					"num": 1,
					"name": "Soul Reaver Draven",
					"chromas": false
				},
				{
					"id": "119002",
					"num": 2,
					"name": "Gladiator Draven",
					"chromas": false
				},
				{
					"id": "119003",
					"num": 3,
					"name": "Primetime Draven",
					"chromas": true
				},
				{
					"id": "119004",
					"num": 4,
					"name": "Pool Party Draven",
					"chromas": false
				},
				{
					"id": "119005",
					"num": 5,
					"name": "Beast Hunter Draven",
					"chromas": false
				},
				{
					"id": "119006",
					"num": 6,
					"name": "Draven Draven",
					"chromas": false
				},
				{
					"id": "119012",
					"num": 12,
					"name": "Santa Draven",
					"chromas": false
				}
			],
			"lore": "In Noxus, warriors known as reckoners face one another in arenas where blood is spilled and strength tested—but none has ever been as celebrated as Draven. A former soldier, he found that the crowds uniquely appreciated his flair for the dramatic, not to mention the spray of blood from each of his spinning axes. Addicted to the spectacle of his own brash perfection, Draven has sworn to defeat whomever he must to ensure that his name is chanted throughout the empire forever more.",
			"blurb": "In Noxus, warriors known as reckoners face one another in arenas where blood is spilled and strength tested—but none has ever been as celebrated as Draven. A former soldier, he found that the crowds uniquely appreciated his flair for the dramatic, not...",
			"allytips": [
				"If Draven doesn't move, Spinning Axe will fall near his present location. It will fall directly on him, or just to the right or left.",
				"If Draven does move after attacking, Spinning Axe will lead him in the direction of his movement. Use this to control where the Spinning Axe will go."
			],
			"enemytips": [
				"Launch skillshots toward the landing position of Draven's Spinning Axes.",
				"Disrupt Draven with the goal of making him drop his axes. If you do, his power drops dramatically."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 3,
				"magic": 1,
				"difficulty": 8
			},
			"stats": {
				"hp": 557.76,
				"hpperlevel": 82,
				"mp": 360.56,
				"mpperlevel": 39,
				"movespeed": 330,
				"armor": 35,
				"armorperlevel": 3.3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6,
				"hpregenperlevel": 0.7,
				"mpregen": 8.042,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 2.91,
				"attackspeedoffset": -0.08,
				"attackspeedperlevel": 2.7
			},
			"spells": [
				{
					"id": "DravenSpinning",
					"name": "Spinning Axe",
					"description": "Draven's next attack will deal bonus physical damage. This axe will ricochet off the target high up into the air. If Draven catches it, he automatically readies another Spinning Axe. Draven can have two Spinning Axes at once.",
					"tooltip": "Draven's next attack will deal <span class=\"colorFF8C00\">{{ f1 }}</span> bonus physical damage. The bonus is equal to {{ e5 }} plus {{ e2 }}% of his bonus Attack Damage.<br /><br />This axe will ricochet off the target high up into the air. If Draven catches it, he automatically readies another Spinning Axe.<br /><br /><span class=\"colorDDDD77\">Draven can have two Spinning Axes at once.</span>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Bonus AD Percentage",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							65,
							75,
							85,
							95,
							105
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							5.75,
							5.75,
							5.75,
							5.75,
							5.75
						],
						[
							35,
							40,
							45,
							50,
							55
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100",
						"65/75/85/95/105",
						"30/35/40/45/50",
						"5.75",
						"35/40/45/50/55",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.45,
								0.55,
								0.65,
								0.75,
								0.85
							],
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "DravenSpinning.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DravenFury",
					"name": "Blood Rush",
					"description": "Draven gains increased Movement Speed and Attack Speed. The Movement Speed bonus decreases rapidly over its duration. Catching a Spinning Axe will refresh the cooldown of Blood Rush.",
					"tooltip": "",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Mana Cost",
							"Movement Speed"
						],
						"effect": [
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cost }} -> {{ costNL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						40,
						35,
						30,
						25,
						20
					],
					"costBurn": "40/35/30/25/20",
					"effect": [
						null,
						[
							4,
							5,
							6,
							7,
							8
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							-0.05,
							-0.056,
							-0.062,
							-0.069,
							-0.075
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/5/6/7/8",
						"40/45/50/55/60",
						"1.5",
						"20/25/30/35/40",
						"3",
						"-0.05/-0.056/-0.062/-0.069/-0.075",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "DravenFury.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DravenDoubleShot",
					"name": "Stand Aside",
					"description": "Draven throws his axes, dealing physical damage to targets hit and knocking them aside. Targets hit are slowed.",
					"tooltip": "Draven throws his axes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to targets hit and knocking them aside. Targets hit are slowed by {{ e2 }}% for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Amount",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							75,
							110,
							145,
							180,
							215
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/110/145/180/215",
						"20/25/30/35/40",
						"2",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1050,
						1050,
						1050,
						1050,
						1050
					],
					"rangeBurn": "1050",
					"image": {
						"full": "DravenDoubleShot.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DravenRCast",
					"name": "Whirling Death",
					"description": "Draven hurls two massive axes to deal physical damage to each unit struck. Whirling Death slowly reverses direction and returns to Draven after striking an enemy champion. Draven may also activate this ability while the axes are in flight to cause it to return early. Deals less damage for each unit hit and resets when the axes reverse direction.",
					"tooltip": "Draven hurls two massive axes to deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to each unit struck.<br /><br />Whirling Death slowly reverses direction and returns to Draven after striking an enemy champion. Draven may also activate this ability while the axes are in flight to cause it to return early. Deals {{ e4 }}% less damage for each unit hit (Minimum {{ e2 }}%) and resets when the axes reverse direction.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							175,
							275,
							375
						],
						[
							40,
							40,
							40
						],
						[
							0,
							0,
							0
						],
						[
							8,
							8,
							8
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"175/275/375",
						"40",
						"0",
						"8",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.1,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20000,
						20000,
						20000
					],
					"rangeBurn": "20000",
					"image": {
						"full": "DravenRCast.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "League of Draven",
				"description": "Draven gains his fans' Adoration when he catches a Spinning Axe or kills a minion, monster, or tower. Killing enemy champions grants Draven bonus gold based on how much Adoration he has.",
				"image": {
					"full": "Draven_passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Draven",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Draven",
					"title": "DravenTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"DrMundo": {
			"id": "DrMundo",
			"key": "36",
			"name": "Dr. Mundo",
			"title": "the Madman of Zaun",
			"image": {
				"full": "DrMundo.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 96,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "36000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "36001",
					"num": 1,
					"name": "Toxic Dr. Mundo",
					"chromas": false
				},
				{
					"id": "36002",
					"num": 2,
					"name": "Mr. Mundoverse",
					"chromas": false
				},
				{
					"id": "36003",
					"num": 3,
					"name": "Corporate Mundo",
					"chromas": false
				},
				{
					"id": "36004",
					"num": 4,
					"name": "Mundo Mundo",
					"chromas": false
				},
				{
					"id": "36005",
					"num": 5,
					"name": "Executioner Mundo",
					"chromas": false
				},
				{
					"id": "36006",
					"num": 6,
					"name": "Rageborn Mundo",
					"chromas": false
				},
				{
					"id": "36007",
					"num": 7,
					"name": "TPA Mundo",
					"chromas": false
				},
				{
					"id": "36008",
					"num": 8,
					"name": "Pool Party Mundo",
					"chromas": false
				},
				{
					"id": "36009",
					"num": 9,
					"name": "El Macho Mundo",
					"chromas": false
				}
			],
			"lore": "Utterly insane, unrepentantly homicidal, and horrifyingly purple, Dr. Mundo is what keeps many of Zaun's citizens indoors on particularly dark nights. This monosyllabic monstrosity seems to want nothing more than pain—both the giving of it, and the receiving of it. Wielding his massive meat cleaver as if it were weightless, Mundo is infamous for capturing and torturing dozens of Zaun's citizens for his nefarious “operations,” which seem to have no overall point or goal. He is brutal. He is unpredictable. He goes where he pleases. He is also not, technically, a doctor.",
			"blurb": "Utterly insane, unrepentantly homicidal, and horrifyingly purple, Dr. Mundo is what keeps many of Zaun's citizens indoors on particularly dark nights. This monosyllabic monstrosity seems to want nothing more than pain—both the giving of it, and the...",
			"allytips": [
				"A well-timed Sadism can bait enemy champions into attacking you even when they lack the damage to finish you.",
				"Spirit Visage will increase the healing done by your ultimate and lower cooldowns on all of your abilities.",
				"Cleavers are a powerful tool for killing neutral monsters. Instead of returning to base, farm neutral monsters until your ultimate can heal you."
			],
			"enemytips": [
				"Try to coordinate high-damage abilities with your allies right after Dr. Mundo uses his ultimate, but if you're unable to kill him quickly with burst he will heal through the damage.",
				"Try casting Ignite when Dr. Mundo uses Sadism to negate a large portion of its healing."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "None",
			"info": {
				"attack": 5,
				"defense": 7,
				"magic": 6,
				"difficulty": 5
			},
			"stats": {
				"hp": 582.52,
				"hpperlevel": 89,
				"mp": 0,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 36,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.75,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61.27,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.8
			},
			"spells": [
				{
					"id": "InfectedCleaverMissileCast",
					"name": "Infected Cleaver",
					"description": "Dr. Mundo hurls his cleaver, dealing damage equal to a portion of his target's current Health and slowing them for a short time. Dr. Mundo delights in the suffering of others, so he is returned half of the Health cost when he successfully lands a cleaver (increased to the full Health cost on killing blows).",
					"tooltip": "Dr. Mundo hurls his cleaver, dealing {{ e2 }}% of the target's current health as magic damage (no less than {{ e1 }}) and slowing them by {{ e4 }}% for {{ e5 }} seconds.<br /><br />If the cleaver hits, {{ f1 }} health is refunded ({{ f2 }} if the cleaver kills).<br /><br /><rules>Infected Cleaver deals no more than {{ e6 }} damage against monsters.</rules>",
					"leveltip": {
						"label": [
							"Cleaver Damage",
							"Damage Minimum",
							"Damage Maximum (vs monsters)",
							"Cost"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e3 }} -> {{ e3NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							50,
							60,
							70,
							80,
							90
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							300,
							350,
							400,
							450,
							500
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/130/180/230/280",
						"15/17.5/20/22.5/25",
						"50/60/70/80/90",
						"40",
						"2",
						"300/350/400/450/500",
						"0.5",
						"1",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Health",
					"maxammo": "-1",
					"range": [
						975,
						975,
						975,
						975,
						975
					],
					"rangeBurn": "975",
					"image": {
						"full": "InfectedCleaverMissileCast.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e3 }} Health"
				},
				{
					"id": "BurningAgony",
					"name": "Burning Agony",
					"description": "Dr. Mundo drains his Health to reduce the duration of disables and deal continual damage to nearby enemies.",
					"tooltip": "<spellActive>Toggle:</spellActive> Dr. Mundo sets himself on fire, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to nearby enemies every second.<br /><br />While on fire, the duration of disables against Dr. Mundo are reduced by {{ e5 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Disable Reduction",
							"Cost"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							325,
							325,
							325,
							325,
							325
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/55/70/85/100",
						"10/15/20/25/30",
						"2",
						"325",
						"10/15/20/25/30",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Health Every Second",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "BurningAgony.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e2 }} Health Every Second"
				},
				{
					"id": "Masochism",
					"name": "Masochism",
					"description": "Dr. Mundo gains bonus attack damage based on his missing health, and his next basic attack headbutts his target for additional damage. Passively increases magic resist whenever Dr. Mundo is dealt magic damage or pays a health cost.",
					"tooltip": "<spellPassive>Passive:</spellPassive> When Dr. Mundo suffers magic damage or pays a health cost, his magic resist is increased by {{ e8 }}% for {{ e0 }} seconds, up to a maximum of {{ f3*100 }}%.<br /><br /><spellActive>Active:</spellActive> Dr. Mundo's next basic attack will headbutt the enemy, dealing an additional <scaleHealth>{{ f1 }}</scaleHealth> physical damage ({{ e1 }}% of maximum health) at the cost of {{ e2 }} health.<br /><br />Upon activation, Dr. Mundo gains up to {{ e4 }} attack damage (no less than {{ e5 }}) for {{ e6 }} seconds based on his missing health.<br /><br /><rules>Masochism grants {{ f2 }} attack damage above the minimum for every 1% of missing health (<scaleHealth>{{ f5 }}</scaleHealth>).",
					"leveltip": {
						"label": [
							"Headbutt Damage",
							"Headbutt Cost",
							"Attack Damage Maximum",
							"Attack Damage Minimum",
							"Magic Resist Maximum"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ f3*100 }}% -> {{ f4*100 }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							3,
							3.5,
							4,
							4.5,
							5
						],
						[
							25,
							35,
							45,
							55,
							65
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							3,
							6,
							9,
							12,
							15
						],
						[
							2,
							2,
							2,
							2,
							2
						]
					],
					"effectBurn": [
						null,
						"3/3.5/4/4.5/5",
						"25/35/45/55/65",
						"25",
						"60/100/140/180/220",
						"30/50/70/90/110",
						"5",
						"0",
						"2",
						"3/6/9/12/15",
						"2"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "Masochism.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "Sadism",
					"name": "Sadism",
					"description": "Dr. Mundo sacrifices a portion of his Health for increased Movement Speed and drastically increased Health Regeneration.",
					"tooltip": "Dr. Mundo regenerates <scaleHealth>{{ f1 }}</scaleHealth> Health ({{ e1 }}% of max health) over {{ e2 }} seconds, and gains {{ e3 }}% movement speed for the duration.",
					"leveltip": {
						"label": [
							"Regeneration",
							"Movement Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						85,
						70
					],
					"cooldownBurn": "100/85/70",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							40,
							50,
							60
						],
						[
							12,
							12,
							12
						],
						[
							15,
							25,
							35
						],
						[
							20,
							20,
							20
						],
						[
							0.015,
							0.015,
							0.015
						],
						[
							5,
							5,
							5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/50/60",
						"12",
						"15/25/35",
						"20",
						"0.01",
						"5",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "% of Current Health",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "Sadism.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e4 }}% of Current Health"
				}
			],
			"passive": {
				"name": "Adrenaline Rush",
				"description": "Dr. Mundo regenerates 0.3% of his maximum Health each second.",
				"image": {
					"full": "DrMundo_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "DrMundo",
					"title": "DrMundoARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "DrMundo",
					"title": "DrMundoCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "DrMundo",
					"title": "DrMundoFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "DrMundo",
					"title": "DrMundoKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "DrMundo",
					"title": "DrMundoSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "DrMundo",
					"title": "DrMundoSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "DrMundo",
					"title": "DrMundoTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Ekko": {
			"id": "Ekko",
			"key": "245",
			"name": "Ekko",
			"title": "the Boy Who Shattered Time",
			"image": {
				"full": "Ekko.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 144,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "245000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "245001",
					"num": 1,
					"name": "Sandstorm Ekko",
					"chromas": true
				},
				{
					"id": "245002",
					"num": 2,
					"name": "Academy Ekko",
					"chromas": false
				},
				{
					"id": "245003",
					"num": 3,
					"name": "PROJECT: Ekko",
					"chromas": false
				},
				{
					"id": "245011",
					"num": 11,
					"name": "SKT T1 Ekko",
					"chromas": false
				}
			],
			"lore": "A prodigy from the rough streets of Zaun, Ekko manipulates time to twist any situation to his advantage. Using his own invention, the Zero Drive, he explores the branching possibilities of reality to craft the perfect moment. Though he revels in this freedom, when there's a threat to his friends he'll do anything to defend them. To outsiders, Ekko seems to achieve the impossible the first time, every time.",
			"blurb": "A prodigy from the rough streets of Zaun, Ekko manipulates time to twist any situation to his advantage. Using his own invention, the Zero Drive, he explores the branching possibilities of reality to craft the perfect moment. Though he revels in this...",
			"allytips": [
				"Chronobreak is a potent escape tool, but it can also be quite powerful when used offensively. Don't underestimate its damage potential.",
				"If you can proc Z-Drive Resonance on an enemy champion, it's worth taking risks to do so. The bonus movement speed makes it easy to escape.",
				"Phase Dive's dash is a great tool for setting up Ekko's other abilities. Use it to get double hits with Timewinder or get into position to detonate Parallel Convergence."
			],
			"enemytips": [
				"Ekko is significantly weaker when his ultimate is down. Watch for the trail he leaves behind to determine if Chronobreak is available.",
				"Ekko's stun zone takes 3 seconds to arm. Watch for the image he creates on cast and try to guess where the zone was placed.",
				"The second hit of Timewinder does more damage than the first; try to avoid it."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 3,
				"magic": 7,
				"difficulty": 8
			},
			"stats": {
				"hp": 585,
				"hpperlevel": 85,
				"mp": 280,
				"mpperlevel": 50,
				"movespeed": 340,
				"armor": 32,
				"armorperlevel": 3,
				"spellblock": 32,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9,
				"hpregenperlevel": 0.9,
				"mpregen": 7,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.3
			},
			"spells": [
				{
					"id": "EkkoQ",
					"name": "Timewinder",
					"description": "Ekko throws a temporal grenade that expands into a time-distortion field upon hitting an enemy champion, slowing and damaging anyone caught inside. After a delay, the grenade rewinds back to Ekko, dealing damage on its return.",
					"tooltip": "Ekko throws a device that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies it passes through. It expands into a slowing field on the first champion hit, slowing everything inside by {{ e2 }}%. It then returns to him after a delay, dealing {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to all targets hit upon return.",
					"leveltip": {
						"label": [
							"Outgoing Damage",
							"Return Damage",
							"Slow",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8.5,
						8,
						7.5,
						7
					],
					"cooldownBurn": "9/8.5/8/7.5/7",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							60,
							75,
							90,
							105,
							120
						],
						[
							32,
							39,
							46,
							53,
							60
						],
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							165,
							165,
							165,
							165,
							165
						],
						[
							1.75,
							1.75,
							1.75,
							1.75,
							1.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/75/90/105/120",
						"32/39/46/53/60",
						"40/65/90/115/140",
						"100",
						"0",
						"165",
						"1.75",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "EkkoQ.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EkkoW",
					"name": "Parallel Convergence",
					"description": "Ekko splits the timeline, creating an anomaly after a few seconds that slows enemies caught inside. If Ekko enters the anomaly, he gains shielding and triggers a detonation, stunning enemies by suspending them in time.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Ekko's basic attacks deal bonus magic damage to enemies under 30% health equal to {{ e3 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> of their missing health. Deals a minimum of {{ e6 }} damage, and a maximum of {{ e5 }} damage vs. minions and monsters.<br /><br /><span class=\"colorFF9900\">Active:</span> After a 3 second delay, Ekko creates a short-lived chronosphere at the target location that slows enemies who enter by {{ e0 }}%. If Ekko enters the sphere, he will detonate it, gaining a shield that absorbs up to {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for 2 seconds. Enemies caught inside are stunned for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Shield Amount",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}<"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20,
						18,
						16,
						14
					],
					"cooldownBurn": "22/20/18/16/14",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							375,
							375,
							375,
							375,
							375
						],
						[
							1.75,
							1.75,
							1.75,
							1.75,
							1.75
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							80,
							100,
							120,
							140,
							160
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							40,
							40,
							40,
							40,
							40
						]
					],
					"effectBurn": [
						null,
						"375",
						"1.75",
						"3",
						"80/100/120/140/160",
						"150",
						"15",
						"1.5",
						"3",
						"2",
						"40"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.03,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 1.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1600,
						1600,
						1600,
						1600,
						1600
					],
					"rangeBurn": "1600",
					"image": {
						"full": "EkkoW.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EkkoE",
					"name": "Phase Dive",
					"description": "Ekko rolls evasively while charging up his Z-Drive. His next attack deals bonus damage and warps reality, teleporting him to his target.",
					"tooltip": " Ekko dashes a short distance in the targeted direction. His next attack will deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and teleport him to his target.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8.5,
						8,
						7.5,
						7
					],
					"cooldownBurn": "9/8.5/8/7.5/7",
					"cost": [
						40,
						50,
						60,
						70,
						80
					],
					"costBurn": "40/50/60/70/80",
					"effect": [
						null,
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							350,
							350,
							350,
							350,
							350
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/65/90/115/140",
						"350",
						"3",
						"300",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "EkkoE.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EkkoR",
					"name": "Chronobreak",
					"description": "Ekko shatters his timeline, becoming untargetable and rewinding to a more favorable point in time. He returns to whenever he was a few seconds ago, and heals for a percentage of the damage received in that duration. Enemies near his arrival zone take massive damage.",
					"tooltip": "Ekko turns back time, going briefly untargetable and invulnerable. He teleports to where he was 4 seconds ago and deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies on arrival. Additionally, Ekko heals for {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span>, increased by {{ e5 }}% for each 1% of his health lost over the last 4 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Flat Heal",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						90,
						70
					],
					"cooldownBurn": "110/90/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							300,
							450
						],
						[
							20,
							20,
							20
						],
						[
							100,
							150,
							200
						],
						[
							375,
							375,
							375
						],
						[
							3,
							3,
							3
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/300/450",
						"20",
						"100/150/200",
						"375",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "EkkoR.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Z-Drive Resonance",
				"description": "Ekko's Zero-Drive charges his spells and attacks with temporal energy. The third hit deals bonus damage and, if the target is a champion, Ekko gains accelerated movement speed.",
				"image": {
					"full": "Ekko_P.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ekko",
					"title": "Beginner",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ekko",
					"title": "EkkoTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Elise": {
			"id": "Elise",
			"key": "60",
			"name": "Elise",
			"title": "the Spider Queen",
			"image": {
				"full": "Elise.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 192,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "60000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "60001",
					"num": 1,
					"name": "Death Blossom Elise",
					"chromas": false
				},
				{
					"id": "60002",
					"num": 2,
					"name": "Victorious Elise",
					"chromas": false
				},
				{
					"id": "60003",
					"num": 3,
					"name": "Blood Moon Elise",
					"chromas": false
				},
				{
					"id": "60004",
					"num": 4,
					"name": "SKT T1 Elise",
					"chromas": false
				},
				{
					"id": "60005",
					"num": 5,
					"name": "Super Galaxy Elise",
					"chromas": false
				}
			],
			"lore": "Elise is a deadly predator who dwells in a shuttered, lightless palace, deep within the oldest city of Noxus. Once mortal, she was the mistress of a powerful house, but the bite of a vile demigod transformed her into something beautiful, yet utterly inhuman—a spider-like creature, drawing unsuspecting prey into her web. To maintain her eternal youth, Elise now prefers to feed upon the naive and the faithless, and there are few who can resist her seductions.",
			"blurb": "Elise is a deadly predator who dwells in a shuttered, lightless palace, deep within the oldest city of Noxus. Once mortal, she was the mistress of a powerful house, but the bite of a vile demigod transformed her into something beautiful, yet utterly...",
			"allytips": [
				"Spider Form is most effective at finishing off enemies with low health; Human Form's Neurotoxin does more damage to healthy foes. ",
				"When in Spider Form, Spiderlings will attack the target that Elise uses Venomous Bite on. ",
				"Elise's Spider Form and Spider Form abilities do not cost mana and can be prioritized when you are trying to conserve mana."
			],
			"enemytips": [
				"Elise's Spider Form is more dangerous when you are at low health, and her Human Form more potent when you are at high health.",
				"Rappel will only move Elise straight up and down unless she can descend upon an enemy unit.",
				"Rappel has a long cooldown. Elise is vulnerable after she has used it."
			],
			"tags": [
				"Mage",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 5,
				"magic": 7,
				"difficulty": 9
			},
			"stats": {
				"hp": 534,
				"hpperlevel": 85,
				"mp": 324,
				"mpperlevel": 50,
				"movespeed": 325,
				"armor": 27,
				"armorperlevel": 3.35,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.75
			},
			"spells": [
				{
					"id": "EliseHumanQ",
					"name": "Neurotoxin / Venomous Bite",
					"description": "Human Form: Deals damage based upon how high the target's Health is.<br><br>Spider Form: Lunges at an enemy and deals damage based upon how low their Health is.",
					"tooltip": "Deals magic damage equal to {{ e1 }} plus {{ e6 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of the target's current health. Maximum bonus against monsters: {{ e2 }}.",
					"leveltip": {
						"label": [
							"Neurotoxin Damage",
							"Venomous Bite Damage",
							"Max Damage to Monsters",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						80,
						85,
						90,
						95,
						100
					],
					"costBurn": "80/85/90/95/100",
					"effect": [
						null,
						[
							40,
							75,
							110,
							145,
							180
						],
						[
							75,
							100,
							125,
							150,
							175
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							36,
							42,
							48,
							54,
							60
						],
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/75/110/145/180",
						"75/100/125/150/175",
						"15/20/25/30/35",
						"36/42/48/54/60",
						"60/100/140/180/220",
						"4",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.03,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "EliseHumanQ.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EliseHumanW",
					"name": "Volatile Spiderling / Skittering Frenzy",
					"description": "Human Form: Releases a venom-gorged Spiderling that explodes when it nears a target.<br><br>Spider Form: Elise and her Spiderlings gain Attack Speed.",
					"tooltip": "Summons a venom-gorged Spiderling that moves to target location and explodes, dealing {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage when it nears an enemy or after 3 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							55,
							95,
							135,
							175,
							215
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							65,
							75,
							85,
							95,
							105
						],
						[
							275,
							275,
							275,
							275,
							275
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4",
						"60/80/100/120/140",
						"55/95/135/175/215",
						"3",
						"65/75/85/95/105",
						"275",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.95,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "EliseHumanW.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EliseHumanE",
					"name": "Cocoon / Rappel",
					"description": "Human Form: Stuns the first enemy unit hit and reveals them if they are not stealthed.<br><br>Spider Form: Elise and her Spiderlings ascend into the air and then descend upon target enemy.",
					"tooltip": "Stuns the first enemy hit for {{ e5 }} seconds and reveals them if they are not stealthed.",
					"leveltip": {
						"label": [
							"Stun Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							14,
							13,
							12,
							11,
							10
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							26,
							24,
							22,
							20,
							18
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1.6,
							1.7,
							1.8,
							1.9,
							2
						],
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"14/13/12/11/10",
						"15/20/25/30/35",
						"26/24/22/20/18",
						"2",
						"1.6/1.7/1.8/1.9/2",
						"40/55/70/85/100",
						"250",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "EliseHumanE.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EliseR",
					"name": "Spider Form",
					"description": "Transforms into a menacing spider, reducing her attack range in exchange for movement speed, new abilities, and a Spiderling swarm that will attack her foes.",
					"tooltip": "Elise transforms into a menacing spider, sacrificing 425 attack range in exchange for {{ e3 }} movement speed and access to arachnid abilities. All dormant Spiderlings are awakened and will attack nearby foes.<br /><br /><span class=\"colorFF3300\">Spiderlings: </span>Spiderlings deal {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage and take {{ e4 }}% reduced damage from multi-target abilities.",
					"leveltip": {
						"label": [
							"Spider Form Bite Damage",
							"Spiderling Bonus Damage",
							"Maximum Number of Spiderlings",
							"Spiderling Armor",
							"Spiderling Magic Resist"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e7 }} -> {{ e7NL }}"
						]
					},
					"maxrank": 4,
					"cooldown": [
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							10,
							15,
							20,
							25
						],
						[
							10,
							20,
							30,
							40
						],
						[
							25,
							25,
							25,
							25
						],
						[
							25,
							25,
							25,
							25
						],
						[
							2,
							3,
							4,
							5
						],
						[
							30,
							50,
							70,
							90
						],
						[
							50,
							70,
							90,
							110
						],
						[
							4,
							6,
							8,
							10
						],
						[
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/15/20/25",
						"10/20/30/40",
						"25",
						"25",
						"2/3/4/5",
						"30/50/70/90",
						"50/70/90/110",
						"4/6/8/10",
						"0.1",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "EliseR.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Spider Queen",
				"description": "Human Form: When Elise's abilities hit an enemy, she gains a dormant Spiderling.<br><br>Spider Form: Basic attacks deal bonus magic damage and restore health to Elise.",
				"image": {
					"full": "ElisePassive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Elise",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "ItemSmiteAoE",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Elise",
					"title": "EliseTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Evelynn": {
			"id": "Evelynn",
			"key": "28",
			"name": "Evelynn",
			"title": "Agony's Embrace",
			"image": {
				"full": "Evelynn.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 240,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "28000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "28001",
					"num": 1,
					"name": "Shadow Evelynn",
					"chromas": false
				},
				{
					"id": "28002",
					"num": 2,
					"name": "Masquerade Evelynn",
					"chromas": false
				},
				{
					"id": "28003",
					"num": 3,
					"name": "Tango Evelynn",
					"chromas": false
				},
				{
					"id": "28004",
					"num": 4,
					"name": "Safecracker Evelynn",
					"chromas": false
				}
			],
			"lore": "Within the dark seams of Runeterra, the demon Evelynn searches for her next victim. She lures in prey with the voluptuous façade of a human female, but once a person succumbs to her charms, Evelynn's true form is unleashed. She then subjects her victim to unspeakable torment, gratifying herself with their pain. To the demon, these liaisons are innocent flings. To the rest of Runeterra, they are ghoulish tales of lust gone awry and horrific reminders of the cost of wanton desire.",
			"blurb": "Within the dark seams of Runeterra, the demon Evelynn searches for her next victim. She lures in prey with the voluptuous façade of a human female, but once a person succumbs to her charms, Evelynn's true form is unleashed. She then subjects her victim...",
			"allytips": [
				"Allure's arm time might seem long, but the Charm and magic resist shred put Evelynn at an exteme advantage so are worth the wait.",
				"While stealthed, pay attention to when you are (near) being detected by enemy champions. This is identified by the glowing yellow and red eyes over nearby enemy champions.",
				"If at low health, you can take advantage of Demon Shade's healing and Camouflage to return to the fight and surprise opponents."
			],
			"enemytips": [
				"Purchasing Vision Wards can help you detect Evelynn's location in order to prepare for her ambushes.",
				"A large share of Evelynn's threat is in her charm, 'Allure.' Protect allies marked with 'Allure' or, if you are marked, make sure allies are between you and where Evelynn may attack from.",
				"If you suspect Evelynn is about to ambush one of your teammates, let them know by pinging the minimap and typing in chat."
			],
			"tags": [
				"Assassin",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 2,
				"magic": 7,
				"difficulty": 10
			},
			"stats": {
				"hp": 572,
				"hpperlevel": 84,
				"mp": 315.6,
				"mpperlevel": 42,
				"movespeed": 335,
				"armor": 37,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.75,
				"mpregen": 8.108,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.1
			},
			"spells": [
				{
					"id": "EvelynnQ",
					"name": "Hate Spike",
					"description": "Evelynn strikes out with her Lasher, dealing damage to the first unit hit. Then, Evelynn can shoot a line of spikes at nearby foes up to 3 times.",
					"tooltip": "Evelynn's Lasher strikes in the target direction, dealing {{ e5 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to the first unit hit and causing Evelynn's next 3 spells or attacks on that unit deal {{ e4 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> bonus magic damage. Then, Evelynn can recast this ability up to 3 times.<br /><br /><span class=\"colorFF9900\">Recast:</span> Fires spikes through the nearest enemy, dealing {{ e5 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to all units hit.<br /><br /><rules><span class=\"color8c8c8c\">Refunds {{ e1 }}% of Hate Spike's cooldown if the Lasher hits a monster. Hate Spike prioritizes the target Evelynn is attacking.</span></rules>",
					"leveltip": {
						"label": [
							"Lasher and Spike Damage",
							"Bonus Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							-0.25,
							-0.25,
							-0.25,
							-0.25,
							-0.25
						]
					],
					"effectBurn": [
						null,
						"60",
						"30",
						"60",
						"10/20/30/40/50",
						"25/30/35/40/45",
						"6",
						"30",
						"50",
						"8",
						"-0.25"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "EvelynnQ.png",
						"sprite": "spell2.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EvelynnW",
					"name": "Allure",
					"description": "Evelynn curses her target, causing her next attack or spell after a delay to charm her target and reduce their magic resist.",
					"tooltip": "Curses target champion or monster for 5 seconds. If Evelynn hits the target with a basic attack or ability, she will expunge the Curse, refund its mana cost, and briefly slow the target by {{ e3 }}%.<br /><br />If the Curse lasts at least 2.5 seconds, expunging it Charms the target for {{ e2 }} second(s) and: <li>Against champions: shreds Magic Resist by {{ e9 }}% for {{ e0 }} seconds.<br />Against monsters: deals {{ e7 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Charm duration increased by {{ e1 }} seconds.</li><br /><rules><span class=\"color8c8c8c\">Casting Allure does not remove Evelynn from Demon Shade.</span></rules>",
					"leveltip": {
						"label": [
							"Charm Duration",
							"Magic Resist Shred",
							"Monster Damage",
							"Cooldown",
							"Cast Range"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e9 }}% -> {{ e9NL }}%",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ f8 }} -> {{ f9 }}",
							"{{ castrange }} -> {{ castrangeNL }}\t"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							65,
							65,
							65,
							65,
							65
						],
						[
							15,
							14,
							13,
							12,
							11
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							250,
							300,
							350,
							400,
							450
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							25,
							27.5,
							30,
							32.5,
							35
						],
						[
							4,
							4,
							4,
							4,
							4
						]
					],
					"effectBurn": [
						null,
						"2",
						"1/1.25/1.5/1.75/2",
						"65",
						"15/14/13/12/11",
						"5",
						"1.5",
						"250/300/350/400/450",
						"0.75",
						"25/27.5/30/32.5/35",
						"4"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1300,
						1400,
						1500,
						1600
					],
					"rangeBurn": "1200/1300/1400/1500/1600",
					"image": {
						"full": "EvelynnW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EvelynnE",
					"name": "Whiplash",
					"description": "Evelynn whips her target with her Lasher, dealing damage. She then gains movement speed for a short duration.",
					"tooltip": "Whip target with Lashers, applying on hit effects and dealing magic damage equal to {{ f1 }} plus {{ e5 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of their max health. Then, gain {{ e3 }}% movement speed for {{ e4 }} seconds.<br /><br />Entering <span class=\"color9542f4\">Demon Shade</span> resets <span class=\"colorFFFFFF\"><i>Whiplash's</i></span> cooldown and empowers it. When empowered, <span class=\"colorFFFFFF\"><i>Whiplash</i></span> pulls Evelynn to her target, dealing magic damage to them and enemies in the way equal to {{ f2 }} plus {{ e6 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> of their max health.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Empowered Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							55,
							70,
							85,
							100,
							115
						],
						[
							95,
							115,
							135,
							155,
							175
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							0.5,
							0.6,
							0.7,
							0.8,
							0.9
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0.9,
							1.05,
							1.2,
							1.35,
							1.5
						]
					],
					"effectBurn": [
						null,
						"55/70/85/100/115",
						"95/115/135/155/175",
						"30",
						"2",
						"3",
						"4",
						"450",
						"0.5/0.6/0.7/0.8/0.9",
						"2",
						"0.9/1.05/1.2/1.35/1.5"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.4,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.015,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.025,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						210,
						210,
						210,
						210,
						210
					],
					"rangeBurn": "210",
					"image": {
						"full": "EvelynnE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EvelynnR",
					"name": "Last Caress",
					"description": "Evelynn briefly goes untargetable and decimates the area in front of her before warping backwards a long distance.",
					"tooltip": "Evelynn unleashes her demonic energy, becoming untargetable and decimating enemies in front of her. She then warps backwards. Deals {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage, increased to {{ f1 }}<span class=\"color99FF99\"> (+{{ f2 }})</span> to enemies below {{ e7 }}% health.",
					"leveltip": {
						"label": [
							"Damage",
							"Empowered Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						110,
						80
					],
					"cooldownBurn": "140/110/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							300,
							550,
							800
						],
						[
							1,
							1,
							1
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							150,
							225,
							300
						],
						[
							3,
							3,
							3
						],
						[
							5,
							4,
							3
						],
						[
							30,
							30,
							30
						],
						[
							700,
							700,
							700
						],
						[
							30,
							45,
							60
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"300/550/800",
						"1",
						"2.5",
						"150/225/300",
						"3",
						"5/4/3",
						"30",
						"700",
						"30/45/60",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "EvelynnR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Demon Shade",
				"description": "When out of combat, Evelynn enters Demon Shade. Demon Shade heals Evelynn when she is low on health and grants Camouflage after level 6.",
				"image": {
					"full": "Evelynn_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Evelynn",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standardjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "kingporosnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeoffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegedefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1082",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Evelynn",
					"title": "EvelynnTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Ezreal": {
			"id": "Ezreal",
			"key": "81",
			"name": "Ezreal",
			"title": "the Prodigal Explorer",
			"image": {
				"full": "Ezreal.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 288,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "81000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "81001",
					"num": 1,
					"name": "Nottingham Ezreal",
					"chromas": false
				},
				{
					"id": "81002",
					"num": 2,
					"name": "Striker Ezreal",
					"chromas": false
				},
				{
					"id": "81003",
					"num": 3,
					"name": "Frosted Ezreal",
					"chromas": false
				},
				{
					"id": "81004",
					"num": 4,
					"name": "Explorer Ezreal",
					"chromas": false
				},
				{
					"id": "81005",
					"num": 5,
					"name": "Pulsefire Ezreal",
					"chromas": false
				},
				{
					"id": "81006",
					"num": 6,
					"name": "TPA Ezreal",
					"chromas": false
				},
				{
					"id": "81007",
					"num": 7,
					"name": "Debonair Ezreal",
					"chromas": true
				},
				{
					"id": "81008",
					"num": 8,
					"name": "Ace of Spades Ezreal",
					"chromas": false
				},
				{
					"id": "81009",
					"num": 9,
					"name": "Arcade Ezreal",
					"chromas": false
				},
				{
					"id": "81018",
					"num": 18,
					"name": "Star Guardian Ezreal",
					"chromas": false
				}
			],
			"lore": "A self-assured Piltovan explorer with an uncanny ability to find his way into and out of trouble, Ezreal travels Runeterra in search of adventure. Armed with a magical gauntlet procured from the ruins of ancient Shurima, he seeks out the world's most cryptic mysteries. Ezreal fires bolts of mystic energy, shifting through treacherous, uncharted places with a cocky grin on his face.",
			"blurb": "A self-assured Piltovan explorer with an uncanny ability to find his way into and out of trouble, Ezreal travels Runeterra in search of adventure. Armed with a magical gauntlet procured from the ruins of ancient Shurima, he seeks out the world's most...",
			"allytips": [
				"Use Arcane Shift to help line up your other skill shots.",
				"You can play Ezreal either as a Attack Damage carry or Ability Power carry depending on how you build him.",
				"You can line up Trueshot Barrage to hit multiple minion waves or even Monsters."
			],
			"enemytips": [
				"Ezreal is a very fragile champion so take the fight to him.",
				"Ezreal is completely skill shot based, so make sure to keep minions in between you.",
				"Mystic Shot applies on-hit effects including the Crest of Cinders."
			],
			"tags": [
				"Marksman",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 2,
				"magic": 6,
				"difficulty": 7
			},
			"stats": {
				"hp": 484.4,
				"hpperlevel": 80,
				"mp": 360.6,
				"mpperlevel": 42,
				"movespeed": 325,
				"armor": 31,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6.5,
				"hpregenperlevel": 0.55,
				"mpregen": 8.092,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.5
			},
			"spells": [
				{
					"id": "EzrealMysticShot",
					"name": "Mystic Shot",
					"description": "Ezreal fires a damaging bolt of energy which reduces all of his cooldowns by 1.5 seconds if it strikes an enemy unit.",
					"tooltip": "Ezreal fires a bolt of energy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> physical damage (applies on-hit effects). <br /><br />Ezreal's cooldowns are reduced by {{ e2 }} seconds if Mystic Shot hits a target.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5.5,
						5.25,
						5,
						4.75,
						4.5
					],
					"cooldownBurn": "5.5/5.25/5/4.75/4.5",
					"cost": [
						28,
						31,
						34,
						37,
						40
					],
					"costBurn": "28/31/34/37/40",
					"effect": [
						null,
						[
							15,
							40,
							65,
							90,
							115
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/40/65/90/115",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.1,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1150,
						1150,
						1150,
						1150,
						1150
					],
					"rangeBurn": "1150",
					"image": {
						"full": "EzrealMysticShot.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EzrealEssenceFlux",
					"name": "Essence Flux",
					"description": "Ezreal fires a fluctuating wave of energy, dealing magic damage to enemy champions, while increasing the Attack Speed of allied champions.",
					"tooltip": "Ezreal fires a wave of energy that damages all enemy champions it passes through for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. If Ezreal or his Allied champions are hit by the wave, their Attack Speed is increased by {{ e2 }}% for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Speed",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }}% -> {{ e2NL }}%",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"20/25/30/35/40",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "EzrealEssenceFlux.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EzrealArcaneShift",
					"name": "Arcane Shift",
					"description": "Ezreal teleports to a target nearby location and fires a homing bolt which strikes the nearest enemy unit.",
					"tooltip": "Ezreal teleports to a nearby location and fires a bolt at the nearest enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						19,
						17.5,
						16,
						14.5,
						13
					],
					"cooldownBurn": "19/17.5/16/14.5/13",
					"cost": [
						90,
						90,
						90,
						90,
						90
					],
					"costBurn": "90",
					"effect": [
						null,
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/130/180/230/280",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						475,
						475,
						475,
						475,
						475
					],
					"rangeBurn": "475",
					"image": {
						"full": "EzrealArcaneShift.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EzrealTrueshotBarrage",
					"name": "Trueshot Barrage",
					"description": "Ezreal winds up for 1 second to fire a powerful barrage of energy missiles which do massive damage to each unit they pass through (deals 10% less damage to each unit it passes through).",
					"tooltip": "Ezreal winds up for 1 second to fire a long range missile that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to each enemy it passes through. Deals {{ e2 }}% less damage for each enemy hit (minimum {{ e3 }}%).",
					"leveltip": {
						"label": [
							"Damage"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						120,
						120
					],
					"cooldownBurn": "120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							350,
							500,
							650
						],
						[
							10,
							10,
							10
						],
						[
							30,
							30,
							30
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"350/500/650",
						"10",
						"30",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20000,
						20000,
						20000
					],
					"rangeBurn": "20000",
					"image": {
						"full": "EzrealTrueshotBarrage.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Rising Spell Force",
				"description": "Ezreal gains increasing Attack Speed each time he successfully hits a spell, stacking up to 5 times.",
				"image": {
					"full": "Ezreal_RisingSpellForce.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ezreal",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3008",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3008",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3008",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ezreal",
					"title": "EzrealTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3034",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Fiddlesticks": {
			"id": "Fiddlesticks",
			"key": "9",
			"name": "Fiddlesticks",
			"title": "the Harbinger of Doom",
			"image": {
				"full": "Fiddlesticks.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 336,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "9000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "9001",
					"num": 1,
					"name": "Spectral Fiddlesticks",
					"chromas": false
				},
				{
					"id": "9002",
					"num": 2,
					"name": "Union Jack Fiddlesticks",
					"chromas": false
				},
				{
					"id": "9003",
					"num": 3,
					"name": "Bandito Fiddlesticks",
					"chromas": false
				},
				{
					"id": "9004",
					"num": 4,
					"name": "Pumpkinhead Fiddlesticks",
					"chromas": false
				},
				{
					"id": "9005",
					"num": 5,
					"name": "Fiddle Me Timbers",
					"chromas": false
				},
				{
					"id": "9006",
					"num": 6,
					"name": "Surprise Party Fiddlesticks",
					"chromas": false
				},
				{
					"id": "9007",
					"num": 7,
					"name": "Dark Candy Fiddlesticks",
					"chromas": false
				},
				{
					"id": "9008",
					"num": 8,
					"name": "Risen Fiddlesticks",
					"chromas": false
				}
			],
			"lore": "Fiddlesticks is a ghastly, living scarecrow who stalks the darkness, wielding a cruel scythe and preying upon the unwary. Once a lonely man accused of bringing famine to his village, he was tied up and left to starve in his own barren field. Resurrected by the savage murder of crows that fed on his remains, Fiddlesticks now relishes terrorizing his victims before claiming their lives amid a flurry of feathers and blood-splattered beaks.",
			"blurb": "Fiddlesticks is a ghastly, living scarecrow who stalks the darkness, wielding a cruel scythe and preying upon the unwary. Once a lonely man accused of bringing famine to his village, he was tied up and left to starve in his own barren field. Resurrected...",
			"allytips": [
				"Use Dark Wind to rack up many minion kills, and try to use Drain on minions to get the maximum health drain.",
				"Use Terrify on enemies before starting up Crowstorm or Drain to ensure maximum damage.",
				"Fiddlesticks is very fragile if you build AP items. Try to strike a balance between offense and defense with runes, masteries, and items."
			],
			"enemytips": [
				"Avoid attacking while close to your allies. Dark Wind will bounce between you and your allies, increasing its damage.",
				"If Fiddlesticks has used Crowstorm, try casting a stun or slow and moving out of range until the spell dissipates.",
				"If Fiddlesticks is nowhere to be seen, watch out for an ambush Crowstorm from brush."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 3,
				"magic": 9,
				"difficulty": 9
			},
			"stats": {
				"hp": 524.4,
				"hpperlevel": 80,
				"mp": 400.12,
				"mpperlevel": 56,
				"movespeed": 335,
				"armor": 30,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 480,
				"hpregen": 5.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 48.36,
				"attackdamageperlevel": 2.625,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.11
			},
			"spells": [
				{
					"id": "Terrify",
					"name": "Terrify",
					"description": "Strikes a target unit with fear, causing it to flee in terror for a duration.",
					"tooltip": "Terrifies a target, causing it to flee from Fiddlesticks for {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						14,
						13,
						12,
						11
					],
					"cooldownBurn": "15/14/13/12/11",
					"cost": [
						65,
						65,
						65,
						65,
						65
					],
					"costBurn": "65",
					"effect": [
						null,
						[
							1.25,
							1.5,
							1.75,
							2,
							2.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.25/1.5/1.75/2/2.25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						575,
						575,
						575,
						575,
						575
					],
					"rangeBurn": "575",
					"image": {
						"full": "Terrify.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Drain",
					"name": "Drain",
					"description": "Fiddlesticks saps the life force of an enemy, dealing damage to a target over time and healing himself.",
					"tooltip": "Fiddlesticks creates a tether to the target unit and channels <span class=\"colorFFEB7F\">Drain</span> on it, granting <span class=\"coloree91d7\">True Sight</span> and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to the target. Fiddlesticks heals for {{ e3 }}% of the damage dealt.<br /><br /><span class=\"colorFFEB7F\">Drain</span> lasts up to {{ e4 }} seconds, dealing a total of {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> damage.<br /><br /><span class=\"size16 color8C8C8C\"><span class=\"size16 colorFFEB7F\">Drain</span> <span class=\"size16 color8C8C8C\">returns cooldown equal to its remaining duration if the target dies.</span>",
					"leveltip": {
						"label": [
							"Damage Per Second",
							"Cooldown",
							"Mana Cost",
							"Drain Ratio"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						3.75,
						3.5,
						3.25,
						3
					],
					"cooldownBurn": "4/3.75/3.5/3.25/3",
					"cost": [
						80,
						90,
						100,
						110,
						120
					],
					"costBurn": "80/90/100/110/120",
					"effect": [
						null,
						[
							80,
							105,
							130,
							155,
							180
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							60,
							65,
							70,
							75,
							80
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							650,
							650,
							650,
							650,
							650
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/105/130/155/180",
						"4",
						"60/65/70/75/80",
						"5",
						"650",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						575,
						575,
						575,
						575,
						575
					],
					"rangeBurn": "575",
					"image": {
						"full": "Drain.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FiddlesticksDarkWind",
					"name": "Dark Wind",
					"description": "A wisp of wind strikes an enemy unit and then bounces to nearby enemy units, dealing damage and silencing the victims.",
					"tooltip": "Unleashes a Crow at the targeted enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage before bouncing to another target. Units struck are also silenced for {{ e2 }} seconds the first time per cast.<br /><br />Dark Wind can strike up to {{ e3 }} times and will prioritize enemies being <span class=\"colorFFEB7F\">Drained</span> or ones it has not yet hit. Deals {{ e4 }}% damage to monsters.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							65,
							85,
							105,
							125,
							145
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/85/105/125/145",
						"1.25",
						"6",
						"200",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "FiddlesticksDarkWind.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Crowstorm",
					"name": "Crowstorm",
					"description": "A murder of crows flock wildly around Fiddlesticks, dealing damage per second to all enemy units in the area.",
					"tooltip": "Fiddlesticks channels for {{ e3 }} seconds, then blinks to the target point unleashing a murder of crows that flock wildly around him, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per second to all enemy units in the area.<br /><br />The effect lasts for {{ e2 }} seconds, dealing up to {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> total magic damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						110,
						80
					],
					"cooldownBurn": "140/110/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							125,
							225,
							325
						],
						[
							5,
							5,
							5
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"125/225/325",
						"5",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "Crowstorm.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Dread",
				"description": "Standing still or channeling abilities for 1.5 seconds empowers Fiddlesticks with Dread. Immobilizing crowd control resets this timer.<br><br>Dread grants Movement Speed, but only lasts for 1.5s after Fiddlesticks starts moving.",
				"image": {
					"full": "Fiddlesticks_Passive.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "FiddleSticks",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "FiddleSticks",
					"title": "FiddleARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiddlesticks",
					"title": "FiddlesticksCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "FiddleSticks",
					"title": "FiddleFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiddlesticks",
					"title": "FiddlesticksKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiddlesticks",
					"title": "FiddlesticksSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "FiddleSticks",
					"title": "FiddleSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "TeleportCancel",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "FiddleSticks",
					"title": "FiddleTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Fiora": {
			"id": "Fiora",
			"key": "114",
			"name": "Fiora",
			"title": "the Grand Duelist",
			"image": {
				"full": "Fiora.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 384,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "114000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "114001",
					"num": 1,
					"name": "Royal Guard Fiora",
					"chromas": false
				},
				{
					"id": "114002",
					"num": 2,
					"name": "Nightraven Fiora",
					"chromas": false
				},
				{
					"id": "114003",
					"num": 3,
					"name": "Headmistress Fiora",
					"chromas": true
				},
				{
					"id": "114004",
					"num": 4,
					"name": "PROJECT: Fiora",
					"chromas": false
				},
				{
					"id": "114005",
					"num": 5,
					"name": "Pool Party Fiora",
					"chromas": true
				},
				{
					"id": "114022",
					"num": 22,
					"name": "Soaring Sword Fiora",
					"chromas": false
				}
			],
			"lore": "The most feared duelist in all Valoran, Fiora is as renowned for her brusque manner and cunning mind as she is for the speed of her bluesteel rapier. Born to House Laurent in the kingdom of Demacia, Fiora took control of the family from her father in the wake of a scandal that nearly destroyed them. House Laurent's reputation was sundered, but Fiora bends her every effort to restore her family's honor and return them to their rightful place among the great and good of Demacia.",
			"blurb": "The most feared duelist in all Valoran, Fiora is as renowned for her brusque manner and cunning mind as she is for the speed of her bluesteel rapier. Born to House Laurent in the kingdom of Demacia, Fiora took control of the family from her father in...",
			"allytips": [
				"Thanks to Duelist's Dance, Fiora excels at quick trades. Use the movement speed boost from striking a Vital to escape unscathed or set up for the next one.",
				"Grand Challenge allows Fiora to take down even the most durable opponents and then recover if successful, so do not hesitate to attack the enemy's front line."
			],
			"enemytips": [
				"Duelist's Dance shows you where Fiora will try to attack from, so be ready to punish her when she tries.",
				"Be careful when casting immobilizing disables on Fiora. If her Riposte is available, she can turn their power against you."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 10,
				"defense": 4,
				"magic": 2,
				"difficulty": 3
			},
			"stats": {
				"hp": 550,
				"hpperlevel": 85,
				"mp": 300,
				"mpperlevel": 40,
				"movespeed": 345,
				"armor": 33,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 150,
				"hpregen": 8.5,
				"hpregenperlevel": 0.55,
				"mpregen": 8,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.2
			},
			"spells": [
				{
					"id": "FioraQ",
					"name": "Lunge",
					"description": "Fiora lunges in a direction and stabs a nearby enemy, dealing physical damage and applying on-hit effects.",
					"tooltip": "Fiora lunges in a direction and stabs a nearby enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and applying on-hit effects. This attack prioritizes <span class=\"colorD4BD22\">Vitals</span> and enemies it will kill.<br /><br />If this ability hits an enemy, {{ e4 }}% of its cooldown is refunded. ",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus AD Ratio",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }}  -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14,
						12,
						10,
						8
					],
					"cooldownBurn": "16/14/12/10/8",
					"cost": [
						20,
						25,
						30,
						35,
						40
					],
					"costBurn": "20/25/30/35/40",
					"effect": [
						null,
						[
							70,
							80,
							90,
							100,
							110
						],
						[
							0.95,
							1,
							1.05,
							1.1,
							1.15
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							90,
							120,
							150,
							180,
							210
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/80/90/100/110",
						"0.95/1/1.05/1.1/1.15",
						"50",
						"60",
						"2.5",
						"2",
						"90/120/150/180/210",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "FioraQ.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FioraW",
					"name": "Riposte",
					"description": "Fiora parries all incoming damage and disables for a short time, then stabs in a direction. This stab slows the first enemy champion hit, or stuns them if Fiora blocked an immobilizing effect with this ability.",
					"tooltip": "Fiora parries all incoming damage, debuffs, and disables for the next {{ e2 }} seconds and then stabs in the target direction.<br /><br />The stab deals {{ e1 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage to the first enemy champion hit and slows their movement and attack speed by {{ e4 }}% for {{ e3 }} seconds. <br /><br />If Fiora parries an immobilizing effect, Riposte stuns instead of slowing.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f2 }} -> {{ f3 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							90,
							130,
							170,
							210,
							250
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0.03,
							0.03,
							0.03,
							0.03,
							0.03
						],
						[
							0.15,
							0.15,
							0.15,
							0.15,
							0.25
						],
						[
							24,
							22,
							20,
							18,
							16
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"90/130/170/210/250",
						"0.75",
						"1.5",
						"50",
						"0.03",
						"0.15/0.15/0.15/0.15/0.25",
						"24/22/20/18/16",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "FioraW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FioraE",
					"name": "Bladework",
					"description": "Fiora has increased attack speed for the next two attacks. The first attack slows the target, and the second attack will critically strike.",
					"tooltip": "Fiora gains {{ e4 }}% attack speed for her next two attacks. The first attack cannot critically strike, but will apply a {{ e3 }}% slow for {{ e2 }} second. The second attack is guaranteed to critically strike for {{ f4 }}% damage <span class=\"colorFF8C00\">({{ f3 }})</span>.",
					"leveltip": {
						"label": [
							"Critical Strike Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ f4 }}%  -> {{ f5 }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						11,
						9,
						7,
						5
					],
					"cooldownBurn": "13/11/9/7/5",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							140,
							155,
							170,
							185,
							200
						],
						[
							5,
							10,
							15,
							20,
							25
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							10,
							12.5,
							15,
							17.5,
							20
						],
						[
							20,
							20,
							20,
							20,
							20
						]
					],
					"effectBurn": [
						null,
						"3",
						"1",
						"30",
						"50",
						"100",
						"140/155/170/185/200",
						"5/10/15/20/25",
						"40/50/60/70/80",
						"10/12.5/15/17.5/20",
						"20"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						425,
						425,
						425,
						425,
						425
					],
					"rangeBurn": "425",
					"image": {
						"full": "FioraE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FioraR",
					"name": "Grand Challenge",
					"description": "Fiora reveals all four Vitals on an enemy champion and gains movement speed while near them. If Fiora hits all 4 Vitals or if the target dies after she has hit at least one, Fiora and her allies in the area are healed over the next few seconds.",
					"tooltip": "Fiora reveals all four <span class=\"colorD4BD22\">Vitals</span> on target champion, for a potential <span class=\"colorFFFFFF\">{{ f8 }}%</span> max health true damage. In addition, Fiora gains Duelist's Dance's movement speed bonus <span class=\"colorFFFFFF\">({{ f6 }}%)</span> while near the target.<br /><br />If Fiora hits all 4 <span class=\"colorD4BD22\">Vitals</span> in {{ e1 }} seconds or if the target dies after she has hit at least one, Fiora and her allies in the area are healed for {{ e7 }} <span class=\"colorFF8C00\">(+{{ f9 }})</span> each second for between {{ e9 }} to {{ e6 }} seconds, scaling with the amount of Vitals hit.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Duelist Movement Speed",
							"Heal Per Second"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e7 }} -> {{ e7NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						90,
						70
					],
					"cooldownBurn": "110/90/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							8,
							8,
							8
						],
						[
							30,
							40,
							50
						],
						[
							0,
							0,
							0
						],
						[
							30,
							45,
							60
						],
						[
							500,
							500,
							500
						],
						[
							5,
							5,
							5
						],
						[
							80,
							110,
							140
						],
						[
							550,
							550,
							550
						],
						[
							2,
							2,
							2
						],
						[
							1,
							1,
							1
						]
					],
					"effectBurn": [
						null,
						"8",
						"30/40/50",
						"0",
						"30/45/60",
						"500",
						"5",
						"80/110/140",
						"550",
						"2",
						"1"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "FioraR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Duelist's Dance",
				"description": "Fiora challenges nearby enemy Champions to dodge her. She calls out a direction from which she will try to strike. If she can complete her own challenge, she receives a small bonus and calls out a new direction.",
				"image": {
					"full": "Fiora_P.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Fiora",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fiora",
					"title": "FioraTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Fizz": {
			"id": "Fizz",
			"key": "105",
			"name": "Fizz",
			"title": "the Tidal Trickster",
			"image": {
				"full": "Fizz.png",
				"sprite": "champion0.png",
				"group": "champion",
				"x": 432,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "105000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "105001",
					"num": 1,
					"name": "Atlantean Fizz",
					"chromas": false
				},
				{
					"id": "105002",
					"num": 2,
					"name": "Tundra Fizz",
					"chromas": false
				},
				{
					"id": "105003",
					"num": 3,
					"name": "Fisherman Fizz",
					"chromas": false
				},
				{
					"id": "105004",
					"num": 4,
					"name": "Void Fizz",
					"chromas": false
				},
				{
					"id": "105008",
					"num": 8,
					"name": "Cottontail Fizz",
					"chromas": false
				},
				{
					"id": "105009",
					"num": 9,
					"name": "Super Galaxy Fizz",
					"chromas": false
				},
				{
					"id": "105010",
					"num": 10,
					"name": "Omega Squad Fizz",
					"chromas": true
				}
			],
			"lore": "Fizz is an amphibious yordle, who dwells among the reefs surrounding Bilgewater. He often retrieves and returns the tithes cast into the sea by superstitious captains, but even the saltiest of sailors know better than to cross him—many are the tales of those who have underestimated this slippery character. Often mistaken for some manner of capricious ocean spirit, he commands the huge, carnivorous beasts of the deep, and delights in confounding his allies and enemies alike.",
			"blurb": "Fizz is an amphibious yordle, who dwells among the reefs surrounding Bilgewater. He often retrieves and returns the tithes cast into the sea by superstitious captains, but even the saltiest of sailors know better than to cross him—many are the tales of...",
			"allytips": [
				"Since Fizz can move through units, find opportunities in lane to walk through minions and apply Seastone Trident's passive - following it up with the ability's active attack after a few seconds.",
				"Fizz's ultimate ability, Chum the Waters, can be aimed at an enemy or towards the area where you think they'll be going.",
				"Fizz's spells scale off Ability Power - consider getting items like Zhonya's Hourglass or Banshee's Veil against teams that have high burst threat - and items like Lich Bane or Rabadon's Deathcap if you think you can survive without the Health."
			],
			"enemytips": [
				"Fizz becomes extremely deadly if his damage over time ability ticks on you for a few seconds - keep him away until it falls off!",
				"Fizz is a slippery target when his abilities are not on cooldown - bait him into using them early and follow up with crowd control or hard-hitting attacks!"
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 4,
				"magic": 7,
				"difficulty": 6
			},
			"stats": {
				"hp": 570,
				"hpperlevel": 98,
				"mp": 317.2,
				"mpperlevel": 37,
				"movespeed": 335,
				"armor": 22.412,
				"armorperlevel": 3.4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.7,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 58.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3.1
			},
			"spells": [
				{
					"id": "FizzQ",
					"name": "Urchin Strike",
					"description": "Fizz dashes through his target, dealing magic damage and applying on hit effects.",
					"tooltip": "Fizz dashes through his target, dealing <span class=\"colorFF8C00\">{{ a2 }}</span> physical damage plus {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. This spell applies on-hit effects. <br /><br /><span class=\"size16 colorFFEB7F\">Seastone Trident</span> <span class=\"size16 color8C8C8C\">is applied to all enemy units Fizz passes through during his dash.</span>",
					"leveltip": {
						"label": [
							"Magic Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7.5,
						7,
						6.5,
						6
					],
					"cooldownBurn": "8/7.5/7/6.5/6",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							10,
							25,
							40,
							55,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							650,
							750,
							850,
							950,
							1050
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.35,
							0.35,
							0.35,
							0.35,
							0.35
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/25/40/55/70",
						"0",
						"650/750/850/950/1050",
						"1.5",
						"600",
						"1",
						"0.35",
						"40",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.55,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "FizzQ.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FizzW",
					"name": "Seastone Trident",
					"description": "Fizz's attacks bleed his enemies, dealing magic damage over several seconds. Fizz can empower his next attack to deal bonus damage, increased by how long the bleed was active on his target.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Fizz's basic attacks bleed his enemies, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage over {{ e8 }} seconds. <br /><br /><span class=\"colorFF9900\">Active: </span>Fizz's next basic attack deals {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus magic damage. If the target has been bleeding for at least {{ e7 }} seconds, this bonus increases to {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span>. <br /><br /><span class=\"size16 color8C8C8C\">If the Active kills a target it refunds {{ e2 }} mana and resets its cooldown to {{ e0 }} second.</span>",
					"leveltip": {
						"label": [
							"Passive / Active Damage",
							"Charged Active Damage",
							"Cooldown",
							"Mana Cost",
							"Mana Refund"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9.5,
						9,
						8.5,
						8
					],
					"cooldownBurn": "10/9.5/9/8.5/8",
					"cost": [
						30,
						40,
						50,
						60,
						70
					],
					"costBurn": "30/40/50/60/70",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							20,
							28,
							36,
							42,
							50
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							750,
							750,
							750,
							750,
							750
						],
						[
							1,
							1,
							1,
							1,
							1
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"20/28/36/42/50",
						"60/90/120/150/180",
						"6",
						"2",
						"4",
						"2",
						"3",
						"750",
						"1"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 1.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "FizzW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FizzE",
					"name": "Playful / Trickster",
					"description": "Fizz hops into the air, landing gracefully upon his spear and becoming untargetable. From this position, Fizz can either slam the ground or choose to jump again before smashing back down.",
					"tooltip": "Fizz hops on his trident towards the cursor, becoming briefly untargetable.<br /><br /><span class=\"colorFF9900\">Reactivation: </span>Fizz cancels the spell early, jumping towards the cursor a second time and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies.<br /><br />If Fizz does not reactivate, he deals damage in a larger area and slows all enemies hit by {{ e2 }}% for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Percentage",
							"Mana Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14.5,
						13,
						11.5,
						10
					],
					"cooldownBurn": "16/14.5/13/11.5/10",
					"cost": [
						90,
						95,
						100,
						105,
						110
					],
					"costBurn": "90/95/100/105/110",
					"effect": [
						null,
						[
							70,
							120,
							170,
							220,
							270
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							375,
							375,
							375,
							375,
							375
						],
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/120/170/220/270",
						"40/45/50/55/60",
						"225",
						"2",
						"375",
						"80",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "FizzE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "FizzR",
					"name": "Chum the Waters",
					"description": "Fizz tosses a fish in a direction that attaches to any champion that touches it, slowing the target. After a short delay, a shark erupts from the ground, knocking up the target and knocking any nearby enemies aside. All enemies hit are dealt magic damage and slowed.",
					"tooltip": "Fizz launches a fish that attaches to the first enemy champion it hits, slowing them, granting <span class=\"coloree91d7\">True Sight</span>, and attracting a shark. After {{ e8 }} seconds, the shark erupts out of the ground, knocking its target up and knocking other enemies aside.<br /><br />The farther the fish travels before attaching, the bigger the shark it attracts, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and slowing by 40% to 80%.<br /><br /><span class=\"size16 colorFFEB7F\">Seastone Trident</span> <span class=\"size16 color8C8C8C\">applies to the champion the fish attaches to and targets hit by the shark.",
					"leveltip": {
						"label": [
							"Small Shark Damage",
							"Medium Shark Damage",
							"Big Shark Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} ->{{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						85,
						70
					],
					"cooldownBurn": "100/85/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							225,
							325,
							425
						],
						[
							300,
							400,
							500
						],
						[
							200,
							200,
							200
						],
						[
							325,
							325,
							325
						],
						[
							450,
							450,
							450
						],
						[
							1300,
							1300,
							1300
						],
						[
							2,
							2,
							2
						],
						[
							2,
							2,
							2
						],
						[
							60,
							60,
							60
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"225/325/425",
						"300/400/500",
						"200",
						"325",
						"450",
						"1300",
						"2",
						"2",
						"60"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 1.2,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1300,
						1300,
						1300
					],
					"rangeBurn": "1300",
					"image": {
						"full": "FizzR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Nimble Fighter",
				"description": "Fizz's dexterity allows him to move through units and take less physical damage from basic attacks.",
				"image": {
					"full": "Fizz_P.png",
					"sprite": "passive0.png",
					"group": "passive",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Fizz",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3100",
									"count": 1
								},
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1414",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Fizz",
					"title": "FizzTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Galio": {
			"id": "Galio",
			"key": "3",
			"name": "Galio",
			"title": "the Colossus",
			"image": {
				"full": "Galio.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 0,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "3000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "3001",
					"num": 1,
					"name": "Enchanted Galio",
					"chromas": false
				},
				{
					"id": "3002",
					"num": 2,
					"name": "Hextech Galio",
					"chromas": false
				},
				{
					"id": "3003",
					"num": 3,
					"name": "Commando Galio",
					"chromas": false
				},
				{
					"id": "3004",
					"num": 4,
					"name": "Gatekeeper Galio",
					"chromas": false
				},
				{
					"id": "3005",
					"num": 5,
					"name": "Debonair Galio",
					"chromas": false
				}
			],
			"lore": "Outside the gleaming city of Demacia, the stone colossus Galio keeps vigilant watch. Built as a bulwark against enemy mages, he often stands motionless for decades until the presence of powerful magic stirs him to life. Once activated, Galio makes the most of his time, savoring the thrill of a fight and the rare honor of defending his countrymen. But his triumphs are always bittersweet, for the magic he destroys is also his source of reanimation, and each victory leaves him dormant once again.",
			"blurb": "Outside the gleaming city of Demacia, the stone colossus Galio keeps vigilant watch. Built as a bulwark against enemy mages, he often stands motionless for decades until the presence of powerful magic stirs him to life. Once activated, Galio makes the...",
			"allytips": [
				"You can release Shield of Durand even while crowd controlled.",
				"You can use the minimap ally icons to cast Hero's Entrance.",
				"You can use the step back from Justice Punch to dodge enemy spells."
			],
			"enemytips": [
				"Galio moves slower when he is charging Shield of Durand.",
				"Hero's Entrance can be interrupted before Galio jumps into the air.",
				"Galio cannot traverse walls with Justice Punch."
			],
			"tags": [
				"Tank",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 10,
				"magic": 6,
				"difficulty": 5
			},
			"stats": {
				"hp": 562,
				"hpperlevel": 112,
				"mp": 400,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 24,
				"armorperlevel": 3.5,
				"spellblock": 32,
				"spellblockperlevel": 1.25,
				"attackrange": 150,
				"hpregen": 8,
				"hpregenperlevel": 0.8,
				"mpregen": 7,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 59,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.5
			},
			"spells": [
				{
					"id": "GalioQ",
					"name": "Winds of War",
					"description": "Galio fires two windblasts that converge into a large tornado.",
					"tooltip": "Galio fires two windblasts that deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />When the windblasts meet, they combine into a giant tornado that deals {{ e5 }} <span class=\"color99FF99\">(+{{ charabilitypower2.0*3 }})</span> plus <span class=\"color99FF99\">(+{{ f9 }})</span>% of enemies' maximum Health (max {{ e4 }} vs. monsters) as magic damage over {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Windblast Damage",
							"Tornado Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							50,
							80,
							110,
							140,
							170
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							30,
							40.002,
							50.001,
							60,
							70.002
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/80/110/140/170",
						"1",
						"1.5",
						"150",
						"30/40.002/50.001/60/70.002",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						825,
						825,
						825,
						825,
						825
					],
					"rangeBurn": "825",
					"image": {
						"full": "GalioQ.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GalioW",
					"name": "Shield of Durand",
					"description": "Galio charges a defensive stance, moving slowly. Upon releasing the charge, Galio will taunt and damage nearby enemies.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> After not taking damage for {{ e6 }} seconds Galio gains a shield that absorbs <span class=\"colorFF0000\">{{ f3 }}</span> magic damage.<br /><br /><span class=\"colorFF9900\">First Cast:</span> Galio starts to charge, gaining {{ e1 }} <span class=\"colorFF00FF\">(+{{ f2 }})</span><span class=\"color99FF99\">(+{{ f4 }})</span>% Damage Reduction from Magic Damage and {{ f5 }}% of that amount as Damage Reduction from Physical Damage. While charging, Galio slows himself by {{ e3 }}%.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Galio taunts nearby enemy champions for {{ e4 }} to {{ e7 }} seconds, deals {{ f8 }} <span class=\"color99FF99\">(+{{ f9 }})</span> to {{ f10 }} <span class=\"color99FF99\">(+{{ f11 }})</span> damage, and refreshes the Damage Reduction for {{ e8 }} seconds. Taunt duration, damage, and radius increase with charge time.<br /><br /><span class=\"colorDDDD77\">Shield of Durand's charge cannot be interrupted by crowd control.</span>",
					"leveltip": {
						"label": [
							"Shield Health Ratio",
							"Magic Damage Reduction",
							"Physical Damage Reduction",
							"Cooldown",
							"Max Damage"
						],
						"effect": [
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ f6 }}% -> {{ f7 }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ f10 }} -> {{ f12 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							8,
							11,
							14,
							17,
							20
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							5,
							5,
							5,
							5,
							5
						]
					],
					"effectBurn": [
						null,
						"20/25/30/35/40",
						"2",
						"30",
						"0.5",
						"8/11/14/17/20",
						"12",
						"1.5",
						"2",
						"1.25",
						"5"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						275,
						275,
						275,
						275,
						275
					],
					"rangeBurn": "275",
					"image": {
						"full": "GalioW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GalioE",
					"name": "Justice Punch",
					"description": "Galio will briefly step back and charge, knocking up the first enemy champion he encounters.",
					"tooltip": "Galio lunges forward with a mighty blow, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies and knocking them into the air for {{ e2 }} seconds. Galio will stop upon hitting a champion or terrain.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							100,
							130,
							160,
							190,
							220
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/130/160/190/220",
						"0.75",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "GalioE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GalioR",
					"name": "Hero's Entrance",
					"description": "Galio grants damage reduction to an ally. After a delay Galio smashes down on the ally's original location, knocking up nearby enemies.",
					"tooltip": "Galio designates an allied champion's current position as his landing spot and grants {{ e5 }} <span class=\"colorFF00FF\">(+{{ f2 }})</span>% damage reduction to that ally until he lands. <br /><br />When Galio lands, enemies in the area take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are knocked into the air for {{ e3 }} seconds ({{ e2 }} seconds in the center).",
					"leveltip": {
						"label": [
							"Damage",
							"Damage Reduction to Ally",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ e8 }} -> {{ e8NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						180,
						150,
						120
					],
					"cooldownBurn": "180/150/120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							1.25,
							1.25,
							1.25
						],
						[
							0.75,
							0.75,
							0.75
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							20,
							25,
							30
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							4000,
							4750,
							5500
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"1.25",
						"0.75",
						"2.5",
						"20/25/30",
						"0",
						"0",
						"4000/4750/5500",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						4000,
						4750,
						5500
					],
					"rangeBurn": "4000/4750/5500",
					"image": {
						"full": "GalioR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Colossal Smash",
				"description": "<mainText>Every few seconds, Galio's next basic attack deals bonus magic damage in an area. Colossal Smash's cooldown is reduced when Galio hits champions with his spells.</mainText>",
				"image": {
					"full": "Galio_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Galio",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Galio",
					"title": "GalioTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Gangplank": {
			"id": "Gangplank",
			"key": "41",
			"name": "Gangplank",
			"title": "the Saltwater Scourge",
			"image": {
				"full": "Gangplank.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 48,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "41000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "41001",
					"num": 1,
					"name": "Spooky Gangplank",
					"chromas": false
				},
				{
					"id": "41002",
					"num": 2,
					"name": "Minuteman Gangplank",
					"chromas": false
				},
				{
					"id": "41003",
					"num": 3,
					"name": "Sailor Gangplank",
					"chromas": false
				},
				{
					"id": "41004",
					"num": 4,
					"name": "Toy Soldier Gangplank",
					"chromas": false
				},
				{
					"id": "41005",
					"num": 5,
					"name": "Special Forces Gangplank",
					"chromas": false
				},
				{
					"id": "41006",
					"num": 6,
					"name": "Sultan Gangplank",
					"chromas": false
				},
				{
					"id": "41007",
					"num": 7,
					"name": "Captain Gangplank",
					"chromas": false
				},
				{
					"id": "41008",
					"num": 8,
					"name": "Dreadnova Gangplank",
					"chromas": true
				}
			],
			"lore": "As unpredictable as he is brutal, the dethroned reaver king Gangplank is feared far and wide. Once, he ruled the port city of Bilgewater, and while his reign is over, there are those who believe this has only made him more dangerous. Gangplank would see Bilgewater bathed in blood once more before letting someone else take it—and now with pistol, cutlass, and barrels of gunpowder, he is determined to reclaim what he has lost.",
			"blurb": "As unpredictable as he is brutal, the dethroned reaver king Gangplank is feared far and wide. Once, he ruled the port city of Bilgewater, and while his reign is over, there are those who believe this has only made him more dangerous. Gangplank would see...",
			"allytips": [
				"Parrrley applies On Hit effects like Frozen Mallet or Black Cleaver.",
				"Paying attention to low-health enemies on the map can land you a surprise kill with Cannon Barrage.",
				"Try placing Cannon Barrage on the path of escape to cut off fleeing enemies."
			],
			"enemytips": [
				"Parrrley deals a high amount of physical damage. Items that grant Armor can help if an enemy Gangplank is doing well.",
				"Once Gangplank reaches level 6, watch out for his global-range ultimate, Cannon Barrage!"
			],
			"tags": [
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 6,
				"magic": 4,
				"difficulty": 9
			},
			"stats": {
				"hp": 540,
				"hpperlevel": 82,
				"mp": 282,
				"mpperlevel": 40,
				"movespeed": 345,
				"armor": 35,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 6,
				"hpregenperlevel": 0.6,
				"mpregen": 7.5,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.2
			},
			"spells": [
				{
					"id": "GangplankQWrapper",
					"name": "Parrrley",
					"description": "Shoots target, plundering Gold for each enemy unit killed.",
					"tooltip": "Fires a bullet that deals {{ e1 }} (<span class=\"colorFF8C00\">+{{ a1 }}</span>) physical damage (can crit and applies on-hit effects).<br /><br />If Parrrley kills the target, Gangplank plunders <span class=\"colorFFDD00\">{{ e2 }}</span> bonus Gold and <span class=\"colorFFDD00\">{{ e5 }}</span> <span class=\"colorffd700\">Silver Serpents</span>. (Trade <span class=\"colorffd700\">Silver Serpents</span> at the shop to upgrade Cannon Barrage).<br /><br />",
					"leveltip": {
						"label": [
							"Damage",
							"Plunder Gold",
							"Plunder Silver Serpents",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						5,
						5,
						5,
						5
					],
					"cooldownBurn": "5",
					"cost": [
						60,
						55,
						50,
						45,
						40
					],
					"costBurn": "60/55/50/45/40",
					"effect": [
						null,
						[
							20,
							45,
							70,
							95,
							120
						],
						[
							3,
							4,
							5,
							6,
							7
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							500,
							500,
							500,
							500,
							500
						],
						[
							4,
							5,
							6,
							7,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/45/70/95/120",
						"3/4/5/6/7",
						"0",
						"500",
						"4/5/6/7/8",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "GangplankQWrapper.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GangplankW",
					"name": "Remove Scurvy",
					"description": "Eats citrus to cure crowd control effects and restore Health.",
					"tooltip": "Gangplank consumes a large quantity of citrus fruit, curing all disabling effects and healing him for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> + <span class=\"colorCC3300\">{{ e2 }}% of his missing Health</span>.",
					"leveltip": {
						"label": [
							"Healing",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20,
						18,
						16,
						14
					],
					"cooldownBurn": "22/20/18/16/14",
					"cost": [
						80,
						90,
						100,
						110,
						120
					],
					"costBurn": "80/90/100/110/120",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"15",
						"0.25",
						"200",
						"30/40/50/60/70",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "GangplankW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GangplankE",
					"name": "Powder Keg",
					"description": "Gangplank uncovers a powder keg at target location. If he attacks it, it explodes, spreading the attack's damage to enemies in the area, slowing them.",
					"tooltip": "Places a powder keg that can be attacked by Gangplank or his enemies at a location for {{ e5 }} seconds.<br /><br />If Gangplank destroys a keg, it explodes dealing <span class=\"colorFF8C00\">the attack's damage</span> as physical damage (ignores {{ e0 }}% Armor) to enemies and slowing them by {{ e4 }}% for {{ e2 }} seconds. Champions take {{ e3 }} bonus physical damage from the explosion.<br /><br />When a keg explodes, other kegs with overlapping blast zones chain explode (damage does not stack).<br /><br />Kegs health decays every {{ f5 }} seconds. (Decay rate increases at level 7 and 13)<br /><br /><span class=\"colorffd700\">Keg explosions apply Parrrley's plunder effect.</span>",
					"leveltip": {
						"label": [
							"Barrel Ammo Charge",
							"Slow",
							"Bonus Damage Against Champions"
						],
						"effect": [
							"{{ f2 }} -> {{ f3 }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e3 }} -> {{ e3NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							40,
							40,
							40,
							40,
							40
						]
					],
					"effectBurn": [
						null,
						"3",
						"2",
						"60/90/120/150/180",
						"40/50/60/70/80",
						"25",
						"2",
						"10",
						"100",
						"0.5",
						"40"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "3",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "GangplankE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GangplankR",
					"name": "Cannon Barrage",
					"description": "Gangplank signals his ship to bombard an area, slowing and damaging enemies.",
					"tooltip": "Signals Gangplank's ship to fire {{ f3 }} waves of cannonballs at an area over {{ e3 }} seconds. Each wave deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slows enemies by {{ e2 }}% for {{ e6 }} seconds.<br /><br /><span class=\"colorffd700\">Collect Silver Serpents with Parrrley to upgrade in the shop.</span>",
					"leveltip": {
						"label": [
							"Damage Per Wave",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						180,
						160,
						140
					],
					"cooldownBurn": "180/160/140",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							35,
							60,
							85
						],
						[
							30,
							30,
							30
						],
						[
							8,
							8,
							8
						],
						[
							2,
							2,
							2
						],
						[
							1.5,
							0.5,
							0.5
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							300,
							300,
							300
						],
						[
							60,
							60,
							60
						],
						[
							1,
							1,
							1
						],
						[
							30,
							30,
							30
						]
					],
					"effectBurn": [
						null,
						"35/60/85",
						"30",
						"8",
						"2",
						"1.5/0.5/0.5",
						"0.5",
						"300",
						"60",
						"1",
						"30"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						30000,
						30000,
						30000
					],
					"rangeBurn": "30000",
					"image": {
						"full": "GangplankR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Trial by Fire",
				"description": "Every few seconds, Gangplank's melee strike will set his opponent on fire.",
				"image": {
					"full": "Gangplank_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Gangplank",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "Map12",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "GangplankCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "GangplankFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "GangplankKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "GangplankSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "GangplankSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gangplank",
					"title": "GangplankTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3902",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3903",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3901",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Garen": {
			"id": "Garen",
			"key": "86",
			"name": "Garen",
			"title": "The Might of Demacia",
			"image": {
				"full": "Garen.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 96,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "86000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "86001",
					"num": 1,
					"name": "Sanguine Garen",
					"chromas": false
				},
				{
					"id": "86002",
					"num": 2,
					"name": "Desert Trooper Garen",
					"chromas": false
				},
				{
					"id": "86003",
					"num": 3,
					"name": "Commando Garen",
					"chromas": false
				},
				{
					"id": "86004",
					"num": 4,
					"name": "Dreadknight Garen",
					"chromas": false
				},
				{
					"id": "86005",
					"num": 5,
					"name": "Rugged Garen",
					"chromas": false
				},
				{
					"id": "86006",
					"num": 6,
					"name": "Steel Legion Garen",
					"chromas": false
				},
				{
					"id": "86010",
					"num": 10,
					"name": "Rogue Admiral Garen",
					"chromas": false
				},
				{
					"id": "86011",
					"num": 11,
					"name": "Warring Kingdoms Garen",
					"chromas": true
				}
			],
			"lore": "A proud and noble warrior, Garen fights as one of the Dauntless Vanguard. He is popular among his fellows, and respected well enough by his enemies—not least as a scion of the prestigious Crownguard family, entrusted with defending Demacia and its ideals. Clad in magic-resistant armor and bearing a mighty broadsword, Garen stands ready to confront mages and sorcerers on the field of battle, in a veritable whirlwind of righteous steel.",
			"blurb": "A proud and noble warrior, Garen fights as one of the Dauntless Vanguard. He is popular among his fellows, and respected well enough by his enemies—not least as a scion of the prestigious Crownguard family, entrusted with defending Demacia and its...",
			"allytips": [
				"Garen's regeneration greatly increases if he can avoid receiving damage for several seconds.",
				"Judgment deals maximum damage when only hitting a single target. For effective trading, try to position such that only the enemy champion is hit.",
				"Garen is only constrained by cooldowns, making items such as Black Cleaver very effective for him."
			],
			"enemytips": [
				"Stack armor items to lower the large amount of physical damage that Garen deals out.",
				"Try to run away from Garen as your health gets lower, as he can execute you quickly with Demacian Justice.",
				"Be careful about attacking Garen in brush. It often will lead to taking full damage from Judgment.",
				"Judgment deals maximum damage when only hitting a single target. If getting out of its radius isn't possible, move through allied minions to reduce damage taken."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "None",
			"info": {
				"attack": 7,
				"defense": 7,
				"magic": 1,
				"difficulty": 5
			},
			"stats": {
				"hp": 616.28,
				"hpperlevel": 84.25,
				"mp": 0,
				"mpperlevel": 0,
				"movespeed": 340,
				"armor": 36,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.5,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 4.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.9
			},
			"spells": [
				{
					"id": "GarenQ",
					"name": "Decisive Strike",
					"description": "Garen gains a burst of movement speed, breaking free of all slows affecting him. His next attack strikes a vital area of his foe, dealing bonus damage and silencing them.",
					"tooltip": "Garen breaks free from all slows affecting him, and gains {{ e2 }}% movement speed for {{ e4 }} seconds.<br /><br />His next basic attack within {{ e5 }} seconds deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and silences his target for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Movement Speed Duration"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							30,
							55,
							80,
							105,
							130
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1.5,
							2,
							2.5,
							3,
							3.5
						],
						[
							4.5,
							4.5,
							4.5,
							4.5,
							4.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/55/80/105/130",
						"30",
						"1.5",
						"1.5/2/2.5/3/3.5",
						"4.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.4,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "GarenQ.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GarenW",
					"name": "Courage",
					"description": "Garen passively increases his armor and magic resist by killing enemies. He may also activate this ability to give him a huge burst of Tenacity and damage reduction for a brief moment followed by a lesser amount of damage reduction for a longer duration.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Killing units permanently grants {{ f2 }} armor and magic resist, up to a maximum of {{ e2 }}. Current Bonus: <span class=\"colorFFFFFF\">{{ f1 }}</span><br /><br /><span class=\"colorFF9900\">Active: </span>Garen steels his courage for {{ e4 }} seconds. For the first {{ e7 }} seconds, he takes {{ e6 }}% less damage and gains {{ e5 }}% Tenacity. For the remaining duration, he takes {{ e3 }}% less damage.",
					"leveltip": {
						"label": [
							"Total Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						23,
						22,
						21,
						20
					],
					"cooldownBurn": "24/23/22/21/20",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							2,
							3,
							4,
							5,
							6
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0.25",
						"30",
						"30",
						"2/3/4/5/6",
						"60",
						"60",
						"0.75",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "GarenW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GarenE",
					"name": "Judgment",
					"description": "Garen performs a dance of death with his sword, dealing damage around him for the duration and shredding the armor of enemy champions hit.",
					"tooltip": "Garen rapidly spins his sword around his body for {{ e2 }} seconds, dealing {{ f3 }} physical damage to nearby enemies -- {{ e1 }} plus {{ e3 }}% of his attack damage <span class=\"colorFF8C00\">(+{{ f1 }})</span>, <span class=\"colorFFFFFF\">{{ f2 }}</span> times (increased by 1 every 3 champion levels) -- over the duration.<br /><br />Enemy champions hit by {{ e6 }} spins lose {{ e5 }}% of their armor for {{ e7 }} seconds.<br /><br /><span class=\"color99FF99\">Judgment deals {{ e4 }}% increased damage when striking only one enemy.<br />Cancelling Judgment returns cooldown equal to the remaining duration.<br /><span class=\"color99FF99\">Judgment can critically strike for bonus damage.</span>",
					"leveltip": {
						"label": [
							"Base Damage per hit",
							"Total Attack Damage Ratio per hit"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							14,
							18,
							22,
							26,
							30
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							36,
							37,
							38,
							39,
							40
						],
						[
							33,
							33,
							33,
							33,
							33
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"14/18/22/26/30",
						"3",
						"36/37/38/39/40",
						"33",
						"25",
						"4",
						"6",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "GarenE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GarenR",
					"name": "Demacian Justice",
					"description": "The enemy champion with the most recent kills is the Villain. Garen's attacks deal additional true damage to that champion.<br><br>Garen can call upon the might of Demacia to deal a finishing blow to an enemy champion that deals damage based upon how much health his target has missing. This damage is true damage against the Villain.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> The enemy champion with the most recent kills is the <span class=\"colorFFF673\">Villain</span>. Judgment and basic attacks against it deal an additional {{ e3 }}% of its maximum health as true damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Garen calls upon the might of Demacia to attempt to execute an enemy champion, dealing magic damage equal to {{ e1 }} plus {{ e2 }}% of the target's missing health. Deals true damage to the <span class=\"colorFFF673\">Villain</span>.",
					"leveltip": {
						"label": [
							"Damage",
							"Missing Health Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							175,
							350,
							525
						],
						[
							28,
							33,
							40
						],
						[
							1,
							1,
							1
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"175/350/525",
						"28/33/40",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "GarenR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Perseverance",
				"description": "If Garen has not recently been struck by damage or enemy abilities, he regenerates a percentage of his total health each second. Minion damage does not stop Perseverance.",
				"image": {
					"full": "Garen_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Garen",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenBT",
					"map": "SR",
					"mode": "TUTORIAL",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Garen",
					"title": "GarenTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Gnar": {
			"id": "Gnar",
			"key": "150",
			"name": "Gnar",
			"title": "the Missing Link",
			"image": {
				"full": "Gnar.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 144,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "150000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "150001",
					"num": 1,
					"name": "Dino Gnar",
					"chromas": true
				},
				{
					"id": "150002",
					"num": 2,
					"name": "Gentleman Gnar",
					"chromas": false
				},
				{
					"id": "150003",
					"num": 3,
					"name": "Snow Day Gnar",
					"chromas": false
				},
				{
					"id": "150004",
					"num": 4,
					"name": "El León Gnar",
					"chromas": false
				},
				{
					"id": "150013",
					"num": 13,
					"name": "Super Galaxy Gnar",
					"chromas": false
				}
			],
			"lore": "Gnar is a primeval yordle whose playful antics can erupt into a toddler's outrage in an instant, transforming him into a massive beast bent on destruction. Frozen in True Ice for millennia, the curious creature broke free and now hops about a changed world he sees as exotic and wondrous. Delighted by danger, Gnar flings whatever he can at his enemies, be it his bonetooth boomerang, or a nearby building.",
			"blurb": "Gnar is a primeval yordle whose playful antics can erupt into a toddler's outrage in an instant, transforming him into a massive beast bent on destruction. Frozen in True Ice for millennia, the curious creature broke free and now hops about a changed...",
			"allytips": [
				"Managing your Rage is very important. Try to time out your transformations so you can get maximum benefit from both forms.",
				"Position yourself next to walls to bait your enemies into getting stunned by your ultimate.",
				"Know your strengths! Mini Gnar is fast, squishy, and has high sustained damage. Mega Gnar is slow, tough, and has high burst."
			],
			"enemytips": [
				"Gnar can't gain Rage for 15 seconds after he turns from big to little. Use this chance to engage on his team.",
				"Gnar's animations and resource bar change as he gets closer to transforming.  ",
				"Gnar's ultimate stuns if he hits you into a wall. Be careful when fighting him near one."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Rage",
			"info": {
				"attack": 6,
				"defense": 5,
				"magic": 5,
				"difficulty": 8
			},
			"stats": {
				"hp": 510,
				"hpperlevel": 65,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 325,
				"armor": 32,
				"armorperlevel": 2.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 175,
				"hpregen": 4.5,
				"hpregenperlevel": 1.75,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 59,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 6
			},
			"spells": [
				{
					"id": "GnarQ",
					"name": "Boomerang Throw / Boulder Toss",
					"description": "Gnar throws a boomerang that damages and slows enemies it hits before returning to him. If he catches the boomerang its cooldown is reduced.<br><br>Mega Gnar instead throws a boulder that stops on the first unit hit, damaging and slowing everything nearby. It can then be picked up to reduce the cooldown.",
					"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span>Throws a boomerang that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slows enemies by {{ e3 }}% for {{ e4 }} seconds. The boomerang returns towards Gnar after hitting an enemy, dealing {{ e7 }}% damage to subsequent targets. Each enemy can only be hit once. Catching the boomerang reduces its cooldown by {{ f1 }}%.<br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Throws a boulder that stops when it hits an enemy, slowing all nearby enemies and dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage. Picking up the boulder reduces its cooldown by {{ e6 }}%.",
					"leveltip": {
						"label": [
							"Boomerang Damage",
							"Boulder Damage",
							"Slow Amount",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						17.5,
						15,
						12.5,
						10
					],
					"cooldownBurn": "20/17.5/15/12.5/10",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							5,
							45,
							85,
							125,
							165
						],
						[
							5,
							45,
							85,
							125,
							165
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							3000,
							3000,
							3000,
							3000,
							3000
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							280,
							280,
							280,
							280,
							280
						]
					],
					"effectBurn": [
						null,
						"5/45/85/125/165",
						"5/45/85/125/165",
						"15/20/25/30/35",
						"2",
						"3000",
						"60",
						"50",
						"200",
						"6",
						"280"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.15,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 1.2,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "GnarQ.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GnarW",
					"name": "Hyper / Wallop",
					"description": "Gnar's attacks and spells hype him up, dealing bonus damage and granting him Movement Speed.<br><br>Mega Gnar is too enraged to be hyper and instead can rear up on his hind legs and smash down on the area in front of him, stunning enemies in an area.",
					"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span><span class=\"colorFF9900\">Passive:</span> Every 3rd attack or spell on the same target deals an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }}) </span>+ {{ e2 }}% of the target's max Health as magic damage and grants Gnar {{ f1 }}% Movement Speed that decays over 3 seconds (max {{ e4 }} damage vs. monsters). <br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Stuns enemies in an area for {{ e5 }} seconds, dealing {{ e3 }}<span class=\"colorFF8C00\"> (+{{ a2 }})</span> physical damage.<br /><br />Gnar gains Hyper's Movement Speed bonus when he leaves Mega form.",
					"leveltip": {
						"label": [
							"Hyper Damage",
							"Hyper % Health Damage",
							"Hyper Max Damage to monsters",
							"Wallop Damage",
							"Wallop Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						13,
						11,
						9,
						7
					],
					"cooldownBurn": "15/13/11/9/7",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							6,
							8,
							10,
							12,
							14
						],
						[
							25,
							45,
							65,
							85,
							105
						],
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							550,
							550,
							550,
							550,
							550
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/20/30/40/50",
						"6/8/10/12/14",
						"25/45/65/85/105",
						"100/150/200/250/300",
						"1.25",
						"3.5",
						"3",
						"550",
						"200",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						0,
						0,
						0,
						0,
						0
					],
					"rangeBurn": "0",
					"image": {
						"full": "GnarW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GnarE",
					"name": "Hop / Crunch",
					"description": "Gnar leaps to a location and bounces off the head of any unit he lands on, traveling further.<br><br>Mega Gnar is too large to bounce and instead lands with earth-shattering force, dealing damage in an area around him.",
					"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span>Leaps to a location, gaining {{ e2 }}% Attack Speed for 3 seconds. If Gnar lands on a unit he will bounce off it, traveling further. Deals {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [6% of Gnar's Max Health]</span> physical damage and slows briefly if the unit landed on was an enemy.<br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Leaps to a location and deals {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [6% of Gnar's Max Health]</span> physical damage to nearby enemies on landing. Enemies Gnar lands directly on top of are slowed briefly.<br /><br />If Crunch is used to transform, Gnar will still be able to bounce.",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						19.5,
						17,
						14.5,
						12
					],
					"cooldownBurn": "22/19.5/17/14.5/12",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							50,
							85,
							120,
							155,
							190
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							-0.8,
							-0.8,
							-0.8,
							-0.8,
							-0.8
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							475,
							475,
							475,
							475,
							475
						],
						[
							525,
							525,
							525,
							525,
							525
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							375,
							375,
							375,
							375,
							375
						]
					],
					"effectBurn": [
						null,
						"50/85/120/155/190",
						"20/30/40/50/60",
						"600",
						"-0.8",
						"0.5",
						"475",
						"525",
						"200",
						"0.6",
						"375"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						475,
						475,
						475,
						475,
						475
					],
					"rangeBurn": "475",
					"image": {
						"full": "GnarE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "GnarR",
					"name": "GNAR!",
					"description": "Mega Gnar throws everything around him in a chosen direction, dealing damage and slowing them.  Any enemy that hits a wall is stunned and takes bonus damage.",
					"tooltip": "<span class=\"color33FF33\">Mini Gnar: </span><span class=\"colorFF9900\">Passive:</span> Increases Hyper's Movement Speed bonus to {{ e2 }}%.<br /><br /><span class=\"colorFF3300\">Mega Gnar: </span>Knocks nearby enemies in the specified direction, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> physical damage and slowing them by {{ e8 }}% for {{ e3 }} seconds. Enemies that hit a wall take {{ e7 }}% damage and are stunned instead of slowed.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow/Stun Duration",
							"Hyper Movement Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							200,
							300,
							400
						],
						[
							45,
							60,
							75
						],
						[
							1.25,
							1.5,
							1.75
						],
						[
							40,
							40,
							40
						],
						[
							475,
							475,
							475
						],
						[
							500,
							500,
							500
						],
						[
							150,
							150,
							150
						],
						[
							45,
							45,
							45
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/300/400",
						"45/60/75",
						"1.25/1.5/1.75",
						"40",
						"475",
						"500",
						"150",
						"45",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						590,
						590,
						590
					],
					"rangeBurn": "590",
					"image": {
						"full": "GnarR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Rage Gene",
				"description": "While in combat Gnar generates Rage. At maximum Rage his next ability will transform him into Mega Gnar, granting increased survivability and access to new spells.",
				"image": {
					"full": "Gnar_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Gnar",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gnar",
					"title": "GnarTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Gragas": {
			"id": "Gragas",
			"key": "79",
			"name": "Gragas",
			"title": "the Rabble Rouser",
			"image": {
				"full": "Gragas.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 192,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "79000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "79001",
					"num": 1,
					"name": "Scuba Gragas",
					"chromas": false
				},
				{
					"id": "79002",
					"num": 2,
					"name": "Hillbilly Gragas",
					"chromas": false
				},
				{
					"id": "79003",
					"num": 3,
					"name": "Santa Gragas",
					"chromas": false
				},
				{
					"id": "79004",
					"num": 4,
					"name": "Gragas, Esq.",
					"chromas": false
				},
				{
					"id": "79005",
					"num": 5,
					"name": "Vandal Gragas",
					"chromas": false
				},
				{
					"id": "79006",
					"num": 6,
					"name": "Oktoberfest Gragas",
					"chromas": false
				},
				{
					"id": "79007",
					"num": 7,
					"name": "Superfan Gragas",
					"chromas": false
				},
				{
					"id": "79008",
					"num": 8,
					"name": "Fnatic Gragas",
					"chromas": false
				},
				{
					"id": "79009",
					"num": 9,
					"name": "Gragas Caskbreaker",
					"chromas": false
				},
				{
					"id": "79010",
					"num": 10,
					"name": "Arctic Ops Gragas",
					"chromas": false
				}
			],
			"lore": "Equal parts jolly and imposing, Gragas is a massive, rowdy brewmaster on his own quest for the perfect pint of ale. Hailing from parts unknown, he now searches for rare ingredients among the unblemished wastes of the Freljord, trying each recipe as he goes. Often intoxicated and extremely impulsive, he is legendary for the brawls he starts, which often end in all-night parties and widespread property damage. Any appearance from Gragas must surely foreshadow drinking and destruction—in that order.",
			"blurb": "Equal parts jolly and imposing, Gragas is a massive, rowdy brewmaster on his own quest for the perfect pint of ale. Hailing from parts unknown, he now searches for rare ingredients among the unblemished wastes of the Freljord, trying each recipe as he...",
			"allytips": [
				"The damage reduction from Drunken Rage is applied when you start drinking, try to use it when you see damage coming your way.",
				"Try to knock enemies back into your towers with Explosive Cask.",
				"Try to combo Body Slam with Explosive Cask to set up kills for your team."
			],
			"enemytips": [
				"Gragas can knock everybody away with his ultimate. Be careful that you don't get knocked into him or, worse, an enemy tower.",
				"Body Slam is on a very low cooldown, making it difficult to pursue Gragas. Don't overextend yourself chasing him."
			],
			"tags": [
				"Fighter",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 7,
				"magic": 6,
				"difficulty": 5
			},
			"stats": {
				"hp": 583.52,
				"hpperlevel": 89,
				"mp": 400,
				"mpperlevel": 47,
				"movespeed": 330,
				"armor": 35,
				"armorperlevel": 3.6,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 5.5,
				"hpregenperlevel": 0.5,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61.38,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.05
			},
			"spells": [
				{
					"id": "GragasQ",
					"name": "Barrel Roll",
					"description": "Gragas rolls his cask to a location, which can be activated to explode or will explode on its own after 4 seconds. Enemies struck by the blast have their Movement Speed slowed.",
					"tooltip": "Gragas rolls his cask to a location. When reactivated, or after {{ e4 }} seconds, the cask will explode, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and slowing their movement speed by {{ e2 }}% for {{ e3 }} seconds.<br /><br />The damage and slow amount increase as the cask ferments, up to {{ e6 }}% after {{ e5 }} seconds. Deals {{ e7 }}% damage to minions.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow %",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10,
						9,
						8,
						7
					],
					"cooldownBurn": "11/10/9/8/7",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"40/45/50/55/60",
						"2",
						"4",
						"2",
						"150",
						"70",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "GragasQ.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GragasW",
					"name": "Drunken Rage",
					"description": "Gragas guzzles down brew from his cask for 1 second. After finishing, he becomes drunkenly empowered, dealing magic damage to all nearby enemies on his next basic attack and reducing damage received.",
					"tooltip": "Gragas guzzles down his brew, taking {{ e1 }}% reduced damage for {{ e5 }} seconds.<br /><br />After finishing his drink, his next basic attack deals magic damage to nearby enemies equal to {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> plus {{ e2 }}% of their max Health (max {{ e4 }} vs monsters).",
					"leveltip": {
						"label": [
							"Damage Reduction",
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7,
						6,
						5,
						4
					],
					"cooldownBurn": "8/7/6/5/4",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							10,
							12,
							14,
							16,
							18
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							20,
							50,
							80,
							110,
							140
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/12/14/16/18",
						"8",
						"20/50/80/110/140",
						"300",
						"2.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "GragasW.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GragasE",
					"name": "Body Slam",
					"description": "Gragas charges to a location and collides with the first enemy unit he comes across, dealing damage to all nearby enemy units and stunning them.",
					"tooltip": "Gragas charges forward, colliding with the first enemy unit. He deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the area and bumps them back, stunning them for {{ e2 }} second.<br /><br />Body Slam's Cooldown is reduced by {{ f1 }} seconds if Gragas collides with a unit.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/130/180/230/280",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "GragasE.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GragasR",
					"name": "Explosive Cask",
					"description": "Gragas hurls his cask to a location, dealing damage and knocking back enemies caught in the blast radius.",
					"tooltip": "Gragas hurls his cask, causing it to explode when it lands. Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are knocked away from the explosion.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							200,
							300,
							400
						],
						[
							900,
							900,
							900
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/300/400",
						"900",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "GragasR.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Happy Hour",
				"description": "On ability use, Gragas takes a drink restoring 6% of his max Health. This effect can only happen every 8 seconds.",
				"image": {
					"full": "GragasPassiveHeal.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Gragas",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumable",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Gragas",
					"title": "GragasTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Graves": {
			"id": "Graves",
			"key": "104",
			"name": "Graves",
			"title": "the Outlaw",
			"image": {
				"full": "Graves.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 240,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "104000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "104001",
					"num": 1,
					"name": "Hired Gun Graves",
					"chromas": false
				},
				{
					"id": "104002",
					"num": 2,
					"name": "Jailbreak Graves",
					"chromas": false
				},
				{
					"id": "104003",
					"num": 3,
					"name": "Mafia Graves",
					"chromas": false
				},
				{
					"id": "104004",
					"num": 4,
					"name": "Riot Graves",
					"chromas": false
				},
				{
					"id": "104005",
					"num": 5,
					"name": "Pool Party Graves",
					"chromas": true
				},
				{
					"id": "104006",
					"num": 6,
					"name": "Cutthroat Graves",
					"chromas": false
				},
				{
					"id": "104007",
					"num": 7,
					"name": "Snow Day Graves",
					"chromas": false
				},
				{
					"id": "104014",
					"num": 14,
					"name": "Victorious Graves",
					"chromas": true
				}
			],
			"lore": "Malcolm Graves is a renowned mercenary, gambler, and thief—a wanted man in every city and empire he has visited. Even though he has an explosive temper, he possesses a strict sense of criminal honor, often enforced at the business end of his double-barreled shotgun Destiny. In recent years, he has reconciled a troubled partnership with Twisted Fate, and together they have prospered once more in the turmoil of Bilgewater's criminal underbelly.",
			"blurb": "Malcolm Graves is a renowned mercenary, gambler, and thief—a wanted man in every city and empire he has visited. Even though he has an explosive temper, he possesses a strict sense of criminal honor, often enforced at the business end of his...",
			"allytips": [
				"Smoke Screen can be used both to escape and to set up a kill.",
				"Using Quickdraw to get into range and delivering a point blank Buckshot can do lots of damage."
			],
			"enemytips": [
				"Graves deals mostly physical damage so Armor is an effective counter.",
				"Leaving the Smoke Screen's area of effect removes the harmful effect immediately."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 3,
				"difficulty": 3
			},
			"stats": {
				"hp": 551.12,
				"hpperlevel": 84,
				"mp": 322.2,
				"mpperlevel": 40,
				"movespeed": 340,
				"armor": 33,
				"armorperlevel": 3.4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 425,
				"hpregen": 8,
				"hpregenperlevel": 0.7,
				"mpregen": 7.9,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 69,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": 0.3,
				"attackspeedperlevel": 2.6
			},
			"spells": [
				{
					"id": "GravesQLineSpell",
					"name": "End of the Line",
					"description": "Graves fires an explosive shell that detonates after 2 seconds, or 0.2 seconds if it strikes terrain.",
					"tooltip": "Fires a powder round that deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ f1 }})</span> physical damage to enemies in a line.<br /><br />After 2 seconds or {{ e6 }} seconds on collision with terrain, the round detonates, dealing {{ e2 }}<span class=\"colorFF8C00\"> (+{{ f2 }})</span> physical damage to all nearby enemies.",
					"leveltip": {
						"label": [
							"Damage",
							"Detonation AD Ratio",
							"Mana Cost",
							"Cooldown "
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }} / {{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							45,
							60,
							75,
							90,
							105
						],
						[
							85,
							115,
							145,
							175,
							205
						],
						[
							0.4,
							0.7,
							1,
							1.3,
							1.6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.2,
							0.2,
							0.2,
							0.2,
							0.2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"45/60/75/90/105",
						"85/115/145/175/205",
						"0.4/0.7/1/1.3/1.6",
						"0",
						"1",
						"0.2",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "GravesQLineSpell.png",
						"sprite": "spell3.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GravesSmokeGrenade",
					"name": "Smoke Screen",
					"description": "Graves fires a smoke canister at the target area creating a cloud of smoke that reduces sight range. Enemies caught in the initial impact are dealt magic damage and have their movement speed reduced briefly.",
					"tooltip": "Creates a cloud of Black Smoke lasting 4 seconds. Enemies inside Black Smoke cannot see out.<br /><br />Enemies caught in the initial impact are dealt {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and have their movement speed reduced by {{ e2 }}% for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						26,
						24,
						22,
						20,
						18
					],
					"cooldownBurn": "26/24/22/20/18",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/110/160/210/260",
						"50",
						"200",
						"4",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "GravesSmokeGrenade.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GravesMove",
					"name": "Quickdraw",
					"description": "Graves dashes forward gaining an Armor boost for several seconds. If Graves dashes towards an enemy champion, gain two stacks of True Grit instead. Hitting enemies with basic attacks lowers the cooldown of this skill and refreshes the resistance boost. ",
					"tooltip": "Dashes in a direction, reloading one shell. Graves gains <span class=\"colorFFF673\">True Grit</span> for 4 seconds. If Graves dashes towards an enemy champion, gain two stacks of <span class=\"colorFFF673\">True Grit</span> instead. <br /><br />Basic attack hits lower the cooldown of Quickdraw by {{ e4 }} seconds. Damage against non-minions also refreshes <span class=\"colorFFF673\">True Grit</span>.<br /><br /><span class=\"colorFFF673\">True Grit</span> grants {{ e5 }} Armor (stacks up to {{ e0 }} times).",
					"leveltip": {
						"label": [
							"True Grit Armor",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							5,
							7.5,
							10,
							12.5,
							15
						],
						[
							750,
							750,
							750,
							750,
							750
						],
						[
							375,
							375,
							375,
							375,
							375
						],
						[
							275,
							275,
							275,
							275,
							275
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							8,
							8,
							8,
							8,
							8
						]
					],
					"effectBurn": [
						null,
						"30/40/50/60/70",
						"4",
						"20/25/30/35/40",
						"0.5",
						"5/7.5/10/12.5/15",
						"750",
						"375",
						"275",
						"60",
						"8"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						425,
						425,
						425,
						425,
						425
					],
					"rangeBurn": "425",
					"image": {
						"full": "GravesMove.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "GravesChargeShot",
					"name": "Collateral Damage",
					"description": "Graves fires an explosive shell dealing heavy damage to the first champion it hits. After hitting a champion or reaching the end of its range, the shell explodes dealing damage in a cone. ",
					"tooltip": "Fires an explosive shell with such force that it knocks Graves back. The shell deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ f1 }})</span> physical damage to the first enemy hit. After hitting an enemy Champion or reaching the end of its range, the shell explodes, dealing {{ e2 }}<span class=\"colorFF8C00\"> (+{{ f2 }})</span> physical damage in a cone.",
					"leveltip": {
						"label": [
							"Primary Damage",
							"Cone Damage",
							"Cooldown "
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							250,
							400,
							550
						],
						[
							200,
							320,
							440
						],
						[
							400,
							400,
							400
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250/400/550",
						"200/320/440",
						"400",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "GravesChargeShot.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "New Destiny",
				"description": "Graves's shotgun holds two shells. After firing them he must reload. Each attack fires several bullets in a cone. Hitting an enemy with multiple bullets does bonus damage. These bullets cannot pass through units.",
				"image": {
					"full": "GravesTrueGrit.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Graves",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Graves",
					"title": "GravesTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Hecarim": {
			"id": "Hecarim",
			"key": "120",
			"name": "Hecarim",
			"title": "the Shadow of War",
			"image": {
				"full": "Hecarim.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 288,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "120000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "120001",
					"num": 1,
					"name": "Blood Knight Hecarim",
					"chromas": false
				},
				{
					"id": "120002",
					"num": 2,
					"name": "Reaper Hecarim",
					"chromas": false
				},
				{
					"id": "120003",
					"num": 3,
					"name": "Headless Hecarim",
					"chromas": false
				},
				{
					"id": "120004",
					"num": 4,
					"name": "Arcade Hecarim",
					"chromas": false
				},
				{
					"id": "120005",
					"num": 5,
					"name": "Elderwood Hecarim",
					"chromas": false
				},
				{
					"id": "120006",
					"num": 6,
					"name": "Worldbreaker Hecarim",
					"chromas": false
				},
				{
					"id": "120007",
					"num": 7,
					"name": "Lancer Zero Hecarim",
					"chromas": false
				}
			],
			"lore": "Hecarim is a spectral fusion of man and beast, cursed to ride down the souls of the living for all eternity. When the Blessed Isles fell into shadow, this proud knight was obliterated by the destructive energies of the Ruination, along with all his cavalry and their mounts. Now, whenever the Black Mist reaches out across Runeterra, he leads their devastating charge, reveling in the slaughter and crushing the foe beneath his armored hooves.",
			"blurb": "Hecarim is a spectral fusion of man and beast, cursed to ride down the souls of the living for all eternity. When the Blessed Isles fell into shadow, this proud knight was obliterated by the destructive energies of the Ruination, along with all his...",
			"allytips": [
				"Spirit of Dread restores Health when nearby enemies take damage, including damage dealt by allies. Cast this during a large fight to maximize Hecarim's survivability.",
				"Devastating Charge deals more damage based on the distance traveled. Try using Onslaught of Shadows or Summoner Spells such as Ghost or Flash to maximize this damage."
			],
			"enemytips": [
				"Hecarim gains life from nearby enemies with Spirit of Dread but lacks durability, use burst damage.",
				"Hecarim's ultimate causes opponents to flee in terror. Spread out to reduce his power in fights."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 6,
				"magic": 4,
				"difficulty": 6
			},
			"stats": {
				"hp": 580,
				"hpperlevel": 90,
				"mp": 277.2,
				"mpperlevel": 40,
				"movespeed": 345,
				"armor": 36,
				"armorperlevel": 4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 7,
				"hpregenperlevel": 0.75,
				"mpregen": 6.5,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.0672,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "HecarimRapidSlash",
					"name": "Rampage",
					"description": "Hecarim cleaves nearby enemies dealing physical damage. ",
					"tooltip": "Hecarim cleaves nearby enemies for {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage. ({{ e5 }}% damage to minions)<br /><br />If Hecarim damages at least one enemy with this attack he gains a stack of Rampage, reducing the base cooldown of this skill by {{ e3 }} second for a short duration. This effect can stack up to {{ e2 }} times.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						32,
						34,
						36,
						38,
						40
					],
					"costBurn": "32/34/36/38/40",
					"effect": [
						null,
						[
							55,
							90,
							125,
							160,
							195
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							66,
							66,
							66,
							66,
							66
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/90/125/160/195",
						"2",
						"1",
						"3",
						"66",
						"6",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "HecarimRapidSlash.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "HecarimW",
					"name": "Spirit of Dread",
					"description": "Hecarim deals magic damage to nearby enemies for a short duration. Hecarim gains Health equal to a percentage of any damage those enemies suffer.",
					"tooltip": "Hecarim deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e3 }} seconds to all nearby enemies. Hecarim is healed for {{ e1 }}% of the damage these enemies take from any source.<br /><br />Hecarim cannot heal more than {{ e4 }} Health from minions or monsters.",
					"leveltip": {
						"label": [
							"Damage",
							"Healing Cap",
							"Cooldown",
							"Mana Cost "
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						21,
						20,
						19,
						18
					],
					"cooldownBurn": "22/21/20/19/18",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							90,
							120,
							150,
							180,
							210
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20",
						"80/120/160/200/240",
						"4",
						"90/120/150/180/210",
						"8",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						575,
						575,
						575,
						575,
						575
					],
					"rangeBurn": "575",
					"image": {
						"full": "HecarimW.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "HecarimRamp",
					"name": "Devastating Charge",
					"description": "Hecarim gains increasing Movement Speed and can move through units for a short duration. His next attack knocks the target back and deals additional physical damage based on the distance he has traveled since activating the ability. ",
					"tooltip": "Hecarim gains increasing Movement Speed and can move through units for {{ e5 }} seconds. His next attack knocks the target back dealing {{ e4 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> to {{ e3 }}<span class=\"colorFF8C00\"> (+{{ a2 }})</span> physical damage based on how far Hecarim has traveled during Devastating Charge (knockback distance also scales).<br /><br /><rules>Devastating Charge's remaining duration pauses during Onslaught of Shadows.</rules>",
					"leveltip": {
						"label": [
							"Minimum Damage",
							"Maximum Damage",
							"Cooldown"
						],
						"effect": [
							" {{ e4 }} -> {{ e4NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						22,
						20,
						18,
						16
					],
					"cooldownBurn": "24/22/20/18/16",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							90,
							160,
							230,
							300,
							370
						],
						[
							45,
							80,
							115,
							150,
							185
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							1200,
							1200,
							1200,
							1200,
							1200
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250",
						"450",
						"90/160/230/300/370",
						"45/80/115/150/185",
						"4",
						"0.75",
						"1200",
						"0.25",
						"2.5",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "HecarimRamp.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "HecarimUlt",
					"name": "Onslaught of Shadows",
					"description": "Hecarim summons spectral riders and charges forward, dealing magic damage in a line. Hecarim creates a shockwave when he finishes his charge, causing nearby enemies to flee in terror.",
					"tooltip": "Hecarim summons spectral riders and charges forward, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies hit. <br /><br />Hecarim releases a shockwave at the end of his charge, causing nearby enemies to flee from him for {{ e2 }} to {{ e3 }} seconds (increases by charge distance).<br /><br /><rules>Hecarim himself will only move to the targeted location. The riders will always move the full distance.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						120,
						100
					],
					"cooldownBurn": "140/120/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							0.75,
							0.75,
							0.75
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							1100,
							1100,
							1100
						],
						[
							1000,
							1000,
							1000
						],
						[
							950,
							950,
							950
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"0.75",
						"1.5",
						"1100",
						"1000",
						"950",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						50000,
						50000,
						50000
					],
					"rangeBurn": "50000",
					"image": {
						"full": "HecarimUlt.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Warpath",
				"description": "Hecarim gains Attack Damage equal to a percentage of his bonus Movement Speed.",
				"image": {
					"full": "Hecarim_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Hecarim",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1054",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1054",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "3044",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3009",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3044",
									"count": 1
								},
								{
									"id": "3057",
									"count": 1
								},
								{
									"id": "3086",
									"count": 1
								},
								{
									"id": "3078",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3065",
									"count": 1
								},
								{
									"id": "3071",
									"count": 1
								},
								{
									"id": "3068",
									"count": 1
								},
								{
									"id": "3105",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "Map12",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "HecarimCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "HecarimFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "HecarimKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "HecarimSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "HecarimSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Hecarim",
					"title": "HecarimTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Heimerdinger": {
			"id": "Heimerdinger",
			"key": "74",
			"name": "Heimerdinger",
			"title": "the Revered Inventor",
			"image": {
				"full": "Heimerdinger.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 336,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "74000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "74001",
					"num": 1,
					"name": "Alien Invader Heimerdinger",
					"chromas": false
				},
				{
					"id": "74002",
					"num": 2,
					"name": "Blast Zone Heimerdinger",
					"chromas": false
				},
				{
					"id": "74003",
					"num": 3,
					"name": "Piltover Customs Heimerdinger",
					"chromas": false
				},
				{
					"id": "74004",
					"num": 4,
					"name": "Snowmerdinger",
					"chromas": false
				},
				{
					"id": "74005",
					"num": 5,
					"name": "Hazmat Heimerdinger",
					"chromas": false
				}
			],
			"lore": "A brilliant yet eccentric yordle scientist, Professor Cecil B. Heimerdinger is one of the most innovative and esteemed inventors Piltover has ever known. Relentless in his work to the point of neurotic obsession, he thrives on answering the universe's most impenetrable questions. Though his theories often appear opaque and esoteric, Heimerdinger has crafted some of Piltover's most miraculous—not to mention lethal—machinery, and constantly tinkers with his inventions to make them even more efficient.",
			"blurb": "A brilliant yet eccentric yordle scientist, Professor Cecil B. Heimerdinger is one of the most innovative and esteemed inventors Piltover has ever known. Relentless in his work to the point of neurotic obsession, he thrives on answering the universe's...",
			"allytips": [
				"Turret placement can be a deciding factor in a battle. Against most enemies turrets are best when they can support each other, but if the enemy has a lot of area of effect damage your turrets can be destroyed quickly. Placing turrets in brush can lead to a surprise attack in your favor.",
				"The success of Electron Storm Grenade is very important to Heimerdinger's survival. The slow and stun both are capable of keeping enemies in place long enough to punish them, but it is also the first line of defense against a surprise attack.",
				"Spreading out Hextech Micro-Rockets leads to more reliable damage and more efficiency against multiple targets, but focusing it creates the biggest impact."
			],
			"enemytips": [
				"It's better to destroy all of Heimerdinger's turrets at once with the help of creeps than to fight them one at a time.",
				"Be wary of Heimerdinger's Upgrade!!!, as he can use it to find an answer to most trouble he gets into. Once his ultimate is down, go in for the kill!"
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 6,
				"magic": 8,
				"difficulty": 8
			},
			"stats": {
				"hp": 488,
				"hpperlevel": 87,
				"mp": 307.2,
				"mpperlevel": 40,
				"movespeed": 340,
				"armor": 19.04,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55.536,
				"attackdamageperlevel": 2.7,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "HeimerdingerQ",
					"name": "H-28G Evolution Turret",
					"description": "Heimerdinger lays down a rapid-fire cannon turret equipped with a secondary pass-through beam attack (turrets deal half damage to towers).",
					"tooltip": "Places a Turret. Turret attacks prioritize Heimerdinger's targets and enemies attacking Heimerdinger. Turrets shut down if Heimerdinger moves far away. Heimerdinger generates a Turret Kit every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can hold {{ e3 }} Kits at once. <br /><br /><u><span class=\"colorFFFFFF\">H-28G Evolution Turret Stats</span></u><br /><span class=\"colorFFDD77\">Health:</span> <span class=\"colorFFFFFF\">{{ f4 }}</span> <span class=\"color99FF99\">(+{{ f2 }})</span><br /><span class=\"colorFFDD77\">Attack - Cannon:</span> {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage.<br /><span class=\"colorFFDD77\">Attack - Beam:</span> {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage every {{ e6 }} seconds.<br /><span class=\"colorFFDD77\">Maximum Turrets Placed:</span> 3",
					"leveltip": {
						"label": [
							"Cannon Damage",
							"Beam Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1,
						1,
						1,
						1,
						1
					],
					"cooldownBurn": "1",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							6,
							9,
							12,
							15,
							18
						],
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							26,
							22,
							18,
							14,
							10
						],
						[
							900,
							900,
							900,
							900,
							900
						],
						[
							90,
							90,
							90,
							90,
							90
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							20,
							20,
							20,
							20,
							20
						]
					],
					"effectBurn": [
						null,
						"6/9/12/15/18",
						"40/60/80/100/120",
						"3",
						"26/22/18/14/10",
						"900",
						"90",
						"0",
						"0.25",
						"0",
						"20"
					],
					"vars": [
						{
							"link": "@cooldownchampion",
							"coeff": 0,
							"key": "f1"
						},
						{
							"link": "@text",
							"coeff": [
								150,
								175,
								200,
								225,
								250,
								275,
								300,
								325,
								350,
								375,
								400,
								425,
								450,
								475,
								500,
								525,
								550,
								575
							],
							"key": "f4"
						},
						{
							"link": "@cooldownchampion",
							"coeff": 0,
							"key": "f2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.55,
							"key": "a2"
						}
					],
					"costType": " Mana and  Turret Kit",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "HeimerdingerQ.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana and  Turret Kit"
				},
				{
					"id": "HeimerdingerW",
					"name": "Hextech Micro-Rockets",
					"description": "Heimerdinger fires long-range rockets that converge on his cursor. ",
					"tooltip": "Unleashes a barrage of 5 rockets that converge towards the cursor and fan out past it. Rockets deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage. Additional rocket hits deal reduced damage:<br /><br /><span class=\"colorFFDD77\">Champions and Monsters:</span> {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage, max {{ e6 }} <span class=\"color99FF99\">(+{{ f2 }})</span> total damage<br /><span class=\"colorFFDD77\">Minions:</span> 60% of base damage<br /><br />Rocket hits against champions charge nearby turret beam attacks.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Damage",
							"Maximum Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10,
						9,
						8,
						7
					],
					"cooldownBurn": "11/10/9/8/7",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							12,
							18,
							24,
							30,
							36
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							108,
							162,
							216,
							270,
							324
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/90/120/150/180",
						"12/18/24/30/36",
						"25",
						"20",
						"30",
						"108/162/216/270/324",
						"5",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.12,
							"key": "a2"
						},
						{
							"link": "@dynamic.abilitypower",
							"coeff": 0.93,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1325,
						1325,
						1325,
						1325,
						1325
					],
					"rangeBurn": "1325",
					"image": {
						"full": "HeimerdingerW.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "HeimerdingerE",
					"name": "CH-2 Electron Storm Grenade",
					"description": "Heimerdinger lobs a grenade at a location, dealing damage to enemy units, as well as stunning anyone directly hit and slowing surrounding units.",
					"tooltip": "Hurls a grenade that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to enemies and slows their Movement Speed by {{ e3 }}% for {{ e2 }} seconds. Enemies in the center of the blast are also stunned for {{ e4 }} seconds.<br /><br />Hitting a champion fully charges nearby turret beams.",
					"leveltip": {
						"label": [
							"Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						85,
						85,
						85,
						85,
						85
					],
					"costBurn": "85",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"2",
						"35",
						"1.25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						970,
						970,
						970,
						970,
						970
					],
					"rangeBurn": "970",
					"image": {
						"full": "HeimerdingerE.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "HeimerdingerR",
					"name": "UPGRADE!!!",
					"description": "Heimerdinger invents an upgrade, causing his next spell to have increased effects. ",
					"tooltip": "Makes Heimerdinger's next ability free and gives it bonus effects. Reactivate to cancel. <br /><br /><span class=\"colorFFFF99\">H-28Q Apex Turret:</span> Places a Turret for 8 seconds that deals {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage with its cannon and {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage with its beam. It has splash damage, immunity to disables, its attacks slow by 25% for 2 seconds and it doesn't count toward the Turret limit. <br /><br /><span class=\"colorFFFF99\">Hextech Rocket Swarm:</span> Fires 4 waves of rockets that each deal {{ e8 }} <span class=\"color99FF99\">(+{{ f1 }})</span> Magic Damage. Champions and Monsters hit by multiple rockets take reduced damage, max {{ e5 }} <span class=\"color99FF99\">(+{{ f2 }})</span>. <br /><br /><span class=\"colorFFFF99\">CH-3X Lightning Grenade:</span> Throws a bouncing grenade that discharges three times, dealing {{ e0 }} <span class=\"color99FF99\">(+{{ f4 }})</span> Magic Damage. Both the stun and slow areas are larger and the slow is improved to 80%. ",
					"leveltip": {
						"label": [
							"Cooldown",
							"Apex Turret Cannon Damage",
							"Turret Beam Damage",
							"Rocket Swarm Damage",
							"Rocket Swarm Max Damage",
							"Lightning Grenade Damage"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e8 }} -> {{ e8NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e0 }} -> {{ e0NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						85,
						70
					],
					"cooldownBurn": "100/85/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							140,
							180
						],
						[
							80,
							80,
							80
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							0.12,
							0.12,
							0.12
						],
						[
							500,
							690,
							865
						],
						[
							0.45,
							0.45,
							0.45
						],
						[
							80,
							100,
							120
						],
						[
							135,
							180,
							225
						],
						[
							28,
							39,
							49
						],
						[
							150,
							250,
							350
						]
					],
					"effectBurn": [
						null,
						"100/140/180",
						"80",
						"1.5",
						"0.12",
						"500/690/865",
						"0.45",
						"80/100/120",
						"135/180/225",
						"28/39/49",
						"150/250/350"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "@dynamic.abilitypower",
							"coeff": 0,
							"key": "f1"
						},
						{
							"link": "@dynamic.abilitypower",
							"coeff": 1.83,
							"key": "f2"
						},
						{
							"link": "@dynamic.abilitypower",
							"coeff": 0.6,
							"key": "f4"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "HeimerdingerR.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Hextech Affinity",
				"description": "Gain Movement Speed while near allied towers and turrets deployed by Heimerdinger.",
				"image": {
					"full": "Heimerdinger_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Heimerdinger",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Heimerdinger",
					"title": "HeimerdingerTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Illaoi": {
			"id": "Illaoi",
			"key": "420",
			"name": "Illaoi",
			"title": "the Kraken Priestess",
			"image": {
				"full": "Illaoi.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 384,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "420000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "420001",
					"num": 1,
					"name": "Void Bringer Illaoi",
					"chromas": false
				}
			],
			"lore": "Illaoi's powerful physique is dwarfed only by her indomitable faith. As the prophet of the Great Kraken, she uses a huge, golden idol to rip her foes' spirits from their bodies and shatter their perception of reality. All who challenge the “Truth Bearer of Nagakabouros” soon discover Illaoi never battles alone—the god of the Serpent Isles fights by her side.",
			"blurb": "Illaoi's powerful physique is dwarfed only by her indomitable faith. As the prophet of the Great Kraken, she uses a huge, golden idol to rip her foes' spirits from their bodies and shatter their perception of reality. All who challenge the “Truth Bearer...",
			"allytips": [
				"Tentacles are an immense source of power. Don't fight without them.",
				"Spirits inherit their target's current health. If making a ",
				"Vessel",
				" is your goal, try whittling your opponent's health down a bit first to make killing the spirit easier.",
				"Leap of Faith is best used to follow-up a strong engage or when being engaged upon. Be careful about being the first one into a fight."
			],
			"enemytips": [
				"Killing Tentacles whenever possible will make it much easier to win a fight against Illaoi.",
				"When your spirit gets pulled out, fight back if you can. Dealing damage to Illaoi reduces the spirit's duration.",
				"Avoid grouping up for Leap of Faith to reduce the number of Tentacles available to Illaoi."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 6,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 585.6,
				"hpperlevel": 95,
				"mp": 300,
				"mpperlevel": 40,
				"movespeed": 340,
				"armor": 35,
				"armorperlevel": 3.8,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9.5,
				"hpregenperlevel": 0.8,
				"mpregen": 7.5,
				"mpregenperlevel": 0.75,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "IllaoiQ",
					"name": "Tentacle Smash",
					"description": "Increases the damage dealt by Tentacles. When activated, Illaoi smashes down a Tentacle that deals physical damage.",
					"tooltip": "<span class=\"colorFF8C00\">Passive:</span> <span class=\"color85FFAD\">Slam</span> damage is increased by {{ e6 }}% (<span class=\"colorFF8C00\">{{ f1 }}</span>).<br /><br /><span class=\"colorFF8C00\">Active:</span> Illaoi swings her idol, causing a Tentacle to <span class=\"color85FFAD\">Slam</span> forward.",
					"leveltip": {
						"label": [
							"Slam Bonus",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e6 }}% -> {{ e6NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							10,
							8,
							6,
							4,
							2
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							1.2,
							1.2,
							1.2,
							1.2,
							1.2
						],
						[
							-0.3,
							-0.35,
							-0.4,
							-0.45,
							-0.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10",
						"200",
						"800",
						"10/8/6/4/2",
						"5",
						"10/15/20/25/30",
						"1.2",
						"-0.3/-0.35/-0.4/-0.45/-0.5",
						"1.5",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "IllaoiQ.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IllaoiW",
					"name": "Harsh Lesson",
					"description": "Illaoi leaps to her target, dealing physical damage and causing nearby Tentacles to also swing at the target.",
					"tooltip": "Illaoi leaps at her target on her next basic attack, dealing bonus physical damage equal to <span class=\"colorFF8C00\">{{ f1*100 }}%</span> of their maximum health [{{ e1 }}% + {{ f2*100 }}% per 100 attack damage].<br /><br />When she strikes, nearby Tentacles will <span class=\"color85FFAD\">Slam</span> at the target.<br /><br /><span class=\"color919191\"><i>Harsh Lesson's bonus damage against monsters is capped at {{ e3 }} damage per hit.</i></span>",
					"leveltip": {
						"label": [
							"Base Damage"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							3,
							3.5,
							4,
							4.5,
							5
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"3/3.5/4/4.5/5",
						"2",
						"300",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "IllaoiW.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IllaoiE",
					"name": "Test of Spirit",
					"description": "Illaoi rips the spirit from a foe's body, forcing it to stand before her. Spirits echo a percentage of the damage they take to the original target. If killed, or if the target gets too far from the spirit, the target will become a <font color='#669900'>Vessel</font> and begin spawning Tentacles.",
					"tooltip": "Illaoi pulls the spirit from an enemy champion for {{ e3 }} seconds (reduced when Illaoi is attacked by the target). The spirit can be attacked, with {{ e1 }}% <span class=\"colorFF8C00\">(+{{ f5 }}%)</span> of the damage taken echoing to its owner.<br /><br />If the spirit dies or the target leaves its range, the target becomes a <span class=\"color669900\">Vessel</span> for {{ e2 }} seconds and is slowed by {{ e8 }}% for {{ e5 }} seconds. <span class=\"color669900\">Vessels</span> spawn Tentacles every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds if no other Tentacles are nearby.<br /><br />Tentacles will automatically <span class=\"color85FFAD\">Slam</span> at spirits and <span class=\"color669900\">Vessels</span> once every 10 seconds.",
					"leveltip": {
						"label": [
							"Damage Echo",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ f4 }} -> {{ f6 }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						35,
						40,
						45,
						50,
						55
					],
					"costBurn": "35/40/45/50/55",
					"effect": [
						null,
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							1500,
							1500,
							1500,
							1500,
							1500
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							20,
							18,
							16,
							14,
							12
						],
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							4,
							3,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/30/35/40/45",
						"12",
						"10",
						"1500",
						"1.5",
						"3",
						"20/18/16/14/12",
						"80",
						"8",
						"4/3/0/0/0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "IllaoiE.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IllaoiR",
					"name": "Leap of Faith",
					"description": "Illaoi smashes her idol into the ground, dealing physical damage to nearby enemies. A Tentacle spawns for each enemy champion hit.",
					"tooltip": "Illaoi smashes her idol into the ground, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and spawning a Tentacle for each enemy champion hit.<br /><br />For the next {{ e1 }} seconds Tentacles are untargetable and will <span class=\"color85FFAD\">Slam</span> 50% faster, and Harsh Lesson has a 2 second cooldown.<br /><br /><span class=\"colorcccccc\"><i>'There are kind and gentle gods. Mine isn't one of those.'</i></span>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown<"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							8,
							8,
							8
						],
						[
							150,
							250,
							350
						],
						[
							1500,
							1500,
							1500
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"8",
						"150/250/350",
						"1500",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "IllaoiR.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Prophet of an Elder God",
				"description": "Illaoi and the <font color='#669900'>Vessels</font> she creates spawn Tentacles on nearby impassible terrain. Tentacles swing at spirits, <font color='#669900'>Vessels</font>, and victims of Illaoi's Harsh lesson. Tentacles deal physical damage to enemies hit, and will heal Illaoi if they damage a champion.",
				"image": {
					"full": "Illaoi_P.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Illaoi",
					"title": "IllaoiARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Illaoi",
					"title": "IllaoiCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Illaoi",
					"title": "IllaoiFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Illaoi",
					"title": "IllaoiKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Illaoi",
					"title": "IllaoiSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Illaoi",
					"title": "IllaoiSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Illaoi",
					"title": "IllaoiTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Irelia": {
			"id": "Irelia",
			"key": "39",
			"name": "Irelia",
			"title": "the Will of the Blades",
			"image": {
				"full": "Irelia.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 432,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "39000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "39001",
					"num": 1,
					"name": "Nightblade Irelia",
					"chromas": false
				},
				{
					"id": "39002",
					"num": 2,
					"name": "Aviator Irelia",
					"chromas": false
				},
				{
					"id": "39003",
					"num": 3,
					"name": "Infiltrator Irelia",
					"chromas": false
				},
				{
					"id": "39004",
					"num": 4,
					"name": "Frostblade Irelia",
					"chromas": false
				},
				{
					"id": "39005",
					"num": 5,
					"name": "Order of the Lotus Irelia",
					"chromas": false
				}
			],
			"lore": "Raised in the shadow of Noxian occupation, Irelia developed one of the most exotic—and deadly—fighting styles in Ionia. While most of her family died at the hands of the invaders, she survived and learned to wield her levitating blades with nothing but her own determined spirit. She remains a fierce symbol of the resistance, ready to strike down any tyrant who may reach the shores of her homeland.",
			"blurb": "Raised in the shadow of Noxian occupation, Irelia developed one of the most exotic—and deadly—fighting styles in Ionia. While most of her family died at the hands of the invaders, she survived and learned to wield her levitating blades with nothing but...",
			"allytips": [
				"Use Bladesurge to cover great distances by targeting low life minions on your way to champion targets.",
				"Save your Transcendent Blades attacks for the right moment.",
				"Reserving Equilibrium Strike for losing battles can often turn the tide."
			],
			"enemytips": [
				"Be wary of Irelia's Equilibrium Strike, as it stuns if you have a higher Health % than her.",
				"Irelia can quickly cover great distances by using Bladesurge on low life targets (its cooldown refreshes if it slays the target)."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 4,
				"magic": 5,
				"difficulty": 5
			},
			"stats": {
				"hp": 607.2,
				"hpperlevel": 90,
				"mp": 338.8,
				"mpperlevel": 32,
				"movespeed": 345,
				"armor": 34,
				"armorperlevel": 3.75,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.65,
				"mpregen": 8.1,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 70,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": -0.06,
				"attackspeedperlevel": 3.2
			},
			"spells": [
				{
					"id": "IreliaGatotsu",
					"name": "Bladesurge",
					"description": "Irelia dashes forward to strike her target. If it kills the target, Bladesurge's cooldown refreshes and refunds a portion of the Mana Cost.",
					"tooltip": "Irelia dashes forward to strike her target, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and applying on-hit effects.<br /><br />If it kills the target, Bladesurge's cooldown is refreshed and Irelia gains {{ e2 }} Mana.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						12,
						10,
						8,
						6
					],
					"cooldownBurn": "14/12/10/8/6",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							20,
							50,
							80,
							110,
							140
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							1400,
							1400,
							1400,
							1400,
							1400
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/50/80/110/140",
						"35",
						"1400",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "IreliaGatotsu.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IreliaHitenStyle",
					"name": "Hiten Style",
					"description": "Irelia is skilled in the art of Hiten, passively giving her physical attacks Health restoration. Activating Hiten Style doubles her Health restoration and gives her basic attacks true damage.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Basic attacks restore {{ e1 }} Health.<br /><br /><span class=\"colorFF9900\">Active:</span> Irelia's basic attacks deal {{ e2 }} true damage and Hiten Style restores twice as much health for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Health Restoration",
							"True Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							5,
							7,
							9,
							11,
							13
						],
						[
							15,
							30,
							45,
							60,
							75
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5/7/9/11/13",
						"15/30/45/60/75",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "IreliaHitenStyle.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IreliaEquilibriumStrike",
					"name": "Equilibrium Strike",
					"description": "Irelia's attack balances the scales, dealing damage and slowing the target. However, if the target has a higher Health % than Irelia, then the blow stuns the target instead of slowing.",
					"tooltip": "Irelia pierces her target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing them by {{ e3 }}% for {{ e2 }} second(s).<br /><br />If the target has a higher Health % than Irelia, she stuns them for the duration instead.",
					"leveltip": {
						"label": [
							"Damage",
							"Disable Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }} -> {{ e2NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"1/1.25/1.5/1.75/2",
						"60",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "IreliaEquilibriumStrike.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IreliaTranscendentBlades",
					"name": "Transcendent Blades",
					"description": "Irelia summons 4 spirit blades that she can fling to deal physical damage and siphon life from enemies they pass through.",
					"tooltip": "Irelia summons 4 spirit blades that she can fling to deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to enemies they pass through. She heals for {{ e3 }}% of the damage dealt against champions. ({{ e4 }}% vs. minions and monsters)",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						80,
						60
					],
					"cooldownBurn": "100/80/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							80,
							120,
							160
						],
						[
							10,
							10,
							10
						],
						[
							25,
							25,
							25
						],
						[
							10,
							10,
							10
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160",
						"10",
						"25",
						"10",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.7,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "IreliaTranscendentBlades.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Ionian Fervor",
				"description": "Irelia reduces the duration of disables on herself based on whether she is Outnumbered by nearby champions. If she's in an even fight, she'll reduce disables by a small amount, if she's outnumbered, she'll reduce disables by a larger amount.",
				"image": {
					"full": "Irelia_IonianFervor.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Irelia",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1419",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Irelia",
					"title": "IreliaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Ivern": {
			"id": "Ivern",
			"key": "427",
			"name": "Ivern",
			"title": "the Green Father",
			"image": {
				"full": "Ivern.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 0,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "427000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "427001",
					"num": 1,
					"name": "Candy King Ivern",
					"chromas": false
				}
			],
			"lore": "Ivern Bramblefoot, known to many as the Green Father, is a peculiar half man, half tree who roams Runeterra's forests, cultivating life everywhere he goes. He knows the secrets of the natural world, and holds deep friendships with all things that grow, fly, and scuttle. Ivern wanders the wilderness, imparting strange wisdom to any he meets, enriching the forests, and occasionally entrusting loose-lipped butterflies with his secrets.",
			"blurb": "Ivern Bramblefoot, known to many as the Green Father, is a peculiar half man, half tree who roams Runeterra's forests, cultivating life everywhere he goes. He knows the secrets of the natural world, and holds deep friendships with all things that grow...",
			"allytips": [
				"Try to help allies follow up a good Rootcaller hit with Triggerseed!",
				"Use Brushmaker to set up future ambush spots!",
				"Daisy can block skillshots and slow down enemies. Use her to peel for your teammates!"
			],
			"enemytips": [
				"Ivern can be deceptively slippery. Be careful chasing him too far.",
				"Ivern's brush has a long duration. Watch out for ambushes!",
				"Be careful when fighting Ivern alone if he has Daisy ready to help!"
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 5,
				"magic": 7,
				"difficulty": 7
			},
			"stats": {
				"hp": 585,
				"hpperlevel": 95,
				"mp": 450,
				"mpperlevel": 60,
				"movespeed": 325,
				"armor": 27,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7,
				"hpregenperlevel": 0.85,
				"mpregen": 6,
				"mpregenperlevel": 0.75,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 50,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.03,
				"attackspeedperlevel": 3.4
			},
			"spells": [
				{
					"id": "IvernQ",
					"name": "Rootcaller",
					"description": "Ivern conjures a vine, dealing damage and rooting enemy targets hit. Ivern's allies can dash to the rooted target.",
					"tooltip": "Ivern conjures a vine dealing {{ e5 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage and rooting the first enemy hit for {{ e1 }} second(s). Allies can click on rooted enemies to dash into attack range.",
					"leveltip": {
						"label": [
							"Root Duration",
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							1.2,
							1.4,
							1.6,
							1.8,
							2
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							26,
							23,
							20,
							17,
							14
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.2/1.4/1.6/1.8/2",
						"15/20/25/30/35",
						"26/23/20/17/14",
						"2",
						"80/125/170/215/260",
						"40/55/70/85/100",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "IvernQ.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IvernW",
					"name": "Brushmaker",
					"description": "In brush, Ivern's attacks are ranged and deal bonus magic damage. Ivern can activate this ability to create a patch of brush.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> In brush, Ivern's attacks are ranged and deal {{ e5 }} <span class=\"color99FF99\">(+{{ f2 }})</span> bonus magic damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Ivern grows a patch of brush for {{ e1 }} seconds. For 3 seconds the area in and around the brush is revealed.",
					"leveltip": {
						"label": [
							"Bonus Magic Damage",
							"Brush Recharge"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e4 }} -> {{ e4NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.5,
						0.5,
						0.5,
						0.5,
						0.5
					],
					"cooldownBurn": "0.5",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							90,
							90,
							90,
							90,
							90
						],
						[
							190,
							190,
							190,
							190,
							190
						],
						[
							40,
							36,
							32,
							28,
							24
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30",
						"90",
						"190",
						"40/36/32/28/24",
						"20/30/40/50/60",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "3",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "IvernW.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IvernE",
					"name": "Triggerseed",
					"description": "Ivern places a shield on an ally which explodes after a short duration slowing and damaging enemies.",
					"tooltip": "Ivern shields an ally, absorbing up to {{ e1 }} <span class=\"color99FF99\">(+{{ f3 }})</span> damage. After 2 seconds, the shield bursts dealing {{ e2 }} <span class=\"color99FF99\">(+{{ f4 }})</span> magic damage and slowing enemies by {{ e3 }}% for {{ e4 }} seconds.<br /><br /><rules><span class=\"colorFFFF00\">Can also be cast on Daisy.</span></rules>",
					"leveltip": {
						"label": [
							"Shield",
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							75,
							110,
							145,
							180,
							215
						],
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/110/145/180/215",
						"60/80/100/120/140",
						"40/45/50/55/60",
						"2",
						"1",
						"80/120/160/200/240",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "IvernE.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IvernR",
					"name": "Daisy!",
					"description": "Ivern summons his Sentinel friend Daisy to fight with him. Daisy will send out a shockwave if she attacks the same champion three times in a row.",
					"tooltip": "Ivern summons his sentinel friend Daisy for {{ f6 }} seconds. If Daisy attacks the same champion three times in a row, she will create a shockwave knocking enemies up for 1 second (3s cooldown). Daisy has:<li>Health: {{ e1 }} <span class=\"color99FF99\">(+{{ f1 }})</span><br />Armor and Magic Resist: {{ e2 }} <span class=\"color99FF99\">(+{{ f2 }})</span><br />Attack Damage: {{ f4 }} <span class=\"color99FF99\">(+{{ f3 }})</span></li><br /><rules><span class=\"colorFFFF00\">Recast to manually issue orders to Daisy.</span></rules>",
					"leveltip": {
						"label": [
							"Cooldown",
							"Daisy's Base Health",
							"Daisy's Base Armor And Magic Resist",
							"Daisy Bonus Attack Speed"
						],
						"effect": [
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 3,
					"cooldown": [
						160,
						140,
						120
					],
					"cooldownBurn": "160/140/120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							1250,
							2500,
							3750
						],
						[
							15,
							40,
							90
						],
						[
							30,
							50,
							70
						],
						[
							30,
							60,
							130
						],
						[
							25,
							25,
							25
						],
						[
							160,
							140,
							120
						],
						[
							40,
							40,
							40
						],
						[
							25,
							25,
							25
						],
						[
							5,
							5,
							5
						],
						[
							0.05,
							0.05,
							0.05
						]
					],
					"effectBurn": [
						null,
						"1250/2500/3750",
						"15/40/90",
						"30/50/70",
						"30/60/130",
						"25",
						"160/140/120",
						"40",
						"25",
						"5",
						"0.05"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "IvernR.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Friend of the Forest",
				"description": "Ivern cannot attack or be attacked by non-epic monsters. Ivern can create magical groves on jungle camps which grow over time. When the grove is fully grown, Ivern may free the monsters to receive gold and experience. After level 5 Ivern can share jungle buffs with allies.",
				"image": {
					"full": "IvernP.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ivern",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1004",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3114",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "ItemTeleportCancel",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3114",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3801",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3711",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ivern",
					"title": "IvernTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Janna": {
			"id": "Janna",
			"key": "40",
			"name": "Janna",
			"title": "the Storm's Fury",
			"image": {
				"full": "Janna.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 48,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "40000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "40001",
					"num": 1,
					"name": "Tempest Janna",
					"chromas": false
				},
				{
					"id": "40002",
					"num": 2,
					"name": "Hextech Janna",
					"chromas": false
				},
				{
					"id": "40003",
					"num": 3,
					"name": "Frost Queen Janna",
					"chromas": false
				},
				{
					"id": "40004",
					"num": 4,
					"name": "Victorious Janna",
					"chromas": false
				},
				{
					"id": "40005",
					"num": 5,
					"name": "Forecast Janna",
					"chromas": false
				},
				{
					"id": "40006",
					"num": 6,
					"name": "Fnatic Janna",
					"chromas": false
				},
				{
					"id": "40007",
					"num": 7,
					"name": "Star Guardian Janna",
					"chromas": false
				},
				{
					"id": "40008",
					"num": 8,
					"name": "Sacred Sword Janna",
					"chromas": true
				}
			],
			"lore": "Armed with the power of Runeterra's gales, Janna is a mysterious, elemental wind spirit who protects the dispossessed of Zaun. Some believe she was brought into existence by the pleas of Runeterra's sailors who prayed for fair winds as they navigated treacherous waters and braved rough tempests. Her favor and protection has since been called into the depths of Zaun, where Janna has become a beacon of hope to those in need. No one knows where or when she will appear, but more often than not, she's come to help.",
			"blurb": "Armed with the power of Runeterra's gales, Janna is a mysterious, elemental wind spirit who protects the dispossessed of Zaun. Some believe she was brought into existence by the pleas of Runeterra's sailors who prayed for fair winds as they navigated...",
			"allytips": [
				"Eye of the Storm can be used on allied turrets.",
				"Quickly firing a Howling Gale without the charge up can be used to heavily disable the other team.",
				"Timing Janna's ultimate can push enemies away from a wounded ally or even separate enemies."
			],
			"enemytips": [
				"Save an interrupt ability for when Janna uses her ultimate.",
				"Listen for the charge up sound on Howling Gale in case Janna is trying to hit you with it from off screen or from brush.",
				"Janna's at her strongest when buffing another ally. If you can harass her ally, it will weaken her ability to fight you."
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 5,
				"magic": 7,
				"difficulty": 7
			},
			"stats": {
				"hp": 500,
				"hpperlevel": 70,
				"mp": 350,
				"mpperlevel": 64,
				"movespeed": 320,
				"armor": 28,
				"armorperlevel": 3.8,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 11.5,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 46,
				"attackdamageperlevel": 1.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.95
			},
			"spells": [
				{
					"id": "HowlingGale",
					"name": "Howling Gale",
					"description": "By creating a localized change in pressure and temperature, Janna is able to create a small storm that grows in size with time. She can activate the spell again to release the storm. On release this storm will fly towards the direction it was cast in, dealing damage and knocking away any enemies in its path.",
					"tooltip": "Summons a whirlwind, which deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in its path and knocks them into the air for {{ e4 }} seconds.<br /><br />The whirlwind can be charged up to {{ e6 }} seconds. For each second charged, it:<br /><li>Deals {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus damage<br />Knocks up for an additional {{ e5 }} seconds<br />Travels {{ e3 }}% further</li><br />Howling Gale always reaches its destination in {{ e8 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Activate again to release the whirlwind early.</span>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Damage Per Second Charged",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ e2 }} -> {{ e2NL }} ",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						60,
						80,
						100,
						120,
						140
					],
					"costBurn": "60/80/100/120/140",
					"effect": [
						null,
						[
							60,
							85,
							110,
							135,
							160
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/85/110/135/160",
						"15/20/25/30/35",
						"25",
						"0.5",
						"0.25",
						"3",
						"0",
						"1.5",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1700,
						1700,
						1700,
						1700,
						1700
					],
					"rangeBurn": "1700",
					"image": {
						"full": "HowlingGale.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SowTheWind",
					"name": "Zephyr",
					"description": "Janna summons an air elemental that passively increases her Movement Speed and enables her to pass through units. She may also activate this ability to deal damage and slow an enemy's Movement Speed. The passive is lost while this ability is on cooldown.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> While Zephyr is not on cooldown, Janna gains {{ e1 }}% <span class=\"color99FF99\">(+{{ f1 }}%)</span> Movement Speed and can move through units.<br /><br /><span class=\"colorFF9900\">Active: </span>Deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFFF673\">(+{{ f3 }})</span> magic damage to an enemy and slows their Movement Speed by {{ e3 }}% <span class=\"color99FF99\">(+{{ f2 }}%)</span> for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Passive Movement Speed",
							"Damage",
							"Slow Amount",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }} ",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							6,
							7,
							8,
							9,
							10
						],
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							24,
							28,
							32,
							36,
							40
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0.0002,
							0.0002,
							0.0002,
							0.0002,
							0.0002
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6/7/8/9/10",
						"60/105/150/195/240",
						"24/28/32/36/40",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.02,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.06,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "SowTheWind.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "EyeOfTheStorm",
					"name": "Eye Of The Storm",
					"description": "Janna conjures a defensive gale that shields an ally champion or turret from incoming damage and increases their Attack Damage.",
					"tooltip": "Shields an allied Champion or turret for {{ e3 }} seconds. The shield absorbs up to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage and grants {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Attack Damage until it breaks.",
					"leveltip": {
						"label": [
							"Shield Health",
							"Attack Damage Bonus",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							10,
							17.5,
							25,
							32.5,
							40
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"10/17.5/25/32.5/40",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "EyeOfTheStorm.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ReapTheWhirlwind",
					"name": "Monsoon",
					"description": "Janna surrounds herself in a magical storm, throwing enemies back. After the storm has settled, soothing winds heal nearby allies while the ability is active.",
					"tooltip": "Summons forth the might of the wind to knock surrounding enemies back and restores {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health to nearby allies each second for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Heal Per Second",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						150,
						135,
						120
					],
					"cooldownBurn": "150/135/120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							150,
							200
						],
						[
							300,
							450,
							600
						],
						[
							3,
							3,
							3
						],
						[
							700,
							700,
							700
						],
						[
							875,
							875,
							875
						],
						[
							875,
							875,
							875
						],
						[
							1200,
							1200,
							1200
						],
						[
							10,
							10,
							10
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/150/200",
						"300/450/600",
						"3",
						"700",
						"875",
						"875",
						"1200",
						"10",
						"0.5",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "ReapTheWhirlwind.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Tailwind",
				"description": "Janna passively gains 8% Movement Speed, and nearby allied champions gain this bonus when moving toward her.<br><br>Additionally, Janna's basic attacks cause additional magic damage based on her bonus Movement Speed.",
				"image": {
					"full": "Janna_Tailwind.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Janna",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								},
								{
									"id": "3151",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3041",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Janna",
					"title": "JannaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"JarvanIV": {
			"id": "JarvanIV",
			"key": "59",
			"name": "Jarvan IV",
			"title": "the Exemplar of Demacia",
			"image": {
				"full": "JarvanIV.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 96,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "59000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "59001",
					"num": 1,
					"name": "Commando Jarvan IV",
					"chromas": false
				},
				{
					"id": "59002",
					"num": 2,
					"name": "Dragonslayer Jarvan IV",
					"chromas": false
				},
				{
					"id": "59003",
					"num": 3,
					"name": "Darkforge Jarvan IV",
					"chromas": false
				},
				{
					"id": "59004",
					"num": 4,
					"name": "Victorious Jarvan IV",
					"chromas": false
				},
				{
					"id": "59005",
					"num": 5,
					"name": "Warring Kingdoms Jarvan IV",
					"chromas": false
				},
				{
					"id": "59006",
					"num": 6,
					"name": "Fnatic Jarvan IV",
					"chromas": false
				},
				{
					"id": "59007",
					"num": 7,
					"name": "Dark Star Jarvan IV",
					"chromas": false
				}
			],
			"lore": "Prince Jarvan, scion of the Lightshield dynasty, is heir apparent to the throne of Demacia. Raised to be a paragon of his nation's greatest virtues, he is forced to balance the heavy expectations placed upon him with his own desire to fight on the front lines. Jarvan inspires his troops with his fearsome courage and selfless determination, raising his family's colors high and revealing his true strength as a future leader of his people.",
			"blurb": "Prince Jarvan, scion of the Lightshield dynasty, is heir apparent to the throne of Demacia. Raised to be a paragon of his nation's greatest virtues, he is forced to balance the heavy expectations placed upon him with his own desire to fight on the front...",
			"allytips": [
				"You can use the Dragon Strike / Demacian Standard combo to get out of your own Cataclysm arenas.",
				"Split your basic attacks on different champions at the beginning of fights to maximize damage.",
				"Use Demacian Standard as a scouting tool when worried about incoming enemies."
			],
			"enemytips": [
				"Keep out of the path between Jarvan IV and his Demacian Standard to avoid being knocked up in the air.",
				"Cataclysm's terrain is a frightening force to fight against, but movement abilities can go through it."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 8,
				"magic": 3,
				"difficulty": 5
			},
			"stats": {
				"hp": 571.2,
				"hpperlevel": 90,
				"mp": 302.2,
				"mpperlevel": 40,
				"movespeed": 340,
				"armor": 34,
				"armorperlevel": 3.6,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.7,
				"mpregen": 6.756,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 3.4,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "JarvanIVDragonStrike",
					"name": "Dragon Strike",
					"description": "Jarvan IV extends his lance, dealing physical damage and lowering the Armor of enemies in its path. Additionally, this will pull Jarvan to his Demacian Standard, knocking up enemies in his path.",
					"tooltip": "Extends Jarvan IV's lance dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and lowering the Armor of enemies hit by {{ e2 }}% for {{ e3 }} seconds.<br /><br />If the lance contacts Demacian Standard it will pull Jarvan IV to its location, knocking up enemies in his path. This effect can be triggered even while immobilized.",
					"leveltip": {
						"label": [
							"Damage",
							"Armor Reduction",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							10,
							14,
							18,
							22,
							26
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"10/14/18/22/26",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						770,
						770,
						770,
						770,
						770
					],
					"rangeBurn": "770",
					"image": {
						"full": "JarvanIVDragonStrike.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JarvanIVGoldenAegis",
					"name": "Golden Aegis",
					"description": "Jarvan IV calls upon the ancient kings of Demacia to shield him from harm and slow surrounding enemies.",
					"tooltip": "Grants a shield that absorbs {{ e1 }} (<span class=\"colorCC3300\">+{{ f1 }}</span> [{{ e6 }}% max Health] for each nearby enemy champion) damage for {{ e4 }} seconds, and slows surrounding enemies by {{ e2 }}% for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Shield",
							"Bonus Shield Percent Health",
							"Slow Amount"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e6 }}% -> {{ e6NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							60,
							85,
							110,
							135,
							160
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							2,
							2.25,
							2.5,
							2.75,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/85/110/135/160",
						"15/20/25/30/35",
						"10/20/30/40/50",
						"5",
						"2",
						"2/2.25/2.5/2.75/3",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "JarvanIVGoldenAegis.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JarvanIVDemacianStandard",
					"name": "Demacian Standard",
					"description": "Jarvan IV carries the pride of Demacia, passively granting him bonus Attack Speed. Activating Demacian Standard allows Jarvan IV to place a Demacian flag that deals magic damage on impact and grants Attack Speed to nearby allied champions.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Gains {{ e3 }}% Attack Speed.<br /><br /><span class=\"colorFF9900\">Active:</span> Throws a Demacian Standard to a nearby area dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies. The Standard lasts for {{ e4 }} seconds and grants surrounding allied champions {{ e3 }}% Attack Speed.",
					"leveltip": {
						"label": [
							"Damage",
							"Passive Attack Speed",
							"Active Attack Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							" {{ e3 }}% -> {{ e3NL }}%",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12.5,
						12,
						11.5,
						11
					],
					"cooldownBurn": "13/12.5/12/11.5/11",
					"cost": [
						55,
						55,
						55,
						55,
						55
					],
					"costBurn": "55",
					"effect": [
						null,
						[
							10,
							13,
							16,
							19,
							22
						],
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0.15,
							0.025,
							0.025,
							0.025,
							0.025
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/13/16/19/22",
						"60/105/150/195/240",
						"15/17.5/20/22.5/25",
						"8",
						"0.15/0.025/0.025/0.025/0.025",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						860,
						860,
						860,
						860,
						860
					],
					"rangeBurn": "860",
					"image": {
						"full": "JarvanIVDemacianStandard.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JarvanIVCataclysm",
					"name": "Cataclysm",
					"description": "Jarvan IV heroically leaps into battle at a target with such force that he terraforms the surrounding area to create an arena around them. Nearby enemies are damaged at the moment of impact.",
					"tooltip": "Heroically leaps to an enemy Champion dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and creating an arena of impassable terrain around them for {{ e2 }} seconds.<br /><br />Activate again to collapse the terrain.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							200,
							325,
							450
						],
						[
							3.5,
							3.5,
							3.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/325/450",
						"3.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "JarvanIVCataclysm.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Martial Cadence",
				"description": "Jarvan IV's initial basic attack on a target deals bonus physical damage. This effect cannot occur again on the same target for a short duration.",
				"image": {
					"full": "JarvanIV_MartialCadence.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "JarvanIV",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "3044",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3044",
									"count": 1
								},
								{
									"id": "3057",
									"count": 1
								},
								{
									"id": "3086",
									"count": 1
								},
								{
									"id": "3078",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3105",
									"count": 1
								},
								{
									"id": "3071",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								},
								{
									"id": "3068",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "JarvanIV",
					"title": "JarvanIVTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Jax": {
			"id": "Jax",
			"key": "24",
			"name": "Jax",
			"title": "Grandmaster at Arms",
			"image": {
				"full": "Jax.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 144,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "24000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "24001",
					"num": 1,
					"name": "The Mighty Jax",
					"chromas": false
				},
				{
					"id": "24002",
					"num": 2,
					"name": "Vandal Jax",
					"chromas": false
				},
				{
					"id": "24003",
					"num": 3,
					"name": "Angler Jax",
					"chromas": false
				},
				{
					"id": "24004",
					"num": 4,
					"name": "PAX Jax",
					"chromas": false
				},
				{
					"id": "24005",
					"num": 5,
					"name": "Jaximus",
					"chromas": false
				},
				{
					"id": "24006",
					"num": 6,
					"name": "Temple Jax",
					"chromas": false
				},
				{
					"id": "24007",
					"num": 7,
					"name": "Nemesis Jax",
					"chromas": true
				},
				{
					"id": "24008",
					"num": 8,
					"name": "SKT T1 Jax",
					"chromas": false
				},
				{
					"id": "24012",
					"num": 12,
					"name": "Warden Jax",
					"chromas": false
				},
				{
					"id": "24013",
					"num": 13,
					"name": "God Staff Jax",
					"chromas": false
				}
			],
			"lore": "Unmatched in both his skill with unique armaments and his biting sarcasm, Jax is the last known weapons master of Icathia. After his homeland was laid low by its own hubris in unleashing the Void, Jax and his kind vowed to protect what little remained. As magic now rises in the world, this slumbering threat stirs once more, and Jax roams Valoran, wielding the last light of Icathia and testing all warriors he meets to see if any are strong enough to stand beside him...",
			"blurb": "Unmatched in both his skill with unique armaments and his biting sarcasm, Jax is the last known weapons master of Icathia. After his homeland was laid low by its own hubris in unleashing the Void, Jax and his kind vowed to protect what little remained...",
			"allytips": [
				"Jax can Leap Strike to friendly units, including wards. You can use them to plan your escape.",
				"Jax benefits greatly from items that have both Ability Power and Attack Damage such as Guinsoo's Rageblade and Hextech Gunblade."
			],
			"enemytips": [
				"Try to engage him in short bursts instead of going toe-to-toe with him. Preventing him from attacking consecutively drastically lowers his damage output.",
				"Jax can dodge all incoming attacks for a very short amount of time and stuns enemies in melee range when it ends. Wait to strike him until after his dodge is finished."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 5,
				"magic": 7,
				"difficulty": 5
			},
			"stats": {
				"hp": 592.8,
				"hpperlevel": 85,
				"mp": 338.8,
				"mpperlevel": 32,
				"movespeed": 350,
				"armor": 36,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.55,
				"mpregen": 7.576,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 69.97,
				"attackdamageperlevel": 3.375,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 3.4
			},
			"spells": [
				{
					"id": "JaxLeapStrike",
					"name": "Leap Strike",
					"description": "Jax leaps toward a unit. If they are an enemy, he strikes them with his weapon.",
					"tooltip": "Jax leaps to target unit, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage if it is an enemy.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						65,
						65,
						65,
						65,
						65
					],
					"costBurn": "65",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "JaxLeapStrike.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JaxEmpowerTwo",
					"name": "Empower",
					"description": "Jax charges his weapon with energy, causing his next attack to deal additional damage.",
					"tooltip": "Jax charges his weapon with energy, causing his next basic attack or Leap Strike to deal an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }}) </span>Magic Damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6,
						5,
						4,
						3
					],
					"cooldownBurn": "7/6/5/4/3",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							40,
							75,
							110,
							145,
							180
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/75/110/145/180",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "JaxEmpowerTwo.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JaxCounterStrike",
					"name": "Counter Strike",
					"description": "Jax's combat prowess allows him to dodge all incoming attacks for a short duration and then quickly counterattack, stunning all surrounding enemies.",
					"tooltip": "Jax enters a defensive stance for up to {{ e6 }} seconds, dodging all incoming basic attacks and taking {{ e3 }}% less damage from area of effect abilities.<br /><br />After 2 seconds or if activated again, Jax stuns surrounding enemies for {{ e2 }} second and deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage to them.<br /><br /><span class=\"color99FF99\">Counter Strike deals {{ e5 }}% more damage for each attack Jax dodged (max: {{ e4 }}% increased damage).</span>",
					"leveltip": {
						"label": [
							"Cooldown",
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }} "
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14,
						12,
						10,
						8
					],
					"cooldownBurn": "16/14/12/10/8",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							55,
							80,
							105,
							130,
							155
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/80/105/130/155",
						"1",
						"25",
						"100",
						"20",
						"2",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "JaxCounterStrike.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JaxRelentlessAssault",
					"name": "Grandmaster's Might",
					"description": "Every third consecutive attack deals additional Magic Damage. Additionally, Jax can activate this ability to strengthen his resolve, increasing his Armor and Magic Resist for a short duration.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Every third consecutive strike Jax deals {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }}) </span>additional Magic Damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Jax strengthens his resolve, granting him <span class=\"colorFF8C00\">{{ f2 }}</span> Armor and <span class=\"color99FF99\">{{ f1 }}</span> Magic Resist for {{ e5 }} seconds.<span class=\"colorFF8C00\"><br /><br />Armor bonus is equal to {{ e3 }} + {{ e6 }}% bonus Attack Damage.</span><span class=\"color99FF99\"><br />Magic Resist bonus is equal to {{ e3 }} + {{ e7 }}% Ability Power.</span>",
					"leveltip": {
						"label": [
							"Passive Damage",
							"Armor Bonus",
							"Magic Resist Bonus"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e3 }} -> {{ e3NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						80,
						80,
						80
					],
					"cooldownBurn": "80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							160,
							220
						],
						[
							3,
							3,
							3
						],
						[
							30,
							50,
							70
						],
						[
							6,
							8,
							10
						],
						[
							8,
							8,
							8
						],
						[
							50,
							50,
							50
						],
						[
							20,
							20,
							20
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/160/220",
						"3",
						"30/50/70",
						"6/8/10",
						"8",
						"50",
						"20",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "@special.jaxrarmor",
							"coeff": 0.3,
							"key": "f2"
						},
						{
							"link": "@special.jaxrmr",
							"coeff": 0.2,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						100,
						100,
						100
					],
					"rangeBurn": "100",
					"image": {
						"full": "JaxRelentlessAssault.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Relentless Assault",
				"description": "Jax's consecutive basic attacks continuously increase his Attack Speed.",
				"image": {
					"full": "Armsmaster_MasterOfArms.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Jax",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "3044",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3044",
									"count": 1
								},
								{
									"id": "3057",
									"count": 1
								},
								{
									"id": "3086",
									"count": 1
								},
								{
									"id": "3078",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3124",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								},
								{
									"id": "3083",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jax",
					"title": "JaxTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Jayce": {
			"id": "Jayce",
			"key": "126",
			"name": "Jayce",
			"title": "the Defender of Tomorrow",
			"image": {
				"full": "Jayce.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 192,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "126000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "126001",
					"num": 1,
					"name": "Full Metal Jayce",
					"chromas": false
				},
				{
					"id": "126002",
					"num": 2,
					"name": "Debonair Jayce",
					"chromas": false
				},
				{
					"id": "126003",
					"num": 3,
					"name": "Forsaken Jayce",
					"chromas": false
				},
				{
					"id": "126004",
					"num": 4,
					"name": "Jayce Brighthammer",
					"chromas": false
				}
			],
			"lore": "Jayce is a brilliant inventor who has pledged his life to the defense of Piltover and its unyielding pursuit of progress. With his transforming hextech hammer in hand, Jayce uses his strength, courage, and considerable intelligence to protect his hometown. While revered throughout the city as a hero, he hasn't taken well to the attention heroism brings. Still, Jayce's heart is in the right place, and even those who envy his natural skills are grateful for his protection in the City of Progress.",
			"blurb": "Jayce is a brilliant inventor who has pledged his life to the defense of Piltover and its unyielding pursuit of progress. With his transforming hextech hammer in hand, Jayce uses his strength, courage, and considerable intelligence to protect his...",
			"allytips": [
				"Be sure to switch stances often. It will enhance your attacks and grant you quick bursts of speed.",
				"If you find yourself taking lots of damage, try using Jayce's Hammer Stance, as it grants you additional defenses.",
				"For increased range and damage, try casting Shock Blast through the Acceleration Gate."
			],
			"enemytips": [
				"Jayce can attack in melee or at range. Pay attention to his stance and weapon color to know how he is going to attack.",
				"If you see Jayce drop his Acceleration Gate, be careful, he is probably about to cast Shock Blast.",
				"Jayce is strong in the early game. If he gains the advantage, play defensively."
			],
			"tags": [
				"Fighter",
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 4,
				"magic": 3,
				"difficulty": 7
			},
			"stats": {
				"hp": 576,
				"hpperlevel": 95,
				"mp": 357.2,
				"mpperlevel": 37,
				"movespeed": 335,
				"armor": 27,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 125,
				"hpregen": 7.5,
				"hpregenperlevel": 0.8,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 58,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "JayceToTheSkies",
					"name": "To the Skies! / Shock Blast",
					"description": "Hammer Stance: Leaps to an enemy dealing physical damage and slowing enemies.<br><br>Cannon Stance: Fires an orb of electricity that detonates upon hitting an enemy (or reaching the end of its path) dealing physical damage to all enemies hit.",
					"tooltip": "Leaps to an enemy dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and slowing them by {{ e3 }}% for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Slow"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 6,
					"cooldown": [
						16,
						14,
						12,
						10,
						8,
						6
					],
					"cooldownBurn": "16/14/12/10/8/6",
					"cost": [
						40,
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							45,
							80,
							115,
							150,
							185,
							220
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5,
							2
						],
						[
							30,
							35,
							40,
							45,
							50,
							55
						],
						[
							20,
							40,
							60,
							80,
							0,
							0
						],
						[
							2,
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"45/80/115/150/185/220",
						"1.5/1.5/1.5/1.5/1.5/2",
						"30/35/40/45/50/55",
						"20/40/60/80/0/0",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "JayceToTheSkies.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JayceStaticField",
					"name": "Lightning Field / Hyper Charge",
					"description": "Hammer Stance: Passive: Restores Mana per strike. Active: Creates a field of lightning damaging nearby enemies for several seconds.<br><br>Cannon Stance: Gains a burst of energy, increasing Attack Speed to maximum for several attacks.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Gains {{ e5 }} Mana per strike while in Hammer Stance.<br /><br /><span class=\"colorFF9900\">Active:</span> Creates an electric aura dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e2 }} seconds to nearby enemies.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Return"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e5 }} -> {{ e5NL }}"
						]
					},
					"maxrank": 6,
					"cooldown": [
						10,
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						40,
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							25,
							35,
							45,
							55,
							65,
							75
						],
						[
							4,
							4,
							4,
							4,
							4,
							4
						],
						[
							25,
							30,
							35,
							40,
							45,
							50
						],
						[
							100,
							160,
							220,
							280,
							340,
							400
						],
						[
							6,
							8,
							10,
							12,
							14,
							16
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/35/45/55/65/75",
						"4",
						"25/30/35/40/45/50",
						"100/160/220/280/340/400",
						"6/8/10/12/14/16",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						285,
						285,
						285,
						285,
						285,
						285
					],
					"rangeBurn": "285",
					"image": {
						"full": "JayceStaticField.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JayceThunderingBlow",
					"name": "Thundering Blow / Acceleration Gate",
					"description": "Hammer Stance: Deals magic damage to an enemy and knocks them back a short distance.<br><br>Cannon Stance: Deploys an Acceleration Gate increasing the Movement Speed of all allied champions who pass through it. If Shock Blast is fired through the gate the missile speed, range, and damage will increase.",
					"tooltip": "Deals {{ e4 }}% of the target's maximum health <span class=\"colorFF8C00\">(+{{ a1 }})</span> as magic damage and knocks them back a short distance. ({{ e1 }} Maximum Damage against monsters)",
					"leveltip": {
						"label": [
							"Maximum Health %",
							"Cooldown",
							"Maximum Damage against monsters"
						],
						"effect": [
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 6,
					"cooldown": [
						20,
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "20/18/16/14/12/10",
					"cost": [
						55,
						55,
						55,
						55,
						55,
						55
					],
					"costBurn": "55",
					"effect": [
						null,
						[
							200,
							300,
							400,
							500,
							600,
							700
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							10,
							20,
							30,
							40,
							50,
							60
						],
						[
							8,
							10.4,
							12.8,
							15.2,
							17.6,
							20
						],
						[
							40,
							70,
							100,
							130,
							160,
							190
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/300/400/500/600/700",
						"0.25",
						"10/20/30/40/50/60",
						"8/10.4/12.8/15.2/17.6/20",
						"40/70/100/130/160/190",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						240,
						240,
						240,
						240,
						240,
						240
					],
					"rangeBurn": "240",
					"image": {
						"full": "JayceThunderingBlow.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JayceStanceHtG",
					"name": "Mercury Cannon / Mercury Hammer",
					"description": "Hammer Stance: Transforms the Mercury Hammer into the Mercury Cannon gaining new abilities and increased range. The first attack in this form reduces the target's Armor and Magic Resist.<br><br>Cannon Stance: Transforms the Mercury Cannon into the Mercury Hammer gaining new abilities and increasing Armor and Magic Resist. The first attack in this form deals additional magic damage.",
					"tooltip": "<span class=\"colorFF8C00\">Active: </span>Transforms the Mercury Hammer into the Mercury Cannon gaining new abilities and ranged attacks.<br /><br />The next attack in Cannon Stance reduces the target's Armor and Magic Resist by {{ f3 }}% for {{ e3 }} seconds.",
					"maxrank": 1,
					"cooldown": [
						6
					],
					"cooldownBurn": "6",
					"cost": [
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							5
						],
						[
							10
						],
						[
							5
						],
						[
							5
						],
						[
							20
						],
						[
							0
						],
						[
							0
						],
						[
							0
						],
						[
							0
						],
						[
							0
						]
					],
					"effectBurn": [
						null,
						"5",
						"10",
						"5",
						"5",
						"20",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "JayceStanceHtG.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Hextech Capacitor",
				"description": "After casting Transform Jayce gains 40 Movement Speed and can move through units for the next 1.25 seconds.",
				"image": {
					"full": "Jayce_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Jayce",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3008",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3155",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jayce",
					"title": "JayceTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Jhin": {
			"id": "Jhin",
			"key": "202",
			"name": "Jhin",
			"title": "the Virtuoso",
			"image": {
				"full": "Jhin.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 240,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "202000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "202001",
					"num": 1,
					"name": "High Noon Jhin",
					"chromas": false
				},
				{
					"id": "202002",
					"num": 2,
					"name": "Blood Moon Jhin",
					"chromas": false
				},
				{
					"id": "202003",
					"num": 3,
					"name": "SKT T1 Jhin",
					"chromas": false
				},
				{
					"id": "202004",
					"num": 4,
					"name": "PROJECT: Jhin",
					"chromas": false
				}
			],
			"lore": "Jhin is a meticulous criminal psychopath who believes murder is art. Once an Ionian prisoner, but freed by shadowy elements within Ionia's ruling council, the serial killer now works as their cabal's assassin. Using his gun as his paintbrush, Jhin creates works of artistic brutality, horrifying victims and onlookers. He gains a cruel pleasure from putting on his gruesome theater, making him the ideal choice to send the most powerful of messages: terror.",
			"blurb": "Jhin is a meticulous criminal psychopath who believes murder is art. Once an Ionian prisoner, but freed by shadowy elements within Ionia's ruling council, the serial killer now works as their cabal's assassin. Using his gun as his paintbrush, Jhin...",
			"allytips": [
				"Deadly Flourish has incredible range. When approaching a fight be sure to look ahead for enemies that could be rooted.",
				"Your ultimate deals significantly less damage to enemies with full health. Look to pick off weakened targets as they run away.",
				"You can still cast your spells while reloading. Use them to fill the down time."
			],
			"enemytips": [
				"Deadly Flourish only roots those hit by one of Jhin's basic attacks, traps, or allies within the last 4 seconds.",
				"Jhin places invisible traps around the map. Watch where you step!",
				"Jhin's attacks are quite potent, but he runs out of ammo after the 4th shot. Use this window to jump him and burst him down."
			],
			"tags": [
				"Marksman",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 10,
				"defense": 2,
				"magic": 6,
				"difficulty": 6
			},
			"stats": {
				"hp": 540,
				"hpperlevel": 85,
				"mp": 300,
				"mpperlevel": 50,
				"movespeed": 330,
				"armor": 29,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61,
				"attackdamageperlevel": 4,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 0
			},
			"spells": [
				{
					"id": "JhinQ",
					"name": "Dancing Grenade",
					"description": "Jhin launches a magical cartridge at an enemy. It can hit up to four targets and gains damage each time it kills.",
					"tooltip": "Jhin launches a cartridge at the targeted enemy that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }}) </span>physical damage before bouncing to a nearby target that has not yet been hit.<br /><br />The cartridge can hit a maximum of 4 times. Each kill by the cartridge increases the damage of subsequent hits by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Total AD Ratio",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							45,
							70,
							95,
							120,
							145
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							0.4,
							0.45,
							0.5,
							0.55,
							0.6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"45/70/95/120/145",
						"35",
						"0.4/0.45/0.5/0.55/0.6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "JhinQ.png",
						"sprite": "spell4.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JhinW",
					"name": "Deadly Flourish",
					"description": "Jhin brandishes his cane, firing a single shot with incredible range. It pierces through minions and monsters, but stops on the first champion hit. If the target was recently struck by Jhin's allies, lotus traps, or basic attacks, they are rooted.",
					"tooltip": "Jhin fires a long range shot that stops on the first champion hit, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to it, and {{ e4 }}% of that damage to minions and monsters hit along the way.<br /><br />If Deadly Flourish strikes a champion that has been hit by one of Jhin's basic attacks, Lotus Traps, or allies within the last 4 seconds it will root them for {{ e2 }} seconds and grants Jhin movement speed as though he had <span class=\"colorFF5802\">crit</span> them.",
					"leveltip": {
						"label": [
							"Damage",
							"Root Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						14,
						14,
						14,
						14
					],
					"cooldownBurn": "14",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							50,
							85,
							120,
							155,
							190
						],
						[
							0.75,
							1,
							1.25,
							1.5,
							1.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/85/120/155/190",
						"0.75/1/1.25/1.5/1.75",
						"0",
						"75",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3000,
						3000,
						3000,
						3000,
						3000
					],
					"rangeBurn": "3000",
					"image": {
						"full": "JhinW.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JhinE",
					"name": "Captive Audience",
					"description": "Jhin places an invisible lotus trap that blooms when walked over. It slows nearby enemies before dealing damage with an explosion of serrated petals. <br><br><font color='#FFFFFF'>Beauty in Death -</font> When Jhin kills an enemy champion, a lotus trap will bloom near their corpse.",
					"tooltip": "Jhin places an invisible Lotus Trap that lasts {{ e5 }} minutes and activates when stepped on, revealing nearby enemies for 4 seconds.<br /><br />The trap leaves behind a zone that slows enemies inside by {{ e7 }}% and detonates after 2 seconds, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage ({{ e1 }}% damage on subsequent hits and vs. minions and monsters).<br /><br />Jhin prepares a new trap every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can store 2 at once. <br /><br /><span class=\"colorFFFFFF\">Beauty in Death -</span> When Jhin kills an enemy champion a Lotus Trap will spawn and detonate where they were killed.",
					"leveltip": {
						"label": [
							"Damage",
							"Recharge Time",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ f1 }} -> {{ f2 }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						2,
						2,
						2,
						2,
						2
					],
					"cooldownBurn": "2",
					"cost": [
						30,
						35,
						40,
						45,
						50
					],
					"costBurn": "30/35/40/45/50",
					"effect": [
						null,
						[
							65,
							65,
							65,
							65,
							65
						],
						[
							20,
							80,
							140,
							200,
							260
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65",
						"20/80/140/200/260",
						"0",
						"0.75",
						"2",
						"0",
						"35",
						"1",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "JhinE.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JhinR",
					"name": "Curtain Call",
					"description": "Jhin channels, transforming Whisper into a shoulder-mounted mega-cannon. It is able to fire 4 super shots at extreme range that pierce through minions and monsters, but stop on the first champion impacted. Whisper cripples enemies hit, which slows them and deals execute damage. The 4th shot is perfectly crafted, epically powerful, and guaranteed to critically strike.",
					"tooltip": "Jhin sets up and channels, enabling him to fire 4 super shots at extreme range in a cone in front of him. The shots stop on the first champion hit, slowing it by {{ e3 }}% for {{ e4 }} seconds and dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage, increased by {{ e5 }}% for each 1% health the target is missing (up to {{ f2 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span>). The 4th shot <span class=\"colorFF5802\">crits</span> for <span class=\"colorFFFFFF\">{{ f1 }}%</span> damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							50,
							125,
							200
						],
						[
							200,
							200,
							200
						],
						[
							80,
							80,
							80
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							1,
							1,
							1
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/125/200",
						"200",
						"80",
						"0.5",
						"2.5",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "JhinR.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Whisper",
				"description": "Jhin's hand cannon, Whisper, is a precise instrument designed to deal superior damage. It fires at a fixed rate and carries only four shots. Jhin imbues the final bullet with dark magics to critically strike and deal bonus execute damage. Whenever Whisper crits, it inspires Jhin with a burst of movement speed.",
				"image": {
					"full": "Jhin_P.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Jhin",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jhin",
					"title": "JhinTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Jinx": {
			"id": "Jinx",
			"key": "222",
			"name": "Jinx",
			"title": "the Loose Cannon",
			"image": {
				"full": "Jinx.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 288,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "222000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "222001",
					"num": 1,
					"name": "Mafia Jinx",
					"chromas": false
				},
				{
					"id": "222002",
					"num": 2,
					"name": "Firecracker Jinx",
					"chromas": true
				},
				{
					"id": "222003",
					"num": 3,
					"name": "Slayer Jinx",
					"chromas": false
				},
				{
					"id": "222004",
					"num": 4,
					"name": "Star Guardian Jinx",
					"chromas": false
				},
				{
					"id": "222012",
					"num": 12,
					"name": "Ambitious Elf Jinx",
					"chromas": false
				}
			],
			"lore": "A manic and impulsive criminal from Zaun, Jinx lives to wreak havoc without care for the consequences. With an arsenal of deadly weapons, she unleashes the loudest blasts and brightest explosions to leave a trail of mayhem and panic in her wake. Jinx despises boredom, and gleefully brings her own chaotic brand of pandemonium wherever she goes.",
			"blurb": "A manic and impulsive criminal from Zaun, Jinx lives to wreak havoc without care for the consequences. With an arsenal of deadly weapons, she unleashes the loudest blasts and brightest explosions to leave a trail of mayhem and panic in her wake. Jinx...",
			"allytips": [
				"Rockets aren't always the best choice! Jinx's minigun is incredibly powerful when fully ramped up. Switch to it whenever an enemy champion gets too close.",
				"Jinx's rockets deal full damage to all enemies in the explosion. Use them on minions in lane to hit nearby enemy champions without drawing minion aggro.",
				"When a fight starts try to stay on the edge of fray by poking with rockets and Zap!. Do not run in and unload with the minigun until you feel it is safe."
			],
			"enemytips": [
				"Jinx's minigun takes time to ramp up. If you see her poking with rockets try to jump on her and burst her down.",
				"Jinx's ultimate does less damage the closer you are to her.",
				"Jinx's snare grenades have a long cooldown and are her primary means of protecting herself. If she misses with them she will have a hard time escaping if engaged upon. "
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 2,
				"magic": 4,
				"difficulty": 6
			},
			"stats": {
				"hp": 515,
				"hpperlevel": 82,
				"mp": 245,
				"mpperlevel": 45,
				"movespeed": 325,
				"armor": 32,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 6,
				"hpregenperlevel": 0.5,
				"mpregen": 6.7,
				"mpregenperlevel": 1,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61,
				"attackdamageperlevel": 2.7,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1
			},
			"spells": [
				{
					"id": "JinxQ",
					"name": "Switcheroo!",
					"description": "Jinx modifies her basic attacks by swapping between Pow-Pow, her minigun and Fishbones, her rocket launcher. Attacks with Pow-Pow grant Attack Speed, while attacks with Fishbones deal area of effect damage, gain increased range, and drain Mana.",
					"tooltip": "Jinx swaps weapons.<br /><br /><span class=\"colorFF9900\">Fishbones, the Rocket Launcher:</span> Basic attacks deal 110% Damage to the target and nearby enemies, gain {{ e3 }} range, drain Mana, and scale {{ e5 }}% less with bonus Attack Speed.<br /><br /><span class=\"colorFF9900\">Pow-Pow, the Minigun:</span> Basic attacks grant bonus Attack Speed for 2.5 seconds. This effect stacks up to 3 times for a total bonus of {{ e1 }}%.<br /><br /><rules>Stacks fall off one at a time and only benefit Jinx's first attack after switching to Rocket Launcher.</rules>",
					"leveltip": {
						"label": [
							"Rocket Bonus Range",
							"Minigun Total Attack Speed"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1,
						1,
						1,
						1,
						1
					],
					"cooldownBurn": "1",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							30,
							55,
							80,
							105,
							130
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							75,
							100,
							125,
							150,
							175
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							33.25,
							33.25,
							33.25,
							33.25,
							33.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/55/80/105/130",
						"100",
						"75/100/125/150/175",
						"0",
						"25",
						"33.25",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana per Rocket",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "JinxQ.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana per Rocket"
				},
				{
					"id": "JinxW",
					"name": "Zap!",
					"description": "Jinx uses Zapper, her shock pistol, to fire a blast that deals damage to the first enemy hit, slowing and revealing it.",
					"tooltip": "Jinx fires a shock blast that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage to the first enemy hit, revealing it and slowing it by {{ e2 }}% for 2 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7,
						6,
						5,
						4
					],
					"cooldownBurn": "8/7/6/5/4",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							10,
							60,
							110,
							160,
							210
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/60/110/160/210",
						"30/40/50/60/70",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1450,
						1450,
						1450,
						1450,
						1450
					],
					"rangeBurn": "1450",
					"image": {
						"full": "JinxW.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JinxE",
					"name": "Flame Chompers!",
					"description": "Jinx throws out a line of snare grenades that explode after 5 seconds, lighting enemies on fire. Flame Chompers will bite enemy champions who walk over them, rooting them in place.",
					"tooltip": "Jinx tosses out 3 chompers that, once armed, explode on contact with enemy champions, rooting the target for 1.5 seconds and stopping in-progress movement abilities on the spot before dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage over 1.5 seconds to nearby enemies. Chompers last for 5 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						20.5,
						17,
						13.5,
						10
					],
					"cooldownBurn": "24/20.5/17/13.5/10",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							70,
							120,
							170,
							220,
							270
						],
						[
							100,
							140,
							180,
							220,
							260
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							35,
							50,
							65,
							80,
							95
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/120/170/220/270",
						"100/140/180/220/260",
						"30/35/40/45/50",
						"35/50/65/80/95",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "JinxE.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JinxR",
					"name": "Super Mega Death Rocket!",
					"description": "Jinx fires a super rocket across the map that gains damage as it travels. The rocket will explode upon colliding with an enemy champion, dealing damage to it and surrounding enemies based on their missing Health. ",
					"tooltip": "Jinx fires a rocket that gains damage over the first second it travels. It explodes on the first enemy champion hit, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> to {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> Physical Damage plus {{ e3 }}% of the target's missing Health. Nearby enemies take 80% Damage.",
					"leveltip": {
						"label": [
							"Minimum Damage",
							"Maximum Damage",
							"Percent Missing Health Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						90,
						75,
						60
					],
					"cooldownBurn": "90/75/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							25,
							35,
							45
						],
						[
							250,
							350,
							450
						],
						[
							25,
							30,
							35
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/35/45",
						"250/350/450",
						"25/30/35",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.15,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1.5,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "JinxR.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Get Excited!",
				"description": "Jinx receives massively increased Movement Speed and stacking Attack Speed whenever she damages an enemy champion, tower, or inhibitor that is then killed or destroyed within 3 seconds.",
				"image": {
					"full": "Jinx_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Jinx",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Jinx",
					"title": "JinxTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2015",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Kalista": {
			"id": "Kalista",
			"key": "429",
			"name": "Kalista",
			"title": "the Spear of Vengeance",
			"image": {
				"full": "Kalista.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 336,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "429000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "429001",
					"num": 1,
					"name": "Blood Moon Kalista",
					"chromas": false
				},
				{
					"id": "429002",
					"num": 2,
					"name": "Championship Kalista",
					"chromas": false
				},
				{
					"id": "429003",
					"num": 3,
					"name": "SKT T1 Kalista",
					"chromas": false
				}
			],
			"lore": "A specter of wrath and retribution, Kalista is the undying spirit of vengeance, an armored nightmare summoned from the Shadow Isles to hunt deceivers and traitors. The betrayed may cry out in blood to be avenged, but Kalista only answers those willing to pay with their very souls. Those who become the focus of Kalista's wrath should make their final peace, for any pact sealed with this grim hunter can only end with the cold, piercing fire of her soul-spears.",
			"blurb": "A specter of wrath and retribution, Kalista is the undying spirit of vengeance, an armored nightmare summoned from the Shadow Isles to hunt deceivers and traitors. The betrayed may cry out in blood to be avenged, but Kalista only answers those willing...",
			"allytips": [
				"Rend is a valuable last hitting aid, since its cooldown resets if it kills a target. ",
				"Entering a move order once to trigger Martial Poise will not clear Kalista's basic attack target.",
				"Due to her passive, Kalista's Movement Speed is effectively increased by Attack Speed."
			],
			"enemytips": [
				"Kalista's mobility is dependent upon attacking. This means it is low when she is outside of her attack range and that Attack Speed slows reduce the amount of distance she can cover in an engagement.",
				"Kalista cannot cancel her basic attack wind up. While she is very mobile, this offers a window to land spells on her if you anticipate when she will begin attacking.",
				"If you can break line of sight from Kalista, including through brush, her basic attacks will miss you, falling harmlessly to the ground."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 2,
				"magic": 4,
				"difficulty": 7
			},
			"stats": {
				"hp": 517.76,
				"hpperlevel": 83,
				"mp": 231.8,
				"mpperlevel": 35,
				"movespeed": 325,
				"armor": 28,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 6,
				"hpregenperlevel": 0.55,
				"mpregen": 6.3,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 2.9,
				"attackspeedoffset": -0.1,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "KalistaMysticShot",
					"name": "Pierce",
					"description": "Throw a fast moving spear that passes through enemies it kills.",
					"tooltip": "Hurl a fast but narrow spear that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. Triggers <span class=\"colorFFFFFF\"><i>Martial Poise</i> (P)</span>, <span class=\"colorFFFFFF\"><i>Sentinel</i> (W)</span>, and <span class=\"colorFFFFFF\"><i>Rend</i> (E)</span>.<br /><br /><span class=\"colorFFFF00\">If it kills a target, </span><span class=\"colorFFFFFF\"><i>Pierce</i></span><span class=\"colorFFFF00\"> continues onward, passing all stacks of <span class=\"colorFFFFFF\"><i>Rend</i></span> to the next target.</span>",
					"leveltip": {
						"label": [
							"Mana Cost",
							"Damage"
						],
						"effect": [
							"{{ cost }} -> {{ costNL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							10,
							70,
							130,
							190,
							250
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/70/130/190/250",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1150,
						1150,
						1150,
						1150,
						1150
					],
					"rangeBurn": "1150",
					"image": {
						"full": "KalistaMysticShot.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KalistaW",
					"name": "Sentinel",
					"description": "Passively gain Attack Damage when near her Oathsworn ally, and deal bonus damage when striking the same target. <br><br>Activate to send a soul to scout out the path, revealing the area in front of it.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>When Kalista is near her <i>Oathsworn</i>, she gains {{ e8 }} Attack Damage. If they both basic attack the same target, she deals {{ e2 }}% of their max health as magic damage. {{ e7 }} second cooldown per target.<br /><br /><span class=\"colorFF9900\">Active: </span>Send a soul Sentinel to patrol an unseen area. Champions spotted are revealed for 4 seconds. Sentinels last 3 laps.<br /><br />Kalista gains a charge of Sentinel every {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Passive Attack Damage",
							"Damage",
							"Ammo Recharge"
						],
						"effect": [
							"{{ e8 }} -> {{ e8NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e4 }} -> {{ e4NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						30,
						30,
						30,
						30,
						30
					],
					"cooldownBurn": "30",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							5,
							7.5,
							10,
							12.5,
							15
						],
						[
							125,
							150,
							175,
							200,
							225
						],
						[
							90,
							80,
							70,
							60,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							75,
							100,
							125,
							150,
							175
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							5,
							10,
							15,
							20,
							25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80",
						"5/7.5/10/12.5/15",
						"125/150/175/200/225",
						"90/80/70/60/50",
						"0",
						"75/100/125/150/175",
						"10",
						"5/10/15/20/25",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						5000,
						5000,
						5000,
						5000,
						5000
					],
					"rangeBurn": "5000",
					"image": {
						"full": "KalistaW.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KalistaExpungeWrapper",
					"name": "Rend",
					"description": "Attacks impale their targets with spears. Activate to rip the spears out, slowing and dealing escalating damage.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Kalista's spears pierce their target, lingering for 4 seconds.<br /><br /><span class=\"colorFF9900\">Active: </span>Rip the spears from nearby targets, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slowing their Movement Speed by {{ e2 }}% for {{ e6 }} seconds.</span><br /><br /><span class=\"colorFFFF00\">If </span><span class=\"colorFFFFFF\"><i>Rend</i></span><span class=\"colorFFFF00\"> kills at least one target, its cooldown is reset and it refunds <span class=\"color44DDFF\">{{ e8 }}</span> mana.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Mana Refund",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e8 }} -> {{ e8NL }}",
							"{{ e5 }} -> {{ e5NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							33,
							37.5,
							41.667,
							45.833,
							50
						],
						[
							14,
							12.5,
							11,
							9.5,
							8
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							254,
							254,
							254,
							254,
							254
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							10,
							14,
							19,
							25,
							32
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"25/30/35/40/45",
						"0",
						"33/37.5/41.667/45.833/50",
						"14/12.5/11/9.5/8",
						"2",
						"254",
						"10/15/20/25/30",
						"10/14/19/25/32",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "KalistaExpungeWrapper.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KalistaRx",
					"name": "Fate's Call",
					"description": "Kalista teleports the Oathsworn ally to herself. They gain the ability to dash toward a position, knocking enemy champions back.",
					"tooltip": "Draw Kalista's <i>Oathsworn</i> to her. For up to 4 seconds, the Oathsworn is untargetable and pacified.<br /><br />The Oathsworn may mouse click to fly toward target position, stopping at the first enemy champion hit and knocking all enemies in a small radius back.<br /><br />Kalista's Oathsworn must be within 1100 units for her to cast this ability.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Knock Up Duration"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						150,
						120,
						90
					],
					"cooldownBurn": "150/120/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							0,
							0,
							0
						],
						[
							1.5,
							1.75,
							2
						],
						[
							40,
							60,
							80
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"1.5/1.75/2",
						"40/60/80",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "KalistaRx.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Martial Poise",
				"description": "Enter a movement command while winding up Kalista's basic attack or Pierce to lunge a short distance when she launches her attack.",
				"image": {
					"full": "Kalista_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kalista",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kalista",
					"title": "KalistaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Karma": {
			"id": "Karma",
			"key": "43",
			"name": "Karma",
			"title": "the Enlightened One",
			"image": {
				"full": "Karma.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 384,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "43000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "43001",
					"num": 1,
					"name": "Sun Goddess Karma",
					"chromas": false
				},
				{
					"id": "43002",
					"num": 2,
					"name": "Sakura Karma",
					"chromas": false
				},
				{
					"id": "43003",
					"num": 3,
					"name": "Traditional Karma",
					"chromas": false
				},
				{
					"id": "43004",
					"num": 4,
					"name": "Order of the Lotus Karma",
					"chromas": false
				},
				{
					"id": "43005",
					"num": 5,
					"name": "Warden Karma",
					"chromas": false
				},
				{
					"id": "43006",
					"num": 6,
					"name": "Winter Wonder Karma",
					"chromas": false
				},
				{
					"id": "43007",
					"num": 7,
					"name": "Conqueror Karma",
					"chromas": false
				}
			],
			"lore": "No champion exemplifies the spiritual traditions of Ionia more than Karma. She is the living embodiment of an ancient soul reincarnated countless times, carrying all her accumulated memories into each new life. With this insight, she serves as a spiritual beacon to her people, bestowing boundless wisdom and healing in times of crisis. Despite being blessed with power that few could comprehend, she rarely uses her magic for destruction, as it always comes at a considerable cost—both to her, and to the land she holds most dear.",
			"blurb": "No champion exemplifies the spiritual traditions of Ionia more than Karma. She is the living embodiment of an ancient soul reincarnated countless times, carrying all her accumulated memories into each new life. With this insight, she serves as a...",
			"allytips": [
				"Gathering Fire rewards aggressive play. Look to land abilities and basic attacks on your opponent to lower Mantra's cooldown and stay on the offensive.",
				"When using Focused Resolve, slow your opponents with Inner Flame or speed yourself up with Inspire if you're having trouble sticking to a target. ",
				"Don't be too conservative with Mantra. Gathering Fire is strongest in teamfights, making it easy to recharge Mantra multiple times."
			],
			"enemytips": [
				"Karma's passive lowers her Mantra cooldown when she hits enemy champions with abilities and basic attacks. Deny her from getting free hits on you.",
				"Karma's Soulflare erupts for bonus damage in the area in which it's placed. React quickly and escape the circle to avoid taking heavy damage.",
				"Focused Resolve is a strong disengage tool. Create distance to avoid being rooted and seek to engage afterwards."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 7,
				"magic": 8,
				"difficulty": 5
			},
			"stats": {
				"hp": 534,
				"hpperlevel": 95,
				"mp": 374,
				"mpperlevel": 50,
				"movespeed": 335,
				"armor": 20.384,
				"armorperlevel": 3.8,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 8.5,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.544,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.3
			},
			"spells": [
				{
					"id": "KarmaQ",
					"name": "Inner Flame",
					"description": "Karma sends forth a ball of spirit energy that explodes and deals damage upon hitting an enemy unit.<br><br>Mantra Bonus: In addition to the explosion, Mantra increases the destructive power of her Inner Flame, creating a cataclysm which deals damage after a short delay.",
					"tooltip": "Fires a blast of energy that explodes upon enemy contact, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing Movement Speed by {{ e2 }}% for {{ e3 }} seconds. <br /><br /><span class=\"colorFF9900\">Mantra Bonus - Soulflare:</span> Deals {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> additional magic damage and leaves a circle of flame that slows enemies by {{ f3 }}%. After 1.5 seconds the circle erupts, dealing {{ f2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the area.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"25",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "@text",
							"coeff": [
								25,
								75,
								125,
								175
							],
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "@text",
							"coeff": [
								50,
								150,
								250,
								350
							],
							"key": "f2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "KarmaQ.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KarmaSpiritBind",
					"name": "Focused Resolve",
					"description": "Karma creates a tether between herself and a targeted enemy, dealing damage and revealing them. If the tether is not broken, the enemy will be rooted and damaged again.<br><br>Mantra Bonus: Karma strengthens the link, healing herself and extending the root duration.",
					"tooltip": "Links Karma to an enemy champion or monster, granting <span class=\"coloree91d7\">True Sight</span> and dealing {{ effect1amount*0.5 }} <span class=\"color99FF99\">(+{{ f4 }}) </span>magic damage. If the link is unbroken for {{ e3 }} seconds, the target is rooted for {{ e2 }} second(s) and takes an additional {{ effect1amount*0.5 }} <span class=\"color99FF99\">(+{{ f4 }}) </span>magic damage.<br /><br /><span class=\"colorFF9900\">Mantra Bonus - Renewal:</span> Karma is healed for {{ f1 }}% <span class=\"color99FF99\">(+{{ f3 }}%)</span> of her missing health. If the link is not broken or the target dies, the root duration is increased by {{ f2 }} second(s) and Karma is healed for {{ f1 }}% <span class=\"color99FF99\">(+{{ f3 }}%)</span> of her missing health.",
					"leveltip": {
						"label": [
							"Damage",
							"Root Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ effect1amount*0.5 }} -> {{ effect1amountnl*0.5 }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							825,
							825,
							825,
							825,
							825
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/110/160/210/260",
						"1/1.25/1.5/1.75/2",
						"2",
						"2",
						"825",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "@text",
							"coeff": [
								75,
								150,
								225,
								300
							],
							"key": "f1"
						},
						{
							"link": "@text",
							"coeff": [
								75,
								150,
								225,
								300
							],
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						675,
						675,
						675,
						675,
						675
					],
					"rangeBurn": "675",
					"image": {
						"full": "KarmaSpiritBind.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KarmaSolKimShield",
					"name": "Inspire",
					"description": "Karma summons a protective shield that absorbs incoming damage and increases the Movement Speed of the protected ally.<br><br>Mantra Bonus: Energy radiates out from her target, strengthening the initial shield and applying Inspire to nearby allied champions.",
					"tooltip": "Target ally gains a shield, granting {{ e3 }}% Movement Speed for {{ e2 }} seconds and absorbing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for {{ e4 }} seconds.<br /><br /><span class=\"colorFF9900\">Mantra Bonus - Defiance:</span> The shield overflows with energy, absorbing an additional {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage. Nearby allied champions gain shields that absorb {{ f2 }}% as much as the initial target's shield. All champions shielded gain {{ f3 }}% movement speed for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage Absorption",
							"Movement Speed",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9.5,
						9,
						8.5,
						8
					],
					"cooldownBurn": "10/9.5/9/8.5/8",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							70,
							95,
							120,
							145,
							170
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/95/120/145/170",
						"1.5",
						"40/45/50/55/60",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "@text",
							"coeff": [
								60,
								140,
								220,
								300
							],
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "KarmaSolKimShield.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KarmaMantra",
					"name": "Mantra",
					"description": "Karma empowers her next ability to do an additional effect. Mantra is available at level 1 and does not require a skill point.",
					"tooltip": "Karma empowers her next ability within 8 seconds for an additional effect. <br /><br /><span class=\"colorFF9900\">Soulflare: </span>Deals bonus damage and leaves behind a circle of flame, slowing enemies and dealing additional damage. <br /><br /><span class=\"colorFF9900\">Renewal: </span>Karma heals for a portion of her missing health. If the link is unbroken the root is longer and Karma is healed again.<br /><br /><span class=\"colorFF9900\">Defiance: </span>The shield is stronger and allied champions around the target also gain a shield and movement speed.",
					"leveltip": {
						"label": [
							"Soulflare Impact",
							"Soulflare Circle Damage",
							"Renewal Root Extension",
							"Defiance Shield",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 4,
					"cooldown": [
						45,
						42,
						39,
						36
					],
					"cooldownBurn": "45/42/39/36",
					"cost": [
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							25,
							75,
							125,
							175
						],
						[
							50,
							150,
							250,
							350
						],
						[
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0.5,
							0.75,
							1,
							1.25
						],
						[
							0.2,
							0.2,
							0.2,
							0.2
						],
						[
							30,
							90,
							150,
							210
						],
						[
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							0.3,
							0.3,
							0.3,
							0.3
						],
						[
							0.01,
							0.01,
							0.01,
							0.01
						]
					],
					"effectBurn": [
						null,
						"25/75/125/175",
						"50/150/250/350",
						"0.5",
						"1.5",
						"0.5/0.75/1/1.25",
						"0.2",
						"30/90/150/210",
						"0.6",
						"0.3",
						"0.01"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "KarmaMantra.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Gathering Fire",
				"description": "Reduces Mantra's cooldown each time Karma damages an enemy champion with one of her abilities (Half-effect for Karma's basic attacks)",
				"image": {
					"full": "Karma_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Karma",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaSRMid",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karma",
					"title": "KarmaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Karthus": {
			"id": "Karthus",
			"key": "30",
			"name": "Karthus",
			"title": "the Deathsinger",
			"image": {
				"full": "Karthus.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 432,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "30000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "30001",
					"num": 1,
					"name": "Phantom Karthus",
					"chromas": false
				},
				{
					"id": "30002",
					"num": 2,
					"name": "Statue of Karthus",
					"chromas": false
				},
				{
					"id": "30003",
					"num": 3,
					"name": "Grim Reaper Karthus",
					"chromas": true
				},
				{
					"id": "30004",
					"num": 4,
					"name": "Pentakill Karthus",
					"chromas": false
				},
				{
					"id": "30005",
					"num": 5,
					"name": "Fnatic Karthus",
					"chromas": false
				},
				{
					"id": "30009",
					"num": 9,
					"name": "Karthus Lightsbane",
					"chromas": false
				}
			],
			"lore": "The harbinger of oblivion, Karthus is an undying spirit whose haunting songs are a prelude to the horror of his nightmarish appearance. The living fear the eternity of undeath, but Karthus sees only beauty and purity in its embrace, a perfect union of life and death. When Karthus emerges from the Shadow Isles, it is to bring the joy of death to mortals, an apostle of the unliving.",
			"blurb": "The harbinger of oblivion, Karthus is an undying spirit whose haunting songs are a prelude to the horror of his nightmarish appearance. The living fear the eternity of undeath, but Karthus sees only beauty and purity in its embrace, a perfect union of...",
			"allytips": [
				"Ask your allies to help point out when you should use Requiem to get kills in different lanes.",
				"Lay Waste is very strong at farming minions and harassing enemy champions."
			],
			"enemytips": [
				"Karthus can cast spells for a short duration after he is killed. Move away from his corpse to be safe.",
				"Make sure you always have enough health to survive Requiem, even if you have to go back to the base more frequently to heal."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 2,
				"magic": 10,
				"difficulty": 7
			},
			"stats": {
				"hp": 528,
				"hpperlevel": 87,
				"mp": 372.48,
				"mpperlevel": 61,
				"movespeed": 335,
				"armor": 20.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 450,
				"hpregen": 6.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 45.66,
				"attackdamageperlevel": 3.25,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.11
			},
			"spells": [
				{
					"id": "KarthusLayWasteA1",
					"name": "Lay Waste",
					"description": "Karthus unleashes a delayed blast at a location, dealing damage to nearby enemies.",
					"tooltip": "Creates a delayed blast at Karthus' cursor position dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to each nearby enemy.<br /><br />If the blast hits only a single unit it deals double damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						20,
						26,
						32,
						38,
						44
					],
					"costBurn": "20/26/32/38/44",
					"effect": [
						null,
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/60/80/100/120",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						875,
						875,
						875,
						875,
						875
					],
					"rangeBurn": "875",
					"image": {
						"full": "KarthusLayWasteA1.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KarthusWallOfPain",
					"name": "Wall of Pain",
					"description": "Karthus creates a passable screen of leeching energy. Any enemy units that walk through the screen have their Movement Speed and Magic Resist reduced for a period.",
					"tooltip": "Creates a wall that lasts for {{ e4 }} seconds. Enemies that pass through the wall have their Magic Resist reduced by {{ e1 }}% and Movement Speed reduced by {{ e3 }}% for {{ e5 }} seconds (their Movement Speed gradually recovers over the duration).",
					"leveltip": {
						"label": [
							"Wall Width",
							"Movement Speed Slow"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							" {{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						18,
						18,
						18,
						18
					],
					"cooldownBurn": "18",
					"cost": [
						100,
						100,
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							800,
							900,
							1000,
							1100,
							1200
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15",
						"800/900/1000/1100/1200",
						"40/50/60/70/80",
						"5",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "KarthusWallOfPain.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KarthusDefile",
					"name": "Defile",
					"description": "Karthus passively steals energy from his victims, gaining Mana on each kill. Alternatively, Karthus can surround himself in the souls of his prey, dealing damage to nearby enemies, but quickly draining his own Mana.  ",
					"tooltip": "<span class=\"colorFF9900\">Toggle Off: </span>When Karthus kills a unit, he restores {{ e2 }} Mana.<br /><br /><span class=\"colorFF9900\">Toggle On: </span>Drains {{ cost }} Mana to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies each second. ",
					"leveltip": {
						"label": [
							"Damage per second",
							"Mana Restore",
							"Mana Cost per second"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.5,
						0.5,
						0.5,
						0.5,
						0.5
					],
					"cooldownBurn": "0.5",
					"cost": [
						30,
						42,
						54,
						66,
						78
					],
					"costBurn": "30/42/54/66/78",
					"effect": [
						null,
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							20,
							27,
							34,
							41,
							48
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/50/70/90/110",
						"20/27/34/41/48",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana Per Second",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "KarthusDefile.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana Per Second"
				},
				{
					"id": "KarthusFallenOne",
					"name": "Requiem",
					"description": "After channeling for 3 seconds, Karthus deals damage to all enemy champions.",
					"tooltip": "After channeling for 3 seconds, Karthus deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemy champions (regardless of distance). ",
					"leveltip": {
						"label": [
							"Damage",
							"Mana cost",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						200,
						180,
						160
					],
					"cooldownBurn": "200/180/160",
					"cost": [
						150,
						175,
						200
					],
					"costBurn": "150/175/200",
					"effect": [
						null,
						[
							250,
							400,
							550
						],
						[
							200,
							300,
							400
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250/400/550",
						"200/300/400",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						10000,
						10000,
						10000
					],
					"rangeBurn": "10000",
					"image": {
						"full": "KarthusFallenOne.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Death Defied",
				"description": "Upon dying, Karthus enters a spirit form that allows him to continue casting spells for 7 seconds.",
				"image": {
					"full": "Karthus_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Karthus",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Karthus",
					"title": "KarthusTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Kassadin": {
			"id": "Kassadin",
			"key": "38",
			"name": "Kassadin",
			"title": "the Void Walker",
			"image": {
				"full": "Kassadin.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 0,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "38000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "38001",
					"num": 1,
					"name": "Festival Kassadin",
					"chromas": false
				},
				{
					"id": "38002",
					"num": 2,
					"name": "Deep One Kassadin",
					"chromas": false
				},
				{
					"id": "38003",
					"num": 3,
					"name": "Pre-Void Kassadin",
					"chromas": false
				},
				{
					"id": "38004",
					"num": 4,
					"name": "Harbinger Kassadin",
					"chromas": false
				},
				{
					"id": "38005",
					"num": 5,
					"name": "Cosmic Reaver Kassadin",
					"chromas": false
				}
			],
			"lore": "Cutting a burning swath through the darkest places of the world, Kassadin knows his days are numbered. Though once a notorious adventurer, he had chosen to live anonymously and raise a family among the nomad tribes of Shurima—until the day his daughter was claimed by the Void. Kassadin vowed to bring her back, combining a number of arcane artifacts and forbidden technologies for the struggle ahead. His precautions were not enough, however, and these devices now only serve to slow the insidious corruption that ravages his body... but he will gladly pay that price, if only he can save her...",
			"blurb": "Cutting a burning swath through the darkest places of the world, Kassadin knows his days are numbered. Though once a notorious adventurer, he had chosen to live anonymously and raise a family among the nomad tribes of Shurima—until the day his daughter...",
			"allytips": [
				"Kassadin has multiple item paths; he can go caster via Mana and Ability Power or anti-caster with Cooldown Reduction and Magic Resist.",
				"Kassadin's ultimate has many uses and is on a shorter cooldown than most, use it often.",
				"Try to get the Ancient Golem buff to counteract Riftwalk's increasing Mana cost."
			],
			"enemytips": [
				"Kassadin deals mostly magic damage. If he's doing well consider buying magic resist items like Mercury's Treads and Banshee's Veil.",
				"Each time Kassadin consecutively uses Riftwalk, he pays more and more mana. Keep this in mind as you chase him.",
				"It takes 6 spell casts for Kassadin's slow, Force Pulse, to become castable. If he levels up that ability, judiciously use your own skills while laning against him."
			],
			"tags": [
				"Assassin",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 5,
				"magic": 8,
				"difficulty": 8
			},
			"stats": {
				"hp": 576,
				"hpperlevel": 90,
				"mp": 397.6,
				"mpperlevel": 67,
				"movespeed": 340,
				"armor": 23.376,
				"armorperlevel": 3.2,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 150,
				"hpregen": 8,
				"hpregenperlevel": 0.5,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 58.852,
				"attackdamageperlevel": 3.9,
				"attackspeedoffset": -0.023,
				"attackspeedperlevel": 3.7
			},
			"spells": [
				{
					"id": "NullLance",
					"name": "Null Sphere",
					"description": "Kassadin fires an orb of void energy at a target, dealing damage and interrupting channels. The excess energy forms around himself, granting a temporary shield that absorbs magic damage.",
					"tooltip": "Kassadin fires an orb of void energy that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and interrupts channels.<br /><br />The excess energy forms around himself, granting a shield that absorbs {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Shield",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							65,
							95,
							125,
							155,
							185
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/95/125/155/185",
						"0",
						"40/70/100/130/160",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "NullLance.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NetherBlade",
					"name": "Nether Blade",
					"description": "Passive: Kassadin's basic attacks deal bonus magic damage. Active: Kassadin's next basic attack deals significant bonus magic damage and restores Mana.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Kassadin's basic attacks draw energy from the void, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage.<br /><br /><span class=\"colorFF9900\">Active: </span>Kassadin charges his Nether Blade, causing his next basic attack to deal {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus magic damage and restore <span class=\"color44DDFF\">{{ e1 }}% of his missing Mana</span> (increases to <span class=\"color44DDFF\">{{ e4 }}%</span> against champions).",
					"leveltip": {
						"label": [
							"Active Damage",
							"Base Mana Restore",
							"Champion Mana Restore"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e4 }}% -> {{ e4NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						7,
						7,
						7,
						7
					],
					"cooldownBurn": "7",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							4,
							5,
							6,
							7,
							8
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/5/6/7/8",
						"20",
						"40/65/90/115/140",
						"20/25/30/35/40",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "NetherBlade.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "ForcePulse",
					"name": "Force Pulse",
					"description": "Kassadin draws energy from spells cast in his vicinity. Upon charging up, Kassadin can use Force Pulse to damage and slow enemies in a cone in front of him.",
					"tooltip": "Kassadin draws energy from spells cast in his vicinity, gaining a charge whenever a spell is cast near him.<br /><br />Upon reaching 6 charges, Kassadin can use Force Pulse to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slow enemies by {{ e2 }}% for {{ e3 }} second in a cone in front of him.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow %",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						5,
						5,
						5,
						5
					],
					"cooldownBurn": "5",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							80,
							105,
							130,
							155,
							180
						],
						[
							50,
							60,
							70,
							80,
							90
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/105/130/155/180",
						"50/60/70/80/90",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "ForcePulse.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RiftWalk",
					"name": "Riftwalk",
					"description": "Kassadin teleports to a nearby location dealing damage to nearby enemy units. Multiple Riftwalks in a short period of time cost additional Mana but also deal additional damage.",
					"tooltip": "Kassadin teleports to a nearby location dealing {{ e1 }} <span class=\"color44DDFF\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to surrounding enemy units.<br /><br />Each subsequent Riftwalk within the next {{ e2 }} seconds doubles the Mana cost and deals an additional {{ e3 }} <span class=\"color44DDFF\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ f3 }})</span> magic damage per stack, stacking up to {{ e6 }} times.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Damage Per Stack",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						6,
						4,
						2
					],
					"cooldownBurn": "6/4/2",
					"cost": [
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							80,
							100,
							120
						],
						[
							15,
							15,
							15
						],
						[
							40,
							50,
							60
						],
						[
							1,
							1,
							1
						],
						[
							0,
							0,
							0
						],
						[
							4,
							4,
							4
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/100/120",
						"15",
						"40/50/60",
						"1",
						"0",
						"4",
						"2",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "RiftWalk.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Void Stone",
				"description": "Kassadin takes 15% reduced magic damage and ignores unit collision.",
				"image": {
					"full": "Kassadin_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kassadin",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerOdinPromote",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kassadin",
					"title": "KassadinTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Katarina": {
			"id": "Katarina",
			"key": "55",
			"name": "Katarina",
			"title": "the Sinister Blade",
			"image": {
				"full": "Katarina.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 48,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "55000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "55001",
					"num": 1,
					"name": "Mercenary Katarina",
					"chromas": false
				},
				{
					"id": "55002",
					"num": 2,
					"name": "Red Card Katarina",
					"chromas": false
				},
				{
					"id": "55003",
					"num": 3,
					"name": "Bilgewater Katarina",
					"chromas": false
				},
				{
					"id": "55004",
					"num": 4,
					"name": "Kitty Cat Katarina",
					"chromas": false
				},
				{
					"id": "55005",
					"num": 5,
					"name": "High Command Katarina",
					"chromas": false
				},
				{
					"id": "55006",
					"num": 6,
					"name": "Sandstorm Katarina",
					"chromas": false
				},
				{
					"id": "55007",
					"num": 7,
					"name": "Slay Belle Katarina",
					"chromas": false
				},
				{
					"id": "55008",
					"num": 8,
					"name": "Warring Kingdoms Katarina",
					"chromas": true
				},
				{
					"id": "55009",
					"num": 9,
					"name": "PROJECT: Katarina",
					"chromas": false
				},
				{
					"id": "55010",
					"num": 10,
					"name": "Death Sworn Katarina",
					"chromas": false
				}
			],
			"lore": "Decisive in judgment and lethal in combat, Katarina is a Noxian assassin of the highest caliber. Eldest daughter to the legendary General Du Couteau, she made her talents known with swift kills against unsuspecting enemies. Her fiery ambition has driven her to pursue heavily-guarded targets, even at the risk of endangering her allies—but no matter the mission, Katarina will not hesitate to execute her duty amid a whirlwind of serrated daggers.",
			"blurb": "Decisive in judgment and lethal in combat, Katarina is a Noxian assassin of the highest caliber. Eldest daughter to the legendary General Du Couteau, she made her talents known with swift kills against unsuspecting enemies. Her fiery ambition has driven...",
			"allytips": [
				"Picking up Daggers will significantly reduce Shunpo's cooldown.",
				"Try waiting until the other team is distracted with fighting your team, and use Shunpo to teleport into the fray and unleash a devastating Death Lotus.",
				"Using Shunpo on an allied Champion, Dagger, or minion can be a great escape tactic."
			],
			"enemytips": [
				"Katarina's abilities deal magic damage, so even if she's building Attack Damage items, get magic resistance to counter her.",
				"Try to save a disable for when Katarina uses her Death Lotus."
			],
			"tags": [
				"Assassin",
				"Mage"
			],
			"partype": "None",
			"info": {
				"attack": 4,
				"defense": 3,
				"magic": 9,
				"difficulty": 8
			},
			"stats": {
				"hp": 602,
				"hpperlevel": 94,
				"mp": 0,
				"mpperlevel": 0,
				"movespeed": 340,
				"armor": 27.88,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7.5,
				"hpregenperlevel": 0.7,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 58,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2.74
			},
			"spells": [
				{
					"id": "KatarinaQ",
					"name": "Bouncing Blade",
					"description": "Katarina throws a <font color='#FFF673'>Dagger</font> at the target that then bounces to nearby enemies before ricocheting onto the ground.",
					"tooltip": "Katarina throws a <span class=\"colorFFF673\">Dagger</span>, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the target and {{ e4 }} nearby enemies. The dagger then ricochets onto the ground behind the primary target.<br /><br /><span class=\"size16 color8C8C8C\">The dagger always lands 350 units on the opposite side from where it struck the first target, getting there in the same amount of time regardless of how many times it bounces.</span>",
					"leveltip": {
						"label": [
							"Initial Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10,
						9,
						8,
						7
					],
					"cooldownBurn": "11/10/9/8/7",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							75,
							105,
							135,
							165,
							195
						],
						[
							350,
							350,
							350,
							350,
							350
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/105/135/165/195",
						"350",
						"450",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "KatarinaQ.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "KatarinaW",
					"name": "Preparation",
					"description": "Katarina gains a burst of movement speed, tossing a <font color='#FFF673'>Dagger</font> into the air directly above herself.",
					"tooltip": "Katarina tosses a <span class=\"colorFFF673\">Dagger</span> into the air and gains {{ e4 }}% decaying movement speed over {{ e2 }} seconds.</span>",
					"leveltip": {
						"label": [
							"Movement Speed Buff",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						14,
						13,
						12,
						11
					],
					"cooldownBurn": "15/14/13/12/11",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							50,
							60,
							70,
							80,
							90
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"1.25",
						"0",
						"50/60/70/80/90",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "KatarinaW.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "KatarinaEWrapper",
					"name": "Shunpo",
					"description": "Katarina blinks to the target, striking it if its an enemy, or striking the nearest enemy otherwise.",
					"tooltip": "Katarina dashes in the blink of an eye to the target ally, enemy, or <span class=\"colorFFF673\">Dagger</span>. If it is an enemy, Katarina strikes for {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage - otherwise she strikes the nearest enemy in range.<br /><br />Picking up a <span class=\"colorFFF673\">Dagger</span> will reduce Shunpo's cooldown by <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds (<span class=\"colorFFFFFF\">{{ f3*100 }}%</span>).<br /><br /><span class=\"size16 color8C8C8C\">Katarina can blink to any location near the target.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}<Br>{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						12.5,
						11,
						9.5,
						8
					],
					"cooldownBurn": "14/12.5/11/9.5/8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							15,
							30,
							45,
							60,
							75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							14,
							12.5,
							11,
							9.5,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/30/45/60/75",
						"0",
						"14/12.5/11/9.5/8",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "KatarinaEWrapper.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "KatarinaR",
					"name": "Death Lotus",
					"description": "Katarina becomes a flurry of blades, dealing massive magic damage while she channels to the 3 nearest enemy champions.",
					"tooltip": "Katarina becomes a flurry of blades, rapidly throwing knives at the three nearest enemy champions, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage per knife. Total over {{ e3 }} seconds to each enemy: {{ f1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ f3 }})</span> magic damage.<br /><br />Applies Grievous Wounds to all enemies struck, reducing their healing and regeneration by 40%.",
					"leveltip": {
						"label": [
							"Damage Per Knife",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						90,
						60,
						45
					],
					"cooldownBurn": "90/60/45",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							25,
							37.5,
							50
						],
						[
							6,
							6,
							6
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							3,
							3,
							3
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/37.5/50",
						"6",
						"2.5",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.22,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.19,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 3,
							"key": "f1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "KatarinaR.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Voracity",
				"description": "Whenever an enemy champion dies that Katarina has damaged in the last 3 seconds, her ability cooldowns are reduced by 15 seconds.<br><br>If Katarina picks up a <font color='#FFF673'>Dagger</font>, she uses it to slash through all nearby enemies, dealing magic damage.",
				"image": {
					"full": "Katarina_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Katarina",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Katarina",
					"title": "KatarinaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Kayle": {
			"id": "Kayle",
			"key": "10",
			"name": "Kayle",
			"title": "The Judicator",
			"image": {
				"full": "Kayle.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 96,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "10000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "10001",
					"num": 1,
					"name": "Silver Kayle",
					"chromas": false
				},
				{
					"id": "10002",
					"num": 2,
					"name": "Viridian Kayle",
					"chromas": false
				},
				{
					"id": "10003",
					"num": 3,
					"name": "Unmasked Kayle",
					"chromas": false
				},
				{
					"id": "10004",
					"num": 4,
					"name": "Battleborn Kayle",
					"chromas": false
				},
				{
					"id": "10005",
					"num": 5,
					"name": "Judgment Kayle",
					"chromas": false
				},
				{
					"id": "10006",
					"num": 6,
					"name": "Aether Wing Kayle",
					"chromas": false
				},
				{
					"id": "10007",
					"num": 7,
					"name": "Riot Kayle",
					"chromas": false
				},
				{
					"id": "10008",
					"num": 8,
					"name": "Iron Inquisitor Kayle",
					"chromas": false
				},
				{
					"id": "10009",
					"num": 9,
					"name": "Pentakill Kayle",
					"chromas": false
				}
			],
			"lore": "A great hero and the strongest among her kind, Kayle is an angelic warrior dedicated to purging those beyond redemption. After conflict divided her people, she took up her enchanted armor and flaming sword in the name of order, disowning her very flesh and blood in the process. When Kayle descends upon the field of battle, her justice is swift—for none can escape the light of divine and righteous fury.",
			"blurb": "A great hero and the strongest among her kind, Kayle is an angelic warrior dedicated to purging those beyond redemption. After conflict divided her people, she took up her enchanted armor and flaming sword in the name of order, disowning her very flesh...",
			"allytips": [
				"Using Intervention on a high-DPS ally can turn the tides of battle by giving your ally free reign to attack. ",
				"Kayle can effectively do large amounts of damage or support her allies depending on her item build. ",
				"Kayle benefits greatly from Attack Damage and Ability Power, making hybrid items like Nashor's Tooth and Trinity Force very effective on her. ",
				"If you wish to support your allies, items like Locket of the Iron Solari can help you assist teammates."
			],
			"enemytips": [
				"Intervention only grants Kayle or her allies immunity to damage. Slows and stuns can still be applied, so trap them if they're being overzealous.",
				"Kayle is usually a fragile target. If you see her ultimate cast on an ally, switch to attacking her.",
				"Be sure to look at what items Kayle is building to determine what role she is fulfilling on her team."
			],
			"tags": [
				"Fighter",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 6,
				"magic": 7,
				"difficulty": 7
			},
			"stats": {
				"hp": 586,
				"hpperlevel": 105,
				"mp": 322.2,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 26.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.75,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 51,
				"attackdamageperlevel": 2.2,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 2.2
			},
			"spells": [
				{
					"id": "JudicatorReckoning",
					"name": "Reckoning",
					"description": "Blasts an enemy unit with angelic force, dealing damage, slowing Movement Speed, and applying Holy Fervor.",
					"tooltip": "Blasts an enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, slowing their Movement Speed by {{ e2 }}% for {{ e3 }} seconds, and applying a stack of Holy Fervor.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }}  ->  {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							35,
							40,
							45,
							50,
							55
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/110/160/210/260",
						"35/40/45/50/55",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "JudicatorReckoning.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JudicatorDivineBlessing",
					"name": "Divine Blessing",
					"description": "Blesses a target friendly champion, granting them increased Movement Speed and healing them.",
					"tooltip": "Blesses an allied champion, increasing their Movement Speed by {{ e2 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> for {{ e3 }} seconds and healing them for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health.",
					"leveltip": {
						"label": [
							"Healing",
							"Movement Speed",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							18,
							21,
							24,
							27,
							30
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/105/150/195/240",
						"18/21/24/27/30",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.07,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "JudicatorDivineBlessing.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JudicatorRighteousFury",
					"name": "Righteous Fury",
					"description": "Passive: Grants Kayle on Hit magic Damage.  Activate: Ignite Kayle's sword with a holy flame, granting Kayle a ranged attack that damages multiple enemies and deals bonus magic damage.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Kayle's Basic Attacks deal an additional {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage on hit.<br /><br /><span class=\"colorFF9900\">Active: </span>Kayle increases her Attack Range by 400 for 10 seconds and the passive bonus is increased to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and apply spell effects on hit.<br /><br />In addition, deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and applies spell effects on attack to enemies near her target.",
					"leveltip": {
						"label": [
							"Passive Damage",
							"Active Damage",
							"Damage to Nearby Enemies Ratio",
							"Cooldown "
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0.2,
							0.25,
							0.3,
							0.35,
							0.4
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"20/25/30/35/40",
						"0.2/0.25/0.3/0.35/0.4",
						"10/15/20/25/30",
						"10",
						"400",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": [
								0.2,
								0.25,
								0.3,
								0.35,
								0.4
							],
							"key": "f2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "JudicatorRighteousFury.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JudicatorIntervention",
					"name": "Intervention",
					"description": "Shields Kayle or an ally for a short time, causing them to be immune to damage.",
					"tooltip": "Bathes Kayle's target in a holy light, rendering them immune to all damage for {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							2,
							2.5,
							3
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2/2.5/3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "JudicatorIntervention.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Holy Fervor",
				"description": "When Kayle attacks a champion, the target loses 3% Armor and Magic Resist for 5 seconds. This effect stacks up to 5 times.",
				"image": {
					"full": "Kayle_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kayle",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1042",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kayle",
					"title": "KayleTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Kayn": {
			"id": "Kayn",
			"key": "141",
			"name": "Kayn",
			"title": "the Shadow Reaper",
			"image": {
				"full": "Kayn.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 144,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "141000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "141001",
					"num": 1,
					"name": "Soulhunter Kayn",
					"chromas": false
				}
			],
			"lore": "A peerless practitioner of lethal shadow magic, Shieda Kayn battles to achieve his true destiny—to one day lead the Order of the Shadow into a new era of Ionian supremacy. He audaciously wields the sentient darkin weapon Rhaast, undeterred by its creeping corruption of his body and mind. There are only two possible outcomes: either Kayn bends the weapon to his will... or the malevolent blade consumes him completely, paving the way for the destruction of all Runeterra.",
			"blurb": "A peerless practitioner of lethal shadow magic, Shieda Kayn battles to achieve his true destiny—to one day lead the Order of the Shadow into a new era of Ionian supremacy. He audaciously wields the sentient darkin weapon Rhaast, undeterred by its...",
			"allytips": [
				"Look at the line-up of both your team and the enemy's team when picking your form.",
				"Remember that nearby enemies can see which wall you're in."
			],
			"enemytips": [
				"Umbral Trespass requires Kayn to damage a target first. Try to dodge Blade's Reach to deny him a long range cast of Umbral Trespass.",
				"When Kayn is in terrain near you, you will get a visual warning on the edge of the terrain he's in.",
				"Damage Kayn while he's in Shadow Step to shorten its duration, or apply hard crowd control (stun, charm, knockup, etc) to end Shadow Step immediately."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 10,
				"defense": 6,
				"magic": 1,
				"difficulty": 8
			},
			"stats": {
				"hp": 585,
				"hpperlevel": 85,
				"mp": 410,
				"mpperlevel": 50,
				"movespeed": 340,
				"armor": 38,
				"armorperlevel": 3.3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.75,
				"mpregen": 11.5,
				"mpregenperlevel": 0.95,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.7
			},
			"spells": [
				{
					"id": "KaynQ",
					"name": "Reaping Slash",
					"description": "Kayn dashes, then slashes. Both deal damage.",
					"tooltip": "Kayn dashes forward to strike nearby enemies. Both dash and strike deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><hr><span class=\"colorff2323\">Darkin:</span> Deal a percentage of the target's maximum health instead.<br /><br /><rules>Deals {{ e6 }} bonus physical damage to monsters.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							200,
							250,
							300,
							350,
							400
						],
						[
							55,
							55,
							55,
							55,
							55
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/80/100/120/140",
						"0.5",
						"5",
						"4",
						"200/250/300/350/400",
						"55",
						"300",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "KaynQ.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KaynW",
					"name": "Blade's Reach",
					"description": "Kayn damages and slows targets in a line.",
					"tooltip": "Kayn deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slows enemies hit by {{ e3 }}%, decaying over the next {{ e5 }} seconds.<br /><hr><span class=\"color7777ff\">Shadow Assassin:</span> Gain extra range and the ability to move during Blade's Reach.<br /><br /><span class=\"colorff2323\">Darkin:</span> Gain a knock up.</li></ul>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							90,
							135,
							180,
							225,
							270
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							160,
							160,
							160,
							160,
							160
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							900,
							900,
							900,
							900,
							900
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"90/135/180/225/270",
						"1",
						"60",
						"160",
						"1.5",
						"900",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "KaynW.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KaynE",
					"name": "Shadow Step",
					"description": "Kayn can walk through terrain.",
					"tooltip": "Kayn gains {{ e1 }}% movement speed and the ability to walk through terrain for {{ e2 }} seconds. When he first enters terrain, he is healed for {{ e7 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span>.<br /><hr><span class=\"color7777ff\">Shadow Assassin:</span> Gain more movement speed and slow immunity.<br /><br /><rules>Maximum duration in combat with enemy champions: {{ e6 }} seconds.<br />Immobilizing effects and spending more than {{ e3 }} consecutive seconds outside of terrain end Shadow Step immediately.</rules>",
					"leveltip": {
						"label": [
							"Duration",
							"Heal",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}s -> {{ e2NL }}s",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 5,
					"cooldown": [
						21,
						19,
						17,
						15,
						13
					],
					"cooldownBurn": "21/19/17/15/13",
					"cost": [
						90,
						90,
						90,
						90,
						90
					],
					"costBurn": "90",
					"effect": [
						null,
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							5,
							6,
							7,
							8,
							9
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1250,
							1250,
							1250,
							1250,
							1250
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							100,
							115,
							130,
							145,
							160
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40",
						"5/6/7/8/9",
						"1.5",
						"1250",
						"70",
						"1.5",
						"100/115/130/145/160",
						"0.4",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "KaynE.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KaynR",
					"name": "Umbral Trespass",
					"description": "Kayn hides in an enemy's body, dealing massive damage when he bursts out.",
					"tooltip": "Kayn infests an enemy champion <specialRules>he has recently damaged</specialRules>, becoming untargetable for up to {{ e4 }} seconds. <span class=\"colorffffff\">Reactivate</span> to end this effect early. When Umbral Trespass ends, the target takes {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><hr><span class=\"color7777ff\">Shadow Assassin:</span> Gains extra range and refresh The Darkin Scythe on exit.<br /><br /><span class=\"colorff2323\">Darkin:</span> Deals percent maximum health damage and heals for a percentage of target maximum health.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							300,
							300,
							300
						],
						[
							10,
							10,
							10
						],
						[
							13,
							13,
							13
						],
						[
							70,
							70,
							70
						],
						[
							750,
							750,
							750
						],
						[
							550,
							550,
							550
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"0.5",
						"0",
						"2.5",
						"300",
						"10",
						"13",
						"70",
						"750",
						"550"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "KaynR.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "The Darkin Scythe",
				"description": "At one point in the game, Kayn will permanently transform into either a Shadow Assassin or a Darkin.",
				"image": {
					"full": "Kayn_Passive_Primary.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kayn",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayn",
					"title": "KaynARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayn",
					"title": "KaynCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayn",
					"title": "KaynFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayn",
					"title": "KaynSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayn",
					"title": "KaynSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								"kaynass",
								"kaynslay"
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynass"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynass"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynass"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynslay"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynslay"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynslay"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kayn",
					"title": "KaynTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								"kaynslay",
								"kaynass"
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynass"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynass"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynass"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynslay"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynslay"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								"kaynslay"
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Kennen": {
			"id": "Kennen",
			"key": "85",
			"name": "Kennen",
			"title": "the Heart of the Tempest",
			"image": {
				"full": "Kennen.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 192,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "85000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "85001",
					"num": 1,
					"name": "Deadly Kennen",
					"chromas": false
				},
				{
					"id": "85002",
					"num": 2,
					"name": "Swamp Master Kennen",
					"chromas": false
				},
				{
					"id": "85003",
					"num": 3,
					"name": "Karate Kennen",
					"chromas": false
				},
				{
					"id": "85004",
					"num": 4,
					"name": "Kennen M.D.",
					"chromas": false
				},
				{
					"id": "85005",
					"num": 5,
					"name": "Arctic Ops Kennen",
					"chromas": false
				},
				{
					"id": "85006",
					"num": 6,
					"name": "Blood Moon Kennen",
					"chromas": false
				},
				{
					"id": "85007",
					"num": 7,
					"name": "Super Kennen",
					"chromas": false
				}
			],
			"lore": "More than just the lightning-quick enforcer of Ionian balance, Kennen is the only yordle member of the Kinkou. Despite his small, furry stature, he is eager to take on any threat with a whirling storm of shuriken and boundless enthusiasm. Alongside his master Shen, Kennen patrols the spirit realm, employing devastating electrical energy to strike down his enemies.",
			"blurb": "More than just the lightning-quick enforcer of Ionian balance, Kennen is the only yordle member of the Kinkou. Despite his small, furry stature, he is eager to take on any threat with a whirling storm of shuriken and boundless enthusiasm. Alongside his...",
			"allytips": [
				"You can stun your opponents by inflicting 3 Marks of the Storm upon them.",
				"Lightning Rush can be used to initiate fights with its Energy return component, allowing him to use other abilities afterward.",
				"You can land an initial Mark of the Storm debuff on an opponent with Thundering Shuriken, and then add to it with Electrical Surge."
			],
			"enemytips": [
				"Consider playing a bit more cautiously around Kennen when you have a Mark of the Storm debuff. If he hits you with 3 Marks of the Storm, you will get stunned.",
				"Kennen is flimsy by nature - turn and attack him if he gets careless with Lightning Rush."
			],
			"tags": [
				"Mage",
				"Marksman"
			],
			"partype": "Energy",
			"info": {
				"attack": 6,
				"defense": 4,
				"magic": 7,
				"difficulty": 4
			},
			"stats": {
				"hp": 541,
				"hpperlevel": 84,
				"mp": 200,
				"mpperlevel": 0,
				"movespeed": 335,
				"armor": 29,
				"armorperlevel": 3.75,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.65,
				"mpregen": 50,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 50.544,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": -0.0947,
				"attackspeedperlevel": 3.4
			},
			"spells": [
				{
					"id": "KennenShurikenHurlMissile1",
					"name": "Thundering Shuriken",
					"description": "Kennen throws a fast moving shuriken towards a location, causing damage and adding a Mark of the Storm to any opponent that it hits.",
					"tooltip": "Throws a shuriken that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy it hits.",
					"leveltip": {
						"label": [
							"Damage",
							"Energy Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7,
						6,
						5,
						4
					],
					"cooldownBurn": "8/7/6/5/4",
					"cost": [
						60,
						55,
						50,
						45,
						40
					],
					"costBurn": "60/55/50/45/40",
					"effect": [
						null,
						[
							75,
							115,
							155,
							195,
							235
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/115/155/195/235",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "KennenShurikenHurlMissile1.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "KennenBringTheLight",
					"name": "Electrical Surge",
					"description": "Kennen passively deals extra damage and adds a Mark of the Storm to his target every few attacks, and he can activate this ability to damage and add another Mark of the Storm to targets who are already marked.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Every 5 attacks, Kennen deals bonus magic damage equal to {{ e2 }} <scaleAD>(+{{ f1 }})</scaleAD> <scaleAP>(+{{ a2 }})</scaleAP> and adds a Mark of the Storm to his target.<br /><br /><span class=\"colorFF9900\">Active:</span> Sends a surge of electricity through all nearby enemies affected by Mark of the Storm or Slicing Maelstrom, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Damage (passive)",
							"Damage (active)",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						12,
						10,
						8,
						6
					],
					"cooldownBurn": "14/12/10/8/6",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							65,
							95,
							125,
							155,
							185
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/95/125/155/185",
						"15/20/25/30/35",
						"0.6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.55,
							"key": "a1"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "KennenBringTheLight.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "KennenLightningRush",
					"name": "Lightning Rush",
					"description": "Kennen morphs into a lightning form, enabling him to pass through units. Each enemy unit he touches takes damage and receives a Mark of the Storm.",
					"tooltip": "Kennen doubles his base movement speed and ignores unit collision for 2 seconds, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to any enemy he passes through. Additionally, Kennen will gain {{ e2 }} Armor and Magic Resist for 4 seconds.<br /><br />Kennen gains 40 Energy the first time he passes through an enemy.<br />Lightning Rush deals half damage to minions.",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus Armor and Magic Resist",
							"Cooldown",
							"Energy Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						100,
						95,
						90,
						85,
						80
					],
					"costBurn": "100/95/90/85/80",
					"effect": [
						null,
						[
							85,
							125,
							165,
							205,
							245
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"85/125/165/205/245",
						"10/20/30/40/50",
						"40",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						200,
						200,
						200,
						200,
						200
					],
					"rangeBurn": "200",
					"image": {
						"full": "KennenLightningRush.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "KennenShurikenStorm",
					"name": "Slicing Maelstrom",
					"description": "Kennen summons a storm that strikes at nearby enemy champions for magical damage.",
					"tooltip": "Summons a magical storm for {{ e3 }} seconds that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies near Kennen every {{ e2 }} seconds. Each maelstrom hit applies Mark of the Storm, up to a maximum of 3.<br /><br />Successive maelstrom hits against the same enemy deal an additional {{ e4 }}% damage for each hit they've already suffered from this storm.",
					"leveltip": {
						"label": [
							"Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						120,
						120
					],
					"cooldownBurn": "120",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							40,
							75,
							110
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							3,
							3,
							3
						],
						[
							10,
							10,
							10
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/75/110",
						"0.5",
						"3",
						"10",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "KennenShurikenStorm.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Mark of the Storm",
				"description": "Kennen's abilities add one stack of Mark of the Storm to their target for 6 seconds. If the target reaches 3 stacks, it is stunned for 1.25 seconds and Kennen gains 25 Energy. <br><br><font color='#99FF99'>The stun will be a diminished duration of 0.5 seconds if it occurs again within 6 seconds.</font>",
				"image": {
					"full": "Kennen_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kennen",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kennen",
					"title": "KennenTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Khazix": {
			"id": "Khazix",
			"key": "121",
			"name": "Kha'Zix",
			"title": "the Voidreaver",
			"image": {
				"full": "Khazix.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 240,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "121000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "121001",
					"num": 1,
					"name": "Mecha Kha'Zix",
					"chromas": true
				},
				{
					"id": "121002",
					"num": 2,
					"name": "Guardian of the Sands Kha'Zix",
					"chromas": false
				},
				{
					"id": "121003",
					"num": 3,
					"name": "Death Blossom Kha'Zix",
					"chromas": false
				},
				{
					"id": "121004",
					"num": 4,
					"name": "Dark Star Kha'Zix",
					"chromas": false
				}
			],
			"lore": "The Void grows, and the Void adapts—in none of its myriad spawn are these truths more apparent than Kha'Zix. Evolution drives the core of this mutating horror, born to survive and to slay the strong. Where it struggles to do so, it grows new, more effective ways to counter and kill its prey. Initially a mindless beast, Kha'Zix's intelligence has developed as much as its form. Now, the creature plans out its hunts, and even utilizes the visceral terror it engenders in its victims.",
			"blurb": "The Void grows, and the Void adapts—in none of its myriad spawn are these truths more apparent than Kha'Zix. Evolution drives the core of this mutating horror, born to survive and to slay the strong. Where it struggles to do so, it grows new, more...",
			"allytips": [
				"Enemies are considered isolated if they have no allies within a short distance. The damage of Taste Their Fear is massively increased against these targets.",
				"Unseen Threat activates when Kha'Zix cannot be seen by the enemy team. Reactivate by using brush or Void Assault. Don't forget to apply Unseen Threat by autoattacking enemy champions.",
				"Kha'Zix has a great deal of freedom to choose where and when to fight. Pick your battles carefully to succeed."
			],
			"enemytips": [
				"Taste Their Fear deals bonus damage to targets that are isolated. Gain an advantage by fighting near allied minions, champions, or turrets.",
				"Leap and Void Assault have long cooldowns. Kha'Zix is very vulnerable when these are not available."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 4,
				"magic": 3,
				"difficulty": 6
			},
			"stats": {
				"hp": 572.8,
				"hpperlevel": 85,
				"mp": 327.2,
				"mpperlevel": 40,
				"movespeed": 350,
				"armor": 36,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7.5,
				"hpregenperlevel": 0.75,
				"mpregen": 7.59,
				"mpregenperlevel": 0.5,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 63,
				"attackdamageperlevel": 3.1,
				"attackspeedoffset": -0.065,
				"attackspeedperlevel": 2.7
			},
			"spells": [
				{
					"id": "KhazixQ",
					"name": "Taste Their Fear",
					"description": "Deals physical damage to the target. Damage increased on <font color='#FFF673'>Isolated</font> targets. If he chooses to <font color='#00DD33'>Evolve Reaper Claws</font>, this refunds a percent of it's cooldown against <font color='#FFF673'>Isolated</font> targets. Kha'Zix also gains increased range on his basic attacks and Taste Their Fear.",
					"tooltip": "Deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. If the target is <span class=\"colorFFF673\">Isolated</span>, the damage is increased by {{ e2 }}% (<span class=\"colorFF8C00\">{{ f1 }}</span>).<br /><br /><span class=\"color00DD33\">Evolved Reaper Claws:</span> Increases the range of Taste Their Fear and Kha'Zix's basic attacks by {{ e3 }}. If target is <span class=\"colorFFF673\">Isolated</span>, refunds {{ e4 }}% of Taste Their Fear's cooldown.",
					"leveltip": {
						"label": [
							"Base Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							65,
							90,
							115,
							140,
							165
						],
						[
							65,
							65,
							65,
							65,
							65
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							45,
							45,
							45,
							45,
							45
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/90/115/140/165",
						"65",
						"50",
						"45",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "KhazixQ.png",
						"sprite": "spell5.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KhazixW",
					"name": "Void Spike",
					"description": "Kha'Zix fires exploding spikes that deal physical damage to enemies hit. Kha'Zix is healed if he is also within the explosion radius. If he chooses to <font color='#00DD33'>Evolve Spike Racks</font>, Void Spike now fires three spikes in a cone, slow enemies hit, and reveals enemy champions hit for 2 seconds. <font color='#FFF673'>Isolated</font> targets are slowed for extra.",
					"tooltip": "Fires exploding spikes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to enemies hit ({{ e5 }}% bonus damage to monsters). Heals Kha'Zix for {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> if he is within the explosion radius.<br /><br /><span class=\"color00DD33\">Evolved Spike Racks:</span> Void Spike fires three spikes in a cone and slows targets hit by {{ e3 }}% for {{ e4 }} seconds. Reveals enemy champions hit for 2 seconds. <span class=\"colorFFF673\">Isolated</span> targets are slowed for {{ e7 }}% instead.",
					"leveltip": {
						"label": [
							"Damage",
							"Healing",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						55,
						60,
						65,
						70,
						75
					],
					"costBurn": "55/60/65/70/75",
					"effect": [
						null,
						[
							85,
							115,
							145,
							175,
							205
						],
						[
							60,
							85,
							110,
							135,
							160
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"85/115/145/175/205",
						"60/85/110/135/160",
						"40",
						"2",
						"20",
						"2",
						"80",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "KhazixW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KhazixE",
					"name": "Leap",
					"description": "Kha'Zix leaps to an area, dealing physical damage upon landing. If he chooses to <font color='#00DD33'>Evolve Wings</font>, Leap's range increases by 200 and the cooldown resets on champion kill or assist.",
					"tooltip": "Leaps to target area, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><br /><span class=\"color00DD33\">Evolved Wings:</span> Increases Leap's range by 200, and the cooldown resets on champion kill or assist.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						18,
						16,
						14,
						12
					],
					"cooldownBurn": "20/18/16/14/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							65,
							100,
							135,
							170,
							205
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/100/135/170/205",
						"30/35/40/45/50",
						"10",
						"2.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "KhazixE.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KhazixR",
					"name": "Void Assault",
					"description": "Each rank allows Kha'Zix to evolve one of his abilities, giving it a unique additional effect. When activated, Kha'Zix becomes <font color='#91d7ee'>Invisible</font>, triggering Unseen Threat and increasing Movement Speed. If he chooses to <font color='#00DD33'>Evolve Adaptive Cloaking</font>, while out of combat Kha'Zix also passively gains Void Assault upon entering a new brush.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Ranking up Void Assault allows Kha'Zix to evolve one of his abilities.<br /><br /><span class=\"colorFF9900\">Active:</span> Kha'Zix becomes <span class=\"color91d7ee\">Invisible</span> for {{ e1 }} seconds and activates Unseen Threat. While <span class=\"color91d7ee\">Invisible</span>, he gains {{ e3 }}% movement speed and ignores unit collision. Void Assault can be cast a second time within {{ e2 }} seconds.<br /><br /><span class=\"color00DD33\">Evolved Adaptive Cloaking:</span> While out of combat, Kha'Zix also passively gains Void Assault for {{ e5 }} seconds in brush. This persists for up to {{ f1 }} seconds after exiting the brush ({{ f1 }} second per brush cooldown).<br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Kha'Zix can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.</span>",
					"leveltip": {
						"label": [
							"Evolutions Available",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							1.5,
							1.5,
							1.5
						],
						[
							10,
							10,
							10
						],
						[
							40,
							40,
							40
						],
						[
							1,
							2,
							3
						],
						[
							3,
							3,
							3
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.5",
						"10",
						"40",
						"1/2/3",
						"3",
						"2",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "KhazixR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Unseen Threat",
				"description": "When Kha'Zix is not visible to the enemy team, he gains Unseen Threat, causing his next basic attack against an enemy Champion to deal bonus magic damage and slow.",
				"image": {
					"full": "Khazix_P.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Khazix",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "KhazixTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Khazix",
					"title": "RainbowScytherFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								},
								{
									"id": "3342",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3181",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2044",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Kindred": {
			"id": "Kindred",
			"key": "203",
			"name": "Kindred",
			"title": "The Eternal Hunters",
			"image": {
				"full": "Kindred.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 288,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "203000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "203001",
					"num": 1,
					"name": "Shadowfire Kindred",
					"chromas": false
				},
				{
					"id": "203002",
					"num": 2,
					"name": "Super Galaxy Kindred",
					"chromas": false
				}
			],
			"lore": "Separate, but never parted, Kindred represents the twin essences of death. Lamb's bow offers a swift release from the mortal realm for those who accept their fate. Wolf hunts down those who run from their end, delivering violent finality within his crushing jaws. Though interpretations of Kindred's nature vary across Runeterra, every mortal must choose the true face of their death.",
			"blurb": "Separate, but never parted, Kindred represents the twin essences of death. Lamb's bow offers a swift release from the mortal realm for those who accept their fate. Wolf hunts down those who run from their end, delivering violent finality within his...",
			"allytips": [
				"Moving around between attacks while jungling will help you avoid damage and also generate more heals from Wolf's Frenzy.",
				"Pick which Hunts you want to pursue carefully; getting many of them is the key to success as the game goes on.",
				"Don't go in first to a large team fight. Wait for your teammates to initiate."
			],
			"enemytips": [
				"Kindred is fragile - turn the pressure up on her, and she will be forced to play cautiously.",
				"Clear the Hunts Wolf activates on jungle camps to slow down Kindred's damage output.",
				"When Kindred uses Lamb's Respite get inside, it stops all champions from dying."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 2,
				"magic": 2,
				"difficulty": 4
			},
			"stats": {
				"hp": 540,
				"hpperlevel": 85,
				"mp": 300,
				"mpperlevel": 35,
				"movespeed": 325,
				"armor": 29,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 6.972,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 2.26,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "KindredQ",
					"name": "Dance of Arrows",
					"description": "Kindred tumbles and shoots up to three arrows at nearby targets.",
					"tooltip": "Lamb vaults, firing up to 3 arrows at nearby enemies, dealing {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> physical damage and gains <scaleLevel>{{ f2 }}%</scaleLevel> bonus attack speed for {{ e8 }} seconds.<br /><br />Casting <span class=\"colorFFFFFF\">Wolf's Frenzy</span> or vaulting inside of its effect reduces the cooldown of this spell to {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown in Wolf's Frenzy"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						35,
						35,
						35,
						35,
						35
					],
					"costBurn": "35",
					"effect": [
						null,
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							500,
							500,
							500,
							500,
							500
						],
						[
							4,
							3.5,
							3,
							2.5,
							2
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/80/100/120/140",
						"0",
						"500",
						"4/3.5/3/2.5/2",
						"100",
						"12",
						"0.1",
						"4",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						340,
						340,
						340,
						340,
						340
					],
					"rangeBurn": "340",
					"image": {
						"full": "KindredQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KindredW",
					"name": "Wolf's Frenzy",
					"description": "Wolf enrages and attacks enemies around him.",
					"tooltip": "Wolf claims a territory, attacking nearby enemies inside it for {{ e4 }} seconds. Lamb can redirect Wolf to new targets by attacking them. If Lamb leaves Wolf's territory he will cease attacking and join her.<br /><br />Wolf's attacks deal magic damage equal to {{ e5 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> plus <scaleLevel>{{ f3 }}%</scaleLevel> of the target's current health.<br /><br /><rules>Wolf attacks faster based on Kindred's attack speed. His attacks maim monsters for {{ e7 }}% increased damage and reduce their attack and movement speed by {{ e8 }}% for 2 seconds.</rules>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							8.5,
							8.5,
							8.5,
							8.5,
							8.5
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/45/50/55/60",
						"1",
						"1.5",
						"8.5",
						"25/30/35/40/45",
						"800",
						"50",
						"50",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						560,
						560,
						560,
						560,
						560
					],
					"rangeBurn": "560",
					"image": {
						"full": "KindredW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KindredEWrapper",
					"name": "Mounting Dread",
					"description": "Lamb fires a carefully placed shot, slowing the target. If Lamb attacks the target two more times, her third attack instead directs Wolf to pounce on the enemy, savaging them for massive damage.",
					"tooltip": "Cripple an enemy, slowing their movement speed by {{ e2 }}% for {{ e8 }} second.<br /><br />After Lamb attacks the target twice, her third attack instead directs Wolf to pounce on the enemy, dealing {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> plus <scaleLevel>{{ f2 }}%</scaleLevel> of the target's missing health as bonus physical damage.<br /><br />Wolf's attack critically strikes targets for {{ e6 }}% increased damage if they are below {{ e5 }}% <span class=\"colorFF5802\">(+{{ f3 }}%)</span> health (Increased by <span class=\"colorFF5802\">Critical Strike Chance</span>).<br /><br /><rules>[Maximum {{ e0 }} vs. monsters]</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							65,
							85,
							105,
							125,
							145
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							300,
							300,
							300,
							300,
							300
						]
					],
					"effectBurn": [
						null,
						"65/85/105/125/145",
						"50",
						"0.5",
						"8",
						"15",
						"50",
						"4",
						"1",
						"4",
						"300"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "KindredEWrapper.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KindredR",
					"name": "Lamb's Respite",
					"description": "Lamb grants all living things inside a zone a respite from death. Until the effect ends, nothing can die. At the end, units are healed.",
					"tooltip": "Lamb blesses the ground underneath her for {{ e2 }} seconds, creating an area in which no living things, <span class=\"color99FF99\">ally</span> or <span class=\"colorFF9999\">enemy</span>, can die. Upon reaching 10% Health, units become immune to further damage or healing.<br /><br />When the blessing ends all living things inside heal for {{ e1 }}.",
					"leveltip": {
						"label": [
							"Heal",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						160,
						130,
						100
					],
					"cooldownBurn": "160/130/100",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							200,
							250,
							300
						],
						[
							4,
							4,
							4
						],
						[
							530,
							530,
							530
						],
						[
							400,
							600,
							800
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/250/300",
						"4",
						"530",
						"400/600/800",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "KindredR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Mark of the Kindred",
				"description": "Kindred can mark targets to Hunt. Successfully completing a Hunt permanently empowers Kindred's basic abilities. Every 4 hunts completed also increases Kindred's basic attack range.",
				"image": {
					"full": "Kindred_Passive.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kindred",
					"title": "KindredARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kindred",
					"title": "KindredCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kindred",
					"title": "KindredFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kindred",
					"title": "KindredKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kindred",
					"title": "KindredSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kindred",
					"title": "KindredSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kindred",
					"title": "KindredTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1419",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Kled": {
			"id": "Kled",
			"key": "240",
			"name": "Kled",
			"title": "the Cantankerous Cavalier",
			"image": {
				"full": "Kled.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 336,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "240000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "240001",
					"num": 1,
					"name": "Sir Kled",
					"chromas": false
				}
			],
			"lore": "A warrior as fearless as he is ornery, the yordle Kled embodies the furious bravado of Noxus. He is an icon beloved by the empire's soldiers, distrusted by its officers, and loathed by the nobility. Many claim Kled has fought in every campaign the legions have waged, has “acquired” every military title, and has never once backed down from a fight. Though the truth of the matter is often questionable, one part of his legend is undeniable: Charging into battle on his un-trusty steed, Skaarl, Kled fights to protect what's his… and to take whatever he can get.",
			"blurb": "A warrior as fearless as he is ornery, the yordle Kled embodies the furious bravado of Noxus. He is an icon beloved by the empire's soldiers, distrusted by its officers, and loathed by the nobility. Many claim Kled has fought in every campaign the...",
			"allytips": [
				"Kled generates some courage by killing minions, but gets much more from fighting Champions.",
				"The last hit of Violent Tendencies deals more damage than the first three - make sure you hit it!",
				"Chaaaaaaaarge!!! can be cast at a great range. Try and predict where the enemy team will be by the time you reach them."
			],
			"enemytips": [
				"Kled generates courage by damaging enemies with his Pocket Pistol and basic attacks, killing minions, and attacking structures or epic monsters.",
				"Watch Kled's courage bar when he's off his mount - when it reaches 100%, he will remount and regain a significant amount of health.",
				"Kled is much more threatening when he has Violent Tendencies ready."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Courage",
			"info": {
				"attack": 8,
				"defense": 2,
				"magic": 2,
				"difficulty": 7
			},
			"stats": {
				"hp": 340,
				"hpperlevel": 70,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 35,
				"armorperlevel": 4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 6,
				"hpregenperlevel": 0.75,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "KledQ",
					"name": "Bear Trap on a Rope",
					"description": "Kled throws a bear trap that damages and hooks an enemy champion. If shackled for a short duration, the target takes additional physical damage and is yanked toward Kled.<br><br>When dismounted, this ability is replaced by Pocket Pistol, a ranged gun blast that knocks back Kled and restores courage.",
					"tooltip": "Kled throws a bear trap that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }}) </span>physical damage and hooks onto the first enemy champion or large monster hit, granting <span class=\"coloree91d7\">True Sight</span>. Deals 150% damage to minions passed through.<br /><br />If Kled stays near a hooked enemy for {{ e3 }} seconds, he deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ charbonusphysical*2 }})</span> physical damage, yanks the enemy toward him, and slows the enemy by {{ e5 }}% for 1.5 seconds.<br /><br /><span class=\"colorFF8C00\">Dismounted:</span> Becomes Pocket Pistol, a ranged ability that restores <span class=\"coloreae57e\">courage</span>.",
					"leveltip": {
						"label": [
							"Throw Damage",
							"Rip Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8.5,
						8,
						7.5,
						7
					],
					"cooldownBurn": "9/8.5/8/7.5/7",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							1.75,
							1.75,
							1.75,
							1.75,
							1.75
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							9,
							8.5,
							8,
							7.5,
							7
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/110/160/210/260",
						"0.6",
						"1.75",
						"2",
						"40/45/50/55/60",
						"9/8.5/8/7.5/7",
						"1.5",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "KledQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "KledW",
					"name": "Violent Tendencies",
					"description": "Kled gains massive attack speed for four attacks. The fourth attack deals more damage.",
					"tooltip": "<span class=\"colorFF8C00\">Passive:</span> When Kled basic attacks, he frenzies, gaining {{ e2 }}% attack speed for four attacks or {{ e6 }} seconds. Violent Tendencies then goes on cooldown.<br /><br />The fourth hit deals bonus physical damage equal to {{ e4 }} plus {{ e1 }}% <span class=\"colorFF8C00\">(+{{ f1 }}%)</span> of the target's maximum health (maximum {{ e7 }} vs monsters).",
					"leveltip": {
						"label": [
							"Flat Damage",
							"Percentage Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						12.5,
						11,
						9.5,
						8
					],
					"cooldownBurn": "14/12.5/11/9.5/8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							4.5,
							5,
							5.5,
							6,
							6.5
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							15,
							30,
							45,
							60,
							75
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4.5/5/5.5/6/6.5",
						"150",
						"20",
						"20/30/40/50/60",
						"15/30/45/60/75",
						"4",
						"200",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						0,
						0,
						0,
						0,
						0
					],
					"rangeBurn": "0",
					"image": {
						"full": "KledW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "KledE",
					"name": "Jousting",
					"description": "Kled dashes, dealing physical damage and gaining a short burst of speed. Kled can cast this ability again to dash back through his initial target, dealing the same damage.",
					"tooltip": "Kled dashes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }}) </span>physical damage to enemies in his path. Cannot cross walls.<br /><br />If Jousting hits an enemy champion or large monster, Kled gains {{ e5 }}% movement speed for {{ e4 }} second and <span class=\"coloree91d7\">True Sight</span> of the target. He can cast this ability again within {{ e6 }} seconds to dash back through the same target, dealing the same damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							35,
							60,
							85,
							110,
							135
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							350,
							350,
							350,
							350,
							350
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							700,
							700,
							700,
							700,
							700
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/60/85/110/135",
						"0",
						"350",
						"1",
						"50",
						"3",
						"600",
						"700",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "KledE.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "KledR",
					"name": "Chaaaaaaaarge!!!",
					"description": "Kled and Skaarl charge to a location, leaving a speed-granting trail behind them and gaining a shield. Skaarl locks onto and rams the first enemy champion encountered.",
					"tooltip": "Kled charges toward a location, leaving a trail that grants allies increasing movement speed. While charging, Kled gains a shield that increases over time to a maximum of {{ e4 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> and lasts for 2 seconds after the charge ends.<br /><br />Skaarl rams the first enemy champion encountered, dealing up to {{ f5 }}% <span class=\"colorFF8C00\">(+{{ f1*3 }}%)</span> of the target's maximum health as physical damage based on distance traveled.",
					"leveltip": {
						"label": [
							"Maximum Damage",
							"Maximum Shield",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e0 }} -> {{ e0NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						160,
						140,
						120
					],
					"cooldownBurn": "160/140/120",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							12,
							15,
							18
						],
						[
							4,
							4,
							4
						],
						[
							0,
							0,
							0
						],
						[
							200,
							300,
							400
						],
						[
							3,
							3,
							3
						],
						[
							100,
							150,
							0
						],
						[
							0,
							0,
							0
						],
						[
							150,
							0,
							0
						],
						[
							3,
							3,
							3
						],
						[
							3500,
							4000,
							4500
						]
					],
					"effectBurn": [
						null,
						"12/15/18",
						"4",
						"0",
						"200/300/400",
						"3",
						"100/150/0",
						"0",
						"150/0/0",
						"3",
						"3500/4000/4500"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 3,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						3500,
						4000,
						4500
					],
					"rangeBurn": "3500/4000/4500",
					"image": {
						"full": "KledR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Skaarl, the Cowardly Lizard",
				"description": "Kled rides his trusty steed, Skaarl, who takes damage for him. When Skaarl's health depletes, Kled dismounts.<br><br>While dismounted, Kled's abilities change and he deals less damage to champions. Kled can restore Skaarl's courage by fighting enemies. At maximum courage, Kled remounts with a portion of Skaarl's health.",
				"image": {
					"full": "Kled_P.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Kled",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Kled",
					"title": "KledTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"KogMaw": {
			"id": "KogMaw",
			"key": "96",
			"name": "Kog'Maw",
			"title": "the Mouth of the Abyss",
			"image": {
				"full": "KogMaw.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 384,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "96000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "96001",
					"num": 1,
					"name": "Caterpillar Kog'Maw",
					"chromas": false
				},
				{
					"id": "96002",
					"num": 2,
					"name": "Sonoran Kog'Maw",
					"chromas": false
				},
				{
					"id": "96003",
					"num": 3,
					"name": "Monarch Kog'Maw",
					"chromas": false
				},
				{
					"id": "96004",
					"num": 4,
					"name": "Reindeer Kog'Maw",
					"chromas": false
				},
				{
					"id": "96005",
					"num": 5,
					"name": "Lion Dance Kog'Maw",
					"chromas": false
				},
				{
					"id": "96006",
					"num": 6,
					"name": "Deep Sea Kog'Maw",
					"chromas": false
				},
				{
					"id": "96007",
					"num": 7,
					"name": "Jurassic Kog'Maw",
					"chromas": false
				},
				{
					"id": "96008",
					"num": 8,
					"name": "Battlecast Kog'Maw",
					"chromas": false
				},
				{
					"id": "96009",
					"num": 9,
					"name": "Pug'Maw",
					"chromas": false
				},
				{
					"id": "96010",
					"num": 10,
					"name": "Hextech Kog'Maw",
					"chromas": false
				}
			],
			"lore": "Belched forth from a rotting Void incursion deep in the wastelands of Icathia, Kog'Maw is an inquisitive yet putrid creature with a caustic, gaping mouth. This particular Void-spawn needs to gnaw and drool on anything within reach to truly understand it. Though not inherently evil, Kog'Maw's beguiling naiveté is dangerous, as it often precedes a feeding frenzy—not for sustenance, but to satisfy its unending curiosity.",
			"blurb": "Belched forth from a rotting Void incursion deep in the wastelands of Icathia, Kog'Maw is an inquisitive yet putrid creature with a caustic, gaping mouth. This particular Void-spawn needs to gnaw and drool on anything within reach to truly understand it...",
			"allytips": [
				"Kog'Maw can outrange most champions with his Bio-Arcane Barrage ability.",
				"Use Void Ooze to set up a perfect Living Artillery.",
				"Make the most out of your Icathian Surprise."
			],
			"enemytips": [
				"Kog'Maw doesn't have a good escape ability, so he is especially prone to ganks.",
				"Run away from Kog'Maw after he dies!!!!",
				"The range on Living Artillery increases each rank.",
				"Bio-Arcane Barrage allows Kog'Maw to kill Baron Nashor extremely early. It can be valuable to ward Nashor when Kog'Maw completes his Blade of the Ruined King."
			],
			"tags": [
				"Marksman",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 2,
				"magic": 5,
				"difficulty": 6
			},
			"stats": {
				"hp": 517.76,
				"hpperlevel": 82,
				"mp": 322.2,
				"mpperlevel": 40,
				"movespeed": 325,
				"armor": 29,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 6,
				"hpregenperlevel": 0.55,
				"mpregen": 8.676,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": -0.06,
				"attackspeedperlevel": 2.65
			},
			"spells": [
				{
					"id": "KogMawQ",
					"name": "Caustic Spittle",
					"description": "Kog'Maw launches a corrosive projectile which deals magic damage and corrodes the target's armor and magic resist for a short time. Kog'Maw also gains additional attack speed.",
					"tooltip": "<span class=\"colorFF8C00\">Passive: </span> Kog'Maw gains {{ e2 }}% bonus attack speed.<br /><br /><span class=\"colorFF8C00\">Active: </span>Launches a corrosive projectile that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to the first enemy hit and shreds its Armor and Magic Resist by {{ e3 }}% for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Bonus Attack Speed",
							"Damage",
							"Armor and Magic Resist Shred"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							20,
							22,
							24,
							26,
							28
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/130/180/230/280",
						"15/20/25/30/35",
						"20/22/24/26/28",
						"4",
						"1",
						"1",
						"100",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1175,
						1175,
						1175,
						1175,
						1175
					],
					"rangeBurn": "1175",
					"image": {
						"full": "KogMawQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KogMawBioArcaneBarrage",
					"name": "Bio-Arcane Barrage",
					"description": "Kog'Maw's attacks gain range and deal a percent of the target's maximum health as magic damage.",
					"tooltip": "For {{ e3 }} seconds, Kog'Maw's basic attacks gain {{ e1 }} range and deal {{ e2 }}% <span class=\"color99FF99\">(+{{ f1 }})%</span> of the target's maximum health as bonus magic damage.",
					"leveltip": {
						"label": [
							"Range",
							"Bonus Max Health Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						17,
						17,
						17,
						17
					],
					"cooldownBurn": "17",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							130,
							150,
							170,
							190,
							210
						],
						[
							3,
							3.75,
							4.5,
							5.25,
							6
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							0.15,
							0.2,
							0.25,
							0.3,
							0.35
						],
						[
							15,
							20,
							25,
							30,
							35
						]
					],
					"effectBurn": [
						null,
						"130/150/170/190/210",
						"3/3.75/4.5/5.25/6",
						"8",
						"100",
						"100",
						"0",
						"100",
						"15",
						"0.15/0.2/0.25/0.3/0.35",
						"15/20/25/30/35"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						530,
						530,
						530,
						530,
						530
					],
					"rangeBurn": "530",
					"image": {
						"full": "KogMawBioArcaneBarrage.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KogMawVoidOoze",
					"name": "Void Ooze",
					"description": "Kog'Maw launches a peculiar ooze which damages all enemies it passes through and leaves a trail which slows enemies who stand on it.",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to enemies hit and leaves a trail on the ground for {{ e3 }} seconds, slowing enemies in it by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						80,
						90,
						100,
						110,
						120
					],
					"costBurn": "80/90/100/110/120",
					"effect": [
						null,
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							20,
							28,
							36,
							44,
							52
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/105/150/195/240",
						"20/28/36/44/52",
						"4",
						"0.25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "KogMawVoidOoze.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "KogMawLivingArtillery",
					"name": "Living Artillery",
					"description": "Kog'Maw fires an artillery shell at a great distance dealing magic damage (increased significantly on low health enemies) and revealing non-stealthed targets. Additionally, multiple Living Artilleries in a short period of time cause them to cost additional Mana.",
					"tooltip": "Fires an artillery shot, damaging enemies above 40% health for {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ effect1amount*1.5 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage based on their missing health.<br /><br />If enemies are below 40% health, they take {{ f4 }} <span class=\"colorFF8C00\">(+{{ f6 }})</span> <span class=\"color99FF99\">(+{{ f5 }})</span> magic damage instead.<br /><br />Each subsequent shot within {{ e4 }} seconds costs {{ e3 }} more Mana (max {{ e5 }}).",
					"leveltip": {
						"label": [
							"Damage",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						2,
						1.5,
						1
					],
					"cooldownBurn": "2/1.5/1",
					"cost": [
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							100,
							140,
							180
						],
						[
							1200,
							1500,
							1800
						],
						[
							40,
							40,
							40
						],
						[
							8,
							8,
							8
						],
						[
							400,
							400,
							400
						],
						[
							2,
							2,
							2
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							2,
							2,
							2
						],
						[
							360,
							360,
							360
						],
						[
							400,
							400,
							400
						]
					],
					"effectBurn": [
						null,
						"100/140/180",
						"1200/1500/1800",
						"40",
						"8",
						"400",
						"2",
						"1.5",
						"2",
						"360",
						"400"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.65,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1500,
						1800
					],
					"rangeBurn": "1200/1500/1800",
					"image": {
						"full": "KogMawLivingArtillery.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Icathian Surprise",
				"description": "Upon dying, Kog'Maw starts a chain reaction in his body which causes him to move faster and detonate after 4 seconds; dealing 100 + (25 x lvl) true damage to surrounding enemies.",
				"image": {
					"full": "KogMaw_IcathianSurprise.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "KogMaw",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogMawARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogMawCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogmawFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogMawKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogMawPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogMawSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogmawSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "KogMaw",
					"title": "KogmawTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Leblanc": {
			"id": "Leblanc",
			"key": "7",
			"name": "LeBlanc",
			"title": "the Deceiver",
			"image": {
				"full": "Leblanc.png",
				"sprite": "champion1.png",
				"group": "champion",
				"x": 432,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "7000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "7001",
					"num": 1,
					"name": "Wicked LeBlanc",
					"chromas": false
				},
				{
					"id": "7002",
					"num": 2,
					"name": "Prestigious LeBlanc",
					"chromas": true
				},
				{
					"id": "7003",
					"num": 3,
					"name": "Mistletoe LeBlanc",
					"chromas": false
				},
				{
					"id": "7004",
					"num": 4,
					"name": "Ravenborn LeBlanc",
					"chromas": false
				},
				{
					"id": "7005",
					"num": 5,
					"name": "Elderwood LeBlanc",
					"chromas": false
				}
			],
			"lore": "Mysterious even to other members of the Black Rose cabal, LeBlanc is but one of many names for a pale woman who has manipulated people and events since the earliest days of Noxus. Using her magic to mirror herself, the sorceress can appear to anyone, anywhere, and even be in many places at once. Always plotting just out of sight, LeBlanc's true motives are as inscrutable as her shifting identity.",
			"blurb": "Mysterious even to other members of the Black Rose cabal, LeBlanc is but one of many names for a pale woman who has manipulated people and events since the earliest days of Noxus. Using her magic to mirror herself, the sorceress can appear to anyone...",
			"allytips": [
				"Distortion allows you to be aggressive with your other spells while being able to return to safety.",
				"Using Distortion can help your positioning to land Ethereal Chains.",
				"You can chain Sigil of Malice and Ethereal Chains to prevent characters with blink from escaping for up to 4 seconds."
			],
			"enemytips": [
				"LeBlanc's ultimate can create fake LeBlancs during her spellcast or, rarely, at a distant position. ",
				"The fake LeBlanc created at a distance will always run at the nearest Champion, cast a harmless spell, then immediately disappear.",
				"Attacking LeBlanc first avoids most of her tricks, especially if she's recently used her dash, Distortion.",
				"Stunning or silencing LeBlanc will prevent her from activating the return part of Distortion."
			],
			"tags": [
				"Assassin",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 4,
				"magic": 10,
				"difficulty": 9
			},
			"stats": {
				"hp": 528,
				"hpperlevel": 92,
				"mp": 334,
				"mpperlevel": 50,
				"movespeed": 340,
				"armor": 21.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 7.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 54.88,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.4
			},
			"spells": [
				{
					"id": "LeblancQ",
					"name": "Shatter Orb",
					"description": "LeBlanc projects an orb towards her target, dealing magic damage. When Shatter Orb is empowered by Sigil of Malice, the spell bounces to the nearest ready Sigil of Malice (bounces deal reduced damage to minions).",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. When Shatter Orb is empowered by Sigil of Malice, the spell bounces to the nearest ready Sigil of Malice (bounces deal {{ e7 }}% damage to minions). ",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							55,
							90,
							125,
							160,
							195
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/90/125/160/195",
						"25",
						"3.5",
						"6",
						"60/90/120/150/180",
						"0",
						"60",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "LeblancQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LeblancW",
					"name": "Distortion",
					"description": "LeBlanc rapidly dashes to a target location, dealing magic damage to nearby units. In the following 4 seconds, she can activate Distortion again to return to her starting location.",
					"tooltip": "Dashes to target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies in the target area.<br /><br />For the next 4 seconds, she can activate Distortion again to return to her starting location.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							0.85,
							0.85,
							0.85,
							0.85,
							0.85
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/55/70/85/100",
						"2",
						"4",
						"600",
						"0.85",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "LeblancW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LeblancE",
					"name": "Ethereal Chains",
					"description": "LeBlanc flings illusionary chains towards a target location. If it hits an enemy unit, it will deal initial magic damage and shackle them. If the target remains shackled for 1.5 seconds, the target takes additional magic damage and is unable to move.",
					"tooltip": "Launches a chain that shackles the first unit hit to LeBlanc, granting <span class=\"coloree91d7\">True Sight</span> of the unit and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />If the target remains shackled for {{ e2 }} seconds they are rooted for {{ e2 }} seconds and take an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. ",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f1 }} -> {{ f2 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							885,
							885,
							885,
							885,
							885
						],
						[
							14,
							13.25,
							12.5,
							11.75,
							11
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/60/80/100/120",
						"1.5",
						"1.5",
						"25",
						"885",
						"14/13.25/12.5/11.75/11",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "LeblancE.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LeblancR",
					"name": "Mimic",
					"description": "LeBlanc creates a clone and casts a mimicked version of one of her basic spells. The clone casts a fake copy of that spell. LeBlanc can instead send the clone far away, where it casts a fake copy of her most recently cast spell.",
					"tooltip": "LeBlanc copies one of her spells and creates a <span class=\"colorCC00FF\">Mimic</span> decoy to cast it with her. The <span class=\"colorCC00FF\">Mimic</span> lasts {{ e7 }} seconds. <br /><br /><li>Shatter Orb deals {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.<br />Distortion deals {{ e5 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage.<br />Ethereal Chains deals {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage each time.<br />Using this spell on itself invokes <span class=\"colorDDDD77\">Shadow of the Rose</span>.</li><br /><span class=\"colorDDDD77\">Shadow of the Rose</span><br />The <span class=\"colorCC00FF\">Mimic</span> appears at target location and approaches the closest visible enemy Champion, then casts a fake version of LeBlanc's most recent basic ability. <br /><br />Has a separate <span class=\"colorFFFFFF\">{{ f2 }} second</span> cooldown. This <span class=\"colorCC00FF\">Mimic</span> lasts much longer but cannot be controlled.",
					"leveltip": {
						"label": [
							"Mimicked Shatter Orb Damage",
							"Mimicked Distortion Damage",
							"Mimicked Ethereal Chains Damage",
							"Shadow of the Rose Cooldown",
							"Mimic Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ f2 }} -> {{ f3 }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						54,
						42,
						30
					],
					"cooldownBurn": "54/42/30",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							40,
							60
						],
						[
							30,
							37.5,
							45
						],
						[
							150,
							275,
							400
						],
						[
							100,
							160,
							220
						],
						[
							60,
							120,
							180
						],
						[
							160,
							140,
							120
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							150,
							150,
							150
						],
						[
							0.3,
							0.3,
							0.3
						],
						[
							0.075,
							0.075,
							0.075
						]
					],
					"effectBurn": [
						null,
						"20/40/60",
						"30/37.5/45",
						"150/275/400",
						"100/160/220",
						"60/120/180",
						"160/140/120",
						"2.5",
						"150",
						"0.3",
						"0.08"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": "Toggle",
					"maxammo": "2",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "LeblancR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "Toggle"
				}
			],
			"passive": {
				"name": "Sigil of Malice",
				"description": "When LeBlanc damages an enemy with a spell, she marks the target for 4 seconds. After 1.5 seconds, LeBlanc's next spell shatters the Sigil to deal magic damage.<br><br>Sigil of Malice cannot occur again on the same unit for 5 seconds.",
				"image": {
					"full": "LeblancP.png",
					"sprite": "passive1.png",
					"group": "passive",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Leblanc",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1082",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leblanc",
					"title": "LeblancTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"LeeSin": {
			"id": "LeeSin",
			"key": "64",
			"name": "Lee Sin",
			"title": "the Blind Monk",
			"image": {
				"full": "LeeSin.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 0,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "64000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "64001",
					"num": 1,
					"name": "Traditional Lee Sin",
					"chromas": false
				},
				{
					"id": "64002",
					"num": 2,
					"name": "Acolyte Lee Sin",
					"chromas": false
				},
				{
					"id": "64003",
					"num": 3,
					"name": "Dragon Fist Lee Sin",
					"chromas": true
				},
				{
					"id": "64004",
					"num": 4,
					"name": "Muay Thai Lee Sin",
					"chromas": false
				},
				{
					"id": "64005",
					"num": 5,
					"name": "Pool Party Lee Sin",
					"chromas": false
				},
				{
					"id": "64006",
					"num": 6,
					"name": "SKT T1 Lee Sin",
					"chromas": false
				},
				{
					"id": "64010",
					"num": 10,
					"name": "Knockout Lee Sin",
					"chromas": false
				},
				{
					"id": "64011",
					"num": 11,
					"name": "God Fist Lee Sin",
					"chromas": false
				}
			],
			"lore": "A master of Ionia's ancient martial arts, Lee Sin is a principled fighter who channels the essence of the dragon spirit to face any challenge. Though he lost his sight many years ago, the warrior-monk has devoted his life to protecting his homeland against any who would dare upset its sacred balance. Enemies who underestimate his meditative demeanor will endure his fabled burning fists and blazing roundhouse kicks.",
			"blurb": "A master of Ionia's ancient martial arts, Lee Sin is a principled fighter who channels the essence of the dragon spirit to face any challenge. Though he lost his sight many years ago, the warrior-monk has devoted his life to protecting his homeland...",
			"allytips": [
				"Use Sonic Wave before Dragon's Rage so you can chase the target with Resonating Strike.",
				"Take advantage of Flurry by weaving in basic attacks between spell casts - this maximizes damage output and minimizes Energy loss.",
				"Self-casting Safeguard and using Iron Will are powerful tools for killing neutral monsters (in the jungle)."
			],
			"enemytips": [
				"Stay spread out to minimize the impact of Lee Sin's ultimate, Dragon's Rage.",
				"Lee Sin has powerful tools to combat physical damage in Iron Will and Cripple but he is still vulnerable to magic damage.",
				"Lee Sin relies heavily on following up with his abilities. Use disables to prevent him from chaining together his abilities and attacks."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Energy",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 3,
				"difficulty": 6
			},
			"stats": {
				"hp": 570.8,
				"hpperlevel": 85,
				"mp": 200,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 33,
				"armorperlevel": 3.7,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7.5,
				"hpregenperlevel": 0.7,
				"mpregen": 50,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 69.18,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.04,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "BlindMonkQOne",
					"name": "Sonic Wave / Resonating Strike",
					"description": "Sonic Wave: Lee Sin projects a discordant wave of sound to locate his enemies, dealing physical damage to the first enemy it encounters. If Sonic Wave hits, Lee Sin can cast Resonating Strike for the next 3 seconds.<br>Resonating Strike: Lee Sin dashes to the enemy hit by Sonic Wave, dealing physical damage plus 8% of their missing Health.",
					"tooltip": "<spellActive>Sonic Wave: </spellActive>Lee Sin projects a discordant wave of sound to locate his enemies, dealing {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage to the first enemy it encounters, granting <keyword>True Sight</keyword> of the target. <specialRules>If Sonic Wave hits, Lee Sin can cast Resonating Strike for the next {{ e7 }} seconds.</specialRules><br /><br /><spellActive>Resonating Strike: </spellActive>Lee Sin dashes to the enemy hit by Sonic Wave, dealing {{ e2 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage plus {{ e3 }}% of their missing Health (Max: {{ e6 }} Damage vs. Monsters).",
					"leveltip": {
						"label": [
							"Sonic Wave Damage",
							"Resonating Strike Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10,
						9,
						8,
						7
					],
					"cooldownBurn": "11/10/9/8/7",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							55,
							85,
							115,
							145,
							175
						],
						[
							55,
							85,
							115,
							145,
							175
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							1350,
							1350,
							1350,
							1350,
							1350
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/85/115/145/175",
						"55/85/115/145/175",
						"8",
						"30",
						"1350",
						"400",
						"3",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.9,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Energy / {{ e4 }} Energy",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "BlindMonkQOne.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy / {{ e4 }} Energy"
				},
				{
					"id": "BlindMonkWOne",
					"name": "Safeguard / Iron Will",
					"description": "Safeguard: Lee Sin rushes to target ally, shielding himself from damage. If the ally is a champion, they are also shielded. After using Safeguard, Lee Sin can cast Iron Will for the next 3 seconds.<br>Iron Will: Lee Sin's intense training allows him to thrive in battle. For 4 seconds, Lee Sin gains Life Steal and Spell Vamp.",
					"tooltip": "<spellActive>Safeguard: </spellActive>Lee Sin rushes to target ally. If the ally is a champion, Lee Sin shields the ally and himself for {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> damage for {{ e3 }} seconds and Safeguard's cooldown is reduced by {{ e6 }}%. <specialRules>After using Safeguard, Lee Sin can cast Iron Will for the next {{ e9 }} seconds.</specialRules><br /><br /><spellActive>Iron Will: </spellActive>Lee Sin gains {{ e2 }}% Life Steal and Spell Vamp for {{ e8 }} seconds.",
					"leveltip": {
						"label": [
							"Safeguard Shield Absorption",
							"Iron Will Lifesteal / Spell Vamp %"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						14,
						14,
						14,
						14
					],
					"cooldownBurn": "14",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							55,
							110,
							165,
							220,
							275
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							1350,
							1350,
							1350,
							1350,
							1350
						]
					],
					"effectBurn": [
						null,
						"55/110/165/220/275",
						"10/15/20/25/30",
						"2",
						"30",
						"5",
						"50",
						"0",
						"4",
						"3",
						"1350"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Energy / {{ e4 }} Energy",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "BlindMonkWOne.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy / {{ e4 }} Energy"
				},
				{
					"id": "BlindMonkEOne",
					"name": "Tempest / Cripple",
					"description": "Tempest: Lee Sin smashes the ground, sending out a shockwave that deals magic damage and reveals enemy units hit. If Tempest hits an enemy, Lee Sin can cast cripple for the next 3 seconds.<br>Cripple: Lee Sin cripples nearby enemies damaged by Tempest, reducing their Movement Speed for 4 seconds. Movement Speed recovers gradually over the duration.",
					"tooltip": "<spellActive>Tempest: </spellActive>Lee Sin smashes the ground, sending out a shockwave that deals {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> magic damage. <specialRules>If Tempest hits an enemy, Lee Sin can cast Cripple for the next {{ e6 }} seconds.</specialRules><br /><br /><spellActive>Cripple: </spellActive>Lee Sin cripples nearby enemies struck by Tempest for {{ e5 }} seconds, slowing their Movement Speed by {{ e2 }}%. Movement Speed recovers gradually over the duration.",
					"leveltip": {
						"label": [
							"Tempest Damage",
							"Cripple Slow"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							60,
							95,
							130,
							165,
							200
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"20/30/40/50/60",
						"60/95/130/165/200",
						"30",
						"4",
						"3",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Energy / {{ e4 }} Energy",
					"maxammo": "-1",
					"range": [
						425,
						425,
						425,
						425,
						425
					],
					"rangeBurn": "425",
					"image": {
						"full": "BlindMonkEOne.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy / {{ e4 }} Energy"
				},
				{
					"id": "BlindMonkRKick",
					"name": "Dragon's Rage",
					"description": "Lee Sin performs a powerful roundhouse kick launching his target back, dealing physical damage to the target and any enemies they collide with. Enemies the target collides with are knocked into the air for a short duration. This technique was taught to him by Jesse Perring, although Lee Sin does not kick players off the map.",
					"tooltip": "Lee Sin performs a powerful roundhouse kick knocking an enemy champion back and dealing {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage.<br /><br />Enemies the target collides with are knocked into the air briefly and take physical damage equal to {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> plus {{ e3 }}% of the initial target's bonus health.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus Health Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						85,
						60
					],
					"cooldownBurn": "110/85/60",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							150,
							300,
							450
						],
						[
							75,
							125,
							175
						],
						[
							12,
							15,
							18
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/300/450",
						"75/125/175",
						"12/15/18",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 2,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 2,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						375,
						375,
						375
					],
					"rangeBurn": "375",
					"image": {
						"full": "BlindMonkRKick.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Flurry",
				"description": "After Lee Sin uses an ability, his next 2 basic attacks gain 40% Attack Speed and return 20/10 Energy.",
				"image": {
					"full": "LeeSinPassive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "LeeSin",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3252",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "LeeSin",
					"title": "LeeSinTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3252",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Leona": {
			"id": "Leona",
			"key": "89",
			"name": "Leona",
			"title": "the Radiant Dawn",
			"image": {
				"full": "Leona.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 48,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "89000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "89001",
					"num": 1,
					"name": "Valkyrie Leona",
					"chromas": false
				},
				{
					"id": "89002",
					"num": 2,
					"name": "Defender Leona",
					"chromas": false
				},
				{
					"id": "89003",
					"num": 3,
					"name": "Iron Solari Leona",
					"chromas": false
				},
				{
					"id": "89004",
					"num": 4,
					"name": "Pool Party Leona",
					"chromas": true
				},
				{
					"id": "89008",
					"num": 8,
					"name": "PROJECT: Leona",
					"chromas": false
				},
				{
					"id": "89009",
					"num": 9,
					"name": "Barbecue Leona",
					"chromas": false
				}
			],
			"lore": "Imbued with the fire of the sun, Leona is a holy warrior of the Solari who defends Mount Targon with her Zenith Blade and the Shield of Daybreak. Her skin shimmers with starfire while her eyes burn with the power of the celestial Aspect within her. Armored in gold and bearing a terrible burden of ancient knowledge, Leona brings enlightenment to some, death to others.",
			"blurb": "Imbued with the fire of the sun, Leona is a holy warrior of the Solari who defends Mount Targon with her Zenith Blade and the Shield of Daybreak. Her skin shimmers with starfire while her eyes burn with the power of the celestial Aspect within her...",
			"allytips": [
				"Lead the charge and mark your foes with Sunlight before your allies deal damage.",
				"Shield of Daybreak and Zenith Blade form a powerful offensive combo.",
				"You can absorb a huge amount of damage using Eclipse, but you must stay near enemies to gain the bonus duration."
			],
			"enemytips": [
				"When Leona activates Eclipse, you have three seconds to get away from her before she deals damage.",
				"Only foes in the center of Solar Flare get stunned, so you can often avoid this if you're quick."
			],
			"tags": [
				"Tank",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 8,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 576.16,
				"hpperlevel": 87,
				"mp": 302.2,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 47,
				"armorperlevel": 3.6,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.85,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 60.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.9
			},
			"spells": [
				{
					"id": "LeonaShieldOfDaybreak",
					"name": "Shield of Daybreak",
					"description": "Leona uses her shield to perform her next basic attack, dealing bonus magic damage and stunning the target.",
					"tooltip": "Next basic attack deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and stuns for {{ e1 }} second.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							10,
							35,
							60,
							85,
							110
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1",
						"10/35/60/85/110",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						100,
						100,
						100,
						100,
						100
					],
					"rangeBurn": "100",
					"image": {
						"full": "LeonaShieldOfDaybreak.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LeonaSolarBarrier",
					"name": "Eclipse",
					"description": "Leona raises her shield to gain Armor and Magic Resist. When the duration first ends, if there are nearby enemies, she will deal magic damage to them and prolong the duration of the effect.",
					"tooltip": "Grants {{ e4 }} <span class=\"colorFFFF00\">(+{{ f1 }})</span> bonus Armor and {{ e2 }} <span class=\"colorFF00FF\">(+{{ f2 }})</span> Magic Resist for {{ e3 }} seconds. When the effect ends, nearby enemies struck take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and Leona retains her bonus Armor and Magic Resist for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Armor",
							"Magic Resist"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						14,
						14,
						14,
						14
					],
					"cooldownBurn": "14",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							40,
							80,
							120,
							160,
							200
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							25,
							35,
							45,
							55,
							65
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/80/120/160/200",
						"20/30/40/50/60",
						"3",
						"25/35/45/55/65",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusarmor",
							"coeff": 0.2,
							"key": "f1"
						},
						{
							"link": "bonusspellblock",
							"coeff": 0.2,
							"key": "f2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "LeonaSolarBarrier.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LeonaZenithBlade",
					"name": "Zenith Blade",
					"description": "Leona projects a solar image of her sword, dealing magic damage to all enemies in a line. When the image fades, the last enemy champion struck will be briefly immobilized and Leona will dash to them.",
					"tooltip": "Strikes all enemies in a line dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The last enemy Champion struck will be rooted for {{ e2 }} seconds and Leona will dash to them.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						875,
						875,
						875,
						875,
						875
					],
					"rangeBurn": "875",
					"image": {
						"full": "LeonaZenithBlade.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LeonaSolarFlare",
					"name": "Solar Flare",
					"description": "Leona calls down a beam of solar energy, dealing damage to enemies in an area. Enemies in the center of the area are stunned, while enemies on the outside are slowed. Afterward, Leona's sword is charged with the power of the sun and deals bonus magic damage for a few attacks.",
					"tooltip": "Calls down a radiant beam of solar energy dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing enemies by {{ e1 }}% for {{ e2 }} seconds. Enemies in the center of the flare are stunned instead of slowed.<br /><br />Leona's sword remains charged with <span class=\"colorFFBB00\">Incandescence</span>, causing her next {{ e5 }} basic attacks to gain 100 range and deal {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus magic damage on hit.",
					"leveltip": {
						"label": [
							"Damage",
							"Incandescence Damage",
							"Incandescent Attacks",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						90,
						75,
						60
					],
					"cooldownBurn": "90/75/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							80,
							80,
							80
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							30,
							40,
							50
						],
						[
							100,
							175,
							250
						],
						[
							3,
							4,
							5
						],
						[
							5,
							5,
							5
						],
						[
							100,
							100,
							100
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80",
						"1.5",
						"30/40/50",
						"100/175/250",
						"3/4/5",
						"5",
						"100",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "LeonaSolarFlare.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Sunlight",
				"description": "Damaging spells afflict enemies with Sunlight for 1.5 seconds. When allied Champions deal damage to those targets, they consume the Sunlight to deal additional magic damage.",
				"image": {
					"full": "LeonaSunlight.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Leona",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Leona",
					"title": "LeonaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Lissandra": {
			"id": "Lissandra",
			"key": "127",
			"name": "Lissandra",
			"title": "the Ice Witch",
			"image": {
				"full": "Lissandra.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 96,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "127000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "127001",
					"num": 1,
					"name": "Bloodstone Lissandra",
					"chromas": false
				},
				{
					"id": "127002",
					"num": 2,
					"name": "Blade Queen Lissandra",
					"chromas": false
				},
				{
					"id": "127003",
					"num": 3,
					"name": "Program Lissandra",
					"chromas": false
				}
			],
			"lore": "Lissandra's magic twists the pure power of ice into something dark and terrible. With the force of her black ice, she does more than freeze—she impales and crushes those who oppose her. To the terrified denizens of the north, she is known only as ''The Ice Witch.'' The truth is much more sinister: Lissandra is a corruptor of nature who plots to unleash an ice age on the world.",
			"blurb": "Lissandra's magic twists the pure power of ice into something dark and terrible. With the force of her black ice, she does more than freeze—she impales and crushes those who oppose her. To the terrified denizens of the north, she is known only as ''The...",
			"allytips": [
				"You can instantly use your ultimate on yourself by pressing the self cast key and the ultimate key at once (alt+R by default).",
				"Casting Glacial Path and then running in the opposite direction will leave your enemies uncertain which way you will actually go.",
				"Lissandra's abilities are shorter range than those of many mages. As a result, buying items that offer both ability power and defense, like Zhonya's Hourglass and Banshee's Veil, can be a great choice to help her both survive and deal damage."
			],
			"enemytips": [
				"The best way to stop Lissandra from moving using her Glacial Path is to immobilize her before she reactivates it.",
				"Lissandra's Ring of Frost has a long cooldown at early ranks; engage her while it's on cooldown.",
				"Lissandra's Ice Shard only slows the first unit it hits. Approach Lissandra from behind your team's minions to avoid being slowed."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 5,
				"magic": 8,
				"difficulty": 6
			},
			"stats": {
				"hp": 518,
				"hpperlevel": 87,
				"mp": 304,
				"mpperlevel": 60,
				"movespeed": 325,
				"armor": 20.216,
				"armorperlevel": 3.7,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 5.672,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53,
				"attackdamageperlevel": 2.7,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "LissandraQ",
					"name": "Ice Shard",
					"description": "Throws a spear of ice that shatters when it hits an enemy, dealing magic damage and slowing Movement Speed. Shards pass through the target, dealing the same damage to other enemies hit.",
					"tooltip": "Throws a spear of ice that shatters when it hits an enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing Movement Speed by {{ e3 }}% for {{ e2 }} seconds. Shards then pass through the target, dealing the same damage to other enemies hit.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.25,
						4.5,
						3.75,
						3
					],
					"cooldownBurn": "6/5.25/4.5/3.75/3",
					"cost": [
						85,
						85,
						85,
						85,
						85
					],
					"costBurn": "85",
					"effect": [
						null,
						[
							70,
							100,
							130,
							160,
							190
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							16,
							19,
							22,
							25,
							28
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/100/130/160/190",
						"1.5",
						"16/19/22/25/28",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "LissandraQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LissandraW",
					"name": "Ring of Frost",
					"description": "Freezes nearby enemies in ice, dealing magic damage and rooting them. ",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and roots them for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Root Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							1.1,
							1.2,
							1.3,
							1.4,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"1.1/1.2/1.3/1.4/1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "LissandraW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LissandraE",
					"name": "Glacial Path",
					"description": "Lissandra creates an ice claw that deals magic damage. Reactivating this ability transports Lissandra to the claw's current location.",
					"tooltip": "Casts an ice claw that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies hit.<br /><br />Reactivating this ability transports Lissandra to the claw's current location.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						21,
						18,
						15,
						12
					],
					"cooldownBurn": "24/21/18/15/12",
					"cost": [
						80,
						85,
						90,
						95,
						100
					],
					"costBurn": "80/85/90/95/100",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							14,
							13,
							12,
							11,
							10
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"14/13/12/11/10",
						"20",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1050,
						1050,
						1050,
						1050,
						1050
					],
					"rangeBurn": "1050",
					"image": {
						"full": "LissandraE.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LissandraR",
					"name": "Frozen Tomb",
					"description": "If cast on an enemy champion, the target is frozen solid, stunning it. If cast on Lissandra, she encases herself in dark ice, healing herself while becoming untargetable and invulnerable. Dark ice then emanates from the target dealing magic damage to enemies and slowing Movement Speed.",
					"tooltip": "<span class=\"colorFF9999\">On Enemy Cast: </span>Freezes target champion solid, stunning it for {{ e4 }} seconds.<br /><br /><span class=\"colorCCFF99\">On Self Cast: </span>Lissandra encases herself in dark ice for {{ e5 }} seconds, healing for {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span>, increased by {{ e7 }}% for each {{ e8 }}% Health she is missing. During this time Lissandra is untargetable and invulnerable but is unable to take any actions.<br /><br />Dark ice then emanates from the target dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies. The ice lasts for {{ e3 }} seconds and slows enemy Movement Speed by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Heal",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						105,
						80
					],
					"cooldownBurn": "130/105/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							30,
							45,
							75
						],
						[
							3,
							3,
							3
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							100,
							150,
							200
						],
						[
							1,
							1,
							1
						],
						[
							1,
							1,
							1
						],
						[
							292,
							292,
							292
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"30/45/75",
						"3",
						"1.5",
						"2.5",
						"100/150/200",
						"1",
						"1",
						"292",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "LissandraR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Iceborn",
				"description": "Every several seconds Lissandra's next ability costs no Mana. This cooldown is reduced whenever Lissandra impairs an enemy's movement with an ability (does not apply to movement-impairing effects from items).",
				"image": {
					"full": "Lissandra_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Lissandra",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3191",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lissandra",
					"title": "LissandraTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Lucian": {
			"id": "Lucian",
			"key": "236",
			"name": "Lucian",
			"title": "the Purifier",
			"image": {
				"full": "Lucian.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 144,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "236000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "236001",
					"num": 1,
					"name": "Hired Gun Lucian",
					"chromas": false
				},
				{
					"id": "236002",
					"num": 2,
					"name": "Striker Lucian",
					"chromas": false
				},
				{
					"id": "236006",
					"num": 6,
					"name": "PROJECT: Lucian",
					"chromas": false
				},
				{
					"id": "236007",
					"num": 7,
					"name": "Heartseeker Lucian",
					"chromas": false
				}
			],
			"lore": "Once a Sentinel of Light, Lucian is a grim hunter of undying spirits, pursuing them relentlessly and annihilating them with his twin relic pistols. Consumed by the need to avenge his dead wife, he will not rest until Thresh, the specter who holds her soul, is destroyed. Merciless and single-minded, Lucian allows nothing to stand in the path of this vengeance—anyone or anything foolish enough to try is blown away by an overwhelming barrage of magical gunfire.",
			"blurb": "Once a Sentinel of Light, Lucian is a grim hunter of undying spirits, pursuing them relentlessly and annihilating them with his twin relic pistols. Consumed by the need to avenge his dead wife, he will not rest until Thresh, the specter who holds her...",
			"allytips": [
				"For optimal burst, try to combine Relentless Pursuit into Piercing Light.",
				"Ardent Blaze actually explodes in a star pattern. Try to line it up so the spokes hit enemy champions.",
				"Once you have chosen an angle for The Culling, you cannot change it. Pick your moment well!",
				"Because of Lightslinger, Lucian benefits more from Attack Damage than he does from Attack Speed."
			],
			"enemytips": [
				"Lucian has strong burst, but little sustained damage.",
				"Lucian cannot change the aim of The Culling. Take advantage of this by avoiding the angle of the bullets.",
				"Piercing Light does not give Lucian extra Attack Range. He still needs to find a target in range to line up his shot. Avoid Piercing Light by anticipating the angle Lucian will choose."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 3,
				"difficulty": 6
			},
			"stats": {
				"hp": 554.4,
				"hpperlevel": 80,
				"mp": 348.88,
				"mpperlevel": 38,
				"movespeed": 335,
				"armor": 33,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 6,
				"hpregenperlevel": 0.65,
				"mpregen": 8.176,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 3.3
			},
			"spells": [
				{
					"id": "LucianQ",
					"name": "Piercing Light",
					"description": "Lucian shoots a bolt of piercing light through a target.",
					"tooltip": "Shoots a bolt of piercing light through an enemy unit, damaging enemies in a line for {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> ({{ e2 }}% of bonus Attack Damage) physical damage.<br /><br /><rules><span class=\"color8c8c8c\">Piercing Light's cast time decreases slightly as Lucian gains levels.</span></rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus Attack Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							85,
							120,
							155,
							190,
							225
						],
						[
							60,
							70,
							80,
							90,
							100
						],
						[
							900,
							900,
							900,
							900,
							900
						],
						[
							0.41,
							0.41,
							0.41,
							0.41,
							0.41
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"85/120/155/190/225",
						"60/70/80/90/100",
						"900",
						"0.41",
						"100",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.6,
								0.75,
								0.9,
								1.05,
								1.2
							],
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "LucianQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LucianW",
					"name": "Ardent Blaze",
					"description": "Lucian shoots a missile that explodes in a star shape, marking enemies. Lucian gains Movement Speed for attacking marked enemies.",
					"tooltip": "Fires a shot that explodes upon enemy contact or reaching the end of its path. The explosion deals {{ e1 }} <span class=\"color88FF88\">(+{{ a1 }})</span> magic damage and marks enemies for 6 seconds.<br /><br />When Lucian or his allies damage a marked target, Lucian gains {{ e2 }} Movement Speed for 1 second.",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed",
							"Cooldown</br>"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							60,
							65,
							70,
							75,
							80
						],
						[
							900,
							900,
							900,
							900,
							900
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							700,
							700,
							700,
							700,
							700
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"60/65/70/75/80",
						"900",
						"0",
						"1",
						"200",
						"1",
						"6",
						"1",
						"700"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "LucianW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LucianE",
					"name": "Relentless Pursuit",
					"description": "Lucian quickly dashes a short distance. Lightslinger attacks reduce Relentless Pursuit's cooldown.",
					"tooltip": "Quickly dashes a short distance.<br /><br />Whenever Lightslinger hits an enemy, Relentless Pursuit's cooldown is reduced by {{ e1 }} second (doubles to {{ e2 }} seconds against champions).",
					"leveltip": {
						"label": [
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20,
						18,
						16,
						14
					],
					"cooldownBurn": "22/20/18/16/14",
					"cost": [
						40,
						30,
						20,
						10,
						0
					],
					"costBurn": "40/30/20/10/0",
					"effect": [
						null,
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							425,
							425,
							425,
							425,
							425
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							1350,
							1350,
							1350,
							1350,
							1350
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1",
						"2",
						"425",
						"200",
						"1350",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						445,
						445,
						445,
						445,
						445
					],
					"rangeBurn": "445",
					"image": {
						"full": "LucianE.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LucianR",
					"name": "The Culling",
					"description": "Lucian unleashes a torrent of shots from his weapons.",
					"tooltip": "Lucian moves freely while firing rapidly in a single direction for {{ e1 }} seconds. His shots collide with the first enemy they hit and each do {{ e2 }} <span class=\"color88FF88\">(+{{ a1 }})</span> <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage.  The Culling does {{ e8 }}% damage to minions.<br /><br />Lucian may use Relentless Pursuit during The Culling.<br /><br />Reactivate The Culling to cancel early.",
					"leveltip": {
						"label": [
							"Damage",
							"Number of Shots",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						100,
						90
					],
					"cooldownBurn": "110/100/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							3,
							3,
							3
						],
						[
							20,
							35,
							50
						],
						[
							2.5,
							3,
							3.5
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							20,
							25,
							30
						],
						[
							0.75,
							0.75,
							0.75
						],
						[
							1050,
							1050,
							1050
						],
						[
							400,
							400,
							400
						],
						[
							125,
							125,
							125
						],
						[
							0.25,
							0.25,
							0.25
						]
					],
					"effectBurn": [
						null,
						"3",
						"20/35/50",
						"2.5/3/3.5",
						"2.5",
						"20/25/30",
						"0.75",
						"1050",
						"400",
						"125",
						"0.25"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 0.2,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1400,
						1400,
						1400
					],
					"rangeBurn": "1400",
					"image": {
						"full": "LucianR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Lightslinger",
				"description": "Whenever Lucian uses an ability, his next attack becomes a double-shot.",
				"image": {
					"full": "Lucian_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Lucian",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lucian",
					"title": "LucianTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Lulu": {
			"id": "Lulu",
			"key": "117",
			"name": "Lulu",
			"title": "the Fae Sorceress",
			"image": {
				"full": "Lulu.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 192,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "117000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "117001",
					"num": 1,
					"name": "Bittersweet Lulu",
					"chromas": false
				},
				{
					"id": "117002",
					"num": 2,
					"name": "Wicked Lulu",
					"chromas": false
				},
				{
					"id": "117003",
					"num": 3,
					"name": "Dragon Trainer Lulu",
					"chromas": false
				},
				{
					"id": "117004",
					"num": 4,
					"name": "Winter Wonder Lulu",
					"chromas": false
				},
				{
					"id": "117005",
					"num": 5,
					"name": "Pool Party Lulu",
					"chromas": true
				},
				{
					"id": "117006",
					"num": 6,
					"name": "Star Guardian Lulu",
					"chromas": false
				}
			],
			"lore": "The yordle mage Lulu is known for conjuring dreamlike illusions and fanciful creatures as she roams Runeterra with her fairy companion Pix. Lulu shapes reality on a whim, warping the fabric of the world, and what she views as the constraints of this mundane, physical realm. While others might consider her magic at best unnatural, and at worst dangerous, she believes everyone could use a touch of enchantment.",
			"blurb": "The yordle mage Lulu is known for conjuring dreamlike illusions and fanciful creatures as she roams Runeterra with her fairy companion Pix. Lulu shapes reality on a whim, warping the fabric of the world, and what she views as the constraints of this...",
			"allytips": [
				"Glitterlance can be fired at odd angles depending on where your cursor is - Moving your cursor closer to Pix and Lulu will change your area of effect size considerably.",
				"Consider casting Help, Pix! on ranged attackers for the Pix boost and Wild Growth on Tanks or Fighters for the added initiation power."
			],
			"enemytips": [
				"The shots from Lulu's faerie can be intercepted - hide behind your minions to avoid the additional Faerie attacks.",
				"Lulu excels when opponents heavily commit. Don't give her this chance! Use heavy harass tactics instead to force Lulu and her partner out of lane."
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 5,
				"magic": 7,
				"difficulty": 5
			},
			"stats": {
				"hp": 525,
				"hpperlevel": 74,
				"mp": 350,
				"mpperlevel": 55,
				"movespeed": 330,
				"armor": 28.22,
				"armorperlevel": 3.7,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6,
				"hpregenperlevel": 0.6,
				"mpregen": 11,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 46.368,
				"attackdamageperlevel": 2.6,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.25
			},
			"spells": [
				{
					"id": "LuluQ",
					"name": "Glitterlance",
					"description": "Pix and Lulu each fire a bolt of magical energy that heavily slows all enemies it hits. An enemy can only be damaged by one bolt.",
					"tooltip": "Lulu and Pix each fire a piercing bolt dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy hit and {{ f4 }}<span class=\"color99FF99\"> (+{{ f5 }})</span> to all additional enemies. Enemies hit are slowed by {{ e2 }}%, decaying over the next {{ e3 }} second(s).<br /><br />An enemy can only be damaged for up to a total of <span class=\"color99FF99\">{{ f6 }}</span> damage per cast.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						7,
						7,
						7,
						7
					],
					"cooldownBurn": "7",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.7,
							0.7,
							0.7,
							0.7,
							0.7
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"80",
						"2",
						"0",
						"0.7",
						"8",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "LuluQ.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LuluW",
					"name": "Whimsy",
					"description": "If cast on an ally, grants them Attack Speed and Movement Speed for a short time. If cast on an enemy, turns them into an adorable critter that can't attack or cast spells.",
					"tooltip": "<span class=\"colorCCFF99\">On Ally Cast: </span>Target ally gains {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span>% Movement Speed and {{ e7 }}% Attack Speed for {{ e5 }} seconds.<br /><br /><span class=\"colorFF9999\">On Enemy Cast: </span>Polymorphs an enemy champion for {{ e3 }} seconds, disabling their ability to attack or cast spells and reducing their base Movement Speed by {{ e4 }}.",
					"leveltip": {
						"label": [
							"Movement and Attack Speed Duration",
							"Attack Speed Bonus",
							"Polymorph Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e7 }}% -> {{ e7NL }}%",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						65,
						65,
						65,
						65,
						65
					],
					"costBurn": "65",
					"effect": [
						null,
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.25,
							1.5,
							1.75,
							2,
							2.25
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							3,
							3.25,
							3.5,
							3.75,
							4
						],
						[
							0.01,
							0.01,
							0.01,
							0.01,
							0.01
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30",
						"0",
						"1.25/1.5/1.75/2/2.25",
						"60",
						"3/3.25/3.5/3.75/4",
						"0.01",
						"25/30/35/40/45",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.05,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "LuluW.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LuluE",
					"name": "Help, Pix!",
					"description": "If cast on an ally, commands Pix to jump to an ally and shield them. He then follows them and aids their attacks. If cast on an enemy, commands Pix to jump to an enemy and damage them. He then follows them and grants you vision of that enemy.",
					"tooltip": "<span class=\"colorCCFF99\">On Ally Cast: </span>Commands Pix to jump to an ally and then follow and aid their attacks instead of Lulu's for {{ e1 }} seconds. If the ally is a champion, Pix shields them from {{ e2 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> damage for {{ e1 }} seconds.<br /><br /><span class=\"colorFF9999\">On Enemy Cast: </span>Pix deals {{ e4 }}<span class=\"color99FF99\"> (+{{ a2 }})</span> magic damage to target enemy unit. Pix then follows and grants <span class=\"coloree91d7\">True Sight</span> of them for {{ e6 }} seconds.</span> ",
					"leveltip": {
						"label": [
							"Shield Amount",
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6",
						"70/105/140/175/210",
						"50",
						"80/110/140/170/200",
						"25",
						"4",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "LuluE.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LuluR",
					"name": "Wild Growth",
					"description": "Lulu enlarges an ally, knocking nearby enemies into the air and granting the ally a large amount of bonus health. For the next few seconds, that ally gains an aura that slows nearby enemies.",
					"tooltip": "Lulu enlarges her ally, knocking nearby enemies into the air. For {{ e4 }} seconds, her ally gains {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> bonus health and slows nearby enemies by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Bonus Health",
							"Slow Percent",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						95,
						80
					],
					"cooldownBurn": "110/95/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							300,
							450,
							600
						],
						[
							30,
							45,
							60
						],
						[
							1,
							1,
							1
						],
						[
							7,
							7,
							7
						],
						[
							50,
							50,
							50
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"300/450/600",
						"30/45/60",
						"1",
						"7",
						"50",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "LuluR.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Pix, Faerie Companion",
				"description": "Pix is a wild Faerie that accompanies Lulu. Pix will fire a barrage of magical energy at targets that Lulu attacks.",
				"image": {
					"full": "Lulu_PixFaerieCompanion.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Lulu",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerTeleport",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerTeleport",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lulu",
					"title": "LuluTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Lux": {
			"id": "Lux",
			"key": "99",
			"name": "Lux",
			"title": "the Lady of Luminosity",
			"image": {
				"full": "Lux.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 240,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "99000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "99001",
					"num": 1,
					"name": "Sorceress Lux",
					"chromas": false
				},
				{
					"id": "99002",
					"num": 2,
					"name": "Spellthief Lux",
					"chromas": false
				},
				{
					"id": "99003",
					"num": 3,
					"name": "Commando Lux",
					"chromas": false
				},
				{
					"id": "99004",
					"num": 4,
					"name": "Imperial Lux",
					"chromas": false
				},
				{
					"id": "99005",
					"num": 5,
					"name": "Steel Legion Lux",
					"chromas": false
				},
				{
					"id": "99006",
					"num": 6,
					"name": "Star Guardian Lux",
					"chromas": false
				},
				{
					"id": "99007",
					"num": 7,
					"name": "Elementalist Lux",
					"chromas": false
				},
				{
					"id": "99008",
					"num": 8,
					"name": "Lunar Empress Lux",
					"chromas": true
				}
			],
			"lore": "Luxanna Crownguard hails from Demacia, an insular realm where magical abilities are viewed with fear and suspicion. Able to bend light to her will, she grew up dreading discovery and exile, and was forced to keep her power secret, in order to preserve her family's noble status. Nonetheless, Lux's optimism and resilience have led her to embrace her unique talents, and she now covertly wields them in service of her homeland.",
			"blurb": "Luxanna Crownguard hails from Demacia, an insular realm where magical abilities are viewed with fear and suspicion. Able to bend light to her will, she grew up dreading discovery and exile, and was forced to keep her power secret, in order to preserve...",
			"allytips": [
				"Lux has great zone control abilities. Try to set up Lucent Singularity to prevent an enemy's advance or escape.",
				"If you have trouble landing Prismatic Barrier, remember that it returns to you after it reaches max range. Try positioning yourself to hit your allies with its return trip.",
				"Lucent Singularity is a great scouting tool. Try throwing it into brush before walking into it to check for ambushes."
			],
			"enemytips": [
				"Lux has powerful zone control abilities. Try to spread out and attack from different directions so she cannot lock down a specific area.",
				"When retreating with low health, be prepared to dodge Lux's Final Spark, a red targeting beam fires prior to the main beam, so try to move to the side if possible."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 4,
				"magic": 9,
				"difficulty": 5
			},
			"stats": {
				"hp": 490,
				"hpperlevel": 91,
				"mp": 384,
				"mpperlevel": 47,
				"movespeed": 330,
				"armor": 18.72,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.54,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "LuxLightBinding",
					"name": "Light Binding",
					"description": "Lux releases a sphere of light that binds and deals damage to up to two enemy units.",
					"tooltip": "Fires a ball of light, rooting up to two enemies for {{ e3 }} seconds and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to each.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12.5,
						12,
						11.5,
						11
					],
					"cooldownBurn": "13/12.5/12/11.5/11",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							50,
							100,
							150,
							200,
							250
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/100/150/200/250",
						"50",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1175,
						1175,
						1175,
						1175,
						1175
					],
					"rangeBurn": "1175",
					"image": {
						"full": "LuxLightBinding.png",
						"sprite": "spell6.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LuxPrismaticWave",
					"name": "Prismatic Barrier",
					"description": "Lux throws her wand and bends the light around any friendly target it touches, protecting them from enemy damage.",
					"tooltip": "Throws Lux's wand in target direction protecting her and all allied Champions it touches from {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for 3 seconds.<br /><br />Upon reaching its destination it returns to Lux, protecting her and other allied Champions it touches from another {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for 3 seconds.<br /><br /><rules>Shielding an ally with the outgoing shield doubles the value of the returning shield.</rules>",
					"leveltip": {
						"label": [
							"Shield",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							2,
							4,
							6,
							8,
							10
						],
						[
							50,
							65,
							80,
							95,
							110
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2/4/6/8/10",
						"50/65/80/95/110",
						"3",
						"100",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "LuxPrismaticWave.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LuxLightStrikeKugel",
					"name": "Lucent Singularity",
					"description": "Fires an anomaly of twisted light to an area, which slows nearby enemies. Lux can detonate it to damage enemies in the area of effect.",
					"tooltip": "Creates a zone that slows enemies by {{ e1 }}%. After {{ e3 }} seconds the zone detonates dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Activate again to detonate early.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Amount",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						70,
						85,
						100,
						115,
						130
					],
					"costBurn": "70/85/100/115/130",
					"effect": [
						null,
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/30/35/40/45",
						"60/105/150/195/240",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "LuxLightStrikeKugel.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "LuxMaliceCannon",
					"name": "Final Spark",
					"description": "After gathering energy, Lux fires a beam of light that deals damage to all targets in the area. If Final Spark kills a champion, part of its cooldown is refunded. In addition, triggers Lux's passive ability and refreshes the Illumination debuff duration.",
					"tooltip": "Fires a dazzling ray of light dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in a line. If Final Spark kills an enemy champion, {{ e3 }}% of its cooldown is refunded.<br /><br />Final Spark ignites and refreshes the Illumination debuff. ",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown Refund",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						80,
						65,
						50
					],
					"cooldownBurn": "80/65/50",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							300,
							400,
							500
						],
						[
							1,
							1,
							1
						],
						[
							10,
							30,
							50
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"300/400/500",
						"1",
						"10/30/50",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3340,
						3340,
						3340
					],
					"rangeBurn": "3340",
					"image": {
						"full": "LuxMaliceCannon.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Illumination",
				"description": "Lux's damaging spells charge the target with energy for 6 seconds. Lux's next attack ignites the energy, dealing bonus magic damage (depending on Lux's level) to the target.",
				"image": {
					"full": "LuxIlluminatingFraulein.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Lux",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3114",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Lux",
					"title": "LuxTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Malphite": {
			"id": "Malphite",
			"key": "54",
			"name": "Malphite",
			"title": "Shard of the Monolith",
			"image": {
				"full": "Malphite.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 288,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "54000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "54001",
					"num": 1,
					"name": "Shamrock Malphite",
					"chromas": false
				},
				{
					"id": "54002",
					"num": 2,
					"name": "Coral Reef Malphite",
					"chromas": false
				},
				{
					"id": "54003",
					"num": 3,
					"name": "Marble Malphite",
					"chromas": false
				},
				{
					"id": "54004",
					"num": 4,
					"name": "Obsidian Malphite",
					"chromas": false
				},
				{
					"id": "54005",
					"num": 5,
					"name": "Glacial Malphite",
					"chromas": false
				},
				{
					"id": "54006",
					"num": 6,
					"name": "Mecha Malphite",
					"chromas": true
				},
				{
					"id": "54007",
					"num": 7,
					"name": "Ironside Malphite",
					"chromas": false
				}
			],
			"lore": "A massive creature of living stone, Malphite struggles to impose blessed order on a chaotic world. Birthed as a servitor-shard to an otherworldly obelisk known as the Monolith, he used his tremendous elemental strength to maintain and protect his progenitor, but ultimately failed. The only survivor of the destruction that followed, Malphite now endures Runeterra's soft folk and their fluid temperaments, while struggling to find a new role worthy of the last of his kind.",
			"blurb": "A massive creature of living stone, Malphite struggles to impose blessed order on a chaotic world. Birthed as a servitor-shard to an otherworldly obelisk known as the Monolith, he used his tremendous elemental strength to maintain and protect his...",
			"allytips": [
				"Armor naturally reduces the rate that attacks go through Granite Shield, so Brutal Strikes will strengthen the shield against physical damage.",
				"Despite his abilities scaling on Armor, some games require Malphite to get Magic Resist. When those games occur, try getting Aegis of the Legion, Mercury's Treads, and Guardian Angel."
			],
			"enemytips": [
				"If you're a physical damage character stay behind your allies when fighting Malphite. Ground Slam can significantly reduce your damage output.",
				"Malphite is one of a couple tanks who are capable of jungling. Watch out if he gets Smite."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 9,
				"magic": 7,
				"difficulty": 2
			},
			"stats": {
				"hp": 574.2,
				"hpperlevel": 90,
				"mp": 282.2,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 37,
				"armorperlevel": 3.75,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 7.324,
				"mpregenperlevel": 0.55,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61.97,
				"attackdamageperlevel": 3.375,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 3.4
			},
			"spells": [
				{
					"id": "SeismicShard",
					"name": "Seismic Shard",
					"description": "Using his primal elemental magic, Malphite sends a shard of the earth through the ground at his foe, dealing damage upon impact and stealing Movement Speed for 4 seconds.",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and steals {{ e2 }}% Movement Speed from the target for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							70,
							120,
							170,
							220,
							270
						],
						[
							14,
							17,
							20,
							23,
							26
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/120/170/220/270",
						"14/17/20/23/26",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "SeismicShard.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Obduracy",
					"name": "Brutal Strikes",
					"description": "Malphite starts to hit with such force that his attacks deal damage to all units in front of him. Passively increases his Armor (this amount is tripled while Granite Shield is active).",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Malphite's armor is increased by {{ e1 }}% (<span class=\"colorFFFF00\">{{ f1 }}</span>). While Granite Shield is active, this bonus is tripled to {{ f4.0 }}% (<span class=\"colorFFFF00\">{{ f3 }}</span>).<br /><br /><span class=\"colorFF9900\">Active: </span>Basic attacks deal an additional {{ e2 }} <span class=\"colorFFFF00\">(+{{ f2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to the target and nearby enemies. Lasts {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Armor",
							"Damage"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						25,
						25,
						25,
						25,
						25
					],
					"costBurn": "25",
					"effect": [
						null,
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							15,
							30,
							45,
							60,
							75
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/15/20/25/30",
						"15/30/45/60/75",
						"6",
						"225",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "Obduracy.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Landslide",
					"name": "Ground Slam",
					"description": "Malphite slams the ground, sending out a shockwave that deals magic damage based on his Armor as damage and reduces the Attack Speed of enemies for a short duration.",
					"tooltip": "Malphite slams the ground dealing {{ e2 }} <span class=\"colorFFFF00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to surrounding enemies, reducing their Attack Speed by {{ e1 }}% for {{ e4 }} seconds.<br /><br />This ability gains damage equal to {{ e3 }}% of Malphite's Armor.",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Speed Reduction",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						7,
						7,
						7,
						7
					],
					"cooldownBurn": "7",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							60,
							95,
							130,
							165,
							200
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/35/40/45/50",
						"60/95/130/165/200",
						"40",
						"3",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "armor",
							"coeff": 0.3,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "Landslide.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UFSlash",
					"name": "Unstoppable Force",
					"description": "Malphite ferociously charges to a location, damaging enemies and knocking them into the air.",
					"tooltip": "Malphite charges to target area. Upon his arrival he deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and knocks them into the air for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						115,
						100
					],
					"cooldownBurn": "130/115/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							1.5,
							1.75,
							2
						],
						[
							200,
							300,
							400
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.5/1.75/2",
						"200/300/400",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "UFSlash.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Granite Shield",
				"description": "Malphite is shielded by a layer of rock which absorbs damage up to 10% of his maximum Health. If Malphite has not been hit for 10 seconds, this effect recharges.",
				"image": {
					"full": "Malphite_GraniteShield.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Malphite",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3082",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malphite",
					"title": "MalphiteTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Malzahar": {
			"id": "Malzahar",
			"key": "90",
			"name": "Malzahar",
			"title": "the Prophet of the Void",
			"image": {
				"full": "Malzahar.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 336,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "90000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "90001",
					"num": 1,
					"name": "Vizier Malzahar",
					"chromas": false
				},
				{
					"id": "90002",
					"num": 2,
					"name": "Shadow Prince Malzahar",
					"chromas": false
				},
				{
					"id": "90003",
					"num": 3,
					"name": "Djinn Malzahar",
					"chromas": false
				},
				{
					"id": "90004",
					"num": 4,
					"name": "Overlord Malzahar",
					"chromas": false
				},
				{
					"id": "90005",
					"num": 5,
					"name": "Snow Day Malzahar",
					"chromas": false
				},
				{
					"id": "90006",
					"num": 6,
					"name": "Battle Boss Malzahar",
					"chromas": false
				}
			],
			"lore": "A religious zealot dedicated to the unification of all life, Malzahar truly believes the newly emergent Void to be the gateway to Runeterra's salvation. In the desert wastes of Shurima, he opened his mind to the universe, and the whispers that answered led him to Icathia. Amidst the ruins of that land, he gazed into the dark heart of the Void itself—and Malzahar emerged changed, a shepherd empowered to bring others into the fold… or to release the voidling creatures that dwell beneath.",
			"blurb": "A religious zealot dedicated to the unification of all life, Malzahar truly believes the newly emergent Void to be the gateway to Runeterra's salvation. In the desert wastes of Shurima, he opened his mind to the universe, and the whispers that answered...",
			"allytips": [
				"Wait to cast Void Swarm until there are nearby enemies for the Voidling to attack or kill.",
				"Use Call of the Void and Nether Grasp to renew the duration of Malefic Visions on enemies.",
				"Avoiding damage in lane maximizes the uptime on Void Shift, increasing Malzahar's safety dramatically."
			],
			"enemytips": [
				"When Malzahar hits a spell on enemies affected by Malefic Visions, the Visions are refreshed.",
				"Avoid minion waves that have been affected by Malefic Visions. You never know when they may die and pass the Visions onto you.",
				"Malzahar is especially dangerous when he has built up his Void Swarm."
			],
			"tags": [
				"Mage",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 2,
				"magic": 9,
				"difficulty": 6
			},
			"stats": {
				"hp": 537,
				"hpperlevel": 87,
				"mp": 300,
				"mpperlevel": 55,
				"movespeed": 335,
				"armor": 18,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 6,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.5
			},
			"spells": [
				{
					"id": "MalzaharQ",
					"name": "Call of the Void",
					"description": "Malzahar opens up two portals to the Void. After a short delay, they fire projectiles that deal Magic Damage and silence enemy champions.",
					"tooltip": "Malzahar opens two portals to the Void that fire projectiles inward, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage and silencing enemies hit for {{ e2 }} second(s).",
					"leveltip": {
						"label": [
							"Damage",
							"Silence Duration"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"1/1.25/1.5/1.75/2",
						"0.4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "MalzaharQ.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MalzaharW",
					"name": "Void Swarm",
					"description": "Malzahar summons Voidlings to attack nearby enemies.",
					"tooltip": "<span class=\"colorFF8C00\">Passive:</span> Casting Malzahar's other spells gives him Gathering Swarm, increasing the number of Voidlings summoned by Void Swarm (max {{ e6 }}).<br /><br /><span class=\"colorFF8C00\">Active:</span> Summons one or more Voidlings. Voidlings last {{ e1 }} seconds and deal an additional {{ e2 }} <scaleAP>(+{{ a1 }})</scaleAP> <scaleAD>(+{{ a2 }})</scaleAD> magic damage each hit.<br /><br /><span class=\"color919191\"><i>Voidlings deal {{ e3 }}% damage to lane minions affected by Malefic Visions.<br />Voidlings deal {{ e4 }}% damage to epic monsters.</i></span>",
					"leveltip": {
						"label": [
							"Voidling Bonus Damage",
							"Voidling Duration",
							"Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							8,
							8,
							9,
							9,
							10
						],
						[
							12,
							14,
							16,
							18,
							20
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							25000,
							25000,
							25000,
							25000,
							25000
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"8/8/9/9/10",
						"12/14/16/18/20",
						"300",
						"50",
						"25000",
						"2",
						"0.5",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.4,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "0",
					"range": [
						150,
						150,
						150,
						150,
						150
					],
					"rangeBurn": "150",
					"image": {
						"full": "MalzaharW.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MalzaharE",
					"name": "Malefic Visions",
					"description": "Malzahar infects his target's mind with cruel visions of their demise, dealing damage over time. Using Malzahar's other spells on the target will refresh the visions.<br><br>If the target dies while afflicted by the visions, they pass on to a nearby enemy unit and Malzahar gains Mana. Malzahar's Voidlings are attracted to affected units.",
					"tooltip": "Deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to an enemy target over {{ e3 }} seconds. Applying Call of the Void or Nether Grasp to the victim during this time refreshes the visions.<br /><br />If the victim is killed, Malzahar gains <scaleMana>{{ f1 }}</scaleMana> Mana ({{ e5 }}% of max mana) and the visions spread to the nearest enemy.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						13,
						11,
						9,
						7
					],
					"cooldownBurn": "15/13/11/9/7",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							80,
							115,
							150,
							185,
							220
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/115/150/185/220",
						"8",
						"4",
						"8",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "MalzaharE.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MalzaharR",
					"name": "Nether Grasp",
					"description": "Malzahar channels the essence of the Void to suppress an enemy champion over a zone of damaging negative energy.",
					"tooltip": "Malzahar suppresses a target champion for {{ e4 }} seconds, dealing {{ e7 }} <scaleAP>(+{{ a2 }})</scaleAP> magic damage over the duration. A zone of negative energy is created around his target for {{ e3 }} seconds, dealing {{ e1 }}% <scaleAP>(+{{ a1 }}%)</scaleAP> of nearby enemies max health as magic damage per second.",
					"leveltip": {
						"label": [
							"Nether Grasp Damage",
							"Null Zone Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e7 }} -> {{ e7NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						110,
						80
					],
					"cooldownBurn": "140/110/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							2,
							3,
							4
						],
						[
							120,
							100,
							80
						],
						[
							5,
							5,
							5
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							120,
							120,
							120
						],
						[
							10,
							10,
							10
						],
						[
							125,
							200,
							275
						],
						[
							1250,
							1250,
							1250
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2/3/4",
						"120/100/80",
						"5",
						"2.5",
						"120",
						"10",
						"125/200/275",
						"1250",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.005,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "MalzaharR.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Void Shift",
				"description": "When he hasn't recently taken damage or been crowd controlled, Malzahar gains massive damage reduction and crowd control immunity, lingering for a short period after taking damage.<br><br>Damage from lane minions is unaffected.",
				"image": {
					"full": "Malzahar_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Malzahar",
					"title": "MalzaharARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malzahar",
					"title": "MalzaharCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malzahar",
					"title": "MalzaharKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Malzahar",
					"title": "MalzaharSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Malzahar",
					"title": "MalzaharSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1414",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Malzahar",
					"title": "MalzaharTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Maokai": {
			"id": "Maokai",
			"key": "57",
			"name": "Maokai",
			"title": "the Twisted Treant",
			"image": {
				"full": "Maokai.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 384,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "57000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "57001",
					"num": 1,
					"name": "Charred Maokai",
					"chromas": false
				},
				{
					"id": "57002",
					"num": 2,
					"name": "Totemic Maokai",
					"chromas": false
				},
				{
					"id": "57003",
					"num": 3,
					"name": "Festive Maokai",
					"chromas": false
				},
				{
					"id": "57004",
					"num": 4,
					"name": "Haunted Maokai",
					"chromas": false
				},
				{
					"id": "57005",
					"num": 5,
					"name": "Goalkeeper Maokai",
					"chromas": false
				},
				{
					"id": "57006",
					"num": 6,
					"name": "Meowkai",
					"chromas": true
				},
				{
					"id": "57007",
					"num": 7,
					"name": "Victorious Maokai",
					"chromas": false
				}
			],
			"lore": "Maokai is a rageful, towering treant who fights the unnatural horrors of the Shadow Isles. He was twisted into a force of vengeance after a magical cataclysm destroyed his home, surviving undeath only through the Waters of Life infused within his heartwood. Once a peaceful nature spirit, Maokai now furiously battles to banish the scourge of unlife from the Shadow Isles and restore his home to its former beauty.",
			"blurb": "Maokai is a rageful, towering treant who fights the unnatural horrors of the Shadow Isles. He was twisted into a force of vengeance after a magical cataclysm destroyed his home, surviving undeath only through the Waters of Life infused within his...",
			"allytips": [
				"Saplings can be tossed into brush for empowered effect - but don't stack well.",
				"Try looking for flanks or other situations where Nature's Grasp is unavoidable or takes enemies by surprise.",
				"Maokai's passive makes him extremely durable against focus fire from spells - so long as he can still basic attack something."
			],
			"enemytips": [
				"Saplings will chase the first enemy that gets too close, but detonate after a few seconds or if they collide with other enemies. Be especially careful around brush sapling, as they are much more dangerous.",
				"The cooldown on Maokai's self healing is heavily gated on how many time you hit him with spells. Careful about wasting abilities on him.",
				"Maokai will avoid taking damage while he's using Twisted Advance, so don't waste your spells."
			],
			"tags": [
				"Tank",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 8,
				"magic": 6,
				"difficulty": 3
			},
			"stats": {
				"hp": 565,
				"hpperlevel": 95,
				"mp": 377.28,
				"mpperlevel": 43,
				"movespeed": 335,
				"armor": 39,
				"armorperlevel": 4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 5,
				"hpregenperlevel": 0.75,
				"mpregen": 7.2,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 63.54,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": -0.1,
				"attackspeedperlevel": 2.125
			},
			"spells": [
				{
					"id": "MaokaiQ",
					"name": "Bramble Smash",
					"description": "Maokai knocks back nearby enemies with a shockwave, dealing magic damage and slowing them.",
					"tooltip": "Maokai smashes his fist into the ground, releasing a shockwave. Nearby enemies are knocked away from him and all affected enemies take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed briefly.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7.25,
						6.5,
						5.75,
						5
					],
					"cooldownBurn": "8/7.25/6.5/5.75/5",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							65,
							105,
							145,
							185,
							225
						],
						[
							325,
							325,
							325,
							325,
							325
						],
						[
							99,
							99,
							99,
							99,
							99
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							750,
							750,
							750,
							750,
							750
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/105/145/185/225",
						"325",
						"99",
						"0.25",
						"750",
						"300",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "MaokaiQ.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MaokaiW",
					"name": "Twisted Advance",
					"description": "Maokai contorts into a mass of moving roots, becoming untargetable and dashing to the target. Upon arrival, he roots the target.",
					"tooltip": "Maokai transforms into a moving mass of roots, becoming untargetable and dashing to the target.<br /><br />Upon arrival, he deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and roots the target for {{ e2 }} second(s).",
					"leveltip": {
						"label": [
							"Damage",
							"Root Duration",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							1,
							1.1,
							1.2,
							1.3,
							1.4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1300,
							1300,
							1300,
							1300,
							1300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"1/1.1/1.2/1.3/1.4",
						"0",
						"0",
						"1300",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						525,
						525,
						525,
						525,
						525
					],
					"rangeBurn": "525",
					"image": {
						"full": "MaokaiW.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MaokaiE",
					"name": "Sapling Toss",
					"description": "Maokai flings a sapling to the target area to stand guard. More effective in brush.",
					"tooltip": "Maokai flings a sapling, which stands watch for {{ f1 }} seconds. Saplings will chase nearby enemies, detonating on proximity, dealing {{ e1 }} <span class=\"colorCC3300\">+{{ e8 }}% <span class=\"color99FF99\">[+{{ a1 }}%]</span> Target Max Health</span> magic damage and slowing enemies struck by {{ e5 }}% for {{ e6 }} seconds.<br /><br />Saplings placed in brush last for <span class=\"colorCC3300\">{{ f2 }}</span> seconds and cause a larger explosion, dealing double damage over {{ e6 }} seconds to all enemies hit.<br /><br /><rules><span class=\"color8c8c8c\">Maximum {{ e4 }} Damage to non-Champions, doubled for brush.</span></rules>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Max Health Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e8 }}% -> {{ e8NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						11,
						11,
						11,
						11
					],
					"cooldownBurn": "11",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							25,
							50,
							75,
							100,
							125
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							6,
							6.5,
							7,
							7.5,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							550,
							550,
							550,
							550,
							550
						]
					],
					"effectBurn": [
						null,
						"25/50/75/100/125",
						"0.5",
						"2",
						"300",
						"35",
						"2",
						"2",
						"6/6.5/7/7.5/8",
						"0",
						"550"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.01,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "MaokaiE.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MaokaiR",
					"name": "Nature's Grasp",
					"description": "Maokai summons a colossal wall of brambles and thorns that slowly advances forwards, damaging and rooting any enemies in the path.",
					"tooltip": "Maokai summons a colossal wall of brambles and thorns that slowly advances forwards, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and rooting any enemies struck for ({{ e2 }} to {{ e2 }}) seconds, increasing with distance travelled.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							225,
							300
						],
						[
							2.4,
							2.4,
							2.4
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/225/300",
						"2.4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3000,
						3000,
						3000
					],
					"rangeBurn": "3000",
					"image": {
						"full": "MaokaiR.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Sap Magic",
				"description": "Maokai's basic attack also heal him on a moderate cooldown. Each time Maokai casts a spell or is struck by an enemy's spell, this cooldown is reduced.",
				"image": {
					"full": "Maokai_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Maokai",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3711",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "kingporosnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Maokai",
					"title": "MaokaiTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"MasterYi": {
			"id": "MasterYi",
			"key": "11",
			"name": "Master Yi",
			"title": "the Wuju Bladesman",
			"image": {
				"full": "MasterYi.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 432,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "11000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "11001",
					"num": 1,
					"name": "Assassin Master Yi",
					"chromas": false
				},
				{
					"id": "11002",
					"num": 2,
					"name": "Chosen Master Yi",
					"chromas": false
				},
				{
					"id": "11003",
					"num": 3,
					"name": "Ionia Master Yi",
					"chromas": false
				},
				{
					"id": "11004",
					"num": 4,
					"name": "Samurai Yi",
					"chromas": false
				},
				{
					"id": "11005",
					"num": 5,
					"name": "Headhunter Master Yi",
					"chromas": true
				},
				{
					"id": "11009",
					"num": 9,
					"name": "PROJECT: Yi",
					"chromas": false
				},
				{
					"id": "11010",
					"num": 10,
					"name": "Cosmic Blade Master Yi",
					"chromas": false
				},
				{
					"id": "11011",
					"num": 11,
					"name": "Eternal Sword Yi",
					"chromas": true
				}
			],
			"lore": "Master Yi has tempered his body and sharpened his mind, so that thought and action have become almost as one. Though he chooses to enter into violence only as a last resort, the grace and speed of his blade ensures resolution is always swift. As one of the last living practitioners of the Ionian art of wuju, Yi has devoted his life to continuing the legacy of his people—scrutinizing potential new disciples with the Seven Lenses of Insight to identify the most worthy among them.",
			"blurb": "Master Yi has tempered his body and sharpened his mind, so that thought and action have become almost as one. Though he chooses to enter into violence only as a last resort, the grace and speed of his blade ensures resolution is always swift. As one of...",
			"allytips": [
				"If you're in a lane against ranged players, leveling up Meditate can allow you to stay in the lane longer and gain levels faster than they will.",
				"Wuju Style is very strong early for last hitting minions.",
				"Try using Alpha Strike on a minion in front of an enemy champion so you are placed at a safe distance at the end of the spell."
			],
			"enemytips": [
				"Meditate is an effective method of healing damage over time, but Master Yi is susceptible to coordinated team ganks early in the game.",
				"If Master Yi tries to farm with Alpha Strike, hit him a few times so he has to use mana with Meditate to heal.",
				"Although Master Yi cannot be slowed while using Highlander, other disables can stop him in his tracks."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 10,
				"defense": 4,
				"magic": 2,
				"difficulty": 4
			},
			"stats": {
				"hp": 598.56,
				"hpperlevel": 92,
				"mp": 250.56,
				"mpperlevel": 42,
				"movespeed": 355,
				"armor": 33,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7.5,
				"hpregenperlevel": 0.65,
				"mpregen": 7.256,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.08,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "AlphaStrike",
					"name": "Alpha Strike",
					"description": "Master Yi teleports across the battlefield with blinding speed, dealing physical damage to multiple units in his path, while simultaneously becoming untargetable. Alpha Strike can critically strike and deals bonus physical damage to minions and monsters. Basic attacks reduce Alpha Strike's cooldown.",
					"tooltip": "Master Yi teleports to strike up to {{ e8 }} enemies, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage, with an additional {{ e3 }} damage to minions and monsters. During Alpha Strike Master Yi is untargetable.<br /><br />Alpha Strike can critically strike, dealing an additional <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage. Basic attacks lower the cooldown of Alpha Strike by {{ e7 }} second.",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus Minion/Monster Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							25,
							60,
							95,
							130,
							165
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							75,
							100,
							125,
							150,
							175
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/60/95/130/165",
						"50",
						"75/100/125/150/175",
						"1",
						"0.25",
						"0.6",
						"1",
						"4",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 0.6,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "AlphaStrike.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Meditate",
					"name": "Meditate",
					"description": "Master Yi rejuvenates his body by focus of mind, restoring Health and taking reduced damage for a short time. In addition, Master Yi will gain stacks of Double Strike and pause the remaining duration on Wuju Style and Highlander for each second he channels.",
					"tooltip": "Master Yi channels, reducing incoming damage by {{ e2 }}% and restoring {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> health over {{ f1.-1 }} seconds. This healing is increased by up to {{ e0 }}% based on Master Yi's missing health.<br /><br />In addition, Master Yi will gain stacks of Double Strike and pause the remaining duration on Wuju Style and Highlander for each second he channels.<br /><br /><rules>Meditate's damage reduction is halved against structures.</rules>",
					"leveltip": {
						"label": [
							"Health Restored",
							"Damage Reduction"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						35,
						35,
						35,
						35,
						35
					],
					"cooldownBurn": "35",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							120,
							200,
							280,
							360,
							440
						],
						[
							50,
							55,
							60,
							65,
							70
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1,
							1,
							1,
							1,
							1
						]
					],
					"effectBurn": [
						null,
						"120/200/280/360/440",
						"50/55/60/65/70",
						"0.5",
						"4",
						"0",
						"0.5",
						"0",
						"0",
						"0",
						"1"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "Meditate.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "WujuStyle",
					"name": "Wuju Style",
					"description": "Master Yi becomes skilled in the art of Wuju, passively increasing his Attack Damage. Activating Wuju Style grants bonus true damage on basic attacks, but the passive bonus is then lost while on cooldown.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Grants {{ e1 }}% <span class=\"colorFF8C00\">({{ f1 }})</span> Attack Damage.<br /><br /><span class=\"colorFF9900\">Active:</span> Basic attacks deal {{ e3 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> bonus true damage for {{ e5 }} seconds. Afterwards the passive bonus is lost while Wuju Style is on cooldown.",
					"leveltip": {
						"label": [
							"Active Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							18,
							26,
							34,
							42,
							50
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10",
						"35",
						"18/26/34/42/50",
						"20/30/40/50/60",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.1,
								0.125,
								0.15,
								0.175,
								0.2
							],
							"key": "f2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "WujuStyle.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "Highlander",
					"name": "Highlander",
					"description": "Master Yi moves with unparalleled agility, temporarily increasing his Movement and Attack Speeds as well as making him immune to all slowing effects. While active, Champion kills or assists extend Highlander's duration. Passively reduces cooldown for his other abilities on a kill or assist.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Champion kills and assists reduce the remaining cooldown of Master Yi's basic abilities by {{ e5 }}%.<br /><br /><span class=\"colorFF9900\">Active:</span> Increases Movement Speed by {{ e3 }}%, Attack Speed by {{ e2 }}%, and grants immunity to slows for {{ e1 }} seconds. While active, champion kills and assists extend the duration of Highlander by {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Movement Speed"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 3,
					"cooldown": [
						85,
						85,
						85
					],
					"cooldownBurn": "85",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							7,
							7,
							7
						],
						[
							30,
							55,
							80
						],
						[
							25,
							35,
							45
						],
						[
							7,
							7,
							7
						],
						[
							70,
							70,
							70
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"7",
						"30/55/80",
						"25/35/45",
						"7",
						"70",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "Highlander.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Double Strike",
				"description": "Every few strikes, Master Yi strikes twice.",
				"image": {
					"full": "MasterYi_Passive1.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "MasterYi",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1419",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1419",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MasterYi",
					"title": "MasterYiTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1036",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"MissFortune": {
			"id": "MissFortune",
			"key": "21",
			"name": "Miss Fortune",
			"title": "the Bounty Hunter",
			"image": {
				"full": "MissFortune.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 0,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "21000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "21001",
					"num": 1,
					"name": "Cowgirl Miss Fortune",
					"chromas": false
				},
				{
					"id": "21002",
					"num": 2,
					"name": "Waterloo Miss Fortune",
					"chromas": false
				},
				{
					"id": "21003",
					"num": 3,
					"name": "Secret Agent Miss Fortune",
					"chromas": false
				},
				{
					"id": "21004",
					"num": 4,
					"name": "Candy Cane Miss Fortune",
					"chromas": false
				},
				{
					"id": "21005",
					"num": 5,
					"name": "Road Warrior Miss Fortune",
					"chromas": false
				},
				{
					"id": "21006",
					"num": 6,
					"name": "Mafia Miss Fortune",
					"chromas": false
				},
				{
					"id": "21007",
					"num": 7,
					"name": "Arcade Miss Fortune",
					"chromas": true
				},
				{
					"id": "21008",
					"num": 8,
					"name": "Captain Fortune",
					"chromas": false
				},
				{
					"id": "21009",
					"num": 9,
					"name": "Pool Party Miss Fortune",
					"chromas": false
				},
				{
					"id": "21015",
					"num": 15,
					"name": "Star Guardian Miss Fortune",
					"chromas": false
				}
			],
			"lore": "A Bilgewater captain famed for her looks but feared for her ruthlessness, Sarah Fortune paints a stark figure among the hardened criminals of the port city. As a child, she witnessed the reaver king Gangplank murder her family—an act she brutally avenged years later, blowing up his flagship while he was still aboard. Those who underestimate her will face a beguiling and unpredictable opponent… and, likely, a bullet or two in their guts.",
			"blurb": "A Bilgewater captain famed for her looks but feared for her ruthlessness, Sarah Fortune paints a stark figure among the hardened criminals of the port city. As a child, she witnessed the reaver king Gangplank murder her family—an act she brutally...",
			"allytips": [
				"Miss Fortune ramps up speed if she hasn't recently taken damage. Avoid getting hit to move very fast.",
				"Use Double Up on the furthest enemy minion if enemy champions are hiding in back; it will bounce to them for lots of damage.",
				"Make sure to utilize Love Tap while Strut is on cooldown to maximize the active's availability."
			],
			"enemytips": [
				"Miss Fortune's speed boost is removed if she is damaged by an enemy.",
				"Miss Fortune is easy to kill if you can reach her; target her first in team fights."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 2,
				"magic": 5,
				"difficulty": 1
			},
			"stats": {
				"hp": 530,
				"hpperlevel": 85,
				"mp": 325.84,
				"mpperlevel": 35,
				"movespeed": 325,
				"armor": 33,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6,
				"hpregenperlevel": 0.65,
				"mpregen": 8.042,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 54,
				"attackdamageperlevel": 1,
				"attackspeedoffset": -0.0473,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "MissFortuneRicochetShot",
					"name": "Double Up",
					"description": "Miss Fortune fires a bullet at an enemy, damaging them and a target behind them. Both strikes can also apply Love Tap.",
					"tooltip": "Miss Fortune fires a bouncing shot through an enemy, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to each target hit. Both apply on-hit effects.<br /><br />The second shot can critically strike for {{ f1 }}% damage, and it always critically strikes if the first shot kills its target.",
					"leveltip": {
						"label": [
							"Mana Cost",
							"Cooldown",
							"Damage"
						],
						"effect": [
							"{{ cost }} -> {{ costNL }} ",
							"{{ cooldown }} -> {{ cooldownNL }} ",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6,
						5,
						4,
						3
					],
					"cooldownBurn": "7/6/5/4/3",
					"cost": [
						43,
						46,
						49,
						52,
						55
					],
					"costBurn": "43/46/49/52/55",
					"effect": [
						null,
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							110,
							110,
							110,
							110,
							110
						],
						[
							160,
							160,
							160,
							160,
							160
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1",
						"20/40/60/80/100",
						"1",
						"40/70/100/130/160",
						"40",
						"20",
						"40",
						"110",
						"160",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "MissFortuneRicochetShot.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MissFortuneViciousStrikes",
					"name": "Strut",
					"description": "Miss Fortune passively gains Movement Speed when not attacked. This ability can be activated to grant bonus Attack Speed for a short duration. While it's on cooldown, Love Taps reduce the remaining cooldown of Strut.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> After 5 seconds of not taking direct damage, Miss Fortune gains {{ e5 }} Movement Speed. After another 5 seconds, this bonus increases to {{ e2 }}.<br /><br /><span class=\"colorFF9900\">Active:</span> Fully activates Strut's Movement Speed and grants {{ e1 }}% Attack Speed for {{ e3 }} seconds.<br /><br />Love Taps reduce the cooldown of Strut by {{ f2 }} seconds.",
					"leveltip": {
						"label": [
							"Max Movement Speed",
							"Attack Speed"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							40,
							55,
							70,
							85,
							100
						],
						[
							60,
							70,
							80,
							90,
							100
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/55/70/85/100",
						"60/70/80/90/100",
						"4",
						"2",
						"25",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "MissFortuneViciousStrikes.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MissFortuneScattershot",
					"name": "Make It Rain",
					"description": "Miss Fortune reveals an area with a flurry of bullets, dealing waves of damage to opponents and slowing them.",
					"tooltip": "Miss Fortune reveals an area, raining down bullets that deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over 2 seconds and slow enemies hit by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Damage",
							"Slow"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }} ",
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							80,
							115,
							150,
							185,
							220
						],
						[
							28,
							36,
							44,
							52,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/115/150/185/220",
						"28/36/44/52/60",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "MissFortuneScattershot.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MissFortuneBulletTime",
					"name": "Bullet Time",
					"description": "Miss Fortune channels a flurry of bullets into a cone in front of her, dealing large amounts of damage to enemies. Each wave of Bullet Time can critically strike.",
					"tooltip": "Miss Fortune channels a barrage of bullets for {{ e3 }} seconds, dealing <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage per wave ({{ e2 }} waves total).<br /><br />Each wave of Bullet Time can critically strike for {{ f3 }}% damage.<br /><br /><span class=\"colorF50F00\">Total Damage: {{ f2 }}</span>",
					"leveltip": {
						"label": [
							"Cooldown",
							"Waves Fired"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }} ",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							0,
							0,
							0
						],
						[
							12,
							14,
							16
						],
						[
							3,
							3,
							3
						],
						[
							75,
							75,
							75
						],
						[
							120,
							120,
							120
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"12/14/16",
						"3",
						"75",
						"120",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.35,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "MissFortuneBulletTime.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Love Tap",
				"description": "Miss Fortune deals bonus physical damage whenever she attacks a new target.",
				"image": {
					"full": "MissFortune_W.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "MissFortune",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortunePRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MissFortune",
					"title": "MissFortuneTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"MonkeyKing": {
			"id": "MonkeyKing",
			"key": "62",
			"name": "Wukong",
			"title": "the Monkey King",
			"image": {
				"full": "MonkeyKing.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 48,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "62000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "62001",
					"num": 1,
					"name": "Volcanic Wukong",
					"chromas": false
				},
				{
					"id": "62002",
					"num": 2,
					"name": "General Wukong",
					"chromas": false
				},
				{
					"id": "62003",
					"num": 3,
					"name": "Jade Dragon Wukong",
					"chromas": false
				},
				{
					"id": "62004",
					"num": 4,
					"name": "Underworld Wukong",
					"chromas": false
				},
				{
					"id": "62005",
					"num": 5,
					"name": "Radiant Wukong",
					"chromas": false
				}
			],
			"lore": "Wukong is a vastayan trickster who uses his strength, agility, and intelligence to confuse his opponents and gain the upper hand. After finding a lifelong friend in the warrior known as Master Yi, Wukong became the last student of the ancient martial art known as Wuju. Armed with an enchanted staff, Wukong seeks to prevent Ionia from falling to ruin.",
			"blurb": "Wukong is a vastayan trickster who uses his strength, agility, and intelligence to confuse his opponents and gain the upper hand. After finding a lifelong friend in the warrior known as Master Yi, Wukong became the last student of the ancient martial...",
			"allytips": [
				"Decoy and Nimbus Strike work well together to quickly strike your enemy and get out before they can retaliate.",
				"Try using Decoy near brush to make an enemy overreact to your movement."
			],
			"enemytips": [
				"Wukong will often use Decoy after Nimbus Strike. Try delaying your abilities by a short amount of time to ensure that you're hitting the real Wukong.",
				"Wukong becomes tougher to kill when surrounded by his enemies. Try to isolate him to gain an advantage."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 2,
				"difficulty": 3
			},
			"stats": {
				"hp": 577.8,
				"hpperlevel": 85,
				"mp": 265.84,
				"mpperlevel": 38,
				"movespeed": 345,
				"armor": 34,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 6,
				"hpregenperlevel": 0.65,
				"mpregen": 8.042,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "MonkeyKingDoubleAttack",
					"name": "Crushing Blow",
					"description": "Wukong's next attack deals additional physical damage, gains range, and reduces the enemy's Armor for a short duration.",
					"tooltip": "Wukong's next attack gains {{ e4 }} range, deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> bonus physical damage and reduces the enemy's Armor by {{ e2 }}% for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Armor Reduction",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} ->{{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							30,
							60,
							90,
							120,
							150
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							125,
							125,
							125,
							125,
							125
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/60/90/120/150",
						"10/15/20/25/30",
						"3",
						"125",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "MonkeyKingDoubleAttack.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MonkeyKingDecoy",
					"name": "Decoy",
					"description": "Wukong becomes Invisible for a short duration, leaving behind a decoy that will deal Magic Damage to enemies near it when Wukong's stealth expires.",
					"tooltip": "Wukong becomes <span class=\"color91d7ee\">Invisible</span> for {{ e2 }} seconds, leaving behind a decoy that will deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage to enemies near it after {{ e2 }} seconds. <br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Wukong can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} ->{{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "MonkeyKingDecoy.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MonkeyKingNimbus",
					"name": "Nimbus Strike",
					"description": "Wukong dashes to target enemy and sends out images to attack up to 2 additional enemies near his target, dealing physical damage to each enemy struck.",
					"tooltip": "Wukong dashes to target enemy and sends out images to attack up to 2 additional enemies nearby. Each enemy struck takes {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. Wukong then gains {{ e2 }}% Attack Speed for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Attack Speed",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} ->{{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							65,
							110,
							155,
							200,
							245
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							1050,
							1050,
							1050,
							1050,
							1050
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/110/155/200/245",
						"30/35/40/45/50",
						"4",
						"1050",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "MonkeyKingNimbus.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MonkeyKingSpinToWin",
					"name": "Cyclone",
					"description": "Wukong's staff grows outward and he spins it around, dealing damage and knocking up enemies. Wukong gains Movement Speed over the duration of the spell.",
					"tooltip": "Wukong's staff grows outward and he spins it around for 4 seconds, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage per second to nearby enemies, knocking them up for {{ e4 }} second the first time they get hit.<br /><br />At the start, Wukong gains {{ e2 }}% Movement Speed, and he gains an additional {{ e3 }}% per second over the duration.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} ->{{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							20,
							110,
							200
						],
						[
							15,
							15,
							15
						],
						[
							10,
							10,
							10
						],
						[
							1,
							1,
							1
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/110/200",
						"15",
						"10",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						315,
						315,
						315
					],
					"rangeBurn": "315",
					"image": {
						"full": "MonkeyKingSpinToWin.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Stone Skin",
				"description": "Increases Wukong's Armor and Magic Resist for each nearby enemy champion.",
				"image": {
					"full": "MonkeyKingStoneSkin.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "MonkeyKing",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "WukongARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "MonkeyKingCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "WukongFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3342",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2044",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "MonkeyKingKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "MonkeyKingSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "WukongSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "MonkeyKing",
					"title": "WukongTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Mordekaiser": {
			"id": "Mordekaiser",
			"key": "82",
			"name": "Mordekaiser",
			"title": "the Iron Revenant",
			"image": {
				"full": "Mordekaiser.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 96,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "82000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "82001",
					"num": 1,
					"name": "Dragon Knight Mordekaiser",
					"chromas": false
				},
				{
					"id": "82002",
					"num": 2,
					"name": "Infernal Mordekaiser",
					"chromas": false
				},
				{
					"id": "82003",
					"num": 3,
					"name": "Pentakill Mordekaiser",
					"chromas": false
				},
				{
					"id": "82004",
					"num": 4,
					"name": "Lord Mordekaiser",
					"chromas": false
				},
				{
					"id": "82005",
					"num": 5,
					"name": "King of Clubs Mordekaiser",
					"chromas": false
				}
			],
			"lore": "The baleful revenant Mordekaiser is among the most terrifying and hateful spirits haunting the Shadow Isles. He has existed for countless centuries, shielded from true death by necromantic sorcery and the force of his own dark will. Those who dare face Mordekaiser in battle risk a horrific curse: He enslaves his victims' souls to become instruments of destruction.",
			"blurb": "The baleful revenant Mordekaiser is among the most terrifying and hateful spirits haunting the Shadow Isles. He has existed for countless centuries, shielded from true death by necromantic sorcery and the force of his own dark will. Those who dare face...",
			"allytips": [
				"You can control a pet by holding down the alt key and using the right mouse button.",
				"Sometimes the best defense is more offense; use Mordekaiser's abilities to charge up his shield.",
				"Remember that Children of the Grave can be used defensively because of its lifesteal component."
			],
			"enemytips": [
				"Mordekaiser's abilities charge up his shield, making him tougher to kill over time. Try focusing fire on Mordekaiser to burst him down.",
				"Keep your distance and don't stand near creep waves since he'll be aiming Siphon of Destruction at them.",
				"Watch out for the Children of the Grave and Ignite combo. If you're low enough, this will kill you and give his team a powerful ghost."
			],
			"tags": [
				"Fighter"
			],
			"partype": "Shield",
			"info": {
				"attack": 4,
				"defense": 6,
				"magic": 7,
				"difficulty": 4
			},
			"stats": {
				"hp": 530,
				"hpperlevel": 78,
				"mp": 0,
				"mpperlevel": 0,
				"movespeed": 325,
				"armor": 25,
				"armorperlevel": 3.75,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 4,
				"hpregenperlevel": 0.3,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61,
				"attackdamageperlevel": 5,
				"attackspeedoffset": 0.04,
				"attackspeedperlevel": 2.2
			},
			"spells": [
				{
					"id": "MordekaiserMaceOfSpades",
					"name": "Mace of Spades",
					"description": "Mordekaiser's next three attacks deal escalating bonus damage.",
					"tooltip": "Mordekaiser's next three hits are empowered. The first two strikes deal {{ e3 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ f2 }})</span> bonus magic damage. The final strike deals {{ e9 }} times the bonus damage of the previous strikes, up to {{ f5 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> <span class=\"color99FF99\">(+{{ f4 }})</span>.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Attack Damage Ratio",
							"Cooldown",
							"Health Cost"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e0 }} -> {{ e0NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						8.5,
						7,
						5.5,
						4
					],
					"cooldownBurn": "10/8.5/7/5.5/4",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							132,
							181.5,
							231,
							280.5,
							330
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							30,
							60,
							90,
							120,
							150
						],
						[
							20,
							225,
							250,
							275,
							300
						],
						[
							0.5,
							0.6,
							0.7,
							0.8,
							0.9
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							20,
							23,
							26,
							29,
							32
						]
					],
					"effectBurn": [
						null,
						"132/181.5/231/280.5/330",
						"10/15/20/25/30",
						"10/20/30/40/50",
						"4",
						"30/60/90/120/150",
						"20/225/250/275/300",
						"0.5/0.6/0.7/0.8/0.9",
						"0.6",
						"2",
						"20/23/26/29/32"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.65,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "f2"
						}
					],
					"costType": " Health",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "MordekaiserMaceOfSpades.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e0 }} Health"
				},
				{
					"id": "MordekaiserCreepingDeathCast",
					"name": "Harvesters of Sorrow",
					"description": "Coats an ally in magnetic metal, increasing each unit's movement speed toward one another. While near one another, the metal swirls violently dealing damage per second to enemies.",
					"tooltip": "<span class=\"size18 colorFF9900\">Passive:</span> Mordekaiser gains bonus experience for killing minions near allied champions.<br /><br />Bonus Experience Earned: <span class=\"colorFFFFFF\">{{ f3 }}</span><br /><br /><span class=\"size18 colorFF9900\">Active:</span> Target an ally, linking them to Mordekaiser:<span class=\"size4\"><br /><br /></span><li>Both gain up to {{ e5 }} movement speed toward one another.<span class=\"size8\"><br /><br /></span>When they touch, they deal {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over 4 seconds to nearby enemies.<span class=\"size8\"><br /><br /></span>Reactivate to both instantly steal {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> health from nearby enemies ({{ e7 }}% heal on minions, max {{ e8 }} units; deals magic damage).",
					"leveltip": {
						"label": [
							"Damage",
							"Reactivation Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							140,
							180,
							220,
							260,
							300
						],
						[
							25,
							35,
							45,
							55,
							65
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							50,
							85,
							120,
							155,
							190
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"140/180/220/260/300",
						"25/35/45/55/65",
						"1",
						"75",
						"50/85/120/155/190",
						"25",
						"2",
						"50",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Health",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "MordekaiserCreepingDeathCast.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e3 }} Health"
				},
				{
					"id": "MordekaiserSyphonOfDestruction",
					"name": "Siphon of Destruction",
					"description": "Mordekaiser deals damage to enemies in a cone in front of him. For each unit hit, Mordekaiser's shield absorbs energy.",
					"tooltip": "Mordekaiser deals {{ e3 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span><span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage in a cone.<span class=\"size8\"><br /><br /></span>For each Champion hit, he gains {{ e5 }}% maximum shield.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"% Max Shield From Champions",
							"Health Cost"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.75,
						5.5,
						5.25,
						5
					],
					"cooldownBurn": "6/5.75/5.5/5.25/5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							24,
							36,
							48,
							60,
							72
						],
						[
							1,
							2,
							3,
							4,
							5
						],
						[
							35,
							65,
							95,
							125,
							155
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"24/36/48/60/72",
						"1/2/3/4/5",
						"35/65/95/125/155",
						"4",
						"15/17.5/20/22.5/25",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Health",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "MordekaiserSyphonOfDestruction.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e1 }} Health"
				},
				{
					"id": "MordekaiserChildrenOfTheGrave",
					"name": "Children of the Grave",
					"description": "Mordekaiser curses an enemy champion or the Dragon, stealing a percent of their life initially and each second. If the target dies while the spell is active, their soul is enslaved and will follow Mordekaiser as a ghost.",
					"tooltip": "<span class=\"size18 colorFF9900\">Passive - Dragon Force:</span> Damaging the Dragon will <span class=\"size18 color53c653\">Curse</span> it for 10 seconds.<br /><br /><span class=\"size18 colorFF9900\">Active:</span> <span class=\"size18 color53c653\">Curse</span> target Champion and steal {{ e1 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of their maximum health (25% initially, 75% over 10 seconds; deals magic damage).<br /><br /><span class=\"size18 color53c653\">Curse Effect:</span> When killed by Mordekaiser's team, the Cursed unit's soul will follow Mordekaiser for {{ e9 }} seconds. Mordekaiser gains {{ e7 }}% of their ability power and {{ e8 }}% of their bonus health. The ghost gains <span class=\"colorFF8C00\">(+{{ f1 }})</span> attack damage and <span class=\"colorCC3300\">(+{{ f2 }})</span> health.<br /><br /><span class=\"color53c653\">The ghost can be controlled by holding the alt key and using the right mouse button or by reactivating this ability.</span>",
					"leveltip": {
						"label": [
							"Total Health Stolen",
							"Cooldown",
							"Ghost Lifetime"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e9 }} -> {{ e9NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							25,
							30,
							35
						],
						[
							55,
							65,
							75
						],
						[
							75,
							150,
							225
						],
						[
							2,
							2,
							2
						],
						[
							3,
							3,
							3
						],
						[
							10,
							25,
							50
						],
						[
							30,
							30,
							30
						],
						[
							25,
							25,
							25
						],
						[
							45,
							60,
							75
						],
						[
							2000,
							2000,
							2000
						]
					],
					"effectBurn": [
						null,
						"25/30/35",
						"55/65/75",
						"75/150/225",
						"2",
						"3",
						"10/25/50",
						"30",
						"25",
						"45/60/75",
						"2000"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.04,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "MordekaiserChildrenOfTheGrave.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Iron Man",
				"description": "A percent of the damage dealt from abilities is converted into a temporary shield, absorbing incoming damage.",
				"image": {
					"full": "MordekaiserPassive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Mordekaiser",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Mordekaiser",
					"title": "MordekaiserTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Morgana": {
			"id": "Morgana",
			"key": "25",
			"name": "Morgana",
			"title": "Fallen Angel",
			"image": {
				"full": "Morgana.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 144,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "25000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "25001",
					"num": 1,
					"name": "Exiled Morgana",
					"chromas": false
				},
				{
					"id": "25002",
					"num": 2,
					"name": "Sinful Succulence Morgana",
					"chromas": false
				},
				{
					"id": "25003",
					"num": 3,
					"name": "Blade Mistress Morgana",
					"chromas": false
				},
				{
					"id": "25004",
					"num": 4,
					"name": "Blackthorn Morgana",
					"chromas": false
				},
				{
					"id": "25005",
					"num": 5,
					"name": "Ghost Bride Morgana",
					"chromas": false
				},
				{
					"id": "25006",
					"num": 6,
					"name": "Victorious Morgana",
					"chromas": false
				},
				{
					"id": "25010",
					"num": 10,
					"name": "Lunar Wraith Morgana",
					"chromas": false
				},
				{
					"id": "25011",
					"num": 11,
					"name": "Bewitching Morgana",
					"chromas": false
				}
			],
			"lore": "Driven by vindictive obsession, Morgana is a potent mistress of suffering and the black arts. Once a being of grace and light, she was ripped from her kind during an ancient conflict that broke her soul, turning her into the cruel tormentor she is today. Comforted by a prophecy that claims she will strike the final blow and gain her revenge, Morgana lies in wait, her lust for power growing endlessly.",
			"blurb": "Driven by vindictive obsession, Morgana is a potent mistress of suffering and the black arts. Once a being of grace and light, she was ripped from her kind during an ancient conflict that broke her soul, turning her into the cruel tormentor she is today...",
			"allytips": [
				"Shrewd use of Black Shield can determine the outcome of team fights.",
				"Items that provide survivability allow Morgana to become extremely difficult to kill in conjunction with Black Shield and Soul Shackles.",
				"Tormented Soil is an excellent farming tool if you're by yourself in a lane."
			],
			"enemytips": [
				"Tormented Soil deals tons of damage to units missing large amounts of Health. When low on Health, be wary of Morgana's attempts to trap you within its reach.",
				"Morgana often needs to land Dark Binding to setup her other attacks. Use your minions as shields against Dark Binding."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 6,
				"magic": 8,
				"difficulty": 1
			},
			"stats": {
				"hp": 559.48,
				"hpperlevel": 90,
				"mp": 340.8,
				"mpperlevel": 60,
				"movespeed": 335,
				"armor": 25.384,
				"armorperlevel": 3.8,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 450,
				"hpregen": 5.5,
				"hpregenperlevel": 0.6,
				"mpregen": 11.5,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55.46,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.53
			},
			"spells": [
				{
					"id": "DarkBindingMissile",
					"name": "Dark Binding",
					"description": "Morgana releases a sphere of dark magic. Upon contact with an enemy unit, the sphere will deal magic damage and force the unit to the ground for a period of time.",
					"tooltip": "Fires a bolt of dark energy, rooting the first enemy hit for {{ e2 }} seconds and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Root Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						11,
						11,
						11,
						11
					],
					"cooldownBurn": "11",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							80,
							135,
							190,
							245,
							300
						],
						[
							2,
							2.25,
							2.5,
							2.75,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/135/190/245/300",
						"2/2.25/2.5/2.75/3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1175,
						1175,
						1175,
						1175,
						1175
					],
					"rangeBurn": "1175",
					"image": {
						"full": "DarkBindingMissile.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TormentedSoil",
					"name": "Tormented Soil",
					"description": "Infects an area with desecrated soil, causing enemy units who stand on the location to take continual damage.",
					"tooltip": "Curses an area for {{ e7 }} seconds. Enemies on the cursed ground are dealt<br />from {{ e5 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage every second based on the enemy's missing Health.<br /><br />Every time <span class=\"colorE9DDAB\">Soul Siphon</span> heals Morgana, Tormented Soil's cooldown is reduced by {{ e4 }}%.",
					"leveltip": {
						"label": [
							"Damage ",
							"Mana Cost"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }} ",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						70,
						85,
						100,
						115,
						130
					],
					"costBurn": "70/85/100/115/130",
					"effect": [
						null,
						[
							8,
							16,
							24,
							32,
							40
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							280,
							280,
							280,
							280,
							280
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							16,
							32,
							48,
							64,
							80
						],
						[
							24,
							48,
							72,
							96,
							120
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"8/16/24/32/40",
						"0.5",
						"280",
						"5",
						"16/32/48/64/80",
						"24/48/72/96/120",
						"5",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.22,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.33,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "TormentedSoil.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BlackShield",
					"name": "Black Shield",
					"description": "Places a protective barrier around an allied champion, absorbing magical damage and disables until penetrated or the shield dissipates.",
					"tooltip": "Shields an allied Champion for {{ e2 }} seconds. The shield absorbs {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and prevents disables until it breaks.",
					"leveltip": {
						"label": [
							"Shield Health",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						23,
						21,
						19,
						17,
						15
					],
					"cooldownBurn": "23/21/19/17/15",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							70,
							140,
							210,
							280,
							350
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/140/210/280/350",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "BlackShield.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SoulShackles",
					"name": "Soul Shackles",
					"description": "Latches chains of energy onto nearby enemy champions, dealing initial damage to them and slowing their Movement Speed, and then echoing the pain a few seconds later and stunning them if they remain close to Morgana.",
					"tooltip": "Dark chains latch onto nearby enemy Champions dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing them by {{ e4 }}% for {{ e3 }} seconds, granting <span class=\"coloree91d7\">True Sight</span>. After {{ e3 }} seconds, they are dealt an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are stunned for {{ e2 }} seconds.<br /><br />Enemy Champions can break the chains by moving away from Morgana.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							225,
							300
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							3,
							3,
							3
						],
						[
							20,
							20,
							20
						],
						[
							575,
							575,
							575
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/225/300",
						"1.5",
						"3",
						"20",
						"575",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "SoulShackles.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Soul Siphon",
				"description": "Morgana heals for the spell damage she deals to champions, large minions, and large monsters.",
				"image": {
					"full": "FallenAngel_Empathize.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Morgana",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Morgana",
					"title": "MorganaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Nami": {
			"id": "Nami",
			"key": "267",
			"name": "Nami",
			"title": "the Tidecaller",
			"image": {
				"full": "Nami.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 192,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "267000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "267001",
					"num": 1,
					"name": "Koi Nami",
					"chromas": true
				},
				{
					"id": "267002",
					"num": 2,
					"name": "River Spirit Nami",
					"chromas": false
				},
				{
					"id": "267003",
					"num": 3,
					"name": "Urf the Nami-tee",
					"chromas": false
				},
				{
					"id": "267007",
					"num": 7,
					"name": "Deep Sea Nami",
					"chromas": false
				},
				{
					"id": "267008",
					"num": 8,
					"name": "SKT T1 Nami",
					"chromas": false
				}
			],
			"lore": "A headstrong young vastaya of the seas, Nami was the first of the Marai tribe to leave the waves and venture onto dry land, when their ancient accord with the Targonians was broken. With no other option, she took it upon herself to complete the sacred ritual that would ensure the safety of her people. Amidst the chaos of this new age, Nami faces an uncertain future with grit and determination, using her Tidecaller staff to summon the strength of the oceans themselves.",
			"blurb": "A headstrong young vastaya of the seas, Nami was the first of the Marai tribe to leave the waves and venture onto dry land, when their ancient accord with the Targonians was broken. With no other option, she took it upon herself to complete the sacred...",
			"allytips": [
				"Aqua Prison has a long cooldown, make sure to use it at the right moment.",
				"Using Ebb and Flow during an engagement with enemy champions will help sway the battle in your favor.",
				"Nami's ultimate can come in very handy for initiating on enemies who are far away."
			],
			"enemytips": [
				"Aqua Prison is a very powerful ability with a long cooldown, take advantage of the situation if Nami misses this ability.",
				"Tidal Wave has a very long range but travels slowly, be aware of when it is coming your way as you can move out of its path.",
				"Try to avoid fighting an opponent affected by Tidecaller's Blessing, it lasts a short duration so waiting it out can help you greatly."
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 3,
				"magic": 7,
				"difficulty": 5
			},
			"stats": {
				"hp": 489.32,
				"hpperlevel": 74,
				"mp": 377.24,
				"mpperlevel": 43,
				"movespeed": 335,
				"armor": 29,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 11.5,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 51.208,
				"attackdamageperlevel": 3.1,
				"attackspeedoffset": -0.03,
				"attackspeedperlevel": 2.61
			},
			"spells": [
				{
					"id": "NamiQ",
					"name": "Aqua Prison",
					"description": "Sends a bubble to a target area, dealing damage and stunning all enemies on impact.",
					"tooltip": "Sends a bubble to target area, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies, and stunning them for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							75,
							130,
							185,
							240,
							295
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/130/185/240/295",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						875,
						875,
						875,
						875,
						875
					],
					"rangeBurn": "875",
					"image": {
						"full": "NamiQ.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NamiW",
					"name": "Ebb and Flow",
					"description": "Unleashes a stream of water that bounces back and forth between allied and enemy champions, healing allies and damaging enemies.",
					"tooltip": "Unleashes a stream of water that bounces back and forth between allied and enemy champions.<br /><br /><span class=\"colorCCFF99\">On Ally Hit: </span>Heals {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Health and will bounce to a nearby enemy champion.<br /><br /><span class=\"colorFF9999\">On Enemy Hit: </span>Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and bounces to a nearby allied champion.<br /><br />Bounces to each target only once, and hits up to {{ e2 }} targets. The damage and healing value is modified by <span class=\"color99FF99\">({{ f1 }}%)</span> each bounce. ",
					"leveltip": {
						"label": [
							"Heal",
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						70,
						85,
						100,
						115,
						130
					],
					"costBurn": "70/85/100/115/130",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							65,
							95,
							125,
							155,
							185
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							0.075,
							0.075,
							0.075,
							0.075,
							0.075
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"3",
						"65/95/125/155/185",
						"15",
						"0.08",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "NamiW.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NamiE",
					"name": "Tidecaller's Blessing",
					"description": "Empowers an allied champion for a short duration. The ally's basic attacks deal bonus magic damage and slow the target.",
					"tooltip": "Empowers an allied champion's next {{ e4 }} basic attacks, causing them to slow the target by {{ e2 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> for {{ e3 }} second and deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage. Lasts for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						11,
						11,
						11,
						11
					],
					"cooldownBurn": "11",
					"cost": [
						55,
						60,
						65,
						70,
						75
					],
					"costBurn": "55/60/65/70/75",
					"effect": [
						null,
						[
							25,
							40,
							55,
							70,
							85
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/40/55/70/85",
						"15/20/25/30/35",
						"1",
						"3",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.05,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "NamiE.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NamiR",
					"name": "Tidal Wave",
					"description": "Summons a massive Tidal Wave that knocks up, slows, and damages enemies. Allies hit gain double the effect of Surging Tides.",
					"tooltip": "Summons a Tidal Wave from Nami's position. The wave knocks up enemies and slows them by {{ e4 }}%, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The duration of the slow increases based on how far the Tidal Wave has traveled, with a minimum duration of {{ e3 }} seconds and a maximum of {{ e5 }} seconds.<br /><br />Allies hit by the wave gain double the effect of Surging Tides.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Slow"
						],
						"effect": [
							" ",
							" {{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e4 }}% -> {{ e4NL }}%"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							2,
							2,
							2
						],
						[
							50,
							60,
							70
						],
						[
							4,
							4,
							4
						],
						[
							0.002,
							0.002,
							0.002
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"0.5",
						"2",
						"50/60/70",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						2550,
						2550,
						2550
					],
					"rangeBurn": "2550",
					"image": {
						"full": "NamiR.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Surging Tides",
				"description": "When Nami's abilities hit allied champions they gain Movement Speed for a short duration.",
				"image": {
					"full": "NamiPassive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Nami",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "NamiARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "NamiCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "namiFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "NamiKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "NamiSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "namiSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nami",
					"title": "namiTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Nasus": {
			"id": "Nasus",
			"key": "75",
			"name": "Nasus",
			"title": "the Curator of the Sands",
			"image": {
				"full": "Nasus.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 240,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "75000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "75001",
					"num": 1,
					"name": "Galactic Nasus",
					"chromas": false
				},
				{
					"id": "75002",
					"num": 2,
					"name": "Pharaoh Nasus",
					"chromas": false
				},
				{
					"id": "75003",
					"num": 3,
					"name": "Dreadknight Nasus",
					"chromas": true
				},
				{
					"id": "75004",
					"num": 4,
					"name": "Riot K-9 Nasus",
					"chromas": false
				},
				{
					"id": "75005",
					"num": 5,
					"name": "Infernal Nasus",
					"chromas": false
				},
				{
					"id": "75006",
					"num": 6,
					"name": "Archduke Nasus",
					"chromas": false
				},
				{
					"id": "75010",
					"num": 10,
					"name": "Worldbreaker Nasus",
					"chromas": false
				},
				{
					"id": "75011",
					"num": 11,
					"name": "Lunar Guardian Nasus",
					"chromas": true
				}
			],
			"lore": "Nasus is an imposing, jackal-headed Ascended being from ancient Shurima, a heroic figure regarded as a demigod by the people of the desert. Fiercely intelligent, he was a guardian of knowledge and peerless strategist whose wisdom guided the ancient empire of Shurima to greatness for many centuries. After the fall of the empire, he went into self-imposed exile, becoming little more than a legend. Now that the ancient city of Shurima has risen once more, he has returned, determined to ensure it never falls again.",
			"blurb": "Nasus is an imposing, jackal-headed Ascended being from ancient Shurima, a heroic figure regarded as a demigod by the people of the desert. Fiercely intelligent, he was a guardian of knowledge and peerless strategist whose wisdom guided the ancient...",
			"allytips": [
				"Paying attention to last hitting with Siphoning Strike will have a large impact at the end of a game.",
				"If you're solo, Spirit Fire is a great way to farm a lane. It can be bad if you're in a lane with 2 and you push too far. Find the right balance between Siphoning Strike last hits and AoE farming.",
				"If you have low defenses, people will focus you down even during your ultimate. Try buying some survivability items even in your DPS builds."
			],
			"enemytips": [
				"While transformed by his ultimate, Nasus is stronger than most champions in the League. Engage him only if you have a clear advantage.",
				"Max rank Wither is a very effective counter to Attack Damage characters, so try to avoid getting caught alone by it.",
				"Nasus is prone to being kited. Try not to engage him at full Health."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 5,
				"magic": 6,
				"difficulty": 6
			},
			"stats": {
				"hp": 561.2,
				"hpperlevel": 90,
				"mp": 325.6,
				"mpperlevel": 42,
				"movespeed": 350,
				"armor": 34,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9,
				"hpregenperlevel": 0.9,
				"mpregen": 7.44,
				"mpregenperlevel": 0.5,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 67,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 3.48
			},
			"spells": [
				{
					"id": "NasusQ",
					"name": "Siphoning Strike",
					"description": "Nasus strikes his foe, dealing damage and increasing the power of his future Siphoning Strikes if he slays his target.",
					"tooltip": "Nasus's next basic attack will deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> <span class=\"color5555FF\">(+{{ f1 }})</span> physical damage.<br /><br />Siphoning Strike permanently gains <span class=\"color5555FF\">{{ e2 }}</span> damage if it kills an enemy. This bonus is doubled against Champions, large minions and large monsters.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7,
						6,
						5,
						4
					],
					"cooldownBurn": "8/7/6/5/4",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/50/70/90/110",
						"3",
						"25",
						"6",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "@stacks",
							"coeff": 3,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "NasusQ.png",
						"sprite": "spell7.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NasusW",
					"name": "Wither",
					"description": "Nasus ages an enemy champion, decelerating their Movement and Attack Speeds over time.",
					"tooltip": "Nasus ages target champion over {{ e3 }} seconds, slowing their Movement Speed by {{ e2 }}%, increasing to {{ e1 }}% over the duration. The target's Attack Speed is reduced by half the amount.",
					"leveltip": {
						"label": [
							"Max Slow",
							"Cooldown"
						],
						"effect": [
							" {{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						14,
						13,
						12,
						11
					],
					"cooldownBurn": "15/14/13/12/11",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							47,
							59,
							71,
							83,
							95
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							17.5,
							17.5,
							17.5,
							17.5,
							17.5
						],
						[
							1.5,
							3,
							4.5,
							6,
							7.5
						],
						[
							3,
							6,
							9,
							12,
							15
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"47/59/71/83/95",
						"35",
						"5",
						"17.5",
						"1.5/3/4.5/6/7.5",
						"3/6/9/12/15",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "NasusW.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NasusE",
					"name": "Spirit Fire",
					"description": "Nasus unleashes a spirit flame at a location, dealing damage and reducing the Armor of enemies who stand on it.",
					"tooltip": "Nasus unleashes a spirit flame at target location, dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.<br /><br />For the next {{ e3 }} seconds, enemies in the area have their Armor reduced by {{ e2 }}% and are dealt an additional {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage each second.",
					"leveltip": {
						"label": [
							"Initial Damage",
							"Damage Per Second",
							"Armor Reduction",
							"Mana Cost"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						70,
						85,
						100,
						115,
						130
					],
					"costBurn": "70/85/100/115/130",
					"effect": [
						null,
						[
							11,
							19,
							27,
							35,
							43
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							55,
							95,
							135,
							175,
							215
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"11/19/27/35/43",
						"15/20/25/30/35",
						"5",
						"55/95/135/175/215",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.12,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "NasusE.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NasusR",
					"name": "Fury of the Sands",
					"description": "Nasus unleashes a mighty sandstorm that batters nearby enemies. While the storm rages, he gains increased Health, Attack Range, damages nearby enemies, has a reduced cooldown on Siphoning Strike, and gains bonus Armor and Magic Resistance for the duration.",
					"tooltip": "Nasus becomes empowered in the sandstorm for 15 seconds, increasing his maximum Health by {{ e1 }} and Armor and Magic Resistance by {{ e4 }}.<br /><br />While the storm rages, he deals {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of nearby enemies' maximum Health each second as magic damage ({{ e5 }} damage max per second), gains an additional {{ e8 }} Armor and Magic Resistance each second, and Siphoning Strike has a {{ e9 }}% reduced cooldown.",
					"leveltip": {
						"label": [
							"Bonus Health",
							"Max Health %",
							"Initial Armor and Magic Resistance",
							"Incremental Armor and Magic Resistance"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e8 }} -> {{ e8NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						120,
						120
					],
					"cooldownBurn": "120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							300,
							450,
							600
						],
						[
							50,
							50,
							50
						],
						[
							3,
							4,
							5
						],
						[
							15,
							35,
							55
						],
						[
							240,
							240,
							240
						],
						[
							15,
							15,
							15
						],
						[
							0,
							0,
							0
						],
						[
							1,
							2,
							3
						],
						[
							50,
							50,
							50
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"300/450/600",
						"50",
						"3/4/5",
						"15/35/55",
						"240",
						"15",
						"0",
						"1/2/3",
						"50",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.01,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "NasusR.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Soul Eater",
				"description": "Nasus drains his foe's spiritual energy, giving him bonus Life Steal.",
				"image": {
					"full": "Nasus_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Nasus",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nasus",
					"title": "NasusTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Nautilus": {
			"id": "Nautilus",
			"key": "111",
			"name": "Nautilus",
			"title": "the Titan of the Depths",
			"image": {
				"full": "Nautilus.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 288,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "111000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "111001",
					"num": 1,
					"name": "Abyssal Nautilus",
					"chromas": false
				},
				{
					"id": "111002",
					"num": 2,
					"name": "Subterranean Nautilus",
					"chromas": false
				},
				{
					"id": "111003",
					"num": 3,
					"name": "AstroNautilus",
					"chromas": false
				},
				{
					"id": "111004",
					"num": 4,
					"name": "Warden Nautilus",
					"chromas": false
				},
				{
					"id": "111005",
					"num": 5,
					"name": "Worldbreaker Nautilus",
					"chromas": false
				}
			],
			"lore": "All know the tales; all pay the Bilgewater tithe. Since time immemorial, Nautilus has roamed the dark waters off the coast of the Blue Flame Isles, dragging impious sailors to their doom. The armored goliath strikes without warning, his inexorable footfalls churning the waters, before swinging his enormous anchor upward to shatter mast and keel alike. He then pulls the flotsam beneath the waves to appease the wrath of the Bearded Lady.",
			"blurb": "All know the tales; all pay the Bilgewater tithe. Since time immemorial, Nautilus has roamed the dark waters off the coast of the Blue Flame Isles, dragging impious sailors to their doom. The armored goliath strikes without warning, his inexorable...",
			"allytips": [
				"While ganking, consider aiming Dredge Line at nearby terrain and following it up with Riptide for a higher hit rate.",
				"Riptide has a delayed blast timing on activation - you can use this while running away or when enemies are incoming to serve as a deterrent."
			],
			"enemytips": [
				"If Nautilus uses Riptide right next to you, hold in place until the ripple effect finishes before running. Running early will run straight into the secondary explosions, causing you to take additional damage and slow.",
				"While Nautilus is shielded, he is capable of dealing large amounts of area of effect damage with his basic attacks - consider taking down the shield if you have time."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 6,
				"magic": 6,
				"difficulty": 6
			},
			"stats": {
				"hp": 576.48,
				"hpperlevel": 86,
				"mp": 334,
				"mpperlevel": 47,
				"movespeed": 325,
				"armor": 35.46,
				"armorperlevel": 3.75,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8.5,
				"hpregenperlevel": 0.55,
				"mpregen": 8.626,
				"mpregenperlevel": 0.5,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 57.54,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0.02,
				"attackspeedperlevel": 1
			},
			"spells": [
				{
					"id": "NautilusAnchorDrag",
					"name": "Dredge Line",
					"description": "Nautilus hurls his anchor forward. If it hits a champion, he drags both himself and the opponent close together. If it hits terrain, Nautilus instead pulls himself to the anchor, the cooldown of Dredge Line is reduced by half, and half the Mana cost is refunded.",
					"tooltip": "Nautilus hurls his anchor forward. If it hits an enemy unit, Nautilus drags himself and the target together dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage and stunning them briefly.<br /><br />If the anchor hits terrain, Nautilus will drag himself forward, the cooldown is reduced by {{ e3 }}% (<totalValue>{{ f1 }}</totalValue>), and {{ e4 }}% of the Mana cost is refunded.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"0",
						"50",
						"50",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						},
						{
							"link": "@special.nautilusq",
							"coeff": 0.5,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "NautilusAnchorDrag.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NautilusPiercingGaze",
					"name": "Titan's Wrath",
					"description": "Nautilus surrounds himself with dark energies, gaining a shield that blocks incoming damage. While the shield persists, his attacks apply a damage over time effect to enemies around his target.",
					"tooltip": "Nautilus surrounds himself with dark energies for {{ e3 }} seconds, shielding him from the next {{ e1 }} <scaleHealth>(+{{ f1 }})</scaleHealth> ({{ e2 }}% of his max Health) damage.<br /><br />While the shield persists, Nautilus' basic attacks deal {{ e4 }} <scaleAP>(+{{ a1 }})</scaleAP> bonus magic damage over 2 seconds to all enemies around his target.",
					"leveltip": {
						"label": [
							"Shield Amount",
							"Bonus Magic Damage",
							"Percent Max Health"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						18,
						18,
						18,
						18
					],
					"cooldownBurn": "18",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							65,
							70,
							75,
							80,
							85
						],
						[
							9,
							11,
							13,
							15,
							17
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/70/75/80/85",
						"9/11/13/15/17",
						"10",
						"30/40/50/60/70",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonushealth",
							"coeff": 0.1,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "NautilusPiercingGaze.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NautilusSplashZone",
					"name": "Riptide",
					"description": "Nautilus slams the ground, causing the earth to explode around him in a set of three explosions. Each explosion damages and slows enemies.",
					"tooltip": "Nautilus slams the ground, causing the earth to explode around him. Each explosion deals {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to enemies in the area and slows them by {{ e2 }}% for {{ e4 }} seconds. This slow diminishes over time.<br /><br />A unit can be hit by more than one explosion, but they take {{ e3 }}% less damage from additional explosions.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							55,
							85,
							115,
							145,
							175
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/85/115/145/175",
						"30/35/40/45/50",
						"50",
						"1.25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "NautilusSplashZone.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NautilusGrandLine",
					"name": "Depth Charge",
					"description": "Nautilus fires a shockwave into the earth that chases an opponent. This shockwave rips up the earth above it, knocking enemies into the air. When it reaches the opponent, the shockwave erupts, knocking his target into the air and stunning them.",
					"tooltip": "Nautilus fires a shockwave that chases an enemy champion, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to other enemies it passes through, knocking them into the air, and stunning them for {{ e5 }} seconds.<br /><br />The shockwave explodes upon hitting its target dealing {{ e2 }} <scaleAP>(+{{ a2 }})</scaleAP> magic damage, launching them into the air and stunning them for {{ e5 }} seconds. ",
					"leveltip": {
						"label": [
							"Pass Through Damage",
							"Explosion Damage",
							"Stun Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							125,
							175,
							225
						],
						[
							200,
							325,
							450
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							1,
							1.5,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"125/175/225",
						"200/325/450",
						"0",
						"0",
						"1/1.5/2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						825,
						825,
						825
					],
					"rangeBurn": "825",
					"image": {
						"full": "NautilusGrandLine.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Staggering Blow",
				"description": "Nautilus' basic attacks deal bonus physical damage and immobilize his targets. This effect cannot happen more than once every few seconds on the same target.",
				"image": {
					"full": "Nautilus_StaggeringBlow.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Nautilus",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusSupport",
					"map": "any",
					"mode": "any",
					"type": "riot-support",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nautilus",
					"title": "NautilusTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Nidalee": {
			"id": "Nidalee",
			"key": "76",
			"name": "Nidalee",
			"title": "the Bestial Huntress",
			"image": {
				"full": "Nidalee.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 336,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "76000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "76001",
					"num": 1,
					"name": "Snow Bunny Nidalee",
					"chromas": false
				},
				{
					"id": "76002",
					"num": 2,
					"name": "Leopard Nidalee",
					"chromas": false
				},
				{
					"id": "76003",
					"num": 3,
					"name": "French Maid Nidalee",
					"chromas": false
				},
				{
					"id": "76004",
					"num": 4,
					"name": "Pharaoh Nidalee",
					"chromas": false
				},
				{
					"id": "76005",
					"num": 5,
					"name": "Bewitching Nidalee",
					"chromas": false
				},
				{
					"id": "76006",
					"num": 6,
					"name": "Headhunter Nidalee",
					"chromas": false
				},
				{
					"id": "76007",
					"num": 7,
					"name": "Warring Kingdoms Nidalee",
					"chromas": false
				},
				{
					"id": "76008",
					"num": 8,
					"name": "Challenger Nidalee",
					"chromas": false
				},
				{
					"id": "76009",
					"num": 9,
					"name": "Super Galaxy Nidalee",
					"chromas": false
				}
			],
			"lore": "Raised in the deepest jungle, Nidalee is a master tracker who can shapeshift into a ferocious cougar at will. Neither wholly woman nor beast, she viciously defends her territory from any and all trespassers, with carefully placed traps and deft spear throws. She cripples her quarry before pouncing on them in feline form—the lucky few who survive tell tales of a wild woman with razor-sharp instincts, and even sharper claws...",
			"blurb": "Raised in the deepest jungle, Nidalee is a master tracker who can shapeshift into a ferocious cougar at will. Neither wholly woman nor beast, she viciously defends her territory from any and all trespassers, with carefully placed traps and deft spear...",
			"allytips": [
				"Use brush to your advantage! Moving in and out of brush can heavily alter your effectiveness in battle.",
				"Start team fights by harassing with your Javelin Toss, and then switch to cougar form to chase down Hunted targets.",
				"Bushwhack traps deal damage based on their victim's current Health. Set them up in your team's backline before fights break out during sieges to help your team deal damage to the enemy frontline."
			],
			"enemytips": [
				"Nidalee's Hunt debuff is only applied with Javelin Toss and Bushwhack. Avoiding being hit by these abilities will impair her ability to deal follow-up damage.",
				"Nidalee's Javelin Toss deals more damage the farther she is. If she is far away, it's imperative to dodge it.",
				"Nidalee's Takedown deals extreme damage to Hunted targets, but she has to get close to use it. Save your crowd control or defensive abilities for when she goes in for the kill."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 4,
				"magic": 7,
				"difficulty": 8
			},
			"stats": {
				"hp": 545,
				"hpperlevel": 85,
				"mp": 295.6,
				"mpperlevel": 45,
				"movespeed": 335,
				"armor": 28,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 6,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 3.22
			},
			"spells": [
				{
					"id": "JavelinToss",
					"name": "Javelin Toss / Takedown",
					"description": "In human form, Nidalee throws a spiked javelin at her target that gains damage as it flies.  As a cougar, her next attack will attempt to fatally wound her target, dealing more damage the less life they have.",
					"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee throws her javelin, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage. If it exceeds her basic attack range, it gains damage based on distance flown, up to a potential {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> total damage.<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee's next attack deals additional damage, greatly increased on low health targets.",
					"leveltip": {
						"label": [
							"Javelin Minimum Damage",
							"Javelin Maximum Damage",
							"Javelin Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							70,
							85,
							100,
							115,
							130
						],
						[
							210,
							255,
							300,
							345,
							390
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							1.2,
							1.2,
							1.2,
							1.2,
							1.2
						],
						[
							525,
							525,
							525,
							525,
							525
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/85/100/115/130",
						"210/255/300/345/390",
						"0",
						"0",
						"0.4",
						"1.2",
						"525",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 1.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1500,
						1500,
						1500,
						1500,
						1500
					],
					"rangeBurn": "1500",
					"image": {
						"full": "JavelinToss.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Bushwhack",
					"name": "Bushwhack / Pounce",
					"description": "In human form, Nidalee lays a trap for unwary opponents that, when sprung, damages and reveals its target. As a cougar, she jumps in a direction, dealing damage in an area where she lands.",
					"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee places an invisible trap that lasts for 2 minutes. The trap triggers when an enemy walks over it, revealing the victim and bleeding them for {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage over 4 seconds.<br /><br /><span class=\"colorFFFFFF\">{{ f4 }}</span> traps may be active at once. (Maximum traps increases at level 6, 11 and 16)<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee lunges in target direction, dealing damage to nearby enemies.",
					"leveltip": {
						"label": [
							"Trap Damage",
							"Trap Cooldown",
							"Trap Mana Cost"
						],
						"effect": [
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							13,
							12,
							11,
							10,
							9
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							120,
							120,
							120,
							120,
							120
						],
						[
							40,
							80,
							120,
							160,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"0",
						"4",
						"13/12/11/10/9",
						"10/20/30/40/50",
						"120",
						"40/80/120/160/200",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "0",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "Bushwhack.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PrimalSurge",
					"name": "Primal Surge / Swipe",
					"description": "In human form, Nidalee channels the spirit of the cougar to heal her allies and imbue them with Attack Speed for a short duration. As a cougar, she claws in a direction, dealing damage to enemies in front of her.",
					"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee heals target ally champion for {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> to {{ e2 }} <span class=\"color99FF99\">(+{{ f3 }})</span> based on their missing health and grants them {{ e4 }}% Attack Speed for 7 seconds.<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee claws at enemies in target direction.",
					"leveltip": {
						"label": [
							"Primal Surge Heal",
							"Primal Surge Attack Speed",
							"Primal Surge Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						60,
						75,
						90,
						105,
						120
					],
					"costBurn": "60/75/90/105/120",
					"effect": [
						null,
						[
							35,
							55,
							75,
							95,
							115
						],
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.05,
							0.05,
							0.05,
							0.05,
							0.05
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/55/75/95/115",
						"70/110/150/190/230",
						"0",
						"20/30/40/50/60",
						"0",
						"0.05",
						"2",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.325,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "PrimalSurge.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AspectOfTheCougar",
					"name": "Aspect Of The Cougar",
					"description": "Nidalee transforms into a cougar, gaining new abilities.",
					"tooltip": "<span class=\"size18 colorFF9900\">Human: </span>Nidalee transforms into a vicious cougar with the basic abilities Takedown, Pounce, and Swipe.<br /><br /><span class=\"size18 colorFF9900\">Cougar: </span>Nidalee transforms back into human form. While in human form, triggering a <span class=\"colorFFF673\">Hunt</span> resets the cooldown of Aspect of the Cougar.",
					"leveltip": {
						"label": [
							"Takedown Damage",
							"Takedown Damage Amp",
							"Pounce Damage",
							"Swipe Damage",
							"Enhanced Pounce Cooldown"
						],
						"effect": [
							"{{ f1 }} -> {{ f6 }}",
							"{{ f4 }}% -> {{ f5 }}%",
							"{{ f7 }} -> {{ f8 }}",
							"{{ f9 }} -> {{ f10 }}",
							"{{ f2 }} -> {{ f3 }}"
						]
					},
					"maxrank": 4,
					"cooldown": [
						3,
						3,
						3,
						3
					],
					"cooldownBurn": "3",
					"cost": [
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0
						],
						[
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0
						],
						[
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"0",
						"0",
						"0",
						"0",
						"6",
						"0",
						"10",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "AspectOfTheCougar.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Prowl",
				"description": "Moving through brush increases Nidalee's Movement Speed by 10% for 2 seconds, increased to 30% toward visible enemy champions within 1400 range.<br><br>Hitting champions or monsters with Javelin Toss or Bushwhack triggers a <font color='#FFF673'>Hunt</font>, granting <font color='#ee91d7'>True Sight</font> of them for 4 seconds. During this time, Nidalee gains 10% Movement Speed (increased to 30% toward the <font color='#FFF673'>Hunted</font> target) and her Takedown and Pounce are enhanced against them.",
				"image": {
					"full": "Nidalee_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Nidalee",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1410",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nidalee",
					"title": "NidaleeTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Nocturne": {
			"id": "Nocturne",
			"key": "56",
			"name": "Nocturne",
			"title": "the Eternal Nightmare",
			"image": {
				"full": "Nocturne.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 384,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "56000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "56001",
					"num": 1,
					"name": "Frozen Terror Nocturne",
					"chromas": false
				},
				{
					"id": "56002",
					"num": 2,
					"name": "Void Nocturne",
					"chromas": false
				},
				{
					"id": "56003",
					"num": 3,
					"name": "Ravager Nocturne",
					"chromas": false
				},
				{
					"id": "56004",
					"num": 4,
					"name": "Haunting Nocturne",
					"chromas": false
				},
				{
					"id": "56005",
					"num": 5,
					"name": "Eternum Nocturne",
					"chromas": false
				},
				{
					"id": "56006",
					"num": 6,
					"name": "Cursed Revenant Nocturne",
					"chromas": false
				}
			],
			"lore": "A demonic amalgamation drawn from the nightmares that haunt every sentient mind, the thing known as Nocturne has become a primordial force of pure evil. It is liquidly chaotic in aspect, a faceless shadow with cold eyes and armed with wicked-looking blades. After freeing itself from the spirit realm, Nocturne descended upon the waking world, to feed upon the kind of terror that can only thrive in true darkness.",
			"blurb": "A demonic amalgamation drawn from the nightmares that haunt every sentient mind, the thing known as Nocturne has become a primordial force of pure evil. It is liquidly chaotic in aspect, a faceless shadow with cold eyes and armed with wicked-looking...",
			"allytips": [
				"Using Paranoia at a critical moment is well worth it even if you cannot use the dash.",
				"Duskbringer isn't only an offensive ability. It can be used to close distance out of combat or escape from certain death.",
				"Use Shroud of Darkness in tandem with Paranoia's dash. Your opponents may panic and waste a critical disable on your spell shield."
			],
			"enemytips": [
				"Stay close to your allies when Paranoia is cast - there is strength in numbers!",
				"Nocturne's Unspeakable Horror is broken with range, so try to save your movement abilities for when he casts it."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 5,
				"magic": 2,
				"difficulty": 4
			},
			"stats": {
				"hp": 582.8,
				"hpperlevel": 85,
				"mp": 273.8,
				"mpperlevel": 35,
				"movespeed": 345,
				"armor": 36,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.75,
				"mpregen": 6.756,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 67.21,
				"attackdamageperlevel": 3.1,
				"attackspeedoffset": -0.065,
				"attackspeedperlevel": 2.7
			},
			"spells": [
				{
					"id": "NocturneDuskbringer",
					"name": "Duskbringer",
					"description": "Nocturne throws a shadow blade that deals damage, leaves a Dusk Trail, and causes champions to leave a Dusk Trail. While on the trail, Nocturne can move through units and has increased Movement Speed and Attack Damage.",
					"tooltip": "Nocturne throws a shadow blade that deals {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and leaves a Dusk Trail for {{ e3 }} seconds. Enemy champions hit also leave a Dusk Trail.<br /><br />While on the trail, Nocturne can move through units and gains {{ e1 }}% Movement Speed and {{ e4 }} Attack Damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed Bonus",
							"Bonus Attack Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							" {{ e1 }}% -> {{ e1NL }}%",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							65,
							110,
							155,
							200,
							245
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							15,
							25,
							35,
							45,
							55
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/20/25/30/35",
						"65/110/155/200/245",
						"5",
						"15/25/35/45/55",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.75,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1125,
						1125,
						1125,
						1125,
						1125
					],
					"rangeBurn": "1125",
					"image": {
						"full": "NocturneDuskbringer.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NocturneShroudofDarkness",
					"name": "Shroud of Darkness",
					"description": "Nocturne empowers his blades, passively gaining Attack Speed. Activating Shroud of Darkness allows Nocturne to fade into the shadows, creating a magical barrier which blocks a single enemy ability and doubles his passive Attack Speed if successful.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Nocturne gains {{ e1 }}% Attack Speed.<br /><br /><span class=\"colorFF9900\">Active:</span> Nocturne creates a magical barrier for 1.5 seconds, which blocks the next enemy ability.<br /><br />If an ability is blocked by the shield, Nocturne's passive Attack Speed bonus doubles for 5 seconds.",
					"leveltip": {
						"label": [
							"Attack Speed Bonus",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						18,
						16,
						14,
						12
					],
					"cooldownBurn": "20/18/16/14/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0.2,
							0.05,
							0.05,
							0.05,
							0.05
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/25/30/35/40",
						"0.2/0.05/0.05/0.05/0.05",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "NocturneShroudofDarkness.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NocturneUnspeakableHorror",
					"name": "Unspeakable Horror",
					"description": "Nocturne plants a nightmare into his target's mind, dealing damage each second and terrifying the target if they do not get out of range by the end of the duration.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Nocturne gains massively increased Movement Speed toward terrified enemies.<br /><br /><span class=\"colorFF9900\">Active:</span> Nocturne plants a nightmare into his target's mind, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e3 }} seconds. If Nocturne stays within range of the target for the full duration, the target becomes terrified for {{ e2 }} second(s).",
					"leveltip": {
						"label": [
							"Damage",
							"Terrify Duration",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						14,
						13,
						12,
						11
					],
					"cooldownBurn": "15/14/13/12/11",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							1.25,
							1.5,
							1.75,
							2,
							2.25
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							465,
							465,
							465,
							465,
							465
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"1.25/1.5/1.75/2/2.25",
						"2",
						"465",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						425,
						425,
						425,
						425,
						425
					],
					"rangeBurn": "425",
					"image": {
						"full": "NocturneUnspeakableHorror.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "NocturneParanoia",
					"name": "Paranoia",
					"description": "Nocturne reduces the sight radius of all enemy champions and removes their ally vision in the process. He can then launch himself at a nearby enemy champion.",
					"tooltip": "Nocturne reduces the sight radius of all enemy champions and removes their ally vision for 4 seconds.<br /><br />While Paranoia is active, Nocturne can launch himself at an enemy champion, dealing {{ e3 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						150,
						125,
						100
					],
					"cooldownBurn": "150/125/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							250,
							250,
							250
						],
						[
							2500,
							3250,
							4000
						],
						[
							150,
							250,
							350
						],
						[
							3500,
							4250,
							5000
						],
						[
							1800,
							1800,
							1800
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250",
						"2500/3250/4000",
						"150/250/350",
						"3500/4250/5000",
						"1800",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						2500,
						3250,
						4000
					],
					"rangeBurn": "2500/3250/4000",
					"image": {
						"full": "NocturneParanoia.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Umbra Blades",
				"description": "Every 10 seconds, Nocturne's next attack strikes surrounding enemies for 120% physical damage and heals himself. <br><br>Nocturne's basic attacks reduce this cooldown by 1 second.",
				"image": {
					"full": "Nocturne_UmbraBlades.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Nocturne",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumablesjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nocturne",
					"title": "NocturneTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Nunu": {
			"id": "Nunu",
			"key": "20",
			"name": "Nunu",
			"title": "the Yeti Rider",
			"image": {
				"full": "Nunu.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 432,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "20000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "20001",
					"num": 1,
					"name": "Sasquatch Nunu",
					"chromas": false
				},
				{
					"id": "20002",
					"num": 2,
					"name": "Workshop Nunu",
					"chromas": false
				},
				{
					"id": "20003",
					"num": 3,
					"name": "Grungy Nunu",
					"chromas": false
				},
				{
					"id": "20004",
					"num": 4,
					"name": "Nunu Bot",
					"chromas": false
				},
				{
					"id": "20005",
					"num": 5,
					"name": "Demolisher Nunu",
					"chromas": false
				},
				{
					"id": "20006",
					"num": 6,
					"name": "TPA Nunu",
					"chromas": false
				},
				{
					"id": "20007",
					"num": 7,
					"name": "Zombie Nunu",
					"chromas": false
				}
			],
			"lore": "Frolicking through the hills of the Freljord, Nunu and Willump make an unlikely pair, but many travellers would swear they have seen the yeti with a fearless boy clinging to his back. Though Nunu may have tamed the beast's heart, Willump's anger remains, fueled by a ravenous hunger. Some have even tried to separate the two, yet the bond of friendship between them is stronger than any chain, and they continue to ramble on their wild adventures.",
			"blurb": "Frolicking through the hills of the Freljord, Nunu and Willump make an unlikely pair, but many travellers would swear they have seen the yeti with a fearless boy clinging to his back. Though Nunu may have tamed the beast's heart, Willump's anger remains...",
			"allytips": [
				"Consume allows Nunu to stay in a lane against ranged opponents.",
				"You can choose to interrupt Absolute Zero early for partial damage if an opponent is about to run out of range.",
				"It's often beneficial to delay the casting of Absolute Zero until the initial round of disables are used. Try to hang back before rushing into a team fight."
			],
			"enemytips": [
				"Nunu's Blood Boil allows its target to run away from fights. Make sure to snare and stun any target with Blood Boil on.",
				"Interrupting the charge up on Absolute Zero will lower the amount of damage your team takes.",
				"Using Summoner Flash is a surefire way to escape Absolute Zero.",
				"With only 1 single target ability that can break a spell shield, Banshee's Veil is extremely effective against Nunu."
			],
			"tags": [
				"Support",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 6,
				"magic": 7,
				"difficulty": 4
			},
			"stats": {
				"hp": 590,
				"hpperlevel": 90,
				"mp": 283.56,
				"mpperlevel": 42,
				"movespeed": 345,
				"armor": 28,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 5,
				"hpregenperlevel": 0.8,
				"mpregen": 7.44,
				"mpregenperlevel": 0.5,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 67,
				"attackdamageperlevel": 4,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.25
			},
			"spells": [
				{
					"id": "Consume",
					"name": "Consume",
					"description": "Nunu commands the yeti to take a bite out of a target minion or monster, dealing heavy damage to it and healing himself.",
					"tooltip": "Nunu commands the yeti to take a bite out of a minion or monster, dealing {{ e1 }} true damage and healing himself for {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span>.<br /><br /><span class=\"colorFF9900\">Passive -</span><span class=\"color33FF33\"> Feed The Yeti</span>: For every Large or Epic Monster the yeti bites, Nunu gains {{ e4 }} <scaleAP>(+{{ a2 }})</scaleAP> magic damage on hit, {{ e0 }}% Maximum Health, increased size, and {{ e9 }} out of combat Movement Speed for the next <span class=\"colorFFFFFF\">{{ f5 }}</span> seconds (max {{ e6 }} stacks).<br /><br /><span class=\"colorDDDD77\">Recently Consumed monsters will not grant additional bonuses ({{ e5 }} second cooldown).</span>",
					"leveltip": {
						"label": [
							"Damage (bite)",
							"Damage (on hit)",
							"Health Restore",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							340,
							500,
							660,
							820,
							980
						],
						[
							50,
							100,
							150,
							200,
							250
						],
						[
							120,
							150,
							180,
							210,
							240
						],
						[
							1,
							2,
							3,
							4,
							5
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0.02,
							0.02,
							0.02,
							0.02,
							0.02
						]
					],
					"effectBurn": [
						null,
						"340/500/660/820/980",
						"50/100/150/200/250",
						"120/150/180/210/240",
						"1/2/3/4/5",
						"60",
						"5",
						"5",
						"50",
						"10",
						"0.02"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.05,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						125,
						125,
						125,
						125,
						125
					],
					"rangeBurn": "125",
					"image": {
						"full": "Consume.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "BloodBoil",
					"name": "Blood Boil",
					"description": "Nunu invigorates himself and an allied unit by heating their blood, increasing their Attack Speed, Movement Speed, and Ability Power.",
					"tooltip": "The heat of Nunu and a target ally's blood rises, increasing Ability Power by {{ e4 }}% (max: {{ e5 }}), Movement Speed by {{ e2 }}%, and Attack Speed by {{ e1 }}% for {{ e3 }} seconds.<br /><br />If Nunu targets himself, Blood Boil will try to target the nearest Ally champion.",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Ability Power (max)",
							"Movement Speed"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							8,
							9,
							10,
							11,
							12
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/30/35/40/45",
						"8/9/10/11/12",
						"12",
						"40",
						"40/60/80/100/120",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "BloodBoil.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "IceBlast",
					"name": "Ice Blast",
					"description": "Nunu launches a ball of ice at an enemy unit, dealing damage and temporarily slowing their Movement and Attack Speeds.",
					"tooltip": "Nunu launches a ball of ice at an enemy unit, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slowing their Movement Speed by {{ e2 }}% and Attack Speed by {{ e3 }}% for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed Slow",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.5,
						5,
						4.5,
						4
					],
					"cooldownBurn": "6/5.5/5/4.5/4",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"40/45/50/55/60",
						"25",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "IceBlast.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "AbsoluteZero",
					"name": "Absolute Zero",
					"description": "Nunu begins to sap the area of heat, slowing all nearby enemies. When Absolute Zero ends, he deals massive damage to all enemies caught in the area.",
					"tooltip": "Nunu channels for {{ e4 }} seconds, sapping the area of heat. Nearby enemies have their Movement Speed slowed by {{ e2 }}% and their Attack Speed slowed by {{ e3 }}%. The Movement Speed slow increases to {{ e6 }}% over the duration of the channel.<br /><br />Enemies caught in the area when the channel ends take up to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, depending on how long Absolute Zero was channeled.<br />(Minimum Damage: <span class=\"color99FF99\">{{ f2 }}</span>)",
					"leveltip": {
						"label": [
							"Maximum Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						100,
						90
					],
					"cooldownBurn": "110/100/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							625,
							875,
							1125
						],
						[
							50,
							50,
							50
						],
						[
							25,
							25,
							25
						],
						[
							3,
							3,
							3
						],
						[
							3,
							3,
							3
						],
						[
							95,
							95,
							95
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"625/875/1125",
						"50",
						"25",
						"3",
						"3",
						"95",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 2.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "AbsoluteZero.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Visionary",
				"description": "After 5 attacks, Nunu's next spell costs no Mana and is empowered to do its next rank's effects.",
				"image": {
					"full": "Nunu_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Nunu",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3068",
									"count": 1
								},
								{
									"id": "3065",
									"count": 1
								},
								{
									"id": "3110",
									"count": 1
								},
								{
									"id": "3001",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3711",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Nunu",
					"title": "NunuTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Olaf": {
			"id": "Olaf",
			"key": "2",
			"name": "Olaf",
			"title": "the Berserker",
			"image": {
				"full": "Olaf.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 0,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "2000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "2001",
					"num": 1,
					"name": "Forsaken Olaf",
					"chromas": false
				},
				{
					"id": "2002",
					"num": 2,
					"name": "Glacial Olaf",
					"chromas": false
				},
				{
					"id": "2003",
					"num": 3,
					"name": "Brolaf",
					"chromas": true
				},
				{
					"id": "2004",
					"num": 4,
					"name": "Pentakill Olaf",
					"chromas": false
				},
				{
					"id": "2005",
					"num": 5,
					"name": "Marauder Olaf",
					"chromas": false
				},
				{
					"id": "2006",
					"num": 6,
					"name": "Butcher Olaf",
					"chromas": false
				},
				{
					"id": "2015",
					"num": 15,
					"name": "SKT T1 Olaf",
					"chromas": false
				}
			],
			"lore": "An unstoppable force of destruction, the axe-wielding Olaf wants nothing but to die in glorious combat. Hailing from the brutal Freljordian peninsula of Lokfar, he once received a prophecy foretelling his peaceful passing—a coward's fate, and a great insult among his people. Seeking death, and fueled by rage, he rampaged across the land, slaughtering scores of great warriors and legendary beasts in search of any opponent who could stop him. Now a brutal enforcer for the Winter's Claw, he seeks his end in the great wars to come.",
			"blurb": "An unstoppable force of destruction, the axe-wielding Olaf wants nothing but to die in glorious combat. Hailing from the brutal Freljordian peninsula of Lokfar, he once received a prophecy foretelling his peaceful passing—a coward's fate, and a great...",
			"allytips": [
				"Olaf can combine Berserker Rage, Vicious Strikes, and Ragnarok at low life to become deceptively strong.",
				"The bonus healing granted by Vicious Strikes amplifies your Life Steal from all sources as well as heals from allies."
			],
			"enemytips": [
				"Olaf becomes more dangerous the lower life he is. Save your disables to finish him off.",
				"Preventing Olaf from reaching his axe will minimize the amount of harassment he can cause in the laning phase.",
				"Olaf has reduced defenses from damage during Ragnarok, despite being immune to disables. If you can't escape from Olaf during Ragnarok, try focusing your damage on him with your teammates."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 5,
				"magic": 3,
				"difficulty": 3
			},
			"stats": {
				"hp": 597.24,
				"hpperlevel": 93,
				"mp": 315.6,
				"mpperlevel": 42,
				"movespeed": 350,
				"armor": 35,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.9,
				"mpregen": 7.466,
				"mpregenperlevel": 0.575,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": -0.1,
				"attackspeedperlevel": 2.7
			},
			"spells": [
				{
					"id": "OlafAxeThrowCast",
					"name": "Undertow",
					"description": "Olaf throws an axe into the ground at a target location, dealing damage to enemies it passes through and slowing their Movement Speed. If Olaf picks up the axe, the ability's cooldown is reduced by 4.5 seconds.",
					"tooltip": "Olaf throws an axe to target location, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to units it passes through and slowing them by {{ e2 }}% for up to {{ e3 }} seconds. The further the Axe flies, the longer the slow lasts, but it is never less than {{ e4 }} seconds.<br /><br />If Olaf picks up the axe, the ability's cooldown is reduced by 4.5 seconds.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Slow %"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						7,
						7,
						7,
						7
					],
					"cooldownBurn": "7",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							29,
							33,
							37,
							41,
							45
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"29/33/37/41/45",
						"2.5",
						"1.5",
						"800",
						"400",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "OlafAxeThrowCast.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OlafFrenziedStrikes",
					"name": "Vicious Strikes",
					"description": "Olaf's Attack Speed is increased, he gains Life Steal and has increased healing from all sources based on how much Health he is missing.",
					"tooltip": "For 6 seconds, Olaf gains {{ e2 }}% Life Steal and his Attack Speed is increased by {{ e1 }}%.<br /><br />During this time, Olaf also receives 1% increased healing from all sources for every {{ e3 }}% of Health he is missing.",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Life Steal"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						16,
						16,
						16,
						16
					],
					"cooldownBurn": "16",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							14,
							16,
							18,
							20,
							22
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/50/60/70/80",
						"14/16/18/20/22",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "OlafFrenziedStrikes.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OlafRecklessStrike",
					"name": "Reckless Swing",
					"description": "Olaf attacks with such force that it deals true damage to his target and himself, refunding the Health cost if he destroys the target.",
					"tooltip": "Olaf ferociously swings his axes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> true damage to his target. This ability's cost is equal to {{ e2 }}% of the total damage dealt, but the cost is refunded if it kills the target.<br /><br />Basic attacks lower the cooldown of Reckless Swing by 1 second.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"30",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": "Health",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "OlafRecklessStrike.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "Health"
				},
				{
					"id": "OlafRagnarok",
					"name": "Ragnarok",
					"description": "Olaf temporarily becomes immune to disables.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Olaf gains {{ e1 }} Armor and {{ e1 }} Magic Resist.<br /><br /><span class=\"colorFF9900\">Active: </span>Olaf removes all disables from himself and becomes immune to them for the next {{ e2 }} seconds. Olaf also receives a {{ e5 }}% Movement Speed bonus towards enemy champions for {{ e4 }} second. During this time, Olaf loses the passive portion of Ragnarok and gains {{ e3 }} Attack Damage.",
					"leveltip": {
						"label": [
							"Armor and Magic Resist",
							"Attack Damage",
							"Movement Speed Bonus",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							30,
							40
						],
						[
							6,
							6,
							6
						],
						[
							40,
							60,
							80
						],
						[
							1,
							1,
							1
						],
						[
							50,
							60,
							70
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40",
						"6",
						"40/60/80",
						"1",
						"50/60/70",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "OlafRagnarok.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Berserker Rage",
				"description": "Olaf's Attack Speed is increased by 1% for each 1% of his Health he is missing.",
				"image": {
					"full": "Olaf_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Olaf",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3082",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Olaf",
					"title": "OlafTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Orianna": {
			"id": "Orianna",
			"key": "61",
			"name": "Orianna",
			"title": "the Lady of Clockwork",
			"image": {
				"full": "Orianna.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 48,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "61000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "61001",
					"num": 1,
					"name": "Gothic Orianna",
					"chromas": false
				},
				{
					"id": "61002",
					"num": 2,
					"name": "Sewn Chaos Orianna",
					"chromas": false
				},
				{
					"id": "61003",
					"num": 3,
					"name": "Bladecraft Orianna",
					"chromas": false
				},
				{
					"id": "61004",
					"num": 4,
					"name": "TPA Orianna",
					"chromas": false
				},
				{
					"id": "61005",
					"num": 5,
					"name": "Winter Wonder Orianna",
					"chromas": false
				},
				{
					"id": "61006",
					"num": 6,
					"name": "Heartseeker Orianna",
					"chromas": false
				},
				{
					"id": "61007",
					"num": 7,
					"name": "Dark Star Orianna",
					"chromas": false
				}
			],
			"lore": "Once a curious girl of flesh and blood, Orianna is now a technological marvel comprised entirely of clockwork. She became gravely ill after an accident in the lower districts of Zaun, and her failing body had to be replaced with exquisite artifice, piece by piece. Accompanied by an extraordinary brass sphere she built for companionship and protection, Orianna is now free to explore the wonders of Piltover, and beyond.",
			"blurb": "Once a curious girl of flesh and blood, Orianna is now a technological marvel comprised entirely of clockwork. She became gravely ill after an accident in the lower districts of Zaun, and her failing body had to be replaced with exquisite artifice...",
			"allytips": [
				"Command: Protect can be used on yourself to return the Ball back to you quickly. Combine this with Command: Attack for a quick harassment.",
				"Command: Dissonance is a very powerful escape tool if Orianna has the Ball. The combination of speed and leaving a slowing obstacle can be quite powerful.",
				"Command: Shockwave can be used to drag enemies towards you or away from you if you position the Ball properly."
			],
			"enemytips": [
				"Orianna can only affect the area the Ball is around. Use this to your advantage.",
				"Watch out for Orianna's Ball returning to her due to leashing. This may cause some unexpected situations."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 3,
				"magic": 9,
				"difficulty": 7
			},
			"stats": {
				"hp": 530,
				"hpperlevel": 91,
				"mp": 334,
				"mpperlevel": 50,
				"movespeed": 325,
				"armor": 17.04,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 40.368,
				"attackdamageperlevel": 2.6,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "OrianaIzunaCommand",
					"name": "Command: Attack",
					"description": "Orianna commands her Ball to fire toward a target location, dealing magic damage to targets along the way (deals less damage to subsequent targets). Her Ball remains at the target location after.",
					"tooltip": "Orianna commands her Ball to shoot toward a target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to targets along the way. However, it deals {{ e2 }}% less damage for each unit it hits (Minimum {{ e3 }}%).<br /><br />Her Ball remains behind at the target location afterwards.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.25,
						4.5,
						3.75,
						3
					],
					"cooldownBurn": "6/5.25/4.5/3.75/3",
					"cost": [
						30,
						35,
						40,
						45,
						50
					],
					"costBurn": "30/35/40/45/50",
					"effect": [
						null,
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/90/120/150/180",
						"10",
						"40",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						815,
						815,
						815,
						815,
						815
					],
					"rangeBurn": "815",
					"image": {
						"full": "OrianaIzunaCommand.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OrianaDissonanceCommand",
					"name": "Command: Dissonance",
					"description": "Orianna commands the Ball to release a pulse of energy, dealing magic damage around it. This leaves a field behind that speeds up allies and slows enemies.",
					"tooltip": "Orianna commands her Ball to release an electric pulse, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies.<br /><br />The pulse leaves behind an energy field for {{ e4 }} seconds, lowering enemy Movement Speed by {{ e2 }}% and increasing ally Movement Speed by {{ e3 }}% for {{ e5 }} seconds. This effect diminishes over time.",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed Bonus",
							"Slow Amount",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/105/150/195/240",
						"20/25/30/35/40",
						"20/25/30/35/40",
						"3",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						255,
						255,
						255,
						255,
						255
					],
					"rangeBurn": "255",
					"image": {
						"full": "OrianaDissonanceCommand.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OrianaRedactCommand",
					"name": "Command: Protect",
					"description": "Orianna commands her Ball to attach to an allied champion, shielding them and dealing magic damage to any enemies it passes through on the way. Additionally, the Ball grants additional Armor and Magic Resist to the champion it is attached to.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>The Ball adds {{ e2 }} Armor and Magic Resist to the allied champion it is attached to.<br /><br /><span class=\"colorFF9900\">Active: </span>Orianna commands her Ball to travel to and attach onto an allied champion, shielding them for {{ e5 }} seconds from the next {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage. Enemies the Ball passes through along the way are damaged for {{ e3 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Armor Bonus",
							"Magic Resist Bonus",
							"Damage Absorption"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"10/15/20/25/30",
						"60/90/120/150/180",
						"75",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1095,
						1095,
						1095,
						1095,
						1095
					],
					"rangeBurn": "1095",
					"image": {
						"full": "OrianaRedactCommand.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OrianaDetonateCommand",
					"name": "Command: Shockwave",
					"description": "Orianna commands her Ball to unleash a shockwave, dealing magic damage and launching nearby enemies towards the Ball after a short delay.",
					"tooltip": "Orianna commands her Ball to unleash a shockwave after a brief delay, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and flinging them into the air a set distance in the direction of the Ball.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						95,
						80
					],
					"cooldownBurn": "110/95/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							225,
							300
						],
						[
							40,
							50,
							60
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/225/300",
						"40/50/60",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						410,
						410,
						410
					],
					"rangeBurn": "410",
					"image": {
						"full": "OrianaDetonateCommand.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Clockwork Windup",
				"description": "Orianna's autoattack deals additional magic damage. This damage increases the more Orianna attacks the same target.",
				"image": {
					"full": "OriannaPassive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Orianna",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Orianna",
					"title": "OriannaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Ornn": {
			"id": "Ornn",
			"key": "516",
			"name": "Ornn",
			"title": "The Fire below the Mountain",
			"image": {
				"full": "Ornn.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 96,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "516000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "516001",
					"num": 1,
					"name": "Thunder Lord Ornn",
					"chromas": false
				}
			],
			"lore": "Ornn is the Freljordian spirit of forging and craftsmanship. He works in the solitude of a massive smithy, hammered out from the lava caverns beneath the volcano Hearth-Home. There he stokes bubbling cauldrons of molten rock to purify ores and fashion items of unsurpassed quality. When other deities—especially Volibear—walk the earth and meddle in mortal affairs, Ornn arises to put these impetuous beings back in their place, either with his trusty hammer or the fiery power of the mountains themselves.",
			"blurb": "Ornn is the Freljordian spirit of forging and craftsmanship. He works in the solitude of a massive smithy, hammered out from the lava caverns beneath the volcano Hearth-Home. There he stokes bubbling cauldrons of molten rock to purify ores and fashion...",
			"allytips": [
				"Learning build paths of items can help quickly select upgrades in lane.",
				"Volcanic Rupture can be used to set up zoning areas to threaten enemies.",
				"The order of your abilties matters! Try to optimize Brittle usage."
			],
			"enemytips": [
				"Try to stay away from walls. Ornn is much less strong if he cannot stun you.",
				"Attack Ornn to keep him from creating items in lane."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 9,
				"magic": 3,
				"difficulty": 5
			},
			"stats": {
				"hp": 565.64,
				"hpperlevel": 90,
				"mp": 340.6,
				"mpperlevel": 45,
				"movespeed": 335,
				"armor": 33.04,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 9,
				"hpregenperlevel": 0.8,
				"mpregen": 8.01,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 67.72,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": -0.08,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "OrnnQ",
					"name": "Volcanic Rupture",
					"description": "Ornn slams the ground, sending out a fissure dealing damage and slowing enemies hit. After a small delay, a magma pillar forms at the end location.",
					"tooltip": "Ornn slams the ground, creating a fissure which deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and slows by {{ e5 }}% for {{ e6 }} seconds. A magma pillar then forms at the fissure's end for {{ e3 }} seconds.<br /><br /><span class=\"size16 color8C8C8C\">The fissure stops shortly after hitting an enemy champion.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8.5,
						8,
						7.5,
						7
					],
					"cooldownBurn": "9/8.5/8/7.5/7",
					"cost": [
						55,
						55,
						55,
						55,
						55
					],
					"costBurn": "55",
					"effect": [
						null,
						[
							20,
							50,
							80,
							110,
							140
						],
						[
							1.125,
							1.125,
							1.125,
							1.125,
							1.125
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/50/80/110/140",
						"1.13",
						"4",
						"0",
						"40/45/50/55/60",
						"2",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.6,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "OrnnQ.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OrnnW",
					"name": "Bellows Breath",
					"description": "Ornn advances, breathing fire and shielding himself. Enemies hit by the final gout of flame become Brittle.",
					"tooltip": "Ornn stomps forwards, breathing fire and shielding himself for <span class=\"colorCC3300\">{{ f5 }}</span> (12% max health) for {{ e5 }} seconds. The fire deals up to {{ e0 }}% of the enemy's max health as magic damage (minimum {{ e3 }}).<br /><br />Enemies hit by the final gout of flame become <span class=\"colorFF5733\">Brittle</span> for {{ f9 }} seconds. The next immobilizing effect against a Brittle enemy has its duration increased by 30% and deals <span class=\"colorFFFFFF\">{{ f8 }}</span>% of their max health as magic damage.<br /><br /><span class=\"size16 color8C8C8C\">Ornn's basic attacks knock back Brittle targets.</span>",
					"leveltip": {
						"label": [
							"Max Damage",
							"Min Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e0 }}% -> {{ e0NL }}%",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						15,
						13,
						11,
						9
					],
					"cooldownBurn": "17/15/13/11/9",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							0.024,
							0.026,
							0.028,
							0.03,
							0.032
						],
						[
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							550,
							550,
							550,
							550,
							550
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							12,
							13,
							14,
							15,
							16
						]
					],
					"effectBurn": [
						null,
						"0.75",
						"0",
						"80/130/180/230/280",
						"0.024/0.026/0.028/0.03/0.032",
						"3.5",
						"225",
						"550",
						"0.5",
						"1.5",
						"12/13/14/15/16"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "OrnnW.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OrnnE",
					"name": "Searing Charge",
					"description": "Ornn charges, dealing damage to enemies he passes through. If Ornn collides with terrain while charging, the impact creates a shockwave around him which deals damage and knocks up enemies.",
					"tooltip": "Ornn charges, dealing {{ e1 }} <span class=\"colorFFFF00\">(+{{ f2 }})</span><span class=\"colorFF00FF\">(+{{ f3 }})</span> physical damage to enemies hit.<br /><br />If Ornn rams into terrain, he creates a shockwave that knocks up enemies for {{ e6 }} second and applies Searing Charge's damage to those not hit by the charge.<br /><br /><span class=\"size16 color8C8C8C\">The shockwave destroys magma pillars and terrain created by enemy champions.</span>",
					"leveltip": {
						"label": [
							"Dash Damage",
							"Shockwave Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							1600,
							1600,
							1600,
							1600,
							1600
						],
						[
							650,
							650,
							650,
							650,
							650
						],
						[
							360,
							360,
							360,
							360,
							360
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"80/125/170/215/260",
						"1600",
						"650",
						"360",
						"1",
						"150",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "OrnnE.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "OrnnR",
					"name": "Call of the Forge God",
					"description": "Ornn summons a massive elemental at a location which travels toward him with increasing speed. Enemies run over by the elemental take damage, are slowed and are made Brittle. Ornn can recast the ability to charge into the elemental, redirecting it in the direction he hits it, causing the elemental to affect any enemies it runs over to be knocked up, dealing the same damage and re-applying Brittle.",
					"tooltip": "Ornn summons a massive lava elemental which stampedes toward him. Enemies run over by the elemental take {{ e2 }} <span class=\"color99FF99\">(+{{ f4 }})</span> magic damage, are slowed by {{ e5 }}% for {{ e6 }} seconds and become <span class=\"colorFF5733\">Brittle</span> for {{ f10 }} seconds.<br /><br />Ornn can recast this ability to smash into the elemental to redirect and empower it. The empowered elemental knocks up enemies for 1.5 seconds, deals {{ e2 }} <span class=\"color99FF99\">(+{{ f4 }})</span> magic damage and applies <span class=\"colorFF5733\">Brittle</span>.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						120,
						100
					],
					"cooldownBurn": "140/120/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							2500,
							2500,
							2500
						],
						[
							125,
							175,
							225
						],
						[
							1200,
							1200,
							1200
						],
						[
							100,
							100,
							100
						],
						[
							40,
							60,
							80
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2500",
						"125/175/225",
						"1200",
						"100",
						"40/60/80",
						"2",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						2500,
						2500,
						2500
					],
					"rangeBurn": "2500",
					"image": {
						"full": "OrnnR.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Living Forge",
				"description": "Ornn can spend gold to forge non-consumable items anywhere.<br><br>Additionally, when Ornn reaches level 13 masterwork upgrades for some items become available for Ornn and his team to purchase.<br><br><font color='#8C8C8C' size='16'>Ornn can smith items directly from his forge menu or the shop.</font>",
				"image": {
					"full": "OrnnP.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ornn",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendary",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extenOrnnPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extenOrnnPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extenOrnnPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3801",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ornn",
					"title": "OrnnTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Pantheon": {
			"id": "Pantheon",
			"key": "80",
			"name": "Pantheon",
			"title": "the Artisan of War",
			"image": {
				"full": "Pantheon.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 144,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "80000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "80001",
					"num": 1,
					"name": "Myrmidon Pantheon",
					"chromas": false
				},
				{
					"id": "80002",
					"num": 2,
					"name": "Ruthless Pantheon",
					"chromas": false
				},
				{
					"id": "80003",
					"num": 3,
					"name": "Perseus Pantheon",
					"chromas": false
				},
				{
					"id": "80004",
					"num": 4,
					"name": "Full Metal Pantheon",
					"chromas": false
				},
				{
					"id": "80005",
					"num": 5,
					"name": "Glaive Warrior Pantheon",
					"chromas": false
				},
				{
					"id": "80006",
					"num": 6,
					"name": "Dragonslayer Pantheon",
					"chromas": true
				},
				{
					"id": "80007",
					"num": 7,
					"name": "Slayer Pantheon",
					"chromas": false
				},
				{
					"id": "80008",
					"num": 8,
					"name": "Baker Pantheon",
					"chromas": false
				}
			],
			"lore": "The peerless warrior known as Pantheon is a nigh-unstoppable paragon of battle. He was born among the Rakkor, a warlike people living on the flanks of Mount Targon, and after climbing the mountain's treacherous peak and being deemed worthy, he was chosen to become the earthly incarnation of the celestial Aspect of War. Imbued with inhuman power, he relentlessly seeks the enemies of Targon, leaving only corpses in his wake.",
			"blurb": "The peerless warrior known as Pantheon is a nigh-unstoppable paragon of battle. He was born among the Rakkor, a warlike people living on the flanks of Mount Targon, and after climbing the mountain's treacherous peak and being deemed worthy, he was...",
			"allytips": [
				"Using Aegis of Zeonia quickly followed by Heartseeker Strike can devastate your enemies.",
				"Using Spear Shot frequently in a battle, along with Attack Speed items, can help defensively by charging Aegis Protection.",
				"Using Grand Skyfall to assist your allies across the map can quickly turn the tides of battle, putting your allies at an advantage."
			],
			"enemytips": [
				"Keeping yourself hidden in brush can make it harder for Pantheon to target you with Grand Skyfall.",
				"Watch out for when Pantheon has a stunning or snaring partner in lane with him (example: Morgana, Sion) as he can cause devastating damage with his Heartseeker Strike.",
				"Pantheon's Aegis Protection shield will block a single champion basic attack or turret shot, but he's vulnerable until he brings it back up again by attacking or using abilities."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 4,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 579.16,
				"hpperlevel": 87,
				"mp": 317.12,
				"mpperlevel": 31,
				"movespeed": 355,
				"armor": 37,
				"armorperlevel": 3.9,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 150,
				"hpregen": 8,
				"hpregenperlevel": 0.65,
				"mpregen": 7.356,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 2.9,
				"attackspeedoffset": -0.03,
				"attackspeedperlevel": 2.95
			},
			"spells": [
				{
					"id": "PantheonQ",
					"name": "Spear Shot",
					"description": "Pantheon hurls his spear at an opponent, dealing damage.",
					"tooltip": "Pantheon hurls his spear at an opponent, dealing {{ e2 }} <scaleAD>(+{{ f1 }})</scaleAD> physical damage. ",
					"leveltip": {
						"label": [
							"Base Damage"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							100,
							115,
							130,
							145,
							160
						],
						[
							75,
							110,
							155,
							195,
							235
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/115/130/145/160",
						"75/110/155/195/235",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.4,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "PantheonQ.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PantheonW",
					"name": "Aegis of Zeonia",
					"description": "Pantheon leaps at an enemy and bashes them with his shield, stunning them. After finishing the attack, Pantheon readies himself to block the next attack.",
					"tooltip": "Pantheon leaps at target enemy, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage and stunning them for {{ e2 }} second. Pantheon also instantly refreshes his Aegis Protection.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						55,
						55,
						55,
						55,
						55
					],
					"costBurn": "55",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "PantheonW.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PantheonE",
					"name": "Heartseeker Strike",
					"description": "Pantheon focuses and unleashes 3 swift strikes to the area in front of him dealing damage to all enemies. Pantheon also becomes more aware of his enemy's vital spots, allowing him to always crit enemies below 15% Health.",
					"tooltip": "<spellPassive>Passive: </spellPassive>Pantheon's basic attacks and Spear Shot gain 100% critical strike chance against targets below {{ e3 }}% Health.<br /><br /><spellActive>Active: </spellActive>Pantheon focuses and delivers {{ e4 }} swift strikes in front of him for a total of {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage (deals {{ e2 }}% damage to minions and monsters).<br /><br />Damage per Strike: <totalValue>{{ f1 }}</totalValue>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/150/200/250/300",
						"60",
						"15",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 3,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "PantheonE.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PantheonRJump",
					"name": "Grand Skyfall",
					"description": "Pantheon composes himself then leaps into the air to a target, striking all enemy units in an area. Enemies closer to the impact point take more damage.",
					"tooltip": "Pantheon gathers his strength and then leaps high into the air, crashing down at target area a few seconds later. Deals up to {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to enemies at the center (down to {{ e6 }}% at the edge) and slows their Movement Speed by {{ e4 }}% for 1 second.<br /><br />If Pantheon cancels this channel, Grand Skyfall is put on a {{ e5 }} second cooldown.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						150,
						135,
						120
					],
					"cooldownBurn": "150/135/120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							400,
							700,
							1000
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							35,
							35,
							35
						],
						[
							30,
							30,
							30
						],
						[
							50,
							50,
							50
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"400/700/1000",
						"0",
						"0",
						"35",
						"30",
						"50",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						5500,
						5500,
						5500
					],
					"rangeBurn": "5500",
					"image": {
						"full": "PantheonRJump.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Aegis Protection",
				"description": "After attacking or casting spells 4 times, Pantheon will block the next incoming basic attack or turret attack.",
				"image": {
					"full": "Pantheon_AOZ.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Pantheon",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "3044",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3044",
									"count": 1
								},
								{
									"id": "3057",
									"count": 1
								},
								{
									"id": "3086",
									"count": 1
								},
								{
									"id": "3078",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3071",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3035",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Pantheon",
					"title": "PantheonTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Poppy": {
			"id": "Poppy",
			"key": "78",
			"name": "Poppy",
			"title": "Keeper of the Hammer",
			"image": {
				"full": "Poppy.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 192,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "78000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "78001",
					"num": 1,
					"name": "Noxus Poppy",
					"chromas": false
				},
				{
					"id": "78002",
					"num": 2,
					"name": "Lollipoppy",
					"chromas": false
				},
				{
					"id": "78003",
					"num": 3,
					"name": "Blacksmith Poppy",
					"chromas": false
				},
				{
					"id": "78004",
					"num": 4,
					"name": "Ragdoll Poppy",
					"chromas": false
				},
				{
					"id": "78005",
					"num": 5,
					"name": "Battle Regalia Poppy",
					"chromas": true
				},
				{
					"id": "78006",
					"num": 6,
					"name": "Scarlet Hammer Poppy",
					"chromas": false
				},
				{
					"id": "78007",
					"num": 7,
					"name": "Star Guardian Poppy",
					"chromas": false
				},
				{
					"id": "78014",
					"num": 14,
					"name": "Snow Fawn Poppy",
					"chromas": false
				}
			],
			"lore": "Runeterra has no shortage of valiant champions, but few are as tenacious as Poppy. Bearing the legendary hammer of Orlon, a weapon twice her size, this determined yordle has spent untold years searching in secret for the fabled “Hero of Demacia,” said to be its rightful wielder. Until then, she dutifully charges into battle, pushing back the kingdom's enemies with every whirling strike.",
			"blurb": "Runeterra has no shortage of valiant champions, but few are as tenacious as Poppy. Bearing the legendary hammer of Orlon, a weapon twice her size, this determined yordle has spent untold years searching in secret for the fabled “Hero of Demacia,” said...",
			"allytips": [
				"Iron Ambassador tends to land near walls, try to take advantage of this with Heroic Charge.",
				"Keeper's Verdict can be released immediately to send the enemy straight up, take advantage of this in duels."
			],
			"enemytips": [
				"Poppy can stop nearby enemies from dashing with Steadfast Presence.",
				"When Poppy starts to spin her hammer, she is charging Keeper's Verdict.",
				"You can step on Poppy's shield to deny it from her."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 7,
				"magic": 2,
				"difficulty": 6
			},
			"stats": {
				"hp": 540,
				"hpperlevel": 90,
				"mp": 280,
				"mpperlevel": 40,
				"movespeed": 345,
				"armor": 38,
				"armorperlevel": 3.5,
				"spellblock": 32,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.8,
				"mpregen": 7,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 4,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "PoppyQ",
					"name": "Hammer Shock",
					"description": "Poppy swings her hammer, dealing damage and creating a zone that will slow enemies and explode after a delay.",
					"tooltip": "Poppy smashes the ground, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> plus {{ e5 }}% of the enemies' maximum Health as physical damage, and leaving an unstable area.<br /><br />The area slows enemies inside it by {{ e3 }}% and erupts after {{ e4 }} second, dealing the initial damage again.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						35,
						40,
						45,
						50,
						55
					],
					"costBurn": "35/40/45/50/55",
					"effect": [
						null,
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/60/80/100/120",
						"0.5",
						"20/25/30/35/40",
						"1",
						"8",
						"40/60/80/100/120",
						"100",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						430,
						430,
						430,
						430,
						430
					],
					"rangeBurn": "430",
					"image": {
						"full": "PoppyQ.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PoppyW",
					"name": "Steadfast Presence",
					"description": "Poppy passively gains Armor and Magic Resist. This bonus increases when she is low on Health. Poppy can activate Steadfast Presence to stop enemy dashes around her and gain movement speed.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Poppy gains <span class=\"colorFFFF00\">{{ f1 }}</span> Armor and <span class=\"colorFF00FF\">{{ f2 }}</span> Magic Resist ({{ e3 }}% of Armor and Magic Resist). This bonus is doubled if Poppy is below 40% Health.<br /><br /><span class=\"colorFF9900\">Active:</span> For the next {{ e1 }} seconds, Poppy gains {{ e2 }}% Movement Speed. While Steadfast Presence is active, she stops enemy dashes in an area around her, dealing {{ e5 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Movement Speed",
							"Cooldown",
							"Damage"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e5 }} -> {{ e5NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						22,
						20,
						18,
						16
					],
					"cooldownBurn": "24/22/20/18/16",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							32,
							34,
							36,
							38,
							40
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2.5",
						"32/34/36/38/40",
						"15",
						"0.5",
						"70/110/150/190/230",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "PoppyW.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PoppyE",
					"name": "Heroic Charge",
					"description": "Poppy dashes to the target and pushes it back. If the target is pushed into a wall, it is stunned.",
					"tooltip": "Poppy tackles an enemy, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and carrying them forward. If Poppy carries the target into terrain, the enemy takes {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> additional physical damage and is stunned for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Initial Damage",
							"Wall Damage",
							"Stun Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							1.6,
							1.7,
							1.8,
							1.9,
							2
						],
						[
							1800,
							1800,
							1800,
							1800,
							1800
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/80/100/120/140",
						"60/80/100/120/140",
						"1.6/1.7/1.8/1.9/2",
						"1800",
						"400",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						425,
						425,
						425,
						425,
						425
					],
					"rangeBurn": "425",
					"image": {
						"full": "PoppyE.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PoppyR",
					"name": "Keeper's Verdict",
					"description": "Poppy channels a hammer strike that knocks enemies very far away.",
					"tooltip": "<span class=\"colorFF9900\">First Cast:</span> Poppy channels for up to {{ e3 }} seconds, slowing herself by {{ e7 }}%.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Poppy smashes the ground, emanating a shockwave that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to enemies around the first champion hit and knocking them a large distance toward their Summoning Platform. The shockwave length and knockback distance increases with channel duration.<br /><br />Enemies hit with an uncharged Keeper's Verdict will take half the damage and be knocked straight into the air for half the duration. Enemies are untargetable while they are being knocked away.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						120,
						100
					],
					"cooldownBurn": "140/120/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							200,
							300,
							400
						],
						[
							0.25,
							0.25,
							0.25
						],
						[
							4,
							4,
							4
						],
						[
							2400,
							2400,
							2400
						],
						[
							2,
							2,
							2
						],
						[
							1,
							1,
							1
						],
						[
							15,
							15,
							15
						],
						[
							30,
							30,
							30
						],
						[
							1,
							1,
							1
						],
						[
							0.5,
							0.5,
							0.5
						]
					],
					"effectBurn": [
						null,
						"200/300/400",
						"0.25",
						"4",
						"2400",
						"2",
						"1",
						"15",
						"30",
						"1",
						"0.5"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "PoppyR.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Iron Ambassador",
				"description": "<mainText>Poppy throws her buckler, gaining range and bonus magic damage.<br><br>The buckler lands at a nearby location and Poppy can pick it up to gain a shield. Enemies can step on the buckler to destroy it.</mainText>",
				"image": {
					"full": "Poppy_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Poppy",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppyARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppyCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppyFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppyKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppySG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppySIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppySR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Poppy",
					"title": "PoppyTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Quinn": {
			"id": "Quinn",
			"key": "133",
			"name": "Quinn",
			"title": "Demacia's Wings",
			"image": {
				"full": "Quinn.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 240,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "133000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "133001",
					"num": 1,
					"name": "Phoenix Quinn",
					"chromas": false
				},
				{
					"id": "133002",
					"num": 2,
					"name": "Woad Scout Quinn",
					"chromas": false
				},
				{
					"id": "133003",
					"num": 3,
					"name": "Corsair Quinn",
					"chromas": false
				},
				{
					"id": "133004",
					"num": 4,
					"name": "Heartseeker Quinn",
					"chromas": false
				}
			],
			"lore": "Quinn is an elite ranger-knight of Demacia, who undertakes dangerous missions deep in enemy territory. She and her legendary eagle, Valor, share an unbreakable bond, and their foes are often slain before they realize they are fighting not one, but two of the kingdom's greatest heroes. Nimble and acrobatic when required, Quinn takes aim with her crossbow while Valor marks their elusive targets from above, making them a deadly pair on the battlefield.",
			"blurb": "Quinn is an elite ranger-knight of Demacia, who undertakes dangerous missions deep in enemy territory. She and her legendary eagle, Valor, share an unbreakable bond, and their foes are often slain before they realize they are fighting not one, but two...",
			"allytips": [
				"Attacking a ",
				"Vulnerable",
				" target marked by Valor will put Harrier on cooldown. Quickly consuming Harrier marks will allow you to generate them faster.",
				"Vault is powerful but must be used with caution, as enemies can attack Quinn when she strikes them. Vault can sometimes be used to cross terrain if your back is to a wall.",
				"Use Behind Enemy Lines for traveling very long distances quickly, for farming minions around the map, or for chasing wounded targets."
			],
			"enemytips": [
				"After being marked, move away from Quinn so she can't take advantage of it.",
				"Keep tabs on Quinn's position. Behind Enemy Lines can enable Valor to cross the map very quickly and attack you by surprise.",
				"When Quinn is using Behind Enemy Lines, damaging her will end the effect."
			],
			"tags": [
				"Marksman",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 4,
				"magic": 2,
				"difficulty": 5
			},
			"stats": {
				"hp": 532.8,
				"hpperlevel": 85,
				"mp": 268.8,
				"mpperlevel": 35,
				"movespeed": 335,
				"armor": 32,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6.972,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 62,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": -0.065,
				"attackspeedperlevel": 3.1
			},
			"spells": [
				{
					"id": "QuinnQ",
					"name": "Blinding Assault",
					"description": "Quinn calls Valor to mark an enemy and hinder its vision before damaging all enemies in the immediate area.",
					"tooltip": "Valor flies in a line, marking the first enemy he hits as <span class=\"colorFFF673\">Vulnerable</span> and reducing its vision radius dramatically for {{ e3 }} seconds. He then deals {{ e1 }} <scaleAD>(+{{ f2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> physical damage to all nearby enemies.<br /><br />If the primary target is not a champion, it cannot attack for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Total Attack Damage Ratio",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10.5,
						10,
						9.5,
						9
					],
					"cooldownBurn": "11/10.5/10/9.5/9",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							20,
							45,
							70,
							95,
							120
						],
						[
							-1000,
							-1000,
							-1000,
							-1000,
							-1000
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0.8,
							0.9,
							1,
							1.1,
							1.2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/45/70/95/120",
						"-1000",
						"1.5",
						"0.8/0.9/1/1.1/1.2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1025,
						1025,
						1025,
						1025,
						1025
					],
					"rangeBurn": "1025",
					"image": {
						"full": "QuinnQ.png",
						"sprite": "spell8.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "QuinnW",
					"name": "Heightened Senses",
					"description": "Passively grants Quinn Attack Speed and Movement Speed after she attacks a <font color='#FFF673'>Vulnerable</font> target. Activate to have Valor reveal a large area nearby.",
					"tooltip": "<spellPassive>Passive:</spellPassive> Attacking a <span class=\"colorFFF673\">Vulnerable</span> target increases Quinn's Attack Speed by {{ e2 }}% and Movement Speed by {{ e3 }}% for {{ e1 }} seconds.<br /><br /><spellActive>Active:</spellActive> Valor reveals a large area nearby for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Attack Speed Bonus",
							"Movement Speed Bonus",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						50,
						45,
						40,
						35,
						30
					],
					"cooldownBurn": "50/45/40/35/30",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							20,
							35,
							50,
							65,
							80
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							2100,
							2100,
							2100,
							2100,
							2100
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2",
						"20/35/50/65/80",
						"20/25/30/35/40",
						"2100",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						2100,
						2100,
						2100,
						2100,
						2100
					],
					"rangeBurn": "2100",
					"image": {
						"full": "QuinnW.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "QuinnE",
					"name": "Vault",
					"description": "Quinn dashes to an enemy, dealing physical damage and slowing the target's Movement Speed. Upon reaching the target, she leaps off the target, briefly interrupting it, and lands near her maximum Attack Range away from the target.",
					"tooltip": "Quinn dashes to an enemy, dealing {{ e2 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage while Valor marks it as <span class=\"colorFFF673\">Vulnerable</span>.<br /><br />Upon reaching the target, Quinn leaps off, briefly displacing and slowing it by {{ e1 }}% (diminishing over {{ e3 }} seconds).",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50",
						"40/70/100/130/160",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						675,
						675,
						675,
						675,
						675
					],
					"rangeBurn": "675",
					"image": {
						"full": "QuinnE.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "QuinnR",
					"name": "Behind Enemy Lines",
					"description": "Quinn and Valor team up to fly around at great speed.",
					"tooltip": "Quinn calls down Valor to assist her. After a 2 second channel, they unite, gaining {{ e3 }}% Total Movement Speed and the ability to cast Skystrike by recasting this ability or taking offensive action. Skystrike damages nearby enemies.<br /><br />Taking champion or turret damage puts Behind Enemy Lines on a 3 second cooldown.",
					"leveltip": {
						"label": [
							"Movement Speed Bonus",
							"Mana Cost"
						],
						"effect": [
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e7 }} -> {{ e7NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						3,
						3,
						3
					],
					"cooldownBurn": "3",
					"cost": [
						100,
						50,
						0
					],
					"costBurn": "100/50/0",
					"effect": [
						null,
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							70,
							100,
							130
						],
						[
							25000,
							25000,
							25000
						],
						[
							0,
							0,
							0
						],
						[
							8,
							8,
							8
						],
						[
							100,
							50,
							0
						],
						[
							0.4,
							0.4,
							0.4
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"0",
						"70/100/130",
						"25000",
						"0",
						"8",
						"100/50/0",
						"0.4",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "QuinnR.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Harrier",
				"description": "Valor periodically marks enemies as <font color='#FFF673'>Vulnerable</font>. Quinn's first basic attack against <font color='#FFF673'>Vulnerable</font> targets will deal bonus physical damage.",
				"image": {
					"full": "Quinn_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Quinn",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Quinn",
					"title": "QuinnTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Rakan": {
			"id": "Rakan",
			"key": "497",
			"name": "Rakan",
			"title": "The Charmer",
			"image": {
				"full": "Rakan.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 288,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "497000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "497001",
					"num": 1,
					"name": "Cosmic Dawn Rakan",
					"chromas": false
				},
				{
					"id": "497002",
					"num": 2,
					"name": "Sweetheart Rakan",
					"chromas": false
				}
			],
			"lore": "As mercurial as he is charming, Rakan is an infamous vastayan troublemaker and the greatest battle-dancer in Lhotlan tribal history. To the humans of the Ionian highlands, his name has long been synonymous with wild festivals, uncontrollable parties, and anarchic music. Few would suspect this energetic, traveling showman is also partner to the rebel Xayah, and is dedicated to her cause.",
			"blurb": "As mercurial as he is charming, Rakan is an infamous vastayan troublemaker and the greatest battle-dancer in Lhotlan tribal history. To the humans of the Ionian highlands, his name has long been synonymous with wild festivals, uncontrollable parties...",
			"allytips": [
				"Rakan requires allies near him to make the most out of his tools.",
				"Rakan's dash speeds increase with his movement speed. Use the extra speed to surprise your enemies!",
				"Danger is as fun as you let it be."
			],
			"enemytips": [
				"Rakan's movement abilities forecast their destination. Try to use this to your advantage.",
				"Champions with crowd control that can be applied quickly excel against Rakan.",
				"Catching Rakan with no allies around severely inhibits his mobility. Try to find him alone."
			],
			"tags": [
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 4,
				"magic": 8,
				"difficulty": 5
			},
			"stats": {
				"hp": 510,
				"hpperlevel": 85,
				"mp": 315,
				"mpperlevel": 50,
				"movespeed": 335,
				"armor": 36,
				"armorperlevel": 3.9,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 300,
				"hpregen": 5,
				"hpregenperlevel": 0.5,
				"mpregen": 8.75,
				"mpregenperlevel": 0.5,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 70,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "RakanQ",
					"name": "Gleaming Quill",
					"description": "Flings a magical feather that deals magic damage. Striking a champion or epic monster enables Rakan to heal his allies.",
					"tooltip": "Flings a magical feather that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy hit.<br /><br />If the feather hits a champion or epic monster, Rakan restores <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a2 }})</span> health to himself and nearby allies after {{ e4 }} seconds or when he touches an ally.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f3 }} -> {{ f2 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							7.5,
							7.5,
							7.5,
							7.5,
							7.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							12,
							10.5,
							9,
							7.5,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"15",
						"7.5",
						"3",
						"12/10.5/9/7.5/6",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "RakanQ.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RakanW",
					"name": "Grand Entrance",
					"description": "Dashes to a location, knocking up nearby enemies on arrival.",
					"tooltip": "Dashes to a location. Upon arrival Rakan spirals into the air, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and knocking up enemies for {{ e3 }} second.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16.5,
						15,
						13.5,
						12
					],
					"cooldownBurn": "18/16.5/15/13.5/12",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							2050,
							2050,
							2050,
							2050,
							2050
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.3,
							0.3,
							0.3,
							0.3,
							0.3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"2050",
						"1",
						"0.3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "RakanW.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RakanE",
					"name": "Battle Dance",
					"description": "Flies to an allied champion granting them a shield. Can be re-cast for free for a short duration.",
					"tooltip": "Flies to an allied champion, granting them a {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health shield for {{ e3 }} seconds.<br /><br />Can be re-cast at no cost once within {{ e2 }} seconds.<br /><br /><span class=\"colore5c100\">Battle Dance's cast range is increased when cast on Xayah.</span></i>",
					"leveltip": {
						"label": [
							"Shield Health",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f2 }} -> {{ f6 }}",
							"{{ e5 }} -> {{ e5NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							20,
							18,
							16,
							14,
							12
						],
						[
							60,
							70,
							80,
							90,
							100
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							1150,
							1150,
							1150,
							1150,
							1150
						],
						[
							1250,
							1250,
							1250,
							1250,
							1250
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"5",
						"3",
						"20/18/16/14/12",
						"60/70/80/90/100",
						"600",
						"1000",
						"1150",
						"1250",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "RakanE.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RakanR",
					"name": "The Quickness",
					"description": "Gains movement speed, charming and dealing magic damage to enemies touched.",
					"tooltip": "Gain {{ e5 }}% movement speed for {{ e2 }} seconds.<br /><br />Touching enemies deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and charms them for {{ e3 }} second(s) the first time they're hit. The first champion charmed grants Rakan {{ e6 }}% decaying movement speed.",
					"leveltip": {
						"label": [
							"Charm Duration",
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							200,
							300
						],
						[
							4,
							4,
							4
						],
						[
							1,
							1.25,
							1.5
						],
						[
							0.25,
							0.25,
							0.25
						],
						[
							50,
							50,
							50
						],
						[
							150,
							150,
							150
						],
						[
							150,
							150,
							150
						],
						[
							120,
							100,
							80
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/200/300",
						"4",
						"1/1.25/1.5",
						"0.25",
						"50",
						"150",
						"150",
						"120/100/80",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						200,
						200,
						200
					],
					"rangeBurn": "200",
					"image": {
						"full": "RakanR.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Fey Feathers",
				"description": "Rakan periodically gains a shield.",
				"image": {
					"full": "Rakan_P.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Rakan",
					"title": "Beginner",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rakan",
					"title": "RakanARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rakan",
					"title": "RakanCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rakan",
					"title": "RakanKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rakan",
					"title": "RakanSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rakan",
					"title": "RakanSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rakan",
					"title": "RakanTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Rammus": {
			"id": "Rammus",
			"key": "33",
			"name": "Rammus",
			"title": "the Armordillo",
			"image": {
				"full": "Rammus.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 336,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "33000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "33001",
					"num": 1,
					"name": "King Rammus",
					"chromas": false
				},
				{
					"id": "33002",
					"num": 2,
					"name": "Chrome Rammus",
					"chromas": false
				},
				{
					"id": "33003",
					"num": 3,
					"name": "Molten Rammus",
					"chromas": false
				},
				{
					"id": "33004",
					"num": 4,
					"name": "Freljord Rammus",
					"chromas": false
				},
				{
					"id": "33005",
					"num": 5,
					"name": "Ninja Rammus",
					"chromas": false
				},
				{
					"id": "33006",
					"num": 6,
					"name": "Full Metal Rammus",
					"chromas": false
				},
				{
					"id": "33007",
					"num": 7,
					"name": "Guardian of the Sands Rammus",
					"chromas": false
				}
			],
			"lore": "Idolized by many, dismissed by some, mystifying to all, the curious being Rammus is an enigma. Protected by a spiked shell, he inspires increasingly disparate theories on his origin wherever he goes—from demigod, to sacred oracle, to a mere beast transformed by magic. Whatever the truth may be, Rammus keeps his own counsel and stops for no one as he roams the Shuriman desert.",
			"blurb": "Idolized by many, dismissed by some, mystifying to all, the curious being Rammus is an enigma. Protected by a spiked shell, he inspires increasingly disparate theories on his origin wherever he goes—from demigod, to sacred oracle, to a mere beast...",
			"allytips": [
				"Powerball can be used as an effective escape mechanism.",
				"Using taunt on a champion by your tower can cause the tower to attack your enemy.",
				"Tremors and Defensive Ball Curl can be used late in the game to obliterate towers. If you're bogged down in a team fight, it is often valuable to break off and attack the buildings."
			],
			"enemytips": [
				"Pay particular attention to when his Defensive Ball Curl is off. Rammus has much lower stats than a normal tank when he's out of the stance.",
				"Rammus often stacks high Armor, leaving him especially vulnerable to caster damage while not in Defensive Ball Curl."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 10,
				"magic": 5,
				"difficulty": 5
			},
			"stats": {
				"hp": 564.48,
				"hpperlevel": 86,
				"mp": 310.44,
				"mpperlevel": 33,
				"movespeed": 335,
				"armor": 36,
				"armorperlevel": 4.3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.55,
				"mpregen": 7.84,
				"mpregenperlevel": 0.5,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55.88,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.215
			},
			"spells": [
				{
					"id": "PowerBall",
					"name": "Powerball",
					"description": "Rammus accelerates in a ball towards his enemies, dealing damage and slowing targets affected by the impact.",
					"tooltip": "Rammus accelerates in a ball, gaining up to <span class=\"colorFFFFFF\">{{ f2 }}%</span> Movement Speed over {{ e4 }} seconds. On enemy collision, he stops, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies, knocking them back, and slowing them by {{ e2 }}% for {{ e3 }} second.<br /><br /><rules><span class=\"color8c8c8c\">Can be reactivated to end the effect early and put Powerball on cooldown.<br />Powerball is a channeled spell and is subject to interruption by spells that prevent casting.<br />Casting Powerball cancels Defensive Ball Curl and puts it on cooldown.</span></rules>",
					"leveltip": {
						"label": [
							"Damage ",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						13.5,
						11,
						8.5,
						6
					],
					"cooldownBurn": "16/13.5/11/8.5/6",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							100,
							135,
							170,
							205,
							240
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							125,
							125,
							125,
							125,
							125
						],
						[
							0.35,
							0.35,
							0.35,
							0.35,
							0.35
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						]
					],
					"effectBurn": [
						null,
						"100/135/170/205/240",
						"40/50/60/70/80",
						"1",
						"6",
						"125",
						"0.35",
						"25",
						"0.25",
						"50",
						"1000"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "PowerBall.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "DefensiveBallCurl",
					"name": "Defensive Ball Curl",
					"description": "Rammus goes into a defensive formation, vastly increasing his Armor and Magic Resistance, amplifying Spiked Shells' damage, and returning damage to enemies that basic attack him, but he is also slowed during this time.",
					"tooltip": "Rammus enters a defensive formation for up to {{ e3 }} seconds, increasing Armor by {{ e1 }} plus {{ e6 }}% <span class=\"colorFFFF00\">({{ f1 }})</span> and Magic Resist by {{ e8 }} plus {{ e7 }}% <span class=\"colorFF00FF\">({{ f2 }})</span> but becoming slowed by {{ e5 }}%.<br /><br />During this time, Spiked Shell deals {{ e4 }}% damage and also deals its damage to enemies that basic attack Rammus.<br /><br /><rules><span class=\"color8c8c8c\">Can be reactivated to end the effect early and put Defensive Ball Curl on cooldown.<br />Casting Defensive Ball Curl cancels Powerball and puts it on cooldown.</span></rules>",
					"leveltip": {
						"label": [
							"Percent Armor Bonus",
							"Percent Magic Resist Bonus"
						],
						"effect": [
							"{{ e6 }}% -> {{ e6NL }}%",
							"{{ e7 }}% -> {{ e7NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							25,
							35,
							45,
							55,
							65
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							50,
							60,
							70,
							80,
							90
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20",
						"25/35/45/55/65",
						"6",
						"150",
						"30",
						"50/60/70/80/90",
						"25/30/35/40/45",
						"10",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "armor",
							"coeff": 0.1,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "DefensiveBallCurl.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PuncturingTaunt",
					"name": "Frenzying Taunt",
					"description": "Rammus taunts an enemy champion or monster into a reckless assault against him. Additionally, he gains increased Attack Speed for a short time, but this bonus is extended by having any of his other spells active.",
					"tooltip": "Taunt an enemy champion or monster for {{ e1 }} seconds and gain {{ e2 }}% Attack Speed for the same duration.<br /><br />While any of Rammus' other spells are active, Frenzying Taunt's Attack Speed bonus is refreshed.",
					"leveltip": {
						"label": [
							"Duration",
							"Attack Speed Bonus"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							1.25,
							1.5,
							1.75,
							2,
							2.25
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.25/1.5/1.75/2/2.25",
						"20/25/30/35/40",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "PuncturingTaunt.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Tremors2",
					"name": "Tremors",
					"description": "Rammus creates waves of destruction pulsing through the ground, causing damage to nearby enemies and slowing them. Turrets take double damage from Tremors.",
					"tooltip": "Shake the earth for {{ e2 }} seconds, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and slowing them by {{ e4 }}% for {{ e3 }} seconds, stacking up to {{ e6 }} times.<br /><br />Tremors deals {{ e5 }}% damage to turrets.",
					"leveltip": {
						"label": [
							"Damage per Tremor",
							"Slow per Tremor",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						80,
						60
					],
					"cooldownBurn": "100/80/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							40,
							80,
							120
						],
						[
							7,
							7,
							7
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							8,
							10,
							12
						],
						[
							200,
							200,
							200
						],
						[
							8,
							8,
							8
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/80/120",
						"7",
						"1.5",
						"8/10/12",
						"200",
						"8",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						375,
						375,
						375
					],
					"rangeBurn": "375",
					"image": {
						"full": "Tremors2.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Spiked Shell",
				"description": "Rammus' basic attacks deal bonus magic damage, scaling with his Armor.",
				"image": {
					"full": "Armordillo_ScavengeArmor.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Rammus",
					"title": "RammusARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rammus",
					"title": "RammusCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rammus",
					"title": "RammusFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3711",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rammus",
					"title": "RammusKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rammus",
					"title": "RammusSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rammus",
					"title": "RammusSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rammus",
					"title": "RammusTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"RekSai": {
			"id": "RekSai",
			"key": "421",
			"name": "Rek'Sai",
			"title": "the Void Burrower",
			"image": {
				"full": "RekSai.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 384,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "421000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "421001",
					"num": 1,
					"name": "Eternum Rek'Sai",
					"chromas": false
				},
				{
					"id": "421002",
					"num": 2,
					"name": "Pool Party Rek'Sai",
					"chromas": false
				}
			],
			"lore": "An apex predator, Rek'Sai is a merciless Void-spawn that tunnels beneath the ground to ambush and devour unsuspecting prey. Her insatiable hunger has laid waste to entire regions of the once-great empire of Shurima—merchants, traders, even armed caravans, will go hundreds of miles out of their way to avoid her and her offspring's hunting grounds. All know that once Rek'Sai is seen on the horizon, death from below is all but guaranteed.",
			"blurb": "An apex predator, Rek'Sai is a merciless Void-spawn that tunnels beneath the ground to ambush and devour unsuspecting prey. Her insatiable hunger has laid waste to entire regions of the once-great empire of Shurima—merchants, traders, even armed...",
			"allytips": [
				"Keeping tunnels spread out across the map will ensure you have choices when you want to cast Void Rush.",
				"Cast Burrow before travelling around the map to take advantage of the increased Movement Speed and the safety provided by Tremor Sense.",
				"Tremor Sense can warn you of enemies closing in, and is particularly useful when entering enemy territory."
			],
			"enemytips": [
				"If you see one of Rek'Sai's tunnels, briefly stand on one of the entrances to destroy it.",
				"Rek'Sai's Furious Bite gains damage as she builds Fury. Be very careful around her when her Fury is full.",
				"When Rek'Sai is near, she can see the position of you and your allies, but only if you're moving."
			],
			"tags": [
				"Fighter"
			],
			"partype": "Fury",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 2,
				"difficulty": 3
			},
			"stats": {
				"hp": 570,
				"hpperlevel": 85,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 335,
				"armor": 33,
				"armorperlevel": 3.75,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 7.5,
				"hpregenperlevel": 0.65,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65.5,
				"attackdamageperlevel": 3.35,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "RekSaiQ",
					"name": "Queen's Wrath / Prey Seeker",
					"description": "Rek'Sai's next 3 basic attacks deal bonus Physical Damage to nearby enemies.<br><br>While Burrowed, Rek'Sai launches a burst of void-charged earth that deals Physical Damage and reveals enemies hit.",
					"tooltip": "<span class=\"colorFF8C00\">Un-Burrowed:</span> Rek'Sai's next 3 basic attacks within 5 seconds deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> bonus Physical Damage to nearby enemies.<br /><br /><span class=\"colorFF8C00\">Burrowed:</span> Rek'Sai launches a burst of void-charged earth that explodes on first enemy hit, dealing {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage and revealing non-stealthed enemies for {{ e6 }} seconds.",
					"leveltip": {
						"label": [
							"Queen's Wrath Damage",
							"Prey Seeker Damage",
							"Prey Seeker Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e5 }} -> {{ e5NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							11,
							10,
							9,
							8,
							7
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/25/30/35/40",
						"0",
						"0",
						"60/90/120/150/180",
						"11/10/9/8/7",
						"2.5",
						"5",
						"300",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a2"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "RekSaiQ.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "RekSaiW",
					"name": "Burrow / Un-burrow",
					"description": "Rek'Sai burrows into the ground, gaining new abilities and increased Movement Speed. Her vision range is reduced and she cannot use basic attacks.<br><br>While Burrowed, Rek'Sai may cast Un-burrow to knock up and damage nearby enemies.",
					"tooltip": "<span class=\"colorFF8C00\">Un-Burrowed:</span> Burrow into the ground. <br /><br /><span class=\"colorFF8C00\">Burrowed:</span> Un-burrow, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage and knocking up the closest enemy for {{ e5 }} second. All other nearby enemies will be knocked back. An enemy who has been knocked up will be immune from further Un-burrow effects for {{ e6 }} seconds.<br /><br /><span class=\"colorFF8C00\">Burrowed Effects:</span> New abilities, <span class=\"colorFFFFFF\">+{{ f1 }}</span> Movement Speed, reduced vision range, disabled basic attacks, and gains <span class=\"color993299\">Tremor Sense:</span> Nearby enemies that move in Fog of War have their position revealed to Rek'Sai and her allies.",
					"leveltip": {
						"label": [
							"Un-burrow Damage"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							1500,
							1500,
							1500,
							1500,
							1500
						],
						[
							55,
							70,
							85,
							100,
							115
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							175,
							175,
							175,
							175,
							175
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.3,
							0.3,
							0.3,
							0.3,
							0.3
						]
					],
					"effectBurn": [
						null,
						"1500",
						"55/70/85/100/115",
						"0",
						"0",
						"1",
						"10",
						"250",
						"175",
						"3",
						"0.3"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1650,
						1650,
						1650,
						1650,
						1650
					],
					"rangeBurn": "1650",
					"image": {
						"full": "RekSaiW.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "RekSaiE",
					"name": "Furious Bite / Tunnel",
					"description": "Rek'Sai bites her target, dealing double and True Damage if she has max Fury.<br><br>While Burrowed, Rek'Sai creates a re-usable, long lasting tunnel. Enemies can destroy it by standing on top of either entrance.",
					"tooltip": "<span class=\"colorFF8C00\">Un-Burrowed:</span> Rek'Sai bites a target dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> Physical Damage. At max Fury, the bite does 100% more and deals True Damage.<br /><br />Maximum Damage: <span class=\"colorFFFFFF\">{{ f2 }}</span><br /><br /><span class=\"colorFF8C00\">Burrowed:</span> Rek'Sai tunnels forward leaving two connected <span class=\"color993299\">Tunnel Entrances</span>. Clicking a <span class=\"color993299\">Tunnel Entrance</span> will make Rek'Sai dive to the other entrance.<br /><br /><span class=\"color993299\">Tunnel Entrances</span> last for {{ e5 }} minutes and can be destroyed by enemies. Rek'Sai may have {{ e6 }} tunnels at one time. Tunnels have a {{ e8 }} second cooldown on use.",
					"leveltip": {
						"label": [
							"Furious Bite Damage",
							"Tunnel Cast Cooldown",
							"Tunnel Use Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f4 }} -> {{ f5 }}",
							"{{ e8 }} -> {{ e8NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							55,
							65,
							75,
							85,
							95
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							10,
							8,
							6,
							4,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/65/75/85/95",
						"0",
						"12",
						"0",
						"10",
						"8",
						"0",
						"10/8/6/4/2",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.85,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						250,
						250,
						250,
						250,
						250
					],
					"rangeBurn": "250",
					"image": {
						"full": "RekSaiE.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "RekSaiRWrapper",
					"name": "Void Rush",
					"description": "Rek'Sai dives underground and leaps towards her target, dealing massive damage.",
					"tooltip": "<span class=\"colorFF8C00\">Passive:</span> Dealing damage to enemy Champions marks them for the next {{ e6 }} seconds.<br /><br /><span class=\"colorFF8C00\">Active:</span> Rek'Sai lets out a harrowing scream before burrowing underground seeking out a marked target. Moments later she leaps from underground, dealing {{ e8 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage plus {{ e9 }}% of their missing Health.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Missing Health Damage"
						],
						"effect": [
							"{{ e8 }} -> {{ e8NL }}",
							"{{ f7 }} -> {{ f8 }}",
							"{{ e9 }}% -> {{ e9NL }}%"
						]
					},
					"maxrank": 3,
					"cooldown": [
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							5,
							5,
							5
						],
						[
							0,
							0,
							0
						],
						[
							100,
							250,
							400
						],
						[
							20,
							25,
							30
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"0",
						"0",
						"0",
						"0",
						"5",
						"0",
						"100/250/400",
						"20/25/30",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.85,
							"key": "a2"
						}
					],
					"costType": "No cost",
					"maxammo": "-1",
					"range": [
						1500,
						1500,
						1500
					],
					"rangeBurn": "1500",
					"image": {
						"full": "RekSaiRWrapper.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No cost"
				}
			],
			"passive": {
				"name": "Fury of the Xer'Sai",
				"description": "While unburrowed Rek'Sai generates Fury with her basic attacks and spells. When burrowed Rek'Sai consumes Fury to heal herself.",
				"image": {
					"full": "RekSai_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "RekSai",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3052",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "RekSai",
					"title": "RekSaiTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Renekton": {
			"id": "Renekton",
			"key": "58",
			"name": "Renekton",
			"title": "the Butcher of the Sands",
			"image": {
				"full": "Renekton.png",
				"sprite": "champion2.png",
				"group": "champion",
				"x": 432,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "58000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "58001",
					"num": 1,
					"name": "Galactic Renekton",
					"chromas": false
				},
				{
					"id": "58002",
					"num": 2,
					"name": "Outback Renekton",
					"chromas": false
				},
				{
					"id": "58003",
					"num": 3,
					"name": "Bloodfury Renekton",
					"chromas": false
				},
				{
					"id": "58004",
					"num": 4,
					"name": "Rune Wars Renekton",
					"chromas": false
				},
				{
					"id": "58005",
					"num": 5,
					"name": "Scorched Earth Renekton",
					"chromas": false
				},
				{
					"id": "58006",
					"num": 6,
					"name": "Pool Party Renekton",
					"chromas": false
				},
				{
					"id": "58007",
					"num": 7,
					"name": "Prehistoric Renekton",
					"chromas": false
				},
				{
					"id": "58008",
					"num": 8,
					"name": "SKT T1 Renekton",
					"chromas": false
				},
				{
					"id": "58009",
					"num": 9,
					"name": "Renektoy",
					"chromas": false
				}
			],
			"lore": "Renekton is a terrifying, rage-fueled Ascended being from the scorched deserts of Shurima. Once, he was his empire's most esteemed warrior, leading the nation's armies to countless victories. However, after the empire's fall, Renekton was entombed beneath the sands, and slowly, as the world turned and changed, he succumbed to insanity. Now free once more, he is utterly consumed with finding and killing his brother, Nasus, who he blames, in his madness, for the centuries he spent in darkness.",
			"blurb": "Renekton is a terrifying, rage-fueled Ascended being from the scorched deserts of Shurima. Once, he was his empire's most esteemed warrior, leading the nation's armies to countless victories. However, after the empire's fall, Renekton was entombed...",
			"allytips": [
				"Slice and Dice excels at harassing maneuvers. Slice in, follow up with another skill and then Dice back out to safety.",
				"Cull the Meek drains an enormous amount of life when used in the middle of the fray. You can use this to bait opponents into thinking you are weaker than you really are.",
				"Cooldown reduction is especially good for Renekton, allowing him to both quickly build up and use his Fury."
			],
			"enemytips": [
				"Pay close attention to Renekton's Fury gauge as that will usually signify when he is about to attack.",
				"Keeping Renekton from being able to fight and gain Fury by continually harassing him will severely reduce the effectiveness of his abilities."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Fury",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 2,
				"difficulty": 3
			},
			"stats": {
				"hp": 572.16,
				"hpperlevel": 87,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 35,
				"armorperlevel": 3.8,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.75,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 69,
				"attackdamageperlevel": 3.75,
				"attackspeedoffset": -0.06,
				"attackspeedperlevel": 2.65
			},
			"spells": [
				{
					"id": "RenektonCleave",
					"name": "Cull the Meek",
					"description": "Renekton swings his blade, dealing moderate physical damage to all targets around him, and heals for a small portion of the damage dealt. If he has more than 50 Fury, his damage and heal are increased.",
					"tooltip": "Renekton swings his blade, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies and healing himself for {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> Health for each non-champion hit and {{ f2 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> Health for each champion hit, up to {{ e4 }} Health.<br /><br />He generates <span class=\"colorFF6633\">2.5 Fury</span> for each non-champion hit and <span class=\"colorFF6633\">10 Fury</span> for each champion hit, up to a maximum of <span class=\"colorFF6633\">30 Fury</span>.<br /><br /><span class=\"colorFF6633\">50 Fury Bonus:</span> Damage increased to {{ e6 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span>. Heal increased to {{ e7 }} <span class=\"colorFF8C00\">(+{{ f4 }})</span> per non-champion and {{ f5 }} <span class=\"colorFF8C00\">(+{{ f6 }})</span> per champion, up to {{ e9 }}. No longer generates <span class=\"colorFF6633\">Fury</span>.",
					"leveltip": {
						"label": [
							"Damage",
							"Max Health Gain",
							"Fury Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} / {{ e9 }} -> {{ e4NL }} / {{ e9NL }}",
							"{{ e6 }} -> {{ e6NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							65,
							100,
							135,
							170,
							205
						],
						[
							3,
							4.5,
							6,
							7.5,
							9
						],
						[
							0.04,
							0.04,
							0.04,
							0.04,
							0.04
						],
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							9,
							13.5,
							18,
							22.5,
							27
						],
						[
							0.12,
							0.12,
							0.12,
							0.12,
							0.12
						],
						[
							150,
							225,
							300,
							375,
							450
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/100/135/170/205",
						"3/4.5/6/7.5/9",
						"0.04",
						"50/75/100/125/150",
						"300",
						"100/150/200/250/300",
						"9/13.5/18/22.5/27",
						"0.12",
						"150/225/300/375/450",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "f2"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1.2,
							"key": "a2"
						}
					],
					"costType": "No Cost or 50 Fury",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "RenektonCleave.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost or 50 Fury"
				},
				{
					"id": "RenektonPreExecute",
					"name": "Ruthless Predator",
					"description": "Renekton slashes his target twice, dealing moderate physical damage and stuns them for 0.75 seconds. If Renekton has more than 50 Fury, he slashes his target three times, dealing high physical damage and stuns them for 1.5 seconds.",
					"tooltip": "Renekton's next attack strikes twice, stunning his target for {{ e3 }} seconds and dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage per hit ({{ e5 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> total).<br /><br />Each strike applies on-hit effects and generates <span class=\"colorFF6633\">Fury</span>. Hitting a champion generates an additional <span class=\"colorFF6633\">{{ e7 }} Fury</span>.<br /><br /><span class=\"colorFF6633\">50 Fury Bonus:</span> Renekton attacks three times, stunning his target for {{ e4 }} seconds and dealing a total of {{ e6 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> damage.  No longer generates <span class=\"colorFF6633\">Fury</span>.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} / {{ e6 }} -> {{ e5NL }} / {{ e6NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							5,
							15,
							25,
							35,
							45
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							10,
							30,
							50,
							70,
							90
						],
						[
							15,
							45,
							75,
							105,
							135
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5/15/25/35/45",
						"0.75",
						"0.75",
						"1.5",
						"10/30/50/70/90",
						"15/45/75/105/135",
						"10",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.5,
							"key": "f1"
						},
						{
							"link": "attackdamage",
							"coeff": 2.25,
							"key": "f2"
						}
					],
					"costType": "No Cost or 50 Fury",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "RenektonPreExecute.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost or 50 Fury"
				},
				{
					"id": "RenektonSliceAndDice",
					"name": "Slice and Dice",
					"description": "Renekton dashes, dealing damage to units along the way. Empowered, Renekton deals bonus damage and reduces the Armor of units hit.",
					"tooltip": "<span class=\"colorFF6633\">Slice:</span> Renekton dashes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to enemies he passes through. Hitting an enemy grants the ability to use Dice for {{ e8 }} seconds.<br /><br /><span class=\"colorFF6633\">Dice:</span> Renekton dashes, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to enemies he passes through.<br /><br />He generates <span class=\"colorFF6633\">{{ e4 }} Fury</span> for each non-champion hit and <span class=\"colorFF6633\">{{ e5 }} Fury</span> for each champion hit, up to a maximum of <span class=\"colorFF6633\">{{ e0 }} Fury</span>.<br /><br /><span class=\"colorFF6633\">Dice - 50 Fury Bonus:</span> Damage increased to {{ e3 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span>. Enemies hit have {{ e2 }}% reduced Armor for {{ e9 }} seconds. No longer generates <span class=\"colorFF6633\">Fury</span>.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Armor Reduction %",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0.9,
							0.9,
							0.9,
							0.9,
							0.9
						],
						[
							1.35,
							1.35,
							1.35,
							1.35,
							1.35
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							30,
							30,
							30,
							30,
							30
						]
					],
					"effectBurn": [
						null,
						"40/70/100/130/160",
						"15/20/25/30/35",
						"60/105/150/195/240",
						"2",
						"10",
						"0.9",
						"1.35",
						"4",
						"4",
						"30"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.9,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.9,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1.35,
							"key": "f2"
						}
					],
					"costType": "No Cost or 50 Fury",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "RenektonSliceAndDice.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost or 50 Fury"
				},
				{
					"id": "RenektonReignOfTheTyrant",
					"name": "Dominus",
					"description": "Renekton transforms into the Tyrant form, gaining bonus Health and dealing damage to enemies around him. While in this form, Renekton gains Fury periodically.",
					"tooltip": "Renekton surrounds himself with dark energies for {{ e5 }} seconds, gaining {{ e1 }} Health and <span class=\"colorFF6633\">{{ e6 }} Fury</span>. While active, he deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and gains <span class=\"colorFF6633\">{{ e4 }} Fury</span> per second.",
					"leveltip": {
						"label": [
							"Bonus Health",
							"Periodic Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						120,
						120
					],
					"cooldownBurn": "120",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							250,
							500,
							750
						],
						[
							40,
							80,
							120
						],
						[
							7.5,
							7.5,
							7.5
						],
						[
							5,
							5,
							5
						],
						[
							15,
							15,
							15
						],
						[
							20,
							20,
							20
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250/500/750",
						"40/80/120",
						"7.5",
						"5",
						"15",
						"20",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "RenektonReignOfTheTyrant.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Reign of Anger",
				"description": "Renekton gains Fury for every autoattack he makes. This Fury can empower his abilities with bonus effects. Additionally, Renekton gains bonus Fury when he is low on life.",
				"image": {
					"full": "Renekton_Passive.png",
					"sprite": "passive2.png",
					"group": "passive",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Renekton",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Renekton",
					"title": "RenektonTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Rengar": {
			"id": "Rengar",
			"key": "107",
			"name": "Rengar",
			"title": "the Pridestalker",
			"image": {
				"full": "Rengar.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 0,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "107000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "107001",
					"num": 1,
					"name": "Headhunter Rengar",
					"chromas": true
				},
				{
					"id": "107002",
					"num": 2,
					"name": "Night Hunter Rengar",
					"chromas": false
				},
				{
					"id": "107003",
					"num": 3,
					"name": "SSW Rengar",
					"chromas": false
				},
				{
					"id": "107008",
					"num": 8,
					"name": "Mecha Rengar",
					"chromas": true
				}
			],
			"lore": "Rengar is a ferocious vastayan trophy hunter who lives for the thrill of tracking down and killing dangerous creatures. He scours the world for the most fearsome beasts he can find, especially seeking any trace of Kha'Zix, the void creature who scratched out his eye. Rengar stalks his prey neither for food nor glory, but for the sheer beauty of the pursuit.",
			"blurb": "Rengar is a ferocious vastayan trophy hunter who lives for the thrill of tracking down and killing dangerous creatures. He scours the world for the most fearsome beasts he can find, especially seeking any trace of Kha'Zix, the void creature who...",
			"allytips": [
				"Use Rengar's ultimate to find and assassinate high priority targets in team fights and skirmishes.",
				"A lot of Rengar's power comes from empowered abilities he uses at the right moment - choose wisely!",
				"Make sure to take paths through brush when chasing opponents to take advantage of Rengar's passive."
			],
			"enemytips": [
				"Rengar gains an empowered ability when his resource bar is full. Try to confront him when it's low.",
				"Rengar's passive enables him to leap out of brush, so avoid fighting him when near bushes.",
				"Rengar puts an indicator over the nearest enemy champion when he is camouflaged during his ultimate."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Ferocity",
			"info": {
				"attack": 7,
				"defense": 4,
				"magic": 2,
				"difficulty": 8
			},
			"stats": {
				"hp": 585,
				"hpperlevel": 90,
				"mp": 4,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 34,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7,
				"hpregenperlevel": 0.5,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "RengarQ",
					"name": "Savagery",
					"description": "Rengar slashes all enemies in an arc before piercing all enemies in a line. Casting this outside the max range moves Rengar a short distance in that direction.<br><br>Ferocity effect: deals increased damage.",
					"tooltip": "Rengar gains {{ e5 }}% Attack Speed for his next 2 attacks. The first attack deals {{ e1 }} <span class=\"colorF88017\">(+{{ f2 }})</span> physical damage.<br /><br /><span class=\"colorEDDA74\">Ferocity effect:</span><br />Savagery's damage is increased to <span class=\"colorFFFFFF\">{{ f3 }}</span> <span class=\"colorFF8C00\">(+{{ a2 }})</span> and grants Rengar <span class=\"colorFFFFFF\">{{ f4 }}</span>% Attack Speed for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.25,
						0.25,
						0.25,
						0.25,
						0.25
					],
					"cooldownBurn": "0.25",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							50,
							80,
							110,
							140
						],
						[
							110,
							110,
							110,
							110,
							110
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.2,
							0.3,
							0.4,
							0.5,
							0.6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/50/80/110/140",
						"110",
						"5",
						"5",
						"40",
						"3",
						"0.2/0.3/0.4/0.5/0.6",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.3,
							"key": "a2"
						}
					],
					"costType": "Generates 1 Ferocity",
					"maxammo": "1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "RengarQ.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "Generates 1 Ferocity"
				},
				{
					"id": "RengarW",
					"name": "Battle Roar",
					"description": "Rengar lets out a battle roar, damaging enemies and healing for some of the recent damage he has taken.<br><br>Ferocity effect: additionally breaks crowd control effects.",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies and heals Rengar for {{ e2 }}% of the damage he took in the last {{ e3 }} seconds.<br /><br /><span class=\"colorEDDA74\">Ferocity effect: </span><br />Deals <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and removes existing crowd control effects, in addition to its normal effect.<br /><br /><rules><span class=\"color8c8c8c\">Damage healed from monster attacks is increased by {{ e5 }}%.</span></rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.25,
						0.25,
						0.25,
						0.25,
						0.25
					],
					"cooldownBurn": "0.25",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							50,
							80,
							110,
							140,
							170
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/80/110/140/170",
						"50",
						"1.5",
						"1.5",
						"50",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": "Generates 1 Ferocity",
					"maxammo": "1",
					"range": [
						450,
						450,
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "RengarW.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "Generates 1 Ferocity"
				},
				{
					"id": "RengarE",
					"name": "Bola Strike",
					"description": "Rengar throws a bola, slowing the first target hit for a short duration.<br><br>Ferocity effect: roots the target.",
					"tooltip": "Throw a bola, dealing {{ e1 }}<span class=\"colorF88017\"> (+{{ a1 }})</span> physical damage and slowing the first enemy hit by {{ e2 }}% for {{ e3 }} seconds.<br /><br /><span class=\"colorEDDA74\">Ferocity effect:</span><br />Deals <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"colorF88017\">(+{{ a1 }})</span> physical damage and roots the target for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Amount"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.25,
						0.25,
						0.25,
						0.25,
						0.25
					],
					"cooldownBurn": "0.25",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							55,
							100,
							145,
							190,
							235
						],
						[
							30,
							45,
							60,
							75,
							90
						],
						[
							1.75,
							1.75,
							1.75,
							1.75,
							1.75
						],
						[
							1.75,
							1.75,
							1.75,
							1.75,
							1.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/100/145/190/235",
						"30/45/60/75/90",
						"1.75",
						"1.75",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": "Generates 1 Ferocity",
					"maxammo": "1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "RengarE.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "Generates 1 Ferocity"
				},
				{
					"id": "RengarR",
					"name": "Thrill of the Hunt",
					"description": "Rengar's predatory instincts take over, <font color='#cd90ee'>Camouflaging</font> him and revealing the nearest enemy champion in a large radius around him. During Thrill of the Hunt, Rengar gains Movement Speed and he can leap to the tracked enemy for a guaranteed critical strike, even without being in brush.",
					"tooltip": "Rengar gains {{ e1 }}% Movement Speed and <span class=\"coloree91d7\">True Sight</span> of the nearest enemy champion within {{ e9 }} range for {{ e2 }} seconds.<br /><br />After the first {{ e6 }} seconds, Rengar becomes <span class=\"colorcd90ee\">Camouflaged</span> and can leap to an enemy without being in brush. Leaping to the nearest champion deals <span class=\"colorF88017\">{{ a1 }}</span> bonus physical damage and reduces their Armor by {{ e8 }} for {{ e7 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Enemy champions within {{ e3 }} range and their nearby allies can sense Rengar during Thrill of the Hunt.<br />Enemies revealed by Thrill of the Hunt stay revealed for the spell's duration.<br />Attacking or casting most spells ends Thrill of the Hunt.</span><br /><span class=\"colorcd90ee\"><u>Stealth - Camouflaged:</u></span><span class=\"color8c8c8c\"> This character is hidden from view. It is revealed by nearby enemy champions and turrets.</span></rules>",
					"leveltip": {
						"label": [
							"Armor Shred",
							"Duration",
							"Movement Speed",
							"Tracking Range",
							"Cooldown"
						],
						"effect": [
							"{{ e8 }} -> {{ e8NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e9 }} -> {{ e9NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						100,
						70
					],
					"cooldownBurn": "130/100/70",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							40,
							50,
							60
						],
						[
							12,
							16,
							20
						],
						[
							1600,
							1600,
							1600
						],
						[
							750,
							750,
							750
						],
						[
							725,
							725,
							725
						],
						[
							2,
							2,
							2
						],
						[
							4,
							4,
							4
						],
						[
							12,
							18,
							24
						],
						[
							2500,
							3000,
							3500
						],
						[
							50,
							100,
							150
						]
					],
					"effectBurn": [
						null,
						"40/50/60",
						"12/16/20",
						"1600",
						"750",
						"725",
						"2",
						"4",
						"12/18/24",
						"2500/3000/3500",
						"50/100/150"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1600,
						1600,
						1600
					],
					"rangeBurn": "1600",
					"image": {
						"full": "RengarR.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Unseen Predator",
				"description": "While in brush, Rengar leaps at his target with his basic attack.<br><br><font color='#EDDA74'>Rengar's abilities build Ferocity. Upon reaching full Ferocity, his next ability becomes empowered and grants him Movement Speed on cast, but he instantly loses all Ferocity if he leaves combat.<br><br>Killing enemy champions awards trophies on Rengar's Bonetooth Necklace, permanently increasing his Attack Damage.</font>",
				"image": {
					"full": "Rengar_P.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Rengar",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rengar",
					"title": "RengarTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Riven": {
			"id": "Riven",
			"key": "92",
			"name": "Riven",
			"title": "the Exile",
			"image": {
				"full": "Riven.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 48,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "92000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "92001",
					"num": 1,
					"name": "Redeemed Riven",
					"chromas": false
				},
				{
					"id": "92002",
					"num": 2,
					"name": "Crimson Elite Riven",
					"chromas": false
				},
				{
					"id": "92003",
					"num": 3,
					"name": "Battle Bunny Riven",
					"chromas": true
				},
				{
					"id": "92004",
					"num": 4,
					"name": "Championship Riven",
					"chromas": false
				},
				{
					"id": "92005",
					"num": 5,
					"name": "Dragonblade Riven",
					"chromas": true
				},
				{
					"id": "92006",
					"num": 6,
					"name": "Arcade Riven",
					"chromas": false
				},
				{
					"id": "92007",
					"num": 7,
					"name": "Championship Riven 2016",
					"chromas": false
				},
				{
					"id": "92016",
					"num": 16,
					"name": "Dawnbringer Riven",
					"chromas": false
				}
			],
			"lore": "Once a leader in the warhosts of Noxus, Riven is an expatriate in a land she previously tried to conquer. She rose through the ranks on the strength of her conviction and her brutal efficiency, and was rewarded with a legendary runic blade—however, on the Ionian front, Riven's faith in her homeland was tested and ultimately broken. Having severed all ties to the empire, she now wanders with her shattered sword, seeking atonement for a past she cannot forgive.",
			"blurb": "Once a leader in the warhosts of Noxus, Riven is an expatriate in a land she previously tried to conquer. She rose through the ranks on the strength of her conviction and her brutal efficiency, and was rewarded with a legendary runic blade—however, on...",
			"allytips": [
				"Riven's Broken Wings locks onto the champion your cursor is over at the time of cast. If you want to move past your opponent, make sure that your cursor is past your opponent as well.",
				"Riven lacks a source of healing or strong defense and must compensate with burst combos. Lead into fights with Broken Wings and Ki Burst, while using Valor to escape and absorb counter-harass."
			],
			"enemytips": [
				"Riven has a great deal of mobility but she cannot move very far with any one skill. Rooting or silencing her during her combo will greatly reduce her effectiveness.",
				"All of Riven's damage is physical, prioritize high Armor if an opposing Riven gets out of control.",
				"Riven excels at dueling multiple melee attackers at once, as she will be on an almost equal footing damage-wise. If pairing up against Riven, don't go in as double melee until she has expended her full combo."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "None",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 1,
				"difficulty": 8
			},
			"stats": {
				"hp": 558.48,
				"hpperlevel": 86,
				"mp": 0,
				"mpperlevel": 0,
				"movespeed": 340,
				"armor": 33,
				"armorperlevel": 3.2,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 5.5,
				"hpregenperlevel": 0.5,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "RivenTriCleave",
					"name": "Broken Wings",
					"description": "Riven lashes out in a series of strikes. This ability can be reactivated three times in a short time frame with the third hit knocking back nearby enemies.",
					"tooltip": "Riven strikes out in front of her in a short line. This ability may be re-cast {{ e4 }} additional times.<br /><br /><span class=\"colorDDDD77\">1st and 2nd Use:</span> Slashes forward, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to all units she comes in contact with.<br /><span class=\"colorDDDD77\">3rd Use:</span> Leaps forward and slams the ground dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and knocking nearby enemies up. This leap can cross unpathable terrain.<br /><br /><span class=\"colorDDDD77\">Riven will target the unit your cursor is hovering over, or if no targets are present, Riven will simply strike the direction she is currently facing.</span>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Attack Damage Scaling"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						13,
						13,
						13,
						13
					],
					"cooldownBurn": "13",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							15,
							35,
							55,
							75,
							95
						],
						[
							30,
							55,
							80,
							105,
							130
						],
						[
							150,
							225,
							300,
							375,
							450
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							45,
							50,
							55,
							60,
							65
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/35/55/75/95",
						"30/55/80/105/130",
						"150/225/300/375/450",
						"2",
						"45/50/55/60/65",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.4,
								0.45,
								0.5,
								0.55,
								0.6
							],
							"key": "f1"
						},
						{
							"link": "attackdamage",
							"coeff": [
								0.4,
								0.45,
								0.5,
								0.55,
								0.6
							],
							"key": "f1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						275,
						275,
						275,
						275,
						275
					],
					"rangeBurn": "275",
					"image": {
						"full": "RivenTriCleave.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "RivenMartyr",
					"name": "Ki Burst",
					"description": "Riven emits a Ki Burst, damaging and stunning nearby enemies.",
					"tooltip": "Riven's sword emits a burst of runic energy that shocks nearby enemies, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and stunning them for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						10,
						9,
						8,
						7
					],
					"cooldownBurn": "11/10/9/8/7",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							55,
							85,
							115,
							145,
							175
						],
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/85/115/145/175",
						"40/70/100/130/160",
						"3",
						"0.75",
						"0.75",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "f1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						260,
						260,
						260,
						260,
						260
					],
					"rangeBurn": "260",
					"image": {
						"full": "RivenMartyr.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "RivenFeint",
					"name": "Valor",
					"description": "Riven steps forward a short distance and blocks incoming damage.",
					"tooltip": "Riven does a quick dash in the direction of your cursor and becomes shielded, blocking up to {{ e2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> incoming damage for 1.5 seconds.",
					"leveltip": {
						"label": [
							"Damage Blocked",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							95,
							125,
							155,
							185,
							215
						],
						[
							95,
							125,
							155,
							185,
							215
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"95/125/155/185/215",
						"95/125/155/185/215",
						"4",
						"800",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "f1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						250,
						250,
						250,
						250,
						250
					],
					"rangeBurn": "250",
					"image": {
						"full": "RivenFeint.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "RivenFengShuiEngine",
					"name": "Blade of the Exile",
					"description": "Riven empowers her keepsake weapon with energy, and gains Attack Damage and Range. During this time, she also gains the ability to use Wind Slash, a powerful ranged attack, once. ",
					"tooltip": "Riven's weapon surges with spiritual energy for {{ e4 }} seconds, granting her {{ e5 }}% extra Attack Damage (<span class=\"colorFF8C00\">+{{ f3 }}</span>), increased Range on her damaging spells and attacks, and the ability to use Wind Slash once.<br /><br /><span class=\"colorDDDD77\">Wind Slash:</span> Riven fires a shockwave that deals from {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> to {{ e2 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage to all enemies hit, increasing based on how much Health they are missing.",
					"leveltip": {
						"label": [
							"Shockwave Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} / {{ e2 }} -> {{ e1NL }} / {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						95,
						60
					],
					"cooldownBurn": "130/95/60",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							100,
							150,
							200
						],
						[
							300,
							450,
							600
						],
						[
							20,
							20,
							20
						],
						[
							15,
							15,
							15
						],
						[
							20,
							20,
							20
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/150/200",
						"300/450/600",
						"20",
						"15",
						"20",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.2,
							"key": "f3"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1.8,
							"key": "f2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						200,
						200,
						200
					],
					"rangeBurn": "200",
					"image": {
						"full": "RivenFengShuiEngine.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Runic Blade",
				"description": "Riven's abilities charge her blade, causing her basic attacks to deal bonus physical damage. Riven's blade may be charged up to three times and expends one charge per attack.",
				"image": {
					"full": "RivenRunicBlades.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Riven",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Riven",
					"title": "RivenTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Rumble": {
			"id": "Rumble",
			"key": "68",
			"name": "Rumble",
			"title": "the Mechanized Menace",
			"image": {
				"full": "Rumble.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 96,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "68000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "68001",
					"num": 1,
					"name": "Rumble in the Jungle",
					"chromas": false
				},
				{
					"id": "68002",
					"num": 2,
					"name": "Bilgerat Rumble",
					"chromas": false
				},
				{
					"id": "68003",
					"num": 3,
					"name": "Super Galaxy Rumble",
					"chromas": false
				}
			],
			"lore": "Rumble is a young inventor with a temper. Using nothing more than his own two hands and a heap of scrap, the feisty yordle constructed a colossal mech suit outfitted with an arsenal of electrified harpoons and incendiary rockets. Though others may scoff and sneer at his junkyard creations, Rumble doesn't mind—after all, he's the one with the flamespitter.",
			"blurb": "Rumble is a young inventor with a temper. Using nothing more than his own two hands and a heap of scrap, the feisty yordle constructed a colossal mech suit outfitted with an arsenal of electrified harpoons and incendiary rockets. Though others may scoff...",
			"allytips": [
				"Try and pace yourself to stay in the Danger Zone to maximize your effectiveness. It is easy to overheat if you rapidly use your abilities.",
				"Try and keep targets in the range of your Flamespitter. It can deal a lot of damage overtime.",
				"If you are winning a fight you can use your ultimate to wall off an escape path."
			],
			"enemytips": [
				"Watch Rumble's Heat bar carefully. If you see him Overheat, go in for the kill while his skills are disabled.",
				"Rumble's ultimate can deal a lot of damage if you stay inside the area of effect. When you see the missiles falling, move out of the way as quickly as possible.",
				"Rumble deals almost entirely magic damage. Build some Magic Resistance to reduce his damage."
			],
			"tags": [
				"Fighter",
				"Mage"
			],
			"partype": "Heat",
			"info": {
				"attack": 3,
				"defense": 6,
				"magic": 8,
				"difficulty": 10
			},
			"stats": {
				"hp": 589,
				"hpperlevel": 85,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 30.88,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.6,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 61.036,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.03,
				"attackspeedperlevel": 1.85
			},
			"spells": [
				{
					"id": "RumbleFlameThrower",
					"name": "Flamespitter",
					"description": "Rumble torches opponents in front of him, dealing magic damage in a cone for 3 seconds. While in Danger Zone this damage is increased. ",
					"tooltip": "Rumble torches his opponents, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage in a cone over {{ e9 }} seconds. This spell deals {{ e4 }}% damage to minions.<br /><br /><caution>Danger Zone Bonus:</caution> Deals {{ e5 }}% damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							135,
							180,
							225,
							270,
							315
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"135/180/225/270/315",
						"20",
						"0",
						"75",
						"150",
						"12",
						"0.25",
						"3",
						"3",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1.1,
							"key": "a1"
						}
					],
					"costType": " Heat",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "RumbleFlameThrower.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e2 }} Heat"
				},
				{
					"id": "RumbleShield",
					"name": "Scrap Shield",
					"description": "Rumble pulls up a shield, protecting him from damage and granting him a quick burst of speed. While in Danger Zone, the shield strength and speed bonus is increased. ",
					"tooltip": "Rumble tosses up a shield for {{ e5 }} seconds that absorbs {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> damage. Rumble also gains an additional {{ e2 }}% Movement Speed for {{ e6 }} second. </span><br /><br /><caution>Danger Zone Bonus:</caution> 50% increase in shield health and Movement Speed.",
					"leveltip": {
						"label": [
							"Damage Absorption",
							"Movement Speed Bonus"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/110/140/170/200",
						"10/15/20/25/30",
						"20",
						"0",
						"1.5",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Heat",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "RumbleShield.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e3 }} Heat"
				},
				{
					"id": "RumbleGrenade",
					"name": "Electro Harpoon",
					"description": "Rumble launches a taser, electrocuting his target with magic damage and slowing their Movement Speed. Rumble can carry 2 harpoons at a time. While in Danger Zone the damage and slow percentage is increased.  ",
					"tooltip": "Rumble shoots his opponent with up to 2 tasers, dealing {{ e1 }}<scaleAP> (+{{ a1 }})</scaleAP> magic damage and applying a stacking slow of {{ e2 }}% for {{ e7 }} seconds.<br /><br /><caution>Danger Zone Bonus:</caution> Damage and slow percentage increased by 50%.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Amount"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.5,
						0.5,
						0.5,
						0.5,
						0.5
					],
					"cooldownBurn": "0.5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							60,
							85,
							110,
							135,
							160
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/85/110/135/160",
						"15/20/25/30/35",
						"10",
						"0",
						"0",
						"0",
						"2",
						"30/40/50/60/70",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Heat",
					"maxammo": "2",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "RumbleGrenade.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e3 }} Heat"
				},
				{
					"id": "RumbleCarpetBomb",
					"name": "The Equalizer",
					"description": "Rumble fires off a group of rockets, creating a wall of flames that damages and slows enemies. ",
					"tooltip": "Rumble launches a line of rockets that creates a burning trail for {{ e5 }} seconds. Enemies in the area have their Movement Speed slowed by {{ e3 }}% and take {{ e1 }}<scaleAP> (+{{ a2 }})</scaleAP> magic damage each second.<br /><br /><specialRules>You can control the placement of this attack by clicking and dragging your mouse in a line.</specialRules>",
					"leveltip": {
						"label": [
							"Damage Per Second",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						100,
						90
					],
					"cooldownBurn": "110/100/90",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							130,
							185,
							240
						],
						[
							0,
							0,
							0
						],
						[
							35,
							35,
							35
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							5,
							5,
							5
						],
						[
							6,
							6,
							6
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"130/185/240",
						"0",
						"35",
						"0.5",
						"5",
						"6",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1750,
						1750,
						1750
					],
					"rangeBurn": "1750",
					"image": {
						"full": "RumbleCarpetBomb.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Junkyard Titan",
				"description": "Every spell Rumble casts gives him Heat. When he reaches 50% Heat he reaches Danger Zone, granting all his basic abilities bonus effects. When he reaches 100% Heat, he starts Overheating, granting his basic attacks bonus damage, but making him unable to cast spells for a few seconds. ",
				"image": {
					"full": "Rumble_Junkyard Titan1.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Rumble",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Rumble",
					"title": "RumbleTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Ryze": {
			"id": "Ryze",
			"key": "13",
			"name": "Ryze",
			"title": "the Rune Mage",
			"image": {
				"full": "Ryze.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 144,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "13000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "13001",
					"num": 1,
					"name": "Young Ryze",
					"chromas": false
				},
				{
					"id": "13002",
					"num": 2,
					"name": "Tribal Ryze",
					"chromas": false
				},
				{
					"id": "13003",
					"num": 3,
					"name": "Uncle Ryze",
					"chromas": false
				},
				{
					"id": "13004",
					"num": 4,
					"name": "Triumphant Ryze",
					"chromas": false
				},
				{
					"id": "13005",
					"num": 5,
					"name": "Professor Ryze",
					"chromas": false
				},
				{
					"id": "13006",
					"num": 6,
					"name": "Zombie Ryze",
					"chromas": false
				},
				{
					"id": "13007",
					"num": 7,
					"name": "Dark Crystal Ryze",
					"chromas": false
				},
				{
					"id": "13008",
					"num": 8,
					"name": "Pirate Ryze",
					"chromas": false
				},
				{
					"id": "13009",
					"num": 9,
					"name": "Ryze Whitebeard",
					"chromas": false
				},
				{
					"id": "13010",
					"num": 10,
					"name": "SKT T1 Ryze",
					"chromas": false
				}
			],
			"lore": "Widely considered one of the most adept sorcerers on Runeterra, Ryze is an ancient, hard-bitten archmage with an impossibly heavy burden to bear. Armed with immense arcane power and a boundless constitution, he tirelessly hunts for World Runes—fragments of the raw magic that once shaped the world from nothingness. He must retrieve these artifacts before they fall into the wrong hands, for Ryze understands the horrors they could unleash on Runeterra.",
			"blurb": "Widely considered one of the most adept sorcerers on Runeterra, Ryze is an ancient, hard-bitten archmage with an impossibly heavy burden to bear. Armed with immense arcane power and a boundless constitution, he tirelessly hunts for World Runes—fragments...",
			"allytips": [
				"Use Overload's passive to optimize for maximum damage or maximum survivability.",
				"Spell Flux's short cooldown allows it to be used to spread Flux to many enemies.",
				"Ryze can move and cast other spells while Realm Warp is charging without cancelling the portal."
			],
			"enemytips": [
				"Ryze is especially dangerous to opponents that are marked with Flux.",
				"Use Realm Warp's windup time to figure out how to deal with what may be coming out of the portal.",
				"Crowd controlling Ryze during Realm Warp's windup will cancel the portal."
			],
			"tags": [
				"Mage",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 2,
				"magic": 10,
				"difficulty": 7
			},
			"stats": {
				"hp": 570.48,
				"hpperlevel": 98,
				"mp": 400,
				"mpperlevel": 50,
				"movespeed": 340,
				"armor": 21.552,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.112
			},
			"spells": [
				{
					"id": "RyzeQWrapper",
					"name": "Overload",
					"description": "Passively, Ryze's other damaging spells reset Overload and begin to charge a Rune that can be used to empower Overload.<br><br>On cast, Ryze throws a charge of pure energy in a line, dealing damage to the first enemy struck. If a Rune is fully charged, Ryze also gains a shield and Movement Speed.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Rune Prison and Spell Flux reset Overload's cooldown and charge a <span class=\"colorFFF673\">Rune</span> for {{ e2 }} seconds, up to {{ e9 }} <span class=\"colorFFF673\">Runes</span>.<br /><br /><span class=\"colorFF9900\">Active:</span> Unleash a runic blast, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"color44DDFF\">(+{{ f1 }})</span> magic damage to the first enemy struck. Any active <span class=\"colorFFF673\">Runes</span> are discharged.<br /><br />If {{ e9 }} <span class=\"colorFFF673\">Runes</span> are discharged, they Overload, shielding Ryze from <span class=\"colorFFFFFF\">{{ f3 }}</span> <span class=\"color99FF99\">(+{{ a2 }})</span> <span class=\"color44DDFF\">(+{{ f2 }})</span> damage and increasing his Movement Speed by {{ e4 }}% for {{ e5 }} seconds. ",
					"leveltip": {
						"label": [
							"Base Damage",
							"Movement Speed"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }}% -> {{ e4NL }}%"
						]
					},
					"maxrank": 6,
					"cooldown": [
						6,
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						40,
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							60,
							85,
							110,
							135,
							160,
							185
						],
						[
							4,
							4,
							4,
							4,
							4,
							4
						],
						[
							55,
							55,
							55,
							55,
							55,
							55
						],
						[
							25,
							28,
							31,
							34,
							37,
							40
						],
						[
							2,
							2,
							2,
							2,
							2,
							2
						],
						[
							2,
							2,
							2,
							2,
							2,
							2
						],
						[
							3,
							3,
							3,
							3,
							3,
							3
						],
						[
							3,
							3,
							3,
							3,
							3,
							3
						],
						[
							2,
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/85/110/135/160/185",
						"4",
						"55",
						"25/28/31/34/37/40",
						"2",
						"2",
						"3",
						"3",
						"2",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "RyzeQWrapper.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RyzeW",
					"name": "Rune Prison",
					"description": "Ryze traps a target enemy unit in a cage of runes, damaging them and preventing them from moving.",
					"tooltip": "Instantly root an enemy for {{ e1 }} second and deal {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"color44DDFF\">(+{{ f1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							80,
							100,
							120,
							140,
							160
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0.75",
						"80/100/120/140/160",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						615,
						615,
						615,
						615,
						615
					],
					"rangeBurn": "615",
					"image": {
						"full": "RyzeW.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RyzeE",
					"name": "Spell Flux",
					"description": "Ryze releases an orb of pure magical power that damages an enemy and debuffs them. Ryze's spells have additional effects against the debuffed enemy.",
					"tooltip": "Apply Flux to an enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"color44DDFF\">(+{{ f1 }})</span> magic damage. Spells consume Flux for bonus effects:<br /><br /><span class=\"colorFFF673\">Overload:</span> Deals {{ e2 }}% more damage and spreads to nearby enemies with Flux.<br /><span class=\"colorFFF673\">Rune Prison:</span> Root duration is increased to {{ e6 }} seconds.<br /><span class=\"colorFFF673\">Spell Flux:</span> Spreads Spell Flux to nearby enemies.<br /><br /><i>Spells that kill enemies affected by Flux spread Spell Flux to nearby enemies.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Overload Damage Increase",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						3.25,
						3,
						2.75,
						2.5,
						2.25
					],
					"cooldownBurn": "3.25/3/2.75/2.5/2.25",
					"cost": [
						40,
						55,
						70,
						85,
						100
					],
					"costBurn": "40/55/70/85/100",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							40,
							50,
							60,
							70,
							80
						],
						[
							167,
							167,
							167,
							167,
							167
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"40/50/60/70/80",
						"167",
						"0.1",
						"1.5",
						"2",
						"4",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						615,
						615,
						615,
						615,
						615
					],
					"rangeBurn": "615",
					"image": {
						"full": "RyzeE.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "RyzeR",
					"name": "Realm Warp",
					"description": "Ryze creates a portal to a nearby location. After a few seconds, allies standing near the portal are teleported to the target location.",
					"tooltip": "Ryze opens a portal to a location up to {{ e7 }} range away. After {{ e4 }} seconds, all allies near the portal are teleported to that location.<br /><br /><i>If Ryze becomes unable to cast or move, Realm Warp is cancelled.</i>",
					"leveltip": {
						"label": [
							"Range"
						],
						"effect": [
							"{{ e7 }} -> {{ e7NL }}"
						]
					},
					"maxrank": 2,
					"cooldown": [
						120,
						120
					],
					"cooldownBurn": "120",
					"cost": [
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							2.1,
							2.1
						],
						[
							0.65,
							0.65
						],
						[
							0.75,
							0.75
						],
						[
							2,
							2
						],
						[
							150,
							250
						],
						[
							6,
							6
						],
						[
							1750,
							3000
						],
						[
							0,
							0
						],
						[
							0,
							0
						],
						[
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2.1",
						"0.65",
						"0.75",
						"2",
						"150/250",
						"6",
						"1750/3000",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1750,
						3000
					],
					"rangeBurn": "1750/3000",
					"image": {
						"full": "RyzeR.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Arcane Mastery",
				"description": "<mainText>Ryze's spells deal extra damage based on his Bonus Mana, and he gains a percentage increase to his maximum Mana based on his Ability Power.</mainText>",
				"image": {
					"full": "Ryze_P.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ryze",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeBT",
					"map": "SR",
					"mode": "TUTORIAL",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ryze",
					"title": "RyzeTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Sejuani": {
			"id": "Sejuani",
			"key": "113",
			"name": "Sejuani",
			"title": "Fury of the North",
			"image": {
				"full": "Sejuani.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 192,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "113000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "113001",
					"num": 1,
					"name": "Sabretusk Sejuani",
					"chromas": false
				},
				{
					"id": "113002",
					"num": 2,
					"name": "Darkrider Sejuani",
					"chromas": false
				},
				{
					"id": "113003",
					"num": 3,
					"name": "Traditional Sejuani",
					"chromas": false
				},
				{
					"id": "113004",
					"num": 4,
					"name": "Bear Cavalry Sejuani",
					"chromas": false
				},
				{
					"id": "113005",
					"num": 5,
					"name": "Poro Rider Sejuani",
					"chromas": false
				},
				{
					"id": "113006",
					"num": 6,
					"name": "Beast Hunter Sejuani",
					"chromas": false
				},
				{
					"id": "113007",
					"num": 7,
					"name": "Sejuani Dawnchaser",
					"chromas": false
				}
			],
			"lore": "Sejuani is the brutal, unforgiving Iceborn warmother of the Winter's Claw, one of the most feared tribes of the Freljord. Her people's survival is a constant, desperate battle against the elements, forcing them to raid Noxians, Demacians, and Avarosans alike to survive the harsh winters. Sejuani herself spearheads the most dangerous of these attacks from the saddle of her drüvask boar Bristle, using her True Ice flail to freeze and shatter her enemies.",
			"blurb": "Sejuani is the brutal, unforgiving Iceborn warmother of the Winter's Claw, one of the most feared tribes of the Freljord. Her people's survival is a constant, desperate battle against the elements, forcing them to raid Noxians, Demacians, and Avarosans...",
			"allytips": [
				"Use Arctic Assault to escape bad situations, interupt channeled spells or chase runners.",
				"Melee allies can stack Frost for your Permafrost, keep an eye on who they are attacking.",
				"Save Glacial Prison for encounters where you have teammates present to take advantage of it."
			],
			"enemytips": [
				"Dodging Arctic Assault and Glacial Prison can give you a huge advantage.",
				"Focus on avoiding the second swing of Winter's Wrath which carries the brunt of the damage.",
				"Melee enemies can also stack Frost for Sejuani, be very careful around them."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 7,
				"magic": 6,
				"difficulty": 4
			},
			"stats": {
				"hp": 560,
				"hpperlevel": 95,
				"mp": 400,
				"mpperlevel": 40,
				"movespeed": 340,
				"armor": 31,
				"armorperlevel": 3,
				"spellblock": 27.1,
				"spellblockperlevel": 0.75,
				"attackrange": 150,
				"hpregen": 8.5,
				"hpregenperlevel": 0.85,
				"mpregen": 7,
				"mpregenperlevel": 0.7,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "SejuaniQ",
					"name": "Arctic Assault",
					"description": "Sejuani charges forward, knocking enemies into the air. The charge stops after hitting an enemy champion.",
					"tooltip": "Sejuani charges, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies and knocking them up. The charge ends after hitting an enemy champion.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						15.5,
						14,
						12.5,
						11
					],
					"cooldownBurn": "17/15.5/14/12.5/11",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							625,
							625,
							625,
							625,
							625
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/90/120/150/180",
						"625",
						"1000",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "SejuaniQ.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SejuaniW",
					"name": "Winter's Wrath",
					"description": "Sejuani swings her mace twice, dealing damage and applying Frost stacks.",
					"tooltip": "Sejuani swings her flail, dealing {{ e1 }} <span class=\"colorFF3300\">(+{{ f1 }})</span> physical damage and applying <span class=\"color07F2F1\">Frost</span> to enemies hit and knocking minions and monsters back.<br /><br />She then lashes out with her flail, dealing {{ e3 }} <span class=\"colorFF3300\">(+{{ f2 }})</span> physical damage, applying <span class=\"color07F2F1\">Frost</span> and slowing enemies hit briefly.",
					"leveltip": {
						"label": [
							"First Hit Damage",
							"Second Hit Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							30,
							65,
							100,
							135,
							170
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/25/30/35/40",
						"0.75",
						"30/65/100/135/170",
						"0",
						"75",
						"0.25",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "SejuaniW.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SejuaniE",
					"name": "Permafrost",
					"description": "Sejuani freezes and stuns an enemy champion that has maximum Frost stacks.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Nearby melee allied champions' basic attacks apply <span class=\"color07F2F1\">Frost</span> to enemy champions and large monsters.<br /><br /><span class=\"colorFF9900\">Active:</span> Target enemy with 4 stacks of <span class=\"color07F2F1\">Frost</span> takes {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, is stunned for {{ e1 }} second(s), and is briefly displaced.<br /><br /><span class=\"size16 color8C8C8C\">An enemy stunned by Sejuani cannot gain </span><span class=\"size16 color07F2F1\">Frost</span><span class=\"size16 color8C8C8C\"> for {{ f2 }} seconds.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Stun Duration"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1.5,
						1.5,
						1.5,
						1.5,
						1.5
					],
					"cooldownBurn": "1.5",
					"cost": [
						20,
						20,
						20,
						20,
						20
					],
					"costBurn": "20",
					"effect": [
						null,
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							1100,
							1100,
							1100,
							1100,
							1100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1/1.25/1.5/1.75/2",
						"0",
						"20/30/40/50/60",
						"4",
						"5",
						"1100",
						"0",
						"0",
						"250",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "SejuaniE.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SejuaniR",
					"name": "Glacial Prison",
					"description": "Sejuani throws her bola that freezes and stuns the first champion hit and creates an ice storm that slows other enemies.",
					"tooltip": "Sejuani throws her True Ice bola that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy champion hit and stuns them for {{ e2 }} second.<br /><br />The bola becomes more powerful as it travels, dealing {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage, stunning for {{ e6 }} seconds and creating a storm that slows other enemies by {{ e8 }}%. After {{ e3 }} seconds, the storm deals {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and slows by {{ e4 }}% for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Minimum Damage",
							"Maximum Damage",
							"Cooldown"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							125,
							150
						],
						[
							1,
							1,
							1
						],
						[
							2,
							2,
							2
						],
						[
							80,
							80,
							80
						],
						[
							3,
							3,
							3
						],
						[
							2,
							2,
							2
						],
						[
							150,
							250,
							350
						],
						[
							30,
							30,
							30
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/125/150",
						"1",
						"2",
						"80",
						"3",
						"2",
						"150/250/350",
						"30",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1300,
						1300,
						1300
					],
					"rangeBurn": "1300",
					"image": {
						"full": "SejuaniR.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Fury of the North",
				"description": "<mainText>After being out of combat, Sejuani gains Frost Armor which grants Armor and Magic Resist and immunity to slows. Frost Armor persists for a short time after Sejuani takes damage.  Sejuani can damage a stunned enemy to shatter it, dealing massive magic damage.</mainText>",
				"image": {
					"full": "Sejuani_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Sejuani",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sejuani",
					"title": "SejuaniTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Shaco": {
			"id": "Shaco",
			"key": "35",
			"name": "Shaco",
			"title": "the Demon Jester",
			"image": {
				"full": "Shaco.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 240,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "35000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "35001",
					"num": 1,
					"name": "Mad Hatter Shaco",
					"chromas": false
				},
				{
					"id": "35002",
					"num": 2,
					"name": "Royal Shaco",
					"chromas": false
				},
				{
					"id": "35003",
					"num": 3,
					"name": "Nutcracko",
					"chromas": false
				},
				{
					"id": "35004",
					"num": 4,
					"name": "Workshop Shaco",
					"chromas": false
				},
				{
					"id": "35005",
					"num": 5,
					"name": "Asylum Shaco",
					"chromas": false
				},
				{
					"id": "35006",
					"num": 6,
					"name": "Masked Shaco",
					"chromas": false
				},
				{
					"id": "35007",
					"num": 7,
					"name": "Wild Card Shaco",
					"chromas": false
				}
			],
			"lore": "Crafted long ago as a plaything for a lonely prince, the enchanted marionette Shaco now delights in murder and mayhem. Corrupted by dark magic and the loss of his beloved charge, the once-kind puppet finds pleasure only in the misery of the poor souls he torments. He uses toys and simple tricks to deadly effect, finding the results of his bloody “games” hilarious—and for those who hear a dark chuckle in the dead of night, the Demon Jester may have marked them as his next plaything.",
			"blurb": "Crafted long ago as a plaything for a lonely prince, the enchanted marionette Shaco now delights in murder and mayhem. Corrupted by dark magic and the loss of his beloved charge, the once-kind puppet finds pleasure only in the misery of the poor souls...",
			"allytips": [
				"Using Deceive over terrain can help you make a clean escape.",
				"Try getting items with on-hit effects. These will also benefit your Hallucination clone.",
				"Backstab's damage can be increased with increased Critical Damage effects like Infinity Edge."
			],
			"enemytips": [
				"If Shaco is doing well early-game, it is worth the investment to place Stealth Wards near his Jungle camps.",
				"If Shaco uses Deceive to enter a fight he won't be able to quickly use it again to get away. Work with your team to quickly focus him down."
			],
			"tags": [
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 4,
				"magic": 6,
				"difficulty": 9
			},
			"stats": {
				"hp": 587,
				"hpperlevel": 89,
				"mp": 297.2,
				"mpperlevel": 40,
				"movespeed": 350,
				"armor": 30,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.55,
				"mpregen": 7.156,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": -0.1,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "Deceive",
					"name": "Deceive",
					"description": "Shaco becomes Invisible and teleports to target location.",
					"tooltip": "Shaco teleports nearby and becomes <span class=\"color91d7ee\">Invisible</span> for {{ e3 }} seconds. Shaco remains <span class=\"color91d7ee\">Invisible</span> even if he uses Jack in the Box or Hallucinate. <br /><br />His next basic attack during or shortly after <span class=\"color91d7ee\">Invisibility</span> will reduce Deceive's cooldown by {{ f3 }} seconds. <br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Shaco can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
					"leveltip": {
						"label": [
							"Stealth Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15.5,
						15,
						14.5,
						14
					],
					"cooldownBurn": "16/15.5/15/14.5/14",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							1.5,
							2.25,
							3,
							3.75,
							4.5
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"200",
						"1.5/2.25/3/3.75/4.5",
						"6",
						"400",
						"2.5",
						"0",
						"2.5",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "Deceive.png",
						"sprite": "spell9.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "JackInTheBox",
					"name": "Jack In The Box",
					"description": "Shaco creates a hidden animated Jack-in-the-Box. When triggered, it will fear and attack nearby enemies.",
					"tooltip": "Shaco creates a Jack in the Box that hides from view after {{ e5 }} seconds. It pops out when an enemy comes near or when uncovered by a ward or trinket, making nearby enemies flee very slowly for {{ e3 }} seconds.<br /><br />Its attacks deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage. It lasts for {{ e4 }} <scaleAP>(+{{ a2 }})</scaleAP> seconds while hidden or 5 seconds while firing. ",
					"leveltip": {
						"label": [
							"Damage",
							"Fear Duration",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						16,
						16,
						16,
						16
					],
					"cooldownBurn": "16",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							35,
							50,
							65,
							80,
							95
						],
						[
							200,
							300,
							400,
							500,
							600
						],
						[
							0.5,
							0.75,
							1,
							1.25,
							1.5
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/50/65/80/95",
						"200/300/400/500/600",
						"0.5/0.75/1/1.25/1.5",
						"60",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.05,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "JackInTheBox.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TwoShivPoison",
					"name": "Two-Shiv Poison",
					"description": "Shaco's Shivs passively poison targets on hit, slowing their movement speed. He can throw his Shivs to deal damage and poison the target. The thrown Shiv deals bonus damage based on the target's missing Health.",
					"tooltip": "<spellPassive>Passive:</spellPassive> While Two-Shiv Poison is ready to cast, Shaco's basic attacks reduce the target's movement speed by {{ e4 }}% for {{ e5 }} seconds.<br /><br /><spellActive>Active:</spellActive> Shaco throws a shiv that deals {{ e1 }} <scaleAD>(+{{ f1 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> physical damage and reduces the target's movement speed by {{ e4 }}% for {{ e6 }} seconds. The shiv's damage is increased by up to {{ e3 }}% based on the target's missing health.",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus AD Ratio",
							"Slow",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							55,
							80,
							105,
							130,
							155
						],
						[
							60,
							75,
							90,
							105,
							120
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							20,
							22.5,
							25,
							27.5,
							30
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/80/105/130/155",
						"60/75/90/105/120",
						"50",
						"20/22.5/25/27.5/30",
						"2",
						"3",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "TwoShivPoison.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "HallucinateFull",
					"name": "Hallucinate",
					"description": "Shaco creates an illusion of himself near him, which can attack nearby enemies (Deals reduced damage to turrets).  Upon death, it explodes, spawning three mini Jack in the Boxes and dealing damage to nearby enemies. ",
					"tooltip": "Shaco vanishes briefly and reappears with a clone. The clone lasts up to 18 seconds and detonates when it dies, dealing {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> magic damage to nearby enemies and spawning three mini Jack in the Boxes. <br /><br /><li>Mini boxes deal {{ e6 }} <scaleAP>(+{{ a2 }})</scaleAP> damage, make enemies flee for {{ e7 }} second(s), and trigger together. <br /><br />Clone deals {{ e8 }}% of Shaco's damage and receives {{ e2 }}% increased damage.</li><br /><scaleAP>The clone can be controlled by holding the alt key and using the right mouse button or by reactivating this ability.</scaleAP>",
					"leveltip": {
						"label": [
							"On Death Damage",
							"Mini Box Damage",
							"Mini Box Flee Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							200,
							300,
							400
						],
						[
							50,
							50,
							50
						],
						[
							15,
							15,
							15
						],
						[
							2,
							2,
							2
						],
						[
							6,
							6,
							6
						],
						[
							25,
							50,
							75
						],
						[
							0.75,
							1,
							1.25
						],
						[
							75,
							75,
							75
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/300/400",
						"50",
						"15",
						"2",
						"6",
						"25/50/75",
						"0.75/1/1.25",
						"75",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "HallucinateFull.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Backstab",
				"description": "Shaco's basic attack critically strikes for extra damage when striking a unit from behind. Units can't be Backstabbed more than once every few seconds, modified by Shaco's cooldown reduction.",
				"image": {
					"full": "Jester_CarefulStrikes.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Shaco",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2015",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "selective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shaco",
					"title": "ShacoTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1036",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Shen": {
			"id": "Shen",
			"key": "98",
			"name": "Shen",
			"title": "the Eye of Twilight",
			"image": {
				"full": "Shen.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 288,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "98000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "98001",
					"num": 1,
					"name": "Frozen Shen",
					"chromas": false
				},
				{
					"id": "98002",
					"num": 2,
					"name": "Yellow Jacket Shen",
					"chromas": false
				},
				{
					"id": "98003",
					"num": 3,
					"name": "Surgeon Shen",
					"chromas": false
				},
				{
					"id": "98004",
					"num": 4,
					"name": "Blood Moon Shen",
					"chromas": false
				},
				{
					"id": "98005",
					"num": 5,
					"name": "Warlord Shen",
					"chromas": true
				},
				{
					"id": "98006",
					"num": 6,
					"name": "TPA Shen",
					"chromas": false
				}
			],
			"lore": "Among the secretive, Ionian warriors known as the Kinkou, Shen serves as their leader, the Eye of Twilight. He longs to remain free from the confusion of emotion, prejudice, and ego, and walks the unseen path of dispassionate judgment between the spirit realm and the physical world. Tasked with enforcing the equilibrium between them, Shen wields blades of steel and arcane energy against any who would threaten it.",
			"blurb": "Among the secretive, Ionian warriors known as the Kinkou, Shen serves as their leader, the Eye of Twilight. He longs to remain free from the confusion of emotion, prejudice, and ego, and walks the unseen path of dispassionate judgment between the spirit...",
			"allytips": [
				"Keep an eye on allies and be ready to save them with your teleport.",
				"Leverage your Energy to get a long-term advantage over Mana users."
			],
			"enemytips": [
				"Be ready to dodge Shen's taunt and punish him if he misses.",
				"Once Shen reaches level 6, watch out for his global-range ultimate, which can turn fights quickly."
			],
			"tags": [
				"Tank"
			],
			"partype": "Energy",
			"info": {
				"attack": 3,
				"defense": 9,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 540,
				"hpperlevel": 85,
				"mp": 400,
				"mpperlevel": 0,
				"movespeed": 340,
				"armor": 34,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.75,
				"mpregen": 50,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 60,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "ShenQ",
					"name": "Twilight Assault",
					"description": "Shen recalls his spirit blade to attack with it, dealing damage based on the target's max health. The attacks are greatly empowered if it collides with an enemy champion, and all collided enemies are slowed while running away from Shen.",
					"tooltip": "Shen recalls his <span class=\"colorBB77FF\">spirit blade</span> and draws it. Enemies it collides with are slowed by {{ e4 }}% when moving away from Shen for the next {{ e5 }} seconds.<br /><br />Shen's next {{ e3 }} attacks deal <scaleLevel>{{ f1 }}</scaleLevel> plus {{ e2 }} <span class=\"color99FF99\">(+{{ charabilitypower*.01 }})</span>% of their target's max health as bonus magic damage. If the <span class=\"colorBB77FF\">spirit blade</span> collided with an enemy champion, those attacks deal <scaleLevel>{{ f2 }}</scaleLevel> plus {{ e6 }} <span class=\"color99FF99\">(+{{ charabilitypower2*.01 }})</span>% instead and have +{{ e9 }}% Attack Speed.<br /><br /><rules>Each attack deals {{ e1 }}% increased damage to monsters (capped at {{ e7 }}).</rules>",
					"leveltip": {
						"label": [
							"Base Percent Damage",
							"Enhanced Percent Damage",
							"Energy Cost",
							"Monster Damage Cap",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e6 }}% -> {{ e6NL }}%",
							"{{ cost }} -> {{ costNL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7.25,
						6.5,
						5.75,
						5
					],
					"cooldownBurn": "8/7.25/6.5/5.75/5",
					"cost": [
						140,
						130,
						120,
						110,
						100
					],
					"costBurn": "140/130/120/110/100",
					"effect": [
						null,
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							2,
							2.5,
							3,
							3.5,
							4
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							4,
							4.5,
							5,
							5.5,
							6
						],
						[
							75,
							100,
							125,
							150,
							175
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							75,
							75,
							75,
							75,
							75
						]
					],
					"effectBurn": [
						null,
						"100",
						"2/2.5/3/3.5/4",
						"3",
						"35",
						"2",
						"4/4.5/5/5.5/6",
						"75/100/125/150/175",
						"8",
						"50",
						"75"
					],
					"vars": [],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "ShenQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "ShenW",
					"name": "Spirit's Refuge",
					"description": "Attacks that would hit Shen or his allies near his spirit blade are blocked.",
					"tooltip": "Shen's <span class=\"colorBB77FF\">spirit blade</span> creates a defensive zone for {{ e1 }} seconds. Basic attacks that would hit Shen or an allied champion in the zone are blocked.<br /><br />If there are no champions to protect in the zone when it starts, the <span class=\"colorBB77FF\">spirit blade</span> will not activate until one enters or {{ e2 }} seconds pass.",
					"leveltip": {
						"label": [
							"Cooldown"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16.5,
						15,
						13.5,
						11
					],
					"cooldownBurn": "18/16.5/15/13.5/11",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							1.75,
							1.75,
							1.75,
							1.75,
							1.75
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.75",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "ShenW.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "ShenE",
					"name": "Shadow Dash",
					"description": "Shen dashes in a direction, taunting enemies in his path.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Dealing damage with Shadow Dash or Twilight Assault recovers <span class=\"colorFFFFFF\">{{ f1 }}</span> Energy.<br /><br /><span class=\"colorFF9900\">Active:</span> Shen dashes in a direction, dealing {{ e2 }} <span class=\"colorCC3300\">[+{{ f2 }}]</span> physical damage to enemy champions and neutral monsters in his path and taunting them for {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						150,
						150,
						150,
						150,
						150
					],
					"costBurn": "150",
					"effect": [
						null,
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							125,
							125,
							125,
							125,
							125
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.5",
						"50/75/100/125/150",
						"25",
						"300",
						"125",
						"150",
						"800",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "ShenE.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "ShenR",
					"name": "Stand United",
					"description": "Shen shields target allied champion from incoming damage, and soon after teleports to their location.",
					"tooltip": "Shen grants a shield to a target allied champion that lasts {{ e2 }} seconds and absorbs up to {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e8 }} <span class=\"color99FF99\">(+{{ f2 }})</span> damage based on their missing health. After channeling for {{ f1 }} seconds, Shen and his <span class=\"colorBB77FF\">spirit blade</span> teleport to the ally's location.",
					"leveltip": {
						"label": [
							"Minimum Shield Health",
							"Maximum Shield Health",
							"Cooldown "
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ e8 }} -> {{ e8NL }} ",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						200,
						180,
						160
					],
					"cooldownBurn": "200/180/160",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							175,
							350,
							525
						],
						[
							5,
							5,
							5
						],
						[
							175,
							175,
							175
						],
						[
							2000,
							2000,
							2000
						],
						[
							600,
							600,
							600
						],
						[
							0.4,
							0.4,
							0.4
						],
						[
							1.6,
							1.6,
							1.6
						],
						[
							280,
							560,
							840
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"175/350/525",
						"5",
						"175",
						"2000",
						"600",
						"0.4",
						"1.6",
						"280/560/840",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1.35,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						35000,
						35000,
						35000
					],
					"rangeBurn": "35000",
					"image": {
						"full": "ShenR.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Ki Barrier",
				"description": "After casting a spell, Shen gets a shield. Affecting other champions reduces the cooldown of this effect.",
				"image": {
					"full": "Shen_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Shen",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1054",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1054",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "3044",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3044",
									"count": 1
								},
								{
									"id": "3057",
									"count": 1
								},
								{
									"id": "3086",
									"count": 1
								},
								{
									"id": "3078",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3068",
									"count": 1
								},
								{
									"id": "3091",
									"count": 1
								},
								{
									"id": "3065",
									"count": 1
								},
								{
									"id": "3083",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1413",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shen",
					"title": "ShenTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Shyvana": {
			"id": "Shyvana",
			"key": "102",
			"name": "Shyvana",
			"title": "the Half-Dragon",
			"image": {
				"full": "Shyvana.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 336,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "102000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "102001",
					"num": 1,
					"name": "Ironscale Shyvana",
					"chromas": false
				},
				{
					"id": "102002",
					"num": 2,
					"name": "Boneclaw Shyvana",
					"chromas": false
				},
				{
					"id": "102003",
					"num": 3,
					"name": "Darkflame Shyvana",
					"chromas": false
				},
				{
					"id": "102004",
					"num": 4,
					"name": "Ice Drake Shyvana",
					"chromas": false
				},
				{
					"id": "102005",
					"num": 5,
					"name": "Championship Shyvana",
					"chromas": false
				},
				{
					"id": "102006",
					"num": 6,
					"name": "Super Galaxy Shyvana",
					"chromas": false
				}
			],
			"lore": "Shyvana is a creature with the magic of a rune shard burning within her heart. Though she often appears humanoid, she can take her true form as a fearsome dragon, incinerating her foes with fiery breath. Having saved the life of the crown prince Jarvan IV, Shyvana now serves uneasily in his royal guard, struggling to find acceptance among the suspicious people of Demacia.",
			"blurb": "Shyvana is a creature with the magic of a rune shard burning within her heart. Though she often appears humanoid, she can take her true form as a fearsome dragon, incinerating her foes with fiery breath. Having saved the life of the crown prince Jarvan...",
			"allytips": [
				"Shyvana's abilities all benefit from attacking units. As a result, Attack Speed items are more valuable on her than most champions.",
				"Flame Breath is great to level-up against difficult lane opponents.",
				"Burnout is an ideal choice for jungling. Monsters will be hit by the full duration, and the speed boost improves her ganking potential.",
				"It can be valuable to purchase one of the items that can slow enemies: Frozen Mallet, Dead Man's Plate, or Entropy."
			],
			"enemytips": [
				"A significant portion of Shyvana's power is generated through aggression, making her weak against opponents who are able to keep their distance.",
				"All of Shyvana's basic abilities hit multiple enemies in dragon form. It's important for opposing champions to not cluster while fighting her.",
				"Shyvana's Fury Bar indicate her ultimate can be activated. Harassing her when she's low on Fury can be very effective."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Fury",
			"info": {
				"attack": 8,
				"defense": 6,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 595,
				"hpperlevel": 95,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 350,
				"armor": 38,
				"armorperlevel": 3.35,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.8,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 2.8,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "ShyvanaDoubleAttack",
					"name": "Twin Bite",
					"description": "Shyvana strikes twice on her next attack. Basic attacks reduce the cooldown of Twin Bite by 0.5 seconds.<br><br><font color='#FF3300'>Dragon Form: </font>Twin Bite cleaves all units in front Shyvana. ",
					"tooltip": "Shyvana strikes twice on her next attack, dealing <span class=\"colorFF8C00\">{{ f2 }}</span> and <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage on the first and second hits respectively.<br /><br />While Twin Bite is on cooldown, basic attacks reduce the remaining cooldown duration by {{ e3 }} seconds.<br /><br /><span class=\"colorFF3300\">Dragon Form: </span>Twin Bite cleaves all units in front Shyvana.<br /><br /><span class=\"color919191\"><i>Twin Bite's second hit damage is equal to {{ e1 }}% of Shyvana's attack damage.</i></span>",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} ->{{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							35,
							50,
							65,
							80
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/35/50/65/80",
						"250",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.8,
								0.85,
								0.9,
								0.95,
								1
							],
							"key": "f1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "ShyvanaDoubleAttack.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "ShyvanaImmolationAura",
					"name": "Burnout",
					"description": "Shyvana surrounds herself in fire, dealing magic damage per second to nearby enemies and moving faster for 3 seconds, part of this damage is applied again when Shyvana basic attacks an enemy with Burnout active. The Movement Speed reduces over the duration of the spell. Basic attacks extend the duration of Burnout. <br><br><font color='#FF3300'>Dragon Form: </font>Burnout grows in size.",
					"tooltip": "Shyvana deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage per second to nearby enemies and gains a bonus {{ e2 }}% movement speed that decays over {{ e7 }} seconds.<br /><br />While Burnout is active, basic attacks deal {{ effect1amount*0.25 }} <span class=\"colorFF8C00\">(+{{ charbonusphysical*0.25 }})</span> <span class=\"color99FF99\">(+{{ charabilitypower2*.25 }})</span> magic damage to nearby enemies and extend its duration by {{ e8 }} second.<br /><br /><span class=\"colorFF3300\">Dragon Form: </span>Burnout grows in size.<br /><br /><span class=\"color919191\"><i>Burnout has a maximum duration of {{ e9 }} seconds.</i></span>",
					"leveltip": {
						"label": [
							"Damage (aura)",
							"Damage (on hit)",
							"Movement Speed Bonus"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ effect1amount*0.25 }} -> {{ effect1amountnl*0.25 }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							32,
							45,
							57,
							70
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							0.85,
							0.85,
							0.85,
							0.85,
							0.85
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							325,
							325,
							325,
							325,
							325
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							350,
							365,
							380,
							380,
							380
						]
					],
					"effectBurn": [
						null,
						"20/32/45/57/70",
						"30/35/40/45/50",
						"0.85",
						"0",
						"25",
						"325",
						"3",
						"1",
						"7",
						"350/365/380/380/380"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "ShyvanaImmolationAura.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "ShyvanaFireball",
					"name": "Flame Breath",
					"description": "Shyvana unleashes a fireball that deals damage to all enemies it encounters and leaves cinders on the target, marking them for 5 seconds. Shyvana's basic attacks on marked targets deal a percentage of their maximum Health as damage on-hit.<br><br><font color='#FF3300'>Dragon Form: </font>Flame Breath explodes on impact or at target location, dealing bonus damage and scorching the earth for a short duration.",
					"tooltip": "Shyvana unleashes a fireball that stops after hitting a champion. All enemies hit take {{ e1 }} <span class=\"colorFF8C00\">(+{{ f4 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are marked for {{ e2 }} seconds.<br /><br />Shyvana's basic attacks against marked targets deal {{ e4 }}% of their maximum health as magic damage on hit.<br /><br /><span class=\"colorFF3300\">Dragon Form: </span>Flame Breath explodes on impact or at target location, dealing <span class=\"colorFFFFFF\">{{ f1 }}</span> <span class=\"colorFF8C00\">(+{{ f5 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and scorching the earth for 4 seconds. Enemies on scorched earth take <span class=\"colorFFFFFF\">{{ f3 }}</span> <span class=\"colorFF8C00\">(+{{ f6 }})</span> <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage per second.<br /><br /><span class=\"color919191\"><i>Flame Breath's on-hit damage against monsters is capped at {{ e3 }} damage per hit.</i></span>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							4.5,
							4.5,
							4.5,
							4.5,
							4.5
						],
						[
							220,
							240,
							260,
							260,
							260
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"5",
						"100",
						"2.5",
						"0",
						"60/100/140/180/220",
						"4.5",
						"220/240/260/260/260",
						"0.1",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "ShyvanaFireball.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "ShyvanaTransformCast",
					"name": "Dragon's Descent",
					"description": "Shyvana transforms into a dragon and takes flight to a target location. Enemies along her path take damage and are knocked toward her target location.<br><br>Shyvana passively gains Fury per second and gains 2 Fury on basic attack.",
					"tooltip": "<span class=\"colorFF9900\">Active: </span>Shyvana transforms into a dragon, gaining {{ e0 }} Health and flying to target location. Enemies along her path take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are knocked toward her target location.<br /><br /><span class=\"colorFF9900\">Passive: </span>Shyvana generates {{ e3 }} Fury every second. Basic Attacks generate {{ e2 }} Fury.",
					"leveltip": {
						"label": [
							"Passive Fury Gain",
							"Dragon Size",
							"Bonus Health",
							"Flight Damage"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"Big -> Bigger",
							"{{ e0 }} -> {{ e0NL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							2,
							2,
							2
						],
						[
							1,
							1.5,
							2
						],
						[
							5,
							5,
							5
						],
						[
							1100,
							1100,
							1100
						],
						[
							275,
							275,
							275
						],
						[
							100,
							100,
							100
						],
						[
							200,
							230,
							260
						],
						[
							0,
							0.085,
							0.16
						],
						[
							150,
							250,
							350
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"2",
						"1/1.5/2",
						"5",
						"1100",
						"275",
						"100",
						"200/230/260",
						"0/0.085/0.16",
						"150/250/350"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Fury a Second",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "ShyvanaTransformCast.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e4 }} Fury a Second"
				}
			],
			"passive": {
				"name": "Fury of the Dragonborn",
				"description": "<mainText>Shyvana deals bonus damage to dragons and gains Armor and Magic Resistance. As Shyvana and her allies slay more dragons, she gains more bonus Armor and Magic Resistance.</mainText>",
				"image": {
					"full": "ShyvanaReinforcedScales.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Shyvana",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3052",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3052",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Shyvana",
					"title": "ShyvanaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Singed": {
			"id": "Singed",
			"key": "27",
			"name": "Singed",
			"title": "the Mad Chemist",
			"image": {
				"full": "Singed.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 384,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "27000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "27001",
					"num": 1,
					"name": "Riot Squad Singed",
					"chromas": false
				},
				{
					"id": "27002",
					"num": 2,
					"name": "Hextech Singed",
					"chromas": false
				},
				{
					"id": "27003",
					"num": 3,
					"name": "Surfer Singed",
					"chromas": false
				},
				{
					"id": "27004",
					"num": 4,
					"name": "Mad Scientist Singed",
					"chromas": false
				},
				{
					"id": "27005",
					"num": 5,
					"name": "Augmented Singed",
					"chromas": false
				},
				{
					"id": "27006",
					"num": 6,
					"name": "Snow Day Singed",
					"chromas": false
				},
				{
					"id": "27007",
					"num": 7,
					"name": "SSW Singed",
					"chromas": false
				},
				{
					"id": "27008",
					"num": 8,
					"name": "Black Scourge Singed",
					"chromas": false
				},
				{
					"id": "27009",
					"num": 9,
					"name": "Beekeeper Singed",
					"chromas": false
				}
			],
			"lore": "Singed is a Zaunite alchemist of unmatched intellect, who has devoted his life to pushing the boundaries of knowledge—with no price, even his own sanity, too high to pay. Is there a method to his madness? His concoctions rarely fail, but it appears to many that Singed has lost all sense of humanity, leaving a toxic trail of misery and terror in his wake.",
			"blurb": "Singed is a Zaunite alchemist of unmatched intellect, who has devoted his life to pushing the boundaries of knowledge—with no price, even his own sanity, too high to pay. Is there a method to his madness? His concoctions rarely fail, but it appears to...",
			"allytips": [
				"Poison Trail is very effective at farming and harassing, allowing Singed to dominate the flow of whatever lane he's in.",
				"Use Insanity Potion to trick your opponents into chasing you through your Poison Trail.",
				"Flinging enemies into your tower can deal heavy amounts of damage to them."
			],
			"enemytips": [
				"Keep your distance to avoid being Flung back into Singed's allies.",
				"Singed needs to run close to your team to be effective. Try to take advantage of this by using crowd control effects on him while attacking his allies.",
				"Be careful when chasing Singed. He's very difficult to bring down, and can leave his Poison Trail to damage you in your pursuit."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 8,
				"magic": 7,
				"difficulty": 5
			},
			"stats": {
				"hp": 580,
				"hpperlevel": 85,
				"mp": 290.6,
				"mpperlevel": 45,
				"movespeed": 345,
				"armor": 37,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.55,
				"mpregen": 7.524,
				"mpregenperlevel": 0.55,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 62.32,
				"attackdamageperlevel": 3.375,
				"attackspeedoffset": 0.02,
				"attackspeedperlevel": 1.81
			},
			"spells": [
				{
					"id": "PoisonTrail",
					"name": "Poison Trail",
					"description": "Leaves a trail of poison behind Singed, dealing damage to enemies caught in the path.",
					"tooltip": "<span class=\"colorFF9900\">Toggle: </span>Singed lays a poisonous trail that deals {{ e1 }} <span class=\"color99FF99\">(+{{ charabilitypower*4 }})</span> magic damage per second.",
					"leveltip": {
						"label": [
							"Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						13,
						13,
						13,
						13,
						13
					],
					"costBurn": "13",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							3.25,
							3.25,
							3.25,
							3.25,
							3.25
						],
						[
							2.1,
							2.1,
							2.1,
							2.1,
							2.1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"1",
						"3.25",
						"2.1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana per Second",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "PoisonTrail.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana per Second"
				},
				{
					"id": "MegaAdhesive",
					"name": "Mega Adhesive",
					"description": "Throws a vial of mega adhesive on the ground, slowing and grounding enemies who walk on it.",
					"tooltip": "Singed leaves a sticky area on the ground for {{ e2 }} seconds. Enemies in the area are slowed by {{ e1 }}% and grounded, prohibiting the use of Movement abilities.<br /><br />If Singed flings a target into the zone, it will root them.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Mana Cost "
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						16,
						15,
						14,
						13
					],
					"cooldownBurn": "17/16/15/14/13",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							265,
							265,
							265,
							265,
							265
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40",
						"3",
						"0",
						"265",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "MegaAdhesive.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "Fling",
					"name": "Fling",
					"description": "Damages target enemy unit and flings them into the air behind Singed. If the target Singed flings lands in his Mega Adhesive, they are also rooted.",
					"tooltip": "Singed flings an enemy over his shoulder, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> plus {{ e3 }}% of the target's maximum Health as magic damage. Max 300 bonus damage against minions and monsters.<br /><br />If the target Singed flings lands in his Mega Adhesive, they are also rooted for {{ e2 }} second(s).",
					"leveltip": {
						"label": [
							"Damage",
							"Max Health Damage",
							"Root Duration",
							"Mana Cost "
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						80,
						95,
						110,
						125,
						140
					],
					"costBurn": "80/95/110/125/140",
					"effect": [
						null,
						[
							50,
							65,
							80,
							95,
							110
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							6,
							6.5,
							7,
							7.5,
							8
						],
						[
							420,
							420,
							420,
							420,
							420
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/65/80/95/110",
						"1/1.25/1.5/1.75/2",
						"6/6.5/7/7.5/8",
						"420",
						"300",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						125,
						125,
						125,
						125,
						125
					],
					"rangeBurn": "125",
					"image": {
						"full": "Fling.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "InsanityPotion",
					"name": "Insanity Potion",
					"description": "Singed drinks a potent brew of chemicals, granting him increased combat stats.",
					"tooltip": "Singed drinks a potent brew of chemicals, granting him {{ e1 }} Ability Power, Armor, Magic Resist, Movement Speed, Health Regen, and Mana Regen for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Bonus Stats",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							35,
							60,
							85
						],
						[
							25,
							25,
							25
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/60/85",
						"25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "InsanityPotion.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Noxious Slipstream",
				"description": "Singed drafts off nearby champions, gaining a burst of movement speed when passing them.",
				"image": {
					"full": "Singed_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Singed",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1082",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3801",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1082",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3801",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Singed",
					"title": "SingedTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Sion": {
			"id": "Sion",
			"key": "14",
			"name": "Sion",
			"title": "The Undead Juggernaut",
			"image": {
				"full": "Sion.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 432,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "14000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "14001",
					"num": 1,
					"name": "Hextech Sion",
					"chromas": false
				},
				{
					"id": "14002",
					"num": 2,
					"name": "Barbarian Sion",
					"chromas": false
				},
				{
					"id": "14003",
					"num": 3,
					"name": "Lumberjack Sion",
					"chromas": false
				},
				{
					"id": "14004",
					"num": 4,
					"name": "Warmonger Sion",
					"chromas": false
				},
				{
					"id": "14005",
					"num": 5,
					"name": "Mecha Zero Sion",
					"chromas": false
				}
			],
			"lore": "A war hero from a bygone era, Sion was revered in Noxus for choking the life out of a Demacian king with his bare hands—but, denied oblivion, he was resurrected to serve his empire even in death. His indiscriminate slaughter claimed all who stood in his way, regardless of allegiance, proving he no longer retained his former humanity. Even so, with crude armor bolted onto rotten flesh, Sion continues to charge into battle with reckless abandon, struggling to remember his true self between the swings of his mighty axe.",
			"blurb": "A war hero from a bygone era, Sion was revered in Noxus for choking the life out of a Demacian king with his bare hands—but, denied oblivion, he was resurrected to serve his empire even in death. His indiscriminate slaughter claimed all who stood in his...",
			"allytips": [
				"You only have very slight turning ability during Unstoppable Onslaught, so make sure to use it in straight paths.",
				"Roar of the Slayer is a great setup ability to land a very powerful Decimating Smash.",
				"The Soul Furnace buff displays how much shield strength is remaining, use this information to time its explosion perfectly."
			],
			"enemytips": [
				"Even if Sion still hits a Decimating Smash, making him release the charge earlier reduces its impact.",
				"Use the time after Sion has died to reposition and prepare for his return."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 9,
				"magic": 3,
				"difficulty": 5
			},
			"stats": {
				"hp": 542.64,
				"hpperlevel": 73,
				"mp": 325.6,
				"mpperlevel": 42,
				"movespeed": 345,
				"armor": 32,
				"armorperlevel": 3,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 10,
				"hpregenperlevel": 0.8,
				"mpregen": 8.008,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 4,
				"attackspeedoffset": -0.08,
				"attackspeedperlevel": 1.3
			},
			"spells": [
				{
					"id": "SionQ",
					"name": "Decimating Smash",
					"description": "Sion charges a powerful swing in an area in front of himself that will deal damage to enemies when released. If he charges for enough time, enemies hit by the swing will also be knocked up and stunned.</font>",
					"tooltip": "Sion charges up a heavy blow for up to 2 seconds. When released, he deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> to {{ e4 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage to enemies hit ({{ e8 }}% damage to minions) and briefly slows them.<br /><br />If Sion charges for at least 1 second, enemies are knocked up and stunned for 1.25 to 2.25 seconds.",
					"leveltip": {
						"label": [
							"Minimum Damage",
							"Maximum Damage",
							"Cooldown "
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							0.65,
							0.65,
							0.65,
							0.65,
							0.65
						],
						[
							60,
							120,
							180,
							240,
							300
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							1.95,
							1.95,
							1.95,
							1.95,
							1.95
						],
						[
							7.5,
							7.5,
							7.5,
							7.5,
							7.5
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							80,
							80,
							80,
							80,
							80
						],
						[
							-0.8,
							-0.8,
							-0.8,
							-0.8,
							-0.8
						]
					],
					"effectBurn": [
						null,
						"20/40/60/80/100",
						"1.25",
						"0.65",
						"60/120/180/240/300",
						"2.5",
						"1.95",
						"7.5",
						"60",
						"80",
						"-0.8"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.6,
							"key": "f1"
						},
						{
							"link": "attackdamage",
							"coeff": 1.8,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						10000,
						10000,
						10000,
						10000,
						10000
					],
					"rangeBurn": "10000",
					"image": {
						"full": "SionQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SionW",
					"name": "Soul Furnace",
					"description": "Sion shields himself and can reactivate after 3 seconds to deal Magic Damage to enemies nearby. When Sion kills enemies, he passively gains maximum Health.",
					"tooltip": "<span class=\"colorFFE076\">Passive:</span> Sion gains {{ e5 }} maximum Health when he kills a unit ({{ e6 }} for champion kills, assists, large minions and large monsters). <span class=\"colorFF3300\">Current Bonus: {{ f1 }} </span><br /><br /><span class=\"colorFFE076\">Active:</span> Sion shields himself for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFF3300\">(+{{ f2 }})</span> ({{ e3 }}% of maximum Health) for 6 seconds. After {{ e7 }} seconds, while the shield holds, Sion can reactivate to deal {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> plus {{ e4 }}% of the target's maximum Health as magic damage to nearby enemies. Max 400 bonus damage to minions and monsters.",
					"leveltip": {
						"label": [
							"Shield",
							"Damage",
							"Max Health Damage",
							"Max Health Shield Ratio",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						11,
						11,
						11,
						11
					],
					"cooldownBurn": "11",
					"cost": [
						65,
						70,
						75,
						80,
						85
					],
					"costBurn": "65/70/75/80/85",
					"effect": [
						null,
						[
							30,
							55,
							80,
							105,
							130
						],
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							8,
							9,
							10,
							11,
							12
						],
						[
							10,
							11,
							12,
							13,
							14
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/55/80/105/130",
						"40/65/90/115/140",
						"8/9/10/11/12",
						"10/11/12/13/14",
						"3",
						"10",
						"3",
						"10",
						"6",
						"0"
					],
					"vars": [
						{
							"link": "health",
							"coeff": 0.1,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "SionW.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SionE",
					"name": "Roar of the Slayer",
					"description": "Sion fires a short range shockwave that damages and slows and reduces the Armor of the first enemy hit. If the shockwave hits a minion or monster, it will be knocked back, damaging and slowing all enemies that it passes through.",
					"tooltip": "Sion fires a shockwave, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first enemy hit, slowing it by {{ e2 }}%, and reducing its Armor by {{ e5 }}% for 2.5 seconds.<br /><br />If the target is not a champion, it will be knocked back. Enemies that the knocked back unit collides with take {{ e6 }}% bonus damage and are slowed by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown",
							"Mana Cost "
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						35,
						40,
						45,
						50,
						55
					],
					"costBurn": "35/40/45/50/55",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"40/45/50/55/60",
						"5",
						"40/45/50/55/60",
						"20",
						"30",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "SionE.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SionR",
					"name": "Unstoppable Onslaught",
					"description": "Sion charges in a direction, ramping up speed over time. He can steer his charge slightly with the mouse cursor location. When he collides with an enemy he deals damage and knocks them up based on the distance he has charged.",
					"tooltip": "Sion charges in a direction for 8 seconds and can steer slowly towards the mouse cursor. While charging, Sion is immune to all Crowd Control. Reactivating will cancel Sion's charge early.<br /><br />When Sion collides with an enemy champion or wall, he deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and knocks up enemies in a small area for {{ e5 }} seconds. Enemies in a larger area take the same damage and are slowed by {{ e3 }}% for 3 seconds.<br /><br />The damage increases to {{ e2 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> and the stun increases to {{ e6 }} seconds as Sion charges farther.",
					"leveltip": {
						"label": [
							"Minimum Damage",
							"Maximum Damage",
							"Slow",
							"Cooldown "
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						100,
						60
					],
					"cooldownBurn": "140/100/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							300,
							450
						],
						[
							400,
							800,
							1200
						],
						[
							40,
							45,
							50
						],
						[
							500,
							500,
							500
						],
						[
							0.75,
							0.75,
							0.75
						],
						[
							1.75,
							1.75,
							1.75
						],
						[
							950,
							950,
							950
						],
						[
							0,
							0,
							0
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/300/450",
						"400/800/1200",
						"40/45/50",
						"500",
						"0.75",
						"1.75",
						"950",
						"0",
						"2",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.4,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						7500,
						7500,
						7500
					],
					"rangeBurn": "7500",
					"image": {
						"full": "SionR.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Glory in Death",
				"description": "After being killed, Sion will reanimate with rapidly decaying Health. His attacks become very rapid, gain 100% Lifesteal and deal bonus damage equal to 10% of his target's maximum Health (max 75 to monsters).<br><br>All his abilities are replaced with Death Surge, which grants a burst of Movement Speed.",
				"image": {
					"full": "Sion_Passive1.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Sion",
					"title": "SionARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sion",
					"title": "SionCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sion",
					"title": "SionFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sion",
					"title": "SionKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sion",
					"title": "SionSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sion",
					"title": "SionSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "S5_SummonerSmiteDuel",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sion",
					"title": "SionTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Sivir": {
			"id": "Sivir",
			"key": "15",
			"name": "Sivir",
			"title": "the Battle Mistress",
			"image": {
				"full": "Sivir.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 0,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "15000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "15001",
					"num": 1,
					"name": "Warrior Princess Sivir",
					"chromas": false
				},
				{
					"id": "15002",
					"num": 2,
					"name": "Spectacular Sivir",
					"chromas": false
				},
				{
					"id": "15003",
					"num": 3,
					"name": "Huntress Sivir",
					"chromas": false
				},
				{
					"id": "15004",
					"num": 4,
					"name": "Bandit Sivir",
					"chromas": false
				},
				{
					"id": "15005",
					"num": 5,
					"name": "PAX Sivir",
					"chromas": false
				},
				{
					"id": "15006",
					"num": 6,
					"name": "Snowstorm Sivir",
					"chromas": false
				},
				{
					"id": "15007",
					"num": 7,
					"name": "Warden Sivir",
					"chromas": false
				},
				{
					"id": "15008",
					"num": 8,
					"name": "Victorious Sivir",
					"chromas": false
				},
				{
					"id": "15009",
					"num": 9,
					"name": "Neo PAX Sivir",
					"chromas": false
				}
			],
			"lore": "Sivir is a renowned fortune hunter and mercenary captain who plies her trade in the deserts of Shurima. Armed with her legendary jeweled crossblade, she has fought and won countless battles for those who can afford her exorbitant price. Known for her fearless resolve and endless ambition, she prides herself on recovering buried treasures from the perilous tombs of Shurima—for a generous bounty. With ancient forces stirring the very bones of Shurima, Sivir finds herself torn between conflicting destinies.",
			"blurb": "Sivir is a renowned fortune hunter and mercenary captain who plies her trade in the deserts of Shurima. Armed with her legendary jeweled crossblade, she has fought and won countless battles for those who can afford her exorbitant price. Known for her...",
			"allytips": [
				"Sivir's Boomerang Blade returns to her after reaching the max range, so you can shift position to hit enemies who would otherwise have evaded it.",
				"Ricochet resets Sivir's basic attack timer on activation, so activating this immediately after landing a normal basic attack will maximize damage output.",
				"Try saving Spell Shield for enemy abilities that can disable you such as stuns and roots."
			],
			"enemytips": [
				"Boomerang Blade costs a lot of mana to cast, so dodging it sets Sivir back. If it hits you on the way out, avoid its path on the way back.",
				"Sivir is a powerful pushing champion, so leaving her unattended in a lane for too long will often result in your turrets being destroyed.",
				"When laning against Sivir, it is possible to throw off the timing of her Spell Shield by faking an advance, then backing off."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 3,
				"magic": 1,
				"difficulty": 4
			},
			"stats": {
				"hp": 515.76,
				"hpperlevel": 82,
				"mp": 284,
				"mpperlevel": 50,
				"movespeed": 335,
				"armor": 31,
				"armorperlevel": 3.25,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 5,
				"hpregenperlevel": 0.55,
				"mpregen": 8.012,
				"mpregenperlevel": 0.9,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.6
			},
			"spells": [
				{
					"id": "SivirQ",
					"name": "Boomerang Blade",
					"description": "Sivir hurls her crossblade like a boomerang, dealing damage each way.",
					"tooltip": "Sivir hurls her crossblade like a boomerang, which deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to the first target hit and {{ e2 }}% reduced damage to each subsequent target down to a minimum of {{ e3 }}%.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Attack Damage Scaling",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							35,
							55,
							75,
							95,
							115
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							0.7,
							0.8,
							0.9,
							1,
							1.1
						],
						[
							70,
							80,
							90,
							100,
							110
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/55/75/95/115",
						"15",
						"40",
						"0.7/0.8/0.9/1/1.1",
						"70/80/90/100/110",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "SivirQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SivirW",
					"name": "Ricochet",
					"description": "Sivir's next few basic attacks will bounce to nearby targets, dealing reduced damage to secondary targets.",
					"tooltip": "Sivir's next {{ e4 }} basic attacks bounce to nearby targets, dealing <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage to the first target and <span class=\"colorFF8C00\">{{ f2 }}</span> physical damage to each subsequent target.<br /><br />If a given Ricochet attack critically strikes its first target, all subsequent bounces from that attack will also critically strike.<br /><br /><span class=\"color919191\"><i>Targets cannot be hit more than once by a given Ricochet attack and on-hit effects are applied only to the first target of each attack.</i></span>",
					"leveltip": {
						"label": [
							"Cooldown",
							"Bounce Damage (total attack damage)"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						10.5,
						9,
						7.5,
						6
					],
					"cooldownBurn": "12/10.5/9/7.5/6",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							5,
							6,
							7,
							8,
							9
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							50,
							55,
							60,
							65,
							70
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							60,
							70,
							80,
							90,
							100
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							4.5,
							4.25,
							4,
							3.75,
							3.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5/6/7/8/9",
						"10/20/30/40/50",
						"50/55/60/65/70",
						"3",
						"60/70/80/90/100",
						"1",
						"0",
						"4.5/4.25/4/3.75/3.5",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0,
							"key": "f1"
						},
						{
							"link": "attackdamage",
							"coeff": 0,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "SivirW.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SivirE",
					"name": "Spell Shield",
					"description": "Creates a magical barrier that blocks a single enemy ability cast on Sivir. She receives Mana back if a spell is blocked.",
					"tooltip": "Sivir creates a magical barrier for {{ e1 }} seconds that blocks the next incoming enemy ability.<br /><br />If an ability is blocked by the shield, Sivir regains {{ e2 }} Mana.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Mana Gain"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						19,
						16,
						13,
						10
					],
					"cooldownBurn": "22/19/16/13/10",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							80,
							95,
							110,
							125,
							140
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.5",
						"80/95/110/125/140",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "SivirE.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "SivirR",
					"name": "On The Hunt",
					"description": "Sivir leads her allies in battle, granting them a surge Movement Speed for a period of time. Additionally passively grants Sivir bonus Attack Speed while Ricochet is active.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Sivir gains {{ e1 }}% Attack Speed while Ricochet is active.<br /><br /><span class=\"colorFF9900\">Active: </span>Sivir rallies her allies for {{ e3 }} seconds, granting all nearby allies an initial {{ e4 }}% Movement Speed bonus that reduces to {{ e2 }}% after the first {{ e5 }} seconds of On The Hunt elapse.",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Enhanced Movement Speed Bonus",
							"Enhanced Movement Speed Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							30,
							45,
							60
						],
						[
							20,
							20,
							20
						],
						[
							8,
							8,
							8
						],
						[
							40,
							50,
							60
						],
						[
							2,
							3,
							4
						],
						[
							1000,
							1000,
							1000
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/45/60",
						"20",
						"8",
						"40/50/60",
						"2/3/4",
						"1000",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "SivirR.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Fleet of Foot",
				"description": "Sivir gains a short burst of Movement Speed when she attacks an enemy champion.",
				"image": {
					"full": "Sivir_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Sivir",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sivir",
					"title": "SivirTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Skarner": {
			"id": "Skarner",
			"key": "72",
			"name": "Skarner",
			"title": "the Crystal Vanguard",
			"image": {
				"full": "Skarner.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 48,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "72000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "72001",
					"num": 1,
					"name": "Sandscourge Skarner",
					"chromas": false
				},
				{
					"id": "72002",
					"num": 2,
					"name": "Earthrune Skarner",
					"chromas": false
				},
				{
					"id": "72003",
					"num": 3,
					"name": "Battlecast Alpha Skarner",
					"chromas": false
				},
				{
					"id": "72004",
					"num": 4,
					"name": "Guardian of the Sands Skarner",
					"chromas": false
				}
			],
			"lore": "Skarner is an immense crystalline scorpion from a hidden valley in Shurima. Part of the ancient Brackern race, Skarner and his kin are known for their great wisdom and deep connection to the land, as their souls are fused with powerful life crystals which hold the living thoughts and memories of their ancestors. In an age long past, the Brackern entered hibernation to avoid untold magical destruction, but recent, threatening events have roused Skarner. As the only Brackern awake, he strives to protect his kind from those who seek to harm them.",
			"blurb": "Skarner is an immense crystalline scorpion from a hidden valley in Shurima. Part of the ancient Brackern race, Skarner and his kin are known for their great wisdom and deep connection to the land, as their souls are fused with powerful life crystals...",
			"allytips": [
				"Basic attacks reduce the cooldown of Crystal Slash. Use them as often as possible for maximum damage.",
				"Capturing Crystal Spires before attempting neutral objectives or team fights around them improves Skarner's performance in said fights dramatically.",
				"Impale is extremely powerful when you use it to position an enemy so your allies can attack them."
			],
			"enemytips": [
				"Skarner can't harm you very much outside of short range, so stay away from him!",
				"Skarner's Movement Speed is increased as long as his shield, Crystalline Exoskeleton, persists. Attack him to lower his speed.",
				"Skarner is especially dangerous when inside Crystal Spire zones his team controls. Try to capture them ahead of time if a fight may break out around them."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 6,
				"magic": 5,
				"difficulty": 5
			},
			"stats": {
				"hp": 601.28,
				"hpperlevel": 90,
				"mp": 320,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 38,
				"armorperlevel": 3.8,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9,
				"hpregenperlevel": 0.85,
				"mpregen": 7.206,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 4.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.1
			},
			"spells": [
				{
					"id": "SkarnerVirulentSlash",
					"name": "Crystal Slash",
					"description": "Skarner lashes out with his claws, dealing physical damage to all nearby enemies and charging himself with Crystal Energy for several seconds if a unit is struck. If he casts Crystal Slash again while powered by Crystal Energy, he deals bonus magic damage.",
					"tooltip": "Skarner deals <span class=\"colorFF8C00\">{{ f1 }}</span> physical damage to all nearby enemies. If a unit is struck, he charges himself with Crystal Energy for {{ e2 }} seconds.<br /><br />While Skarner is charged, Crystal Slash deals <span class=\"colorFF8C00\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage.<br /><br />Basic attacks against non-structures lower Crystal Slash's cooldown by 0.25 seconds (quadrupled against champions).",
					"leveltip": {
						"label": [
							"Total Attack Damage Ratio",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						3.5,
						3.25,
						3,
						2.75,
						2.5
					],
					"cooldownBurn": "3.5/3.25/3/2.75/2.5",
					"cost": [
						10,
						11,
						12,
						13,
						14
					],
					"costBurn": "10/11/12/13/14",
					"effect": [
						null,
						[
							33,
							36,
							39,
							42,
							45
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"33/36/39/42/45",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "f1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "f1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "SkarnerVirulentSlash.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SkarnerExoskeleton",
					"name": "Crystalline Exoskeleton",
					"description": "Skarner gains a shield and has increased Movement Speed while the shield persists.",
					"tooltip": "Skarner is shielded for <span class=\"colorCC3300\">{{ f1 }}</span> ({{ e1 }}% of his maximum health) <span class=\"color99FF99\">(+{{ a1 }})</span> damage for {{ e4 }} seconds. While the shield persists, Skarner gains movement speed that ramps up to {{ e5 }}% over 3 seconds.",
					"leveltip": {
						"label": [
							"Max Health Damage Absorption",
							"Movement Speed Bonus",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e5 }}% -> {{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12.5,
						12,
						11.5,
						11
					],
					"cooldownBurn": "13/12.5/12/11.5/11",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							10,
							11,
							12,
							13,
							14
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							8,
							10,
							12,
							14,
							16
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							16,
							20,
							24,
							28,
							32
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/11/12/13/14",
						"30/35/40/45/50",
						"8/10/12/14/16",
						"6",
						"16/20/24/28/32",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "SkarnerExoskeleton.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SkarnerFracture",
					"name": "Fracture",
					"description": "Skarner summons a blast of crystalline energy which deals damage to enemies struck and slows them. Basic attacking these enemies within a short window will stun them.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> Crystallizing enemies with Fracture and Impale grants <span class=\"colorFFF673\">Crystal Charge</span> for the disable duration and reduces the cooldown of Fracture by the same amount.<br /><br /><span class=\"colorFF9900\">Active:</span> Skarner summons a blast of crystalline energy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, slowing targets hit by {{ e8 }}% for {{ e7 }} seconds and reducing the blast's speed.<br /><br />Enemies hit by Fracture are afflicted with Crystal Venom for {{ e6 }} seconds, causing Skarner's next basic attack against them to deal {{ e2 }} additional physical damage and stun the target for {{ e3 }} second.",
					"leveltip": {
						"label": [
							"Blast Damage / Attack Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} / {{ e2 }} -> {{ e1NL }} / {{ e2NL }}",
							"{{ e8 }}% -> {{ e8NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13.5,
						13,
						12.5,
						12
					],
					"cooldownBurn": "14/13.5/13/12.5/12",
					"cost": [
						55,
						55,
						55,
						55,
						55
					],
					"costBurn": "55",
					"effect": [
						null,
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/65/90/115/140",
						"30/50/70/90/110",
						"1.5",
						"50",
						"6",
						"5",
						"2.5",
						"30/35/40/45/50",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						980,
						980,
						980,
						980,
						980
					],
					"rangeBurn": "980",
					"image": {
						"full": "SkarnerFracture.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SkarnerImpale",
					"name": "Impale",
					"description": "Skarner suppresses an enemy champion and deals damage to it. During this time, Skarner can move freely and will drag his helpless victim around with him. When the effect ends, the target will be dealt additional damage.",
					"tooltip": "Skarner suppresses an enemy champion for {{ e1 }} seconds, dealing <span class=\"colorFF8C00\">{{ a2 }}</span> physical damage plus {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Skarner can move freely during this time, and will drag his helpless victim around with him. When the effect ends, Skarner's target will be dealt the same damage again.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							1.75,
							1.75,
							1.75
						],
						[
							20,
							60,
							100
						],
						[
							50,
							75,
							100
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.75",
						"20/60/100",
						"50/75/100",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.6,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "SkarnerImpale.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Crystal Spires",
				"description": "Skarner's presence causes crystals to spawn in set locations around the map. While near crystals his team owns, Skarner gains tremendous movement speed, attack speed, and mana regeneration.",
				"image": {
					"full": "Skarner_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Skarner",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": true
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Skarner",
					"title": "SkarnerTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Sona": {
			"id": "Sona",
			"key": "37",
			"name": "Sona",
			"title": "Maven of the Strings",
			"image": {
				"full": "Sona.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 96,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "37000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "37001",
					"num": 1,
					"name": "Muse Sona",
					"chromas": false
				},
				{
					"id": "37002",
					"num": 2,
					"name": "Pentakill Sona",
					"chromas": false
				},
				{
					"id": "37003",
					"num": 3,
					"name": "Silent Night Sona",
					"chromas": false
				},
				{
					"id": "37004",
					"num": 4,
					"name": "Guqin Sona",
					"chromas": true
				},
				{
					"id": "37005",
					"num": 5,
					"name": "Arcade Sona",
					"chromas": false
				},
				{
					"id": "37006",
					"num": 6,
					"name": "DJ Sona",
					"chromas": false
				},
				{
					"id": "37007",
					"num": 7,
					"name": "Sweetheart Sona",
					"chromas": false
				}
			],
			"lore": "Sona is Demacia's foremost virtuoso of the stringed etwahl, speaking only through her graceful chords and vibrant arias. This genteel manner has endeared her to the highborn, though others suspect her spellbinding melodies to actually emanate magic—a Demacian taboo. Silent to outsiders but somehow understood by close companions, Sona plucks her harmonies not only to soothe injured allies, but also to strike down unsuspecting enemies.",
			"blurb": "Sona is Demacia's foremost virtuoso of the stringed etwahl, speaking only through her graceful chords and vibrant arias. This genteel manner has endeared her to the highborn, though others suspect her spellbinding melodies to actually emanate magic—a...",
			"allytips": [
				"Make sure to tag your allies while Sona's auras are active, but avoid getting caught out by enemies.",
				"Save Crescendo for the game-altering moment.",
				"Well-timed uses of Aria of Perseverance will grant you maximum survivability."
			],
			"enemytips": [
				"Spread out when you see Sona so she can't make your entire team dance.",
				"Kill Sona first, as she will heal up her team if left alone for too long."
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 2,
				"magic": 8,
				"difficulty": 4
			},
			"stats": {
				"hp": 482.36,
				"hpperlevel": 77,
				"mp": 340.6,
				"mpperlevel": 45,
				"movespeed": 325,
				"armor": 28,
				"armorperlevel": 3.3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 11.5,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 46,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.03,
				"attackspeedperlevel": 2.3
			},
			"spells": [
				{
					"id": "SonaQ",
					"name": "Hymn of Valor",
					"description": "Sona plays the Hymn of Valor, sends out bolts of sound, dealing magic damage to two nearby enemies, prioritizing champions and monsters. Sona gains a temporary aura that grants allies tagged by the zone bonus damage on their next attack against enemies.",
					"tooltip": "<span class=\"colorFF9900\">Active:</span> Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the nearest two enemies (prioritizes champions) and changes her <span class=\"colorEEEEEE\">Power Chord</span> bonus to <span class=\"color4477FF\">Staccato</span>.<br /><br /><span class=\"colorFF9900\">Melody:</span> Sona gains an aura for {{ e3 }} seconds. Allied champions that enter the aura will gain an additional {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage on their next attack.",
					"leveltip": {
						"label": [
							"Damage (active)",
							"Damage (melody)",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/70/100/130/160",
						"400",
						"3",
						"10/15/20/25/30",
						"5",
						"0.4",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						825,
						825,
						825,
						825,
						825
					],
					"rangeBurn": "825",
					"image": {
						"full": "SonaQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SonaW",
					"name": "Aria of Perseverance",
					"description": "Sona plays the Aria of Perseverance, sending out protective melodies, healing Sona and a nearby wounded ally. Sona gains a temporary aura that grants allies tagged by the zone a temporary shield.",
					"tooltip": "<span class=\"colorFF9900\">Active:</span> Restores {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health to Sona and a nearby allied champion (prioritizes most wounded) and changes her <span class=\"colorEEEEEE\">Power Chord</span> bonus to <span class=\"color44FF77\">Diminuendo</span>.<br /><br /><span class=\"colorFF9900\">Melody:</span> Sona gains an aura for {{ e3 }} seconds. Allied champions that enter the aura will gain a shield that prevents up to {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> damage within the next {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Heal (active)",
							"Shield (melody)",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						10,
						10,
						10,
						10
					],
					"cooldownBurn": "10",
					"cost": [
						80,
						85,
						90,
						95,
						100
					],
					"costBurn": "80/85/90/95/100",
					"effect": [
						null,
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							25,
							50,
							75,
							100,
							125
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0.04,
							0.04,
							0.04,
							0.04,
							0.04
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/50/70/90/110",
						"400",
						"3",
						"25/50/75/100/125",
						"1.5",
						"0.25",
						"0.04",
						"3",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "SonaW.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SonaE",
					"name": "Song of Celerity",
					"description": "Sona plays the Song of Celerity, granting nearby allies bonus Movement Speed. Sona gains a temporary aura that grants allied champions tagged by the zone bonus Movement Speed on their next attack.",
					"tooltip": "<span class=\"colorFF9900\">Active:</span> Grants Sona <span class=\"color99FF99\">{{ f1*100 }}%</span> movement speed [{{ e1 }}% + {{ f2*100 }}% per 100 ability power] for {{ e9 }} seconds (or until damaged) and changes her <span class=\"colorEEEEEE\">Power Chord</span> bonus to <span class=\"colorDD5599\">Tempo</span>.<br /><br /><span class=\"colorFF9900\">Melody:</span> Sona gains an aura for {{ e3 }} seconds. Allied champions that enter the aura will gain <span class=\"color99FF99\">{{ f3*100 }}%</span> movement speed for {{ e5 }} seconds.<br /><br /><span class=\"color919191\"><i>Sona's personal movement speed increase will always last at least {{ e5 }} seconds.</i></span>",
					"leveltip": {
						"label": [
							"Movement Speed"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						65,
						65,
						65,
						65,
						65
					],
					"costBurn": "65",
					"effect": [
						null,
						[
							10,
							11,
							12,
							13,
							14
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.1,
							0.11,
							0.12,
							0.13,
							0.14
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0.04,
							0.04,
							0.04,
							0.04,
							0.04
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/11/12/13/14",
						"400",
						"3",
						"0.1/0.11/0.12/0.13/0.14",
						"3",
						"0.4",
						"0.04",
						"2",
						"7",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						430,
						430,
						430,
						430,
						430
					],
					"rangeBurn": "430",
					"image": {
						"full": "SonaE.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SonaR",
					"name": "Crescendo",
					"description": "Sona plays her ultimate chord, stunning enemy champions and forcing them to dance and dealing magic damage to them. Each rank reduces the base cooldown of Sona's basic abilities.",
					"tooltip": "<span class=\"colorFF9900\">Active: </span>Strikes an irresistible chord, stunning enemy Champions and forcing them to dance for {{ e2 }} seconds and take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorFF9900\">Passive: </span>Reduces the base cooldown of Sona's basic abilities by {{ e3 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Hymn of Valor Cooldown",
							"Aria of Perseverance Cooldown",
							"Song of Celerity Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ f1 }} -> {{ f2 }}",
							"{{ f3 }} -> {{ f4 }}",
							"{{ f5 }} -> {{ f6 }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						120,
						100
					],
					"cooldownBurn": "140/120/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							10,
							25,
							40
						],
						[
							-0.1,
							-0.25,
							-0.4
						],
						[
							-0.1,
							-0.25,
							-0.4
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"1.5",
						"10/25/40",
						"-0.1/-0.25/-0.4",
						"-0.1/-0.25/-0.4",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "SonaR.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Power Chord",
				"description": "After casting 3 spells, Sona's next attack deals bonus magic damage in addition to a bonus effect depending on what song Sona last activated.",
				"image": {
					"full": "Sona_Passive_Charged.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Sona",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "ability_scaling",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "ability_scaling",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "ability_scaling",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3114",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "ability_scaling",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Sona",
					"title": "SonaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Soraka": {
			"id": "Soraka",
			"key": "16",
			"name": "Soraka",
			"title": "the Starchild",
			"image": {
				"full": "Soraka.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 144,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "16000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "16001",
					"num": 1,
					"name": "Dryad Soraka",
					"chromas": false
				},
				{
					"id": "16002",
					"num": 2,
					"name": "Divine Soraka",
					"chromas": false
				},
				{
					"id": "16003",
					"num": 3,
					"name": "Celestine Soraka",
					"chromas": false
				},
				{
					"id": "16004",
					"num": 4,
					"name": "Reaper Soraka",
					"chromas": false
				},
				{
					"id": "16005",
					"num": 5,
					"name": "Order of the Banana Soraka",
					"chromas": false
				},
				{
					"id": "16006",
					"num": 6,
					"name": "Program Soraka",
					"chromas": false
				},
				{
					"id": "16007",
					"num": 7,
					"name": "Star Guardian Soraka",
					"chromas": false
				}
			],
			"lore": "A wanderer from the celestial dimensions beyond Mount Targon, Soraka gave up her immortality to protect the mortal races from their own more violent instincts. She endeavors to spread the virtues of compassion and mercy to everyone she meets—even healing those who would wish harm upon her. And, for all Soraka has seen of this world's struggles, she still believes the people of Runeterra have yet to reach their full potential.",
			"blurb": "A wanderer from the celestial dimensions beyond Mount Targon, Soraka gave up her immortality to protect the mortal races from their own more violent instincts. She endeavors to spread the virtues of compassion and mercy to everyone she meets—even...",
			"allytips": [
				"Soraka is a powerful ally in battle, using her strong healing to keep the party moving forward.",
				"You can use Wish on your allies from across the map to save them from otherwise fatal events.",
				"Equinox can be used as a powerful zoning tool to keep enemies at bay."
			],
			"enemytips": [
				"Focus on attacking Soraka when she ever ventures to the frontline to heal her allies.",
				"Take advantage of Soraka's long cooldown on Equinox if she uses it to harass.",
				"It's easier to focus Soraka than the ally she is healing."
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 5,
				"magic": 7,
				"difficulty": 3
			},
			"stats": {
				"hp": 529.04,
				"hpperlevel": 78,
				"mp": 350.8,
				"mpperlevel": 60,
				"movespeed": 325,
				"armor": 32,
				"armorperlevel": 3.8,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 2.5,
				"hpregenperlevel": 0.5,
				"mpregen": 11.5,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 50.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.14
			},
			"spells": [
				{
					"id": "SorakaQ",
					"name": "Starcall",
					"description": "A star falls from the sky at the target location dealing magic damage and slowing enemies. If an enemy champion is hit by Starcall, Soraka recovers health and gains movement speed when moving away from enemy champions.",
					"tooltip": "Calls down a star from Soraka to a target location. Enemies standing in the explosion radius take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed by {{ e2 }}% for 2 seconds.<br /><br />If Starcall hits a champion Soraka gains <span class=\"colorDDDDDD\">Rejuvenation</span> for {{ e5 }} seconds, which restores {{ e3 }} <span class=\"color99FF99\">(+{{ f1 }})</span> health per second and grants {{ e9 }}% movement speed when not moving toward enemy champions.",
					"leveltip": {
						"label": [
							"Damage",
							"Health Restore (Rejuvenation)",
							"Rejuvenation Duration (for allies)",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						5,
						5,
						5,
						5
					],
					"cooldownBurn": "5",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							14,
							16,
							18,
							20,
							22
						],
						[
							7,
							9,
							11,
							13,
							15
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							3,
							3.5,
							4,
							4.5,
							5
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0.05,
							0.05,
							0.05,
							0.05,
							0.05
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"30",
						"14/16/18/20/22",
						"7/9/11/13/15",
						"4",
						"3/3.5/4/4.5/5",
						"0.1",
						"0.05",
						"10",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						810,
						810,
						810,
						810,
						810
					],
					"rangeBurn": "810",
					"image": {
						"full": "SorakaQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SorakaW",
					"name": "Astral Infusion",
					"description": "Soraka sacrifices a portion of her own health to heal another friendly champion.",
					"tooltip": "Restores {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> health to another champion ally.<br /><br />If cast while affected by <span class=\"colorDDDDDD\">Rejuvenation</span>, Soraka will grant her target its benefits for {{ f1 }} seconds.<br /><br /><span class=\"color919191\"><i>Cannot be cast if Soraka is below 5% Health.</i></span>",
					"leveltip": {
						"label": [
							"Heal Amount",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						6.5,
						5,
						3.5,
						2
					],
					"cooldownBurn": "8/6.5/5/3.5/2",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/110/140/170/200",
						"0.1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "SorakaW.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "10% Max Health, {{ cost }} Mana"
				},
				{
					"id": "SorakaE",
					"name": "Equinox",
					"description": "Creates a zone at a location that silences all enemies inside. When the zone expires, all enemies still inside are rooted.",
					"tooltip": "Creates a zone at target location for 1.5 seconds, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemy Champions in the cast radius. Enemy Champions standing in the zone are silenced until they leave. <br /><br />When the zone disappears, all enemy Champions still standing in the zone are rooted for {{ e1 }} second(s) and are dealt {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }}) </span>magic damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Root Duration"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						22,
						20,
						18,
						16
					],
					"cooldownBurn": "24/22/20/18/16",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							40,
							70,
							100,
							130,
							160
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							260,
							260,
							260,
							260,
							260
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1/1.25/1.5/1.75/2",
						"70/110/150/190/230",
						"40/70/100/130/160",
						"5",
						"20/40/60/80/100",
						"60/90/120/150/180",
						"1.5",
						"260",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "SorakaE.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SorakaR",
					"name": "Wish",
					"description": "Soraka fills her allies with hope, instantly restoring health to herself and all friendly champions.",
					"tooltip": "Calls upon divine powers to restore {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health to all allied Champions. Wish's power is increased by 50% on each Champion below 40% Health.",
					"leveltip": {
						"label": [
							"Health Restored",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						160,
						145,
						130
					],
					"cooldownBurn": "160/145/130",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							120,
							90,
							60
						],
						[
							250,
							350,
							450
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"120/90/60",
						"250/350/450",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.55,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "SorakaR.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Salvation",
				"description": "Soraka runs faster towards nearby low health allies.",
				"image": {
					"full": "Soraka_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Soraka",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3096",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Soraka",
					"title": "SorakaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3301",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3504",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3060",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Swain": {
			"id": "Swain",
			"key": "50",
			"name": "Swain",
			"title": "the Noxian Grand General",
			"image": {
				"full": "Swain.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 192,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "50000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "50001",
					"num": 1,
					"name": "Northern Front Swain",
					"chromas": false
				},
				{
					"id": "50002",
					"num": 2,
					"name": "Bilgewater Swain",
					"chromas": false
				},
				{
					"id": "50003",
					"num": 3,
					"name": "Tyrant Swain",
					"chromas": false
				},
				{
					"id": "50004",
					"num": 4,
					"name": "Dragon Master Swain",
					"chromas": false
				}
			],
			"lore": "Jericho Swain is the visionary ruler of Noxus, an expansionist nation that reveres only strength. Though he was cast down and crippled in the Ionian wars, his left arm severed, he seized control of the empire with ruthless determination… and a new, demonic hand. Now, Swain commands from the front lines, marching against a coming darkness that only he can see—in glimpses gathered by shadowy ravens from the corpses all around him. In a swirl of sacrifice and secrets, the greatest secret of all is that the true enemy lies within.",
			"blurb": "Jericho Swain is the visionary ruler of Noxus, an expansionist nation that reveres only strength. Though he was cast down and crippled in the Ionian wars, his left arm severed, he seized control of the empire with ruthless determination… and a new...",
			"allytips": [
				"If you're having trouble rooting an enemy with Nevermove, try throwing it at opponents when they are near their minions so the explosion surprises them.",
				"While laning, try to use Death's Hand's piercing damage to damage opponents from a safe distance.",
				"Vision of Empire is quite difficult to land on its own, look for skirmishes around the map where enemies may be distracted or crowd controlled so you can land it more easily.",
				"Demonic Ascension may make Swain very hard to kill but he's pretty easy to get away from. Try building items that can slow opponents to keep them in range if their mobility is overwhelming."
			],
			"enemytips": [
				"Swain's passive is very potent if you are immobilized. Make sure to be extra careful around enemies who have immobilizing effects.",
				"High mobility counters all of Swain's basic abilities: Death's Hand does more damage the closer he is, Vision of Empire has a very long delay and Nevermove must start returning back to him to be dangerous.",
				"Buying an item with Grievous Wounds will make Swain much easier to kill during his Demonic Ascension."
			],
			"tags": [
				"Mage",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 6,
				"magic": 9,
				"difficulty": 8
			},
			"stats": {
				"hp": 525,
				"hpperlevel": 90,
				"mp": 374,
				"mpperlevel": 57,
				"movespeed": 335,
				"armor": 22.72,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 7,
				"hpregenperlevel": 0.65,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 58,
				"attackdamageperlevel": 2.7,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.11
			},
			"spells": [
				{
					"id": "SwainQ",
					"name": "Death's Hand",
					"description": "Swain unleashes several bolts of eldritch power that pierce through targets killed. Enemies hit take more damage for each bolt they are struck by.",
					"tooltip": "Swain unleashes {{ e5 }} bolts of eldritch power that strike the first enemy they hit and pierce through enemies they kill. Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, plus {{ e2 }}% per additional bolt. Max Damage: {{ f2 }}.<br /><br />Each unit killed by Death's Hand restores <span class=\"color44DDFF\">{{ f1 }}</span> Mana ({{ e4 }}% max mana).",
					"leveltip": {
						"label": [
							"Bolt Damage",
							"Additional Bolt Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7.5,
						6.25,
						5,
						3.75,
						2.5
					],
					"cooldownBurn": "7.5/6.25/5/3.75/2.5",
					"cost": [
						65,
						70,
						75,
						80,
						85
					],
					"costBurn": "65/70/75/80/85",
					"effect": [
						null,
						[
							65,
							85,
							105,
							125,
							145
						],
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							700,
							700,
							700,
							700,
							700
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							-0.4,
							-0.4,
							-0.4,
							-0.4,
							-0.4
						]
					],
					"effectBurn": [
						null,
						"65/85/105/125/145",
						"15/20/25/30/35",
						"3",
						"3",
						"5",
						"0.4",
						"700",
						"15/17.5/20/22.5/25",
						"0.75",
						"-0.4"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "SwainQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SwainW",
					"name": "Vision of Empire",
					"description": "Swain opens a demon eye that deals damage and slows enemies. Champions hit are revealed and also grant Swain a Soul Fragment.",
					"tooltip": "Swain opens a demon eye up to {{ castrange }} range away that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slows for {{ e4 }}% for {{ e7 }} seconds.<br /><br />Champions hit grant Swain a <span class=\"size18 colorFF3F3F\">Soul Fragment</span> and are revealed for {{ e9 }} seconds.<br /><br /><rules>Damage is reduced by {{ e6 }}% against minions.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Reveal Duration",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e9 }} -> {{ e9NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						21,
						20,
						19,
						18
					],
					"cooldownBurn": "22/21/20/19/18",
					"cost": [
						70,
						85,
						100,
						115,
						130
					],
					"costBurn": "70/85/100/115/130",
					"effect": [
						null,
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							0.05,
							0.05,
							0.05,
							0.05,
							0.05
						],
						[
							265,
							265,
							265,
							265,
							265
						],
						[
							25,
							35,
							45,
							55,
							65
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							420,
							420,
							420,
							420,
							420
						],
						[
							4,
							5,
							6,
							7,
							8
						],
						[
							4,
							5,
							6,
							7,
							8
						]
					],
					"effectBurn": [
						null,
						"100/150/200/250/300",
						"0.05",
						"265",
						"25/35/45/55/65",
						"0.5",
						"50",
						"2.5",
						"420",
						"4/5/6/7/8",
						"4/5/6/7/8"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3500,
						3500,
						3500,
						3500,
						3500
					],
					"rangeBurn": "3500",
					"image": {
						"full": "SwainW.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SwainE",
					"name": "Nevermove",
					"description": "Swain launches a wave of demonic power forward. It then returns to Swain and roots enemies it hits.",
					"tooltip": "Swain launches a wave of demonic power, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to enemies it passes through.<br /><br />Swain then commands the wave to return, detonating it on the first enemy hit. Enemies hit take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are rooted for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Pass-through Damage",
							"Detonation Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							35,
							45,
							55,
							65,
							75
						],
						[
							35,
							70,
							105,
							140,
							175
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1500,
							1500,
							1500,
							1500,
							1500
						],
						[
							-0.5,
							-0.5,
							-0.5,
							-0.5,
							-0.5
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							60,
							85,
							105,
							125,
							150
						],
						[
							60,
							85,
							105,
							125,
							150
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							400,
							400,
							400,
							400,
							400
						]
					],
					"effectBurn": [
						null,
						"35/45/55/65/75",
						"35/70/105/140/175",
						"1.5",
						"1500",
						"-0.5",
						"0.75",
						"60/85/105/125/150",
						"60/85/105/125/150",
						"15",
						"400"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "SwainE.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SwainR",
					"name": "Demonic Ascension",
					"description": "Swain transforms into a demon and drains health from the 3 closest enemy champions. After draining enough health, Swain can cast Demonflare to end his transformation and decimate nearby enemies with a nova of soulfire.",
					"tooltip": "Swain frees the demon within for {{ e3 }} seconds, gaining {{ e6 }} health. Every second, he drains the 3 closest enemy champions for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, healing him for {{ e4 }} <span class=\"color99FF99\">(+{{ a2 }})</span> health. After draining <scaleLevel>{{ f7 }}</scaleLevel> health, Swain gains the ability to cast Demonflare.<br /><br /><span class=\"colorDDDD77\">Demonflare:</span> Swain unleashes a nova of soulfire dealing magic damage and ending his transformation. Damage per <span class=\"size18 colorFF3F3F\">Soul Fragment</span>: {{ e0 }} <span class=\"color99FF99\">(+{{ f1 }})</span>.<br /><br />Current Damage: {{ f3 }}<br />Max Damage: {{ f2 }}<br /><br /><rules>Swain can drain non-champions to heal for {{ e7 }}% of the normal amount.",
					"leveltip": {
						"label": [
							"Health Gain",
							"Drain Damage",
							"Drain Heal",
							"Damage Per Soul"
						],
						"effect": [
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e0 }} -> {{ e0NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						120,
						120
					],
					"cooldownBurn": "120",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							35,
							50,
							65
						],
						[
							1,
							1,
							1
						],
						[
							12,
							12,
							12
						],
						[
							20,
							35,
							50
						],
						[
							0.04,
							0.06,
							0.08
						],
						[
							150,
							275,
							400
						],
						[
							20,
							20,
							20
						],
						[
							0.27,
							0.27,
							0.27
						],
						[
							0,
							0,
							0
						],
						[
							45,
							60,
							75
						]
					],
					"effectBurn": [
						null,
						"35/50/65",
						"1",
						"12",
						"20/35/50",
						"0.04/0.06/0.08",
						"150/275/400",
						"20",
						"0.27",
						"0",
						"45/60/75"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.14,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.16,
							"key": "a2"
						}
					],
					"costType": "All Soul Fragments",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "SwainR.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "All Soul Fragments"
				}
			],
			"passive": {
				"name": "Ravenous Flock",
				"description": "Swain's ravens collect <i>Soul Fragments</i> that heal him. Swain can right-click an immobilized enemy champions to pull them closer to him, dealing damage and ripping out a <i>Soul Fragment</i>.",
				"image": {
					"full": "Swain_P.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Swain",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3001",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Swain",
					"title": "SwainTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Syndra": {
			"id": "Syndra",
			"key": "134",
			"name": "Syndra",
			"title": "the Dark Sovereign",
			"image": {
				"full": "Syndra.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 240,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "134000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "134001",
					"num": 1,
					"name": "Justicar Syndra",
					"chromas": false
				},
				{
					"id": "134002",
					"num": 2,
					"name": "Atlantean Syndra",
					"chromas": false
				},
				{
					"id": "134003",
					"num": 3,
					"name": "Queen of Diamonds Syndra",
					"chromas": false
				},
				{
					"id": "134004",
					"num": 4,
					"name": "Snow Day Syndra",
					"chromas": false
				},
				{
					"id": "134005",
					"num": 5,
					"name": "SKT T1 Syndra",
					"chromas": false
				},
				{
					"id": "134006",
					"num": 6,
					"name": "Star Guardian Syndra",
					"chromas": false
				}
			],
			"lore": "Syndra is a fearsome dark mage with incredible power at her command. As a child of Ionia, she disturbed the village elders with her prodigious but reckless use of magic. They sent her away to be trained under strict supervision, but she quickly surpassed her mentor and discovered he was restraining her powers. Betrayed and disgusted by such cowardice, Syndra eliminated her teacher and struck out to destroy all who would try to limit her potential, dark spheres in hand.",
			"blurb": "Syndra is a fearsome dark mage with incredible power at her command. As a child of Ionia, she disturbed the village elders with her prodigious but reckless use of magic. They sent her away to be trained under strict supervision, but she quickly...",
			"allytips": [
				"To maximize your ultimate's damage use it when there are many spheres on the battlefield.",
				"After you hit an enemy champion with Force of Will follow up with Dark Sphere, they'll be slowed and have a hard time avoiding it.",
				"Get one of your spells to rank 5 as quickly as possible, they gain powerful bonus effects at max rank."
			],
			"enemytips": [
				"Get boots early when playing against Syndra, they'll help you avoid many of her spells.",
				"Attack Syndra after she's used Scatter the Weak, it has a long cooldown so she'll be vulnerable.",
				"At max rank Syndra's spells gain bonus effects and change in appearance."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 3,
				"magic": 9,
				"difficulty": 8
			},
			"stats": {
				"hp": 523,
				"hpperlevel": 90,
				"mp": 384,
				"mpperlevel": 60,
				"movespeed": 330,
				"armor": 24.712,
				"armorperlevel": 3.4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.872,
				"attackdamageperlevel": 2.9,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "SyndraQ",
					"name": "Dark Sphere",
					"description": "Syndra conjures a Dark Sphere dealing magic damage. The sphere remains and can be manipulated by her other powers.",
					"tooltip": "Conjures a Dark Sphere dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. The sphere remains for <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can be manipulated by Syndra's other abilities.<br /><br /><span class=\"color99FF99\">This spell can be cast while moving.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						40,
						50,
						60,
						70,
						80
					],
					"costBurn": "40/50/60/70/80",
					"effect": [
						null,
						[
							50,
							95,
							140,
							185,
							230
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							2,
							2.2,
							2.4,
							2.6,
							2.8
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/95/140/185/230",
						"6",
						"2/2.2/2.4/2.6/2.8",
						"8",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "SyndraQ.png",
						"sprite": "spell10.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SyndraW",
					"name": "Force of Will",
					"description": "Syndra picks up and throws a Dark Sphere or enemy minion dealing magic damage and slowing the Movement Speed of enemies. ",
					"tooltip": "<span class=\"colorFF9900\">First Cast:</span> Grabs target Dark Sphere or enemy minion. If no target is selected, grabs nearest Dark Sphere.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Throws the grabbed unit. Enemies hit take {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed by <span class=\"colorFFFFFF\">{{ e1 }}%</span> for {{ f2 }} seconds.<br /><br /><span class=\"color99FF99\">This spell can be cast while moving.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }} ",
							"{{ cost }} -> {{ costNL }} ",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							12,
							11,
							10,
							9,
							8
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							0.2,
							0.2,
							0.2,
							0.2,
							0.2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"25/30/35/40/45",
						"70/110/150/190/230",
						"12/11/10/9/8",
						"1.5",
						"400",
						"0.2",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "@text",
							"coeff": 1.5,
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "SyndraW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SyndraE",
					"name": "Scatter the Weak",
					"description": "Syndra knocks enemies and Dark Spheres back dealing magic damage. Enemies hit by Dark Spheres become stunned.",
					"tooltip": "Knocks enemies and Dark Spheres back dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to them and any enemies they collide with.<br /><br />Dark Spheres that are knocked back stun all enemies in their path for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ cooldown }} -> {{ cooldownNL }} "
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/115/160/205/250",
						"1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "SyndraE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "SyndraR",
					"name": "Unleashed Power",
					"description": "Syndra bombards an enemy Champion with all of her Dark Spheres.",
					"tooltip": "Draws upon Syndra's full cataclysmic power, harnessing Dark Spheres to deal magic damage to target enemy Champion. Unleashed Power manipulates the three Dark Spheres orbiting Syndra, in addition to up to 4 Dark Spheres previously created.<br /><br />Damage per sphere: {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>.<br />Minimum total damage: {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span>.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }} ",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							90,
							135,
							180
						],
						[
							270,
							405,
							540
						],
						[
							7,
							7,
							7
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"90/135/180",
						"270/405/540",
						"7",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						675,
						675,
						675
					],
					"rangeBurn": "675",
					"image": {
						"full": "SyndraR.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Transcendent",
				"description": "Spells gain extra effects at max rank.<br><br><font color='#FF9900'>Dark Sphere</font>: Sphere's lifetime is increased to 8 seconds.<br><font color='#FF9900'>Force of Will</font>: Deals 20% bonus true damage.<br><font color='#FF9900'>Scatter the Weak</font>: Spell width increased by 50%.<br><font color='#FF9900'>Unleashed Power</font>: Range increased by 75.",
				"image": {
					"full": "SyndraPassive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Syndra",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraSG",
					"map": "CityPark",
					"mode": "STARGUARDIAN",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Syndra",
					"title": "SyndraTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"TahmKench": {
			"id": "TahmKench",
			"key": "223",
			"name": "Tahm Kench",
			"title": "the River King",
			"image": {
				"full": "TahmKench.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 288,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "223000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "223001",
					"num": 1,
					"name": "Master Chef Tahm Kench",
					"chromas": false
				},
				{
					"id": "223002",
					"num": 2,
					"name": "Urf Kench",
					"chromas": false
				}
			],
			"lore": "Known by many names throughout history, the demon Tahm Kench travels the waterways of Runeterra, feeding his insatiable appetite with the misery of others. Though he may appear singularly charming and proud, he swaggers through the physical realm like a vagabond in search of unsuspecting prey. His lashing tongue can stun even a heavily armored warrior from a dozen paces, and to fall into his rumbling belly is to tumble into an abyss from which there is little hope of return.",
			"blurb": "Known by many names throughout history, the demon Tahm Kench travels the waterways of Runeterra, feeding his insatiable appetite with the misery of others. Though he may appear singularly charming and proud, he swaggers through the physical realm like a...",
			"allytips": [
				"Your most important function as a support is to keep fragile allies safe. Keep Devour's range and cooldown in mind and position accordingly!",
				"Consider carefully when to use Thick Skin's active. Sometimes shielding early to avoid further damage is good, but sometimes the healing is more beneficial."
			],
			"enemytips": [
				"When you see Tahm Kench use the shield from Thick Skin, remember that he just opted out of a good deal of healing. He will also not accumulate new gray health until Thick Skin comes off cooldown. Use this to your advantage!",
				"If Tahm Kench harasses you by spitting minions at you, try going in for a trade right after he spits. His Devour will be on cooldown and you should be able to trade favourably if he can't eat you."
			],
			"tags": [
				"Support",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 3,
				"defense": 9,
				"magic": 6,
				"difficulty": 5
			},
			"stats": {
				"hp": 610,
				"hpperlevel": 95,
				"mp": 325,
				"mpperlevel": 40,
				"movespeed": 335,
				"armor": 47,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 6.5,
				"hpregenperlevel": 0.55,
				"mpregen": 8,
				"mpregenperlevel": 1,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 56,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "TahmKenchQ",
					"name": "Tongue Lash",
					"description": "Tahm Kench lashes out with his tongue, damaging and slowing the first unit hit. This ability gains a stun after three stacks of An Acquired Taste.",
					"tooltip": "Damage the first enemy hit for {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slow them by {{ e4 }}% for {{ e5 }}s. Champions with 3 stacks of An Acquired Taste will additionally be stunned for {{ e6 }}s.<br /><br />Activate <span class=\"color0bf7de\">Devour</span> while your tongue is in midair to devour monsters/minions from a distance.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Slow Amount"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e4 }}% -> {{ e4NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							875,
							875,
							875,
							875,
							875
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							80,
							130,
							180,
							230,
							280
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"875",
						"1000",
						"80/130/180/230/280",
						"30/40/50/60/70",
						"2",
						"1.5",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "TahmKenchQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TahmKenchW",
					"name": "Devour",
					"description": "Tahm Kench devours a target, dealing a percentage of their maximum health as magic damage. He can spit devoured minions and monsters out as a skillshot that deals magic damage in an area upon impact.",
					"tooltip": "Devour a target for {{ e1 }}s (half that for enemy champions.) Enemies are dealt {{ e3 }}% <span class=\"color99FF99\">(+{{ a1 }}%)</span> of their maximum health as magic damage (maximum of {{ e2 }} against neutral monsters).<br /><br /><span class=\"colorFF9900\">Enemy Champions:</span> Requires 3 stacks of An Acquired Taste to be devoured. While holding an enemy champion, Tahm Kench is slowed by 95%. <br /><br /><span class=\"colorFF9900\">Allied Champions:</span> While holding an allied champion, Tahm Kench gains {{ e4 }}% movement speed toward enemy champions.<br /><br /><span class=\"colorFF9900\">Minions and Monsters:</span> Reactivate to spit them, dealing {{ e7 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage to targets hit.",
					"leveltip": {
						"label": [
							"Devour Duration",
							"Max Health Damage",
							"Max Damage to Monsters",
							"Minion Spit Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}s -> {{ e1NL }}s",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						13,
						12,
						11,
						10
					],
					"cooldownBurn": "14/13/12/11/10",
					"cost": [
						90,
						90,
						90,
						90,
						90
					],
					"costBurn": "90",
					"effect": [
						null,
						[
							4,
							4.5,
							5,
							5.5,
							6
						],
						[
							400,
							450,
							500,
							550,
							600
						],
						[
							20,
							23,
							26,
							29,
							32
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/4.5/5/5.5/6",
						"400/450/500/550/600",
						"20/23/26/29/32",
						"30/35/40/45/50",
						"0",
						"0",
						"100/150/200/250/300",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.02,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						250,
						250,
						250,
						250,
						250
					],
					"rangeBurn": "250",
					"image": {
						"full": "TahmKenchW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TahmKenchE",
					"name": "Thick Skin",
					"description": "Tahm Kench turns incoming damage into gray health. As gray health decays, Tahm Kench is healed for a percentage of the gray health amount. When activated, this ability turns all gray health into a shield.",
					"tooltip": "<span class=\"colorFF9900\">Passive:</span> {{ e3 }}% of the Damage taken while this ability is not cooling down is converted to gray health. If allowed to decay, {{ e2 }}% of gray health will turn back into health.<br /><br /><span class=\"colorFF9900\">Active:</span> Convert all of your gray health into a shield that lasts {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Damage to Gray Health Conversion",
							"Gray Health to Healing Conversion"
						],
						"effect": [
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							70,
							75,
							80,
							85,
							90
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"3",
						"25/30/35/40/45",
						"70/75/80/85/90",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "TahmKenchE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TahmKenchNewR",
					"name": "Abyssal Voyage",
					"description": "Tahm Kench teleports across the map, and he may bring one ally champion with him.",
					"tooltip": "Begin to channel for up to 6 seconds. During this time, one ally champion can right click Tahm Kench to join in. Alternatively, reactivate this ability to travel alone. On reactivation or once an ally has opted in, Tahm travels to the target location. Incoming champion damage breaks the channel.<br /><br /><span class=\"colorcccccc\"><i>'Boy, the world's one river, and I'm its king. Ain't no place I ain't been; ain't no place I can't go again.'</i></span>",
					"leveltip": {
						"label": [
							"Cooldown",
							"Range"
						],
						"effect": [
							"{{ cooldown }}s -> {{ cooldownNL }}s",
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							4500,
							5500,
							6500
						],
						[
							0.02,
							0.04,
							0.06
						],
						[
							20,
							20,
							20
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4500/5500/6500",
						"0.02/0.04/0.06",
						"20",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						4500,
						5500,
						6500
					],
					"rangeBurn": "4500/5500/6500",
					"image": {
						"full": "TahmKenchNewR.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "An Acquired Taste",
				"description": "Tahm Kench puts the heft of his immense body behind his attacks and abilities, gaining extra damage based on his total health. Damaging enemy champions builds stacks of An Acquired Taste. At three stacks, he can use Devour on an enemy champion.",
				"image": {
					"full": "TahmKench_P.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Maokai",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1054",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1054",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "3067",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3067",
									"count": 1
								},
								{
									"id": "3211",
									"count": 1
								},
								{
									"id": "3065",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3025",
									"count": 1
								},
								{
									"id": "3068",
									"count": 1
								},
								{
									"id": "3001",
									"count": 1
								},
								{
									"id": "3105",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TahmKench",
					"title": "TahmKenchTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Taliyah": {
			"id": "Taliyah",
			"key": "163",
			"name": "Taliyah",
			"title": "the Stoneweaver",
			"image": {
				"full": "Taliyah.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 336,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "163000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "163001",
					"num": 1,
					"name": "Freljord Taliyah",
					"chromas": false
				}
			],
			"lore": "Taliyah is a nomadic mage from Shurima, torn between teenage wonder and adult responsibility. She has crossed nearly all of Valoran on a journey to learn the true nature of her growing powers, though more recently she has returned to protect her tribe. Some have mistaken her compassion for weakness and paid the ultimate price—for beneath Taliyah's youthful demeanor is a will strong enough to move mountains, and a spirit fierce enough to make the earth itself tremble.",
			"blurb": "Taliyah is a nomadic mage from Shurima, torn between teenage wonder and adult responsibility. She has crossed nearly all of Valoran on a journey to learn the true nature of her growing powers, though more recently she has returned to protect her tribe...",
			"allytips": [
				"Try to throw enemies into Unraveled Earth using Seismic Shove.",
				"Remember, you don't always have to ride Weaver's Wall.",
				"Once you have Rylai's Crystal Scepter, casting Threaded Volley at enemies chasing you is a great way of making them regret everything."
			],
			"enemytips": [
				"When Taliyah casts Unraveled Earth in the lane, be on the lookout for Seismic Shove. If she throws you into her minefield, the throws and stones will break your bones.",
				"Taliyah's Threaded Volley is locked into a direction. If she's throwing rocks at you, dodge to the side!"
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 7,
				"magic": 8,
				"difficulty": 5
			},
			"stats": {
				"hp": 532,
				"hpperlevel": 90,
				"mp": 340,
				"mpperlevel": 60,
				"movespeed": 325,
				"armor": 20,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 7,
				"hpregenperlevel": 0.7,
				"mpregen": 7,
				"mpregenperlevel": 0.85,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 56,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "TaliyahQ",
					"name": "Threaded Volley",
					"description": "Taliyah throws a volley of missiles in a target direction, moving freely as she does. This works the ground below her. If Taliyah casts Threaded Volley on worked ground, she only throws one missile.",
					"tooltip": "Hurls 5 rocks in a direction, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage in a small area around the first enemy hit. Subsequent hits on the same unit deal {{ e2 }}% reduced damage. Creates <span class=\"colora56705\">Worked Ground</span> for <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds.<br /><br />Taliyah gains <span class=\"colorffffff\">{{ f2 }}%</span> movement speed on <span class=\"colora56705\">Worked Ground</span>. Casting Threaded Volley on <span class=\"colora56705\">Worked Ground</span> only hurls one rock but refunds {{ e7 }}% of its mana cost.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						7.5,
						6,
						4.5,
						3
					],
					"cooldownBurn": "9/7.5/6/4.5/3",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							70,
							95,
							120,
							145,
							170
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							160,
							160,
							160,
							160,
							160
						],
						[
							120,
							120,
							120,
							120,
							120
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/95/120/145/170",
						"60",
						"0",
						"0",
						"160",
						"120",
						"50",
						"450",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "TaliyahQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TaliyahWVC",
					"name": "Seismic Shove",
					"description": "Taliyah causes an area of ground to erupt and throws enemies within in a direction of her choosing.",
					"tooltip": "Taliyah targets an area. After a short delay, enemies caught within the area will be <span class=\"colorffffff\">pushed</span> and dealt {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />You can control the direction enemies will be <span class=\"colorffffff\">pushed</span> by clicking and dragging your mouse in a line.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							0.55,
							0.55,
							0.55,
							0.55,
							0.55
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/80/100/120/140",
						"0.55",
						"400",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "TaliyahWVC.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TaliyahE",
					"name": "Unraveled Earth",
					"description": "Taliyah creates a slowing minefield that explodes if enemies dash through it or are pushed/pulled through it.",
					"tooltip": "Places a field of dash-sensitive traps that deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and slow enemies in the area by <span class=\"color99FF99\">{{ f2 }}%</span>. After {{ e3 }} seconds, the traps explode, dealing damage again.<br /><br />Enemies <span class=\"colorFFFFFF\">dashing</span>, being <span class=\"colorFFFFFF\">pushed</span>, or being <span class=\"colorFFFFFF\">pulled</span> through Unraveled Earth will trigger traps, taking {{ f3 }} <span class=\"color99FF99\">(+{{ f1 }})</span> magic damage from each trap (maximum 4, each hit after the first deals {{ f4 }}% less damage).",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14,
						12,
						10,
						8
					],
					"cooldownBurn": "16/14/12/10/8",
					"cost": [
						90,
						95,
						100,
						105,
						110
					],
					"costBurn": "90/95/100/105/110",
					"effect": [
						null,
						[
							70,
							90,
							110,
							130,
							150
						],
						[
							-0.2,
							-0.2,
							-0.2,
							-0.2,
							-0.2
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							85,
							85,
							85,
							85,
							85
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.15,
							0.15,
							0.15,
							0.15,
							0.15
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/90/110/130/150",
						"-0.2",
						"4",
						"85",
						"0.5",
						"4",
						"0.15",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "TaliyahE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TaliyahR",
					"name": "Weaver's Wall",
					"description": "Taliyah creates a very long wall and then surfs it.",
					"tooltip": "Cast once to create a wall. Recast immediately to ride ahead of the wall. Moving or receiving damage will cause Taliyah to stop.<br /><br />Weaver's Wall lasts for {{ e1 }} seconds. Deactivate this spell to break the wall early.",
					"leveltip": {
						"label": [
							"Duration",
							"Wall length",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}s -> {{ e1NL }}s",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 3,
					"cooldown": [
						180,
						150,
						120
					],
					"cooldownBurn": "180/150/120",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							6,
							7,
							8
						],
						[
							3000,
							4500,
							6000
						],
						[
							0.1,
							0.1,
							0.1
						],
						[
							2500,
							2500,
							2500
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6/7/8",
						"3000/4500/6000",
						"0.1",
						"2500",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3000,
						4500,
						6000
					],
					"rangeBurn": "3000/4500/6000",
					"image": {
						"full": "TaliyahR.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Rock Surfing",
				"description": "Taliyah gains movement speed near walls.",
				"image": {
					"full": "Taliyah_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Taliyah",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Taliyah",
					"title": "TaliyahTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Talon": {
			"id": "Talon",
			"key": "91",
			"name": "Talon",
			"title": "the Blade's Shadow",
			"image": {
				"full": "Talon.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 384,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "91000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "91001",
					"num": 1,
					"name": "Renegade Talon",
					"chromas": false
				},
				{
					"id": "91002",
					"num": 2,
					"name": "Crimson Elite Talon",
					"chromas": false
				},
				{
					"id": "91003",
					"num": 3,
					"name": "Dragonblade Talon",
					"chromas": true
				},
				{
					"id": "91004",
					"num": 4,
					"name": "SSW Talon",
					"chromas": false
				},
				{
					"id": "91005",
					"num": 5,
					"name": "Blood Moon Talon",
					"chromas": false
				}
			],
			"lore": "Talon is the knife in the darkness, a merciless killer able to strike without warning and escape before any alarm is raised. He carved out a dangerous reputation on the brutal streets of Noxus, where he was forced to fight, kill, and steal to survive. Adopted by the notorious Du Couteau family, he now plies his deadly trade at the empire's command, assassinating enemy leaders, captains, and heroes… as well as any Noxian foolish enough to earn the scorn of their masters.",
			"blurb": "Talon is the knife in the darkness, a merciless killer able to strike without warning and escape before any alarm is raised. He carved out a dangerous reputation on the brutal streets of Noxus, where he was forced to fight, kill, and steal to survive...",
			"allytips": [
				"You can use Assassin's Path to get behind the enemy and set up for Noxian Diplomacy's melee attack.",
				"Shadow Assault is a powerful escape tool, but can also be offensively used to assault a group.",
				"Remember to pick your target before the fight. Focusing all of Talon's abilities on one target can be very rewarding, but splitting them up between many may leave you helpless."
			],
			"enemytips": [
				"Talon's attacks are all physical damage. Build armor early to counter his burst damage.",
				"Talon is heavily reliant on Shadow Assault to escape a fight. When it is down he's significantly more vulnerable.",
				"Talon has unrivaled roaming ability. Make sure to keep track of his position or force him to stay in lane by pushing aggressively."
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 3,
				"magic": 1,
				"difficulty": 7
			},
			"stats": {
				"hp": 588,
				"hpperlevel": 95,
				"mp": 377.2,
				"mpperlevel": 37,
				"movespeed": 335,
				"armor": 30,
				"armorperlevel": 3.5,
				"spellblock": 39,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.75,
				"mpregen": 7.6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.1,
				"attackspeedoffset": -0.065,
				"attackspeedperlevel": 2.9
			},
			"spells": [
				{
					"id": "TalonQ",
					"name": "Noxian Diplomacy",
					"description": "Talon stabs the target unit. If they are within melee range, this attack deals critical damage. If they are outside melee range, Talon will leap at his target before stabbing them. Talon refunds some health and cooldown if this ability kills the target.",
					"tooltip": "Talon leaps to target and deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage. If cast from melee range, Talon does not leap but instead critically strikes, dealing {{ f2 }}% damage <span class=\"colorFF8C00\">({{ f3 }})</span>.<br /><br />When Noxian Diplomacy kills a unit, Talon regains <span class=\"colorFFFFFF\">{{ f4 }}</span> health and refunds {{ e5 }}% of its cooldown.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f5 }} -> {{ f6 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							65,
							90,
							115,
							140,
							165
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							17,
							17,
							17,
							17,
							17
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							8,
							7.5,
							7,
							6.5,
							6
						],
						[
							0.8,
							0.8,
							0.8,
							0.8,
							0.8
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/90/115/140/165",
						"50",
						"17",
						"3",
						"50",
						"8/7.5/7/6.5/6",
						"0.8",
						"1.5",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "TalonQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TalonW",
					"name": "Rake",
					"description": "Talon sends out a volley of daggers that then return back to him, dealing physical damage every time it passes through an enemy. The returning blades deal bonus damage and slow units hit.",
					"tooltip": "Talon tosses a volley of blades, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage to units hit and returning to him after a delay.<br /><br />On their way back to Talon, the blades deal {{ e5 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> additional damage and slow the enemy by {{ e2 }}% for 1 second.",
					"leveltip": {
						"label": [
							"Initial Damage",
							"Return Damage",
							"Slow Amount",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						55,
						60,
						65,
						70,
						75
					],
					"costBurn": "55/60/65/70/75",
					"effect": [
						null,
						[
							50,
							65,
							80,
							95,
							110
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							14,
							13,
							12,
							11,
							10
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							70,
							95,
							120,
							145,
							170
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/65/80/95/110",
						"40/45/50/55/60",
						"14/13/12/11/10",
						"2",
						"70/95/120/145/170",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "TalonW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TalonE",
					"name": "Assassin's Path",
					"description": "Talon vaults over any terrain or structure, up to a max distance. This ability has a low cooldown, but puts the used terrain on a long cooldown.",
					"tooltip": "Talon vaults up to {{ f2 }} units over the nearest structure or terrain in the target direction. The vault's speed is affected by Talon's movement speed.<br /><br />Talon cannot dash over the same section of terrain more than once every <span class=\"colorFFFFFF\">{{ f3 }}</span> seconds.",
					"leveltip": {
						"label": [
							"Terrain Cooldown"
						],
						"effect": [
							"{{ f3 }} -> {{ f4 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							625,
							625,
							625,
							625,
							625
						],
						[
							1250,
							1250,
							1250,
							1250,
							1250
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							160,
							135,
							110,
							85,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0",
						"0",
						"625",
						"1250",
						"2",
						"160/135/110/85/60",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No cost",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "TalonE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "No cost"
				},
				{
					"id": "TalonR",
					"name": "Shadow Assault",
					"description": "Talon disperses a ring of blades and becomes Invisible while gaining additional Movement Speed. When Talon emerges from Invisibility, the blades converge on his location. Each time the blades move, Shadow Assault deals physical damage to enemies hit by at least one blade.  ",
					"tooltip": "Talon disperses a ring of blades that deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to all units they hit, gains {{ e2 }}% increased movement speed, and becomes <span class=\"color91d7ee\">Invisible</span> for up to {{ e3 }} seconds. When the <span class=\"color91d7ee\">Invisibility</span> ends, the blades converge, dealing the same damage again to enemies they pass through.<br /><br />If Talon cancels <span class=\"color91d7ee\">Invisibility</span> with an attack or Noxian Diplomacy, the blades converge on his target's location instead.<br /><br /><u><span class=\"size16 color91d7ee\">Stealth - Invisible</span></u><span class=\"size16 colorb3b3b3\">: Talon can only be revealed by nearby enemy Turrets or <span class=\"size16 coloree91d7\">True Sight</span>.",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						80,
						60
					],
					"cooldownBurn": "100/80/60",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							90,
							135,
							180
						],
						[
							40,
							55,
							70
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"90/135/180",
						"40/55/70",
						"2.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "TalonR.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Blade's End",
				"description": "Talon's spells Wound champions and epic monsters, stacking up to 3 times. When Talon attacks a champion with 3 stacks of Wound, they bleed for heavy damage over time.",
				"image": {
					"full": "TalonP.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Talon",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Talon",
					"title": "TalonTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3104",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Taric": {
			"id": "Taric",
			"key": "44",
			"name": "Taric",
			"title": "the Shield of Valoran",
			"image": {
				"full": "Taric.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 432,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "44000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "44001",
					"num": 1,
					"name": "Emerald Taric",
					"chromas": false
				},
				{
					"id": "44002",
					"num": 2,
					"name": "Armor of the Fifth Age Taric",
					"chromas": false
				},
				{
					"id": "44003",
					"num": 3,
					"name": "Bloodstone Taric",
					"chromas": false
				},
				{
					"id": "44004",
					"num": 4,
					"name": "Pool Party Taric",
					"chromas": false
				}
			],
			"lore": "Taric is the Aspect of the Protector, wielding incredible power as Runeterra's guardian of life, love, and beauty. Shamed by a dereliction of duty and exiled from his homeland Demacia, Taric ascended Mount Targon to find redemption, only to discover a higher calling among the stars. Imbued with the might of ancient Targon, the Shield of Valoran now stands ever vigilant against the insidious corruption of the Void.",
			"blurb": "Taric is the Aspect of the Protector, wielding incredible power as Runeterra's guardian of life, love, and beauty. Shamed by a dereliction of duty and exiled from his homeland Demacia, Taric ascended Mount Targon to find redemption, only to discover a...",
			"allytips": [
				"The cooldown reducing component of Bravado makes Cooldown Reduction items like Frozen Heart, Iceborn Gauntlet, and Spirit Visage exceptionally powerful on Taric.",
				"Using Starlight's Touch at lower charges makes its healing less Mana efficient, but can greatly increase Taric's sustained damage via Bravado.",
				"Rather than saving Cosmic Radiance for the last moment and risking someone dying during the delay, it can be more beneficial to cast it as soon as you know a teamfight is guaranteed to start."
			],
			"enemytips": [
				"Taric's ultimate, Cosmic Radiance, has a long delay before its effect. Try to quickly assess whether to disengage the fight or attempt to kill his allies before it goes off.",
				"Taric reduces his spell cooldowns by basic attacking enemies with Bravado. Try to kite him in teamfights and punish him for approaching the minion wave in lane."
			],
			"tags": [
				"Support",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 8,
				"magic": 5,
				"difficulty": 3
			},
			"stats": {
				"hp": 575,
				"hpperlevel": 90,
				"mp": 300,
				"mpperlevel": 60,
				"movespeed": 340,
				"armor": 40,
				"armorperlevel": 3.4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 150,
				"hpregen": 6,
				"hpregenperlevel": 0.5,
				"mpregen": 8.5,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "TaricQ",
					"name": "Starlight's Touch",
					"description": "Heals nearby allied champions based on charges stored. Bravado-empowered attacks grant a charge of Starlight's Touch.",
					"tooltip": "Spends all charges to heal nearby allied champions for {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFF3300\">(+{{ f1 }})</span> ({{ e2 }}% of maximum Health) per charge, up to {{ e5 }} <span class=\"color99FF99\">(+{{ f3 }})</span> <span class=\"colorFF3300\">(+{{ f2 }})</span> at maximum charges.<br />Maximum charges: {{ e6 }}<br /><br />Bravado-empowered attacks grant 1 charge of Starlight's Touch.",
					"leveltip": {
						"label": [
							"Max Charges",
							"Max Healing",
							"Mana Cost"
						],
						"effect": [
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						3,
						3,
						3,
						3,
						3
					],
					"cooldownBurn": "3",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.2,
							0.4,
							0.6,
							0.8,
							1
						],
						[
							1,
							2,
							3,
							4,
							5
						],
						[
							30,
							60,
							90,
							120,
							150
						],
						[
							1,
							2,
							3,
							4,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30",
						"1",
						"0.2/0.4/0.6/0.8/1",
						"1/2/3/4/5",
						"30/60/90/120/150",
						"1/2/3/4/5",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana, all Charges",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "TaricQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana, all Charges"
				},
				{
					"id": "TaricW",
					"name": "Bastion",
					"description": "Passively increase the Armor of Taric and any allied champion with Bastion.<br><br>Actively shields an ally and grants them Bastion for as long as they remain near Taric. Taric's spells also cast off the ally with Bastion.",
					"tooltip": "Taric's spells will also cast from a nearby ally protected by Bastion.<br /><br /><span class=\"colorFF9900\">Passive: </span>Bastion increases Armor by <span class=\"colorFFFF00\">{{ f1 }}</span> ({{ e1 }}% of Taric's Armor).<br /><br /><span class=\"colorFF9900\">Active: </span>Blesses an ally with Bastion and shields them for {{ e2 }}% of their maximum Health for {{ e3 }} seconds. Bastion lasts on the target until a new one is chosen.",
					"leveltip": {
						"label": [
							"Passive Armor",
							"Shield Ratio"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							10,
							12.5,
							15,
							17.5,
							20
						],
						[
							8,
							9,
							10,
							11,
							12
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							1300,
							1300,
							1300,
							1300,
							1300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/12.5/15/17.5/20",
						"8/9/10/11/12",
						"2.5",
						"1000",
						"1300",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "TaricW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TaricE",
					"name": "Dazzle",
					"description": "Taric readies a beam of starlight that, after a brief delay, deals magic damage and stuns enemies.",
					"tooltip": "Readies a beam of starlight that, after {{ e3 }} second, deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFFFF00\">(+{{ f1 }})</span> magic damage and stuns enemies for {{ e2 }} second(s).",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						16,
						15,
						14,
						13
					],
					"cooldownBurn": "17/16/15/14/13",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							105,
							150,
							195,
							240,
							285
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"105/150/195/240/285",
						"1.25",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						610,
						610,
						610,
						610,
						610
					],
					"rangeBurn": "610",
					"image": {
						"full": "TaricE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TaricR",
					"name": "Cosmic Radiance",
					"description": "Pulses cosmic energy onto nearby allied champions after a delay, making them invulnerable for a short duration.",
					"tooltip": "After a {{ e4 }} second delay, pulses cosmic energy onto nearby allied champions, making them invulnerable for {{ e5 }} seconds.",
					"leveltip": {
						"label": [
							"Cooldown"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						160,
						130,
						100
					],
					"cooldownBurn": "160/130/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							275,
							400
						],
						[
							25,
							35,
							45
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/275/400",
						"25/35/45",
						"2.5",
						"2.5",
						"2.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "TaricR.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Bravado",
				"description": "Spellcasts empower Taric's next 2 basic attacks to deal bonus magic damage, reduce his spell cooldowns, and attack in quick succession.",
				"image": {
					"full": "Taric_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 432,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Taric",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3107",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3341",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2045",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3341",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Taric",
					"title": "TaricTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Teemo": {
			"id": "Teemo",
			"key": "17",
			"name": "Teemo",
			"title": "the Swift Scout",
			"image": {
				"full": "Teemo.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 0,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "17000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "17001",
					"num": 1,
					"name": "Happy Elf Teemo",
					"chromas": false
				},
				{
					"id": "17002",
					"num": 2,
					"name": "Recon Teemo",
					"chromas": false
				},
				{
					"id": "17003",
					"num": 3,
					"name": "Badger Teemo",
					"chromas": false
				},
				{
					"id": "17004",
					"num": 4,
					"name": "Astronaut Teemo",
					"chromas": false
				},
				{
					"id": "17005",
					"num": 5,
					"name": "Cottontail Teemo",
					"chromas": true
				},
				{
					"id": "17006",
					"num": 6,
					"name": "Super Teemo",
					"chromas": false
				},
				{
					"id": "17007",
					"num": 7,
					"name": "Panda Teemo",
					"chromas": false
				},
				{
					"id": "17008",
					"num": 8,
					"name": "Omega Squad Teemo",
					"chromas": true
				},
				{
					"id": "17014",
					"num": 14,
					"name": "Little Devil Teemo",
					"chromas": false
				}
			],
			"lore": "Undeterred by even the most dangerous and threatening of obstacles, Teemo scouts the world with boundless enthusiasm and a cheerful spirit. A yordle with an unwavering sense of morality, he takes pride in following the Bandle Scout's Code, sometimes with such eagerness that he is unaware of the broader consequences of his actions. Though some say the existence of the Scouts is questionable, one thing is for certain: Teemo's conviction is nothing to be trifled with.",
			"blurb": "Undeterred by even the most dangerous and threatening of obstacles, Teemo scouts the world with boundless enthusiasm and a cheerful spirit. A yordle with an unwavering sense of morality, he takes pride in following the Bandle Scout's Code, sometimes...",
			"allytips": [
				"Teemo's mushrooms can be used to farm creep waves very effectively.",
				"Place your mushrooms at key locations on the map, such as by the Dragon or Baron Nashor, to reveal when your enemies might be attempting to kill them."
			],
			"enemytips": [
				"Teemo's Toxic Shot punishes players who get hit and back out, so stay at a safe range until you're ready to commit.",
				"It can be valuable to use Oracle's Lens(Trinket) to destroy mushrooms around key locations."
			],
			"tags": [
				"Marksman",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 3,
				"magic": 7,
				"difficulty": 6
			},
			"stats": {
				"hp": 528,
				"hpperlevel": 90,
				"mp": 267.2,
				"mpperlevel": 40,
				"movespeed": 330,
				"armor": 24.3,
				"armorperlevel": 3.75,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 500,
				"hpregen": 5.5,
				"hpregenperlevel": 0.65,
				"mpregen": 7.206,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 54,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.0947,
				"attackspeedperlevel": 3.38
			},
			"spells": [
				{
					"id": "BlindingDart",
					"name": "Blinding Dart",
					"description": "Obscures an enemy's vision with a powerful venom, dealing damage to the target unit and blinding it for the duration.",
					"tooltip": "Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and blinds the target for {{ e2 }} seconds. ",
					"leveltip": {
						"label": [
							"Damage",
							"Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }} -> {{ e2NL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							80,
							125,
							170,
							215,
							260
						],
						[
							1.5,
							1.75,
							2,
							2.25,
							2.5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/125/170/215/260",
						"1.5/1.75/2/2.25/2.5",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						680,
						680,
						680,
						680,
						680
					],
					"rangeBurn": "680",
					"image": {
						"full": "BlindingDart.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "MoveQuick",
					"name": "Move Quick",
					"description": "Teemo scampers around, passively increasing his Movement Speed until he is struck by an enemy champion or turret. Teemo can sprint to gain bonus Movement Speed that isn't stopped by being struck for a short time.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Teemo's Movement Speed is increased by {{ e1 }}% unless he has been damaged by an enemy champion or turret in the last 5 seconds.<br /><br /><span class=\"colorFF9900\">Active: </span>Teemo sprints, gaining twice his normal bonus for {{ e2 }} seconds. This bonus is not lost when struck.",
					"leveltip": {
						"label": [
							"Base Movement Speed Bonus"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						17,
						17,
						17,
						17
					],
					"cooldownBurn": "17",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							10,
							14,
							18,
							22,
							26
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.2,
							0.28,
							0.36,
							0.44,
							0.52
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/14/18/22/26",
						"3",
						"0.2/0.28/0.36/0.44/0.52",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "MoveQuick.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ToxicShot",
					"name": "Toxic Shot",
					"description": "Each of Teemo's attacks will poison the target, dealing damage on impact and each second after for 4 seconds.",
					"tooltip": "Teemo's basic attacks poison their target, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magical damage upon impact and {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magical damage each second for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Impact Damage",
							"Damage per Second "
						],
						"effect": [
							" {{ e2 }} -> {{ e2NL }}",
							" {{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						8,
						8,
						8,
						8
					],
					"cooldownBurn": "8",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							6,
							12,
							18,
							24,
							30
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4.5,
							4.5,
							4.5,
							4.5,
							4.5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6/12/18/24/30",
						"10/20/30/40/50",
						"4",
						"4.5",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.1,
							"key": "a2"
						}
					],
					"costType": "Passive",
					"maxammo": "-1",
					"range": [
						680,
						680,
						680,
						680,
						680
					],
					"rangeBurn": "680",
					"image": {
						"full": "ToxicShot.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "Passive"
				},
				{
					"id": "TeemoRCast",
					"name": "Noxious Trap",
					"description": "Teemo throws an explosive poisonous trap using one of the mushrooms stored in his pack. If an enemy steps on the trap, it will release a poisonous cloud, slowing enemies and damaging them over time. If Teemo throws a mushroom onto another mushroom it will bounce, gaining additional range.",
					"tooltip": "Tosses a stored mushroom as a trap that detonates if an enemy steps on it, spreading poison to nearby enemies that slows Movement Speed by {{ e2 }}%, reveals them and deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage over {{ e9 }} seconds. <br /><br />Traps last {{ e5 }} minutes and take {{ e4 }} second to arm and stealth. If a thrown trap lands on another trap, it will bounce up to <span class=\"colorFFFF99\">{{ e6 }}</span> Teemos further before planting.<br /><br />Teemo forages for a mushroom every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds, but he is only big enough to carry 3 at once.",
					"leveltip": {
						"label": [
							"Damage ",
							"Slow Percent",
							"Max Bounce Range",
							"Forage Timer",
							"Cast Range"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }}% -> {{ e2NL }}%",
							"{{ e6 }} Teemos -> {{ e6NL }} Teemos",
							" {{ f1 }} -> {{ f2 }}",
							" {{ e8 }} -> {{ e8NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						0.25,
						0.25,
						0.25
					],
					"cooldownBurn": "0.25",
					"cost": [
						75,
						75,
						75
					],
					"costBurn": "75",
					"effect": [
						null,
						[
							200,
							325,
							450
						],
						[
							30,
							40,
							50
						],
						[
							75,
							75,
							75
						],
						[
							1,
							1,
							1
						],
						[
							5,
							5,
							5
						],
						[
							3,
							4,
							5
						],
						[
							30,
							25,
							20
						],
						[
							400,
							650,
							900
						],
						[
							4,
							4,
							4
						],
						[
							450,
							450,
							450
						]
					],
					"effectBurn": [
						null,
						"200/325/450",
						"30/40/50",
						"75",
						"1",
						"5",
						"3/4/5",
						"30/25/20",
						"400/650/900",
						"4",
						"450"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "3",
					"range": [
						400,
						650,
						900
					],
					"rangeBurn": "400/650/900",
					"image": {
						"full": "TeemoRCast.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Guerrilla Warfare",
				"description": "If Teemo stands still and takes no actions for a short duration, he becomes Invisible indefinitely. If he's in brush, Teemo can enter and maintain his Invisibility while moving. After leaving Invisibility, Teemo gains the Element of Surprise, increasing his Attack Speed for 3 seconds.",
				"image": {
					"full": "Teemo_P.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 0,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Teemo",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3146",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3115",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Teemo",
					"title": "TeemoTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3136",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Thresh": {
			"id": "Thresh",
			"key": "412",
			"name": "Thresh",
			"title": "the Chain Warden",
			"image": {
				"full": "Thresh.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 48,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "412000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "412001",
					"num": 1,
					"name": "Deep Terror Thresh",
					"chromas": false
				},
				{
					"id": "412002",
					"num": 2,
					"name": "Championship Thresh",
					"chromas": false
				},
				{
					"id": "412003",
					"num": 3,
					"name": "Blood Moon Thresh",
					"chromas": false
				},
				{
					"id": "412004",
					"num": 4,
					"name": "SSW Thresh",
					"chromas": false
				},
				{
					"id": "412005",
					"num": 5,
					"name": "Dark Star Thresh",
					"chromas": false
				}
			],
			"lore": "Sadistic and cunning, Thresh is an ambitious and restless spirit of the Shadow Isles. Once the custodian of countless arcane secrets, he sought a power greater than life or death, and now sustains himself by tormenting and breaking others with slow, excruciating inventiveness. His victims suffer far beyond their brief mortal coil as Thresh wreaks agony upon their souls, imprisoning them in his unholy lantern to torture for all eternity.",
			"blurb": "Sadistic and cunning, Thresh is an ambitious and restless spirit of the Shadow Isles. Once the custodian of countless arcane secrets, he sought a power greater than life or death, and now sustains himself by tormenting and breaking others with slow...",
			"allytips": [
				"Communication is key when making use of Thresh's lantern. Let your teammates know how you like to use it.",
				"Death Sentence and Flay can be combined in either cast order for powerful combinations.",
				"Thresh can collect souls without needing to kill units himself. Planning your map position to be near the most deaths will help to maximize soul collection."
			],
			"enemytips": [
				"Thresh's Death Sentence has a long cast time. Watch for the cast to begin to take evasive actions.",
				"Intentionally breaking a wall of The Box can allow a vulnerable ally to escape unscathed.",
				"Thresh relies on collecting souls for a portion of his defense and damage. Try punishing him when he moves to collect them."
			],
			"tags": [
				"Support",
				"Fighter"
			],
			"partype": "Mana",
			"info": {
				"attack": 5,
				"defense": 6,
				"magic": 6,
				"difficulty": 7
			},
			"stats": {
				"hp": 560.52,
				"hpperlevel": 93,
				"mp": 273.92,
				"mpperlevel": 44,
				"movespeed": 335,
				"armor": 28,
				"armorperlevel": 0,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 450,
				"hpregen": 7,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 56,
				"attackdamageperlevel": 2.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "ThreshQ",
					"name": "Death Sentence",
					"description": "Thresh binds an enemy in chains and pulls them toward him. Activating this ability a second time pulls Thresh to the enemy.",
					"tooltip": "Thresh throws out his scythe, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, granting <span class=\"coloree91d7\">True Sight</span> and stunning the first unit hit, pulling them in for {{ e2 }} seconds.<br /><br />Reactivating this ability will pull Thresh to the bound enemy.<br /><br />Death Sentence's cooldown is reduced by {{ e4 }} seconds if it hits an enemy.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						18,
						16,
						14,
						12
					],
					"cooldownBurn": "20/18/16/14/12",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"1.5",
						"75",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1075,
						1075,
						1075,
						1075,
						1075
					],
					"rangeBurn": "1075",
					"image": {
						"full": "ThreshQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ThreshW",
					"name": "Dark Passage",
					"description": "Thresh throws out a lantern that shields nearby allied Champions from damage. Allies can click the lantern to dash to Thresh.",
					"tooltip": "Thresh throws the Lantern to a target location. If an ally clicks on it Thresh will pull both the Lantern and his ally to him.<br /><br />The Lantern grants a shield lasting {{ e5 }} seconds that absorbs up to {{ e1 }} <span class=\"color0bf7de\">(+{{ f6 }})</span> damage to Thresh and up to one ally if they come near it. The shield amount scales with the number of <span class=\"color0bf7de\">souls</span> Thresh has collected.",
					"leveltip": {
						"label": [
							"Shield Absorption",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20.5,
						19,
						17.5,
						16
					],
					"cooldownBurn": "22/20.5/19/17.5/16",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"1",
						"0",
						"6",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "ThreshW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ThreshE",
					"name": "Flay",
					"description": "Thresh's attacks wind up, dealing more damage the longer he waits between attacks. When activated, Thresh sweeps his chain, knocking all enemies hit in the direction of the blow.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Thresh's basic attacks deal from <span class=\"color0bf7de\">{{ f3 }}</span> to <span class=\"color0bf7de\">{{ f3 }}</span> <span class=\"colorFF8C00\">(+{{ f2 }})</span> additional magic damage, which builds up while not attacking (total <span class=\"color0bf7de\">souls</span> collected plus up to {{ e3 }}% total Attack Damage).<br /><br /><span class=\"colorFF9900\">Active: </span>Deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage in a line beginning behind Thresh. Enemies hit are pushed in the direction of the swing, then slowed by {{ e2 }}% for {{ e4 }} second.<br /><br />Cast forward to push; cast backward to pull.",
					"leveltip": {
						"label": [
							"Passive Damage",
							"Active Damage",
							"Slow",
							"Mana Cost"
						],
						"effect": [
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						9,
						9,
						9,
						9
					],
					"cooldownBurn": "9",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							65,
							95,
							125,
							155,
							185
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"65/95/125/155/185",
						"20/25/30/35/40",
						"80/110/140/170/200",
						"1",
						"1",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "ThreshE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ThreshRPenta",
					"name": "The Box",
					"description": "A prison of walls that slow and deal damage if broken.",
					"tooltip": "Thresh creates a prison of spectral walls around himself. Enemy champions who walk through a wall suffer {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are slowed by {{ e3 }}% for {{ e2 }} seconds, but break that wall.  <br /><br />Once one wall is broken, the remaining walls deal no damage and apply half slow duration. An enemy cannot be affected by multiple walls simultaneously.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						120,
						100
					],
					"cooldownBurn": "140/120/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							250,
							400,
							550
						],
						[
							2,
							2,
							2
						],
						[
							99,
							99,
							99
						],
						[
							4,
							4,
							4
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"250/400/550",
						"2",
						"99",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "ThreshRPenta.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Damnation",
				"description": "Thresh can harvest the souls of enemies that die near him, permanently granting him Armor and Ability Power.",
				"image": {
					"full": "Thresh_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 48,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Thresh",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3097",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Thresh",
					"title": "ThreshTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3109",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Tristana": {
			"id": "Tristana",
			"key": "18",
			"name": "Tristana",
			"title": "the Yordle Gunner",
			"image": {
				"full": "Tristana.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 96,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "18000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "18001",
					"num": 1,
					"name": "Riot Girl Tristana",
					"chromas": false
				},
				{
					"id": "18002",
					"num": 2,
					"name": "Earnest Elf Tristana",
					"chromas": false
				},
				{
					"id": "18003",
					"num": 3,
					"name": "Firefighter Tristana",
					"chromas": false
				},
				{
					"id": "18004",
					"num": 4,
					"name": "Guerilla Tristana",
					"chromas": false
				},
				{
					"id": "18005",
					"num": 5,
					"name": "Buccaneer Tristana",
					"chromas": false
				},
				{
					"id": "18006",
					"num": 6,
					"name": "Rocket Girl Tristana",
					"chromas": true
				},
				{
					"id": "18010",
					"num": 10,
					"name": "Dragon Trainer Tristana",
					"chromas": false
				},
				{
					"id": "18011",
					"num": 11,
					"name": "Bewitching Tristana",
					"chromas": false
				},
				{
					"id": "18012",
					"num": 12,
					"name": "Omega Squad Tristana",
					"chromas": true
				}
			],
			"lore": "While many other yordles channel their energy into discovery, invention, or just plain mischief-making, Tristana was always inspired by the adventures of great warriors. She had heard much about Runeterra, its factions, and its wars, and believed her kind could become worthy of legend too. Setting foot in the world for the first time, she took up her trusty cannon Boomer, and now leaps into battle with steadfast courage and optimism.",
			"blurb": "While many other yordles channel their energy into discovery, invention, or just plain mischief-making, Tristana was always inspired by the adventures of great warriors. She had heard much about Runeterra, its factions, and its wars, and believed her...",
			"allytips": [
				"Her massive gun allows Tristana to fire on targets at a great distance. Utilize this to prevent your enemies from ever laying a hand on you.",
				"Use Rocket Jump after you have stacked up your Explosive Charge on an enemy to finish them off with a burst of damage.",
				"Use Rapid Fire to help stack up your Explosive Charge on enemy champions."
			],
			"enemytips": [
				"If you see Tristana activate Rapid Fire in a fight, stun her and try to back off until the spell dissipates.",
				"Stand away from your creeps in a lane to take less collateral damage from Explosive Charge."
			],
			"tags": [
				"Marksman",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 3,
				"magic": 5,
				"difficulty": 4
			},
			"stats": {
				"hp": 542.76,
				"hpperlevel": 82,
				"mp": 246.76,
				"mpperlevel": 32,
				"movespeed": 325,
				"armor": 31,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6,
				"hpregenperlevel": 0.65,
				"mpregen": 7.206,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 65,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": -0.0473,
				"attackspeedperlevel": 1.5
			},
			"spells": [
				{
					"id": "TristanaQ",
					"name": "Rapid Fire",
					"description": "Tristana fires her weapon rapidly, increasing her Attack Speed for a short time.",
					"tooltip": "<span class=\"colorFF9900\">Active: </span>Increases Tristana's Attack Speed by {{ e1 }}% for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Attack Speed %",
							"Cooldown"
						],
						"effect": [
							" {{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}</postScriptRight>"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						19,
						18,
						17,
						16
					],
					"cooldownBurn": "20/19/18/17/16",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/50/70/90/110",
						"7",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "TristanaQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "TristanaW",
					"name": "Rocket Jump",
					"description": "Tristana fires at the ground to propel her to a distant location, dealing damage and slowing surrounding units for a brief period where she lands.",
					"tooltip": "Tristana launches herself to target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and slowing surrounding enemies by {{ e3 }}% for {{ e2 }} seconds.<br /><br />Kills, Assists, and max stack Explosive Charge detonations on Champions reset Rocket Jump's cooldown.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20,
						18,
						16,
						14
					],
					"cooldownBurn": "22/20/18/16/14",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							1,
							1.5,
							2,
							2.5,
							3
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							350,
							350,
							350,
							350,
							350
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/110/160/210/260",
						"1/1.5/2/2.5/3",
						"60",
						"350",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "TristanaW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TristanaE",
					"name": "Explosive Charge",
					"description": "When Tristana kills a unit, her cannonballs burst into shrapnel, dealing damage to surrounding enemies. Can be activated to place a bomb on a target enemy that explodes after a short duration dealing damage to surrounding units.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Enemies explode when slain by Tristana's basic attacks, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage to nearby enemies.<br /><br /><span class=\"colorFF9900\">Active: </span>Places a bomb on an enemy or turret that explodes after 4 seconds, dealing {{ e4 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> Physical Damage. Each attack and ability charges the bomb's damage by +{{ e6 }}%.<br /><br />At 4 charges, the bomb explodes immediately. The detonation radius is twice as large if used on a turret.",
					"leveltip": {
						"label": [
							"Passive Explosion Damage",
							"Base Charge Damage",
							"Mana Cost",
							"Bonus Attack Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ e5 }}% -> {{ e5NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15.5,
						15,
						14.5,
						14
					],
					"cooldownBurn": "16/15.5/15/14.5/14",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							55,
							80,
							105,
							130,
							155
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							60,
							70,
							80,
							90,
							100
						],
						[
							50,
							60,
							70,
							80,
							90
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							500,
							500,
							500,
							500,
							500
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/80/105/130/155",
						"4",
						"300",
						"60/70/80/90/100",
						"50/60/70/80/90",
						"30",
						"500",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "TristanaE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TristanaR",
					"name": "Buster Shot",
					"description": "Tristana loads a massive cannonball into her weapon and fires it at an enemy unit. This deals Magic Damage and knocks the target back. If the target is carrying the Explosive Charge bomb, the bomb detonation radius is doubled.",
					"tooltip": "Tristana fires a massive cannonball at an enemy unit. This deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and knocks surrounding units back {{ e2 }} distance.",
					"leveltip": {
						"label": [
							"Damage",
							"Knockback Distance",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							" {{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							300,
							400,
							500
						],
						[
							600,
							800,
							1000
						],
						[
							200,
							200,
							200
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"300/400/500",
						"600/800/1000",
						"200",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "TristanaR.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Draw a Bead",
				"description": "Increases Tristana's Attack Range as she levels.",
				"image": {
					"full": "Tristana_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 96,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Tristana",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tristana",
					"title": "TristanaTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Trundle": {
			"id": "Trundle",
			"key": "48",
			"name": "Trundle",
			"title": "the Troll King",
			"image": {
				"full": "Trundle.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 144,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "48000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "48001",
					"num": 1,
					"name": "Lil' Slugger Trundle",
					"chromas": false
				},
				{
					"id": "48002",
					"num": 2,
					"name": "Junkyard Trundle",
					"chromas": false
				},
				{
					"id": "48003",
					"num": 3,
					"name": "Traditional Trundle",
					"chromas": false
				},
				{
					"id": "48004",
					"num": 4,
					"name": "Constable Trundle",
					"chromas": false
				},
				{
					"id": "48005",
					"num": 5,
					"name": "Worldbreaker Trundle",
					"chromas": false
				}
			],
			"lore": "Trundle is a hulking and devious troll with a particularly vicious streak, and there is nothing he cannot bludgeon into submission—not even the Freljord itself. Fiercely territorial, he chases down anyone foolish enough to enter his domain. Then, his massive club of True Ice at the ready, he chills his enemies to the bone and impales them with jagged, frozen pillars, laughing as they bleed out onto the tundra.",
			"blurb": "Trundle is a hulking and devious troll with a particularly vicious streak, and there is nothing he cannot bludgeon into submission—not even the Freljord itself. Fiercely territorial, he chases down anyone foolish enough to enter his domain. Then, his...",
			"allytips": [
				"Trundle excels at fighting within his Frozen Domain. Try to draw enemies onto it.",
				"Use Subjugate to soften a powerful enemy tank or to create a target for your team to focus fire.",
				"Chomp is good for lowering the physical damage of enemies; try to focus it on enemy physical damage dealers."
			],
			"enemytips": [
				"Trundle is very powerful at location-based combat. Try to draw him off of his Frozen Domain.",
				"Make sure to get out of his Pillar of Ice as quickly as possible, as it significantly slows you down."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 6,
				"magic": 2,
				"difficulty": 5
			},
			"stats": {
				"hp": 616.28,
				"hpperlevel": 96,
				"mp": 281.6,
				"mpperlevel": 45,
				"movespeed": 350,
				"armor": 37,
				"armorperlevel": 2.7,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 6,
				"hpregenperlevel": 0.75,
				"mpregen": 7.508,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.0672,
				"attackspeedperlevel": 2.9
			},
			"spells": [
				{
					"id": "TrundleTrollSmash",
					"name": "Chomp",
					"description": "Trundle bites his opponent, dealing damage, briefly slowing and sapping some of their Attack Damage.",
					"tooltip": "Trundle lunges at his opponent with his next basic attack, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and briefly slowing his target.<br /><br />This attack increases Trundle's Attack Damage by {{ e3 }} for {{ e6 }} seconds, with his opponent losing half of this amount.",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Damage",
							"Attack Damage Scaling"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						4,
						4,
						4,
						4,
						4
					],
					"cooldownBurn": "4",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							100,
							105,
							110,
							115,
							120
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							-10,
							-12.5,
							-15,
							-17.5,
							-20
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/40/60/80/100",
						"100/105/110/115/120",
						"20/25/30/35/40",
						"-10/-12.5/-15/-17.5/-20",
						"7",
						"8",
						"0.75",
						"0.1",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.8,
								0.9,
								1,
								1.1,
								1.2
							],
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "TrundleTrollSmash.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "trundledesecrate",
					"name": "Frozen Domain",
					"description": "Trundle turns target location into his domain, gaining Attack Speed, Movement Speed, and increased healing from all sources while on it.",
					"tooltip": "Trundle coats target location with ice for {{ e4 }} seconds, gaining {{ e1 }}% Movement Speed, {{ e2 }}% Attack Speed and {{ e3 }}% increased healing and regeneration from all sources.",
					"leveltip": {
						"label": [
							"Movement Speed",
							"Attack Speed"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						60,
						60,
						60,
						60,
						60
					],
					"costBurn": "60",
					"effect": [
						null,
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							20,
							35,
							50,
							65,
							80
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							775,
							775,
							775,
							775,
							775
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/25/30/35/40",
						"20/35/50/65/80",
						"25",
						"8",
						"775",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "trundledesecrate.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TrundleCircle",
					"name": "Pillar of Ice",
					"description": "Trundle creates an ice pillar at target location, becoming impassable terrain and slowing all nearby enemy units.",
					"tooltip": "Trundle creates an icy pillar at target location for {{ e1 }} seconds, becoming impassable terrain and slowing all nearby enemy units by {{ e2 }}%.",
					"leveltip": {
						"label": [
							"Cooldown",
							"Slow"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20,
						18,
						16,
						14
					],
					"cooldownBurn": "22/20/18/16/14",
					"cost": [
						75,
						75,
						75,
						75,
						75
					],
					"costBurn": "75",
					"effect": [
						null,
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							360,
							360,
							360,
							360,
							360
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6",
						"30/35/40/45/50",
						"360",
						"225",
						"150",
						"225",
						"400",
						"60",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "TrundleCircle.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TrundlePain",
					"name": "Subjugate",
					"description": "Trundle immediately steals a percent of his target's Health, Armor and Magic Resistance. Over the next 4 seconds the amount of Health, Armor, and Magic Resistance stolen is doubled.",
					"tooltip": "Trundle drains {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of an enemy champion's maximum Health as Magic Damage and {{ e2 }}% of their Armor and Magic Resist, half immediately and half over {{ e3 }} seconds. The Armor and Magic Resist is returned {{ e3 }} seconds after the drain ends.",
					"leveltip": {
						"label": [
							"Health Drain",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						90,
						70
					],
					"cooldownBurn": "110/90/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							20,
							27.5,
							35
						],
						[
							40,
							40,
							40
						],
						[
							4,
							4,
							4
						],
						[
							4,
							4,
							4
						],
						[
							8,
							8,
							8
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							5,
							5,
							5
						],
						[
							0.02,
							0.02,
							0.02
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/27.5/35",
						"40",
						"4",
						"4",
						"8",
						"0.5",
						"5",
						"0.02",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.02,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "TrundlePain.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "King's Tribute",
				"description": "When an enemy unit dies near Trundle, he heals for a percent of its maximum Health.",
				"image": {
					"full": "Trundle_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 144,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Trundle",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Trundle",
					"title": "TrundleTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Tryndamere": {
			"id": "Tryndamere",
			"key": "23",
			"name": "Tryndamere",
			"title": "the Barbarian King",
			"image": {
				"full": "Tryndamere.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 192,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "23000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "23001",
					"num": 1,
					"name": "Highland Tryndamere",
					"chromas": false
				},
				{
					"id": "23002",
					"num": 2,
					"name": "King Tryndamere",
					"chromas": false
				},
				{
					"id": "23003",
					"num": 3,
					"name": "Viking Tryndamere",
					"chromas": false
				},
				{
					"id": "23004",
					"num": 4,
					"name": "Demonblade Tryndamere",
					"chromas": false
				},
				{
					"id": "23005",
					"num": 5,
					"name": "Sultan Tryndamere",
					"chromas": false
				},
				{
					"id": "23006",
					"num": 6,
					"name": "Warring Kingdoms Tryndamere",
					"chromas": false
				},
				{
					"id": "23007",
					"num": 7,
					"name": "Nightmare Tryndamere",
					"chromas": false
				},
				{
					"id": "23008",
					"num": 8,
					"name": "Beast Hunter Tryndamere",
					"chromas": false
				},
				{
					"id": "23009",
					"num": 9,
					"name": "Chemtech Tryndamere",
					"chromas": false
				}
			],
			"lore": "Fueled by unbridled fury and rage, Tryndamere once carved his way through the Freljord, openly challenging the greatest warriors of the north to prepare himself for even darker days ahead. The wrathful barbarian has long sought revenge for the annihilation of his clan, though more recently he has found companionship with Ashe, the Avarosan warmother, and a home with her people. His almost inhuman strength and fortitude is legendary, and has delivered him and his new allies countless victories against the greatest of odds.",
			"blurb": "Fueled by unbridled fury and rage, Tryndamere once carved his way through the Freljord, openly challenging the greatest warriors of the north to prepare himself for even darker days ahead. The wrathful barbarian has long sought revenge for the...",
			"allytips": [
				"Delaying the activation of Undying Rage is a very effective way to make an enemy champion over-commit to trying to kill you.",
				"Bloodlust is an excellent way to heal Tryndamere. Try not to let it fade off before you activate it.",
				"If the enemy is stacking Armor, try building items like Last Whisper or Youmuu's Ghostblade."
			],
			"enemytips": [
				"Try harassing Tryndamere early so he can't kill minions and heal with Bloodlust.",
				"Remember, Tryndamere can only slow you if you are facing away from him.",
				"Most of Tryndamere's damage is physical. If he's getting too strong, consider buying a Thornmail."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Fury",
			"info": {
				"attack": 10,
				"defense": 5,
				"magic": 2,
				"difficulty": 5
			},
			"stats": {
				"hp": 625.64,
				"hpperlevel": 98,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 33,
				"armorperlevel": 3.1,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8.5,
				"hpregenperlevel": 0.9,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 69,
				"attackdamageperlevel": 3.7,
				"attackspeedoffset": -0.0672,
				"attackspeedperlevel": 2.9
			},
			"spells": [
				{
					"id": "TryndamereQ",
					"name": "Bloodlust",
					"description": "Tryndamere thrives on the thrills of combat, increasing his Attack Damage as he is more and more wounded. He can cast Bloodlust to consume his Fury and heal himself.",
					"tooltip": "<spellPassive>Passive:</spellPassive> Tryndamere thirsts for blood, gaining {{ e1 }} Attack Damage plus {{ e2 }} per 1% Health missing.<br /><br /><spellActive>Active:</spellActive> Tryndamere consumes his Fury, restoring {{ e3 }} <scaleAP>(+{{ a1 }})</scaleAP> Health, plus {{ e4 }} <scaleAP>(+{{ f2 }})</scaleAP> Health per Fury consumed.",
					"leveltip": {
						"label": [
							"Attack Damage",
							"Attack Damage per Health % Missing",
							"Heal",
							"Heal Per Fury"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e4 }} -> {{ e4NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							5,
							10,
							15,
							20,
							25
						],
						[
							0.15,
							0.2,
							0.25,
							0.3,
							0.35
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							0.5,
							0.95,
							1.4,
							1.85,
							2.3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5/10/15/20/25",
						"0.15/0.2/0.25/0.3/0.35",
						"30/40/50/60/70",
						"0.5/0.95/1.4/1.85/2.3",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "TryndamereQ.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "TryndamereW",
					"name": "Mocking Shout",
					"description": "Tryndamere lets out an insulting cry, decreasing surrounding champions' Attack Damage. Enemies with their backs turned to Tryndamere also have their Movement Speed reduced.",
					"tooltip": "Decreases surrounding champions' Attack Damage by {{ e1 }} for {{ e3 }} seconds, and enemies with their backs turned also have their Movement Speed reduced by {{ e2 }}% for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Attack Damage Reduction",
							"Movement Speed Reduction"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						14,
						14,
						14,
						14
					],
					"cooldownBurn": "14",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							35,
							50,
							65,
							80
						],
						[
							30,
							37.5,
							45,
							52.5,
							60
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/35/50/65/80",
						"30/37.5/45/52.5/60",
						"4",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "TryndamereW.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "TryndamereE",
					"name": "Spinning Slash",
					"description": "Tryndamere slices toward a target unit, dealing damage to enemies in his path.",
					"tooltip": "Tryndamere spins through his enemies, dealing {{ e1 }} <scaleAD>(+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> physical damage to enemies in his path and generating Fury.<br /><br />Spinning Slash's cooldown is reduced by {{ e2 }} second whenever Tryndamere critically strikes. This reduction is increased to {{ e3 }} seconds against champions.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/110/140/170/200",
						"1",
						"2",
						"2",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.3,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "TryndamereE.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "UndyingRage",
					"name": "Undying Rage",
					"description": "Tryndamere's lust for battle becomes so strong that he is unable to die, no matter how wounded he becomes.",
					"tooltip": "Tryndamere becomes completely immune to death for {{ e3 }} seconds, refusing to be reduced below {{ e2 }} Health and instantly gaining {{ e1 }} Fury.",
					"leveltip": {
						"label": [
							"Fury Gained",
							"Minimum Health",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						100,
						90
					],
					"cooldownBurn": "110/100/90",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							50,
							75,
							100
						],
						[
							30,
							50,
							70
						],
						[
							5,
							5,
							5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100",
						"30/50/70",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "UndyingRage.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Battle Fury",
				"description": "Tryndamere gains Fury for each attack, critical strike, and killing blow he makes. Fury passively increases his Critical Strike Chance and can be consumed with his Bloodlust spell.",
				"image": {
					"full": "Tryndamere_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 192,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Tryndamere",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1054",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3065",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3035",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2015",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2015",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Tryndamere",
					"title": "TryndamereTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"TwistedFate": {
			"id": "TwistedFate",
			"key": "4",
			"name": "Twisted Fate",
			"title": "the Card Master",
			"image": {
				"full": "TwistedFate.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 240,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "4000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "4001",
					"num": 1,
					"name": "PAX Twisted Fate",
					"chromas": false
				},
				{
					"id": "4002",
					"num": 2,
					"name": "Jack of Hearts Twisted Fate",
					"chromas": false
				},
				{
					"id": "4003",
					"num": 3,
					"name": "The Magnificent Twisted Fate",
					"chromas": false
				},
				{
					"id": "4004",
					"num": 4,
					"name": "Tango Twisted Fate",
					"chromas": false
				},
				{
					"id": "4005",
					"num": 5,
					"name": "High Noon Twisted Fate",
					"chromas": false
				},
				{
					"id": "4006",
					"num": 6,
					"name": "Musketeer Twisted Fate",
					"chromas": false
				},
				{
					"id": "4007",
					"num": 7,
					"name": "Underworld Twisted Fate",
					"chromas": false
				},
				{
					"id": "4008",
					"num": 8,
					"name": "Red Card Twisted Fate",
					"chromas": false
				},
				{
					"id": "4009",
					"num": 9,
					"name": "Cutpurse Twisted Fate",
					"chromas": false
				},
				{
					"id": "4010",
					"num": 10,
					"name": "Blood Moon Twisted Fate",
					"chromas": false
				}
			],
			"lore": "Twisted Fate is an infamous cardsharp and swindler who has gambled and charmed his way across much of the known world, earning the enmity and admiration of the rich and foolish alike. He rarely takes things seriously, greeting each day with a mocking smile and an insouciant swagger. In every possible way, Twisted Fate always has an ace up his sleeve.",
			"blurb": "Twisted Fate is an infamous cardsharp and swindler who has gambled and charmed his way across much of the known world, earning the enmity and admiration of the rich and foolish alike. He rarely takes things seriously, greeting each day with a mocking...",
			"allytips": [
				"Coordinate with your allies for the best time to use Destiny to ambush enemies.",
				"Stealth characters often escape a battle with very low hit points. Take advantage of Destiny's ability to reveal stealthed units to finish them off.",
				"Twisted Fate is viable as an Attack Damage or Ability Power character, letting him fit on many different team compositions."
			],
			"enemytips": [
				"Focus on dodging Wild Cards early when your champion doesn't have the hit points to afford getting hit.",
				"If you have low Health, use Destiny as an indicator to run to safety. It will give you a head start in escaping any possible ganks."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 2,
				"magic": 6,
				"difficulty": 9
			},
			"stats": {
				"hp": 534,
				"hpperlevel": 94,
				"mp": 265.84,
				"mpperlevel": 38,
				"movespeed": 335,
				"armor": 20.542,
				"armorperlevel": 3.15,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 5.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 49.954,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": -0.04,
				"attackspeedperlevel": 3.22
			},
			"spells": [
				{
					"id": "WildCards",
					"name": "Wild Cards",
					"description": "Twisted Fate throws three cards, dealing damage to each enemy unit they pass through.",
					"tooltip": "Throws three cards that deal {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage to each enemy unit they pass through.",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						60,
						70,
						80,
						90,
						100
					],
					"costBurn": "60/70/80/90/100",
					"effect": [
						null,
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/105/150/195/240",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						10000,
						10000,
						10000,
						10000,
						10000
					],
					"rangeBurn": "10000",
					"image": {
						"full": "WildCards.png",
						"sprite": "spell11.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "PickACard",
					"name": "Pick A Card",
					"description": "Twisted Fate chooses a magic card from his deck, and uses that for his next attack, causing bonus effects.",
					"tooltip": "Cast once to shuffle the deck and again to choose your card, enhancing your next attack.<br /><br /><span class=\"color4455FF\">Blue Card</span> deals {{ e1 }} <scaleAD>(+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage and restores {{ e6 }} Mana.<br /><br /><span class=\"colorFF2222\">Red Card</span> deals {{ e4 }} <scaleAD>(+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage to units around the target and slows their Movement Speed by {{ e2 }}% for 2.5 seconds.<br /><br /><span class=\"colorFFD700\">Gold Card</span> deals {{ e5 }}<scaleAD> (+{{ a2 }})</scaleAD> <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage and stuns for {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Blue Card Damage",
							"Blue Card Mana Restore",
							"Red Card Damage",
							"Red Card Slow %",
							"Gold Card Damage",
							"Gold Card Stun Duration",
							"Mana Cost"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						40,
						55,
						70,
						85,
						100
					],
					"costBurn": "40/55/70/85/100",
					"effect": [
						null,
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							1,
							1.25,
							1.5,
							1.75,
							2
						],
						[
							30,
							45,
							60,
							75,
							90
						],
						[
							15,
							22.5,
							30,
							37.5,
							45
						],
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/60/80/100/120",
						"30/35/40/45/50",
						"1/1.25/1.5/1.75/2",
						"30/45/60/75/90",
						"15/22.5/30/37.5/45",
						"50/75/100/125/150",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a2"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						200,
						200,
						200,
						200,
						200
					],
					"rangeBurn": "200",
					"image": {
						"full": "PickACard.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "CardmasterStack",
					"name": "Stacked Deck",
					"description": "Every 4 attacks, Twisted Fate deals bonus damage. In addition, his Attack Speed is increased.",
					"tooltip": "<spellPassive>Passive:</spellPassive> Every 4 attacks, Twisted Fate deals an additional {{ e1 }} <scaleAP>(+{{ a1 }})</scaleAP> Magic Damage.<br /><br />In addition, his Attack Speed is increased by {{ e3 }}%.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Attack Speed Increase"
						],
						"effect": [
							" {{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							55,
							80,
							105,
							130,
							155
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/80/105/130/155",
						"0",
						"10/15/20/25/30",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": "",
					"maxammo": "-1",
					"range": [
						0,
						0,
						0,
						0,
						0
					],
					"rangeBurn": "0",
					"image": {
						"full": "CardmasterStack.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					}
				},
				{
					"id": "Destiny",
					"name": "Destiny",
					"description": "Twisted Fate predicts the fortunes of his foes, revealing all enemy champions and enabling the use of Gate, which teleports Twisted Fate to any target location in 1.5 seconds.",
					"tooltip": "Grants <span class=\"coloree91d7\">True Sight</span> on all enemy champions on the map for {{ e1 }} seconds.<br /><br />While Destiny is active, Twisted Fate can teleport up to {{ e4 }} units away in 1.5 seconds.",
					"leveltip": {
						"label": [
							"Duration",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						180,
						150,
						120
					],
					"cooldownBurn": "180/150/120",
					"cost": [
						150,
						125,
						100
					],
					"costBurn": "150/125/100",
					"effect": [
						null,
						[
							6,
							8,
							10
						],
						[
							180,
							150,
							120
						],
						[
							150,
							125,
							100
						],
						[
							5500,
							5500,
							5500
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6/8/10",
						"180/150/120",
						"150/125/100",
						"5500",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						5500,
						5500,
						5500
					],
					"rangeBurn": "5500",
					"image": {
						"full": "Destiny.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Loaded Dice",
				"description": "Upon killing a unit, Twisted Fate rolls his 'lucky' dice receiving anywhere between 1 and 6 bonus gold.",
				"image": {
					"full": "Cardmaster_SealFate.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 240,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "TwistedFate",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "TwistedFate",
					"title": "TwistedFateTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Twitch": {
			"id": "Twitch",
			"key": "29",
			"name": "Twitch",
			"title": "the Plague Rat",
			"image": {
				"full": "Twitch.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 288,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "29000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "29001",
					"num": 1,
					"name": "Kingpin Twitch",
					"chromas": false
				},
				{
					"id": "29002",
					"num": 2,
					"name": "Whistler Village Twitch",
					"chromas": false
				},
				{
					"id": "29003",
					"num": 3,
					"name": "Medieval Twitch",
					"chromas": false
				},
				{
					"id": "29004",
					"num": 4,
					"name": "Gangster Twitch",
					"chromas": false
				},
				{
					"id": "29005",
					"num": 5,
					"name": "Vandal Twitch",
					"chromas": false
				},
				{
					"id": "29006",
					"num": 6,
					"name": "Pickpocket Twitch",
					"chromas": false
				},
				{
					"id": "29007",
					"num": 7,
					"name": "SSW Twitch",
					"chromas": false
				},
				{
					"id": "29008",
					"num": 8,
					"name": "Omega Squad Twitch",
					"chromas": true
				}
			],
			"lore": "A Zaunite plague rat by birth, but a connoisseur of filth by passion, Twitch is not afraid to get his paws dirty. Aiming a chem-powered crossbow at the gilded heart of Piltover, he has vowed to show those in the city above just how filthy they really are. Always a sneaky sneak, when he's not rooting around in the Sump, he's digging deep into other people's garbage for discarded treasures… and perhaps a moldy sandwich.",
			"blurb": "A Zaunite plague rat by birth, but a connoisseur of filth by passion, Twitch is not afraid to get his paws dirty. Aiming a chem-powered crossbow at the gilded heart of Piltover, he has vowed to show those in the city above just how filthy they really...",
			"allytips": [
				"Twitch's Attack Speed is among the highest in the game; try purchasing items with on-hit effects such as Black Cleaver or Wit's End.",
				"Contaminate has a large range; apply as many stacks of Deadly Venom as possible before using it.",
				"You can catch up to an enemy out of attack range with Venom Cask."
			],
			"enemytips": [
				"Twitch is fragile. Work with teammates to focus on him when you're able to catch him out of Camouflage.",
				"Spell Shields won't block the damage from Deadly Venom, but they will block the effects Twitch can trigger with it.",
				"If you suspect Twitch has left the lane, let your teammates know that Twitch is ''MIA.''"
			],
			"tags": [
				"Marksman",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 2,
				"magic": 3,
				"difficulty": 6
			},
			"stats": {
				"hp": 525.08,
				"hpperlevel": 81,
				"mp": 287.2,
				"mpperlevel": 40,
				"movespeed": 330,
				"armor": 32,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6,
				"hpregenperlevel": 0.6,
				"mpregen": 7.256,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 63,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": -0.08,
				"attackspeedperlevel": 3.38
			},
			"spells": [
				{
					"id": "TwitchHideInShadows",
					"name": "Ambush",
					"description": "Twitch becomes Camouflaged for a short duration and gains Movement Speed. When leaving Camouflage, Twitch gains Attack Speed for a short duration.<br><br>When an enemy champion with Deadly Venom dies, Ambush's cooldown is reset.",
					"tooltip": "Twitch becomes <span class=\"colorcd90ee\">Camouflaged</span> and gains {{ e3 }}% Movement Speed for {{ e2 }} seconds. This bonus triples when he is nearby an enemy champion that cannot see him. <br /><br />Twitch gains {{ e1 }}% Attack Speed for {{ e6 }} seconds after exiting Ambush. Ambush resets when a champion dies while affected by <span class=\"color3ca126\">Deadly Venom.</span><br /><br /><font color='#cd90ee'size='16'><u>Stealth - Camouflage:</u></span> <font color='#8C8C8C'size='16'>Twitch is hidden from view while enemy champions remain outside his detection radius. Attacking or casting spells ends Camouflage.</span>",
					"leveltip": {
						"label": [
							"Camouflage Duration",
							"Attack Speed"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }}% -> {{ e1NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						16,
						16,
						16,
						16
					],
					"cooldownBurn": "16",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							10,
							11,
							12,
							13,
							14
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							500,
							500,
							500,
							500,
							500
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							30,
							30,
							30,
							30,
							30
						]
					],
					"effectBurn": [
						null,
						"30/35/40/45/50",
						"10/11/12/13/14",
						"10",
						"1",
						"1",
						"5",
						"3",
						"500",
						"1000",
						"30"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						20,
						20,
						20,
						20,
						20
					],
					"rangeBurn": "20",
					"image": {
						"full": "TwitchHideInShadows.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TwitchVenomCask",
					"name": "Venom Cask",
					"description": "Twitch hurls a cask of venom that explodes in an area, slowing targets and applying deadly venom to the target.",
					"tooltip": "Twitch hurls a cask that adds a stack of <span class=\"color3ca126\">Deadly Venom</span> to all enemies struck and leaves behind a toxic cloud that persists for {{ e3 }} seconds.<br /><br />Enemies that remain within the cloud have {{ e2 }}% reduced Movement Speed and receive an additional stack of <span class=\"color3ca126\">Deadly Venom</span> each second.",
					"leveltip": {
						"label": [
							"Slow Amount",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2",
						"25/30/35/40/45",
						"3",
						"300",
						"3.5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						950,
						950,
						950,
						950,
						950
					],
					"rangeBurn": "950",
					"image": {
						"full": "TwitchVenomCask.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TwitchExpunge",
					"name": "Contaminate",
					"description": "Twitch wreaks further havoc on poisoned enemies with a blast of his vile diseases.",
					"tooltip": "Deals {{ e2 }} physical damage plus {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> <span class=\"colorFF8C00\">(+{{ f1 }})</span> per stack of <span class=\"color3ca126\">Deadly Venom</span> to all nearby enemies affected by <span class=\"color3ca126\">Deadly Venom.</span> <span class=\"colora3554e\">(Max Stack Damage: {{ f2 }})</span>",
					"leveltip": {
						"label": [
							"Base Damage",
							"Damage per Stack",
							"Mana Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/20/25/30/35",
						"20/25/30/35/40",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "TwitchExpunge.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "TwitchFullAutomatic",
					"name": "Spray and Pray",
					"description": "Twitch unleashes the full power of his crossbow, shooting bolts over a great distance that pierce all enemies caught in their path.",
					"tooltip": "For {{ e2 }} seconds Twitch gains {{ e5 }} Attack Range and {{ e1 }} Bonus Attack Damage.<br /><br />For the duration, his basic attacks become piercing bolts that deal {{ e3 }}% less damage to subsequent targets, down to a minimum of {{ e4 }}% damage.<br /><br /><font color='#cd90ee'size='16'><u>Stealth - Camouflage:</u></span> <font color='#8C8C8C'size='16'>Activating Spray and Pray does not end Camouflage.",
					"leveltip": {
						"label": [
							"Attack Damage Bonus"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						90,
						90,
						90
					],
					"cooldownBurn": "90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							20,
							30,
							40
						],
						[
							5,
							5,
							5
						],
						[
							20,
							20,
							20
						],
						[
							40,
							40,
							40
						],
						[
							300,
							300,
							300
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40",
						"5",
						"20",
						"40",
						"300",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "TwitchFullAutomatic.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Deadly Venom",
				"description": "Twitch's basic attacks infect the target, dealing true damage each second.",
				"image": {
					"full": "Twitch_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 288,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Twitch",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1043",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Twitch",
					"title": "TwitchTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Udyr": {
			"id": "Udyr",
			"key": "77",
			"name": "Udyr",
			"title": "the Spirit Walker",
			"image": {
				"full": "Udyr.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 336,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "77000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "77001",
					"num": 1,
					"name": "Black Belt Udyr",
					"chromas": false
				},
				{
					"id": "77002",
					"num": 2,
					"name": "Primal Udyr",
					"chromas": false
				},
				{
					"id": "77003",
					"num": 3,
					"name": "Spirit Guard Udyr",
					"chromas": false
				},
				{
					"id": "77004",
					"num": 4,
					"name": "Definitely Not Udyr",
					"chromas": false
				}
			],
			"lore": "Udyr is more than a man; he is a vessel for the untamed power of four primal animal spirits. When tapping into the spirits' bestial natures, Udyr can harness their unique strengths: The tiger grants him speed and ferocity, the turtle resilience, the bear might, and the phoenix its eternal flame. With their combined power, Udyr can turn back all those who would attempt to harm the natural order.",
			"blurb": "Udyr is more than a man; he is a vessel for the untamed power of four primal animal spirits. When tapping into the spirits' bestial natures, Udyr can harness their unique strengths: The tiger grants him speed and ferocity, the turtle resilience, the...",
			"allytips": [
				"Damage is applied to turtle shield post-mitigation. Therefore, buying defensive items can drastically increase your survivability.",
				"Udyr is one of the best junglers in the game. Taking advantage of this can give your team a large XP advantage and map control."
			],
			"enemytips": [
				"Udyr players will often start in the jungle and only appear to gank in lanes. Try warding key locations to keep track of his movement.",
				"Once the initial shield effect has faded, Turtle Stance is weak against other champions. Press the attack to force him to switch stances and prevent him from regenerating health.",
				"Some Udyr players buy tank items to become very durable. If they do, focus their weaker teammates instead."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 7,
				"magic": 4,
				"difficulty": 7
			},
			"stats": {
				"hp": 593.32,
				"hpperlevel": 99,
				"mp": 270.4,
				"mpperlevel": 30,
				"movespeed": 345,
				"armor": 34,
				"armorperlevel": 4,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 6,
				"hpregenperlevel": 0.75,
				"mpregen": 7.506,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 5,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2.67
			},
			"spells": [
				{
					"id": "UdyrTigerStance",
					"name": "Tiger Stance",
					"description": "Tiger Stance: Activation - Udyr's Attack Speed is increased for a few seconds. Persistent Effect - Udyr's first attack and every third attack after will deal a high amount of damage over 2 seconds.",
					"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Udyr's first attack and every third attack after will perform a Tiger Strike, dealing bonus {{ e1 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> physical damage over {{ e5 }} seconds. <br /><br />If a target is affected by Tiger Strike, a new application of Tiger Strike will deal the remaining damage instantly.<br /><br /><span class=\"colorFF9900\">Activation:</span> Increases Attack Speed by {{ e2 }}% for {{ e6 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
					"leveltip": {
						"label": [
							"Tiger Strike Damage",
							"Attack Speed",
							"Tiger Strike Scaling"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e4 }}% -> {{ e4NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							30,
							60,
							90,
							120,
							150
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							0.15,
							0.15,
							0.15,
							0.15,
							0.15
						],
						[
							120,
							135,
							150,
							165,
							180
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/60/90/120/150",
						"30/40/50/60/70",
						"0.15",
						"120/135/150/165/180",
						"2",
						"5",
						"0.5",
						"0.25",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								1.2,
								1.3,
								1.4,
								1.5,
								1.6
							],
							"key": "f2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "UdyrTigerStance.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UdyrTurtleStance",
					"name": "Turtle Stance",
					"description": "Turtle Stance: Activation - Udyr gains a temporary shield that absorbs damage. Persistent Effect - Udyr's first attack and every third attack after heals him for 2.5% of his maximum health.",
					"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Udyr's first attack and every third attack after heals him for <span class=\"colorFF3300\">(+{{ f1 }})</span> ({{ e3 }}% of his maximum health), increasing by 1% for every percent of Udyr's missing health.<br /><br /><span class=\"colorFF9900\">Activation: </span>Gains a shield that absorbs {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> damage for {{ e2 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
					"leveltip": {
						"label": [
							"Shield Amount"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							60,
							95,
							130,
							165,
							200
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0.05,
							0.05,
							0.05,
							0.05,
							0.05
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/95/130/165/200",
						"5",
						"2.5",
						"0.05",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "UdyrTurtleStance.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UdyrBearStance",
					"name": "Bear Stance",
					"description": "Bear Stance: Activation - Udyr increases Movement Speed for a short duration. Persistent Effect - Udyr's basic attacks stun his target for 1 second. This effect cannot occur on the same target for several seconds.",
					"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Basic attacks stun the target for {{ e3 }} second. This effect cannot occur on the same target again for {{ e4 }} seconds.<br /><br /><span class=\"colorFF9900\">Activation: </span>Increases Movement Speed by {{ e1 }}% and ignores unit collision for {{ e2 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
					"leveltip": {
						"label": [
							"Movement Speed Increase",
							"Movement Speed Duration"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							2,
							2.25,
							2.5,
							2.75,
							3
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/20/25/30/35",
						"2/2.25/2.5/2.75/3",
						"1",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "UdyrBearStance.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UdyrPhoenixStance",
					"name": "Phoenix Stance",
					"description": "Phoenix Stance: Activation - Udyr unleashes pulsing waves of fire, dealing damage to nearby enemies. Persistent Effect - Udyr's first attack and every third attack after engulfs enemies in front of him with flames.",
					"tooltip": "<span class=\"colorFF9900\">Persistent Effect: </span>Udyr's first attack and every third attack after burns enemies in front of him, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br /><span class=\"colorFF9900\">Activation: </span>Unleashes pulsing waves of fire, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage each second to nearby enemies for {{ e5 }} seconds.<br /><br /><rules><span class=\"color8c8c8c\">Udyr's stance mana costs decrease by 1 each time he levels up.</span></rules>",
					"leveltip": {
						"label": [
							"Pulse Damage",
							"Flame Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							40,
							80,
							120,
							160,
							200
						],
						[
							16,
							24,
							32,
							40,
							48
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							325,
							325,
							325,
							325,
							325
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/20/30/40/50",
						"40/80/120/160/200",
						"16/24/32/40/48",
						"1",
						"4",
						"325",
						"400",
						"3",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						325,
						325,
						325,
						325,
						325
					],
					"rangeBurn": "325",
					"image": {
						"full": "UdyrPhoenixStance.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Monkey's Agility",
				"description": "Entering a stance grants Udyr bonus Attack Speed and Movement Speed for a short duration. This effect can stack multiple times.",
				"image": {
					"full": "Udyr_MonkeysAgility.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 336,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Udyr",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3401",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Udyr",
					"title": "UdyrTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3024",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Urgot": {
			"id": "Urgot",
			"key": "6",
			"name": "Urgot",
			"title": "the Dreadnought",
			"image": {
				"full": "Urgot.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 384,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "6000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "6001",
					"num": 1,
					"name": "Giant Enemy Crabgot",
					"chromas": false
				},
				{
					"id": "6002",
					"num": 2,
					"name": "Butcher Urgot",
					"chromas": false
				},
				{
					"id": "6003",
					"num": 3,
					"name": "Battlecast Urgot",
					"chromas": true
				}
			],
			"lore": "Once a powerful Noxian headsman, Urgot was betrayed by the empire for which he had killed so many. Bound in iron chains, he was forced to learn the true meaning of strength in the Dredge—a prison mine deep beneath Zaun. Emerging in a disaster that spread chaos throughout the city, he now casts an imposing shadow over its criminal underworld. Raising his victims on the very chains that once enslaved him, he will purge his new home of the unworthy, making it a crucible of pain.",
			"blurb": "Once a powerful Noxian headsman, Urgot was betrayed by the empire for which he had killed so many. Bound in iron chains, he was forced to learn the true meaning of strength in the Dredge—a prison mine deep beneath Zaun. Emerging in a disaster that...",
			"allytips": [
				"Pay attention to your individual leg's cooldowns, as they make for a signficiant portion of your damage",
				"Land Corrosive Charge or Disdain to lock on to target's with Purge - a great way to trigger multiple legs in rapid succession.",
				"Save Fear Beyond Death for opponents you know are already too weak to survive. It's especially good for picking off fleeing foes."
			],
			"enemytips": [
				"Urgot relies heavily on blasting opponents with his legs, which have their own cooldowns and only detonate when he attacks in the direction they are facing. Avoid getting hit by multiple.",
				"Urgot can deal and absorb tremendous amounts of damage with Purge, but slows himself while firing.",
				"If you are struck by Fear Beyond Death, do your best to avoid falling below the execution threshold (25% of your Maximum Health) until the effect times out."
			],
			"tags": [
				"Fighter",
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 3,
				"difficulty": 8
			},
			"stats": {
				"hp": 585,
				"hpperlevel": 88,
				"mp": 300,
				"mpperlevel": 45,
				"movespeed": 330,
				"armor": 39,
				"armorperlevel": 4.25,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 350,
				"hpregen": 7.5,
				"hpregenperlevel": 0.7,
				"mpregen": 7.25,
				"mpregenperlevel": 0.6,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 63,
				"attackdamageperlevel": 4,
				"attackspeedoffset": 0.05,
				"attackspeedperlevel": 3.75
			},
			"spells": [
				{
					"id": "UrgotQ",
					"name": "Corrosive Charge",
					"description": "Fires an explosive charge at the target location, dealing physical damage and slowing enemies caught in the explosion.",
					"tooltip": "Urgot fires an explosive charge, dealing {{ e2 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slowing enemies hit by {{ e4 }}% for {{ e5 }} second.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							25,
							70,
							115,
							160,
							205
						],
						[
							0.3,
							0.3,
							0.3,
							0.3,
							0.3
						],
						[
							45,
							50,
							55,
							60,
							65
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0.3,
							0.3,
							0.3,
							0.3,
							0.3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"0.1",
						"25/70/115/160/205",
						"0.3",
						"45/50/55/60/65",
						"1",
						"0.3",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "UrgotQ.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UrgotW",
					"name": "Purge",
					"description": "Urgot shields himself, slowing himself while he unloads his weapon on nearby enemies. Prioritizes enemy champions Urgot has recently struck with other abilities and triggers Echoing Flames.",
					"tooltip": "For {{ e3 }} seconds, Urgot shoots at a nearby enemy {{ e8 }} times a second, dealing {{ e9 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> physical damage per shot, <span class=\"colorFFEB7F\">locking onto</span> champions recently damaged by his other abilities. He also shields himself, absorbing {{ e1 }} <span class=\"colorCC3300\">(+{{ f2 }})</span> damage.<br /><br />While firing, Urgot loses {{ e5 }} movement speed but has {{ e2 }}% slow resistance and can walk over minions and non-epic monsters.<br /><br /><rules><span class=\"color8c8c8c\">Applies on-hits at 33% damage. Cannot critically strike. Minimum of {{ e0 }} damage to minions.</span></rules>",
					"leveltip": {
						"label": [
							"Shield",
							"Attack Damage Per Shot",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e7 }}% -> {{ e7NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							125,
							125,
							125,
							125,
							125
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							20,
							24,
							28,
							32,
							36
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							12,
							12,
							12,
							12,
							12
						],
						[
							50,
							50,
							50,
							50,
							50
						]
					],
					"effectBurn": [
						null,
						"60/90/120/150/180",
						"40",
						"4",
						"450",
						"125",
						"0.5",
						"20/24/28/32/36",
						"3",
						"12",
						"50"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						490,
						490,
						490,
						490,
						490
					],
					"rangeBurn": "490",
					"image": {
						"full": "UrgotW.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UrgotE",
					"name": "Disdain",
					"description": "Urgot charges in a direction, trampling non-champion enemies. If he catches an enemy champion, he will stop and hurl them out of his way.",
					"tooltip": "Urgot charges forwards. If he catches an enemy champion, he will stop and hurl them behind him, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and stunning them for {{ e6 }} seconds.<br /><br />Non-champions take the same damage but are knocked aside.<br /><br /><rules><span class=\"color8c8c8c\">Cannot cross terrain.</span></rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							1200,
							1200,
							1200,
							1200,
							1200
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							1.25,
							1.25,
							1.25,
							1.25,
							1.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"450",
						"1200",
						"100",
						"1.25",
						"0.75",
						"1.25",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						475,
						475,
						475,
						475,
						475
					],
					"rangeBurn": "475",
					"image": {
						"full": "UrgotE.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "UrgotR",
					"name": "Fear Beyond Death",
					"description": "Urgot fires a chem-drill that impales the first enemy champion hit. If that champion falls below a health threshold, Urgot judges them weak and can execute them.",
					"tooltip": "Urgot fires a chem-drill, impaling the first enemy champion hit. Deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and slows for {{ e4 }} seconds by up to {{ e3 }}% based on the victim's missing health.<br /><br />If the victim falls below {{ e2 }}% health while impaled, Urgot may recast this ability, suppressing the victim and dragging them in for execution. Activates automatically if the target is below {{ e2 }}% at the end of the effect.<br /><br />When Urgot executes a victim, nearby enemies flee in terror for {{ e0 }} seconds.</span></rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						95,
						70
					],
					"cooldownBurn": "120/95/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							50,
							175,
							300
						],
						[
							25,
							25,
							25
						],
						[
							75,
							75,
							75
						],
						[
							4,
							4,
							4
						],
						[
							1,
							1,
							1
						],
						[
							1,
							1,
							1
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							25000,
							25000,
							25000
						],
						[
							600,
							600,
							600
						],
						[
							1.5,
							1.5,
							1.5
						]
					],
					"effectBurn": [
						null,
						"50/175/300",
						"25",
						"75",
						"4",
						"1",
						"1",
						"0.5",
						"25000",
						"600",
						"1.5"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.5,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1600,
						1600,
						1600
					],
					"rangeBurn": "1600",
					"image": {
						"full": "UrgotR.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Echoing Flames",
				"description": "Urgot's basic attacks and Purge periodically trigger blasts of flame from his legs, dealing physical damage.",
				"image": {
					"full": "Urgot_Passive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 384,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Urgot",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Urgot",
					"title": "UrgotARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3085",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Urgot",
					"title": "UrgotCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Urgot",
					"title": "UrgotFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Urgot",
					"title": "UrgotSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Urgot",
					"title": "UrgotSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3364",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Urgot",
					"title": "UrgotTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Varus": {
			"id": "Varus",
			"key": "110",
			"name": "Varus",
			"title": "the Arrow of Retribution",
			"image": {
				"full": "Varus.png",
				"sprite": "champion3.png",
				"group": "champion",
				"x": 432,
				"y": 96,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "110000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "110001",
					"num": 1,
					"name": "Blight Crystal Varus",
					"chromas": false
				},
				{
					"id": "110002",
					"num": 2,
					"name": "Arclight Varus",
					"chromas": false
				},
				{
					"id": "110003",
					"num": 3,
					"name": "Arctic Ops Varus",
					"chromas": false
				},
				{
					"id": "110004",
					"num": 4,
					"name": "Heartseeker Varus",
					"chromas": false
				},
				{
					"id": "110005",
					"num": 5,
					"name": "Varus Swiftbolt",
					"chromas": false
				},
				{
					"id": "110006",
					"num": 6,
					"name": "Dark Star Varus",
					"chromas": false
				}
			],
			"lore": "One of the ancient race of darkin, Varus was a deadly killer who loved to torment his foes, driving them almost to insanity before delivering the killing arrow. He was imprisoned at the end of the Darkin War, but escaped centuries later in the remade flesh of two Ionian hunters—they had unwittingly released him, cursed to bear the bow containing his bound essence. Varus now seeks out those who trapped him in order to enact his brutal vengeance, but the mortals' souls within him still resist every step of the way.",
			"blurb": "One of the ancient race of darkin, Varus was a deadly killer who loved to torment his foes, driving them almost to insanity before delivering the killing arrow. He was imprisoned at the end of the Darkin War, but escaped centuries later in the remade...",
			"allytips": [
				"An early point in Blighted Quiver helps harass enemy champions and get killing blows on minions.",
				"During short range fights it's sometimes best to fire Piercing Arrow quickly, rather than charging it to full power.",
				"Try to take advantage of Piercing Arrow's very long range to snipe at enemy champions before a fight or as they're trying to flee."
			],
			"enemytips": [
				"If you are affected by Blight, Varus' abilities will deal extra damage to you.",
				"When he gets a kill or assist, Varus temporarily gains Attack Speed and is much more dangerous.",
				"You'll get bound in place if a tendril from Varus' ultimate, Chain of Corruption, reaches you. You can cause the tendril to die however by running far enough away from it."
			],
			"tags": [
				"Marksman",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 3,
				"magic": 4,
				"difficulty": 2
			},
			"stats": {
				"hp": 537.76,
				"hpperlevel": 82,
				"mp": 360.48,
				"mpperlevel": 33,
				"movespeed": 330,
				"armor": 32,
				"armorperlevel": 3.4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 575,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 7.34,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 63,
				"attackdamageperlevel": 2.41,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3
			},
			"spells": [
				{
					"id": "VarusQ",
					"name": "Piercing Arrow",
					"description": "Varus readies and then fires a powerful shot that gains extra range and damage the longer he spends preparing to fire.",
					"tooltip": "<span class=\"colorFF9900\">First Cast:</span> Varus starts drawing back his next shot, gradually increasing its range and damage. While preparing to shoot Varus' Movement Speed is slowed by {{ e7 }}%. After {{ e5 }} seconds, Piercing Arrow fails but refunds {{ e4 }}% of its Mana cost.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Varus fires, dealing {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> to {{ e2 }}<span class=\"colorFF8C00\"> (+{{ a2 }})</span> physical damage, reduced by {{ e3 }}% per enemy hit (minimum {{ e9 }}%).<br /><br />Piercing Arrow's cooldown is reduced by {{ f1 }} seconds if the arrow detonates <span class=\"colorB829FF\">Blight</span> stacks from at least one enemy champion.",
					"leveltip": {
						"label": [
							"Max Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						18,
						16,
						14,
						12
					],
					"cooldownBurn": "20/18/16/14/12",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							10,
							47,
							84,
							120,
							157
						],
						[
							15,
							70,
							125,
							180,
							235
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							33,
							33,
							33,
							33,
							33
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/47/84/120/157",
						"15/70/125/180/235",
						"15",
						"50",
						"4",
						"4",
						"20",
						"0",
						"33",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 1.5,
							"key": "a2"
						},
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "VarusQ.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VarusW",
					"name": "Blighted Quiver",
					"description": "Varus' basic attacks deal bonus magic damage and apply Blight. Varus' other abilities detonate Blight, dealing magic damage based on the target's maximum Health.",
					"tooltip": "Varus' basic attacks deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage and apply <span class=\"colorB829FF\">Blight</span> for {{ e3 }} seconds (stacks {{ e4 }} times).<br /><br />Varus' other abilities detonate <span class=\"colorB829FF\">Blight</span>, dealing magic damage equal to {{ e2 }}% <span class=\"color99FF99\">(+{{ a2 }}%)</span> of the target's maximum Health per stack. Max damage vs. monsters: {{ e5 }} per stack.",
					"leveltip": {
						"label": [
							"Initial Damage",
							"Max Health Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							10,
							14,
							18,
							22,
							26
						],
						[
							2,
							2.75,
							3.5,
							4.25,
							5
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							120,
							120,
							120,
							120,
							120
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/14/18/22/26",
						"2/2.75/3.5/4.25/5",
						"6",
						"3",
						"120",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.02,
							"key": "a2"
						}
					],
					"costType": "Passive",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "VarusW.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "Passive"
				},
				{
					"id": "VarusE",
					"name": "Hail of Arrows",
					"description": "Varus fires a hail of arrows that deal physical damage and desecrate the ground. Desecrated ground slows enemies' Movement Speed and reduces their self healing and regeneration. ",
					"tooltip": "Varus fires a hail of arrows that deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and desecrates the ground for {{ e3 }} seconds.<br /><br />Desecrated Ground slows enemy Movement Speed by {{ e2 }}% and reduces healing effects by {{ e4 }}%.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						16,
						14,
						12,
						10
					],
					"cooldownBurn": "18/16/14/12/10",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							25,
							30,
							35,
							40,
							45
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"25/30/35/40/45",
						"4",
						"40",
						"300",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						925,
						925,
						925,
						925,
						925
					],
					"rangeBurn": "925",
					"image": {
						"full": "VarusE.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VarusR",
					"name": "Chain of Corruption",
					"description": "Varus flings out a damaging tendril of corruption that immobilizes the first enemy champion hit and then spreads towards nearby uninfected champions, immobilizing them too on contact. ",
					"tooltip": "Varus flings out a tendril of corruption that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and immobilizes the first enemy champion hit for {{ e2 }} seconds.<br /><br />The corruption then spreads towards nearby uninfected enemy champions. If it reaches them, they take the same damage and are also immobilized. Immobilized units gain {{ e4 }} <span class=\"colorB829FF\">Blight</span> stacks over the duration.",
					"leveltip": {
						"label": [
							"Damage ",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						90,
						70
					],
					"cooldownBurn": "110/90/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							175,
							250
						],
						[
							2,
							2,
							2
						],
						[
							650,
							650,
							650
						],
						[
							3,
							3,
							3
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							600,
							600,
							600
						],
						[
							1.75,
							1.75,
							1.75
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/175/250",
						"2",
						"650",
						"3",
						"0.5",
						"600",
						"1.75",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1200,
						1200,
						1200
					],
					"rangeBurn": "1200",
					"image": {
						"full": "VarusR.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Living Vengeance",
				"description": "On kill or assist, Varus temporarily gains Attack Speed. This bonus is larger if the enemy is a champion.",
				"image": {
					"full": "VarusPassive.png",
					"sprite": "passive3.png",
					"group": "passive",
					"x": 432,
					"y": 96,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Varus",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3008",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Varus",
					"title": "VarusTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Vayne": {
			"id": "Vayne",
			"key": "67",
			"name": "Vayne",
			"title": "the Night Hunter",
			"image": {
				"full": "Vayne.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 0,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "67000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "67001",
					"num": 1,
					"name": "Vindicator Vayne",
					"chromas": false
				},
				{
					"id": "67002",
					"num": 2,
					"name": "Aristocrat Vayne",
					"chromas": false
				},
				{
					"id": "67003",
					"num": 3,
					"name": "Dragonslayer Vayne",
					"chromas": true
				},
				{
					"id": "67004",
					"num": 4,
					"name": "Heartseeker Vayne",
					"chromas": false
				},
				{
					"id": "67005",
					"num": 5,
					"name": "SKT T1 Vayne",
					"chromas": false
				},
				{
					"id": "67006",
					"num": 6,
					"name": "Arclight Vayne",
					"chromas": false
				},
				{
					"id": "67010",
					"num": 10,
					"name": "Soulstealer Vayne",
					"chromas": false
				},
				{
					"id": "67011",
					"num": 11,
					"name": "PROJECT: Vayne",
					"chromas": false
				}
			],
			"lore": "Shauna Vayne is a deadly, remorseless Demacian monster hunter, who has dedicated her life to finding and destroying the demon that murdered her family. Armed with a wrist-mounted crossbow and a heart full of vengeance, she is only truly happy when slaying practitioners or creations of the dark arts, striking from the shadows with a flurry of silver bolts.",
			"blurb": "Shauna Vayne is a deadly, remorseless Demacian monster hunter, who has dedicated her life to finding and destroying the demon that murdered her family. Armed with a wrist-mounted crossbow and a heart full of vengeance, she is only truly happy when...",
			"allytips": [
				"Tumble has many uses, but it cannot pass over walls.",
				"Condemn can be used to both pin targets to walls to ensure a kill, or to escape a pursuer.",
				"Don't go in first to a large teamfight. Wait for your teammates to initiate."
			],
			"enemytips": [
				"Vayne is fragile - turn the pressure up on her and she will be forced to play cautiously.",
				"Deny Vayne the opportunity to pin you against walls."
			],
			"tags": [
				"Marksman",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 10,
				"defense": 1,
				"magic": 1,
				"difficulty": 8
			},
			"stats": {
				"hp": 498.44,
				"hpperlevel": 83,
				"mp": 231.8,
				"mpperlevel": 35,
				"movespeed": 330,
				"armor": 28,
				"armorperlevel": 3.4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6.972,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 1.66,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 3.3
			},
			"spells": [
				{
					"id": "VayneTumble",
					"name": "Tumble",
					"description": "Vayne tumbles, maneuvering to carefully place her next shot. Her next attack critically strikes.",
					"tooltip": "Vayne rolls a short distance, and deals <scaleAD>{{ f1 }}</scaleAD> bonus physical damage on her next basic attack within {{ e3 }} seconds.<br /><br /><rules>Tumble's bonus damage is equal to {{ e1 }}% of Vayne's total attack damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5,
						4,
						3,
						2
					],
					"cooldownBurn": "6/5/4/3/2",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							50,
							55,
							60,
							65,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/55/60/65/70",
						"0",
						"7",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": [
								0.3,
								0.35,
								0.4,
								0.45,
								0.5
							],
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "VayneTumble.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VayneSilveredBolts",
					"name": "Silver Bolts",
					"description": "Vayne tips her bolts with a rare metal, toxic to evil things. The third consecutive attack or ability against the same target deals a percentage of the target's maximum Health as bonus true damage. (Max: 200 damage vs. Monsters)",
					"tooltip": "Every third consecutive attack or ability against an enemy deals an additional {{ e1 }}% of the enemy's maximum health as true damage (no less than {{ e2 }}).<br /><br /><rules>Silver Bolts deals no more than {{ e3 }} damage against monsters.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Minimum Damage"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }} -> {{ e2NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							4,
							6,
							8,
							10,
							12
						],
						[
							50,
							65,
							80,
							95,
							110
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							3.5,
							3.5,
							3.5,
							3.5,
							3.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/6/8/10/12",
						"50/65/80/95/110",
						"200",
						"3.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "Passive",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "VayneSilveredBolts.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "Passive"
				},
				{
					"id": "VayneCondemn",
					"name": "Condemn",
					"description": "Vayne draws a heavy crossbow from her back, and fires a huge bolt at her target, knocking them back and dealing damage. If they collide with terrain, they are impaled, dealing bonus damage and stunning them.",
					"tooltip": "Fires a bolt that knocks back a target and deals {{ e1 }} <scaleAD>(+{{ a1 }})</scaleAD> physical damage.<br /><br />If the target collides with terrain, the damage is increased to <scaleAD>{{ f1 }}</scaleAD> and the target is stunned for {{ e3 }} seconds.<br /><br /><rules>Condemn's damage is increased by {{ e2 }}% if the target collides with terrain.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						18,
						16,
						14,
						12
					],
					"cooldownBurn": "20/18/16/14/12",
					"cost": [
						90,
						90,
						90,
						90,
						90
					],
					"costBurn": "90",
					"effect": [
						null,
						[
							50,
							85,
							120,
							155,
							190
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							475,
							475,
							475,
							475,
							475
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/85/120/155/190",
						"100",
						"1.5",
						"475",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.5,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "VayneCondemn.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VayneInquisition",
					"name": "Final Hour",
					"description": "Readying herself for an epic confrontation, Vayne gains increased Attack Damage, Invisibility during Tumble, and triple the bonus Movement Speed from Night Hunter.",
					"tooltip": "Vayne gains {{ e1 }} bonus attack damage and improvements to Night Hunter and Tumble for {{ e2 }} seconds. The duration of Final Hour is extended by {{ e5 }} seconds whenever a champion damaged by Vayne dies within {{ e6 }} seconds.<br /><br /><span class=\"colorF0F0F0\">Night Hunter</span>: Vayne instead gains {{ e4 }} movement speed.<br /><span class=\"colorF0F0F0\">Tumble</span>: Vayne will also gain <span class=\"color91d7ee\">Invisibility</span> for {{ e3 }} second when she Tumbles.<br /><br /><rules><span class=\"color91d7ee\">Stealth - Invisible:</span> Vayne can only be revealed by nearby enemy Turrets or <span class=\"coloree91d7\">True Sight</span>.<br />Final Hour's duration can't be increased beyond its original maximum duration.</rules>",
					"leveltip": {
						"label": [
							"Bonus Attack Damage",
							"Duration",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						85,
						70
					],
					"cooldownBurn": "100/85/70",
					"cost": [
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							20,
							30,
							40
						],
						[
							8,
							10,
							12
						],
						[
							1,
							1,
							1
						],
						[
							90,
							90,
							90
						],
						[
							4,
							4,
							4
						],
						[
							3,
							3,
							3
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40",
						"8/10/12",
						"1",
						"90",
						"4",
						"3",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1,
						1,
						1
					],
					"rangeBurn": "1",
					"image": {
						"full": "VayneInquisition.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Night Hunter",
				"description": "Vayne ruthlessly hunts evil-doers, gaining 30 movement speed when moving toward nearby enemy champions.",
				"image": {
					"full": "Vayne_NightHunter.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 0,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Vayne",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "1053",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1042",
									"count": 1
								},
								{
									"id": "3006",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "1053",
									"count": 1
								},
								{
									"id": "1038",
									"count": 1
								},
								{
									"id": "3072",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3087",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								},
								{
									"id": "3031",
									"count": 1
								},
								{
									"id": "3102",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3144",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VaynePRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vayne",
					"title": "VayneTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Veigar": {
			"id": "Veigar",
			"key": "45",
			"name": "Veigar",
			"title": "the Tiny Master of Evil",
			"image": {
				"full": "Veigar.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 48,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "45000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "45001",
					"num": 1,
					"name": "White Mage Veigar",
					"chromas": false
				},
				{
					"id": "45002",
					"num": 2,
					"name": "Curling Veigar",
					"chromas": false
				},
				{
					"id": "45003",
					"num": 3,
					"name": "Veigar Greybeard",
					"chromas": false
				},
				{
					"id": "45004",
					"num": 4,
					"name": "Leprechaun Veigar",
					"chromas": false
				},
				{
					"id": "45005",
					"num": 5,
					"name": "Baron Von Veigar",
					"chromas": false
				},
				{
					"id": "45006",
					"num": 6,
					"name": "Superb Villain Veigar",
					"chromas": false
				},
				{
					"id": "45007",
					"num": 7,
					"name": "Bad Santa Veigar",
					"chromas": false
				},
				{
					"id": "45008",
					"num": 8,
					"name": "Final Boss Veigar",
					"chromas": false
				},
				{
					"id": "45009",
					"num": 9,
					"name": "Omega Squad Veigar",
					"chromas": true
				}
			],
			"lore": "An enthusiastic master of dark sorcery, Veigar has embraced powers that few mortals dare approach. As a free-spirited inhabitant of Bandle City, he longed to push beyond the limitations of yordle magic, and turned instead to arcane texts that had been hidden away for thousands of years. Now a stubborn creature with an endless fascination for the mysteries of the universe, Veigar is often underestimated by others—but even though he believes himself truly evil, he possesses an inner morality that leads some to question his deeper motivations.",
			"blurb": "An enthusiastic master of dark sorcery, Veigar has embraced powers that few mortals dare approach. As a free-spirited inhabitant of Bandle City, he longed to push beyond the limitations of yordle magic, and turned instead to arcane texts that had been...",
			"allytips": [
				"Use Event Horizon to increase your chances of landing Dark Matter.",
				"Veigar is extremely Mana and Cooldown Reduction dependent. Try buying items with these stats in order to increase the effectiveness of your passive and Baleful Strike.",
				"Veigar is very fragile. It is valuable to select at least one summoner spell that can be used defensively."
			],
			"enemytips": [
				"Dark Matter deals very high damage, but it can be avoided. Pay attention to the sound and visual indicator to be aware of when and where the spell will land.",
				"Event Horizon only stuns units on the edge. If you're inside the spell, you can still move and attack.",
				"Veigar's ultimate deals increased damage based on your missing health."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 2,
				"magic": 10,
				"difficulty": 7
			},
			"stats": {
				"hp": 505,
				"hpperlevel": 94,
				"mp": 392.4,
				"mpperlevel": 52,
				"movespeed": 340,
				"armor": 22.55,
				"armorperlevel": 3.75,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 50.71,
				"attackdamageperlevel": 2.625,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.24
			},
			"spells": [
				{
					"id": "VeigarBalefulStrike",
					"name": "Baleful Strike",
					"description": "Veigar unleashes a bolt of dark energy that deals magic damage to the first two enemies hit. Units killed by this bolt grant Veigar some ability power permanently.",
					"tooltip": "Unleashes a bolt of dark energy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to the first two enemies hit.<br /><br />Killing a unit with this also grants Veigar a stack of <span class=\"colorFFF673\">Phenomenal Evil</span>. Large minions and large monsters grant two.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"1",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "VeigarBalefulStrike.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VeigarDarkMatter",
					"name": "Dark Matter",
					"description": "Veigar calls a great mass of dark matter to fall from the sky to the target location, dealing magic damage when it lands. Stacks of Phenomenal Evil reduce Dark Matter's cooldown.",
					"tooltip": "After 1.2 seconds, dark matter falls from the sky to the target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />Every 50 stacks of <span class=\"colorFFF673\">Phenomenal Evil</span> reduce Dark Matter's cooldown by 10% (currently <span class=\"colorFFF673\">{{ f2.0*100 }}%</span>).",
					"leveltip": {
						"label": [
							"Damage",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							1.2,
							1.2,
							1.2,
							1.2,
							1.2
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.02,
							0.02,
							0.02,
							0.02,
							0.02
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/150/200/250/300",
						"1.2",
						"8",
						"0",
						"0.02",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "VeigarDarkMatter.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VeigarEventHorizon",
					"name": "Event Horizon",
					"description": "After a brief delay Veigar twists the edges of space around the target location for 3 seconds, stunning enemies who pass through the perimeter.",
					"tooltip": "After a {{ e2 }} second delay, Veigar twists the edges of space around the target location for 3 seconds, forming a pentagon of walls. Enemies who attempt to pass through the perimeter are stopped and stunned for {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Stun Duration",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						17,
						16,
						15,
						14
					],
					"cooldownBurn": "18/17/16/15/14",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							1.5,
							1.75,
							2,
							2.25,
							2.5
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1.5/1.75/2/2.25/2.5",
						"0.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						725,
						725,
						725,
						725,
						725
					],
					"rangeBurn": "725",
					"image": {
						"full": "VeigarEventHorizon.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VeigarR",
					"name": "Primordial Burst",
					"description": "Blasts target enemy champion, dealing a large amount of magic damage, increasing based on the target's missing health.",
					"tooltip": "Blasts the target with primal magic to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> to {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage, increasing based on the <span class=\"colorCC3300\">target's missing health</span>.<br /><br />Damage is maximized against enemies below 33% health.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							175,
							250,
							325
						],
						[
							350,
							500,
							650
						],
						[
							1,
							1,
							1
						],
						[
							2,
							2,
							2
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"175/250/325",
						"350/500/650",
						"1",
						"2",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 1.5,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "VeigarR.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Phenomenal Evil Power",
				"description": "Veigar is the greatest Evil to ever strike at the hearts of Runeterra - and he's only getting bigger! Striking an enemy Champion with a spell or scoring a takedown grants Veigar permanently increased Ability Power.",
				"image": {
					"full": "Veigar_Entropy.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 48,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Veigar",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Veigar",
					"title": "VeigarTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Velkoz": {
			"id": "Velkoz",
			"key": "161",
			"name": "Vel'Koz",
			"title": "the Eye of the Void",
			"image": {
				"full": "Velkoz.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 96,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "161000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "161001",
					"num": 1,
					"name": "Battlecast Vel'Koz",
					"chromas": false
				},
				{
					"id": "161002",
					"num": 2,
					"name": "Arclight Vel'Koz",
					"chromas": false
				},
				{
					"id": "161003",
					"num": 3,
					"name": "Definitely Not Vel'Koz",
					"chromas": false
				}
			],
			"lore": "It is unclear if Vel'Koz was the first Void-spawn to emerge on Runeterra, but there has certainly never been another to match his level of cruel, calculating sentience. While his kin devour or defile everything around them, he seeks instead to scrutinize and study the physical realm—and the strange, warlike beings that dwell there—for any weakness the Void might exploit. But Vel'Koz is far from a passive observer, striking back at threats with deadly plasma, or by disrupting the very fabric of the world itself.",
			"blurb": "It is unclear if Vel'Koz was the first Void-spawn to emerge on Runeterra, but there has certainly never been another to match his level of cruel, calculating sentience. While his kin devour or defile everything around them, he seeks instead to...",
			"allytips": [
				"When laning, use Void Rift to kill minions while building stacks of Organic Deconstruction on your opponent. You can then follow up with your other abilities.",
				"Shooting Plasma Fission diagonally and splitting at maximum range allows you to hit opponents that are out of the range of the initial missile, but is more challenging to pull off.",
				"Be very careful about when to use Life Form Disintegration Ray. Many champions have abilities that can interrupt the spell."
			],
			"enemytips": [
				"Vel'Koz is very dangerous if left alone in a fight. Try to focus him down early.",
				"Vel'Koz has fairly low mobility and is vulnerable to ganks.",
				"Life Form Disintegration Ray can be interrupted by stuns, silences and knockups."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 2,
				"magic": 10,
				"difficulty": 8
			},
			"stats": {
				"hp": 520,
				"hpperlevel": 88,
				"mp": 375.6,
				"mpperlevel": 42,
				"movespeed": 340,
				"armor": 21.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 54.9379,
				"attackdamageperlevel": 3.1416,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "VelkozQ",
					"name": "Plasma Fission",
					"description": "Vel'Koz shoots a bolt of plasma that splits in two on reactivation or upon hitting an enemy. The bolt slows and damages on hit.",
					"tooltip": "Vel'Koz shoots a plasma bolt that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and applies a slow of {{ e5 }}% that decays over {{ e4 }} second(s).<br /><br />Upon reactivation or upon hitting an enemy, the bolt splits at a 90 degree angle.<br /><br />Killing a unit with this refunds {{ e2 }}% of the <span class=\"color44DDFF\">Mana Cost</span>.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						7,
						7,
						7,
						7
					],
					"cooldownBurn": "7",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							1,
							1.4,
							1.8,
							2.2,
							2.6
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"50",
						"0.25",
						"1/1.4/1.8/2.2/2.6",
						"70",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1050,
						1050,
						1050,
						1050,
						1050
					],
					"rangeBurn": "1050",
					"image": {
						"full": "VelkozQ.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VelkozW",
					"name": "Void Rift",
					"description": "Vel'Koz opens a rift to the void that deals an initial burst of damage, then explodes for a second burst of damage after a delay.",
					"tooltip": "Vel'Koz opens a rift to the void that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage. After a delay, it deals an additional {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> Magic Damage.<br /><br />Void Rift has a 2 second cooldown between casts.",
					"leveltip": {
						"label": [
							"Initial Damage",
							"Secondary Damage",
							"Ammo Recharge Time",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1.5,
						1.5,
						1.5,
						1.5,
						1.5
					],
					"cooldownBurn": "1.5",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							30,
							50,
							70,
							90,
							110
						],
						[
							45,
							75,
							105,
							135,
							165
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							88,
							88,
							88,
							88,
							88
						],
						[
							500,
							500,
							500,
							500,
							500
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/50/70/90/110",
						"45/75/105/135/165",
						"100",
						"0",
						"0.25",
						"0.5",
						"88",
						"500",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.25,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						1050,
						1050,
						1050,
						1050,
						1050
					],
					"rangeBurn": "1050",
					"image": {
						"full": "VelkozW.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VelkozE",
					"name": "Tectonic Disruption",
					"description": "Vel'Koz causes an area to explode, knocking up enemies, and knocking close enemies slightly away.",
					"tooltip": "Vel'Koz disrupts a nearby area which, after a delay, deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Magic Damage and knocks up enemies hit for {{ e2 }} seconds.<br /><br />Any enemies hit that are close to Vel'Koz will be pushed slightly in the direction the ability was cast.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15,
						14,
						13,
						12
					],
					"cooldownBurn": "16/15/14/13/12",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							70,
							100,
							130,
							160,
							190
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/100/130/160/190",
						"0.75",
						"0",
						"225",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						810,
						810,
						810,
						810,
						810
					],
					"rangeBurn": "810",
					"image": {
						"full": "VelkozE.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VelkozR",
					"name": "Life Form Disintegration Ray",
					"description": "Vel'Koz unleashes a channelled beam that follows the cursor for 2.5 seconds that deals magic damage. Organic Deconstruction Researches enemy champions causing them to take true damage instead.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Deconstructing enemy Champions <span class=\"colorFFFFFF\">Researches</span> them for {{ e2 }} seconds. Basic attacks and all abilities refresh Research.<br /><br /><span class=\"colorFF9900\">Active: </span>Vel'Koz channels a ray of energy that follows the cursor for 2.5 seconds, dealing Magic Damage up to a total of {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> and slowing units hit by {{ e3 }}%.<br /><br />Enemies that stay in the beam will periodically gain <span class=\"colorFFFFFF\">Organic Deconstruction</span> stacks. Deals True Damage instead of Magic against <span class=\"colorFFFFFF\">Researched</span> units.",
					"leveltip": {
						"label": [
							"Total Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							450,
							625,
							800
						],
						[
							7,
							7,
							7
						],
						[
							20,
							20,
							20
						],
						[
							40,
							40,
							40
						],
						[
							175,
							175,
							175
						],
						[
							7,
							7,
							7
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"450/625/800",
						"7",
						"20",
						"40",
						"175",
						"7",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1.25,
							"key": "a1"
						}
					],
					"costType": "Mana",
					"maxammo": "-1",
					"range": [
						1575,
						1575,
						1575
					],
					"rangeBurn": "1575",
					"image": {
						"full": "VelkozR.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "Mana"
				}
			],
			"passive": {
				"name": "Organic Deconstruction",
				"description": "Vel'Koz's abilities apply <font color='#FFFFFF'>Organic Deconstruction</font> to enemies on hit. If 3 stacks are accumulated, the enemy will take a burst of true damage.",
				"image": {
					"full": "Velkoz_Passive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 96,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Velkoz",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3028",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Velkoz",
					"title": "VelkozTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Vi": {
			"id": "Vi",
			"key": "254",
			"name": "Vi",
			"title": "the Piltover Enforcer",
			"image": {
				"full": "Vi.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 144,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "254000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "254001",
					"num": 1,
					"name": "Neon Strike Vi",
					"chromas": false
				},
				{
					"id": "254002",
					"num": 2,
					"name": "Officer Vi",
					"chromas": true
				},
				{
					"id": "254003",
					"num": 3,
					"name": "Debonair Vi",
					"chromas": false
				},
				{
					"id": "254004",
					"num": 4,
					"name": "Demon Vi",
					"chromas": false
				},
				{
					"id": "254005",
					"num": 5,
					"name": "Warring Kingdoms Vi",
					"chromas": false
				},
				{
					"id": "254011",
					"num": 11,
					"name": "PROJECT: Vi",
					"chromas": false
				}
			],
			"lore": "Once a criminal from the mean streets of Zaun, Vi is a hotheaded, impulsive, and fearsome woman with only a very loose respect for authority figures. Growing up all but alone, Vi developed finely honed survival instincts as well as a wickedly abrasive sense of humor. Now working with the Wardens of Piltover to keep the peace, she wields mighty hextech gauntlets that can punch through walls and suspects with equal ease.",
			"blurb": "Once a criminal from the mean streets of Zaun, Vi is a hotheaded, impulsive, and fearsome woman with only a very loose respect for authority figures. Growing up all but alone, Vi developed finely honed survival instincts as well as a wickedly abrasive...",
			"allytips": [
				"A fully charged Vault Breaker will deal double damage. It's great for catching and finishing off fleeing enemies.",
				"Excessive Force does full damage to anyone caught in the shockwave. Use it on minions in lane to hit enemies hiding behind them.",
				"Assault and Battery is a powerful initiation tool, just remember not to get too far ahead of the rest of your team."
			],
			"enemytips": [
				"A fully charged Vault breaker deals double damage. If you see Vi start to charge you should back off or try to dodge it.",
				"Vi will shred your Armor and gain Attack Speed if she manages to hit you three times in a row. Try not to engage in extended brawls with her.",
				"Vi cannot be stopped while using her ult. Remember to save your displacement effects until after she's done charging."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 5,
				"magic": 3,
				"difficulty": 4
			},
			"stats": {
				"hp": 582.8,
				"hpperlevel": 85,
				"mp": 295.6,
				"mpperlevel": 45,
				"movespeed": 340,
				"armor": 35,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 9,
				"hpregenperlevel": 0.9,
				"mpregen": 8.092,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 3.5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "ViQ",
					"name": "Vault Breaker",
					"description": "Vi charges her gauntlets and unleashes a vault shattering punch, carrying her forward. Enemies she hits are knocked back and receive a stack of Denting Blows.",
					"tooltip": "Charges a powerful punch that carries Vi forward.<br /><br /><span class=\"colorFF9900\">First Cast:</span> Slows Movement Speed by {{ e4 }}% while increasing damage and dash range over 1.25 seconds.<br /><br /><span class=\"colorFF9900\">Second Cast:</span> Dashes forward dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> to {{ f2 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> physical damage and applying Denting Blows to all enemies hit (deals {{ e3 }}% damage to minions and monsters). Stops upon colliding with an enemy champion, knocking it back.",
					"leveltip": {
						"label": [
							"Min Damage",
							"Max Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						14,
						12,
						10,
						8
					],
					"cooldownBurn": "16/14/12/10/8",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							110,
							160,
							210,
							260,
							310
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							75,
							75,
							75,
							75,
							75
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"110/160/210/260/310",
						"2",
						"75",
						"15",
						"6",
						"5",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 1.4,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						250,
						250,
						250,
						250,
						250
					],
					"rangeBurn": "250",
					"image": {
						"full": "ViQ.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ViW",
					"name": "Denting Blows",
					"description": "Vi's punches break her opponent's Armor, dealing bonus damage and granting her Attack Speed.",
					"tooltip": "Every 3rd attack on the same target deals an additional {{ e1 }}% <span class=\"colorFF8C00\">(+{{ f1 }}%)</span> of the target's maximum Health as physical damage, reduces its Armor by {{ e3 }}% and grants Vi {{ e2 }}% Attack Speed for {{ e4 }} seconds (max {{ e5 }} damage vs. monsters).",
					"leveltip": {
						"label": [
							"Max Health Damage",
							"Attack Speed"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							4,
							5.5,
							7,
							8.5,
							10
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.0286,
							0.0286,
							0.0286,
							0.0286,
							0.0286
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/5.5/7/8.5/10",
						"30/35/40/45/50",
						"20",
						"4",
						"300",
						"4",
						"0.03",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "@special.viw",
							"coeff": 35,
							"key": "f1"
						}
					],
					"costType": "Passive",
					"maxammo": "-1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "ViW.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "Passive"
				},
				{
					"id": "ViE",
					"name": "Excessive Force",
					"description": "Vi's next attack blasts through her target, dealing damage to enemies behind it.",
					"tooltip": "Causes next basic attack to deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ f3 }})</span> <span class=\"color99FF99\">(+{{ a1 }})</span> physical damage to the target and enemies behind it.<br /><br /></span>Vi charges a new punch every <span class=\"colorFFFFFF\">{{ f1 }}</span> seconds and can hold 2 charges at once.",
					"leveltip": {
						"label": [
							"Damage",
							"Charge Time",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f1 }} -> {{ f2 }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1,
						1,
						1,
						1,
						1
					],
					"cooldownBurn": "1",
					"cost": [
						40,
						45,
						50,
						55,
						60
					],
					"costBurn": "40/45/50/55/60",
					"effect": [
						null,
						[
							10,
							30,
							50,
							70,
							90
						],
						[
							1.15,
							1.15,
							1.15,
							1.15,
							1.15
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10/30/50/70/90",
						"1.15",
						"50",
						"1.5",
						"6",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.15,
							"key": "f3"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						},
						{
							"link": "@text",
							"coeff": [
								14,
								12.5,
								11,
								9.5,
								8
							],
							"key": "f1"
						},
						{
							"link": "@text",
							"coeff": [
								14,
								12.5,
								11,
								9.5,
								8
							],
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "ViE.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ViR",
					"name": "Assault and Battery",
					"description": "Vi runs down an enemy, knocking aside anyone in the way. When she reaches her target she knocks it into the air, jumps after it, and slams it back into the ground.",
					"tooltip": "Targets an enemy champion and chases it down, knocking it up for 1.25 seconds, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage.<br /><br />While charging, Vi cannot be stopped and has <span class=\"coloree91d7\">True Sight</span> of the target. Any enemies in the way are knocked aside and dealt 75% of the damage.",
					"leveltip": {
						"label": [
							"Total Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							" {{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						100,
						70
					],
					"cooldownBurn": "130/100/70",
					"cost": [
						100,
						125,
						150
					],
					"costBurn": "100/125/150",
					"effect": [
						null,
						[
							150,
							300,
							450
						],
						[
							0.75,
							0.75,
							0.75
						],
						[
							1.25,
							1.25,
							1.25
						],
						[
							4,
							4,
							4
						],
						[
							1,
							1.5,
							2
						],
						[
							800,
							800,
							800
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/300/450",
						"0.75",
						"1.25",
						"4",
						"1/1.5/2",
						"800",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "ViR.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Blast Shield",
				"description": "Vi charges a shield over time. The shield can be activated by hitting an enemy with an ability.",
				"image": {
					"full": "ViPassive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 144,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Vi",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1055",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1055",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1036",
									"count": 1
								},
								{
									"id": "3044",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "1029",
									"count": 1
								},
								{
									"id": "3047",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3044",
									"count": 1
								},
								{
									"id": "3057",
									"count": 1
								},
								{
									"id": "3086",
									"count": 1
								},
								{
									"id": "3078",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3071",
									"count": 1
								},
								{
									"id": "3110",
									"count": 1
								},
								{
									"id": "3105",
									"count": 1
								},
								{
									"id": "3022",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vi",
					"title": "ViTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1400",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3252",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Viktor": {
			"id": "Viktor",
			"key": "112",
			"name": "Viktor",
			"title": "the Machine Herald",
			"image": {
				"full": "Viktor.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 192,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "112000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "112001",
					"num": 1,
					"name": "Full Machine Viktor",
					"chromas": false
				},
				{
					"id": "112002",
					"num": 2,
					"name": "Prototype Viktor",
					"chromas": false
				},
				{
					"id": "112003",
					"num": 3,
					"name": "Creator Viktor",
					"chromas": false
				},
				{
					"id": "112004",
					"num": 4,
					"name": "Death Sworn Viktor",
					"chromas": false
				}
			],
			"lore": "The herald of a new age of technology, Viktor has devoted his life to the advancement of humankind. An idealist who seeks to lift the people of Zaun to a new level of understanding, he believes that only by embracing a glorious evolution of technology can humanity's full potential be realized. With a body augmented by steel and science, Viktor is zealous in his pursuit of this bright future.",
			"blurb": "The herald of a new age of technology, Viktor has devoted his life to the advancement of humankind. An idealist who seeks to lift the people of Zaun to a new level of understanding, he believes that only by embracing a glorious evolution of technology...",
			"allytips": [
				"Death Ray is a powerful poke and a strong area of denial tool. Use it in combination with Gravity Field to control your enemy's position.",
				"Make sure you choose the right augment at the right time."
			],
			"enemytips": [
				"Be careful about how close you let Viktor get to you. Viktor's control of the battlefield increases with his proximity to his opponent.",
				"Be aware of how many augments Viktor has upgraded by looking at the color of the light on his staff (purple, yellow, blue, red)."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 4,
				"magic": 10,
				"difficulty": 9
			},
			"stats": {
				"hp": 528.04,
				"hpperlevel": 90,
				"mp": 324,
				"mpperlevel": 50,
				"movespeed": 335,
				"armor": 22.72,
				"armorperlevel": 4,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 8,
				"hpregenperlevel": 0.65,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 52.04,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2.11
			},
			"spells": [
				{
					"id": "ViktorPowerTransfer",
					"name": "Siphon Power",
					"description": "Viktor blasts an enemy unit dealing magic damage, gaining a shield and empowering his next basic attack.<br><br>Augment: Siphon Power's shield is increased by 60% and Viktor gains bonus Movement Speed after casting.",
					"tooltip": "Viktor blasts an enemy unit, dealing {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage while granting Viktor a shield that absorbs up to <span class=\"color44DDFF\">{{ f1 }}</span> <span class=\"color99FF99\">(+{{ f2 }})</span> damage over the next {{ e2 }} seconds.<br /><br />Viktor's next basic attack deals {{ e5 }}<span class=\"color99FF99\"> (+{{ a2 }})</span> bonus magic damage.<br /><br /><span class=\"colorFFCC00\">Augment - Turbocharge:</span> Siphon Power's shield is increased by 60% and Viktor gains {{ e3 }}% Movement Speed for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage (missile)",
							"Damage (attack)",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8,
						7,
						6,
						5,
						4
					],
					"cooldownBurn": "8/7/6/5/4",
					"cost": [
						45,
						50,
						55,
						60,
						65
					],
					"costBurn": "45/50/55/60/65",
					"effect": [
						null,
						[
							60,
							80,
							100,
							120,
							140
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							20,
							40,
							60,
							80,
							100
						],
						[
							0.08,
							0.08,
							0.08,
							0.08,
							0.08
						],
						[
							0.15,
							0.15,
							0.15,
							0.15,
							0.15
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/80/100/120/140",
						"2.5",
						"30",
						"0",
						"20/40/60/80/100",
						"0.08",
						"0.15",
						"0.6",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "ViktorPowerTransfer.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ViktorGravitonField",
					"name": "Gravity Field",
					"description": "Viktor conjures a heavy gravitational field that slows enemies in its radius. Enemies who stay within the device for too long are stunned.<br><br>Augment: Enemies stunned by Gravity Field are dragged to the center.",
					"tooltip": "Viktor deploys a gravitational imprisonment device for {{ e3 }} seconds, slowing enemy units by {{ e1 }}% and adding a stack every {{ e4 }} seconds. At {{ e5 }} stacks the target is stunned for {{ e2 }} seconds.<br /><br /><span class=\"colorFFCC00\">Augment - Implosion:</span> Enemies stunned by Gravity Field are dragged to the center.",
					"leveltip": {
						"label": [
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						17,
						16,
						15,
						14,
						13
					],
					"cooldownBurn": "17/16/15/14/13",
					"cost": [
						65,
						65,
						65,
						65,
						65
					],
					"costBurn": "65",
					"effect": [
						null,
						[
							28,
							32,
							36,
							40,
							44
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"28/32/36/40/44",
						"1.5",
						"4",
						"0.5",
						"3",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "ViktorGravitonField.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ViktorDeathRay",
					"name": "Death Ray",
					"description": "Viktor uses his robotic arm to fire a chaos beam that cuts across the field in a line, dealing damage to all enemies in its path.<br><br>Augment: An explosion follows the Death Ray's wake, dealing magic damage.",
					"tooltip": "Viktor uses his robotic arm to fire a chaos beam that cuts across the field in a line, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to every enemy in its path.<br /><br /><span class=\"colorFFCC00\">Augment - Aftershock:</span> An explosion follows the Death Ray's wake, dealing {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Damage (Death Ray)",
							"Damage (Aftershock)",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							70,
							110,
							150,
							190,
							230
						],
						[
							20,
							60,
							100,
							140,
							180
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/110/150/190/230",
						"20/60/100/140/180",
						"1",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						525,
						525,
						525,
						525,
						525
					],
					"rangeBurn": "525",
					"image": {
						"full": "ViktorDeathRay.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ViktorChaosStorm",
					"name": "Chaos Storm",
					"description": "Viktor conjures a singularity on the field which deals magic damage and interrupts enemy channels. The singularity then periodically does magic damage to all nearby enemies. Viktor can redirect the singularity.<br><br>Augment: The Chaos Storm moves faster.",
					"tooltip": "Viktor conjures a singularity at target location, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and interrupting enemy channels.<br /><br />Viktor can redirect the singularity for {{ e3 }} seconds, which will discharge {{ e2 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage every {{ e4 }} seconds to nearby enemies. The singularity will move slower as it attempts to move farther away from Viktor.<br /><br /><span class=\"colorFFCC00\">Augment - Velocity:</span> Chaos Storm moves {{ e0 }}% faster.",
					"leveltip": {
						"label": [
							"Damage (impact)",
							"Damage (discharge)",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						100,
						80
					],
					"cooldownBurn": "120/100/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							175,
							250
						],
						[
							150,
							250,
							350
						],
						[
							6.5,
							6.5,
							6.5
						],
						[
							2,
							2,
							2
						],
						[
							3,
							3,
							3
						],
						[
							400,
							400,
							400
						],
						[
							200,
							200,
							200
						],
						[
							300,
							300,
							300
						],
						[
							900,
							900,
							900
						],
						[
							0.2,
							0.2,
							0.2
						]
					],
					"effectBurn": [
						null,
						"100/175/250",
						"150/250/350",
						"6.5",
						"2",
						"3",
						"400",
						"200",
						"300",
						"900",
						"0.2"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "ViktorChaosStorm.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Glorious Evolution",
				"description": "Viktor starts with the Prototype Hex Core that can be upgraded three times in the store to augment his abilities.",
				"image": {
					"full": "Viktor_Passive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 192,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Viktor",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3196",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3196",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Viktor",
					"title": "ViktorTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3196",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3198",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Vladimir": {
			"id": "Vladimir",
			"key": "8",
			"name": "Vladimir",
			"title": "the Crimson Reaper",
			"image": {
				"full": "Vladimir.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 240,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "8000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "8001",
					"num": 1,
					"name": "Count Vladimir",
					"chromas": false
				},
				{
					"id": "8002",
					"num": 2,
					"name": "Marquis Vladimir",
					"chromas": false
				},
				{
					"id": "8003",
					"num": 3,
					"name": "Nosferatu Vladimir",
					"chromas": false
				},
				{
					"id": "8004",
					"num": 4,
					"name": "Vandal Vladimir",
					"chromas": false
				},
				{
					"id": "8005",
					"num": 5,
					"name": "Blood Lord Vladimir",
					"chromas": false
				},
				{
					"id": "8006",
					"num": 6,
					"name": "Soulstealer Vladimir",
					"chromas": false
				},
				{
					"id": "8007",
					"num": 7,
					"name": "Academy Vladimir",
					"chromas": false
				}
			],
			"lore": "A fiend with a thirst for mortal blood, Vladimir has influenced the affairs of Noxus since the empire's earliest days. In addition to unnaturally extending his life, his mastery of hemomancy allows him to control the minds and bodies of others as easily as his own. In the flamboyant salons of the Noxian aristocracy, this has enabled him to build a fanatical cult of personality around himself—while in the lowest back alleys, it allows him to bleed his enemies dry.",
			"blurb": "A fiend with a thirst for mortal blood, Vladimir has influenced the affairs of Noxus since the empire's earliest days. In addition to unnaturally extending his life, his mastery of hemomancy allows him to control the minds and bodies of others as easily...",
			"allytips": [
				"Transfusion instantly deals damage to the enemy before healing Vladimir, making it one of the best last hitting tools in the game.",
				"Cast Hemoplague where it will afflict the most units.",
				"Sanguine Pool pops incoming missiles, so it can be used to dodge disables."
			],
			"enemytips": [
				"Try to take Vladimir down before Hemoplague detonates, as it will heal him for each afflicted enemy Champion.",
				"Making Vladimir use Sanguine Pool at the start of a fight will maximize the Health cost of the ability to him.",
				"Items that counter Health stacking, such as Liandry's Torment and Blade of the Ruined King, are very effective against Vladimir."
			],
			"tags": [
				"Mage",
				"Tank"
			],
			"partype": "Crimson Rush",
			"info": {
				"attack": 2,
				"defense": 6,
				"magic": 8,
				"difficulty": 7
			},
			"stats": {
				"hp": 537,
				"hpperlevel": 96,
				"mp": 2,
				"mpperlevel": 0,
				"movespeed": 330,
				"armor": 23,
				"armorperlevel": 3.3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 450,
				"hpregen": 7,
				"hpregenperlevel": 0.6,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 55,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "VladimirQ",
					"name": "Transfusion",
					"description": "Vladimir steals life from the target enemy. When Vladimir's resource is full, Transfusion will benefit from massively increased damage and healing for a brief time.",
					"tooltip": "Vladimir drains the lifeforce of his target, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and healing himself for {{ e2 }}<span class=\"color99ff99\"> (+{{ a2 }})</span> health. After casting Transfusion twice, Vladimir gains <span class=\"colorFFB3B3\">Crimson Rush</span> the next time it becomes available to cast.<br /><br /><span class=\"colorFFB3B3\">Crimson Rush:</span> Vladimir is briefly hasted and for the next {{ e8 }} seconds Transfusion deals {{ e7 }}% increased damage and heals for an additional <span class=\"colorFFFFFF\">{{ f7 }}</span> plus {{ e5 }}% <span class=\"color99FF99\">(+{{ f6 }}%)</span> of his missing health (empowered heal has {{ e9 }}% effectiveness against minions). ",
					"leveltip": {
						"label": [
							"Damage",
							"Heal",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							80,
							100,
							120,
							140,
							160
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0.04,
							0.04,
							0.04,
							0.04,
							0.04
						],
						[
							85,
							85,
							85,
							85,
							85
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/100/120/140/160",
						"20/25/30/35/40",
						"0",
						"0",
						"5",
						"0.04",
						"85",
						"2.5",
						"35",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a2"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "VladimirQ.png",
						"sprite": "spell12.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "VladimirSanguinePool",
					"name": "Sanguine Pool",
					"description": "Vladimir sinks into a pool of blood, becoming untargetable for 2 seconds. Additionally, enemies on the pool are slowed and Vladimir siphons life from them.",
					"tooltip": "Vladimir sinks into a pool of blood for 2 seconds, gaining a brief haste and becoming untargetable while slowing enemies above him by {{ e3 }}%.<br /><br />Vladimir deals {{ e1 }} <span class=\"colorCC3300\">(+{{ f1 }}) [{{ e4 }}% of bonus Health]</span> magic damage over the duration and heals himself for {{ e5 }}% of that amount.<br /><br />Sanguine Pool can be cast while charging Tides of Blood.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						28,
						25,
						22,
						19,
						16
					],
					"cooldownBurn": "28/25/22/19/16",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							80,
							135,
							190,
							245,
							300
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/135/190/245/300",
						"20",
						"40",
						"10",
						"15",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonushealth",
							"coeff": 0.15,
							"key": "f1"
						}
					],
					"costType": "% of current Health",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "VladimirSanguinePool.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e2 }}% of current Health"
				},
				{
					"id": "VladimirE",
					"name": "Tides of Blood",
					"description": "Vladimir pays his own health to charge up a reservoir of blood which, when released, deals damage in the area around him but can be blocked by enemy units.",
					"tooltip": "<span class=\"colorFF9900\">First Cast: </span>Vladimir charges up a reservoir of blood, spending up to <span class=\"colorCC3300\">{{ e2 }}% of his max Health ({{ f3 }})</span> to increase this spell's damage. While at full charge, Vladimir is slowed.<br /><br /><span class=\"colorFF9900\">Second Cast: </span>Vladimir unleashes a nova of blood at surrounding enemies which deals between {{ e3 }}<span class=\"colorCC3300\"> (+{{ f2 }})</span><span class=\"color99FF99\"> (+{{ a1 }})</span> and {{ e0 }}<span class=\"colorCC3300\"> (+{{ f4 }})</span><span class=\"color99FF99\"> (+{{ a2 }})</span> magic damage and, at full charge, briefly slows by {{ e9 }}%. Targets hit block a portion of the nova.<br /><br />Tides of Blood will release automatically if held for more than {{ e7 }} seconds.",
					"leveltip": {
						"label": [
							"Min Damage",
							"Max Damage",
							"Slow Amount",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e0 }} -> {{ e0NL }}",
							"{{ e9 }}% -> {{ e9NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						11,
						9,
						7,
						5
					],
					"cooldownBurn": "13/11/9/7/5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							30,
							45,
							60,
							75,
							90
						],
						[
							6,
							6,
							6,
							6,
							6
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							60,
							90,
							120,
							150,
							180
						]
					],
					"effectBurn": [
						null,
						"0",
						"8",
						"30/45/60/75/90",
						"6",
						"150",
						"0",
						"1.5",
						"1",
						"40/45/50/55/60",
						"60/90/120/150/180"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 1,
							"key": "a2"
						}
					],
					"costType": "% of max Health",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "VladimirE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "Channeling Cost {{ e2 }}% of max Health"
				},
				{
					"id": "VladimirHemoplague",
					"name": "Hemoplague",
					"description": "Vladimir infects an area with a virulent plague. Affected enemies take increased damage for the duration. After a few seconds, Hemoplague deals magic damage to infected enemies and heals Vladimir for each enemy Champion hit.",
					"tooltip": "Vladimir infects enemies in a target area with a virulent plague, causing them to take {{ e2 }}% increased damage from all sources for {{ e4 }} seconds.<br /><br />After {{ e4 }} seconds, Vladimir deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all infected targets. If Hemoplague damages an enemy Champion, Vladimir heals himself for {{ f4 }} <span class=\"color99FF99\">(+{{ f3 }})</span>, plus {{ e5 }}% for each Champion beyond the first.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						150,
						135,
						120
					],
					"cooldownBurn": "150/135/120",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							10,
							10,
							10
						],
						[
							100,
							100,
							100
						],
						[
							4,
							4,
							4
						],
						[
							50,
							50,
							50
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"10",
						"100",
						"4",
						"50",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "VladimirHemoplague.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Crimson Pact",
				"description": "Every 40 points of bonus Health gives Vladimir 1 Ability Power and every 1 point of Ability Power gives Vladimir 1.4 bonus Health (does not stack with itself).",
				"image": {
					"full": "VladimirP.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 240,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Vladimir",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Vladimir",
					"title": "VladimirTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1052",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Volibear": {
			"id": "Volibear",
			"key": "106",
			"name": "Volibear",
			"title": "the Thunder's Roar",
			"image": {
				"full": "Volibear.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 288,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "106000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "106001",
					"num": 1,
					"name": "Thunder Lord Volibear",
					"chromas": false
				},
				{
					"id": "106002",
					"num": 2,
					"name": "Northern Storm Volibear",
					"chromas": false
				},
				{
					"id": "106003",
					"num": 3,
					"name": "Runeguard Volibear",
					"chromas": false
				},
				{
					"id": "106004",
					"num": 4,
					"name": "Captain Volibear",
					"chromas": false
				},
				{
					"id": "106005",
					"num": 5,
					"name": "El Rayo Volibear",
					"chromas": false
				}
			],
			"lore": "The thunderous demigod known as the Thousand-Pierced Bear is the battle-spirit of the Freljord. Thousands of years of constant and bitter wars, fought in the coldest winters, have hardened Volibear into a truly indomitable force, hurling bolts of lightning from the highest peaks—and when snowy tempests rage down, it can only mean that he is on the attack once more. Any who dare to face him may find themselves joining his fierce army of Ursine warriors… assuming they do not fall victim to his savage claws.",
			"blurb": "The thunderous demigod known as the Thousand-Pierced Bear is the battle-spirit of the Freljord. Thousands of years of constant and bitter wars, fought in the coldest winters, have hardened Volibear into a truly indomitable force, hurling bolts of...",
			"allytips": [
				"Lead the charge with Rolling Thunder and slow enemies with Majestic Roar.",
				"Volibear benefits a great deal from additional Health and cooldown reduction.",
				"You must attack three times in rapid succession before Frenzy can be activated - having the toughness to survive for a long time is one way to accomplish this goal."
			],
			"enemytips": [
				"Volibear can gain great Movement Speed while chasing targets, but he gains much less of a bonus when running away.",
				"Volibear regenerates a large amount of Health when he drops to critical Health.",
				"Slowing or stunning Volibear when he tries to charge will greatly reduce his effectiveness."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 7,
				"defense": 7,
				"magic": 4,
				"difficulty": 3
			},
			"stats": {
				"hp": 584.48,
				"hpperlevel": 86,
				"mp": 270.4,
				"mpperlevel": 30,
				"movespeed": 345,
				"armor": 35,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 8,
				"hpregenperlevel": 0.65,
				"mpregen": 8.092,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 68,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": -0.05,
				"attackspeedperlevel": 2.67
			},
			"spells": [
				{
					"id": "VolibearQ",
					"name": "Rolling Thunder",
					"description": "Volibear drops to all fours and runs faster. This bonus speed increases when chasing enemy champions. The first enemy he attacks is thrown backwards over Volibear.",
					"tooltip": "Volibear drops to all fours to hunt his enemies, gaining {{ e4 }}% Movement Speed for {{ e3 }} seconds. This bonus is enhanced to {{ e2 }}% Movement Speed while moving toward enemy champions.<br /><br />Volibear's next attack during this time deals an additional {{ e1 }} physical damage and flings the target behind him.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Cooldown",
							"Bonus Movement Speed Min",
							"Bonus Movement Speed Max"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							30,
							60,
							90,
							120,
							150
						],
						[
							30,
							37.5,
							45,
							52.5,
							60
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/60/90/120/150",
						"30/37.5/45/52.5/60",
						"4",
						"15/17.5/20/22.5/25",
						"400",
						"1",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "VolibearQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VolibearW",
					"name": "Frenzy",
					"description": "Volibear's repeated attacks grant him additional Attack Speed. Once Volibear has repeatedly attacked three times, he can perform a vicious bite on his target which deals increased damage based on the target's missing Health.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Volibear gains {{ e1 }}% Attack Speed with each attack. Stacks up to {{ e2 }} times.<br /><br /><span class=\"colorFF9900\">Active: </span>When Volibear has {{ e2 }} stacks of Frenzy, he can bite an enemy to deal {{ e3 }} <span class=\"colorCC3300\">(+{{ f1 }} [{{ e4 }}% of bonus Health])</span> physical damage, increased by {{ e5 }}% for each {{ e7 }}% Health the target is missing. If Volibear bites a minion or monster, Frenzy's cooldown is reduced by {{ e6 }}%.",
					"leveltip": {
						"label": [
							"Attack Speed Bonus",
							"Bite Damage"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e3 }} -> {{ e3NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						18,
						18,
						18,
						18,
						18
					],
					"cooldownBurn": "18",
					"cost": [
						35,
						35,
						35,
						35,
						35
					],
					"costBurn": "35",
					"effect": [
						null,
						[
							4,
							8,
							12,
							16,
							20
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4/8/12/16/20",
						"3",
						"60/110/160/210/260",
						"15",
						"1",
						"50",
						"1",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonushealth",
							"coeff": 0.15,
							"key": "f1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "VolibearW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VolibearE",
					"name": "Majestic Roar",
					"description": "Volibear lets out a powerful roar that damages, slows, and slightly knocks back enemies. Enemies who are airborne or dashing are dealt additional damage. Minions and monsters are feared as well.",
					"tooltip": "Volibear deals {{ e2 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to nearby enemies, knocking them back slightly and slowing them by {{ e1 }}% for {{ e3 }} seconds. Enemies who are airborne or dashing are dealt an additional {{ e5 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage.<br /><br />Additionally, minions and monsters are feared for 3 seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus Damage",
							"Slow Amount ",
							"Mana Cost "
						],
						"effect": [
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						11,
						11,
						11,
						11,
						11
					],
					"cooldownBurn": "11",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							49,
							49,
							49,
							49,
							49
						],
						[
							40,
							60,
							80,
							100,
							120
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							140,
							140,
							140,
							140,
							140
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/35/40/45/50",
						"60/105/150/195/240",
						"3",
						"49",
						"40/60/80/100/120",
						"70",
						"140",
						"100",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						425,
						425,
						425,
						425,
						425
					],
					"rangeBurn": "425",
					"image": {
						"full": "VolibearE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "VolibearR",
					"name": "Thunder Claws",
					"description": "Volibear erupts with chain lightning, damaging a number nearby enemies. The power of the storm causes Volibear's attacks to blast his targets with lightning that bounces to other nearby enemies.",
					"tooltip": "Volibear erupts with chain lightning, striking up to {{ e4 }} nearby enemies with {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.<br /><br />For the next {{ e3 }} seconds, the storm empowers Volibear, causing his basic attacks to deal {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> bonus magic damage that chains to {{ e4 }} nearby enemies.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						100,
						90,
						80
					],
					"cooldownBurn": "100/90/80",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							75,
							115,
							155
						],
						[
							9,
							9,
							9
						],
						[
							12,
							12,
							12
						],
						[
							8,
							8,
							8
						],
						[
							0.08,
							0.08,
							0.08
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/115/155",
						"9",
						"12",
						"8",
						"0.08",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "VolibearR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Chosen of the Storm",
				"description": "Volibear heals rapidly for a few seconds when his Health drops to a critical level.",
				"image": {
					"full": "VolibearPassive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 288,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Volibear",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Volibear",
					"title": "VolibearTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2032",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Warwick": {
			"id": "Warwick",
			"key": "19",
			"name": "Warwick",
			"title": "the Uncaged Wrath of Zaun",
			"image": {
				"full": "Warwick.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 336,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "19000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "19001",
					"num": 1,
					"name": "Grey Warwick",
					"chromas": false
				},
				{
					"id": "19002",
					"num": 2,
					"name": "Urf the Manatee",
					"chromas": false
				},
				{
					"id": "19003",
					"num": 3,
					"name": "Big Bad Warwick",
					"chromas": false
				},
				{
					"id": "19004",
					"num": 4,
					"name": "Tundra Hunter Warwick",
					"chromas": false
				},
				{
					"id": "19005",
					"num": 5,
					"name": "Feral Warwick",
					"chromas": false
				},
				{
					"id": "19006",
					"num": 6,
					"name": "Firefang Warwick",
					"chromas": false
				},
				{
					"id": "19007",
					"num": 7,
					"name": "Hyena Warwick",
					"chromas": false
				},
				{
					"id": "19008",
					"num": 8,
					"name": "Marauder Warwick",
					"chromas": false
				},
				{
					"id": "19009",
					"num": 9,
					"name": "Urfwick",
					"chromas": false
				},
				{
					"id": "19010",
					"num": 10,
					"name": "Lunar Guardian Warwick",
					"chromas": true
				}
			],
			"lore": "Warwick is a monster who hunts the gray alleys of Zaun. Transformed by agonizing experiments, his body is fused with an intricate system of chambers and pumps, machinery filling his veins with alchemical rage. Bursting out of the shadows, he preys upon those criminals who terrorize the city's depths. Warwick is drawn to blood, and driven mad by its scent. None who spill it can escape him.",
			"blurb": "Warwick is a monster who hunts the gray alleys of Zaun. Transformed by agonizing experiments, his body is fused with an intricate system of chambers and pumps, machinery filling his veins with alchemical rage. Bursting out of the shadows, he preys upon...",
			"allytips": [
				"Follow your Blood Hunt trails to low health enemy champions.",
				"Infinite Duress (R)'s distance scales with any movement speed you gain, even from ally buffs and summoner spells.",
				"Jaws of the Beast (Q) will follow enemies who run, dash or teleport if you keep the button held down."
			],
			"enemytips": [
				"Warwick's attacks heal him at low health. Save your disables to finish him off.",
				"Warwick is empowered versus low health enemies. Manage your health to keep him at bay.",
				"Warwick's ultimate cast range scales with his movement speed."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 9,
				"defense": 5,
				"magic": 3,
				"difficulty": 3
			},
			"stats": {
				"hp": 550,
				"hpperlevel": 85,
				"mp": 280,
				"mpperlevel": 35,
				"movespeed": 335,
				"armor": 33,
				"armorperlevel": 3.2,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 4,
				"hpregenperlevel": 0.75,
				"mpregen": 7.466,
				"mpregenperlevel": 0.575,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 3,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 2.3
			},
			"spells": [
				{
					"id": "WarwickQ",
					"name": "Jaws of the Beast",
					"description": "Warwick lunges forward and bites his target, dealing damage based on their maximum health and healing for damage dealt.",
					"tooltip": "Warwick lunges forward and bites his target. While the key is held down, he will <span class=\"colorFFEB7F\">attach</span> to the target then leap behind them.<br /><br />On release, deals <span class=\"colorFF8C00\">{{ a1 }}</span><span class=\"color99FF99\">+{{ a2 }}</span> plus {{ e1 }}% of your target's maximum health as magic damage (applies On Hit effects). Heal {{ e3 }}% of damage dealt.<br /><br /><span class=\"size16 color8C8C8C\">While <span class=\"size16 colorFFEB7F\">attached</span>, Warwick follows any movements they make and cannot be displaced.</span>",
					"leveltip": {
						"label": [
							"Heal",
							"Percent Health Damage",
							"Cost"
						],
						"effect": [
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						50,
						60,
						70,
						80,
						90
					],
					"costBurn": "50/60/70/80/90",
					"effect": [
						null,
						[
							6,
							7,
							8,
							9,
							10
						],
						[
							100,
							150,
							200,
							250,
							300
						],
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							100,
							125,
							150,
							175,
							200
						],
						[
							450,
							450,
							450,
							450,
							450
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							425,
							425,
							425,
							425,
							425
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"6/7/8/9/10",
						"100/150/200/250/300",
						"30/40/50/60/70",
						"100/125/150/175/200",
						"450",
						"200",
						"300",
						"425",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.2,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "WarwickQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "WarwickW",
					"name": "Blood Hunt",
					"description": "Warwick senses enemies below 50% health, gaining movement speed toward and attack speed against them. When they fall below 20% health, he frenzies and these bonuses triple.",
					"tooltip": "<span class=\"colorFF9900\"></span><span class=\"colorFF9900\">Passive: </span>Warwick gains {{ e2 }}% attack speed against enemies below 50% health. He also senses low health champions globally, moving {{ e1 }}% faster toward them when out of combat. These bonuses are tripled against enemies below 20% health.<br /><br /><span class=\"colorFF9900\">Active: </span>Warwick briefly senses all enemies. The nearest sensed champion is Blood Hunted for 8 seconds. Cast only while not in combat with a champion.<br /><br />While no enemies are being hunted, Blood Hunt cools down twice as fast.",
					"leveltip": {
						"label": [
							"Movement Speed",
							"Attack Speed",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						120,
						105,
						90,
						75,
						60
					],
					"cooldownBurn": "120/105/90/75/60",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							35,
							40,
							45,
							50,
							55
						],
						[
							50,
							65,
							80,
							95,
							110
						],
						[
							10,
							15,
							20,
							25,
							30
						],
						[
							80,
							90,
							100,
							110,
							120
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/40/45/50/55",
						"50/65/80/95/110",
						"10/15/20/25/30",
						"80/90/100/110/120",
						"30",
						"8",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "2",
					"range": [
						4000,
						4000,
						4000,
						4000,
						4000
					],
					"rangeBurn": "4000",
					"image": {
						"full": "WarwickW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "WarwickE",
					"name": "Primal Howl",
					"description": "Warwick gains damage reduction for 2.5 seconds. At the end, or if re-activated, he howls, causing nearby enemies to flee for 1 second.",
					"tooltip": "Warwick gains {{ e1 }}% damage reduction for 2.5 seconds. At the end of the duration, or if activated again, Warwick howls, causing all nearby enemies to flee for {{ e3 }} second.",
					"leveltip": {
						"label": [
							"Damage Reduction",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						14,
						13,
						12,
						11
					],
					"cooldownBurn": "15/14/13/12/11",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							35,
							40,
							45,
							50,
							55
						],
						[
							2.75,
							2.75,
							2.75,
							2.75,
							2.75
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"35/40/45/50/55",
						"2.75",
						"1",
						"1",
						"800",
						"400",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						375,
						375,
						375,
						375,
						375
					],
					"rangeBurn": "375",
					"image": {
						"full": "WarwickE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "WarwickR",
					"name": "Infinite Duress",
					"description": "Warwick leaps in a direction (scaling with his bonus movement speed), suppressing the first champion he collides with for 1.5 seconds.",
					"tooltip": "Warwick leaps 2.5 seconds worth of movement speed in a direction, suppressing the first champion he collides with for {{ e2 }} seconds. Deals {{ e7 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> magic damage and applies on-hit effects 3 times. Warwick heals for 100% of all damage he deals during Infinite Duress.",
					"leveltip": {
						"label": [
							"Base Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e7 }} -> {{ e7NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						110,
						90,
						70
					],
					"cooldownBurn": "110/90/70",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							30,
							30,
							30
						],
						[
							5,
							5,
							5
						],
						[
							20,
							20,
							20
						],
						[
							0,
							0,
							0
						],
						[
							175,
							350,
							525
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"1.5",
						"30",
						"5",
						"20",
						"0",
						"175/350/525",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.67,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						25000,
						25000,
						25000
					],
					"rangeBurn": "25000",
					"image": {
						"full": "WarwickR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Eternal Hunger",
				"description": "Warwick's basic attacks deal bonus magic damage. If Warwick is below 50% health, he heals the same amount. If Warwick is below 25% health, this healing triples.",
				"image": {
					"full": "WarwickP.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 336,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Warwick",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3009",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3091",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Warwick",
					"title": "WarwickTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3077",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3084",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Xayah": {
			"id": "Xayah",
			"key": "498",
			"name": "Xayah",
			"title": "the Rebel",
			"image": {
				"full": "Xayah.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 384,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "498000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "498001",
					"num": 1,
					"name": "Cosmic Dusk Xayah",
					"chromas": false
				},
				{
					"id": "498002",
					"num": 2,
					"name": "Sweetheart Xayah",
					"chromas": false
				}
			],
			"lore": "Deadly and precise, Xayah is a vastayan revolutionary waging a personal war to save her people. She uses her speed, guile, and razor-sharp feather blades to cut down anyone who stands in her way. Xayah fights alongside her partner and lover, Rakan, to protect their dwindling tribe, and restore their race to her vision of its former glory.",
			"blurb": "Deadly and precise, Xayah is a vastayan revolutionary waging a personal war to save her people. She uses her speed, guile, and razor-sharp feather blades to cut down anyone who stands in her way. Xayah fights alongside her partner and lover, Rakan, to...",
			"allytips": [
				"Xayah's attacks and abilities leave Feathers on the ground that she can later recall for massive area damage and control.",
				"Xayah can use Featherstorm to dodge almost any ability while also creating a ton of Feathers. Try to utilize the offensive and defensive aspects of this ability."
			],
			"enemytips": [
				"Xayah's Bladecaller will only root targets hit by 3 or more returning Feathers.",
				"Long fights in the same area with Xayah will allow her to drop a lot of Feathers. Try to stay on the move!",
				"Make sure you are ready when you go for the kill. Untargetability from Featherstorm can quickly turn an ambush in Xayah's favor."
			],
			"tags": [
				"Marksman"
			],
			"partype": "Mana",
			"info": {
				"attack": 10,
				"defense": 6,
				"magic": 1,
				"difficulty": 5
			},
			"stats": {
				"hp": 545,
				"hpperlevel": 80,
				"mp": 340,
				"mpperlevel": 40,
				"movespeed": 325,
				"armor": 33,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 6,
				"hpregenperlevel": 0.75,
				"mpregen": 8.25,
				"mpregenperlevel": 0.75,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 64,
				"attackdamageperlevel": 2.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.3
			},
			"spells": [
				{
					"id": "XayahQ",
					"name": "Double Daggers",
					"description": "Xayah throws two damaging daggers that also drop Feathers she can recall.",
					"tooltip": "Xayah throws two knives dealing {{ f1 }} <span class=\"colorFF9900\">(+{{ f2 }})</span> physical damage and leaving two <span class=\"colorC200E1\">Feathers</span>. Targets hit after the first take {{ e2 }}% damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9,
						8,
						7,
						6
					],
					"cooldownBurn": "10/9/8/7/6",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							90,
							130,
							170,
							210,
							250
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0.334,
							0.334,
							0.334,
							0.334,
							0.334
						],
						[
							0.584,
							0.584,
							0.584,
							0.584,
							0.584
						],
						[
							3500,
							3500,
							3500,
							3500,
							3500
						],
						[
							3500,
							3500,
							3500,
							3500,
							3500
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"90/130/170/210/250",
						"50",
						"0.33",
						"0.58",
						"3500",
						"3500",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "XayahQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XayahW",
					"name": "Deadly Plumage",
					"description": "Xayah creates a storm of blades that increase her basic attack speed and damage while granting her movement speed if she attacks a champion.",
					"tooltip": "Xayah creates a storm of blades for {{ e2 }} seconds that grant her {{ e1 }}% attack speed and cause her basic attacks to strike an additional time for {{ e5 }}% damage. <br /><br />If Deadly Plumage strikes an enemy champion, Xayah gains {{ e3 }}% movement speed for {{ e4 }} seconds.<br /><br /><span class=\"colore5c100\">If Rakan is nearby he will also gain the effects of Deadly Plumage.</span>",
					"leveltip": {
						"label": [
							"Attack Speed",
							"Cooldown",
							"Cost"
						],
						"effect": [
							"{{ e1 }}% -> {{ e1NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						19,
						18,
						17,
						16
					],
					"cooldownBurn": "20/19/18/17/16",
					"cost": [
						60,
						55,
						50,
						45,
						40
					],
					"costBurn": "60/55/50/45/40",
					"effect": [
						null,
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/35/40/45/50",
						"4",
						"30",
						"1.5",
						"20",
						"1000",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "XayahW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XayahE",
					"name": "Bladecaller",
					"description": "Xayah calls back all her dropped Feathers dealing damage and rooting enemies.",
					"tooltip": "Xayah calls all <span class=\"colorC200E1\">Feathers</span> back to her, dealing {{ e1 }} <span class=\"colorFF9900\">(+{{ f3 }})</span> <span class=\"colorFF5802\">(+{{ f4 }})</span> physical damage to enemies they pass through (Increased by <span class=\"colorFF5802\">Critical Strike Chance</span>).<br /><br />Hitting an enemy with {{ e5 }} <span class=\"colorC200E1\">Feathers</span> roots them for {{ e4 }} second.<br /><br />Minions take {{ e2 }}% damage from Bladecaller.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						40,
						40,
						40,
						40,
						40
					],
					"costBurn": "40",
					"effect": [
						null,
						[
							55,
							65,
							75,
							85,
							95
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"55/65/75/85/95",
						"50",
						"0.1",
						"1",
						"3",
						"0.25",
						"0",
						"0.5",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						2000,
						2000,
						2000,
						2000,
						2000
					],
					"rangeBurn": "2000",
					"image": {
						"full": "XayahE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XayahR",
					"name": "Featherstorm",
					"description": "Xayah leaps into the air becoming untargetable and throwing out a fan of daggers, dropping Feathers she can recall.",
					"tooltip": "Xayah leaps into the air becoming untargetable. She then rains down daggers which deal {{ e1 }}<span class=\"colorFF9900\"> (+{{ a1 }})</span> physical damage and leave behind a line of <span class=\"colorC200E1\">Feathers</span>.<br /><br />Xayah can move while in the air.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						140,
						125,
						110
					],
					"cooldownBurn": "140/125/110",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							100,
							150,
							200
						],
						[
							1,
							1,
							1
						],
						[
							1.25,
							1.25,
							1.25
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"100/150/200",
						"1",
						"1.25",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						450,
						450,
						450
					],
					"rangeBurn": "450",
					"image": {
						"full": "XayahR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Clean Cuts",
				"description": "After using an ability, Xayah's next few basic attacks will hit all enemies along their path and dropping Feathers she can recall.",
				"image": {
					"full": "XayahPassive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 384,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Xayah",
					"title": "XayahARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahPRJ17",
					"map": "ProjectSlums",
					"mode": "PROJECT",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "recommended",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3508",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "3363",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Xayah",
					"title": "XayahTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1037",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3094",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Xerath": {
			"id": "Xerath",
			"key": "101",
			"name": "Xerath",
			"title": "the Magus Ascendant",
			"image": {
				"full": "Xerath.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 432,
				"y": 0,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "101000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "101001",
					"num": 1,
					"name": "Runeborn Xerath",
					"chromas": false
				},
				{
					"id": "101002",
					"num": 2,
					"name": "Battlecast Xerath",
					"chromas": false
				},
				{
					"id": "101003",
					"num": 3,
					"name": "Scorched Earth Xerath",
					"chromas": false
				},
				{
					"id": "101004",
					"num": 4,
					"name": "Guardian of the Sands Xerath",
					"chromas": false
				}
			],
			"lore": "Xerath is an Ascended Magus of ancient Shurima, a being of arcane energy writhing in the broken shards of a magical sarcophagus. For millennia, he was trapped beneath the desert sands, but the rise of Shurima freed him from his ancient prison. Driven insane with power, he now seeks to take what he believes is rightfully his and replace the upstart civilizations of the world with one fashioned in his image.",
			"blurb": "Xerath is an Ascended Magus of ancient Shurima, a being of arcane energy writhing in the broken shards of a magical sarcophagus. For millennia, he was trapped beneath the desert sands, but the rise of Shurima freed him from his ancient prison. Driven...",
			"allytips": [
				"It's easier to land Arcanopulse on an enemy when they're moving toward or away from you, rather than side to side.",
				"Eye of Destruction will make landing Arcanopulse easier as the target will be slowed.",
				"If you stun an enemy with Shocking Orb, follow up with a guaranteed center hit on Eye of Destruction."
			],
			"enemytips": [
				"Xerath's range can be intimidating, but most champions who close distance with him can trade favorably.",
				"Xerath takes a long time to engage Rite of the Arcane. Watch for his spellcast animation and start dodging.",
				"Banshee's Veil will make it much harder for Xerath to land Shocking Orb on you."
			],
			"tags": [
				"Mage",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 3,
				"magic": 10,
				"difficulty": 8
			},
			"stats": {
				"hp": 526,
				"hpperlevel": 92,
				"mp": 366.96,
				"mpperlevel": 44,
				"movespeed": 340,
				"armor": 21.88,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 5.5,
				"hpregenperlevel": 0.55,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 54.7,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 1.36
			},
			"spells": [
				{
					"id": "XerathArcanopulseChargeUp",
					"name": "Arcanopulse",
					"description": "Fires a long-range beam of energy, dealing magic damage to all targets hit.",
					"tooltip": "<span class=\"colorFF9900\">First cast:</span> Xerath charges Arcanopulse, gradually decreasing his Movement Speed while increasing the spell's range.<br /><br /><span class=\"colorFF9900\">Second cast:</span> Xerath fires Arcanopulse, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in a line.<br /><br />While charging Arcanopulse, Xerath cannot attack or cast other spells. If Xerath does not fire the spell, half the Mana cost is refunded.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						80,
						90,
						100,
						110,
						120
					],
					"costBurn": "80/90/100/110/120",
					"effect": [
						null,
						[
							80,
							120,
							160,
							200,
							240
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							145,
							145,
							145,
							145,
							145
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							-0.2,
							-0.2,
							-0.2,
							-0.2,
							-0.2
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/120/160/200/240",
						"4",
						"0.5",
						"145",
						"0.5",
						"-0.2",
						"0.1",
						"0.5",
						"1.5",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.75,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "1",
					"range": [
						750,
						750,
						750,
						750,
						750
					],
					"rangeBurn": "750",
					"image": {
						"full": "XerathArcanopulseChargeUp.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 240,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XerathArcaneBarrage2",
					"name": "Eye of Destruction",
					"description": "Calls down a barrage of arcane energy, slowing and dealing magic damage to all enemies in an area. Targets in the middle receive additional damage and a stronger slow.",
					"tooltip": "Xerath calls down a blast of arcane energy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies within the target area, slowing them by {{ e8 }}% for {{ e4 }} seconds. Enemies in the center of the blast take {{ f1 }} <span class=\"color99FF99\">(+{{ f2 }})</span> magic damage and are slowed by {{ e3 }}%. This slow decays rapidly.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Slow Amount",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
							"{{ e3 }}% -> {{ e3NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						1,
						1,
						1,
						1,
						1
					],
					"cooldownBurn": "1",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							60,
							65,
							70,
							75,
							80
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							25,
							25,
							25,
							25,
							25
						],
						[
							0.8,
							0.8,
							0.8,
							0.8,
							0.8
						],
						[
							-0.25,
							-0.25,
							-0.25,
							-0.25,
							-0.25
						]
					],
					"effectBurn": [
						null,
						"60/90/120/150/180",
						"2",
						"60/65/70/75/80",
						"2.5",
						"0.5",
						"50",
						"50",
						"25",
						"0.8",
						"-0.25"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "XerathArcaneBarrage2.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 288,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XerathMageSpear",
					"name": "Shocking Orb",
					"description": "Deals magic damage to an enemy and stuns them.",
					"tooltip": "Xerath fires an orb of raw magic. The first enemy hit takes {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and is stunned for between {{ e8 }} and {{ e2 }} seconds. The stun duration lengthens based on how far the orb travels.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12.5,
						12,
						11.5,
						11
					],
					"cooldownBurn": "13/12.5/12/11.5/11",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							80,
							110,
							140,
							170,
							200
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0.17,
							0.17,
							0.17,
							0.17,
							0.17
						],
						[
							1125,
							1125,
							1125,
							1125,
							1125
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/110/140/170/200",
						"2",
						"0.17",
						"1125",
						"0.5",
						"0",
						"0",
						"0.5",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.45,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "1",
					"range": [
						1050,
						1050,
						1050,
						1050,
						1050
					],
					"rangeBurn": "1050",
					"image": {
						"full": "XerathMageSpear.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 336,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XerathLocusOfPower2",
					"name": "Rite of the Arcane",
					"description": "Xerath immobilizes himself and gains numerous long-range barrages.",
					"tooltip": "Xerath ascends to his true form, becoming rooted in place and gaining {{ e2 }} Arcane Barrages. This magic artillery deals {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies hit.<br /><br />The root ends after {{ e1 }} seconds, when all shots have been fired or when manually deactivated by issuing a move command. If no barrages are fired, {{ e7 }}% of the cooldown is refunded.",
					"leveltip": {
						"label": [
							"Damage",
							"Number of Shots",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						115,
						100
					],
					"cooldownBurn": "130/115/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							10,
							10,
							10
						],
						[
							3,
							4,
							5
						],
						[
							200,
							240,
							280
						],
						[
							200,
							200,
							200
						],
						[
							3200,
							4400,
							5600
						],
						[
							0.8,
							0.8,
							0.8
						],
						[
							50,
							50,
							50
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"10",
						"3/4/5",
						"200/240/280",
						"200",
						"3200/4400/5600",
						"0.8",
						"50",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.43,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3200,
						4400,
						5600
					],
					"rangeBurn": "3200/4400/5600",
					"image": {
						"full": "XerathLocusOfPower2.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 384,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Mana Surge",
				"description": "Xerath's basic attacks periodically restore Mana.",
				"image": {
					"full": "Xerath_Passive1.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 432,
					"y": 0,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Xerath",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3907",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Xerath",
					"title": "XerathTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"XinZhao": {
			"id": "XinZhao",
			"key": "5",
			"name": "Xin Zhao",
			"title": "the Seneschal of Demacia",
			"image": {
				"full": "XinZhao.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 0,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "5000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "5001",
					"num": 1,
					"name": "Commando Xin Zhao",
					"chromas": false
				},
				{
					"id": "5002",
					"num": 2,
					"name": "Imperial Xin Zhao",
					"chromas": false
				},
				{
					"id": "5003",
					"num": 3,
					"name": "Viscero Xin Zhao",
					"chromas": false
				},
				{
					"id": "5004",
					"num": 4,
					"name": "Winged Hussar Xin Zhao",
					"chromas": false
				},
				{
					"id": "5005",
					"num": 5,
					"name": "Warring Kingdoms Xin Zhao",
					"chromas": true
				},
				{
					"id": "5006",
					"num": 6,
					"name": "Secret Agent Xin Zhao",
					"chromas": false
				},
				{
					"id": "5013",
					"num": 13,
					"name": "Dragonslayer Xin Zhao",
					"chromas": true
				}
			],
			"lore": "Xin Zhao is a resolute warrior loyal to the ruling Lightshield dynasty. Once condemned to the fighting pits of Noxus, he survived countless gladiatorial bouts, but after being freed by Demacian forces, he swore his life and allegiance to these brave liberators. Armed with his favored three-talon spear, Xin Zhao now fights for his adopted kingdom, audaciously challenging any foe, no matter the odds.",
			"blurb": "Xin Zhao is a resolute warrior loyal to the ruling Lightshield dynasty. Once condemned to the fighting pits of Noxus, he survived countless gladiatorial bouts, but after being freed by Demacian forces, he swore his life and allegiance to these brave...",
			"allytips": [
				"Xin Zhao is a great initiator to combat. Lead the front to start a fight and use your ultimate to do the most damage possible.",
				"Try to position yourself so your ultimate's knockback is most effective."
			],
			"enemytips": [
				"Xin Zhao is a powerful initiator with both his charge and ultimate dealing damage to all units around him. Try having your team stay spread out until he's used his ultimate.",
				"Xin Zhao relies heavily on his Three Talon Strikes for damage and cooldown resets, so preventing him from finishing his combo will have a dramatic effect."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Mana",
			"info": {
				"attack": 8,
				"defense": 6,
				"magic": 3,
				"difficulty": 2
			},
			"stats": {
				"hp": 570,
				"hpperlevel": 92,
				"mp": 273.8,
				"mpperlevel": 35,
				"movespeed": 345,
				"armor": 35,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.7,
				"mpregen": 7.256,
				"mpregenperlevel": 0.45,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 66,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 3.5
			},
			"spells": [
				{
					"id": "XinZhaoQ",
					"name": "Three Talon Strike",
					"description": "Xin Zhao's next 3 standard attacks deal increased damage with the third attack knocking an opponent into the air.",
					"tooltip": "Xin Zhao's next 3 basic attacks deal {{ e1 }} <span class=\"colorFF8C00\">(+{{ f1 }})</span> extra physical damage and reduce his other cooldowns by 1 second. The final strike also knocks the target into the air for {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Bonus Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						9,
						8,
						7,
						6,
						5
					],
					"cooldownBurn": "9/8/7/6/5",
					"cost": [
						30,
						30,
						30,
						30,
						30
					],
					"costBurn": "30",
					"effect": [
						null,
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/25/30/35/40",
						"0.75",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						375,
						375,
						375,
						375,
						375
					],
					"rangeBurn": "375",
					"image": {
						"full": "XinZhaoQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 432,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XinZhaoW",
					"name": "Wind Becomes Lightning",
					"description": "Xin Zhao slashes in front of himself with his spear, then thrusts it forward, slowing affected enemies.",
					"tooltip": "Xin Zhao slashes in front of himself with his spear, then thrusts it forward.<br /><br /><span class=\"colorDDDD77\">Slash</span>: {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> damage.<br /><span class=\"colorDDDD77\">Thrust</span>: {{ e2 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> damage and slows by {{ e6 }}% for {{ e7 }} seconds.<br /><br />Cast time is reduced with Attack Speed provided from items and levels (minimum of 0.4 seconds). Current cast time: <span class=\"colorFFFFFF\">{{ f5 }}</fontcolor><br /><br /><rules>Deals 50% less damage to minions.<br />Lifesteal is 33% effective on both attacks.<br />Extends the current duration of Xin Zhao's other abilities by {{ f5 }} seconds.</rules>",
					"leveltip": {
						"label": [
							"Slash Damage",
							"Thrust Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						45,
						45,
						45,
						45,
						45
					],
					"costBurn": "45",
					"effect": [
						null,
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							30,
							65,
							100,
							135,
							170
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							140,
							140,
							140,
							140,
							140
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/40/50/60/70",
						"30/65/100/135/170",
						"0.5",
						"0.4",
						"0.4",
						"50",
						"1.5",
						"140",
						"200",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "attackdamage",
							"coeff": 0.75,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "XinZhaoW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 0,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XinZhaoE",
					"name": "Audacious Charge",
					"description": "Xin Zhao charges to an enemy, dealing damage to all enemies in the area and slowing them briefly.",
					"tooltip": "Xin Zhao charges to an enemy. The charge deals {{ e1 }}<span class=\"color99FF99\"> (+{{ a1 }})</span> magic damage to nearby enemies and slows them by {{ e2 }}% for 0.5 seconds.  Charging grants Xin Zhao {{ e3 }}% attack speed for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Attack Speed"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							50,
							75,
							100,
							125,
							150
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							40,
							45,
							50,
							55,
							60
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							250,
							250,
							250,
							250,
							250
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"50/75/100/125/150",
						"50",
						"40/45/50/55/60",
						"5",
						"250",
						"0.5",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "XinZhaoE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 48,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "XinZhaoR",
					"name": "Crescent Guard",
					"description": "Xin Zhao deals damage to nearby enemies based on their current Health and knocks non-challenged targets back. Xin Zhao is impervious to damage dealt by champions outside of the circle created.",
					"tooltip": "Xin Zhao unleashes a sweep around him that deals {{ e1 }}<span class=\"colorFF8C00\"> (+{{ a1 }})</span> plus {{ e2 }}% of target's current Health in physical damage and knocks them back (max 600 vs monsters).<br /><br />For {{ e5 }} seconds after casting this ability, Xin Zhao has increased <span class=\"colorDDDD77\">Awareness</span> and will completely block damage from enemies that are far away. Xin Zhao's attacks and spell casts increase the duration of <span class=\"colorDDDD77\">Awareness</span> by {{ e7 }} seconds each.<br /><br />The last champion hit by Xin Zhao's basic attacks or Audacious Charge is not knocked back.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						110,
						100
					],
					"cooldownBurn": "120/110/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							75,
							175,
							275
						],
						[
							15,
							15,
							15
						],
						[
							0,
							0,
							0
						],
						[
							40,
							60,
							80
						],
						[
							3,
							3,
							3
						],
						[
							450,
							450,
							450
						],
						[
							0.3,
							0.3,
							0.3
						],
						[
							3,
							3,
							3
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/175/275",
						"15",
						"0",
						"40/60/80",
						"3",
						"450",
						"0.3",
						"3",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						500,
						500,
						500
					],
					"rangeBurn": "500",
					"image": {
						"full": "XinZhaoR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 96,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Determination",
				"description": "Every third attack deals bonus damage and heals Xin Zhao.",
				"image": {
					"full": "XinZhaoP.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 0,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "XinZhao",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3361",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3715",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1412",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3124",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "XinZhao",
					"title": "XinZhaoTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1416",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3252",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Yasuo": {
			"id": "Yasuo",
			"key": "157",
			"name": "Yasuo",
			"title": "the Unforgiven",
			"image": {
				"full": "Yasuo.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 48,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "157000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "157001",
					"num": 1,
					"name": "High Noon Yasuo",
					"chromas": true
				},
				{
					"id": "157002",
					"num": 2,
					"name": "PROJECT: Yasuo",
					"chromas": false
				},
				{
					"id": "157003",
					"num": 3,
					"name": "Blood Moon Yasuo",
					"chromas": false
				},
				{
					"id": "157009",
					"num": 9,
					"name": "Nightbringer Yasuo",
					"chromas": false
				}
			],
			"lore": "An Ionian of deep resolve, Yasuo is an agile swordsman, trained to wield the air itself against his enemies. As a young man, pride led him down a path of loss, costing him his position, his mentor, and ultimately his own brother. Disgraced by false accusations and now hunted as little more than a criminal, Yasuo wanders his homeland seeking redemption for his past, with only the wind to guide his blade.",
			"blurb": "An Ionian of deep resolve, Yasuo is an agile swordsman, trained to wield the air itself against his enemies. As a young man, pride led him down a path of loss, costing him his position, his mentor, and ultimately his own brother. Disgraced by false...",
			"allytips": [
				"Dash through a minion to have Sweeping Blade available to chase your opponent should they flee; Dash directly to your opponent to preserve a minion as your escape route.",
				"At level 18, Yasuo's Steel Tempest reaches its Attack Speed cap with 55% Attack Speed from items.",
				"Last Breath can be cast on any target that is knocked Airborne, even by one of your allies."
			],
			"enemytips": [
				"Steel Tempest is very narrow. Dodge laterally if possible. ",
				"When Yasuo lands two Steel Tempests in a row, his next will fire a tornado. Watch and listen for the associated sound to prepare to dodge.",
				"Yasuo is at his weakest just after he has launched a whirlwind. Engage at that point.",
				"Yasuo's shield from Resolve lasts only 2 seconds. Dealing damage to him will trigger it. Wait it out, then engage."
			],
			"tags": [
				"Fighter",
				"Assassin"
			],
			"partype": "Flow",
			"info": {
				"attack": 8,
				"defense": 4,
				"magic": 4,
				"difficulty": 10
			},
			"stats": {
				"hp": 523,
				"hpperlevel": 87,
				"mp": 100,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 30,
				"armorperlevel": 3.4,
				"spellblock": 30,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 6.5,
				"hpregenperlevel": 0.9,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 60,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": -0.067,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "YasuoQW",
					"name": "Steel Tempest",
					"description": "A skillshot basic attack. After two successful Steel Tempests, the next fires a tornado that knocks enemies Airborne.",
					"tooltip": "Thrusts forward, dealing {{ f2.0 }} <span class=\"colorFF8C00\">(+{{ f3.0 }})</span> physical damage.<br /><br />On hit, Steel Tempest grants a stack of Gathering Storm for 6 seconds. At 2 stacks, Steel Tempest fires a whirlwind that knocks <span class=\"color6655CC\">Airborne</span>.<br /><br />Steel Tempest is treated as a basic attack: It can critically strike, applies on-hit effects, is interruptible by crowd control and its cooldown and cast time are reduced by Attack Speed.<br /><br /><span class=\"color99FF99\">If cast while dashing, Steel Tempest will strike as a circle.</span>",
					"leveltip": {
						"label": [
							"Damage"
						],
						"effect": [
							"{{ f2.0 }} -> {{ f4.0 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.5,
						5,
						4.5,
						4
					],
					"cooldownBurn": "6/5.5/5/4.5/4",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							45,
							70,
							95,
							120
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/45/70/95/120",
						"100",
						"0",
						"4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						475,
						475,
						475,
						475,
						475
					],
					"rangeBurn": "475",
					"image": {
						"full": "YasuoQW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 144,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "YasuoWMovingWall",
					"name": "Wind Wall",
					"description": "Creates a moving wall that blocks enemy projectiles.",
					"tooltip": "Creates a moving wall that blocks all enemy projectiles for 4 seconds.",
					"leveltip": {
						"label": [
							"Wall Width",
							"Cooldown"
						],
						"effect": [
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						26,
						24,
						22,
						20,
						18
					],
					"cooldownBurn": "26/24/22/20/18",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							15,
							20,
							25,
							30,
							35
						],
						[
							60,
							90,
							120,
							150,
							180
						],
						[
							3,
							6,
							9,
							12,
							15
						],
						[
							300,
							350,
							400,
							450,
							500
						],
						[
							320,
							390,
							460,
							530,
							600
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/20/25/30/35",
						"60/90/120/150/180",
						"3/6/9/12/15",
						"300/350/400/450/500",
						"320/390/460/530/600",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						400,
						400,
						400,
						400,
						400
					],
					"rangeBurn": "400",
					"image": {
						"full": "YasuoWMovingWall.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 192,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				},
				{
					"id": "YasuoDashWrapper",
					"name": "Sweeping Blade",
					"description": "Dashes through a unit, dealing escalating Magic Damage with each cast.",
					"tooltip": "Dashes through target enemy, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorFF8C00\">(+{{ f3 }})</span> Magic Damage. Each cast increases your next dash's base Damage by 25%, up to {{ e6 }}%.<br /><br />Cannot be re-cast on the same enemy for {{ e2 }} seconds.<br /><br /><span class=\"color99FF99\">If cast while dashing, Steel Tempest will strike as a circle.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Recast Block",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }} -> {{ e2NL }}",
							"{{ f1 }} -> {{ f2 }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							60,
							70,
							80,
							90,
							100
						],
						[
							10,
							9,
							8,
							7,
							6
						],
						[
							0.5,
							0.4,
							0.3,
							0.2,
							0.1
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							15,
							17.5,
							20,
							22.5,
							25
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/70/80/90/100",
						"10/9/8/7/6",
						"0.5/0.4/0.3/0.2/0.1",
						"1.5",
						"15/17.5/20/22.5/25",
						"50",
						"20",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						}
					],
					"costType": "",
					"maxammo": "-1",
					"range": [
						475,
						475,
						475,
						475,
						475
					],
					"rangeBurn": "475",
					"image": {
						"full": "YasuoDashWrapper.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 240,
						"y": 96,
						"w": 48,
						"h": 48
					}
				},
				{
					"id": "YasuoRKnockUpComboW",
					"name": "Last Breath",
					"description": "Moves to a unit and strikes them repeatedly for heavy damage. Can only be cast on Airborne targets.",
					"tooltip": "Blinks to an <span class=\"color6655CC\">Airborne</span> enemy champion, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and holding all <span class=\"color6655CC\">Airborne</span> enemies in the area in the air for an additional 1 second. Grants maximum Flow but resets all stacks of Gathering Storm.<br /><br />For 15 seconds, Yasuo's critical strikes gain {{ e5 }}% Bonus Armor Penetration - this affects Armor from items, buffs, and runes.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ f1 }} -> {{ f2 }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							200,
							300,
							400
						],
						[
							33,
							66,
							100
						],
						[
							650,
							750,
							850
						],
						[
							1.5,
							1.5,
							1.5
						],
						[
							50,
							50,
							50
						],
						[
							33,
							66,
							100
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"200/300/400",
						"33/66/100",
						"650/750/850",
						"1.5",
						"50",
						"33/66/100",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 1.5,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						1400,
						1400,
						1400
					],
					"rangeBurn": "1400",
					"image": {
						"full": "YasuoRKnockUpComboW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 288,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Way of the Wanderer",
				"description": "Yasuo's Critical Strike Chance is doubled. Additionally, Yasuo builds toward a shield whenever he is moving. The shield triggers when he takes damage from a champion or monster.",
				"image": {
					"full": "Yasuo_Passive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 48,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Yasuo",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1042",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2015",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3087",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yasuo",
					"title": "YasuoTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3086",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3006",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3046",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3033",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Yorick": {
			"id": "Yorick",
			"key": "83",
			"name": "Yorick",
			"title": "Shepherd of Souls",
			"image": {
				"full": "Yorick.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 96,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "83000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "83001",
					"num": 1,
					"name": "Undertaker Yorick",
					"chromas": false
				},
				{
					"id": "83002",
					"num": 2,
					"name": "Pentakill Yorick",
					"chromas": false
				},
				{
					"id": "83003",
					"num": 3,
					"name": "Arclight Yorick",
					"chromas": false
				}
			],
			"lore": "The last survivor of a long-forgotten religious order, Yorick is both blessed and cursed with power over the dead. Trapped on the Shadow Isles, his only companions are the rotting corpses and shrieking spirits that he gathers to him. Yorick's monstrous actions belie his noble purpose: to free his home from the curse of the Ruination.",
			"blurb": "The last survivor of a long-forgotten religious order, Yorick is both blessed and cursed with power over the dead. Trapped on the Shadow Isles, his only companions are the rotting corpses and shrieking spirits that he gathers to him. Yorick's monstrous...",
			"allytips": [
				"You do not need to cast Awakening to regain the ability to cast Last Rites.",
				"The Maiden will attempt to assist you in a fight, so choose your targets well.",
				"You can send the Maiden down a lane alone, be careful though, as she represents a large portion of your combat power."
			],
			"enemytips": [
				"You can cast Smite on Mist Walkers and the Maiden of the Mist to damage or kill them.",
				"Try to thin out Yorick's minions before you engage him, Mist Walkers will die from a basic attack or a single target spell.",
				"You can attack Dark Procession to break the wall down."
			],
			"tags": [
				"Fighter",
				"Tank"
			],
			"partype": "Mana",
			"info": {
				"attack": 6,
				"defense": 6,
				"magic": 4,
				"difficulty": 6
			},
			"stats": {
				"hp": 580,
				"hpperlevel": 100,
				"mp": 300,
				"mpperlevel": 40,
				"movespeed": 340,
				"armor": 39,
				"armorperlevel": 4,
				"spellblock": 32,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.8,
				"mpregen": 7.5,
				"mpregenperlevel": 0.75,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 62,
				"attackdamageperlevel": 5,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "YorickQ",
					"name": "Last Rites",
					"description": "Yorick deals bonus damage on his next attack and heals himself. If the target dies a grave will be dug.",
					"tooltip": "Yorick's next basic attack deals {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage and restores {{ f1 }} Health (doubled when below half Health). Last Rites will leave a grave if it kills the target.<br /><br />When there are three or more graves nearby and Last Rites has been used, Yorick can cast Awakening to raise Mist Walkers from graves.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						25,
						25,
						25,
						25,
						25
					],
					"costBurn": "25",
					"effect": [
						null,
						[
							30,
							55,
							80,
							105,
							130
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"30/55/80/105/130",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						0,
						0,
						0,
						0,
						0
					],
					"rangeBurn": "0",
					"image": {
						"full": "YorickQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 336,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "YorickW",
					"name": "Dark Procession",
					"description": "Yorick summons a destructible wall at target location that will block enemy movement.",
					"tooltip": "Yorick summons a destructible wall of spirits with {{ e5 }} Health around target area for {{ e1 }} seconds. Allies can walk through the wall freely.",
					"leveltip": {
						"label": [
							"Health",
							"Cooldown"
						],
						"effect": [
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						20,
						18,
						16,
						14,
						12
					],
					"cooldownBurn": "20/18/16/14/12",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							18,
							18,
							18,
							18,
							18
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							0,
							0,
							1,
							1,
							2
						],
						[
							2,
							2,
							3,
							3,
							4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"4",
						"18",
						"0.75",
						"0/0/1/1/2",
						"2/2/3/3/4",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "YorickW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 384,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "YorickE",
					"name": "Mourning Mist",
					"description": "Yorick throws a globule of Black Mist that damages, slows and marks enemies.",
					"tooltip": "Yorick throws a globule of Black Mist that deals {{ e7 }}% of enemy's current Health as magic damage (minimum {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span>), slows by {{ e3 }}% for {{ e6 }} seconds, and marks champions and monsters for {{ e2 }} seconds.<br /><br />Yorick and his minions are hasted by {{ e5 }}% while moving toward the mark.",
					"leveltip": {
						"label": [
							"Minimum Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						11,
						10,
						9,
						8
					],
					"cooldownBurn": "12/11/10/9/8",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							1400,
							1400,
							1400,
							1400,
							1400
						],
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							15,
							15,
							15,
							15,
							15
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"4",
						"30",
						"1400",
						"20",
						"2",
						"15",
						"300",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "YorickE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 432,
						"y": 96,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "YorickR",
					"name": "Eulogy of the Isles",
					"description": "Yorick summons the Maiden of the Mist that causes Yorick's attacks against the Maiden's target to deal bonus damage. The Maiden will also automatically raise Walkers from dead enemies.",
					"tooltip": "Yorick summons The Maiden of the Mist and {{ e1 }} Mist Walkers. The Maiden has {{ e3 }} <span class=\"colorFF3300\">(+{{ f1 }})</span> Health, deals {{ e4 }} <span class=\"colorFF8C00\">(+{{ f2 }})</span> magic damage, and raises Mist Walkers from nearby enemy deaths.<br /><br />When Yorick damages the Maiden's target he will deal {{ e5 }}% of their max Health as bonus magic damage ({{ e7 }} second cooldown).<br /><br /><span class=\"colorDDDD77\">If the Maiden is summoned inside a lane, she will start pushing the lane.</span>",
					"leveltip": {
						"label": [
							"Health",
							"Damage",
							"Mist Walkers",
							"Mark Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }}% ->{{ e5NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						160,
						130,
						100
					],
					"cooldownBurn": "160/130/100",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							2,
							3,
							4
						],
						[
							700,
							700,
							700
						],
						[
							700,
							1500,
							4000
						],
						[
							10,
							20,
							40
						],
						[
							5,
							7.5,
							10
						],
						[
							1,
							1,
							1
						],
						[
							2,
							2,
							2
						],
						[
							200,
							300,
							400
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2/3/4",
						"700",
						"700/1500/4000",
						"10/20/40",
						"5/7.5/10",
						"1",
						"2",
						"200/300/400",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "YorickR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 0,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Shepherd of Souls",
				"description": "<mainText>Yorick can raise Mist Walkers with his abilities. Enemies that die near Yorick will sometimes leave a grave.</mainText>",
				"image": {
					"full": "Yorick_P.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 96,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Yorick",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3101",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3004",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3025",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3512",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3748",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Yorick",
					"title": "YorickTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3044",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3078",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Zac": {
			"id": "Zac",
			"key": "154",
			"name": "Zac",
			"title": "the Secret Weapon",
			"image": {
				"full": "Zac.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 144,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "154000",
					"num": 0,
					"name": "default",
					"chromas": true
				},
				{
					"id": "154001",
					"num": 1,
					"name": "Special Weapon Zac",
					"chromas": false
				},
				{
					"id": "154002",
					"num": 2,
					"name": "Pool Party Zac",
					"chromas": false
				},
				{
					"id": "154006",
					"num": 6,
					"name": "SKT T1 Zac",
					"chromas": false
				}
			],
			"lore": "Zac is the product of a toxic spill that ran through a chemtech seam and pooled in an isolated cavern deep in Zaun's Sump. Despite such humble origins, Zac has grown from primordial ooze into a thinking being who dwells in the city's pipes, occasionally emerging to help those who cannot help themselves or to rebuild the broken infrastructure of Zaun.",
			"blurb": "Zac is the product of a toxic spill that ran through a chemtech seam and pooled in an isolated cavern deep in Zaun's Sump. Despite such humble origins, Zac has grown from primordial ooze into a thinking being who dwells in the city's pipes, occasionally...",
			"allytips": [
				"Picking up goo chunks is very important to staying alive.",
				"When Cell Division is ready, try to die in a position that makes it difficult for the enemy team to kill your bloblets.",
				"Charging Elastic Slingshot from the fog of war will give opponents less time to react."
			],
			"enemytips": [
				"Zac heals from the goo that separates from him. You can crush the goo pieces by stepping on them.",
				"Kill all of Zac's bloblets when he splits apart to stop him from reforming.",
				"Silences, stuns, roots and knockups will all interrupt Zac when he is charging Elastic Slingshot."
			],
			"tags": [
				"Tank",
				"Fighter"
			],
			"partype": "None",
			"info": {
				"attack": 3,
				"defense": 7,
				"magic": 7,
				"difficulty": 8
			},
			"stats": {
				"hp": 615,
				"hpperlevel": 95,
				"mp": 0,
				"mpperlevel": 0,
				"movespeed": 340,
				"armor": 33,
				"armorperlevel": 3.5,
				"spellblock": 32,
				"spellblockperlevel": 1.25,
				"attackrange": 175,
				"hpregen": 8,
				"hpregenperlevel": 0.5,
				"mpregen": 0,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 60,
				"attackdamageperlevel": 3.4,
				"attackspeedoffset": -0.02,
				"attackspeedperlevel": 1.6
			},
			"spells": [
				{
					"id": "ZacQ",
					"name": "Stretching Strikes",
					"description": "Zac stretches an arm, grabbing an enemy. Attacking a different enemy will cause him to throw both targets towards each other.",
					"tooltip": "Zac's arm stretches and grabs the first enemy it hits, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorCC3300\">(+{{ f2 }})</span> magic damage and briefly slowing them. Zac's next basic attack is replaced with a long range smack that repeats the initial magic damage and slow effect.<br /><br />If Zac grabs a different enemy with each attack he'll throw them towards each other, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> <span class=\"colorCC3300\">(+{{ f2 }})</span> magic damage in an area if they collide.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }}-> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						13,
						12,
						11,
						10,
						9
					],
					"cooldownBurn": "13/12/11/10/9",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							30,
							40,
							50,
							60,
							70
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							800,
							800,
							800,
							800,
							800
						],
						[
							-0.6,
							-0.6,
							-0.6,
							-0.6,
							-0.6
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							1000,
							1000,
							1000,
							1000,
							1000
						],
						[
							700,
							700,
							700,
							700,
							700
						],
						[
							300,
							300,
							300,
							300,
							300
						],
						[
							300,
							300,
							300,
							300,
							300
						]
					],
					"effectBurn": [
						null,
						"30/40/50/60/70",
						"8",
						"800",
						"-0.6",
						"0.5",
						"2.5",
						"1000",
						"700",
						"300",
						"300"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": "% of current Health",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "ZacQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 48,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e2 }}% of current Health"
				},
				{
					"id": "ZacW",
					"name": "Unstable Matter",
					"description": "Zac's body erupts, damaging nearby enemies.",
					"tooltip": "Zac's body erupts, dealing {{ e1 }} magic damage +{{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span>% of the enemy's max health as magic damage to nearby enemies.<br /><br />Absorbing <span class=\"color3ca126\">Goo</span> reduces Unstable Matter's cooldown by {{ e4 }} second.<br /><br /><span class=\"size16 color8C8C8C\">Max health damage is capped at {{ e5 }} versus minions and monsters.</span></span>",
					"leveltip": {
						"label": [
							"Flat Damage",
							"Percent Max Health Damage"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }}% -> {{ e3NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						5,
						5,
						5,
						5
					],
					"cooldownBurn": "5",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							15,
							30,
							45,
							60,
							75
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							4,
							5,
							6,
							7,
							8
						],
						[
							1,
							1,
							1,
							1,
							1
						],
						[
							200,
							200,
							200,
							200,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"15/30/45/60/75",
						"4",
						"4/5/6/7/8",
						"1",
						"200",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.02,
							"key": "a1"
						}
					],
					"costType": "% of current Health",
					"maxammo": "-1",
					"range": [
						350,
						350,
						350,
						350,
						350
					],
					"rangeBurn": "350",
					"image": {
						"full": "ZacW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 96,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e2 }}% of current Health"
				},
				{
					"id": "ZacE",
					"name": "Elastic Slingshot",
					"description": "Zac attaches his arms to the ground and stretches back, launching himself forward.",
					"tooltip": "<span class=\"colorFF9900\">First cast:</span> Zac faces the cursor and charges up over {{ e4 }} seconds.<br /><br /><span class=\"colorFF9900\">Second cast:</span> Launches Zac towards a location, knocking up nearby enemies for {{ f2 }} to {{ f3 }} seconds (based on charge time) and dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Zac spawns extra chunks of <span class=\"color3ca126\">Goo</span> for each enemy champion hit.<br /><br /><span class=\"size16 color8C8C8C\">Can be cancelled by moving, refunding half of the ability's cooldown and cost.</span>",
					"leveltip": {
						"label": [
							"Damage",
							"Range",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						21,
						18,
						15,
						12
					],
					"cooldownBurn": "24/21/18/15/12",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							60,
							110,
							160,
							210,
							260
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							1200,
							1350,
							1500,
							1650,
							1800
						],
						[
							0.9,
							1,
							1.1,
							1.2,
							1.3
						],
						[
							0.5,
							0.5,
							0.5,
							0.5,
							0.5
						],
						[
							500,
							500,
							500,
							500,
							500
						],
						[
							1350,
							1350,
							1350,
							1350,
							1350
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							265,
							265,
							265,
							265,
							265
						],
						[
							1,
							1,
							1,
							1,
							1
						]
					],
					"effectBurn": [
						null,
						"60/110/160/210/260",
						"4",
						"1200/1350/1500/1650/1800",
						"0.9/1/1.1/1.2/1.3",
						"0.5",
						"500",
						"1350",
						"0.6",
						"265",
						"1"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": "% of current Health",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "ZacE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 144,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e2 }}% of current Health"
				},
				{
					"id": "ZacR",
					"name": "Let's Bounce!",
					"description": "Zac flattens himself, making him immune to crowd control while slowing enemies standing on top of him. When he decides to bounce away, he will suck up any enemies standing on top of him, taking them for a ride.",
					"tooltip": "<span class=\"colorFF9900\">First cast: </span>Zac squishes himself down, making him immune to Crowd Control for up to {{ e5 }} seconds. Enemies standing on top of him are slowed by {{ e4 }}%.<br /><br /><span class=\"colorFF9900\">Second cast: </span>Charging for at least {{ f1 }} seconds before recasting causes Zac to scoop up enemies on top of him, carrying them towards a location. Upon landing nearby enemies take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and are briefly slowed.<br /><br />Reactivating before Zac charges up knocks back nearby enemies instead.</span></span>",
					"leveltip": {
						"label": [
							"Damage",
							"Range",
							"Slow Percent",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e3 }} -> {{ e3NL }}",
							"{{ e4 }}% -> {{ e4NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						115,
						100
					],
					"cooldownBurn": "130/115/100",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							150,
							250,
							350
						],
						[
							1.1,
							1.1,
							1.1
						],
						[
							700,
							850,
							1000
						],
						[
							30,
							40,
							50
						],
						[
							2.5,
							2.5,
							2.5
						],
						[
							275,
							275,
							275
						],
						[
							300,
							300,
							300
						],
						[
							1,
							1,
							1
						],
						[
							0.25,
							0.25,
							0.25
						],
						[
							0.1,
							0.1,
							0.1
						]
					],
					"effectBurn": [
						null,
						"150/250/350",
						"1.1",
						"700/850/1000",
						"30/40/50",
						"2.5",
						"275",
						"300",
						"1",
						"0.25",
						"0.1"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						300,
						300,
						300
					],
					"rangeBurn": "300",
					"image": {
						"full": "ZacR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 192,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Cell Division",
				"description": "Each time Zac hits an enemy with an ability, he sheds a chunk of himself that can be reabsorbed to restore Health. Upon taking fatal damage, Zac splits into 4 bloblets that attempt to recombine. If any bloblets remain, he will revive with an amount of Health depending on the Health of the surviving bloblets. Each bloblet has a percentage of Zac's maximum Health, Armor and Magic Resistance. This ability has a 5 minute cooldown.",
				"image": {
					"full": "ZacPassive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 144,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Zac",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3067",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3211",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3711",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1409",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensivejungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situationaljungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3800",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2051",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1011",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3193",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3194",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3742",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3083",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zac",
					"title": "ZacTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "1054",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1041",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "earlyjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3751",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3068",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essentialjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1401",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3065",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3143",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3075",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2138",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Zed": {
			"id": "Zed",
			"key": "238",
			"name": "Zed",
			"title": "the Master of Shadows",
			"image": {
				"full": "Zed.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 192,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "238000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "238001",
					"num": 1,
					"name": "Shockblade Zed",
					"chromas": true
				},
				{
					"id": "238002",
					"num": 2,
					"name": "SKT T1 Zed",
					"chromas": false
				},
				{
					"id": "238003",
					"num": 3,
					"name": "PROJECT: Zed",
					"chromas": false
				},
				{
					"id": "238010",
					"num": 10,
					"name": "Championship Zed",
					"chromas": false
				},
				{
					"id": "238011",
					"num": 11,
					"name": "Death Sworn Zed",
					"chromas": false
				}
			],
			"lore": "Utterly ruthless and without mercy, Zed is the leader of the Order of Shadow, an organization he created with the intent of militarizing Ionia's martial arts traditions to drive out Noxian invaders. During the war, desperation led him to unlock the secret shadow form—a malevolent spirit magic as dangerous and corrupting as it is powerful. Zed has mastered all of these forbidden techniques to destroy anything he sees as a threat to his nation, or his new order.",
			"blurb": "Utterly ruthless and without mercy, Zed is the leader of the Order of Shadow, an organization he created with the intent of militarizing Ionia's martial arts traditions to drive out Noxian invaders. During the war, desperation led him to unlock the...",
			"allytips": [
				"Saving energy and spell cooldowns until you use your ultimate will maximize Death Mark's damage.",
				"Quickly double tapping Living Shadow will teleport Zed to his shadow immediately for rapid escapes.",
				"Placing a Living Shadow before using Death Mark can give Zed a safe escape from combat."
			],
			"enemytips": [
				"Zed receives bonus effect from Attack Damage items he purchases, so Armor is super effective against him.",
				"After Zed uses his Living Shadow, he is at his most vulnerable as his damage, slow, and mobility are both dependent upon it.",
				"Zed's Shadow Slash can only slow you if his shadow hits you with it. "
			],
			"tags": [
				"Assassin",
				"Fighter"
			],
			"partype": "Energy",
			"info": {
				"attack": 9,
				"defense": 2,
				"magic": 1,
				"difficulty": 7
			},
			"stats": {
				"hp": 584,
				"hpperlevel": 85,
				"mp": 200,
				"mpperlevel": 0,
				"movespeed": 345,
				"armor": 32,
				"armorperlevel": 3.5,
				"spellblock": 32.1,
				"spellblockperlevel": 1.25,
				"attackrange": 125,
				"hpregen": 7,
				"hpregenperlevel": 0.65,
				"mpregen": 50,
				"mpregenperlevel": 0,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 63,
				"attackdamageperlevel": 3.4,
				"attackspeedoffset": -0.04,
				"attackspeedperlevel": 2.1
			},
			"spells": [
				{
					"id": "ZedQ",
					"name": "Razor Shuriken",
					"description": "Zed and his shadow both throw their spinning blades forward, dealing damage to any targets they pass through.",
					"tooltip": "Zed and his shadows throw their shurikens, each dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to the first enemy they pass through, and {{ e3 }} <span class=\"colorFF8C00\">(+{{ a2 }})</span> physical damage to each additional enemy.<br /><br />Additional shurikens that hit the same enemy deal 25% less damage than previous shurikens.",
					"leveltip": {
						"label": [
							"Damage",
							"Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						6,
						6,
						6,
						6
					],
					"cooldownBurn": "6",
					"cost": [
						75,
						70,
						65,
						60,
						55
					],
					"costBurn": "75/70/65/60/55",
					"effect": [
						null,
						[
							80,
							115,
							150,
							185,
							220
						],
						[
							0.6,
							0.6,
							0.6,
							0.6,
							0.6
						],
						[
							45,
							66,
							87,
							108,
							129
						],
						[
							0.75,
							0.75,
							0.75,
							0.75,
							0.75
						],
						[
							925,
							925,
							925,
							925,
							925
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"80/115/150/185/220",
						"0.6",
						"45/66/87/108/129",
						"0.75",
						"925",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.9,
							"key": "a1"
						},
						{
							"link": "bonusattackdamage",
							"coeff": 0.54,
							"key": "a2"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "ZedQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 240,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "ZedW",
					"name": "Living Shadow",
					"description": "Zed's shadow dashes forward, remaining in place for 5 seconds, and mimicking his spell casts. Zed can reactivate to swap places with the shadow.",
					"tooltip": "<span class=\"colorFF9900\">Passive: </span>Whenever Zed and his shadows strike an enemy with the same ability, Zed gains {{ e3 }} energy. Energy can only be gained once per cast ability.<br /><br /><span class=\"colorFF9900\">Active: </span>Zed's shadow dashes forward, remaining in place for {{ e5 }} seconds. Reactivating Living Shadow will cause Zed to switch positions with this shadow.",
					"leveltip": {
						"label": [
							"Energy Return",
							"Cost",
							"Cooldown"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cost }} -> {{ costNL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						22,
						20,
						18,
						16,
						14
					],
					"cooldownBurn": "22/20/18/16/14",
					"cost": [
						40,
						35,
						30,
						25,
						20
					],
					"costBurn": "40/35/30/25/20",
					"effect": [
						null,
						[
							5.25,
							5.25,
							5.25,
							5.25,
							5.25
						],
						[
							0.2,
							0.2,
							0.2,
							0.2,
							0.2
						],
						[
							30,
							35,
							40,
							45,
							50
						],
						[
							5.25,
							5.25,
							5.25,
							5.25,
							5.25
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"5.25",
						"0.2",
						"30/35/40/45/50",
						"5.25",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						650,
						650,
						650,
						650,
						650
					],
					"rangeBurn": "650",
					"image": {
						"full": "ZedW.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 288,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "ZedE",
					"name": "Shadow Slash",
					"description": "Zed and his shadow spin their blades, creating a burst of shadow energy.  The shadow's spin slows.",
					"tooltip": "Zed and his shadows slash, dealing {{ e1 }} <span class=\"colorFF8C00\">(+{{ a1 }})</span> physical damage to nearby enemies.<br /><br />Each enemy champion hit by Zed's slash reduces Living Shadow's cooldown by {{ e4 }} seconds.<br /><br />Enemies hit by a Shadow's slash are slowed by {{ e2 }}% for 1.5 seconds. Enemies hit by multiple slashes take no additional damage but are slowed by {{ e3 }}% instead.",
					"leveltip": {
						"label": [
							"Damage",
							"Slow",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						5,
						4.5,
						4,
						3.5,
						3
					],
					"cooldownBurn": "5/4.5/4/3.5/3",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							70,
							95,
							120,
							145,
							170
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							30,
							37.5,
							45,
							52.5,
							60
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							315,
							315,
							315,
							315,
							315
						],
						[
							290,
							290,
							290,
							290,
							290
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"70/95/120/145/170",
						"20/25/30/35/40",
						"30/37.5/45/52.5/60",
						"2",
						"1.5",
						"315",
						"290",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "bonusattackdamage",
							"coeff": 0.8,
							"key": "a1"
						}
					],
					"costType": " Energy",
					"maxammo": "-1",
					"range": [
						290,
						290,
						290,
						290,
						290
					],
					"rangeBurn": "290",
					"image": {
						"full": "ZedE.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 336,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Energy"
				},
				{
					"id": "ZedR",
					"name": "Death Mark",
					"description": "Zed leaves a shadow behind and dashes to target Champion, marking them for death. After 3 seconds, the mark will trigger, dealing a percentage of the damage Zed has dealt while the mark was active. If the Champion dies under Death Mark, Zed can gain a portion of their attack damage.",
					"tooltip": "Zed becomes untargetable and dashes to an enemy champion, marking them. After 3 seconds, the mark triggers, dealing physical damage equal to <span class=\"colorFF8C00\">{{ a1 }}</span> + {{ e2 }}% of all damage dealt to the target by Zed while the mark was active.<br /><br />The dash leaves a shadow behind for {{ e4 }} seconds. Reactivating Death Mark causes Zed to switch positions with this shadow.<br /><br /><span class=\"colorFFFFFF\">Reaper of Shadows: </span>Zed reaps the shadow of the strongest foe slain under Death Mark, gaining <span class=\"colorFF8C00\">{{ f2 }}</span> attack damage. ({{ e0 }} + {{ e9 }}% of the victim's attack damage.)",
					"leveltip": {
						"label": [
							"Mark Detonation Damage",
							"Percent Attack Damage Stolen",
							"Cooldown"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ e9 }}% -> {{ e9NL }}%",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						90,
						60
					],
					"cooldownBurn": "120/90/60",
					"cost": [
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							1,
							1,
							1
						],
						[
							25,
							35,
							45
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							6,
							6,
							6
						],
						[
							6.5,
							6.5,
							6.5
						],
						[
							3,
							3,
							3
						],
						[
							7.5,
							7.5,
							7.5
						],
						[
							4,
							4,
							4
						],
						[
							5,
							10,
							15
						],
						[
							5,
							5,
							5
						]
					],
					"effectBurn": [
						null,
						"1",
						"25/35/45",
						"0.5",
						"6",
						"6.5",
						"3",
						"7.5",
						"4",
						"5/10/15",
						"5"
					],
					"vars": [
						{
							"link": "attackdamage",
							"coeff": 1,
							"key": "a1"
						}
					],
					"costType": "No Cost",
					"maxammo": "-1",
					"range": [
						625,
						625,
						625
					],
					"rangeBurn": "625",
					"image": {
						"full": "ZedR.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 384,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "No Cost"
				}
			],
			"passive": {
				"name": "Contempt for the Weak",
				"description": "Zed's basic attacks against targets below 50% Health deal 6-10% of the target's maximum Health as bonus Magic Damage. This effect can only occur once every 10 seconds on the same target.",
				"image": {
					"full": "shadowninja_P.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 192,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Zed",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3047",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1053",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1038",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "KagetoraFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3342",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3181",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2044",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3184",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3035",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3034",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3022",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3072",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1036",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3147",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zed",
					"title": "ZedTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3134",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3133",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3142",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3153",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3111",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3071",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3074",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3814",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3156",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3812",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3139",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2140",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Ziggs": {
			"id": "Ziggs",
			"key": "115",
			"name": "Ziggs",
			"title": "the Hexplosives Expert",
			"image": {
				"full": "Ziggs.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 240,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "115000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "115001",
					"num": 1,
					"name": "Mad Scientist Ziggs",
					"chromas": false
				},
				{
					"id": "115002",
					"num": 2,
					"name": "Major Ziggs",
					"chromas": false
				},
				{
					"id": "115003",
					"num": 3,
					"name": "Pool Party Ziggs",
					"chromas": false
				},
				{
					"id": "115004",
					"num": 4,
					"name": "Snow Day Ziggs",
					"chromas": false
				},
				{
					"id": "115005",
					"num": 5,
					"name": "Master Arcanist Ziggs",
					"chromas": false
				},
				{
					"id": "115006",
					"num": 6,
					"name": "Battle Boss Ziggs",
					"chromas": false
				}
			],
			"lore": "With a love of big bombs and short fuses, the yordle Ziggs is an explosive force of nature. As an inventor's assistant in Piltover, he was bored by his predictable life and befriended a mad, blue-haired bomber named Jinx. After a wild night on the town, Ziggs took her advice and moved to Zaun, where he now explores his fascinations more freely, terrorizing the chem-barons and regular citizens alike in his never ending quest to blow stuff up.",
			"blurb": "With a love of big bombs and short fuses, the yordle Ziggs is an explosive force of nature. As an inventor's assistant in Piltover, he was bored by his predictable life and befriended a mad, blue-haired bomber named Jinx. After a wild night on the town...",
			"allytips": [
				"Even if you're far from a fight you can still help from afar with Mega Inferno Bomb.",
				"Slowing your enemies with Hexplosive Minefield makes it easier to land other abilities.",
				"Knocking yourself over walls with Satchel Charge can be great when chasing after or escaping from enemies."
			],
			"enemytips": [
				"Don't step on Ziggs' mines! They'll slow you and make it much easier for him to hit you with his other abiltiies.",
				"Many of Ziggs' abilities have long cooldowns. Try catching him just after he's used his abilities.",
				"Ziggs' ultimate, Mega Inferno Bomb, deals more damage in the center of the explosion."
			],
			"tags": [
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 4,
				"magic": 9,
				"difficulty": 4
			},
			"stats": {
				"hp": 536,
				"hpperlevel": 92,
				"mp": 384,
				"mpperlevel": 47,
				"movespeed": 325,
				"armor": 21.544,
				"armorperlevel": 3.3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 6.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 54.208,
				"attackdamageperlevel": 3.1,
				"attackspeedoffset": -0.0473,
				"attackspeedperlevel": 2
			},
			"spells": [
				{
					"id": "ZiggsQ",
					"name": "Bouncing Bomb",
					"description": "Ziggs throws a bouncing bomb that deals magic damage.",
					"tooltip": "Ziggs throws a bouncing bomb that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						6,
						5.5,
						5,
						4.5,
						4
					],
					"cooldownBurn": "6/5.5/5/4.5/4",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							75,
							120,
							165,
							210,
							255
						],
						[
							850,
							850,
							850,
							850,
							850
						],
						[
							325,
							325,
							325,
							325,
							325
						],
						[
							225,
							225,
							225,
							225,
							225
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							240,
							240,
							240,
							240,
							240
						],
						[
							70,
							70,
							70,
							70,
							70
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/120/165/210/255",
						"850",
						"325",
						"225",
						"150",
						"240",
						"70",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.65,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "ZiggsQ.png",
						"sprite": "spell13.png",
						"group": "spell",
						"x": 432,
						"y": 144,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZiggsW",
					"name": "Satchel Charge",
					"description": "Ziggs flings an explosive charge that detonates after 4 seconds, or when this ability is activated again. The explosion deals magic damage to enemies, knocking them away. Ziggs is also knocked away, but takes no damage. Ziggs can use the Satchel to hexplode vulnerable enemy turrets.",
					"tooltip": "Ziggs flings an explosive charge that detonates after {{ e2 }} seconds, or when this ability is activated again. The explosion deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies, knocking them away. Ziggs is also knocked away, but takes no damage.<br /><br />Satchel Charge will <span class=\"colorD41919\">hexplode</span> structurally unsound towers below {{ f1*100 }}% of their Health.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Tower Destruction Threshold"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ f1*100 }}% -> {{ f2*100 }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						24,
						21,
						18,
						15,
						12
					],
					"cooldownBurn": "24/21/18/15/12",
					"cost": [
						65,
						65,
						65,
						65,
						65
					],
					"costBurn": "65",
					"effect": [
						null,
						[
							70,
							105,
							140,
							175,
							210
						],
						[
							4,
							4,
							4,
							4,
							4
						],
						[
							0.25,
							0.275,
							0.3,
							0.325,
							0.35
						],
						[
							600,
							600,
							600,
							600,
							600
						],
						[
							50,
							50,
							50,
							50,
							50
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							325,
							325,
							325,
							325,
							325
						],
						[
							775,
							775,
							775,
							775,
							775
						],
						[
							400,
							400,
							400,
							400,
							400
						],
						[
							6,
							6,
							6,
							6,
							6
						]
					],
					"effectBurn": [
						null,
						"70/105/140/175/210",
						"4",
						"0.25/0.275/0.3/0.325/0.35",
						"600",
						"50",
						"400",
						"325",
						"775",
						"400",
						"6"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.35,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1000,
						1000,
						1000,
						1000,
						1000
					],
					"rangeBurn": "1000",
					"image": {
						"full": "ZiggsW.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 0,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZiggsE",
					"name": "Hexplosive Minefield",
					"description": "Ziggs scatters proximity mines that detonate on enemy contact, dealing magic damage and slowing.",
					"tooltip": "Ziggs scatters proximity mines that detonate on enemy contact, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Enemies hit are slowed by {{ e2 }}% for {{ e4 }} seconds.<br /><br />Enemies triggering a mine take {{ e5 }}% damage from additional mines. Mines disarm automatically after {{ e3 }} seconds.",
					"leveltip": {
						"label": [
							"Mine Damage",
							"Slow",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e2 }}% -> {{ e2NL }}%",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						16,
						16,
						16,
						16
					],
					"cooldownBurn": "16",
					"cost": [
						70,
						80,
						90,
						100,
						110
					],
					"costBurn": "70/80/90/100/110",
					"effect": [
						null,
						[
							40,
							65,
							90,
							115,
							140
						],
						[
							20,
							25,
							30,
							35,
							40
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							40,
							40,
							40,
							40,
							40
						],
						[
							-0.2,
							-0.25,
							-0.3,
							-0.35,
							-0.4
						],
						[
							135,
							135,
							135,
							135,
							135
						],
						[
							150,
							150,
							150,
							150,
							150
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"40/65/90/115/140",
						"20/25/30/35/40",
						"10",
						"1.5",
						"40",
						"-0.2/-0.25/-0.3/-0.35/-0.4",
						"135",
						"150",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.3,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "ZiggsE.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 48,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZiggsR",
					"name": "Mega Inferno Bomb",
					"description": "Ziggs deploys his ultimate creation, the Mega Inferno Bomb, hurling it an enormous distance. Enemies in the primary blast zone take more damage than those farther away. ",
					"tooltip": "Ziggs deploys his ultimate creation, the Mega Inferno Bomb, hurling it an enormous distance. Enemies in the primary blast zone take {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage. Enemies farther away take two-thirds damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						105,
						90
					],
					"cooldownBurn": "120/105/90",
					"cost": [
						100,
						100,
						100
					],
					"costBurn": "100",
					"effect": [
						null,
						[
							300,
							450,
							600
						],
						[
							66.6667,
							66.6667,
							66.6667
						],
						[
							525,
							525,
							525
						],
						[
							250,
							250,
							250
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"300/450/600",
						"66.67",
						"525",
						"250",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 1.1,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						5000,
						5000,
						5000
					],
					"rangeBurn": "5000",
					"image": {
						"full": "ZiggsR.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 96,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Short Fuse",
				"description": "Every 12 seconds, Ziggs' next basic attack deals bonus magic damage. This cooldown is reduced whenever Ziggs uses an ability.",
				"image": {
					"full": "ZiggsPassiveReady.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 240,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Ziggs",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3108",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3114",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1058",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Ziggs",
					"title": "ZiggsTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Zilean": {
			"id": "Zilean",
			"key": "26",
			"name": "Zilean",
			"title": "the Chronokeeper",
			"image": {
				"full": "Zilean.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 288,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "26000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "26001",
					"num": 1,
					"name": "Old Saint Zilean",
					"chromas": false
				},
				{
					"id": "26002",
					"num": 2,
					"name": "Groovy Zilean",
					"chromas": false
				},
				{
					"id": "26003",
					"num": 3,
					"name": "Shurima Desert Zilean",
					"chromas": false
				},
				{
					"id": "26004",
					"num": 4,
					"name": "Time Machine Zilean",
					"chromas": false
				},
				{
					"id": "26005",
					"num": 5,
					"name": "Blood Moon Zilean",
					"chromas": false
				}
			],
			"lore": "Once a powerful Icathian mage, Zilean became obsessed with the passage of time after witnessing his homeland's destruction by the Void. Unable to spare even a minute to grieve the catastrophic loss, he called upon ancient temporal magic to divine all possible outcomes. Having become functionally immortal, Zilean now drifts through the past, present, and future, bending and warping the flow of time around him, always searching for that elusive moment that will turn back the clock and undo Icathia's destruction.",
			"blurb": "Once a powerful Icathian mage, Zilean became obsessed with the passage of time after witnessing his homeland's destruction by the Void. Unable to spare even a minute to grieve the catastrophic loss, he called upon ancient temporal magic to divine all...",
			"allytips": [
				"You can combine the use of Time Bomb and Rewind to place two Time Bombs on a target quickly. Placing the second bomb will detonate the first and stun all nearby enemies.",
				"Time Warp is an effective way to enable allies to finish off enemies, or escape from a losing battle.",
				"Chronoshift is a powerful deterrent to attacking your carries, but casting Chronoshift too early in a fight can cause the enemy to switch targets too soon, making it less effective."
			],
			"enemytips": [
				"If you're able to match Zilean's speed, it can sometimes be beneficial to wait until his ultimate has faded before landing the killing blow.",
				"Zilean is fragile if a team focuses on him, but otherwise he's very difficult to kill. Commit to killing him as a team."
			],
			"tags": [
				"Support",
				"Mage"
			],
			"partype": "Mana",
			"info": {
				"attack": 2,
				"defense": 5,
				"magic": 8,
				"difficulty": 6
			},
			"stats": {
				"hp": 504,
				"hpperlevel": 82,
				"mp": 360.8,
				"mpperlevel": 60,
				"movespeed": 335,
				"armor": 24,
				"armorperlevel": 3.8,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 550,
				"hpregen": 5.5,
				"hpregenperlevel": 0.5,
				"mpregen": 8.5,
				"mpregenperlevel": 0.8,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 51.64,
				"attackdamageperlevel": 3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.13
			},
			"spells": [
				{
					"id": "ZileanQ",
					"name": "Time Bomb",
					"description": "Tosses a bomb to target area that sticks to units that come near it (prioritizes Champions). It detonates after 3 seconds, dealing area of effect damage. If a Time Bomb is detonated early by another Time Bomb, it also stuns enemies.",
					"tooltip": "Zilean tosses a time-delayed bomb to a location. The bomb sticks to the first unit which comes within a small area around it (prioritizes Champions). After {{ e2 }} seconds it detonates, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all surrounding enemies. <br /><br />Placing two bombs on a unit detonates the first bomb early, stunning all enemies in the blast for {{ e4 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Stun Duration",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e4 }} -> {{ e4NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						10,
						9.5,
						9,
						8.5,
						8
					],
					"cooldownBurn": "10/9.5/9/8.5/8",
					"cost": [
						60,
						65,
						70,
						75,
						80
					],
					"costBurn": "60/65/70/75/80",
					"effect": [
						null,
						[
							75,
							115,
							165,
							230,
							300
						],
						[
							3,
							3,
							3,
							3,
							3
						],
						[
							7,
							7,
							7,
							7,
							7
						],
						[
							1.1,
							1.2,
							1.3,
							1.4,
							1.5
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"75/115/165/230/300",
						"3",
						"7",
						"1.1/1.2/1.3/1.4/1.5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.9,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "ZileanQ.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 144,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZileanW",
					"name": "Rewind",
					"description": "Zilean can prepare himself for future confrontations, reducing the cooldowns of his other basic abilities. ",
					"tooltip": "Reduces Zilean's other basic spell cooldowns by {{ e2 }} seconds.",
					"leveltip": {
						"label": [
							"Cooldown"
						],
						"effect": [
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						14,
						12,
						10,
						8,
						6
					],
					"cooldownBurn": "14/12/10/8/6",
					"cost": [
						35,
						35,
						35,
						35,
						35
					],
					"costBurn": "35",
					"effect": [
						null,
						[
							20,
							30,
							40,
							50,
							60
						],
						[
							10,
							10,
							10,
							10,
							10
						],
						[
							35,
							35,
							35,
							35,
							35
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20/30/40/50/60",
						"10",
						"35",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						600,
						600,
						600,
						600,
						600
					],
					"rangeBurn": "600",
					"image": {
						"full": "ZileanW.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 192,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ e3 }} Mana"
				},
				{
					"id": "TimeWarp",
					"name": "Time Warp",
					"description": "Zilean bends time around any unit, decreasing an enemy's Movement Speed or increasing an ally's Movement Speed for a short time.",
					"tooltip": "Zilean increases an allied champion's Movement Speed, or slows an enemy champion, by {{ e2 }}% for {{ e1 }} seconds.",
					"leveltip": {
						"label": [
							"Speed"
						],
						"effect": [
							"{{ e2 }}% -> {{ e2NL }}%"
						]
					},
					"maxrank": 5,
					"cooldown": [
						15,
						15,
						15,
						15,
						15
					],
					"cooldownBurn": "15",
					"cost": [
						50,
						50,
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							2.5,
							2.5,
							2.5,
							2.5,
							2.5
						],
						[
							40,
							55,
							70,
							85,
							99
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							8,
							8,
							8,
							8,
							8
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"2.5",
						"40/55/70/85/99",
						"1.5",
						"8",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						550,
						550,
						550,
						550,
						550
					],
					"rangeBurn": "550",
					"image": {
						"full": "TimeWarp.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 240,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ChronoShift",
					"name": "Chronoshift",
					"description": "Zilean places a protective time rune on an allied champion, teleporting the champion back in time if they take lethal damage.",
					"tooltip": "Zilean marks himself or an allied champion with a protective time rune for {{ e2 }} seconds. If the target would take lethal damage, they are instead transported back in time, arriving with {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> Health.",
					"leveltip": {
						"label": [
							"Health Restored",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						120,
						90,
						60
					],
					"cooldownBurn": "120/90/60",
					"cost": [
						125,
						150,
						175
					],
					"costBurn": "125/150/175",
					"effect": [
						null,
						[
							600,
							850,
							1100
						],
						[
							5,
							5,
							5
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"600/850/1100",
						"5",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 2,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						900,
						900,
						900
					],
					"rangeBurn": "900",
					"image": {
						"full": "ChronoShift.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 288,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Time in a Bottle",
				"description": "Zilean stores time as <font color='#BB55EE'>Experience</font>. <br><br>When he has enough <font color='#BB55EE'>Experience</font> to finish an ally's level, he can right-click them to impart it. Zilean receives as much <font color='#BB55EE'>Experience</font> as he gives. Cannot be used in combat.",
				"image": {
					"full": "Zilean_Passive.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 288,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Zilean",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"requiredPerk": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 5,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3073",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3302",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3007",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot-mid",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanSRSupport",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot-support",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3070",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zilean",
					"title": "ZileanTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3158",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3170",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				}
			]
		},
		"Zoe": {
			"id": "Zoe",
			"key": "142",
			"name": "Zoe",
			"title": "the Aspect of Twilight",
			"image": {
				"full": "Zoe.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 336,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "142000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "142001",
					"num": 1,
					"name": "Cyber Pop Zoe",
					"chromas": false
				}
			],
			"lore": "As the embodiment of mischief, imagination, and change, Zoe acts as the cosmic messenger of Targon, heralding major events that reshape worlds. Her mere presence warps the arcane mathematics governing realities, sometimes causing cataclysms without conscious effort or malice. This perhaps explains the breezy nonchalance with which Zoe approaches her duties, giving her plenty of time to focus on playing games, tricking mortals, or otherwise amusing herself. An encounter with Zoe can be joyous and life affirming, but it is always more than it appears and often extremely dangerous.",
			"blurb": "As the embodiment of mischief, imagination, and change, Zoe acts as the cosmic messenger of Targon, heralding major events that reshape worlds. Her mere presence warps the arcane mathematics governing realities, sometimes causing cataclysms without...",
			"allytips": [
				"Paddle Star deals more damage the further it has flown. Casting it behind yourself before redirecting can deal tons of damage.",
				"Break Sleep with your biggest damage source, since enemies who are asleep take double damage.",
				"Sleepy Trouble Bubble travels further over walls. Find a hiding spot to set up for a long distance kill."
			],
			"enemytips": [
				"Zoe's Paddle Star deals more damage the further it has flown.",
				"Zoe must return to her starting point after casting Portal Jump, making her vulnerable to a counterattack.",
				"Sleepy Trouble Bubble travels further over walls. Stop Zoe from hiding in fog of war to prevent her from setting the spell up."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 1,
				"defense": 7,
				"magic": 8,
				"difficulty": 5
			},
			"stats": {
				"hp": 526,
				"hpperlevel": 92,
				"mp": 340,
				"mpperlevel": 50,
				"movespeed": 340,
				"armor": 20.8,
				"armorperlevel": 3.5,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 525,
				"hpregen": 6.5,
				"hpregenperlevel": 0.6,
				"mpregen": 6,
				"mpregenperlevel": 0.65,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 56,
				"attackdamageperlevel": 3.3,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.5
			},
			"spells": [
				{
					"id": "ZoeQ",
					"name": "Paddle Star!",
					"description": "Zoe fires a missile that she can redirect in flight. Deals more damage the longer it flies in a straight line.",
					"tooltip": "Fire a missile that deals increasing damage the further it travels -- {{ e1 }} <span class=\"color99FF99\">(+{{ f1 }})</span> to {{ f2 }} <span class=\"color99FF99\">(+{{ f1*2.5 }})</span> magic damage.<span class=\"size5\"><br /><br /><br /></span>Recast to redirect the missile to a new position near Zoe.<br /><br /><rules>Paddle Star applies More Sparkles to the first enemy hit, dealing an additional {{ f3 }} <span class=\"color99FF99\">(+{{ f4 }})</span> to {{ f3*2.5 }} <span class=\"color99FF99\">(+{{ f4*2.5 }})</span> magic damage.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						8.5,
						8,
						7.5,
						7,
						6.5
					],
					"cooldownBurn": "8.5/8/7.5/7/6.5",
					"cost": [
						50,
						55,
						60,
						65,
						70
					],
					"costBurn": "50/55/60/65/70",
					"effect": [
						null,
						[
							45,
							75,
							105,
							135,
							165
						],
						[
							1.5,
							1.5,
							1.5,
							1.5,
							1.5
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"45/75/105/135/165",
						"1.5",
						"0.4",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "ZoeQ.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 336,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZoeW",
					"name": "Spell Thief",
					"description": "Zoe can pick up the remnants of enemy summoner spell and active item casts and cast them once herself. Whenever she casts a summoner spell, she gains 3 missiles that fire at the nearest target.",
					"tooltip": "Enemy Summoner Spell and Active Item casts drop spell shards lasting 40 seconds. Some minions also drop a spell shard when Zoe kills them.<br /><br /><span class=\"colorFF9900\">Active: </span>Collecting a spell shard grants one cast of that spell.<br />                 ____________________________________________ <span class=\"size8\"><br /><br /></span></span><span class=\"colorFF9900\">Passive: </span>When Zoe casts a Summoner Spell or Spell Thief, she gains {{ e9 }}% movement speed for {{ e0 }} seconds and tosses up to 3 missiles at her attack target, dealing {{ e8 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage total. Each missile can apply More Sparkles!<br /><br /><rules>Movement speed bonus and missile damage improve with spell rank.</rules>",
					"leveltip": {
						"label": [
							"Damage",
							"Movement Speed",
							"Speed Duration"
						],
						"effect": [
							"{{ e8 }} -> {{ e8NL }}",
							"{{ e9 }}% -> {{ e9NL }}%",
							"{{ e0 }} -> {{ e0NL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0.25,
						0.25,
						0.25,
						0.25,
						0.25
					],
					"cooldownBurn": "0.25",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							25,
							36.67,
							48.33,
							60,
							71.67
						],
						[
							3000,
							4500,
							6000,
							0,
							0
						],
						[
							0.1,
							0.1,
							0.1,
							0.1,
							0.1
						],
						[
							2500,
							2500,
							2500,
							2500,
							2500
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							20,
							50,
							80,
							110,
							140
						],
						[
							0.25,
							0.25,
							0.25,
							0.25,
							0.25
						],
						[
							70,
							115,
							160,
							205,
							250
						],
						[
							10,
							25,
							40,
							55,
							70
						],
						[
							2,
							2.5,
							3,
							3.5,
							4
						]
					],
					"effectBurn": [
						null,
						"25/36.67/48.33/60/71.67",
						"3000/4500/6000/0/0",
						"0.1",
						"2500",
						"60",
						"20/50/80/110/140",
						"0.25",
						"70/115/160/205/250",
						"10/25/40/55/70",
						"2/2.5/3/3.5/4"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						3000,
						4500,
						6000,
						3000,
						3000
					],
					"rangeBurn": "3000/4500/6000/3000/3000",
					"image": {
						"full": "ZoeW.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 384,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZoeE",
					"name": "Sleepy Trouble Bubble",
					"description": "Causes the target to become drowsy, then fall asleep. The first source of damage that breaks the sleep is doubled, up to a cap.",
					"tooltip": "Dropkick a bubble that deals {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage, lingering as a trap if it hits nothing. The bubble's range is extended when flying over a wall.<br /><br />After a delay, the victim falls asleep for 2 seconds. Attacks and spell hits break sleep but deal double damage, up to {{ e6 }} <span class=\"color99FF99\">(+{{ a2 }})</span> bonus true damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Bonus Damage Cap",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e6 }} -> {{ e6NL }}",
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 5,
					"cooldown": [
						16,
						15.5,
						15,
						14.5,
						14
					],
					"cooldownBurn": "16/15.5/15/14.5/14",
					"cost": [
						80,
						80,
						80,
						80,
						80
					],
					"costBurn": "80",
					"effect": [
						null,
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							0.1,
							0.15,
							0.2,
							0.25,
							0.3
						],
						[
							5,
							15,
							25,
							35,
							45
						],
						[
							5,
							5,
							5,
							5,
							5
						],
						[
							0.1,
							0.2,
							0.3,
							0.4,
							0.5
						],
						[
							60,
							100,
							140,
							180,
							220
						],
						[
							0.4,
							0.4,
							0.4,
							0.4,
							0.4
						],
						[
							1.4,
							1.4,
							1.4,
							1.4,
							1.4
						],
						[
							2.25,
							2.25,
							2.25,
							2.25,
							2.25
						],
						[
							1,
							1,
							1,
							1,
							1
						]
					],
					"effectBurn": [
						null,
						"60/100/140/180/220",
						"0.1/0.15/0.2/0.25/0.3",
						"5/15/25/35/45",
						"5",
						"0.1/0.2/0.3/0.4/0.5",
						"60/100/140/180/220",
						"0.4",
						"1.4",
						"2.25",
						"1"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.4,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "ZoeE.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 432,
						"y": 0,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZoeR",
					"name": "Portal Jump",
					"description": "Blink to a nearby position for 1 second. Then blink back.",
					"tooltip": "Blink to a nearby position for 1 second. Then blink back.<br /><br /><rules>Zoe may cast and attack, but not move, during this time. She can also see over walls.</rules>",
					"leveltip": {
						"label": [
							"Cooldown"
						],
						"effect": [
							"{{ cooldown }}s -> {{ cooldownNL }}s"
						]
					},
					"maxrank": 3,
					"cooldown": [
						11,
						8,
						5
					],
					"cooldownBurn": "11/8/5",
					"cost": [
						50,
						50,
						50
					],
					"costBurn": "50",
					"effect": [
						null,
						[
							-0.3,
							-0.4,
							-0.5
						],
						[
							1.5,
							2,
							2.5
						],
						[
							4,
							4,
							4
						],
						[
							0.5,
							0.5,
							0.5
						],
						[
							3,
							3,
							3
						],
						[
							100,
							200,
							300
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"-0.3/-0.4/-0.5",
						"1.5/2/2.5",
						"4",
						"0.5",
						"3",
						"100/200/300",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						575,
						575,
						575
					],
					"rangeBurn": "575",
					"image": {
						"full": "ZoeR.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 0,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "More Sparkles!",
				"description": "Zoe's next basic attack after casting a spell deals bonus magic damage.",
				"image": {
					"full": "Zoe_P.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 336,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Zoe",
					"title": "Beginner",
					"map": "SR",
					"mode": "INTRO",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": 4,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_starter",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": 5,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_advanced",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1028",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_movementspeed",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_legendaryitem",
							"recMath": true,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3010",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1026",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "beginner_morelegendaryitems",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeASC",
					"map": "CrystalScar",
					"mode": "ASCENSION",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeDM",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3152",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3174",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3105",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3069",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoePG",
					"map": "3",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 4,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3027",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeoffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegedefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3029",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3057",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zoe",
					"title": "ZoeTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3100",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		},
		"Zyra": {
			"id": "Zyra",
			"key": "143",
			"name": "Zyra",
			"title": "Rise of the Thorns",
			"image": {
				"full": "Zyra.png",
				"sprite": "champion4.png",
				"group": "champion",
				"x": 384,
				"y": 48,
				"w": 48,
				"h": 48
			},
			"skins": [
				{
					"id": "143000",
					"num": 0,
					"name": "default",
					"chromas": false
				},
				{
					"id": "143001",
					"num": 1,
					"name": "Wildfire Zyra",
					"chromas": false
				},
				{
					"id": "143002",
					"num": 2,
					"name": "Haunted Zyra",
					"chromas": false
				},
				{
					"id": "143003",
					"num": 3,
					"name": "SKT T1 Zyra",
					"chromas": false
				},
				{
					"id": "143004",
					"num": 4,
					"name": "Dragon Sorceress Zyra",
					"chromas": false
				}
			],
			"lore": "Born in an ancient, sorcerous catastrophe, Zyra is the wrath of nature given form—an alluring hybrid of plant and human, kindling new life with every step. She views the many mortals of Valoran as little more than prey for her seeded progeny, and thinks nothing of slaying them with flurries of deadly spines. Though her true purpose has not been revealed, Zyra wanders the world, indulging her most primal urges to colonize, and strangle all other life from it.",
			"blurb": "Born in an ancient, sorcerous catastrophe, Zyra is the wrath of nature given form—an alluring hybrid of plant and human, kindling new life with every step. She views the many mortals of Valoran as little more than prey for her seeded progeny, and thinks...",
			"allytips": [
				"Placing a seed in your spell's path after you have cast it gives you the best chance of having a seed in the proper spot.",
				"Seeds grant vision to your team.",
				"Zyra is a great ambusher - look for opportunities to set a trap of seeds in brush, then lure enemies in."
			],
			"enemytips": [
				"Zyra's seeds can be destroyed by stepping on them. If she tries to grow them as you do, dodge back at the last moment. ",
				"Moving closer to Zyra can be a smart move if she places plants too far away from herself.",
				"Plants take fixed damage from attacks and effects, similar to wards. They also expire quickly on their own.",
				"Moving the fight to a different area will deprive Zyra of accumulated seeds.",
				"Seeds placed by Zyra's W are larger, a different color, and grant a small amount of vision to her team."
			],
			"tags": [
				"Mage",
				"Support"
			],
			"partype": "Mana",
			"info": {
				"attack": 4,
				"defense": 3,
				"magic": 8,
				"difficulty": 7
			},
			"stats": {
				"hp": 504,
				"hpperlevel": 79,
				"mp": 334,
				"mpperlevel": 50,
				"movespeed": 340,
				"armor": 29,
				"armorperlevel": 3,
				"spellblock": 30,
				"spellblockperlevel": 0.5,
				"attackrange": 575,
				"hpregen": 5.5,
				"hpregenperlevel": 0.5,
				"mpregen": 11.5,
				"mpregenperlevel": 0.4,
				"crit": 0,
				"critperlevel": 0,
				"attackdamage": 53.376,
				"attackdamageperlevel": 3.2,
				"attackspeedoffset": 0,
				"attackspeedperlevel": 2.11
			},
			"spells": [
				{
					"id": "ZyraQ",
					"name": "Deadly Spines",
					"description": "Thick vines spread through the ground and explode into spines, dealing magic damage to enemies within the area. If cast near a seed, Deadly Spines grows a Thorn Spitter plant, which fires at enemies from afar.",
					"tooltip": "Thick vines spread through the ground and explode into spines, dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to enemies within the area. <br /><br /><span class=\"colorDDDD77\">Garden of Thorns: </span>If Deadly Spines is cast near a seed, a Thorn Spitter grows, dealing {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage. A Thorn Spitter has 575 range and lasts {{ f2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						7,
						6.5,
						6,
						5.5,
						5
					],
					"cooldownBurn": "7/6.5/6/5.5/5",
					"cost": [
						70,
						70,
						70,
						70,
						70
					],
					"costBurn": "70",
					"effect": [
						null,
						[
							60,
							95,
							130,
							165,
							200
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/95/130/165/200",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.6,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						800,
						800,
						800,
						800,
						800
					],
					"rangeBurn": "800",
					"image": {
						"full": "ZyraQ.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 48,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZyraW",
					"name": "Rampant Growth",
					"description": "Zyra plants a seed, lasting up to 60 seconds. Deadly Spines and Grasping Roots cast near seeds will turn them into plants who fight for Zyra. Zyra can store multiple seeds at once, and killing enemies reduces Rampant Growth's recharge time.",
					"tooltip": "Plants a seed, lasting {{ e6 }} seconds. If an enemy Champion steps on a seed, it dies. Seeds spawned by Rampant Growth grant vision in a small area, and if stepped on they grant <span class=\"coloree91d7\">True Sight</span> of the enemy champion for {{ e3 }} seconds.<br /><br />Zyra stores a seed every <span class=\"colorFFFFFF\">{{ ammorechargetime }}</span> seconds (Max: 8 seeds planted). Each time she kills an enemy, Rampant Growth's recharge time is reduced by {{ e1 }}% ({{ e2 }}% for champion takedowns, large minion kills, and large monster kills).",
					"leveltip": {
						"label": [
							"Seed Recharge Rate"
						],
						"effect": [
							"{{ ammorechargetime }} -> {{ ammorechargetimeNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						0,
						0,
						0,
						0,
						0
					],
					"cooldownBurn": "0",
					"cost": [
						0,
						0,
						0,
						0,
						0
					],
					"costBurn": "0",
					"effect": [
						null,
						[
							20,
							20,
							20,
							20,
							20
						],
						[
							100,
							100,
							100,
							100,
							100
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							60,
							60,
							60,
							60,
							60
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							10,
							20,
							30,
							40,
							50
						],
						[
							0.4,
							0.8,
							1.2,
							1.6,
							2
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"20",
						"100",
						"2",
						"0",
						"0",
						"60",
						"0",
						"10/20/30/40/50",
						"0.4/0.8/1.2/1.6/2",
						"0"
					],
					"vars": [],
					"costType": "1 Seed",
					"maxammo": "2",
					"range": [
						850,
						850,
						850,
						850,
						850
					],
					"rangeBurn": "850",
					"image": {
						"full": "ZyraW.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 96,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "1 Seed"
				},
				{
					"id": "ZyraE",
					"name": "Grasping Roots",
					"description": "Zyra sends forth vines through the ground to ensnare her target, dealing damage and rooting enemies they come across. If cast near a seed, Grasping Roots grows a Vine Lasher, whose short range attacks reduce enemy Movement Speed.",
					"tooltip": "Sends forward vines dealing {{ e1 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage and rooting enemies for {{ e5 }} second(s).<br /><br /><span class=\"colorDDDD77\">Garden of Thorns: </span>If Grasping Roots passes near a seed, a Vine Lasher grows dealing {{ f1 }} <span class=\"color99FF99\">(+{{ a2 }})</span> magic damage and slowing enemies by {{ e2 }}% for {{ e3 }} seconds. A Vine Lasher has 400 range and lasts {{ f2 }} seconds.",
					"leveltip": {
						"label": [
							"Damage",
							"Root Duration",
							"Mana Cost"
						],
						"effect": [
							"{{ e1 }} -> {{ e1NL }}",
							"{{ e5 }} -> {{ e5NL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 5,
					"cooldown": [
						12,
						12,
						12,
						12,
						12
					],
					"cooldownBurn": "12",
					"cost": [
						70,
						75,
						80,
						85,
						90
					],
					"costBurn": "70/75/80/85/90",
					"effect": [
						null,
						[
							60,
							105,
							150,
							195,
							240
						],
						[
							30,
							30,
							30,
							30,
							30
						],
						[
							2,
							2,
							2,
							2,
							2
						],
						[
							4,
							4,
							4,
							0,
							0
						],
						[
							0.75,
							1,
							1.25,
							1.5,
							1.75
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						],
						[
							0,
							0,
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"60/105/150/195/240",
						"30",
						"2",
						"4/4/4/0/0",
						"0.75/1/1.25/1.5/1.75",
						"0",
						"0",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.5,
							"key": "a1"
						},
						{
							"link": "spelldamage",
							"coeff": 0.15,
							"key": "a2"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						1100,
						1100,
						1100,
						1100,
						1100
					],
					"rangeBurn": "1100",
					"image": {
						"full": "ZyraE.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 144,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				},
				{
					"id": "ZyraR",
					"name": "Stranglethorns",
					"description": "Zyra summons a twisted thicket at her target location, dealing damage to enemies as it expands and knocking them airborne as it contracts.",
					"tooltip": "Summons the fury of nature, growing a twisted thicket at target location which deals {{ e3 }} <span class=\"color99FF99\">(+{{ a1 }})</span> magic damage to all enemies in the area as it expands. After 2 seconds, the vines snap upward knocking enemies into the air for {{ e1 }} second.<br /><br /><span class=\"colorDDDD77\">Garden of Thorns: </span>Plants within the thicket are enraged, resetting their duration, gaining {{ e2 }}% Health and attacking in a flurry for 200% total damage.",
					"leveltip": {
						"label": [
							"Damage",
							"Cooldown",
							"Mana Cost"
						],
						"effect": [
							"{{ e3 }} -> {{ e3NL }}",
							"{{ cooldown }} -> {{ cooldownNL }}",
							"{{ cost }} -> {{ costNL }}"
						]
					},
					"maxrank": 3,
					"cooldown": [
						130,
						120,
						110
					],
					"cooldownBurn": "130/120/110",
					"cost": [
						100,
						120,
						140
					],
					"costBurn": "100/120/140",
					"effect": [
						null,
						[
							1,
							1,
							1
						],
						[
							50,
							50,
							50
						],
						[
							180,
							265,
							350
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							150,
							150,
							150
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						],
						[
							0,
							0,
							0
						]
					],
					"effectBurn": [
						null,
						"1",
						"50",
						"180/265/350",
						"0",
						"0",
						"0",
						"150",
						"0",
						"0",
						"0"
					],
					"vars": [
						{
							"link": "spelldamage",
							"coeff": 0.7,
							"key": "a1"
						}
					],
					"costType": " Mana",
					"maxammo": "-1",
					"range": [
						700,
						700,
						700
					],
					"rangeBurn": "700",
					"image": {
						"full": "ZyraR.png",
						"sprite": "spell14.png",
						"group": "spell",
						"x": 192,
						"y": 48,
						"w": 48,
						"h": 48
					},
					"resource": "{{ cost }} Mana"
				}
			],
			"passive": {
				"name": "Garden of Thorns",
				"description": "Seeds spawn around Zyra periodically, becoming faster with level and lasting 30 seconds. If an enemy Champion steps on a seed, it dies. <br><br>Zyra can cast spells near seeds to grow plants. Extra plants striking the same target deal reduced damage.",
				"image": {
					"full": "ZyraP.png",
					"sprite": "passive4.png",
					"group": "passive",
					"x": 384,
					"y": 48,
					"w": 48,
					"h": 48
				}
			},
			"recommended": [
				{
					"champion": "Zyra",
					"title": "Beginner",
					"type": "riot",
					"map": "SR",
					"mode": "INTRO",
					"priority": false,
					"blocks": [
						{
							"type": "beginner_Starter",
							"maxSummonerLevel": 4,
							"items": [
								{
									"id": "1056",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Starter",
							"minSummonerLevel": 5,
							"items": [
								{
									"id": "1056",
									"count": 1
								},
								{
									"id": "2003",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_Advanced",
							"recMath": true,
							"items": [
								{
									"id": "1028",
									"count": 1
								},
								{
									"id": "1027",
									"count": 1
								},
								{
									"id": "3010",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MovementSpeed",
							"recMath": true,
							"items": [
								{
									"id": "1001",
									"count": 1
								},
								{
									"id": "3020",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_LegendaryItem",
							"recMath": true,
							"items": [
								{
									"id": "3010",
									"count": 1
								},
								{
									"id": "1026",
									"count": 1
								},
								{
									"id": "3027",
									"count": 1
								}
							]
						},
						{
							"type": "beginner_MoreLegendaryItems",
							"items": [
								{
									"id": "3151",
									"count": 1
								},
								{
									"id": "3174",
									"count": 1
								},
								{
									"id": "3116",
									"count": 1
								},
								{
									"id": "3089",
									"count": 1
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraARAM",
					"map": "HA",
					"mode": "ARAM",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraCS",
					"map": "CrystalScar",
					"mode": "ODIN",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraFIRSTBLOOD",
					"map": "HA",
					"mode": "FIRSTBLOOD",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2049",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3222",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3110",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2043",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraKINGPORO",
					"map": "HA",
					"mode": "KINGPORO",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "KingPoroSnax",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3680",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3681",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3682",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3683",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3112",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3285",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2033",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraSIEGE",
					"map": "SR",
					"mode": "SIEGE",
					"type": "riot",
					"customTag": "",
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "siegeOffense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3631",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3641",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3647",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3635",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "siegeDefense",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3634",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3640",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3643",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3636",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3642",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3050",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraSR",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot-support",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3303",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "startingjungle",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1039",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 3,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3098",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3706",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3113",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "SummonerSmite",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3117",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3092",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3916",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "SummonerSmite",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1402",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "aggressive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3905",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "protective",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3190",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraSRMid",
					"map": "SR",
					"mode": "CLASSIC",
					"type": "riot-mid",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2003",
									"count": 2,
									"hideCount": false
								},
								{
									"id": "3340",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "early",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3802",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3145",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "standard",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "situational",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3157",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3102",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3089",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2055",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				},
				{
					"champion": "Zyra",
					"title": "ZyraTT",
					"map": "TT",
					"mode": "CLASSIC",
					"type": "riot",
					"customTag": "",
					"sortrank": 0,
					"extensionPage": false,
					"customPanel": null,
					"blocks": [
						{
							"type": "starting",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "1056",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "1001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "2031",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "essential",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3020",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3030",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3151",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "offensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3135",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3090",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3165",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "defensive",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "3001",
									"count": 1,
									"hideCount": false
								},
								{
									"id": "3116",
									"count": 1,
									"hideCount": false
								}
							]
						},
						{
							"type": "consumables",
							"recMath": false,
							"recSteps": false,
							"minSummonerLevel": -1,
							"maxSummonerLevel": -1,
							"showIfSummonerSpell": "",
							"hideIfSummonerSpell": "",
							"appendAfterSection": "",
							"visibleWithAllOf": [
								""
							],
							"hiddenWithAnyOf": [
								""
							],
							"items": [
								{
									"id": "2003",
									"count": 1,
									"hideCount": true
								},
								{
									"id": "2139",
									"count": 1,
									"hideCount": true
								}
							]
						}
					]
				}
			]
		}
	},
	"keys": {
		"1": "Annie",
		"2": "Olaf",
		"3": "Galio",
		"4": "TwistedFate",
		"5": "XinZhao",
		"6": "Urgot",
		"7": "Leblanc",
		"8": "Vladimir",
		"9": "Fiddlesticks",
		"10": "Kayle",
		"11": "MasterYi",
		"12": "Alistar",
		"13": "Ryze",
		"14": "Sion",
		"15": "Sivir",
		"16": "Soraka",
		"17": "Teemo",
		"18": "Tristana",
		"19": "Warwick",
		"20": "Nunu",
		"21": "MissFortune",
		"22": "Ashe",
		"23": "Tryndamere",
		"24": "Jax",
		"25": "Morgana",
		"26": "Zilean",
		"27": "Singed",
		"28": "Evelynn",
		"29": "Twitch",
		"30": "Karthus",
		"31": "Chogath",
		"32": "Amumu",
		"33": "Rammus",
		"34": "Anivia",
		"35": "Shaco",
		"36": "DrMundo",
		"37": "Sona",
		"38": "Kassadin",
		"39": "Irelia",
		"40": "Janna",
		"41": "Gangplank",
		"42": "Corki",
		"43": "Karma",
		"44": "Taric",
		"45": "Veigar",
		"48": "Trundle",
		"50": "Swain",
		"51": "Caitlyn",
		"53": "Blitzcrank",
		"54": "Malphite",
		"55": "Katarina",
		"56": "Nocturne",
		"57": "Maokai",
		"58": "Renekton",
		"59": "JarvanIV",
		"60": "Elise",
		"61": "Orianna",
		"62": "MonkeyKing",
		"63": "Brand",
		"64": "LeeSin",
		"67": "Vayne",
		"68": "Rumble",
		"69": "Cassiopeia",
		"72": "Skarner",
		"74": "Heimerdinger",
		"75": "Nasus",
		"76": "Nidalee",
		"77": "Udyr",
		"78": "Poppy",
		"79": "Gragas",
		"80": "Pantheon",
		"81": "Ezreal",
		"82": "Mordekaiser",
		"83": "Yorick",
		"84": "Akali",
		"85": "Kennen",
		"86": "Garen",
		"89": "Leona",
		"90": "Malzahar",
		"91": "Talon",
		"92": "Riven",
		"96": "KogMaw",
		"98": "Shen",
		"99": "Lux",
		"101": "Xerath",
		"102": "Shyvana",
		"103": "Ahri",
		"104": "Graves",
		"105": "Fizz",
		"106": "Volibear",
		"107": "Rengar",
		"110": "Varus",
		"111": "Nautilus",
		"112": "Viktor",
		"113": "Sejuani",
		"114": "Fiora",
		"115": "Ziggs",
		"117": "Lulu",
		"119": "Draven",
		"120": "Hecarim",
		"121": "Khazix",
		"122": "Darius",
		"126": "Jayce",
		"127": "Lissandra",
		"131": "Diana",
		"133": "Quinn",
		"134": "Syndra",
		"136": "AurelionSol",
		"141": "Kayn",
		"142": "Zoe",
		"143": "Zyra",
		"150": "Gnar",
		"154": "Zac",
		"157": "Yasuo",
		"161": "Velkoz",
		"163": "Taliyah",
		"164": "Camille",
		"201": "Braum",
		"202": "Jhin",
		"203": "Kindred",
		"222": "Jinx",
		"223": "TahmKench",
		"236": "Lucian",
		"238": "Zed",
		"240": "Kled",
		"245": "Ekko",
		"254": "Vi",
		"266": "Aatrox",
		"267": "Nami",
		"268": "Azir",
		"412": "Thresh",
		"420": "Illaoi",
		"421": "RekSai",
		"427": "Ivern",
		"429": "Kalista",
		"432": "Bard",
		"497": "Rakan",
		"498": "Xayah",
		"516": "Ornn"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/cms/tips/champions.json
// module id = 1040
// module chunks = 0